/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',

    'BlurAdmin.pages.dashboard',
    'BlurAdmin.pages.ui',
    'BlurAdmin.pages.components',
    'BlurAdmin.pages.form',
    'BlurAdmin.pages.tables',
    'BlurAdmin.pages.charts',
    'BlurAdmin.pages.maps',
    'BlurAdmin.pages.profile',
    'mydata.entity',
    'mydata.login',
    'mydata.agency',
    'mydata.user',
    'mydata.report',
    'mydata.home',
    'mydata.document',
    'mydata.transaction',
    'mydata.project',
    'mydata.notification',
    'mydata.invoice',
    'mydata.discount',
    'mydata.service',
    'mydata.pi'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/home');

    baSidebarServiceProvider.addStaticItem({
      title: 'Pages',
      icon: 'ion-document',
      subMenu: [{
        title: 'Sign In',
        fixedHref: 'auth.html',
        blank: true
      }, {
        title: 'Sign Up',
        fixedHref: 'reg.html',
        blank: true
      }, {
        title: 'User Profile',
        stateRef: 'profile'
      }, {
        title: '404 Page',
        fixedHref: '404.html',
        blank: true
      }]
    });
    baSidebarServiceProvider.addStaticItem({
      title: 'Menu Level 1',
      icon: 'ion-ios-more',
      subMenu: [{
        title: 'Menu Level 1.1',
        disabled: true
      }, {
        title: 'Menu Level 1.2',
        subMenu: [{
          title: 'Menu Level 1.2.1',
          disabled: true
        }]
      }]
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author ah
 * created on 21.12.2017
 */
(function () {
    'use strict';

    angular.module('mydata.agency', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('agency', {
                url: '/agency',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('agency.search', {
                url: '/search',
                templateUrl: 'app/pages/agency/agency-list.view.html',
                controller: 'agency.controller',
                title: 'Agency List'
            }).state('agency.manage', {
                url: '/manage/:agencyId',
                templateUrl: 'app/pages/agency/agency-detail.view.html',
                controller: 'agency.controller',
                title: 'Agency Details'
            }).state('agency.create', {
                url: '/create',
                templateUrl: 'app/pages/agency/agency-new.view.html',
                controller: 'agency.controller',
                title: 'Add Agency/Firm'
            });
        $urlRouterProvider.when('/agency', '/agency/search');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
          title: 'Charts',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 150,
          },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
    'BlurAdmin.pages.components.mail',
    'BlurAdmin.pages.components.timeline',
    'BlurAdmin.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
        });
  }

})();

/**
 * @author ah
 * created on 08.02.2020
 */
(function () {
    'use strict';

    angular.module('mydata.discount', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('discount', {
                url: '/discount',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('discount.list', {
                url: '/list',
                templateUrl: 'app/pages/discount/discount-list.view.html',
                controller: 'discount.controller',
                title: 'Discount List'
            }).state('discount.detail', {
                url: '/detail/:discId',
                templateUrl: 'app/pages/discount/discount-detail.view.html',
                controller: 'discount.controller',
                title: 'Manage Discount'
            }).state('discount.new', {
                url: '/new',
                templateUrl: 'app/pages/discount/discount-new.view.html',
                controller: 'discount.controller',
                title: 'Add Discount'
            });
        $urlRouterProvider.when('/discount', '/discount/list');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('mydata.entity', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('entity', {
                url: '/entity',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('entity.search', {
                url: '/search',
                templateUrl: 'app/pages/entity/entity-search.view.html',
                controller: 'entity.controller',
                title: 'Search Entity'
            }).state('entity.document', {
                url: '/document/:entityNumber/:entityType/:entityName',
                templateUrl: 'app/pages/entity/entity-detail.view.html',
                controller: 'entity.controller',
                title: 'Document List'
            }).state('entity.rob', {
                url: '/document/rob/:entityNumber/:entityType/:entityName',
                templateUrl: 'app/pages/entity/rob-detail.view.html',
                controller: 'entity.controller',
                title: 'Document List'
            }).state('entity.llp', {
                url: '/document/llp/:entityNumber/:entityType/:entityName',
                templateUrl: 'app/pages/entity/llp-detail.view.html',
                controller: 'entity.controller',
                title: 'Document List'
            });
        $urlRouterProvider.when('/entity', '/entity/search');
    }

})();

(function () {
    'use strict';

    angular.module('mydata.document', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('document', {
                url: '/document',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('document.request', {
                url: '/cart',
                templateUrl: 'app/pages/document/cart-list.view.html',
                controller: 'order.controller',
                title: 'Cart'
            }).state('document.summary', {
                url: '/summary/:transId',
                templateUrl: 'app/pages/document/order-summary.view.html',
                controller: 'order.controller',
                title: 'Order Summary'
            }).state('document.download', {
                url: '/download',
                templateUrl: 'app/pages/document/order-user-list.view.html',
                controller: 'order.controller',
                title: 'Orders'
            }).state('document.order', {
                url: '/order',
                templateUrl: 'app/pages/document/order-account-list.view.html',
                controller: 'order.controller',
                title: 'Orders'
            }).state('document.checkout', {
                url: '/checkout/:trxId',
                templateUrl: 'app/pages/document/checkout-list.view.html',
                controller: 'order.controller',
                title: 'Checkout'
            }).state('document.all', {
                url: '/all',
                templateUrl: 'app/pages/document/order-all-list.view.html',
                controller: 'order.controller',
                title: 'Orders'
            });
        $urlRouterProvider.when('/document', '/document/search');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Form Elements',
          sidebarMeta: {
            icon: 'ion-compose',
            order: 250,
          },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('mydata.home', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('home', {
                url: '/home',
                templateUrl: 'app/pages/home/landing-page.html',
            });
    }

})();

/**
 * @author ah
 * created on 04.11.2019
 */
(function () {
    'use strict';

    angular.module('mydata.invoice', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('invoice', {
            url: '/invoice',
            templateUrl: 'app/pages/invoice/invoice.view.html',
            controller: 'invoice.controller',
            title: 'Invoice'
        });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('mydata.login', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/pages/login/login.view.html',
                controller: 'login.controller',
            }).state('forgotPassword', {
                url: '/forgot-password',
                templateUrl: 'app/pages/login/forgot-password.view.html',
                controller: 'login.controller',
                title: 'Forgot Password?'
            }).state('resetPassword', {
                url: '/reset-password/:token',
                templateUrl: 'app/pages/login/reset-password.view.html',
                controller: 'login.controller',
                title: 'Reset Password'
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          templateUrl: 'app/pages/maps/maps.html',
          abstract: true,
          title: 'Maps',
          sidebarMeta: {
            icon: 'ion-ios-location-outline',
            order: 500,
          },
        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/pages/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/pages/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps',
          sidebarMeta: {
            order: 200,
          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/pages/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author ah
 * created on 21.09.2018
 */
(function () {
    'use strict';

    angular.module('mydata.notification', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('notification', {
                url: '/notification',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('notification.list', {
                url: '/list',
                templateUrl: 'app/pages/notification/notification-list.view.html',
                controller: 'notification.controller',
                title: 'Notification List'
            }).state('notification.detail', {
                url: '/detail/:notificationId',
                templateUrl: 'app/pages/notification/notification-detail.view.html',
                controller: 'notification.controller',
                title: 'Notification Details'
            }).state('notification.new', {
                url: '/new',
                templateUrl: 'app/pages/notification/notification-new.view.html',
                controller: 'notification.controller',
                title: 'Create Notification'
            })
        $urlRouterProvider.when('/notification', '/notification/list');
    }

})();

/**
 * @author AH
 * created on 11.09.2025
 */
(function () {
    'use strict';

    angular.module('mydata.pi', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('pi', {
                url: '/pi',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('pi.product', {
                url: '/product',
                templateUrl: 'app/pages/personal-involvement/pi.product.view.html',
                controller: 'pi.controller',
                title: 'Personal Involvement'
            });
        $urlRouterProvider.when('/pi', '/pi/product');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

/**
 * @author ah
 * created on 21.12.2017
 */
(function () {
    'use strict';

    angular.module('mydata.project', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('project', {
                url: '/project',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('project.list', {
                url: '/list',
                templateUrl: 'app/pages/project/project-list.view.html',
                controller: 'project.controller',
                title: 'Project List'
            }).state('project.detail', {
                url: '/detail/:projectId',
                templateUrl: 'app/pages/project/project-detail.view.html',
                controller: 'project.controller',
                title: 'Project Details'
            }).state('project.new', {
                url: '/new',
                templateUrl: 'app/pages/project/project-new.view.html',
                controller: 'project.controller',
                title: 'Add New Project'
            }).state('project.listAll', {
                url: '/all/list',
                templateUrl: 'app/pages/project/project-all-list.view.html',
                controller: 'project.controller',
                title: 'Project List'
            });
        $urlRouterProvider.when('/project', '/project/list');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

})();

(function () {
    'use strict';

    angular.module('mydata.service', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('checkout', {
                url: '/checkout/:token',
                templateUrl: 'app/pages/service/checkout.view.html',
                controller: 'service.controller',
                title: 'Checkout'
            }).state('order', {
                url: '/order/:token/:id',
                templateUrl: 'app/pages/service/order.view.html',
                controller: 'service.controller',
                title: 'Orders'
            }).state('payment', {
                url: '/payment/:id',
                templateUrl: 'app/pages/service/payment.view.html',
                controller: 'service.controller',
                title: 'Online Payment'
            });
    }

})();

(function () {
    'use strict';

    angular.module('mydata.transaction', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('transaction', {
                url: '/transaction',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('transaction.search', {
                url: '/search',
                templateUrl: 'app/pages/transaction/transaction-user-list.view.html',
                controller: 'transaction.controller',
                title: 'Transactions'
            }).state('transaction.agency', {
                url: '/trxList',
                templateUrl: 'app/pages/transaction/transaction-account-list.view.html',
                controller: 'transaction.controller',
                title: 'Transactions'
            }).state('transaction.all', {
                url: '/list',
                templateUrl: 'app/pages/transaction/transaction-all-list.view.html',
                controller: 'transaction.controller',
                title: 'Transactions'
            }).state('transaction.ssm', {
                url: '/trans-list',
                templateUrl: 'app/pages/transaction/transaction-ssm-list.view.html',
                controller: 'transaction.controller',
                title: 'Transactions'
            }).state('transaction.detail', {
                url: '/detail/:trxId',
                templateUrl: 'app/pages/transaction/transaction-user-detail.view.html',
                controller: 'transaction.controller',
                title: 'Transaction Details'
            }).state('transaction.agencyDetail', {
                url: '/trxDetail/:trx_id',
                templateUrl: 'app/pages/transaction/transaction-account-detail.view.html',
                controller: 'transaction.controller',
                title: 'Transaction Details'
            }).state('transaction.allDetail', {
                url: '/all/detail/:transId',
                templateUrl: 'app/pages/transaction/transaction-all-detail.view.html',
                controller: 'transaction.controller',
                title: 'Transaction Details'
            }).state('transaction.SSMDetail', {
                url: '/trans-detail/:SSMTransId',
                templateUrl: 'app/pages/transaction/transaction-ssm-detail.view.html',
                controller: 'transaction.controller',
                title: 'Transaction Details'
            });
        $urlRouterProvider.when('/transaction', '/transaction/search');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart/:userId',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('mydata.user', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('user', {
                url: '/user',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('user.search', {
                url: '/search',
                templateUrl: 'app/pages/user/user-all-list.view.html',
                controller: 'user.controller',
                title: 'User Search'
            }).state('user.manage', {
                url: '/manage/:userId',
                templateUrl: 'app/pages/user/user-all-detail.view.html',
                controller: 'user.controller',
                title: 'Manage User'
            }).state('user.profile', {
                url: '/profile/:trxId',
                templateUrl: 'app/pages/user/user-profile.view.html',
                controller: 'user.controller',
                title: 'User Profile'
            }).state('user.list', {
                url: '/list',
                templateUrl: 'app/pages/user/user-list.view.html',
                controller: 'user.controller',
                title: 'User List'
            }).state('user.detail', {
                url: '/detail/:user_id',
                templateUrl: 'app/pages/user/user-detail.view.html',
                controller: 'user.controller',
                title: 'User Details'
            });
        $urlRouterProvider.when('/user', '/user/search');
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('mydata.report', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('report', {
                url: '/report',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            }).state('report.orderTrxUser', {
                url: '/transaction/user',
                templateUrl: 'app/pages/report/report-user-list.view.html',
                controller: 'report.controller',
                title: 'Transaction Report'
            }).state('report.orderTrxAll', {
                url: '/transaction/all',
                templateUrl: 'app/pages/report/report-all-list.view.html',
                controller: 'report.controller',
                title: 'Transaction Report'
            }).state('report.orderTrxAgency', {
                url: '/transaction/agency',
                templateUrl: 'app/pages/report/report-account-list.view.html',
                controller: 'report.controller',
                title: 'Transaction Report'
            });
        $urlRouterProvider.when('/report', '/report/profile');
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.charts.chartJs', [])
        .config(routeConfig).config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('charts.chartJs', {
                url: '/chartJs',
                templateUrl: 'app/pages/charts/chartJs/chartJs.html',
                title: 'Chart.js',
                sidebarMeta: {
                    order: 200
                }
            });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author ah
 * created on 18.11.2017
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components.pageTop', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('pagetop', {
            url: '/pagetop',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controller: 'pageTopCtrl',
        });
    }
  })();
  
'use strict';

angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'ngStorage',
    'Alertify'
]).run(['$rootScope', '$localStorage', '$http', '$state', '$stateParams', '$urlRouter', '$window',
    function ($rootScope, $localStorage, $http, $state, $stateParams, $urlRouter, $window) {
        $rootScope.$on('$viewContentLoading', function () {
            if (!$rootScope.currentUser && $localStorage.currentUser) {
                $rootScope.currentUser = $localStorage.currentUser;
            }
        });
        $rootScope.$on('$stateChangeStart', function (event, toState) {
            if (toState.name === 'document.all' && ($rootScope.currentUser.role != 'Administrator' && $rootScope.currentUser.role != 'Support Admin')) { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'transaction.all' && ($rootScope.currentUser.role != 'Administrator' && $rootScope.currentUser.role != 'Support Admin')) { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'transaction.allDetail' && ($rootScope.currentUser.role != 'Administrator' && $rootScope.currentUser.role != 'Support Admin')) { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'report.orderTrxAll' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'user.search' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'user.manage' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'agency.search' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'agency.manage' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'agency.create' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'project.listAll' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'notification.list' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'notification.detail' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
            if (toState.name === 'notification.new' && $rootScope.currentUser.role != 'Administrator') { 
                event.preventDefault();
                $state.go('home');
            }
        });
    }])
    .factory('HttpInterceptor',
        [
            '$q', '$rootScope', '$injector', '$localStorage', function ($q, $rootScope, $injector, $localStorage) {
                var loadingNumber = 0;

                var responseInterceptor = {
                    request: function (config) {
                        if ($rootScope.currentUser) {
                            config.headers['x-access-token'] = $rootScope.currentUser.token;
                        }
                        loadingNumber++;
                        $rootScope.$broadcast("loadingShow");

                        return config || $q.when(config);
                    },
                    response: function (response) {
                        if ((--loadingNumber) === 0) {
                            $rootScope.$broadcast("loadingHide");
                        }
                        if ($rootScope.currentUser) {
                            if (response.data.token) {
                                $rootScope.currentUser = {
                                    'role': response.data.token.role,
                                    'token': response.data.token.token,
                                    'isLogin': true,
                                    'userId': response.data.token.userId,
                                    'userName': response.data.token.userName,
                                    'userCreditBalance': response.data.token.userCreditBalance,
                                    'userCartCount': response.data.token.userCartCount,
                                    'agencyId': response.data.token.agencyId
                                };
                                $localStorage.currentUser = $rootScope.currentUser;
                            }
                        }
                        return response || $q.when(response);
                    },
                    responseError: function (response) {
                        if ((--loadingNumber) === 0) {
                            $rootScope.$broadcast("loadingHide");
                        }
                        switch (response.status) {
                            case -1:
                                alertify.error('Connection error');
                                return response;
                            case 401:
                                var $state = $injector.get('$state');
                                // $state.transitionTo('login');
                                return response;
                            case 400:
                                var $state = $injector.get('$state');
                                return response;
                        }
                        return $q.reject(response);
                    }
                };

                return responseInterceptor;
            }
        ])
    .config([
        '$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('HttpInterceptor');
        }
    ]);


var DateFormatter;!function(){"use strict";var e,t,a,n,r,o,i;o=864e5,i=3600,e=function(e,t){return"string"==typeof e&&"string"==typeof t&&e.toLowerCase()===t.toLowerCase()},t=function(e,a,n){var r=n||"0",o=e.toString();return o.length<a?t(r+o,a):o},a=function(e){var t,n;for(e=e||{},t=1;t<arguments.length;t++)if(n=arguments[t])for(var r in n)n.hasOwnProperty(r)&&("object"==typeof n[r]?a(e[r],n[r]):e[r]=n[r]);return e},n=function(e,t){for(var a=0;a<t.length;a++)if(t[a].toLowerCase()===e.toLowerCase())return a;return-1},r={dateSettings:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],meridiem:["AM","PM"],ordinal:function(e){var t=e%10,a={1:"st",2:"nd",3:"rd"};return 1!==Math.floor(e%100/10)&&a[t]?a[t]:"th"}},separators:/[ \-+\/\.T:@]/g,validParts:/[dDjlNSwzWFmMntLoYyaABgGhHisueTIOPZcrU]/g,intParts:/[djwNzmnyYhHgGis]/g,tzParts:/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,tzClip:/[^-+\dA-Z]/g},(DateFormatter=function(e){var t=this,n=a(r,e);t.dateSettings=n.dateSettings,t.separators=n.separators,t.validParts=n.validParts,t.intParts=n.intParts,t.tzParts=n.tzParts,t.tzClip=n.tzClip}).prototype={constructor:DateFormatter,getMonth:function(e){var t,a=this;return 0===(t=n(e,a.dateSettings.monthsShort)+1)&&(t=n(e,a.dateSettings.months)+1),t},parseDate:function(t,a){var n,r,o,i,s,d,u,l,f,c,h=this,m=!1,g=!1,p=h.dateSettings,y={date:null,year:null,month:null,day:null,hour:0,min:0,sec:0};if(!t)return null;if(t instanceof Date)return t;if("U"===a)return(o=parseInt(t))?new Date(1e3*o):t;switch(typeof t){case"number":return new Date(t);case"string":break;default:return null}if(!(n=a.match(h.validParts))||0===n.length)throw new Error("Invalid date format definition.");for(r=t.replace(h.separators,"\0").split("\0"),o=0;o<r.length;o++)switch(i=r[o],s=parseInt(i),n[o]){case"y":case"Y":if(!s)return null;f=i.length,y.year=2===f?parseInt((70>s?"20":"19")+i):s,m=!0;break;case"m":case"n":case"M":case"F":if(isNaN(s)){if(!((d=h.getMonth(i))>0))return null;y.month=d}else{if(!(s>=1&&12>=s))return null;y.month=s}m=!0;break;case"d":case"j":if(!(s>=1&&31>=s))return null;y.day=s,m=!0;break;case"g":case"h":if(u=n.indexOf("a")>-1?n.indexOf("a"):n.indexOf("A")>-1?n.indexOf("A"):-1,c=r[u],u>-1)l=e(c,p.meridiem[0])?0:e(c,p.meridiem[1])?12:-1,s>=1&&12>=s&&l>-1?y.hour=s+l-1:s>=0&&23>=s&&(y.hour=s);else{if(!(s>=0&&23>=s))return null;y.hour=s}g=!0;break;case"G":case"H":if(!(s>=0&&23>=s))return null;y.hour=s,g=!0;break;case"i":if(!(s>=0&&59>=s))return null;y.min=s,g=!0;break;case"s":if(!(s>=0&&59>=s))return null;y.sec=s,g=!0}if(!0===m&&y.year&&y.month&&y.day)y.date=new Date(y.year,y.month-1,y.day,y.hour,y.min,y.sec,0);else{if(!0!==g)return null;y.date=new Date(0,0,0,y.hour,y.min,y.sec,0)}return y.date},guessDate:function(e,t){if("string"!=typeof e)return e;var a,n,r,o,i,s,d=this,u=e.replace(d.separators,"\0").split("\0"),l=/^[djmn]/g,f=t.match(d.validParts),c=new Date,h=0;if(!l.test(f[0]))return e;for(r=0;r<u.length;r++){if(h=2,i=u[r],s=parseInt(i.substr(0,2)),isNaN(s))return null;switch(r){case 0:"m"===f[0]||"n"===f[0]?c.setMonth(s-1):c.setDate(s);break;case 1:"m"===f[0]||"n"===f[0]?c.setDate(s):c.setMonth(s-1);break;case 2:if(n=c.getFullYear(),a=i.length,h=4>a?a:4,!(n=parseInt(4>a?n.toString().substr(0,4-a)+i:i.substr(0,4))))return null;c.setFullYear(n);break;case 3:c.setHours(s);break;case 4:c.setMinutes(s);break;case 5:c.setSeconds(s)}(o=i.substr(h)).length>0&&u.splice(r+1,0,o)}return c},parseFormat:function(e,a){var n,r=this,s=r.dateSettings,d=/\\?(.?)/gi,u=function(e,t){return n[e]?n[e]():t};return n={d:function(){return t(n.j(),2)},D:function(){return s.daysShort[n.w()]},j:function(){return a.getDate()},l:function(){return s.days[n.w()]},N:function(){return n.w()||7},w:function(){return a.getDay()},z:function(){var e=new Date(n.Y(),n.n()-1,n.j()),t=new Date(n.Y(),0,1);return Math.round((e-t)/o)},W:function(){var e=new Date(n.Y(),n.n()-1,n.j()-n.N()+3),a=new Date(e.getFullYear(),0,4);return t(1+Math.round((e-a)/o/7),2)},F:function(){return s.months[a.getMonth()]},m:function(){return t(n.n(),2)},M:function(){return s.monthsShort[a.getMonth()]},n:function(){return a.getMonth()+1},t:function(){return new Date(n.Y(),n.n(),0).getDate()},L:function(){var e=n.Y();return e%4==0&&e%100!=0||e%400==0?1:0},o:function(){var e=n.n(),t=n.W();return n.Y()+(12===e&&9>t?1:1===e&&t>9?-1:0)},Y:function(){return a.getFullYear()},y:function(){return n.Y().toString().slice(-2)},a:function(){return n.A().toLowerCase()},A:function(){var e=n.G()<12?0:1;return s.meridiem[e]},B:function(){var e=a.getUTCHours()*i,n=60*a.getUTCMinutes(),r=a.getUTCSeconds();return t(Math.floor((e+n+r+i)/86.4)%1e3,3)},g:function(){return n.G()%12||12},G:function(){return a.getHours()},h:function(){return t(n.g(),2)},H:function(){return t(n.G(),2)},i:function(){return t(a.getMinutes(),2)},s:function(){return t(a.getSeconds(),2)},u:function(){return t(1e3*a.getMilliseconds(),6)},e:function(){return/\((.*)\)/.exec(String(a))[1]||"Coordinated Universal Time"},I:function(){return new Date(n.Y(),0)-Date.UTC(n.Y(),0)!=new Date(n.Y(),6)-Date.UTC(n.Y(),6)?1:0},O:function(){var e=a.getTimezoneOffset(),n=Math.abs(e);return(e>0?"-":"+")+t(100*Math.floor(n/60)+n%60,4)},P:function(){var e=n.O();return e.substr(0,3)+":"+e.substr(3,2)},T:function(){return(String(a).match(r.tzParts)||[""]).pop().replace(r.tzClip,"")||"UTC"},Z:function(){return 60*-a.getTimezoneOffset()},c:function(){return"Y-m-d\\TH:i:sP".replace(d,u)},r:function(){return"D, d M Y H:i:s O".replace(d,u)},U:function(){return a.getTime()/1e3||0}},u(e,e)},formatDate:function(e,t){var a,n,r,o,i,s=this,d="";if("string"==typeof e&&!(e=s.parseDate(e,t)))return null;if(e instanceof Date){for(r=t.length,a=0;r>a;a++)"S"!==(i=t.charAt(a))&&"\\"!==i&&(a>0&&"\\"===t.charAt(a-1)?d+=i:(o=s.parseFormat(i,e),a!==r-1&&s.intParts.test(i)&&"S"===t.charAt(a+1)&&(n=parseInt(o)||0,o+=s.dateSettings.ordinal(n)),d+=o));return d}return""}}}();var datetimepickerFactory=function(e){"use strict";function t(e,t,a){this.date=e,this.desc=t,this.style=a}var a={i18n:{ar:{months:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],dayOfWeekShort:["ن","ث","ع","خ","ج","س","ح"],dayOfWeek:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت","الأحد"]},ro:{months:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],dayOfWeekShort:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],dayOfWeek:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"]},id:{months:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],dayOfWeekShort:["Min","Sen","Sel","Rab","Kam","Jum","Sab"],dayOfWeek:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"]},is:{months:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],dayOfWeekShort:["Sun","Mán","Þrið","Mið","Fim","Fös","Lau"],dayOfWeek:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"]},bg:{months:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],dayOfWeekShort:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],dayOfWeek:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"]},fa:{months:["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],dayOfWeekShort:["یکشنبه","دوشنبه","سه شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"],dayOfWeek:["یک‌شنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنج‌شنبه","جمعه","شنبه","یک‌شنبه"]},ru:{months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],dayOfWeekShort:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],dayOfWeek:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"]},uk:{months:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],dayOfWeekShort:["Ндл","Пнд","Втр","Срд","Чтв","Птн","Сбт"],dayOfWeek:["Неділя","Понеділок","Вівторок","Середа","Четвер","П'ятниця","Субота"]},en:{months:["January","February","March","April","May","June","July","August","September","October","November","December"],dayOfWeekShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayOfWeek:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},el:{months:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],dayOfWeekShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],dayOfWeek:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"]},de:{months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],dayOfWeekShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayOfWeek:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"]},nl:{months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],dayOfWeekShort:["zo","ma","di","wo","do","vr","za"],dayOfWeek:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"]},tr:{months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],dayOfWeekShort:["Paz","Pts","Sal","Çar","Per","Cum","Cts"],dayOfWeek:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"]},fr:{months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],dayOfWeekShort:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],dayOfWeek:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"]},es:{months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],dayOfWeekShort:["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],dayOfWeek:["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]},th:{months:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],dayOfWeekShort:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],dayOfWeek:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัส","ศุกร์","เสาร์","อาทิตย์"]},pl:{months:["styczeń","luty","marzec","kwiecień","maj","czerwiec","lipiec","sierpień","wrzesień","październik","listopad","grudzień"],dayOfWeekShort:["nd","pn","wt","śr","cz","pt","sb"],dayOfWeek:["niedziela","poniedziałek","wtorek","środa","czwartek","piątek","sobota"]},pt:{months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],dayOfWeekShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"],dayOfWeek:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"]},ch:{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeekShort:["日","一","二","三","四","五","六"]},se:{months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],dayOfWeekShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]},km:{months:["មករា​","កុម្ភៈ","មិនា​","មេសា​","ឧសភា​","មិថុនា​","កក្កដា​","សីហា​","កញ្ញា​","តុលា​","វិច្ឆិកា","ធ្នូ​"],dayOfWeekShort:["អាទិ​","ច័ន្ទ​","អង្គារ​","ពុធ​","ព្រហ​​","សុក្រ​","សៅរ៍"],dayOfWeek:["អាទិត្យ​","ច័ន្ទ​","អង្គារ​","ពុធ​","ព្រហស្បតិ៍​","សុក្រ​","សៅរ៍"]},kr:{months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayOfWeekShort:["일","월","화","수","목","금","토"],dayOfWeek:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"]},it:{months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],dayOfWeekShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayOfWeek:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"]},da:{months:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],dayOfWeekShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayOfWeek:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"]},no:{months:["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],dayOfWeekShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayOfWeek:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"]},ja:{months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayOfWeekShort:["日","月","火","水","木","金","土"],dayOfWeek:["日曜","月曜","火曜","水曜","木曜","金曜","土曜"]},vi:{months:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayOfWeekShort:["CN","T2","T3","T4","T5","T6","T7"],dayOfWeek:["Chủ nhật","Thứ hai","Thứ ba","Thứ tư","Thứ năm","Thứ sáu","Thứ bảy"]},sl:{months:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],dayOfWeekShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],dayOfWeek:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"]},cs:{months:["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"],dayOfWeekShort:["Ne","Po","Út","St","Čt","Pá","So"]},hu:{months:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],dayOfWeekShort:["Va","Hé","Ke","Sze","Cs","Pé","Szo"],dayOfWeek:["vasárnap","hétfő","kedd","szerda","csütörtök","péntek","szombat"]},az:{months:["Yanvar","Fevral","Mart","Aprel","May","Iyun","Iyul","Avqust","Sentyabr","Oktyabr","Noyabr","Dekabr"],dayOfWeekShort:["B","Be","Ça","Ç","Ca","C","Ş"],dayOfWeek:["Bazar","Bazar ertəsi","Çərşənbə axşamı","Çərşənbə","Cümə axşamı","Cümə","Şənbə"]},bs:{months:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],dayOfWeekShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayOfWeek:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"]},ca:{months:["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],dayOfWeekShort:["Dg","Dl","Dt","Dc","Dj","Dv","Ds"],dayOfWeek:["Diumenge","Dilluns","Dimarts","Dimecres","Dijous","Divendres","Dissabte"]},"en-GB":{months:["January","February","March","April","May","June","July","August","September","October","November","December"],dayOfWeekShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayOfWeek:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},et:{months:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],dayOfWeekShort:["P","E","T","K","N","R","L"],dayOfWeek:["Pühapäev","Esmaspäev","Teisipäev","Kolmapäev","Neljapäev","Reede","Laupäev"]},eu:{months:["Urtarrila","Otsaila","Martxoa","Apirila","Maiatza","Ekaina","Uztaila","Abuztua","Iraila","Urria","Azaroa","Abendua"],dayOfWeekShort:["Ig.","Al.","Ar.","Az.","Og.","Or.","La."],dayOfWeek:["Igandea","Astelehena","Asteartea","Asteazkena","Osteguna","Ostirala","Larunbata"]},fi:{months:["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kesäkuu","Heinäkuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"],dayOfWeekShort:["Su","Ma","Ti","Ke","To","Pe","La"],dayOfWeek:["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"]},gl:{months:["Xan","Feb","Maz","Abr","Mai","Xun","Xul","Ago","Set","Out","Nov","Dec"],dayOfWeekShort:["Dom","Lun","Mar","Mer","Xov","Ven","Sab"],dayOfWeek:["Domingo","Luns","Martes","Mércores","Xoves","Venres","Sábado"]},hr:{months:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],dayOfWeekShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayOfWeek:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"]},ko:{months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayOfWeekShort:["일","월","화","수","목","금","토"],dayOfWeek:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"]},lt:{months:["Sausio","Vasario","Kovo","Balandžio","Gegužės","Birželio","Liepos","Rugpjūčio","Rugsėjo","Spalio","Lapkričio","Gruodžio"],dayOfWeekShort:["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"],dayOfWeek:["Sekmadienis","Pirmadienis","Antradienis","Trečiadienis","Ketvirtadienis","Penktadienis","Šeštadienis"]},lv:{months:["Janvāris","Februāris","Marts","Aprīlis ","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],dayOfWeekShort:["Sv","Pr","Ot","Tr","Ct","Pk","St"],dayOfWeek:["Svētdiena","Pirmdiena","Otrdiena","Trešdiena","Ceturtdiena","Piektdiena","Sestdiena"]},mk:{months:["јануари","февруари","март","април","мај","јуни","јули","август","септември","октомври","ноември","декември"],dayOfWeekShort:["нед","пон","вто","сре","чет","пет","саб"],dayOfWeek:["Недела","Понеделник","Вторник","Среда","Четврток","Петок","Сабота"]},mn:{months:["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"],dayOfWeekShort:["Дав","Мяг","Лха","Пүр","Бсн","Бям","Ням"],dayOfWeek:["Даваа","Мягмар","Лхагва","Пүрэв","Баасан","Бямба","Ням"]},"pt-BR":{months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],dayOfWeekShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayOfWeek:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"]},sk:{months:["Január","Február","Marec","Apríl","Máj","Jún","Júl","August","September","Október","November","December"],dayOfWeekShort:["Ne","Po","Ut","St","Št","Pi","So"],dayOfWeek:["Nedeľa","Pondelok","Utorok","Streda","Štvrtok","Piatok","Sobota"]},sq:{months:["Janar","Shkurt","Mars","Prill","Maj","Qershor","Korrik","Gusht","Shtator","Tetor","Nëntor","Dhjetor"],dayOfWeekShort:["Die","Hën","Mar","Mër","Enj","Pre","Shtu"],dayOfWeek:["E Diel","E Hënë","E Martē","E Mërkurë","E Enjte","E Premte","E Shtunë"]},"sr-YU":{months:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],dayOfWeekShort:["Ned","Pon","Uto","Sre","čet","Pet","Sub"],dayOfWeek:["Nedelja","Ponedeljak","Utorak","Sreda","Četvrtak","Petak","Subota"]},sr:{months:["јануар","фебруар","март","април","мај","јун","јул","август","септембар","октобар","новембар","децембар"],dayOfWeekShort:["нед","пон","уто","сре","чет","пет","суб"],dayOfWeek:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"]},sv:{months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],dayOfWeekShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"],dayOfWeek:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"]},"zh-TW":{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeekShort:["日","一","二","三","四","五","六"],dayOfWeek:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]},zh:{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeekShort:["日","一","二","三","四","五","六"],dayOfWeek:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]},ug:{months:["1-ئاي","2-ئاي","3-ئاي","4-ئاي","5-ئاي","6-ئاي","7-ئاي","8-ئاي","9-ئاي","10-ئاي","11-ئاي","12-ئاي"],dayOfWeek:["يەكشەنبە","دۈشەنبە","سەيشەنبە","چارشەنبە","پەيشەنبە","جۈمە","شەنبە"]},he:{months:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],dayOfWeekShort:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],dayOfWeek:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת","ראשון"]},hy:{months:["Հունվար","Փետրվար","Մարտ","Ապրիլ","Մայիս","Հունիս","Հուլիս","Օգոստոս","Սեպտեմբեր","Հոկտեմբեր","Նոյեմբեր","Դեկտեմբեր"],dayOfWeekShort:["Կի","Երկ","Երք","Չոր","Հնգ","Ուրբ","Շբթ"],dayOfWeek:["Կիրակի","Երկուշաբթի","Երեքշաբթի","Չորեքշաբթի","Հինգշաբթի","Ուրբաթ","Շաբաթ"]},kg:{months:["Үчтүн айы","Бирдин айы","Жалган Куран","Чын Куран","Бугу","Кулжа","Теке","Баш Оона","Аяк Оона","Тогуздун айы","Жетинин айы","Бештин айы"],dayOfWeekShort:["Жек","Дүй","Шей","Шар","Бей","Жум","Ише"],dayOfWeek:["Жекшемб","Дүйшөмб","Шейшемб","Шаршемб","Бейшемби","Жума","Ишенб"]},rm:{months:["Schaner","Favrer","Mars","Avrigl","Matg","Zercladur","Fanadur","Avust","Settember","October","November","December"],dayOfWeekShort:["Du","Gli","Ma","Me","Gie","Ve","So"],dayOfWeek:["Dumengia","Glindesdi","Mardi","Mesemna","Gievgia","Venderdi","Sonda"]},ka:{months:["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],dayOfWeekShort:["კვ","ორშ","სამშ","ოთხ","ხუთ","პარ","შაბ"],dayOfWeek:["კვირა","ორშაბათი","სამშაბათი","ოთხშაბათი","ხუთშაბათი","პარასკევი","შაბათი"]}},ownerDocument:document,contentWindow:window,value:"",rtl:!1,format:"Y/m/d H:i",formatTime:"H:i",formatDate:"Y/m/d",startDate:!1,step:60,monthChangeSpinner:!0,closeOnDateSelect:!1,closeOnTimeSelect:!0,closeOnWithoutClick:!0,closeOnInputClick:!0,openOnFocus:!0,timepicker:!0,datepicker:!0,weeks:!1,defaultTime:!1,defaultDate:!1,minDate:!1,maxDate:!1,minTime:!1,maxTime:!1,minDateTime:!1,disabledMinTime:!1,disabledMaxTime:!1,allowTimes:[],opened:!1,initTime:!0,inline:!1,theme:"",touchMovedThreshold:5,onSelectDate:function(){},onSelectTime:function(){},onChangeMonth:function(){},onGetWeekOfYear:function(){},onChangeYear:function(){},onChangeDateTime:function(){},onShow:function(){},onClose:function(){},onGenerate:function(){},withoutCopyright:!0,inverseButton:!1,hours12:!1,next:"xdsoft_next",prev:"xdsoft_prev",dayOfWeekStart:0,parentID:"body",timeHeightInTimePicker:25,timepickerScrollbar:!0,todayButton:!0,prevButton:!0,nextButton:!0,defaultSelect:!0,scrollMonth:!0,scrollTime:!0,scrollInput:!0,lazyInit:!1,mask:!1,validateOnBlur:!0,allowBlank:!0,yearStart:1950,yearEnd:2050,monthStart:0,monthEnd:11,style:"",id:"",fixed:!1,roundTime:"round",className:"",weekends:[],highlightedDates:[],highlightedPeriods:[],allowDates:[],allowDateRe:null,disabledDates:[],disabledWeekDays:[],yearOffset:0,beforeShowDay:null,enterLikeTab:!0,showApplyButton:!1},n=null,r="en",o={meridiem:["AM","PM"]},i=function(){var t=a.i18n[r],i={days:t.dayOfWeek,daysShort:t.dayOfWeekShort,months:t.months,monthsShort:e.map(t.months,function(e){return e.substring(0,3)})};"function"==typeof DateFormatter&&(n=new DateFormatter({dateSettings:e.extend({},o,i)}))};e.datetimepicker={setLocale:function(e){var t=a.i18n[e]?e:"en";r!==t&&(r=t,i())},setDateFormatter:function(e){n=e},RFC_2822:"D, d M Y H:i:s O",ATOM:"Y-m-dTH:i:sP",ISO_8601:"Y-m-dTH:i:sO",RFC_822:"D, d M y H:i:s O",RFC_850:"l, d-M-y H:i:s T",RFC_1036:"D, d M y H:i:s O",RFC_1123:"D, d M Y H:i:s O",RSS:"D, d M Y H:i:s O",W3C:"Y-m-dTH:i:sP"},i(),window.getComputedStyle||(window.getComputedStyle=function(e){return this.el=e,this.getPropertyValue=function(t){var a=/(-([a-z]))/g;return"float"===t&&(t="styleFloat"),a.test(t)&&(t=t.replace(a,function(e,t,a){return a.toUpperCase()})),e.currentStyle[t]||null},this}),Array.prototype.indexOf||(Array.prototype.indexOf=function(e,t){var a,n;for(a=t||0,n=this.length;a<n;a+=1)if(this[a]===e)return a;return-1}),Date.prototype.countDaysInMonth=function(){return new Date(this.getFullYear(),this.getMonth()+1,0).getDate()},e.fn.xdsoftScroller=function(t,a){return this.each(function(){var n,r,o,i,s,d=e(this),u=function(e){var t,a={x:0,y:0};return"touchstart"===e.type||"touchmove"===e.type||"touchend"===e.type||"touchcancel"===e.type?(t=e.originalEvent.touches[0]||e.originalEvent.changedTouches[0],a.x=t.clientX,a.y=t.clientY):"mousedown"!==e.type&&"mouseup"!==e.type&&"mousemove"!==e.type&&"mouseover"!==e.type&&"mouseout"!==e.type&&"mouseenter"!==e.type&&"mouseleave"!==e.type||(a.x=e.clientX,a.y=e.clientY),a},l=100,f=!1,c=0,h=0,m=0,g=!1,p=0,y=function(){};"hide"!==a?(e(this).hasClass("xdsoft_scroller_box")||(n=d.children().eq(0),r=d[0].clientHeight,o=n[0].offsetHeight,i=e('<div class="xdsoft_scrollbar"></div>'),s=e('<div class="xdsoft_scroller"></div>'),i.append(s),d.addClass("xdsoft_scroller_box").append(i),y=function(e){var t=u(e).y-c+p;t<0&&(t=0),t+s[0].offsetHeight>m&&(t=m-s[0].offsetHeight),d.trigger("scroll_element.xdsoft_scroller",[l?t/l:0])},s.on("touchstart.xdsoft_scroller mousedown.xdsoft_scroller",function(n){r||d.trigger("resize_scroll.xdsoft_scroller",[a]),c=u(n).y,p=parseInt(s.css("margin-top"),10),m=i[0].offsetHeight,"mousedown"===n.type||"touchstart"===n.type?(t.ownerDocument&&e(t.ownerDocument.body).addClass("xdsoft_noselect"),e([t.ownerDocument.body,t.contentWindow]).on("touchend mouseup.xdsoft_scroller",function a(){e([t.ownerDocument.body,t.contentWindow]).off("touchend mouseup.xdsoft_scroller",a).off("mousemove.xdsoft_scroller",y).removeClass("xdsoft_noselect")}),e(t.ownerDocument.body).on("mousemove.xdsoft_scroller",y)):(g=!0,n.stopPropagation(),n.preventDefault())}).on("touchmove",function(e){g&&(e.preventDefault(),y(e))}).on("touchend touchcancel",function(){g=!1,p=0}),d.on("scroll_element.xdsoft_scroller",function(e,t){r||d.trigger("resize_scroll.xdsoft_scroller",[t,!0]),t=t>1?1:t<0||isNaN(t)?0:t,s.css("margin-top",l*t),setTimeout(function(){n.css("marginTop",-parseInt((n[0].offsetHeight-r)*t,10))},10)}).on("resize_scroll.xdsoft_scroller",function(e,t,a){var u,f;r=d[0].clientHeight,o=n[0].offsetHeight,f=(u=r/o)*i[0].offsetHeight,u>1?s.hide():(s.show(),s.css("height",parseInt(f>10?f:10,10)),l=i[0].offsetHeight-s[0].offsetHeight,!0!==a&&d.trigger("scroll_element.xdsoft_scroller",[t||Math.abs(parseInt(n.css("marginTop"),10))/(o-r)]))}),d.on("mousewheel",function(e){var t=Math.abs(parseInt(n.css("marginTop"),10));return(t-=20*e.deltaY)<0&&(t=0),d.trigger("scroll_element.xdsoft_scroller",[t/(o-r)]),e.stopPropagation(),!1}),d.on("touchstart",function(e){f=u(e),h=Math.abs(parseInt(n.css("marginTop"),10))}),d.on("touchmove",function(e){if(f){e.preventDefault();var t=u(e);d.trigger("scroll_element.xdsoft_scroller",[(h-(t.y-f.y))/(o-r)])}}),d.on("touchend touchcancel",function(){f=!1,h=0})),d.trigger("resize_scroll.xdsoft_scroller",[a])):d.find(".xdsoft_scrollbar").hide()})},e.fn.datetimepicker=function(o,i){var s,d,u=this,l=48,f=57,c=96,h=105,m=17,g=46,p=13,y=27,v=8,D=37,b=38,k=39,x=40,T=9,S=116,w=65,M=67,O=86,W=90,_=89,F=!1,C=e.isPlainObject(o)||!o?e.extend(!0,{},a,o):e.extend(!0,{},a),P=0,A=function(e){e.on("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart",function t(){e.is(":disabled")||e.data("xdsoft_datetimepicker")||(clearTimeout(P),P=setTimeout(function(){e.data("xdsoft_datetimepicker")||s(e),e.off("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart",t).trigger("open.xdsoft")},100))})};return s=function(a){function i(){var e,t=!1;return C.startDate?t=Y.strToDate(C.startDate):(t=C.value||(a&&a.val&&a.val()?a.val():""))?t=Y.strToDateTime(t):C.defaultDate&&(t=Y.strToDateTime(C.defaultDate),C.defaultTime&&(e=Y.strtotime(C.defaultTime),t.setHours(e.getHours()),t.setMinutes(e.getMinutes()))),t&&Y.isValidDate(t)?H.data("changed",!0):t="",t||0}function s(t){var n=function(e,t){var a=e.replace(/([\[\]\/\{\}\(\)\-\.\+]{1})/g,"\\$1").replace(/_/g,"{digit+}").replace(/([0-9]{1})/g,"{digit$1}").replace(/\{digit([0-9]{1})\}/g,"[0-$1_]{1}").replace(/\{digit[\+]\}/g,"[0-9_]{1}");return new RegExp(a).test(t)},r=function(e,a){if(!(e="string"==typeof e||e instanceof String?t.ownerDocument.getElementById(e):e))return!1;if(e.createTextRange){var n=e.createTextRange();return n.collapse(!0),n.moveEnd("character",a),n.moveStart("character",a),n.select(),!0}return!!e.setSelectionRange&&(e.setSelectionRange(a,a),!0)};t.mask&&a.off("keydown.xdsoft"),!0===t.mask&&("undefined"!=typeof moment?t.mask=t.format.replace(/Y{4}/g,"9999").replace(/Y{2}/g,"99").replace(/M{2}/g,"19").replace(/D{2}/g,"39").replace(/H{2}/g,"29").replace(/m{2}/g,"59").replace(/s{2}/g,"59"):t.mask=t.format.replace(/Y/g,"9999").replace(/F/g,"9999").replace(/m/g,"19").replace(/d/g,"39").replace(/H/g,"29").replace(/i/g,"59").replace(/s/g,"59")),"string"===e.type(t.mask)&&(n(t.mask,a.val())||(a.val(t.mask.replace(/[0-9]/g,"_")),r(a[0],0)),a.on("paste.xdsoft",function(o){var i=(o.clipboardData||o.originalEvent.clipboardData||window.clipboardData).getData("text"),s=this.value,d=this.selectionStart;return s=s.substr(0,d)+i+s.substr(d+i.length),d+=i.length,n(t.mask,s)?(this.value=s,r(this,d)):""===e.trim(s)?this.value=t.mask.replace(/[0-9]/g,"_"):a.trigger("error_input.xdsoft"),o.preventDefault(),!1}),a.on("keydown.xdsoft",function(o){var i,s=this.value,d=o.which,u=this.selectionStart,C=this.selectionEnd,P=u!==C;if(d>=l&&d<=f||d>=c&&d<=h||d===v||d===g){for(i=d===v||d===g?"_":String.fromCharCode(c<=d&&d<=h?d-l:d),d===v&&u&&!P&&(u-=1);;){var A=t.mask.substr(u,1),Y=u<t.mask.length,j=u>0;if(!(/[^0-9_]/.test(A)&&Y&&j))break;u+=d!==v||P?1:-1}if(P){var H=C-u,J=t.mask.replace(/[0-9]/g,"_"),z=J.substr(u,H).substr(1);s=s.substr(0,u)+(i+z)+s.substr(u+H)}else s=s.substr(0,u)+i+s.substr(u+1);if(""===e.trim(s))s=J;else if(u===t.mask.length)return o.preventDefault(),!1;for(u+=d===v?0:1;/[^0-9_]/.test(t.mask.substr(u,1))&&u<t.mask.length&&u>0;)u+=d===v?0:1;n(t.mask,s)?(this.value=s,r(this,u)):""===e.trim(s)?this.value=t.mask.replace(/[0-9]/g,"_"):a.trigger("error_input.xdsoft")}else if(-1!==[w,M,O,W,_].indexOf(d)&&F||-1!==[y,b,x,D,k,S,m,T,p].indexOf(d))return!0;return o.preventDefault(),!1}))}var d,u,P,A,Y,j,H=e('<div class="xdsoft_datetimepicker xdsoft_noselect"></div>'),J=e('<div class="xdsoft_copyright"><a target="_blank" href="http://xdsoft.net/jqplugins/datetimepicker/">xdsoft.net</a></div>'),z=e('<div class="xdsoft_datepicker active"></div>'),I=e('<div class="xdsoft_monthpicker"><button type="button" class="xdsoft_prev"></button><button type="button" class="xdsoft_today_button"></button><div class="xdsoft_label xdsoft_month"><span></span><i></i></div><div class="xdsoft_label xdsoft_year"><span></span><i></i></div><button type="button" class="xdsoft_next"></button></div>'),N=e('<div class="xdsoft_calendar"></div>'),L=e('<div class="xdsoft_timepicker active"><button type="button" class="xdsoft_prev"></button><div class="xdsoft_time_box"></div><button type="button" class="xdsoft_next"></button></div>'),E=L.find(".xdsoft_time_box").eq(0),R=e('<div class="xdsoft_time_variant"></div>'),V=e('<button type="button" class="xdsoft_save_selected blue-gradient-button">Save Selected</button>'),B=e('<div class="xdsoft_select xdsoft_monthselect"><div></div></div>'),G=e('<div class="xdsoft_select xdsoft_yearselect"><div></div></div>'),U=!1,q=0;C.id&&H.attr("id",C.id),C.style&&H.attr("style",C.style),C.weeks&&H.addClass("xdsoft_showweeks"),C.rtl&&H.addClass("xdsoft_rtl"),H.addClass("xdsoft_"+C.theme),H.addClass(C.className),I.find(".xdsoft_month span").after(B),I.find(".xdsoft_year span").after(G),I.find(".xdsoft_month,.xdsoft_year").on("touchstart mousedown.xdsoft",function(t){var a,n,r=e(this).find(".xdsoft_select").eq(0),o=0,i=0,s=r.is(":visible");for(I.find(".xdsoft_select").hide(),Y.currentTime&&(o=Y.currentTime[e(this).hasClass("xdsoft_month")?"getMonth":"getFullYear"]()),r[s?"hide":"show"](),a=r.find("div.xdsoft_option"),n=0;n<a.length&&a.eq(n).data("value")!==o;n+=1)i+=a[0].offsetHeight;return r.xdsoftScroller(C,i/(r.children()[0].offsetHeight-r[0].clientHeight)),t.stopPropagation(),!1});var X=function(e){this.touchStartPosition=this.touchStartPosition||e.originalEvent.touches[0];var t=e.originalEvent.touches[0],a=Math.abs(this.touchStartPosition.clientX-t.clientX),n=Math.abs(this.touchStartPosition.clientY-t.clientY);Math.sqrt(a*a+n*n)>C.touchMovedThreshold&&(this.touchMoved=!0)};I.find(".xdsoft_select").xdsoftScroller(C).on("touchstart mousedown.xdsoft",function(e){this.touchMoved=!1,this.touchStartPosition=e.originalEvent.touches[0],e.stopPropagation(),e.preventDefault()}).on("touchmove",".xdsoft_option",X).on("touchend mousedown.xdsoft",".xdsoft_option",function(){if(!this.touchMoved){void 0!==Y.currentTime&&null!==Y.currentTime||(Y.currentTime=Y.now());var t=Y.currentTime.getFullYear();Y&&Y.currentTime&&Y.currentTime[e(this).parent().parent().hasClass("xdsoft_monthselect")?"setMonth":"setFullYear"](e(this).data("value")),e(this).parent().parent().hide(),H.trigger("xchange.xdsoft"),C.onChangeMonth&&e.isFunction(C.onChangeMonth)&&C.onChangeMonth.call(H,Y.currentTime,H.data("input")),t!==Y.currentTime.getFullYear()&&e.isFunction(C.onChangeYear)&&C.onChangeYear.call(H,Y.currentTime,H.data("input"))}}),H.getValue=function(){return Y.getCurrentTime()},H.setOptions=function(r){var o={};C=e.extend(!0,{},C,r),r.allowTimes&&e.isArray(r.allowTimes)&&r.allowTimes.length&&(C.allowTimes=e.extend(!0,[],r.allowTimes)),r.weekends&&e.isArray(r.weekends)&&r.weekends.length&&(C.weekends=e.extend(!0,[],r.weekends)),r.allowDates&&e.isArray(r.allowDates)&&r.allowDates.length&&(C.allowDates=e.extend(!0,[],r.allowDates)),r.allowDateRe&&"[object String]"===Object.prototype.toString.call(r.allowDateRe)&&(C.allowDateRe=new RegExp(r.allowDateRe)),r.highlightedDates&&e.isArray(r.highlightedDates)&&r.highlightedDates.length&&(e.each(r.highlightedDates,function(a,r){var i,s=e.map(r.split(","),e.trim),d=new t(n.parseDate(s[0],C.formatDate),s[1],s[2]),u=n.formatDate(d.date,C.formatDate);void 0!==o[u]?(i=o[u].desc)&&i.length&&d.desc&&d.desc.length&&(o[u].desc=i+"\n"+d.desc):o[u]=d}),C.highlightedDates=e.extend(!0,[],o)),r.highlightedPeriods&&e.isArray(r.highlightedPeriods)&&r.highlightedPeriods.length&&(o=e.extend(!0,[],C.highlightedDates),e.each(r.highlightedPeriods,function(a,r){var i,s,d,u,l,f,c;if(e.isArray(r))i=r[0],s=r[1],d=r[2],c=r[3];else{var h=e.map(r.split(","),e.trim);i=n.parseDate(h[0],C.formatDate),s=n.parseDate(h[1],C.formatDate),d=h[2],c=h[3]}for(;i<=s;)u=new t(i,d,c),l=n.formatDate(i,C.formatDate),i.setDate(i.getDate()+1),void 0!==o[l]?(f=o[l].desc)&&f.length&&u.desc&&u.desc.length&&(o[l].desc=f+"\n"+u.desc):o[l]=u}),C.highlightedDates=e.extend(!0,[],o)),r.disabledDates&&e.isArray(r.disabledDates)&&r.disabledDates.length&&(C.disabledDates=e.extend(!0,[],r.disabledDates)),r.disabledWeekDays&&e.isArray(r.disabledWeekDays)&&r.disabledWeekDays.length&&(C.disabledWeekDays=e.extend(!0,[],r.disabledWeekDays)),!C.open&&!C.opened||C.inline||a.trigger("open.xdsoft"),C.inline&&(U=!0,H.addClass("xdsoft_inline"),a.after(H).hide()),C.inverseButton&&(C.next="xdsoft_prev",C.prev="xdsoft_next"),C.datepicker?z.addClass("active"):z.removeClass("active"),C.timepicker?L.addClass("active"):L.removeClass("active"),C.value&&(Y.setCurrentTime(C.value),a&&a.val&&a.val(Y.str)),isNaN(C.dayOfWeekStart)?C.dayOfWeekStart=0:C.dayOfWeekStart=parseInt(C.dayOfWeekStart,10)%7,C.timepickerScrollbar||E.xdsoftScroller(C,"hide"),C.minDate&&/^[\+\-](.*)$/.test(C.minDate)&&(C.minDate=n.formatDate(Y.strToDateTime(C.minDate),C.formatDate)),C.maxDate&&/^[\+\-](.*)$/.test(C.maxDate)&&(C.maxDate=n.formatDate(Y.strToDateTime(C.maxDate),C.formatDate)),C.minDateTime&&/^\+(.*)$/.test(C.minDateTime)&&(C.minDateTime=Y.strToDateTime(C.minDateTime).dateFormat(C.formatDate)),V.toggle(C.showApplyButton),I.find(".xdsoft_today_button").css("visibility",C.todayButton?"visible":"hidden"),I.find("."+C.prev).css("visibility",C.prevButton?"visible":"hidden"),I.find("."+C.next).css("visibility",C.nextButton?"visible":"hidden"),s(C),C.validateOnBlur&&a.off("blur.xdsoft").on("blur.xdsoft",function(){if(C.allowBlank&&(!e.trim(e(this).val()).length||"string"==typeof C.mask&&e.trim(e(this).val())===C.mask.replace(/[0-9]/g,"_")))e(this).val(null),H.data("xdsoft_datetime").empty();else{var t=n.parseDate(e(this).val(),C.format);if(t)e(this).val(n.formatDate(t,C.format));else{var a=+[e(this).val()[0],e(this).val()[1]].join(""),r=+[e(this).val()[2],e(this).val()[3]].join("");!C.datepicker&&C.timepicker&&a>=0&&a<24&&r>=0&&r<60?e(this).val([a,r].map(function(e){return e>9?e:"0"+e}).join(":")):e(this).val(n.formatDate(Y.now(),C.format))}H.data("xdsoft_datetime").setCurrentTime(e(this).val())}H.trigger("changedatetime.xdsoft"),H.trigger("close.xdsoft")}),C.dayOfWeekStartPrev=0===C.dayOfWeekStart?6:C.dayOfWeekStart-1,H.trigger("xchange.xdsoft").trigger("afterOpen.xdsoft")},H.data("options",C).on("touchstart mousedown.xdsoft",function(e){return e.stopPropagation(),e.preventDefault(),G.hide(),B.hide(),!1}),E.append(R),E.xdsoftScroller(C),H.on("afterOpen.xdsoft",function(){E.xdsoftScroller(C)}),H.append(z).append(L),!0!==C.withoutCopyright&&H.append(J),z.append(I).append(N).append(V),e(C.parentID).append(H),Y=new function(){var t=this;t.now=function(e){var a,n,r=new Date;return!e&&C.defaultDate&&(a=t.strToDateTime(C.defaultDate),r.setFullYear(a.getFullYear()),r.setMonth(a.getMonth()),r.setDate(a.getDate())),C.yearOffset&&r.setFullYear(r.getFullYear()+C.yearOffset),!e&&C.defaultTime&&(n=t.strtotime(C.defaultTime),r.setHours(n.getHours()),r.setMinutes(n.getMinutes()),r.setSeconds(n.getSeconds()),r.setMilliseconds(n.getMilliseconds())),r},t.isValidDate=function(e){return"[object Date]"===Object.prototype.toString.call(e)&&!isNaN(e.getTime())},t.setCurrentTime=function(e,a){"string"==typeof e?t.currentTime=t.strToDateTime(e):t.isValidDate(e)?t.currentTime=e:e||a||!C.allowBlank||C.inline?t.currentTime=t.now():t.currentTime=null,H.trigger("xchange.xdsoft")},t.empty=function(){t.currentTime=null},t.getCurrentTime=function(){return t.currentTime},t.nextMonth=function(){void 0!==t.currentTime&&null!==t.currentTime||(t.currentTime=t.now());var a,n=t.currentTime.getMonth()+1;return 12===n&&(t.currentTime.setFullYear(t.currentTime.getFullYear()+1),n=0),a=t.currentTime.getFullYear(),t.currentTime.setDate(Math.min(new Date(t.currentTime.getFullYear(),n+1,0).getDate(),t.currentTime.getDate())),t.currentTime.setMonth(n),C.onChangeMonth&&e.isFunction(C.onChangeMonth)&&C.onChangeMonth.call(H,Y.currentTime,H.data("input")),a!==t.currentTime.getFullYear()&&e.isFunction(C.onChangeYear)&&C.onChangeYear.call(H,Y.currentTime,H.data("input")),H.trigger("xchange.xdsoft"),n},t.prevMonth=function(){void 0!==t.currentTime&&null!==t.currentTime||(t.currentTime=t.now());var a=t.currentTime.getMonth()-1;return-1===a&&(t.currentTime.setFullYear(t.currentTime.getFullYear()-1),a=11),t.currentTime.setDate(Math.min(new Date(t.currentTime.getFullYear(),a+1,0).getDate(),t.currentTime.getDate())),t.currentTime.setMonth(a),C.onChangeMonth&&e.isFunction(C.onChangeMonth)&&C.onChangeMonth.call(H,Y.currentTime,H.data("input")),H.trigger("xchange.xdsoft"),a},t.getWeekOfYear=function(t){if(C.onGetWeekOfYear&&e.isFunction(C.onGetWeekOfYear)){var a=C.onGetWeekOfYear.call(H,t);if(void 0!==a)return a}var n=new Date(t.getFullYear(),0,1);return 4!==n.getDay()&&n.setMonth(0,1+(4-n.getDay()+7)%7),Math.ceil(((t-n)/864e5+n.getDay()+1)/7)},t.strToDateTime=function(e){var a,r,o=[];return e&&e instanceof Date&&t.isValidDate(e)?e:((o=/^([+-]{1})(.*)$/.exec(e))&&(o[2]=n.parseDate(o[2],C.formatDate)),o&&o[2]?(a=o[2].getTime()-6e4*o[2].getTimezoneOffset(),r=new Date(t.now(!0).getTime()+parseInt(o[1]+"1",10)*a)):r=e?n.parseDate(e,C.format):t.now(),t.isValidDate(r)||(r=t.now()),r)},t.strToDate=function(e){if(e&&e instanceof Date&&t.isValidDate(e))return e;var a=e?n.parseDate(e,C.formatDate):t.now(!0);return t.isValidDate(a)||(a=t.now(!0)),a},t.strtotime=function(e){if(e&&e instanceof Date&&t.isValidDate(e))return e;var a=e?n.parseDate(e,C.formatTime):t.now(!0);return t.isValidDate(a)||(a=t.now(!0)),a},t.str=function(){return n.formatDate(t.currentTime,C.format)},t.currentTime=this.now()},V.on("touchend click",function(e){e.preventDefault(),H.data("changed",!0),Y.setCurrentTime(i()),a.val(Y.str()),H.trigger("close.xdsoft")}),I.find(".xdsoft_today_button").on("touchend mousedown.xdsoft",function(){H.data("changed",!0),Y.setCurrentTime(0,!0),H.trigger("afterOpen.xdsoft")}).on("dblclick.xdsoft",function(){var e,t,n=Y.getCurrentTime();n=new Date(n.getFullYear(),n.getMonth(),n.getDate()),e=Y.strToDate(C.minDate),n<(e=new Date(e.getFullYear(),e.getMonth(),e.getDate()))||(t=Y.strToDate(C.maxDate),n>(t=new Date(t.getFullYear(),t.getMonth(),t.getDate()))||(a.val(Y.str()),a.trigger("change"),H.trigger("close.xdsoft")))}),I.find(".xdsoft_prev,.xdsoft_next").on("touchend mousedown.xdsoft",function(){var t=e(this),a=0,n=!1;!function e(r){t.hasClass(C.next)?Y.nextMonth():t.hasClass(C.prev)&&Y.prevMonth(),C.monthChangeSpinner&&(n||(a=setTimeout(e,r||100)))}(500),e([C.ownerDocument.body,C.contentWindow]).on("touchend mouseup.xdsoft",function t(){clearTimeout(a),n=!0,e([C.ownerDocument.body,C.contentWindow]).off("touchend mouseup.xdsoft",t)})}),L.find(".xdsoft_prev,.xdsoft_next").on("touchend mousedown.xdsoft",function(){var t=e(this),a=0,n=!1,r=110;!function e(o){var i=E[0].clientHeight,s=R[0].offsetHeight,d=Math.abs(parseInt(R.css("marginTop"),10));t.hasClass(C.next)&&s-i-C.timeHeightInTimePicker>=d?R.css("marginTop","-"+(d+C.timeHeightInTimePicker)+"px"):t.hasClass(C.prev)&&d-C.timeHeightInTimePicker>=0&&R.css("marginTop","-"+(d-C.timeHeightInTimePicker)+"px"),E.trigger("scroll_element.xdsoft_scroller",[Math.abs(parseInt(R[0].style.marginTop,10)/(s-i))]),r=r>10?10:r-10,n||(a=setTimeout(e,o||r))}(500),e([C.ownerDocument.body,C.contentWindow]).on("touchend mouseup.xdsoft",function t(){clearTimeout(a),n=!0,e([C.ownerDocument.body,C.contentWindow]).off("touchend mouseup.xdsoft",t)})}),d=0,H.on("xchange.xdsoft",function(t){clearTimeout(d),d=setTimeout(function(){void 0!==Y.currentTime&&null!==Y.currentTime||(Y.currentTime=Y.now());for(var t,i,s,d,u,l,f,c,h,m,g="",p=new Date(Y.currentTime.getFullYear(),Y.currentTime.getMonth(),1,12,0,0),y=0,v=Y.now(),D=!1,b=!1,k=!1,x=[],T=!0,S="";p.getDay()!==C.dayOfWeekStart;)p.setDate(p.getDate()-1);for(g+="<table><thead><tr>",C.weeks&&(g+="<th></th>"),t=0;t<7;t+=1)g+="<th>"+C.i18n[r].dayOfWeekShort[(t+C.dayOfWeekStart)%7]+"</th>";for(g+="</tr></thead>",g+="<tbody>",!1!==C.maxDate&&(D=Y.strToDate(C.maxDate),D=new Date(D.getFullYear(),D.getMonth(),D.getDate(),23,59,59,999)),!1!==C.minDate&&(b=Y.strToDate(C.minDate),b=new Date(b.getFullYear(),b.getMonth(),b.getDate())),!1!==C.minDateTime&&(k=Y.strToDate(C.minDateTime),k=new Date(k.getFullYear(),k.getMonth(),k.getDate(),k.getHours(),k.getMinutes(),k.getSeconds()));y<Y.currentTime.countDaysInMonth()||p.getDay()!==C.dayOfWeekStart||Y.currentTime.getMonth()===p.getMonth();)x=[],y+=1,s=p.getDay(),d=p.getDate(),u=p.getFullYear(),l=p.getMonth(),f=Y.getWeekOfYear(p),m="",x.push("xdsoft_date"),c=C.beforeShowDay&&e.isFunction(C.beforeShowDay.call)?C.beforeShowDay.call(H,p):null,C.allowDateRe&&"[object RegExp]"===Object.prototype.toString.call(C.allowDateRe)&&(C.allowDateRe.test(n.formatDate(p,C.formatDate))||x.push("xdsoft_disabled")),C.allowDates&&C.allowDates.length>0&&-1===C.allowDates.indexOf(n.formatDate(p,C.formatDate))&&x.push("xdsoft_disabled"),(!1!==D&&p>D||!1!==k&&p<k||!1!==b&&p<b||c&&!1===c[0])&&x.push("xdsoft_disabled"),-1!==C.disabledDates.indexOf(n.formatDate(p,C.formatDate))&&x.push("xdsoft_disabled"),-1!==C.disabledWeekDays.indexOf(s)&&x.push("xdsoft_disabled"),a.is("[disabled]")&&x.push("xdsoft_disabled"),c&&""!==c[1]&&x.push(c[1]),Y.currentTime.getMonth()!==l&&x.push("xdsoft_other_month"),(C.defaultSelect||H.data("changed"))&&n.formatDate(Y.currentTime,C.formatDate)===n.formatDate(p,C.formatDate)&&x.push("xdsoft_current"),n.formatDate(v,C.formatDate)===n.formatDate(p,C.formatDate)&&x.push("xdsoft_today"),0!==p.getDay()&&6!==p.getDay()&&-1===C.weekends.indexOf(n.formatDate(p,C.formatDate))||x.push("xdsoft_weekend"),void 0!==C.highlightedDates[n.formatDate(p,C.formatDate)]&&(i=C.highlightedDates[n.formatDate(p,C.formatDate)],x.push(void 0===i.style?"xdsoft_highlighted_default":i.style),m=void 0===i.desc?"":i.desc),C.beforeShowDay&&e.isFunction(C.beforeShowDay)&&x.push(C.beforeShowDay(p)),T&&(g+="<tr>",T=!1,C.weeks&&(g+="<th>"+f+"</th>")),g+='<td data-date="'+d+'" data-month="'+l+'" data-year="'+u+'" class="xdsoft_date xdsoft_day_of_week'+p.getDay()+" "+x.join(" ")+'" title="'+m+'"><div>'+d+"</div></td>",p.getDay()===C.dayOfWeekStartPrev&&(g+="</tr>",T=!0),p.setDate(d+1);if(g+="</tbody></table>",N.html(g),I.find(".xdsoft_label span").eq(0).text(C.i18n[r].months[Y.currentTime.getMonth()]),I.find(".xdsoft_label span").eq(1).text(Y.currentTime.getFullYear()),S="","",l="",h=function(t,r){var o,i,s=Y.now(),d=C.allowTimes&&e.isArray(C.allowTimes)&&C.allowTimes.length;s.setHours(t),t=parseInt(s.getHours(),10),s.setMinutes(r),r=parseInt(s.getMinutes(),10),(o=new Date(Y.currentTime)).setHours(t),o.setMinutes(r),x=[],!1!==C.minDateTime&&C.minDateTime>o||!1!==C.maxTime&&Y.strtotime(C.maxTime).getTime()<s.getTime()||!1!==C.minTime&&Y.strtotime(C.minTime).getTime()>s.getTime()?x.push("xdsoft_disabled"):!1!==C.minDateTime&&C.minDateTime>o||!1!==C.disabledMinTime&&s.getTime()>Y.strtotime(C.disabledMinTime).getTime()&&!1!==C.disabledMaxTime&&s.getTime()<Y.strtotime(C.disabledMaxTime).getTime()?x.push("xdsoft_disabled"):a.is("[disabled]")&&x.push("xdsoft_disabled"),(i=new Date(Y.currentTime)).setHours(parseInt(Y.currentTime.getHours(),10)),d||i.setMinutes(Math[C.roundTime](Y.currentTime.getMinutes()/C.step)*C.step),(C.initTime||C.defaultSelect||H.data("changed"))&&i.getHours()===parseInt(t,10)&&(!d&&C.step>59||i.getMinutes()===parseInt(r,10))&&(C.defaultSelect||H.data("changed")?x.push("xdsoft_current"):C.initTime&&x.push("xdsoft_init_time")),parseInt(v.getHours(),10)===parseInt(t,10)&&parseInt(v.getMinutes(),10)===parseInt(r,10)&&x.push("xdsoft_today"),S+='<div class="xdsoft_time '+x.join(" ")+'" data-hour="'+t+'" data-minute="'+r+'">'+n.formatDate(s,C.formatTime)+"</div>"},C.allowTimes&&e.isArray(C.allowTimes)&&C.allowTimes.length)for(y=0;y<C.allowTimes.length;y+=1)h(Y.strtotime(C.allowTimes[y]).getHours(),l=Y.strtotime(C.allowTimes[y]).getMinutes());else for(y=0,t=0;y<(C.hours12?12:24);y+=1)for(t=0;t<60;t+=C.step)h((y<10?"0":"")+y,l=(t<10?"0":"")+t);for(R.html(S),o="",y=parseInt(C.yearStart,10)+C.yearOffset;y<=parseInt(C.yearEnd,10)+C.yearOffset;y+=1)o+='<div class="xdsoft_option '+(Y.currentTime.getFullYear()===y?"xdsoft_current":"")+'" data-value="'+y+'">'+y+"</div>";for(G.children().eq(0).html(o),y=parseInt(C.monthStart,10),o="";y<=parseInt(C.monthEnd,10);y+=1)o+='<div class="xdsoft_option '+(Y.currentTime.getMonth()===y?"xdsoft_current":"")+'" data-value="'+y+'">'+C.i18n[r].months[y]+"</div>";B.children().eq(0).html(o),e(H).trigger("generate.xdsoft")},10),t.stopPropagation()}).on("afterOpen.xdsoft",function(){if(C.timepicker){var e,t,a,n;R.find(".xdsoft_current").length?e=".xdsoft_current":R.find(".xdsoft_init_time").length&&(e=".xdsoft_init_time"),e?(t=E[0].clientHeight,(a=R[0].offsetHeight)-t<(n=R.find(e).index()*C.timeHeightInTimePicker+1)&&(n=a-t),E.trigger("scroll_element.xdsoft_scroller",[parseInt(n,10)/(a-t)])):E.trigger("scroll_element.xdsoft_scroller",[0])}}),u=0,N.on("touchend click.xdsoft","td",function(t){t.stopPropagation(),u+=1;var n=e(this),r=Y.currentTime;if(void 0!==r&&null!==r||(Y.currentTime=Y.now(),r=Y.currentTime),n.hasClass("xdsoft_disabled"))return!1;r.setDate(1),r.setFullYear(n.data("year")),r.setMonth(n.data("month")),r.setDate(n.data("date")),H.trigger("select.xdsoft",[r]),a.val(Y.str()),C.onSelectDate&&e.isFunction(C.onSelectDate)&&C.onSelectDate.call(H,Y.currentTime,H.data("input"),t),H.data("changed",!0),H.trigger("xchange.xdsoft"),H.trigger("changedatetime.xdsoft"),(u>1||!0===C.closeOnDateSelect||!1===C.closeOnDateSelect&&!C.timepicker)&&!C.inline&&H.trigger("close.xdsoft"),setTimeout(function(){u=0},200)}),R.on("touchstart","div",function(e){this.touchMoved=!1}).on("touchmove","div",X).on("touchend click.xdsoft","div",function(t){if(!this.touchMoved){t.stopPropagation();var a=e(this),n=Y.currentTime;if(void 0!==n&&null!==n||(Y.currentTime=Y.now(),n=Y.currentTime),a.hasClass("xdsoft_disabled"))return!1;n.setHours(a.data("hour")),n.setMinutes(a.data("minute")),H.trigger("select.xdsoft",[n]),H.data("input").val(Y.str()),C.onSelectTime&&e.isFunction(C.onSelectTime)&&C.onSelectTime.call(H,Y.currentTime,H.data("input"),t),H.data("changed",!0),H.trigger("xchange.xdsoft"),H.trigger("changedatetime.xdsoft"),!0!==C.inline&&!0===C.closeOnTimeSelect&&H.trigger("close.xdsoft")}}),z.on("mousewheel.xdsoft",function(e){return!C.scrollMonth||(e.deltaY<0?Y.nextMonth():Y.prevMonth(),!1)}),a.on("mousewheel.xdsoft",function(e){return!C.scrollInput||(!C.datepicker&&C.timepicker?((P=R.find(".xdsoft_current").length?R.find(".xdsoft_current").eq(0).index():0)+e.deltaY>=0&&P+e.deltaY<R.children().length&&(P+=e.deltaY),R.children().eq(P).length&&R.children().eq(P).trigger("mousedown"),!1):C.datepicker&&!C.timepicker?(z.trigger(e,[e.deltaY,e.deltaX,e.deltaY]),a.val&&a.val(Y.str()),H.trigger("changedatetime.xdsoft"),!1):void 0)}),H.on("changedatetime.xdsoft",function(t){if(C.onChangeDateTime&&e.isFunction(C.onChangeDateTime)){var a=H.data("input");C.onChangeDateTime.call(H,Y.currentTime,a,t),delete C.value,a.trigger("change")}}).on("generate.xdsoft",function(){C.onGenerate&&e.isFunction(C.onGenerate)&&C.onGenerate.call(H,Y.currentTime,H.data("input")),U&&(H.trigger("afterOpen.xdsoft"),U=!1)}).on("click.xdsoft",function(e){e.stopPropagation()}),P=0,j=function(e,t){do{if(!(e=e.parentNode)||!1===t(e))break}while("HTML"!==e.nodeName)},A=function(){var t,a,n,r,o,i,s,d,u,l,f,c,h;if(d=H.data("input"),t=d.offset(),a=d[0],l="top",n=t.top+a.offsetHeight-1,r=t.left,o="absolute",u=e(C.contentWindow).width(),c=e(C.contentWindow).height(),h=e(C.contentWindow).scrollTop(),C.ownerDocument.documentElement.clientWidth-t.left<z.parent().outerWidth(!0)){var m=z.parent().outerWidth(!0)-a.offsetWidth;r-=m}"rtl"===d.parent().css("direction")&&(r-=H.outerWidth()-d.outerWidth()),C.fixed?(n-=h,r-=e(C.contentWindow).scrollLeft(),o="fixed"):(s=!1,j(a,function(e){return null!==e&&("fixed"===C.contentWindow.getComputedStyle(e).getPropertyValue("position")?(s=!0,!1):void 0)}),s?(o="fixed",n+H.outerHeight()>c+h?(l="bottom",n=c+h-t.top):n-=h):n+H[0].offsetHeight>c+h&&(n=t.top-H[0].offsetHeight+1),n<0&&(n=0),r+a.offsetWidth>u&&(r=u-a.offsetWidth)),i=H[0],j(i,function(e){if("relative"===C.contentWindow.getComputedStyle(e).getPropertyValue("position")&&u>=e.offsetWidth)return r-=(u-e.offsetWidth)/2,!1}),(f={position:o,left:r,top:"",bottom:""})[l]=n,H.css(f)},H.on("open.xdsoft",function(t){var a=!0;C.onShow&&e.isFunction(C.onShow)&&(a=C.onShow.call(H,Y.currentTime,H.data("input"),t)),!1!==a&&(H.show(),A(),e(C.contentWindow).off("resize.xdsoft",A).on("resize.xdsoft",A),C.closeOnWithoutClick&&e([C.ownerDocument.body,C.contentWindow]).on("touchstart mousedown.xdsoft",function t(){H.trigger("close.xdsoft"),e([C.ownerDocument.body,C.contentWindow]).off("touchstart mousedown.xdsoft",t)}))}).on("close.xdsoft",function(t){var a=!0;I.find(".xdsoft_month,.xdsoft_year").find(".xdsoft_select").hide(),C.onClose&&e.isFunction(C.onClose)&&(a=C.onClose.call(H,Y.currentTime,H.data("input"),t)),!1===a||C.opened||C.inline||H.hide(),t.stopPropagation()}).on("toggle.xdsoft",function(){H.is(":visible")?H.trigger("close.xdsoft"):H.trigger("open.xdsoft")}).data("input",a),q=0,H.data("xdsoft_datetime",Y),H.setOptions(C),Y.setCurrentTime(i()),a.data("xdsoft_datetimepicker",H).on("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart",function(){a.is(":disabled")||a.data("xdsoft_datetimepicker").is(":visible")&&C.closeOnInputClick||C.openOnFocus&&(clearTimeout(q),q=setTimeout(function(){a.is(":disabled")||(U=!0,Y.setCurrentTime(i(),!0),C.mask&&s(C),H.trigger("open.xdsoft"))},100))}).on("keydown.xdsoft",function(t){var a,n=t.which;return-1!==[p].indexOf(n)&&C.enterLikeTab?(a=e("input:visible,textarea:visible,button:visible,a:visible"),H.trigger("close.xdsoft"),a.eq(a.index(this)+1).focus(),!1):-1!==[T].indexOf(n)?(H.trigger("close.xdsoft"),!0):void 0}).on("blur.xdsoft",function(){H.trigger("close.xdsoft")})},d=function(t){var a=t.data("xdsoft_datetimepicker");a&&(a.data("xdsoft_datetime",null),a.remove(),t.data("xdsoft_datetimepicker",null).off(".xdsoft"),e(C.contentWindow).off("resize.xdsoft"),e([C.contentWindow,C.ownerDocument.body]).off("mousedown.xdsoft touchstart"),t.unmousewheel&&t.unmousewheel())},e(C.ownerDocument).off("keydown.xdsoftctrl keyup.xdsoftctrl").on("keydown.xdsoftctrl",function(e){e.keyCode===m&&(F=!0)}).on("keyup.xdsoftctrl",function(e){e.keyCode===m&&(F=!1)}),this.each(function(){var t=e(this).data("xdsoft_datetimepicker");if(t){if("string"===e.type(o))switch(o){case"show":e(this).select().focus(),t.trigger("open.xdsoft");break;case"hide":t.trigger("close.xdsoft");break;case"toggle":t.trigger("toggle.xdsoft");break;case"destroy":d(e(this));break;case"reset":this.value=this.defaultValue,this.value&&t.data("xdsoft_datetime").isValidDate(n.parseDate(this.value,C.format))||t.data("changed",!1),t.data("xdsoft_datetime").setCurrentTime(this.value);break;case"validate":t.data("input").trigger("blur.xdsoft");break;default:t[o]&&e.isFunction(t[o])&&(u=t[o](i))}else t.setOptions(o);return 0}"string"!==e.type(o)&&(!C.lazyInit||C.open||C.inline?s(e(this)):A(e(this)))}),u},e.fn.datetimepicker.defaults=a};!function(e){"function"==typeof define&&define.amd?define(["jquery","jquery-mousewheel"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(datetimepickerFactory),function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e:e(jQuery)}(function(e){function t(t){var i=t||window.event,s=d.call(arguments,1),u=0,f=0,c=0,h=0,m=0,g=0;if(t=e.event.fix(i),t.type="mousewheel","detail"in i&&(c=-1*i.detail),"wheelDelta"in i&&(c=i.wheelDelta),"wheelDeltaY"in i&&(c=i.wheelDeltaY),"wheelDeltaX"in i&&(f=-1*i.wheelDeltaX),"axis"in i&&i.axis===i.HORIZONTAL_AXIS&&(f=-1*c,c=0),u=0===c?f:c,"deltaY"in i&&(u=c=-1*i.deltaY),"deltaX"in i&&(f=i.deltaX,0===c&&(u=-1*f)),0!==c||0!==f){if(1===i.deltaMode){var p=e.data(this,"mousewheel-line-height");u*=p,c*=p,f*=p}else if(2===i.deltaMode){var y=e.data(this,"mousewheel-page-height");u*=y,c*=y,f*=y}if(h=Math.max(Math.abs(c),Math.abs(f)),(!o||h<o)&&(o=h,n(i,h)&&(o/=40)),n(i,h)&&(u/=40,f/=40,c/=40),u=Math[u>=1?"floor":"ceil"](u/o),f=Math[f>=1?"floor":"ceil"](f/o),c=Math[c>=1?"floor":"ceil"](c/o),l.settings.normalizeOffset&&this.getBoundingClientRect){var v=this.getBoundingClientRect();m=t.clientX-v.left,g=t.clientY-v.top}return t.deltaX=f,t.deltaY=c,t.deltaFactor=o,t.offsetX=m,t.offsetY=g,t.deltaMode=0,s.unshift(t,u,f,c),r&&clearTimeout(r),r=setTimeout(a,200),(e.event.dispatch||e.event.handle).apply(this,s)}}function a(){o=null}function n(e,t){return l.settings.adjustOldDeltas&&"mousewheel"===e.type&&t%120==0}var r,o,i=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],s="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],d=Array.prototype.slice;if(e.event.fixHooks)for(var u=i.length;u;)e.event.fixHooks[i[--u]]=e.event.mouseHooks;var l=e.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var a=s.length;a;)this.addEventListener(s[--a],t,!1);else this.onmousewheel=t;e.data(this,"mousewheel-line-height",l.getLineHeight(this)),e.data(this,"mousewheel-page-height",l.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var a=s.length;a;)this.removeEventListener(s[--a],t,!1);else this.onmousewheel=null;e.removeData(this,"mousewheel-line-height"),e.removeData(this,"mousewheel-page-height")},getLineHeight:function(t){var a=e(t),n=a["offsetParent"in e.fn?"offsetParent":"parent"]();return n.length||(n=e("body")),parseInt(n.css("fontSize"),10)||parseInt(a.css("fontSize"),10)||16},getPageHeight:function(t){return e(t).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};e.fn.extend({mousewheel:function(e){return e?this.bind("mousewheel",e):this.trigger("mousewheel")},unmousewheel:function(e){return this.unbind("mousewheel",e)}})});
/**
 * @preserve jQuery DateTimePicker
 * @homepage http://xdsoft.net/jqplugins/datetimepicker/
 * @author Chupurnov Valeriy (<chupurnov@gmail.com>)
 */

/**
 * @param {jQuery} $
 */
var datetimepickerFactory = function ($) {
	'use strict';

	var default_options  = {
		i18n: {
			ar: { // Arabic
				months: [
					"كانون الثاني", "شباط", "آذار", "نيسان", "مايو", "حزيران", "تموز", "آب", "أيلول", "تشرين الأول", "تشرين الثاني", "كانون الأول"
				],
				dayOfWeekShort: [
					"ن", "ث", "ع", "خ", "ج", "س", "ح"
				],
				dayOfWeek: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"]
			},
			ro: { // Romanian
				months: [
					"Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"
				],
				dayOfWeekShort: [
					"Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"
				],
				dayOfWeek: ["Duminică", "Luni", "Marţi", "Miercuri", "Joi", "Vineri", "Sâmbătă"]
			},
			id: { // Indonesian
				months: [
					"Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"
				],
				dayOfWeekShort: [
					"Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"
				],
				dayOfWeek: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
			},
			is: { // Icelandic
				months: [
					"Janúar", "Febrúar", "Mars", "Apríl", "Maí", "Júní", "Júlí", "Ágúst", "September", "Október", "Nóvember", "Desember"
				],
				dayOfWeekShort: [
					"Sun", "Mán", "Þrið", "Mið", "Fim", "Fös", "Lau"
				],
				dayOfWeek: ["Sunnudagur", "Mánudagur", "Þriðjudagur", "Miðvikudagur", "Fimmtudagur", "Föstudagur", "Laugardagur"]
			},
			bg: { // Bulgarian
				months: [
					"Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"
				],
				dayOfWeekShort: [
					"Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"
				],
				dayOfWeek: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"]
			},
			fa: { // Persian/Farsi
				months: [
					'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
				],
				dayOfWeekShort: [
					'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'
				],
				dayOfWeek: ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه", "یک‌شنبه"]
			},
			ru: { // Russian
				months: [
					'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
				],
				dayOfWeekShort: [
					"Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"
				],
				dayOfWeek: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"]
			},
			uk: { // Ukrainian
				months: [
					'Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'
				],
				dayOfWeekShort: [
					"Ндл", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Сбт"
				],
				dayOfWeek: ["Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"]
			},
			en: { // English
				months: [
					"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
				],
				dayOfWeekShort: [
					"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
				],
				dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
			},
			el: { // Ελληνικά
				months: [
					"Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"
				],
				dayOfWeekShort: [
					"Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"
				],
				dayOfWeek: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"]
			},
			de: { // German
				months: [
					'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
				],
				dayOfWeekShort: [
					"So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"
				],
				dayOfWeek: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
			},
			nl: { // Dutch
				months: [
					"januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"
				],
				dayOfWeekShort: [
					"zo", "ma", "di", "wo", "do", "vr", "za"
				],
				dayOfWeek: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
			},
			tr: { // Turkish
				months: [
					"Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
				],
				dayOfWeekShort: [
					"Paz", "Pts", "Sal", "Çar", "Per", "Cum", "Cts"
				],
				dayOfWeek: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"]
			},
			fr: { //French
				months: [
					"Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
				],
				dayOfWeekShort: [
					"Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"
				],
				dayOfWeek: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
			},
			es: { // Spanish
				months: [
					"Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
				],
				dayOfWeekShort: [
					"Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"
				],
				dayOfWeek: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
			},
			th: { // Thai
				months: [
					'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
				],
				dayOfWeekShort: [
					'อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'
				],
				dayOfWeek: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัส", "ศุกร์", "เสาร์", "อาทิตย์"]
			},
			pl: { // Polish
				months: [
					"styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"
				],
				dayOfWeekShort: [
					"nd", "pn", "wt", "śr", "cz", "pt", "sb"
				],
				dayOfWeek: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"]
			},
			pt: { // Portuguese
				months: [
					"Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
				],
				dayOfWeekShort: [
					"Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"
				],
				dayOfWeek: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"]
			},
			ch: { // Simplified Chinese
				months: [
					"一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"
				],
				dayOfWeekShort: [
					"日", "一", "二", "三", "四", "五", "六"
				]
			},
			se: { // Swedish
				months: [
					"Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September",  "Oktober", "November", "December"
				],
				dayOfWeekShort: [
					"Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"
				]
			},
			km: { // Khmer (ភាសាខ្មែរ)
				months: [
					"មករា​", "កុម្ភៈ", "មិនា​", "មេសា​", "ឧសភា​", "មិថុនា​", "កក្កដា​", "សីហា​", "កញ្ញា​", "តុលា​", "វិច្ឆិកា", "ធ្នូ​"
				],
				dayOfWeekShort: ["អាទិ​", "ច័ន្ទ​", "អង្គារ​", "ពុធ​", "ព្រហ​​", "សុក្រ​", "សៅរ៍"],
				dayOfWeek: ["អាទិត្យ​", "ច័ន្ទ​", "អង្គារ​", "ពុធ​", "ព្រហស្បតិ៍​", "សុក្រ​", "សៅរ៍"]
			},
			kr: { // Korean
				months: [
					"1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"
				],
				dayOfWeekShort: [
					"일", "월", "화", "수", "목", "금", "토"
				],
				dayOfWeek: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
			},
			it: { // Italian
				months: [
					"Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
				],
				dayOfWeekShort: [
					"Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"
				],
				dayOfWeek: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"]
			},
			da: { // Dansk
				months: [
					"Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"
				],
				dayOfWeekShort: [
					"Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"
				],
				dayOfWeek: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
			},
			no: { // Norwegian
				months: [
					"Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"
				],
				dayOfWeekShort: [
					"Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"
				],
				dayOfWeek: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag']
			},
			ja: { // Japanese
				months: [
					"1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"
				],
				dayOfWeekShort: [
					"日", "月", "火", "水", "木", "金", "土"
				],
				dayOfWeek: ["日曜", "月曜", "火曜", "水曜", "木曜", "金曜", "土曜"]
			},
			vi: { // Vietnamese
				months: [
					"Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"
				],
				dayOfWeekShort: [
					"CN", "T2", "T3", "T4", "T5", "T6", "T7"
				],
				dayOfWeek: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"]
			},
			sl: { // Slovenščina
				months: [
					"Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"
				],
				dayOfWeekShort: [
					"Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"
				],
				dayOfWeek: ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"]
			},
			cs: { // Čeština
				months: [
					"Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"
				],
				dayOfWeekShort: [
					"Ne", "Po", "Út", "St", "Čt", "Pá", "So"
				]
			},
			hu: { // Hungarian
				months: [
					"Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"
				],
				dayOfWeekShort: [
					"Va", "Hé", "Ke", "Sze", "Cs", "Pé", "Szo"
				],
				dayOfWeek: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"]
			},
			az: { //Azerbaijanian (Azeri)
				months: [
					"Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"
				],
				dayOfWeekShort: [
					"B", "Be", "Ça", "Ç", "Ca", "C", "Ş"
				],
				dayOfWeek: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"]
			},
			bs: { //Bosanski
				months: [
					"Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"
				],
				dayOfWeekShort: [
					"Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"
				],
				dayOfWeek: ["Nedjelja","Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
			},
			ca: { //Català
				months: [
					"Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"
				],
				dayOfWeekShort: [
					"Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"
				],
				dayOfWeek: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"]
			},
			'en-GB': { //English (British)
				months: [
					"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
				],
				dayOfWeekShort: [
					"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
				],
				dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
			},
			et: { //"Eesti"
				months: [
					"Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"
				],
				dayOfWeekShort: [
					"P", "E", "T", "K", "N", "R", "L"
				],
				dayOfWeek: ["Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev"]
			},
			eu: { //Euskara
				months: [
					"Urtarrila", "Otsaila", "Martxoa", "Apirila", "Maiatza", "Ekaina", "Uztaila", "Abuztua", "Iraila", "Urria", "Azaroa", "Abendua"
				],
				dayOfWeekShort: [
					"Ig.", "Al.", "Ar.", "Az.", "Og.", "Or.", "La."
				],
				dayOfWeek: ['Igandea', 'Astelehena', 'Asteartea', 'Asteazkena', 'Osteguna', 'Ostirala', 'Larunbata']
			},
			fi: { //Finnish (Suomi)
				months: [
					"Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"
				],
				dayOfWeekShort: [
					"Su", "Ma", "Ti", "Ke", "To", "Pe", "La"
				],
				dayOfWeek: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
			},
			gl: { //Galego
				months: [
					"Xan", "Feb", "Maz", "Abr", "Mai", "Xun", "Xul", "Ago", "Set", "Out", "Nov", "Dec"
				],
				dayOfWeekShort: [
					"Dom", "Lun", "Mar", "Mer", "Xov", "Ven", "Sab"
				],
				dayOfWeek: ["Domingo", "Luns", "Martes", "Mércores", "Xoves", "Venres", "Sábado"]
			},
			hr: { //Hrvatski
				months: [
					"Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"
				],
				dayOfWeekShort: [
					"Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"
				],
				dayOfWeek: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
			},
			ko: { //Korean (한국어)
				months: [
					"1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"
				],
				dayOfWeekShort: [
					"일", "월", "화", "수", "목", "금", "토"
				],
				dayOfWeek: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
			},
			lt: { //Lithuanian (lietuvių)
				months: [
					"Sausio", "Vasario", "Kovo", "Balandžio", "Gegužės", "Birželio", "Liepos", "Rugpjūčio", "Rugsėjo", "Spalio", "Lapkričio", "Gruodžio"
				],
				dayOfWeekShort: [
					"Sek", "Pir", "Ant", "Tre", "Ket", "Pen", "Šeš"
				],
				dayOfWeek: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"]
			},
			lv: { //Latvian (Latviešu)
				months: [
					"Janvāris", "Februāris", "Marts", "Aprīlis ", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"
				],
				dayOfWeekShort: [
					"Sv", "Pr", "Ot", "Tr", "Ct", "Pk", "St"
				],
				dayOfWeek: ["Svētdiena", "Pirmdiena", "Otrdiena", "Trešdiena", "Ceturtdiena", "Piektdiena", "Sestdiena"]
			},
			mk: { //Macedonian (Македонски)
				months: [
					"јануари", "февруари", "март", "април", "мај", "јуни", "јули", "август", "септември", "октомври", "ноември", "декември"
				],
				dayOfWeekShort: [
					"нед", "пон", "вто", "сре", "чет", "пет", "саб"
				],
				dayOfWeek: ["Недела", "Понеделник", "Вторник", "Среда", "Четврток", "Петок", "Сабота"]
			},
			mn: { //Mongolian (Монгол)
				months: [
					"1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"
				],
				dayOfWeekShort: [
					"Дав", "Мяг", "Лха", "Пүр", "Бсн", "Бям", "Ням"
				],
				dayOfWeek: ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба", "Ням"]
			},
			'pt-BR': { //Português(Brasil)
				months: [
					"Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
				],
				dayOfWeekShort: [
					"Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"
				],
				dayOfWeek: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"]
			},
			sk: { //Slovenčina
				months: [
					"Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"
				],
				dayOfWeekShort: [
					"Ne", "Po", "Ut", "St", "Št", "Pi", "So"
				],
				dayOfWeek: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"]
			},
			sq: { //Albanian (Shqip)
				months: [
					"Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor"
				],
				dayOfWeekShort: [
					"Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Shtu"
				],
				dayOfWeek: ["E Diel", "E Hënë", "E Martē", "E Mërkurë", "E Enjte", "E Premte", "E Shtunë"]
			},
			'sr-YU': { //Serbian (Srpski)
				months: [
					"Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"
				],
				dayOfWeekShort: [
					"Ned", "Pon", "Uto", "Sre", "čet", "Pet", "Sub"
				],
				dayOfWeek: ["Nedelja","Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"]
			},
			sr: { //Serbian Cyrillic (Српски)
				months: [
					"јануар", "фебруар", "март", "април", "мај", "јун", "јул", "август", "септембар", "октобар", "новембар", "децембар"
				],
				dayOfWeekShort: [
					"нед", "пон", "уто", "сре", "чет", "пет", "суб"
				],
				dayOfWeek: ["Недеља","Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"]
			},
			sv: { //Svenska
				months: [
					"Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"
				],
				dayOfWeekShort: [
					"Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"
				],
				dayOfWeek: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"]
			},
			'zh-TW': { //Traditional Chinese (繁體中文)
				months: [
					"一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"
				],
				dayOfWeekShort: [
					"日", "一", "二", "三", "四", "五", "六"
				],
				dayOfWeek: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
			},
			zh: { //Simplified Chinese (简体中文)
				months: [
					"一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"
				],
				dayOfWeekShort: [
					"日", "一", "二", "三", "四", "五", "六"
				],
				dayOfWeek: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
			},
			ug:{ // Uyghur(ئۇيغۇرچە)
				months: [
					"1-ئاي","2-ئاي","3-ئاي","4-ئاي","5-ئاي","6-ئاي","7-ئاي","8-ئاي","9-ئاي","10-ئاي","11-ئاي","12-ئاي"
				],
				dayOfWeek: [
					"يەكشەنبە", "دۈشەنبە","سەيشەنبە","چارشەنبە","پەيشەنبە","جۈمە","شەنبە"
				]
			},
			he: { //Hebrew (עברית)
				months: [
					'ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'
				],
				dayOfWeekShort: [
					'א\'', 'ב\'', 'ג\'', 'ד\'', 'ה\'', 'ו\'', 'שבת'
				],
				dayOfWeek: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת", "ראשון"]
			},
			hy: { // Armenian
				months: [
					"Հունվար", "Փետրվար", "Մարտ", "Ապրիլ", "Մայիս", "Հունիս", "Հուլիս", "Օգոստոս", "Սեպտեմբեր", "Հոկտեմբեր", "Նոյեմբեր", "Դեկտեմբեր"
				],
				dayOfWeekShort: [
					"Կի", "Երկ", "Երք", "Չոր", "Հնգ", "Ուրբ", "Շբթ"
				],
				dayOfWeek: ["Կիրակի", "Երկուշաբթի", "Երեքշաբթի", "Չորեքշաբթի", "Հինգշաբթի", "Ուրբաթ", "Շաբաթ"]
			},
			kg: { // Kyrgyz
				months: [
					'Үчтүн айы', 'Бирдин айы', 'Жалган Куран', 'Чын Куран', 'Бугу', 'Кулжа', 'Теке', 'Баш Оона', 'Аяк Оона', 'Тогуздун айы', 'Жетинин айы', 'Бештин айы'
				],
				dayOfWeekShort: [
					"Жек", "Дүй", "Шей", "Шар", "Бей", "Жум", "Ише"
				],
				dayOfWeek: [
					"Жекшемб", "Дүйшөмб", "Шейшемб", "Шаршемб", "Бейшемби", "Жума", "Ишенб"
				]
			},
			rm: { // Romansh
				months: [
					"Schaner", "Favrer", "Mars", "Avrigl", "Matg", "Zercladur", "Fanadur", "Avust", "Settember", "October", "November", "December"
				],
				dayOfWeekShort: [
					"Du", "Gli", "Ma", "Me", "Gie", "Ve", "So"
				],
				dayOfWeek: [
					"Dumengia", "Glindesdi", "Mardi", "Mesemna", "Gievgia", "Venderdi", "Sonda"
				]
			},
			ka: { // Georgian
				months: [
					'იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი'
				],
				dayOfWeekShort: [
					"კვ", "ორშ", "სამშ", "ოთხ", "ხუთ", "პარ", "შაბ"
				],
				dayOfWeek: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"]
			}
		},

		ownerDocument: document,
		contentWindow: window,

		value: '',
		rtl: false,

		format:	'Y/m/d H:i',
		formatTime:	'H:i',
		formatDate:	'Y/m/d',

		startDate:	false, // new Date(), '1986/12/08', '-1970/01/05','-1970/01/05',
		step: 60,
		monthChangeSpinner: true,

		closeOnDateSelect: false,
		closeOnTimeSelect: true,
		closeOnWithoutClick: true,
		closeOnInputClick: true,
		openOnFocus: true,

		timepicker: true,
		datepicker: true,
		weeks: false,

		defaultTime: false,	// use formatTime format (ex. '10:00' for formatTime:	'H:i')
		defaultDate: false,	// use formatDate format (ex new Date() or '1986/12/08' or '-1970/01/05' or '-1970/01/05')

		minDate: false,
		maxDate: false,
		minTime: false,
		maxTime: false,
        minDateTime: false,

		disabledMinTime: false,
		disabledMaxTime: false,

		allowTimes: [],
		opened: false,
		initTime: true,
		inline: false,
		theme: '',
		touchMovedThreshold: 5,

		onSelectDate: function () {},
		onSelectTime: function () {},
		onChangeMonth: function () {},
		onGetWeekOfYear: function () {},
		onChangeYear: function () {},
		onChangeDateTime: function () {},
		onShow: function () {},
		onClose: function () {},
		onGenerate: function () {},

		withoutCopyright: true,
		inverseButton: false,
		hours12: false,
		next: 'xdsoft_next',
		prev : 'xdsoft_prev',
		dayOfWeekStart: 0,
		parentID: 'body',
		timeHeightInTimePicker: 25,
		timepickerScrollbar: true,
		todayButton: true,
		prevButton: true,
		nextButton: true,
		defaultSelect: true,

		scrollMonth: true,
		scrollTime: true,
		scrollInput: true,

		lazyInit: false,
		mask: false,
		validateOnBlur: true,
		allowBlank: true,
		yearStart: 1950,
		yearEnd: 2050,
		monthStart: 0,
		monthEnd: 11,
		style: '',
		id: '',
		fixed: false,
		roundTime: 'round', // ceil, floor
		className: '',
		weekends: [],
		highlightedDates: [],
		highlightedPeriods: [],
		allowDates : [],
		allowDateRe : null,
		disabledDates : [],
		disabledWeekDays: [],
		yearOffset: 0,
		beforeShowDay: null,

		enterLikeTab: true,
		showApplyButton: false
	};

	var dateHelper = null,
		globalLocaleDefault = 'en',
		globalLocale = 'en';

	var dateFormatterOptionsDefault = {
		meridiem: ['AM', 'PM']
	};

	var initDateFormatter = function(){
		var locale = default_options.i18n[globalLocale],
			opts = {
				days: locale.dayOfWeek,
				daysShort: locale.dayOfWeekShort,
				months: locale.months,
				monthsShort: $.map(locale.months, function(n){ return n.substring(0, 3) })
			};

		if (typeof DateFormatter === 'function') {
			dateHelper = new DateFormatter({
				dateSettings: $.extend({}, dateFormatterOptionsDefault, opts)
			});
		}
	};

	// for locale settings
	$.datetimepicker = {
		setLocale: function(locale){
			var newLocale = default_options.i18n[locale] ? locale : globalLocaleDefault;
			if (globalLocale !== newLocale) {
				globalLocale = newLocale;
				// reinit date formatter
				initDateFormatter();
			}
		},

		setDateFormatter: function(dateFormatter) {
			dateHelper = dateFormatter;
		},

		RFC_2822: 'D, d M Y H:i:s O',
		ATOM: 'Y-m-d\TH:i:sP',
		ISO_8601: 'Y-m-d\TH:i:sO',
		RFC_822: 'D, d M y H:i:s O',
		RFC_850: 'l, d-M-y H:i:s T',
		RFC_1036: 'D, d M y H:i:s O',
		RFC_1123: 'D, d M Y H:i:s O',
		RSS: 'D, d M Y H:i:s O',
		W3C: 'Y-m-d\TH:i:sP'
	};

	// first init date formatter
	initDateFormatter();

	// fix for ie8
	if (!window.getComputedStyle) {
		window.getComputedStyle = function (el) {
			this.el = el;
			this.getPropertyValue = function (prop) {
				var re = /(-([a-z]))/g;
				if (prop === 'float') {
					prop = 'styleFloat';
				}
				if (re.test(prop)) {
					prop = prop.replace(re, function (a, b, c) {
						return c.toUpperCase();
					});
				}
				return el.currentStyle[prop] || null;
			};
			return this;
		};
	}
	if (!Array.prototype.indexOf) {
		Array.prototype.indexOf = function (obj, start) {
			var i, j;
			for (i = (start || 0), j = this.length; i < j; i += 1) {
				if (this[i] === obj) { return i; }
			}
			return -1;
		};
	}

	Date.prototype.countDaysInMonth = function () {
		return new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
	};

	$.fn.xdsoftScroller = function (options, percent) {
		return this.each(function () {
			var timeboxparent = $(this),
				pointerEventToXY = function (e) {
					var out = {x: 0, y: 0},
						touch;
					if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
						touch  = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
						out.x = touch.clientX;
						out.y = touch.clientY;
					} else if (e.type === 'mousedown' || e.type === 'mouseup' || e.type === 'mousemove' || e.type === 'mouseover' || e.type === 'mouseout' || e.type === 'mouseenter' || e.type === 'mouseleave') {
						out.x = e.clientX;
						out.y = e.clientY;
					}
					return out;
				},
				timebox,
				parentHeight,
				height,
				scrollbar,
				scroller,
				maximumOffset = 100,
				start = false,
				startY = 0,
				startTop = 0,
				h1 = 0,
				touchStart = false,
				startTopScroll = 0,
				calcOffset = function () {};

			if (percent === 'hide') {
				timeboxparent.find('.xdsoft_scrollbar').hide();
				return;
			}

			if (!$(this).hasClass('xdsoft_scroller_box')) {
				timebox = timeboxparent.children().eq(0);
				parentHeight = timeboxparent[0].clientHeight;
				height = timebox[0].offsetHeight;
				scrollbar = $('<div class="xdsoft_scrollbar"></div>');
				scroller = $('<div class="xdsoft_scroller"></div>');
				scrollbar.append(scroller);

				timeboxparent.addClass('xdsoft_scroller_box').append(scrollbar);
				calcOffset = function calcOffset(event) {
					var offset = pointerEventToXY(event).y - startY + startTopScroll;
					if (offset < 0) {
						offset = 0;
					}
					if (offset + scroller[0].offsetHeight > h1) {
						offset = h1 - scroller[0].offsetHeight;
					}
					timeboxparent.trigger('scroll_element.xdsoft_scroller', [maximumOffset ? offset / maximumOffset : 0]);
				};

				scroller
					.on('touchstart.xdsoft_scroller mousedown.xdsoft_scroller', function (event) {
						if (!parentHeight) {
							timeboxparent.trigger('resize_scroll.xdsoft_scroller', [percent]);
						}

						startY = pointerEventToXY(event).y;
						startTopScroll = parseInt(scroller.css('margin-top'), 10);
						h1 = scrollbar[0].offsetHeight;

						if (event.type === 'mousedown' || event.type === 'touchstart') {
							if (options.ownerDocument) {
								$(options.ownerDocument.body).addClass('xdsoft_noselect');
							}
							$([options.ownerDocument.body, options.contentWindow]).on('touchend mouseup.xdsoft_scroller', function arguments_callee() {
								$([options.ownerDocument.body, options.contentWindow]).off('touchend mouseup.xdsoft_scroller', arguments_callee)
									.off('mousemove.xdsoft_scroller', calcOffset)
									.removeClass('xdsoft_noselect');
							});
							$(options.ownerDocument.body).on('mousemove.xdsoft_scroller', calcOffset);
						} else {
							touchStart = true;
							event.stopPropagation();
							event.preventDefault();
						}
					})
					.on('touchmove', function (event) {
						if (touchStart) {
							event.preventDefault();
							calcOffset(event);
						}
					})
					.on('touchend touchcancel', function () {
						touchStart =  false;
						startTopScroll = 0;
					});

				timeboxparent
					.on('scroll_element.xdsoft_scroller', function (event, percentage) {
						if (!parentHeight) {
							timeboxparent.trigger('resize_scroll.xdsoft_scroller', [percentage, true]);
						}
						percentage = percentage > 1 ? 1 : (percentage < 0 || isNaN(percentage)) ? 0 : percentage;

						scroller.css('margin-top', maximumOffset * percentage);

						setTimeout(function () {
							timebox.css('marginTop', -parseInt((timebox[0].offsetHeight - parentHeight) * percentage, 10));
						}, 10);
					})
					.on('resize_scroll.xdsoft_scroller', function (event, percentage, noTriggerScroll) {
						var percent, sh;
						parentHeight = timeboxparent[0].clientHeight;
						height = timebox[0].offsetHeight;
						percent = parentHeight / height;
						sh = percent * scrollbar[0].offsetHeight;
						if (percent > 1) {
							scroller.hide();
						} else {
							scroller.show();
							scroller.css('height', parseInt(sh > 10 ? sh : 10, 10));
							maximumOffset = scrollbar[0].offsetHeight - scroller[0].offsetHeight;
							if (noTriggerScroll !== true) {
								timeboxparent.trigger('scroll_element.xdsoft_scroller', [percentage || Math.abs(parseInt(timebox.css('marginTop'), 10)) / (height - parentHeight)]);
							}
						}
					});

				timeboxparent.on('mousewheel', function (event) {
					var top = Math.abs(parseInt(timebox.css('marginTop'), 10));

					top = top - (event.deltaY * 20);
					if (top < 0) {
						top = 0;
					}

					timeboxparent.trigger('scroll_element.xdsoft_scroller', [top / (height - parentHeight)]);
					event.stopPropagation();
					return false;
				});

				timeboxparent.on('touchstart', function (event) {
					start = pointerEventToXY(event);
					startTop = Math.abs(parseInt(timebox.css('marginTop'), 10));
				});

				timeboxparent.on('touchmove', function (event) {
					if (start) {
						event.preventDefault();
						var coord = pointerEventToXY(event);
						timeboxparent.trigger('scroll_element.xdsoft_scroller', [(startTop - (coord.y - start.y)) / (height - parentHeight)]);
					}
				});

				timeboxparent.on('touchend touchcancel', function () {
					start = false;
					startTop = 0;
				});
			}
			timeboxparent.trigger('resize_scroll.xdsoft_scroller', [percent]);
		});
	};

	$.fn.datetimepicker = function (opt, opt2) {
		var result = this,
			KEY0 = 48,
			KEY9 = 57,
			_KEY0 = 96,
			_KEY9 = 105,
			CTRLKEY = 17,
			DEL = 46,
			ENTER = 13,
			ESC = 27,
			BACKSPACE = 8,
			ARROWLEFT = 37,
			ARROWUP = 38,
			ARROWRIGHT = 39,
			ARROWDOWN = 40,
			TAB = 9,
			F5 = 116,
			AKEY = 65,
			CKEY = 67,
			VKEY = 86,
			ZKEY = 90,
			YKEY = 89,
			ctrlDown	=	false,
			options = ($.isPlainObject(opt) || !opt) ? $.extend(true, {}, default_options, opt) : $.extend(true, {}, default_options),

			lazyInitTimer = 0,
			createDateTimePicker,
			destroyDateTimePicker,

			lazyInit = function (input) {
				input
					.on('open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart', function initOnActionCallback() {
						if (input.is(':disabled') || input.data('xdsoft_datetimepicker')) {
							return;
						}
						clearTimeout(lazyInitTimer);
						lazyInitTimer = setTimeout(function () {

							if (!input.data('xdsoft_datetimepicker')) {
								createDateTimePicker(input);
							}
							input
								.off('open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart', initOnActionCallback)
								.trigger('open.xdsoft');
						}, 100);
					});
			};

		createDateTimePicker = function (input) {
			var datetimepicker = $('<div class="xdsoft_datetimepicker xdsoft_noselect"></div>'),
				xdsoft_copyright = $('<div class="xdsoft_copyright"><a target="_blank" href="http://xdsoft.net/jqplugins/datetimepicker/">xdsoft.net</a></div>'),
				datepicker = $('<div class="xdsoft_datepicker active"></div>'),
				month_picker = $('<div class="xdsoft_monthpicker"><button type="button" class="xdsoft_prev"></button><button type="button" class="xdsoft_today_button"></button>' +
					'<div class="xdsoft_label xdsoft_month"><span></span><i></i></div>' +
					'<div class="xdsoft_label xdsoft_year"><span></span><i></i></div>' +
					'<button type="button" class="xdsoft_next"></button></div>'),
				calendar = $('<div class="xdsoft_calendar"></div>'),
				timepicker = $('<div class="xdsoft_timepicker active"><button type="button" class="xdsoft_prev"></button><div class="xdsoft_time_box"></div><button type="button" class="xdsoft_next"></button></div>'),
				timeboxparent = timepicker.find('.xdsoft_time_box').eq(0),
				timebox = $('<div class="xdsoft_time_variant"></div>'),
				applyButton = $('<button type="button" class="xdsoft_save_selected blue-gradient-button">Save Selected</button>'),

				monthselect = $('<div class="xdsoft_select xdsoft_monthselect"><div></div></div>'),
				yearselect = $('<div class="xdsoft_select xdsoft_yearselect"><div></div></div>'),
				triggerAfterOpen = false,
				XDSoft_datetime,

				xchangeTimer,
				timerclick,
				current_time_index,
				setPos,
				timer = 0,
				_xdsoft_datetime,
				forEachAncestorOf;

			if (options.id) {
				datetimepicker.attr('id', options.id);
			}
			if (options.style) {
				datetimepicker.attr('style', options.style);
			}
			if (options.weeks) {
				datetimepicker.addClass('xdsoft_showweeks');
			}
			if (options.rtl) {
				datetimepicker.addClass('xdsoft_rtl');
			}

			datetimepicker.addClass('xdsoft_' + options.theme);
			datetimepicker.addClass(options.className);

			month_picker
				.find('.xdsoft_month span')
				.after(monthselect);
			month_picker
				.find('.xdsoft_year span')
				.after(yearselect);

			month_picker
				.find('.xdsoft_month,.xdsoft_year')
				.on('touchstart mousedown.xdsoft', function (event) {
					var select = $(this).find('.xdsoft_select').eq(0),
						val = 0,
						top = 0,
						visible = select.is(':visible'),
						items,
						i;

					month_picker
						.find('.xdsoft_select')
						.hide();
					if (_xdsoft_datetime.currentTime) {
						val = _xdsoft_datetime.currentTime[$(this).hasClass('xdsoft_month') ? 'getMonth' : 'getFullYear']();
					}

					select[visible ? 'hide' : 'show']();
					for (items = select.find('div.xdsoft_option'), i = 0; i < items.length; i += 1) {
						if (items.eq(i).data('value') === val) {
							break;
						} else {
							top += items[0].offsetHeight;
						}
					}

					select.xdsoftScroller(options, top / (select.children()[0].offsetHeight - (select[0].clientHeight)));
					event.stopPropagation();
					return false;
				});

			var handleTouchMoved = function (event) {
				this.touchStartPosition = this.touchStartPosition || event.originalEvent.touches[0]
				var touchPosition = event.originalEvent.touches[0]
				var xMovement = Math.abs(this.touchStartPosition.clientX - touchPosition.clientX)
				var yMovement = Math.abs(this.touchStartPosition.clientY - touchPosition.clientY)
				var distance = Math.sqrt(xMovement * xMovement + yMovement * yMovement)
				if(distance > options.touchMovedThreshold) {
					this.touchMoved = true;
				}
			}

			month_picker
				.find('.xdsoft_select')
				.xdsoftScroller(options)
				.on('touchstart mousedown.xdsoft', function (event) {
					this.touchMoved = false;
					this.touchStartPosition = event.originalEvent.touches[0]
					event.stopPropagation();
					event.preventDefault();
				})
				.on('touchmove', '.xdsoft_option', handleTouchMoved)
				.on('touchend mousedown.xdsoft', '.xdsoft_option', function () {
					if (!this.touchMoved) {
						if (_xdsoft_datetime.currentTime === undefined || _xdsoft_datetime.currentTime === null) {
							_xdsoft_datetime.currentTime = _xdsoft_datetime.now();
						}

						var year = _xdsoft_datetime.currentTime.getFullYear();
						if (_xdsoft_datetime && _xdsoft_datetime.currentTime) {
							_xdsoft_datetime.currentTime[$(this).parent().parent().hasClass('xdsoft_monthselect') ? 'setMonth' : 'setFullYear']($(this).data('value'));
						}

						$(this).parent().parent().hide();

						datetimepicker.trigger('xchange.xdsoft');
						if (options.onChangeMonth && $.isFunction(options.onChangeMonth)) {
							options.onChangeMonth.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'));
						}

						if (year !== _xdsoft_datetime.currentTime.getFullYear() && $.isFunction(options.onChangeYear)) {
							options.onChangeYear.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'));
						}
					}
				});

			datetimepicker.getValue = function () {
				return _xdsoft_datetime.getCurrentTime();
			};

			datetimepicker.setOptions = function (_options) {
				var highlightedDates = {};

				options = $.extend(true, {}, options, _options);

				if (_options.allowTimes && $.isArray(_options.allowTimes) && _options.allowTimes.length) {
					options.allowTimes = $.extend(true, [], _options.allowTimes);
				}

				if (_options.weekends && $.isArray(_options.weekends) && _options.weekends.length) {
					options.weekends = $.extend(true, [], _options.weekends);
				}

				if (_options.allowDates && $.isArray(_options.allowDates) && _options.allowDates.length) {
					options.allowDates = $.extend(true, [], _options.allowDates);
				}

				if (_options.allowDateRe && Object.prototype.toString.call(_options.allowDateRe)==="[object String]") {
					options.allowDateRe = new RegExp(_options.allowDateRe);
				}

				if (_options.highlightedDates && $.isArray(_options.highlightedDates) && _options.highlightedDates.length) {
					$.each(_options.highlightedDates, function (index, value) {
						var splitData = $.map(value.split(','), $.trim),
							exDesc,
							hDate = new HighlightedDate(dateHelper.parseDate(splitData[0], options.formatDate), splitData[1], splitData[2]), // date, desc, style
							keyDate = dateHelper.formatDate(hDate.date, options.formatDate);
						if (highlightedDates[keyDate] !== undefined) {
							exDesc = highlightedDates[keyDate].desc;
							if (exDesc && exDesc.length && hDate.desc && hDate.desc.length) {
								highlightedDates[keyDate].desc = exDesc + "\n" + hDate.desc;
							}
						} else {
							highlightedDates[keyDate] = hDate;
						}
					});

					options.highlightedDates = $.extend(true, [], highlightedDates);
				}

				if (_options.highlightedPeriods && $.isArray(_options.highlightedPeriods) && _options.highlightedPeriods.length) {
					highlightedDates = $.extend(true, [], options.highlightedDates);
					$.each(_options.highlightedPeriods, function (index, value) {
						var dateTest, // start date
							dateEnd,
							desc,
							hDate,
							keyDate,
							exDesc,
							style;
						if ($.isArray(value)) {
							dateTest = value[0];
							dateEnd = value[1];
							desc = value[2];
							style = value[3];
						}
						else {
							var splitData = $.map(value.split(','), $.trim);
							dateTest = dateHelper.parseDate(splitData[0], options.formatDate);
							dateEnd = dateHelper.parseDate(splitData[1], options.formatDate);
							desc = splitData[2];
							style = splitData[3];
						}

						while (dateTest <= dateEnd) {
							hDate = new HighlightedDate(dateTest, desc, style);
							keyDate = dateHelper.formatDate(dateTest, options.formatDate);
							dateTest.setDate(dateTest.getDate() + 1);
							if (highlightedDates[keyDate] !== undefined) {
								exDesc = highlightedDates[keyDate].desc;
								if (exDesc && exDesc.length && hDate.desc && hDate.desc.length) {
									highlightedDates[keyDate].desc = exDesc + "\n" + hDate.desc;
								}
							} else {
								highlightedDates[keyDate] = hDate;
							}
						}
					});

					options.highlightedDates = $.extend(true, [], highlightedDates);
				}

				if (_options.disabledDates && $.isArray(_options.disabledDates) && _options.disabledDates.length) {
					options.disabledDates = $.extend(true, [], _options.disabledDates);
				}

				if (_options.disabledWeekDays && $.isArray(_options.disabledWeekDays) && _options.disabledWeekDays.length) {
					options.disabledWeekDays = $.extend(true, [], _options.disabledWeekDays);
				}

				if ((options.open || options.opened) && (!options.inline)) {
					input.trigger('open.xdsoft');
				}

				if (options.inline) {
					triggerAfterOpen = true;
					datetimepicker.addClass('xdsoft_inline');
					input.after(datetimepicker).hide();
				}

				if (options.inverseButton) {
					options.next = 'xdsoft_prev';
					options.prev = 'xdsoft_next';
				}

				if (options.datepicker) {
					datepicker.addClass('active');
				} else {
					datepicker.removeClass('active');
				}

				if (options.timepicker) {
					timepicker.addClass('active');
				} else {
					timepicker.removeClass('active');
				}

				if (options.value) {
					_xdsoft_datetime.setCurrentTime(options.value);
					if (input && input.val) {
						input.val(_xdsoft_datetime.str);
					}
				}

				if (isNaN(options.dayOfWeekStart)) {
					options.dayOfWeekStart = 0;
				} else {
					options.dayOfWeekStart = parseInt(options.dayOfWeekStart, 10) % 7;
				}

				if (!options.timepickerScrollbar) {
					timeboxparent.xdsoftScroller(options, 'hide');
				}

				if (options.minDate && /^[\+\-](.*)$/.test(options.minDate)) {
					options.minDate = dateHelper.formatDate(_xdsoft_datetime.strToDateTime(options.minDate), options.formatDate);
				}

				if (options.maxDate &&  /^[\+\-](.*)$/.test(options.maxDate)) {
					options.maxDate = dateHelper.formatDate(_xdsoft_datetime.strToDateTime(options.maxDate), options.formatDate);
				}

                if (options.minDateTime &&  /^\+(.*)$/.test(options.minDateTime)) {
                	options.minDateTime = _xdsoft_datetime.strToDateTime(options.minDateTime).dateFormat(options.formatDate);
                }

				applyButton.toggle(options.showApplyButton);

				month_picker
					.find('.xdsoft_today_button')
					.css('visibility', !options.todayButton ? 'hidden' : 'visible');

				month_picker
					.find('.' + options.prev)
					.css('visibility', !options.prevButton ? 'hidden' : 'visible');

				month_picker
					.find('.' + options.next)
					.css('visibility', !options.nextButton ? 'hidden' : 'visible');

				setMask(options);

				if (options.validateOnBlur) {
					input
						.off('blur.xdsoft')
						.on('blur.xdsoft', function () {
							if (options.allowBlank && (!$.trim($(this).val()).length ||
									(typeof options.mask === "string" && $.trim($(this).val()) === options.mask.replace(/[0-9]/g, '_')))) {
								$(this).val(null);
								datetimepicker.data('xdsoft_datetime').empty();
							} else {
								var d = dateHelper.parseDate($(this).val(), options.format);
								if (d) { // parseDate() may skip some invalid parts like date or time, so make it clear for user: show parsed date/time
									$(this).val(dateHelper.formatDate(d, options.format));
								} else {
									var splittedHours   = +([$(this).val()[0], $(this).val()[1]].join('')),
										splittedMinutes = +([$(this).val()[2], $(this).val()[3]].join(''));

									// parse the numbers as 0312 => 03:12
									if (!options.datepicker && options.timepicker && splittedHours >= 0 && splittedHours < 24 && splittedMinutes >= 0 && splittedMinutes < 60) {
										$(this).val([splittedHours, splittedMinutes].map(function (item) {
											return item > 9 ? item : '0' + item;
										}).join(':'));
									} else {
										$(this).val(dateHelper.formatDate(_xdsoft_datetime.now(), options.format));
									}
								}
								datetimepicker.data('xdsoft_datetime').setCurrentTime($(this).val());
							}

							datetimepicker.trigger('changedatetime.xdsoft');
							datetimepicker.trigger('close.xdsoft');
						});
				}
				options.dayOfWeekStartPrev = (options.dayOfWeekStart === 0) ? 6 : options.dayOfWeekStart - 1;

				datetimepicker
					.trigger('xchange.xdsoft')
					.trigger('afterOpen.xdsoft');
			};

			datetimepicker
				.data('options', options)
				.on('touchstart mousedown.xdsoft', function (event) {
					event.stopPropagation();
					event.preventDefault();
					yearselect.hide();
					monthselect.hide();
					return false;
				});

			//scroll_element = timepicker.find('.xdsoft_time_box');
			timeboxparent.append(timebox);
			timeboxparent.xdsoftScroller(options);

			datetimepicker.on('afterOpen.xdsoft', function () {
				timeboxparent.xdsoftScroller(options);
			});

			datetimepicker
				.append(datepicker)
				.append(timepicker);

			if (options.withoutCopyright !== true) {
				datetimepicker
					.append(xdsoft_copyright);
			}

			datepicker
				.append(month_picker)
				.append(calendar)
				.append(applyButton);

			$(options.parentID)
				.append(datetimepicker);

			XDSoft_datetime = function () {
				var _this = this;
				_this.now = function (norecursion) {
					var d = new Date(),
						date,
						time;

					if (!norecursion && options.defaultDate) {
						date = _this.strToDateTime(options.defaultDate);
						d.setFullYear(date.getFullYear());
						d.setMonth(date.getMonth());
						d.setDate(date.getDate());
					}

					if (options.yearOffset) {
						d.setFullYear(d.getFullYear() + options.yearOffset);
					}

					if (!norecursion && options.defaultTime) {
						time = _this.strtotime(options.defaultTime);
						d.setHours(time.getHours());
						d.setMinutes(time.getMinutes());
						d.setSeconds(time.getSeconds());
						d.setMilliseconds(time.getMilliseconds());
					}
					return d;
				};

				_this.isValidDate = function (d) {
					if (Object.prototype.toString.call(d) !== "[object Date]") {
						return false;
					}
					return !isNaN(d.getTime());
				};

				_this.setCurrentTime = function (dTime, requireValidDate) {
					if (typeof dTime === 'string') {
						_this.currentTime = _this.strToDateTime(dTime);
					}
					else if (_this.isValidDate(dTime)) {
						_this.currentTime = dTime;
					}
					else if (!dTime && !requireValidDate && options.allowBlank && !options.inline) {
						_this.currentTime = null;
					}
					else {
						_this.currentTime = _this.now();
					}

					datetimepicker.trigger('xchange.xdsoft');
				};

				_this.empty = function () {
					_this.currentTime = null;
				};

				_this.getCurrentTime = function () {
					return _this.currentTime;
				};

				_this.nextMonth = function () {

					if (_this.currentTime === undefined || _this.currentTime === null) {
						_this.currentTime = _this.now();
					}

					var month = _this.currentTime.getMonth() + 1,
						year;
					if (month === 12) {
						_this.currentTime.setFullYear(_this.currentTime.getFullYear() + 1);
						month = 0;
					}

					year = _this.currentTime.getFullYear();

					_this.currentTime.setDate(
						Math.min(
							new Date(_this.currentTime.getFullYear(), month + 1, 0).getDate(),
							_this.currentTime.getDate()
						)
					);
					_this.currentTime.setMonth(month);

					if (options.onChangeMonth && $.isFunction(options.onChangeMonth)) {
						options.onChangeMonth.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'));
					}

					if (year !== _this.currentTime.getFullYear() && $.isFunction(options.onChangeYear)) {
						options.onChangeYear.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'));
					}

					datetimepicker.trigger('xchange.xdsoft');
					return month;
				};

				_this.prevMonth = function () {

					if (_this.currentTime === undefined || _this.currentTime === null) {
						_this.currentTime = _this.now();
					}

					var month = _this.currentTime.getMonth() - 1;
					if (month === -1) {
						_this.currentTime.setFullYear(_this.currentTime.getFullYear() - 1);
						month = 11;
					}
					_this.currentTime.setDate(
						Math.min(
							new Date(_this.currentTime.getFullYear(), month + 1, 0).getDate(),
							_this.currentTime.getDate()
						)
					);
					_this.currentTime.setMonth(month);
					if (options.onChangeMonth && $.isFunction(options.onChangeMonth)) {
						options.onChangeMonth.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'));
					}
					datetimepicker.trigger('xchange.xdsoft');
					return month;
				};

				_this.getWeekOfYear = function (datetime) {
					if (options.onGetWeekOfYear && $.isFunction(options.onGetWeekOfYear)) {
						var week = options.onGetWeekOfYear.call(datetimepicker, datetime);
						if (typeof week !== 'undefined') {
							return week;
						}
					}
					var onejan = new Date(datetime.getFullYear(), 0, 1);

					//First week of the year is th one with the first Thursday according to ISO8601
					if (onejan.getDay() !== 4) {
						onejan.setMonth(0, 1 + ((4 - onejan.getDay()+ 7) % 7));
					}

					return Math.ceil((((datetime - onejan) / 86400000) + onejan.getDay() + 1) / 7);
				};

				_this.strToDateTime = function (sDateTime) {
					var tmpDate = [], timeOffset, currentTime;

					if (sDateTime && sDateTime instanceof Date && _this.isValidDate(sDateTime)) {
						return sDateTime;
					}

					tmpDate = /^([+-]{1})(.*)$/.exec(sDateTime);

					if (tmpDate) {
						tmpDate[2] = dateHelper.parseDate(tmpDate[2], options.formatDate);
					}

					if (tmpDate  && tmpDate[2]) {
						timeOffset = tmpDate[2].getTime() - (tmpDate[2].getTimezoneOffset()) * 60000;
						currentTime = new Date((_this.now(true)).getTime() + parseInt(tmpDate[1] + '1', 10) * timeOffset);
					} else {
						currentTime = sDateTime ? dateHelper.parseDate(sDateTime, options.format) : _this.now();
					}

					if (!_this.isValidDate(currentTime)) {
						currentTime = _this.now();
					}

					return currentTime;
				};

				_this.strToDate = function (sDate) {
					if (sDate && sDate instanceof Date && _this.isValidDate(sDate)) {
						return sDate;
					}

					var currentTime = sDate ? dateHelper.parseDate(sDate, options.formatDate) : _this.now(true);
					if (!_this.isValidDate(currentTime)) {
						currentTime = _this.now(true);
					}
					return currentTime;
				};

				_this.strtotime = function (sTime) {
					if (sTime && sTime instanceof Date && _this.isValidDate(sTime)) {
						return sTime;
					}
					var currentTime = sTime ? dateHelper.parseDate(sTime, options.formatTime) : _this.now(true);
					if (!_this.isValidDate(currentTime)) {
						currentTime = _this.now(true);
					}
					return currentTime;
				};

				_this.str = function () {
					return dateHelper.formatDate(_this.currentTime, options.format);
				};
				_this.currentTime = this.now();
			};

			_xdsoft_datetime = new XDSoft_datetime();

			applyButton.on('touchend click', function (e) {//pathbrite
				e.preventDefault();
				datetimepicker.data('changed', true);
				_xdsoft_datetime.setCurrentTime(getCurrentValue());
				input.val(_xdsoft_datetime.str());
				datetimepicker.trigger('close.xdsoft');
			});
			month_picker
				.find('.xdsoft_today_button')
				.on('touchend mousedown.xdsoft', function () {
					datetimepicker.data('changed', true);
					_xdsoft_datetime.setCurrentTime(0, true);
					datetimepicker.trigger('afterOpen.xdsoft');
				}).on('dblclick.xdsoft', function () {
				var currentDate = _xdsoft_datetime.getCurrentTime(), minDate, maxDate;
				currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
				minDate = _xdsoft_datetime.strToDate(options.minDate);
				minDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
				if (currentDate < minDate) {
					return;
				}
				maxDate = _xdsoft_datetime.strToDate(options.maxDate);
				maxDate = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
				if (currentDate > maxDate) {
					return;
				}
				input.val(_xdsoft_datetime.str());
				input.trigger('change');
				datetimepicker.trigger('close.xdsoft');
			});
			month_picker
				.find('.xdsoft_prev,.xdsoft_next')
				.on('touchend mousedown.xdsoft', function () {
					var $this = $(this),
						timer = 0,
						stop = false;

					(function arguments_callee1(v) {
						if ($this.hasClass(options.next)) {
							_xdsoft_datetime.nextMonth();
						} else if ($this.hasClass(options.prev)) {
							_xdsoft_datetime.prevMonth();
						}
						if (options.monthChangeSpinner) {
							if (!stop) {
								timer = setTimeout(arguments_callee1, v || 100);
							}
						}
					}(500));

					$([options.ownerDocument.body, options.contentWindow]).on('touchend mouseup.xdsoft', function arguments_callee2() {
						clearTimeout(timer);
						stop = true;
						$([options.ownerDocument.body, options.contentWindow]).off('touchend mouseup.xdsoft', arguments_callee2);
					});
				});

			timepicker
				.find('.xdsoft_prev,.xdsoft_next')
				.on('touchend mousedown.xdsoft', function () {
					var $this = $(this),
						timer = 0,
						stop = false,
						period = 110;
					(function arguments_callee4(v) {
						var pheight = timeboxparent[0].clientHeight,
							height = timebox[0].offsetHeight,
							top = Math.abs(parseInt(timebox.css('marginTop'), 10));
						if ($this.hasClass(options.next) && (height - pheight) - options.timeHeightInTimePicker >= top) {
							timebox.css('marginTop', '-' + (top + options.timeHeightInTimePicker) + 'px');
						} else if ($this.hasClass(options.prev) && top - options.timeHeightInTimePicker >= 0) {
							timebox.css('marginTop', '-' + (top - options.timeHeightInTimePicker) + 'px');
						}
						/**
						 * Fixed bug:
						 * When using css3 transition, it will cause a bug that you cannot scroll the timepicker list.
						 * The reason is that the transition-duration time, if you set it to 0, all things fine, otherwise, this
						 * would cause a bug when you use jquery.css method.
						 * Let's say: * { transition: all .5s ease; }
						 * jquery timebox.css('marginTop') will return the original value which is before you clicking the next/prev button,
						 * meanwhile the timebox[0].style.marginTop will return the right value which is after you clicking the
						 * next/prev button.
						 *
						 * What we should do:
						 * Replace timebox.css('marginTop') with timebox[0].style.marginTop.
						 */
						timeboxparent.trigger('scroll_element.xdsoft_scroller', [Math.abs(parseInt(timebox[0].style.marginTop, 10) / (height - pheight))]);
						period = (period > 10) ? 10 : period - 10;
						if (!stop) {
							timer = setTimeout(arguments_callee4, v || period);
						}
					}(500));
					$([options.ownerDocument.body, options.contentWindow]).on('touchend mouseup.xdsoft', function arguments_callee5() {
						clearTimeout(timer);
						stop = true;
						$([options.ownerDocument.body, options.contentWindow])
							.off('touchend mouseup.xdsoft', arguments_callee5);
					});
				});

			xchangeTimer = 0;
			// base handler - generating a calendar and timepicker
			datetimepicker
				.on('xchange.xdsoft', function (event) {
					clearTimeout(xchangeTimer);
					xchangeTimer = setTimeout(function () {

						if (_xdsoft_datetime.currentTime === undefined || _xdsoft_datetime.currentTime === null) {
							_xdsoft_datetime.currentTime = _xdsoft_datetime.now();
						}

						var table =	'',
							start = new Date(_xdsoft_datetime.currentTime.getFullYear(), _xdsoft_datetime.currentTime.getMonth(), 1, 12, 0, 0),
							i = 0,
							j,
							today = _xdsoft_datetime.now(),
							maxDate = false,
							minDate = false,
                            minDateTime = false,
							hDate,
							day,
							d,
							y,
							m,
							w,
							classes = [],
							customDateSettings,
							newRow = true,
							time = '',
							h,
							line_time,
							description;

						while (start.getDay() !== options.dayOfWeekStart) {
							start.setDate(start.getDate() - 1);
						}

						table += '<table><thead><tr>';

						if (options.weeks) {
							table += '<th></th>';
						}

						for (j = 0; j < 7; j += 1) {
							table += '<th>' + options.i18n[globalLocale].dayOfWeekShort[(j + options.dayOfWeekStart) % 7] + '</th>';
						}

						table += '</tr></thead>';
						table += '<tbody>';

						if (options.maxDate !== false) {
							maxDate = _xdsoft_datetime.strToDate(options.maxDate);
							maxDate = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate(), 23, 59, 59, 999);
						}

						if (options.minDate !== false) {
							minDate = _xdsoft_datetime.strToDate(options.minDate);
							minDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
						}

                        if (options.minDateTime !== false) {
							minDateTime = _xdsoft_datetime.strToDate(options.minDateTime);
							minDateTime = new Date(minDateTime.getFullYear(), minDateTime.getMonth(), minDateTime.getDate(), minDateTime.getHours(), minDateTime.getMinutes(), minDateTime.getSeconds());
						}

						while (i < _xdsoft_datetime.currentTime.countDaysInMonth() || start.getDay() !== options.dayOfWeekStart || _xdsoft_datetime.currentTime.getMonth() === start.getMonth()) {
							classes = [];
							i += 1;

							day = start.getDay();
							d = start.getDate();
							y = start.getFullYear();
							m = start.getMonth();
							w = _xdsoft_datetime.getWeekOfYear(start);
							description = '';

							classes.push('xdsoft_date');

							if (options.beforeShowDay && $.isFunction(options.beforeShowDay.call)) {
								customDateSettings = options.beforeShowDay.call(datetimepicker, start);
							} else {
								customDateSettings = null;
							}

							if(options.allowDateRe && Object.prototype.toString.call(options.allowDateRe) === "[object RegExp]"){
								if(!options.allowDateRe.test(dateHelper.formatDate(start, options.formatDate))){
									classes.push('xdsoft_disabled');
								}
							}
							
							if(options.allowDates && options.allowDates.length>0){
								if(options.allowDates.indexOf(dateHelper.formatDate(start, options.formatDate)) === -1){
									classes.push('xdsoft_disabled');
								}
							}
							
							if ((maxDate !== false && start > maxDate) || (minDateTime !== false && start < minDateTime)  || (minDate !== false && start < minDate) || (customDateSettings && customDateSettings[0] === false)) {
								classes.push('xdsoft_disabled');
							}
							
							if (options.disabledDates.indexOf(dateHelper.formatDate(start, options.formatDate)) !== -1) {
								classes.push('xdsoft_disabled');
							}
							
							if (options.disabledWeekDays.indexOf(day) !== -1) {
								classes.push('xdsoft_disabled');
							}
							
							if (input.is('[disabled]')) {
								classes.push('xdsoft_disabled');
							}

							if (customDateSettings && customDateSettings[1] !== "") {
								classes.push(customDateSettings[1]);
							}

							if (_xdsoft_datetime.currentTime.getMonth() !== m) {
								classes.push('xdsoft_other_month');
							}

							if ((options.defaultSelect || datetimepicker.data('changed')) && dateHelper.formatDate(_xdsoft_datetime.currentTime, options.formatDate) === dateHelper.formatDate(start, options.formatDate)) {
								classes.push('xdsoft_current');
							}

							if (dateHelper.formatDate(today, options.formatDate) === dateHelper.formatDate(start, options.formatDate)) {
								classes.push('xdsoft_today');
							}

							if (start.getDay() === 0 || start.getDay() === 6 || options.weekends.indexOf(dateHelper.formatDate(start, options.formatDate)) !== -1) {
								classes.push('xdsoft_weekend');
							}

							if (options.highlightedDates[dateHelper.formatDate(start, options.formatDate)] !== undefined) {
								hDate = options.highlightedDates[dateHelper.formatDate(start, options.formatDate)];
								classes.push(hDate.style === undefined ? 'xdsoft_highlighted_default' : hDate.style);
								description = hDate.desc === undefined ? '' : hDate.desc;
							}

							if (options.beforeShowDay && $.isFunction(options.beforeShowDay)) {
								classes.push(options.beforeShowDay(start));
							}

							if (newRow) {
								table += '<tr>';
								newRow = false;
								if (options.weeks) {
									table += '<th>' + w + '</th>';
								}
							}

							table += '<td data-date="' + d + '" data-month="' + m + '" data-year="' + y + '"' + ' class="xdsoft_date xdsoft_day_of_week' + start.getDay() + ' ' + classes.join(' ') + '" title="' + description + '">' +
								'<div>' + d + '</div>' +
								'</td>';

							if (start.getDay() === options.dayOfWeekStartPrev) {
								table += '</tr>';
								newRow = true;
							}

							start.setDate(d + 1);
						}
						table += '</tbody></table>';

						calendar.html(table);

						month_picker.find('.xdsoft_label span').eq(0).text(options.i18n[globalLocale].months[_xdsoft_datetime.currentTime.getMonth()]);
						month_picker.find('.xdsoft_label span').eq(1).text(_xdsoft_datetime.currentTime.getFullYear());

						// generate timebox
						time = '';
						h = '';
						m = '';

						line_time = function line_time(h, m) {
							var now = _xdsoft_datetime.now(), optionDateTime, current_time,
								isALlowTimesInit = options.allowTimes && $.isArray(options.allowTimes) && options.allowTimes.length;
							now.setHours(h);
							h = parseInt(now.getHours(), 10);
							now.setMinutes(m);
							m = parseInt(now.getMinutes(), 10);
							optionDateTime = new Date(_xdsoft_datetime.currentTime);
							optionDateTime.setHours(h);
							optionDateTime.setMinutes(m);
							classes = [];
							if ((options.minDateTime !== false && options.minDateTime > optionDateTime) || (options.maxTime !== false && _xdsoft_datetime.strtotime(options.maxTime).getTime() < now.getTime()) || (options.minTime !== false && _xdsoft_datetime.strtotime(options.minTime).getTime() > now.getTime())) {
								classes.push('xdsoft_disabled');
							} else if ((options.minDateTime !== false && options.minDateTime > optionDateTime) || ((options.disabledMinTime !== false && now.getTime() > _xdsoft_datetime.strtotime(options.disabledMinTime).getTime()) && (options.disabledMaxTime !== false && now.getTime() < _xdsoft_datetime.strtotime(options.disabledMaxTime).getTime()))) {
								classes.push('xdsoft_disabled');
							} else if (input.is('[disabled]')) {
								classes.push('xdsoft_disabled');
							}

							current_time = new Date(_xdsoft_datetime.currentTime);
							current_time.setHours(parseInt(_xdsoft_datetime.currentTime.getHours(), 10));

							if (!isALlowTimesInit) {
								current_time.setMinutes(Math[options.roundTime](_xdsoft_datetime.currentTime.getMinutes() / options.step) * options.step);
							}

							if ((options.initTime || options.defaultSelect || datetimepicker.data('changed')) && current_time.getHours() === parseInt(h, 10) && ((!isALlowTimesInit && options.step > 59) || current_time.getMinutes() === parseInt(m, 10))) {
								if (options.defaultSelect || datetimepicker.data('changed')) {
									classes.push('xdsoft_current');
								} else if (options.initTime) {
									classes.push('xdsoft_init_time');
								}
							}
							if (parseInt(today.getHours(), 10) === parseInt(h, 10) && parseInt(today.getMinutes(), 10) === parseInt(m, 10)) {
								classes.push('xdsoft_today');
							}
							time += '<div class="xdsoft_time ' + classes.join(' ') + '" data-hour="' + h + '" data-minute="' + m + '">' + dateHelper.formatDate(now, options.formatTime) + '</div>';
						};

						if (!options.allowTimes || !$.isArray(options.allowTimes) || !options.allowTimes.length) {
							for (i = 0, j = 0; i < (options.hours12 ? 12 : 24); i += 1) {
								for (j = 0; j < 60; j += options.step) {
									h = (i < 10 ? '0' : '') + i;
									m = (j < 10 ? '0' : '') + j;
									line_time(h, m);
								}
							}
						} else {
							for (i = 0; i < options.allowTimes.length; i += 1) {
								h = _xdsoft_datetime.strtotime(options.allowTimes[i]).getHours();
								m = _xdsoft_datetime.strtotime(options.allowTimes[i]).getMinutes();
								line_time(h, m);
							}
						}

						timebox.html(time);

						opt = '';

						for (i = parseInt(options.yearStart, 10) + options.yearOffset; i <= parseInt(options.yearEnd, 10) + options.yearOffset; i += 1) {
							opt += '<div class="xdsoft_option ' + (_xdsoft_datetime.currentTime.getFullYear() === i ? 'xdsoft_current' : '') + '" data-value="' + i + '">' + i + '</div>';
						}
						yearselect.children().eq(0)
							.html(opt);

						for (i = parseInt(options.monthStart, 10), opt = ''; i <= parseInt(options.monthEnd, 10); i += 1) {
							opt += '<div class="xdsoft_option ' + (_xdsoft_datetime.currentTime.getMonth() === i ? 'xdsoft_current' : '') + '" data-value="' + i + '">' + options.i18n[globalLocale].months[i] + '</div>';
						}
						monthselect.children().eq(0).html(opt);
						$(datetimepicker)
							.trigger('generate.xdsoft');
					}, 10);
					event.stopPropagation();
				})
				.on('afterOpen.xdsoft', function () {
					if (options.timepicker) {
						var classType, pheight, height, top;
						if (timebox.find('.xdsoft_current').length) {
							classType = '.xdsoft_current';
						} else if (timebox.find('.xdsoft_init_time').length) {
							classType = '.xdsoft_init_time';
						}
						if (classType) {
							pheight = timeboxparent[0].clientHeight;
							height = timebox[0].offsetHeight;
							top = timebox.find(classType).index() * options.timeHeightInTimePicker + 1;
							if ((height - pheight) < top) {
								top = height - pheight;
							}
							timeboxparent.trigger('scroll_element.xdsoft_scroller', [parseInt(top, 10) / (height - pheight)]);
						} else {
							timeboxparent.trigger('scroll_element.xdsoft_scroller', [0]);
						}
					}
				});

			timerclick = 0;
			calendar
				.on('touchend click.xdsoft', 'td', function (xdevent) {
					xdevent.stopPropagation();  // Prevents closing of Pop-ups, Modals and Flyouts in Bootstrap
					timerclick += 1;
					var $this = $(this),
						currentTime = _xdsoft_datetime.currentTime;

					if (currentTime === undefined || currentTime === null) {
						_xdsoft_datetime.currentTime = _xdsoft_datetime.now();
						currentTime = _xdsoft_datetime.currentTime;
					}

					if ($this.hasClass('xdsoft_disabled')) {
						return false;
					}

					currentTime.setDate(1);
					currentTime.setFullYear($this.data('year'));
					currentTime.setMonth($this.data('month'));
					currentTime.setDate($this.data('date'));

					datetimepicker.trigger('select.xdsoft', [currentTime]);

					input.val(_xdsoft_datetime.str());

					if (options.onSelectDate &&	$.isFunction(options.onSelectDate)) {
						options.onSelectDate.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'), xdevent);
					}

					datetimepicker.data('changed', true);
					datetimepicker.trigger('xchange.xdsoft');
					datetimepicker.trigger('changedatetime.xdsoft');
					if ((timerclick > 1 || (options.closeOnDateSelect === true || (options.closeOnDateSelect === false && !options.timepicker))) && !options.inline) {
						datetimepicker.trigger('close.xdsoft');
					}
					setTimeout(function () {
						timerclick = 0;
					}, 200);
				});

			timebox
				.on('touchstart', 'div', function (xdevent) {
					this.touchMoved = false;
				})
				.on('touchmove', 'div', handleTouchMoved)
				.on('touchend click.xdsoft', 'div', function (xdevent) {
					if (!this.touchMoved) {
						xdevent.stopPropagation();
						var $this = $(this),
							currentTime = _xdsoft_datetime.currentTime;

						if (currentTime === undefined || currentTime === null) {
							_xdsoft_datetime.currentTime = _xdsoft_datetime.now();
							currentTime = _xdsoft_datetime.currentTime;
						}

						if ($this.hasClass('xdsoft_disabled')) {
							return false;
						}
						currentTime.setHours($this.data('hour'));
						currentTime.setMinutes($this.data('minute'));
						datetimepicker.trigger('select.xdsoft', [currentTime]);

						datetimepicker.data('input').val(_xdsoft_datetime.str());

						if (options.onSelectTime && $.isFunction(options.onSelectTime)) {
							options.onSelectTime.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'), xdevent);
						}
						datetimepicker.data('changed', true);
						datetimepicker.trigger('xchange.xdsoft');
						datetimepicker.trigger('changedatetime.xdsoft');
						if (options.inline !== true && options.closeOnTimeSelect === true) {
							datetimepicker.trigger('close.xdsoft');
						}
					}
				});

			datepicker
				.on('mousewheel.xdsoft', function (event) {
					if (!options.scrollMonth) {
						return true;
					}
					if (event.deltaY < 0) {
						_xdsoft_datetime.nextMonth();
					} else {
						_xdsoft_datetime.prevMonth();
					}
					return false;
				});

			input
				.on('mousewheel.xdsoft', function (event) {
					if (!options.scrollInput) {
						return true;
					}
					if (!options.datepicker && options.timepicker) {
						current_time_index = timebox.find('.xdsoft_current').length ? timebox.find('.xdsoft_current').eq(0).index() : 0;
						if (current_time_index + event.deltaY >= 0 && current_time_index + event.deltaY < timebox.children().length) {
							current_time_index += event.deltaY;
						}
						if (timebox.children().eq(current_time_index).length) {
							timebox.children().eq(current_time_index).trigger('mousedown');
						}
						return false;
					}
					if (options.datepicker && !options.timepicker) {
						datepicker.trigger(event, [event.deltaY, event.deltaX, event.deltaY]);
						if (input.val) {
							input.val(_xdsoft_datetime.str());
						}
						datetimepicker.trigger('changedatetime.xdsoft');
						return false;
					}
				});

			datetimepicker
				.on('changedatetime.xdsoft', function (event) {
					if (options.onChangeDateTime && $.isFunction(options.onChangeDateTime)) {
						var $input = datetimepicker.data('input');
						options.onChangeDateTime.call(datetimepicker, _xdsoft_datetime.currentTime, $input, event);
						delete options.value;
						$input.trigger('change');
					}
				})
				.on('generate.xdsoft', function () {
					if (options.onGenerate && $.isFunction(options.onGenerate)) {
						options.onGenerate.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'));
					}
					if (triggerAfterOpen) {
						datetimepicker.trigger('afterOpen.xdsoft');
						triggerAfterOpen = false;
					}
				})
				.on('click.xdsoft', function (xdevent) {
					xdevent.stopPropagation();
				});

			current_time_index = 0;

			/**
			 * Runs the callback for each of the specified node's ancestors.
			 *
			 * Return FALSE from the callback to stop ascending.
			 *
			 * @param {DOMNode} node
			 * @param {Function} callback
			 * @returns {undefined}
			 */
			forEachAncestorOf = function (node, callback) {
				do {
					node = node.parentNode;

					if (!node || callback(node) === false) {
						break;
					}
				} while (node.nodeName !== 'HTML');
			};

			/**
			 * Sets the position of the picker.
			 *
			 * @returns {undefined}
			 */
			setPos = function () {
				var dateInputOffset,
					dateInputElem,
					verticalPosition,
					left,
					position,
					datetimepickerElem,
					dateInputHasFixedAncestor,
					$dateInput,
					windowWidth,
					verticalAnchorEdge,
					datetimepickerCss,
					windowHeight,
					windowScrollTop;

				$dateInput = datetimepicker.data('input');
				dateInputOffset = $dateInput.offset();
				dateInputElem = $dateInput[0];

				verticalAnchorEdge = 'top';
				verticalPosition = (dateInputOffset.top + dateInputElem.offsetHeight) - 1;
				left = dateInputOffset.left;
				position = "absolute";

				windowWidth = $(options.contentWindow).width();
				windowHeight = $(options.contentWindow).height();
				windowScrollTop = $(options.contentWindow).scrollTop();

				if ((options.ownerDocument.documentElement.clientWidth - dateInputOffset.left) < datepicker.parent().outerWidth(true)) {
					var diff = datepicker.parent().outerWidth(true) - dateInputElem.offsetWidth;
					left = left - diff;
				}

				if ($dateInput.parent().css('direction') === 'rtl') {
					left -= (datetimepicker.outerWidth() - $dateInput.outerWidth());
				}

				if (options.fixed) {
					verticalPosition -= windowScrollTop;
					left -= $(options.contentWindow).scrollLeft();
					position = "fixed";
				} else {
					dateInputHasFixedAncestor = false;

					forEachAncestorOf(dateInputElem, function (ancestorNode) {
						if (ancestorNode === null) {
							return false;
						}

						if (options.contentWindow.getComputedStyle(ancestorNode).getPropertyValue('position') === 'fixed') {
							dateInputHasFixedAncestor = true;
							return false;
						}
					});

					if (dateInputHasFixedAncestor) {
						position = 'fixed';

						//If the picker won't fit entirely within the viewport then display it above the date input.
						if (verticalPosition + datetimepicker.outerHeight() > windowHeight + windowScrollTop) {
							verticalAnchorEdge = 'bottom';
							verticalPosition = (windowHeight + windowScrollTop) - dateInputOffset.top;
						} else {
							verticalPosition -= windowScrollTop;
						}
					} else {
						if (verticalPosition + datetimepicker[0].offsetHeight > windowHeight + windowScrollTop) {
							verticalPosition = dateInputOffset.top - datetimepicker[0].offsetHeight + 1;
						}
					}

					if (verticalPosition < 0) {
						verticalPosition = 0;
					}

					if (left + dateInputElem.offsetWidth > windowWidth) {
						left = windowWidth - dateInputElem.offsetWidth;
					}
				}

				datetimepickerElem = datetimepicker[0];

				forEachAncestorOf(datetimepickerElem, function (ancestorNode) {
					var ancestorNodePosition;

					ancestorNodePosition = options.contentWindow.getComputedStyle(ancestorNode).getPropertyValue('position');

					if (ancestorNodePosition === 'relative' && windowWidth >= ancestorNode.offsetWidth) {
						left = left - ((windowWidth - ancestorNode.offsetWidth) / 2);
						return false;
					}
				});

				datetimepickerCss = {
					position: position,
					left: left,
					top: '',  //Initialize to prevent previous values interfering with new ones.
					bottom: ''  //Initialize to prevent previous values interfering with new ones.
				};

				datetimepickerCss[verticalAnchorEdge] = verticalPosition;

				datetimepicker.css(datetimepickerCss);
			};

			datetimepicker
				.on('open.xdsoft', function (event) {
					var onShow = true;
					if (options.onShow && $.isFunction(options.onShow)) {
						onShow = options.onShow.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'), event);
					}
					if (onShow !== false) {
						datetimepicker.show();
						setPos();
						$(options.contentWindow)
							.off('resize.xdsoft', setPos)
							.on('resize.xdsoft', setPos);

						if (options.closeOnWithoutClick) {
							$([options.ownerDocument.body, options.contentWindow]).on('touchstart mousedown.xdsoft', function arguments_callee6() {
								datetimepicker.trigger('close.xdsoft');
								$([options.ownerDocument.body, options.contentWindow]).off('touchstart mousedown.xdsoft', arguments_callee6);
							});
						}
					}
				})
				.on('close.xdsoft', function (event) {
					var onClose = true;
					month_picker
						.find('.xdsoft_month,.xdsoft_year')
						.find('.xdsoft_select')
						.hide();
					if (options.onClose && $.isFunction(options.onClose)) {
						onClose = options.onClose.call(datetimepicker, _xdsoft_datetime.currentTime, datetimepicker.data('input'), event);
					}
					if (onClose !== false && !options.opened && !options.inline) {
						datetimepicker.hide();
					}
					event.stopPropagation();
				})
				.on('toggle.xdsoft', function () {
					if (datetimepicker.is(':visible')) {
						datetimepicker.trigger('close.xdsoft');
					} else {
						datetimepicker.trigger('open.xdsoft');
					}
				})
				.data('input', input);

			timer = 0;

			datetimepicker.data('xdsoft_datetime', _xdsoft_datetime);
			datetimepicker.setOptions(options);

			function getCurrentValue() {
				var ct = false, time;

				if (options.startDate) {
					ct = _xdsoft_datetime.strToDate(options.startDate);
				} else {
					ct = options.value || ((input && input.val && input.val()) ? input.val() : '');
					if (ct) {
						ct = _xdsoft_datetime.strToDateTime(ct);
					} else if (options.defaultDate) {
						ct = _xdsoft_datetime.strToDateTime(options.defaultDate);
						if (options.defaultTime) {
							time = _xdsoft_datetime.strtotime(options.defaultTime);
							ct.setHours(time.getHours());
							ct.setMinutes(time.getMinutes());
						}
					}
				}

				if (ct && _xdsoft_datetime.isValidDate(ct)) {
					datetimepicker.data('changed', true);
				} else {
					ct = '';
				}

				return ct || 0;
			}

			function setMask(options) {

				var isValidValue = function (mask, value) {
						var reg = mask
							.replace(/([\[\]\/\{\}\(\)\-\.\+]{1})/g, '\\$1')
							.replace(/_/g, '{digit+}')
							.replace(/([0-9]{1})/g, '{digit$1}')
							.replace(/\{digit([0-9]{1})\}/g, '[0-$1_]{1}')
							.replace(/\{digit[\+]\}/g, '[0-9_]{1}');
						return (new RegExp(reg)).test(value);
					},
					getCaretPos = function (input) {
						try {
							if (options.ownerDocument.selection && options.ownerDocument.selection.createRange) {
								var range = options.ownerDocument.selection.createRange();
								return range.getBookmark().charCodeAt(2) - 2;
							}
							if (input.setSelectionRange) {
								return input.selectionStart;
							}
						} catch (e) {
							return 0;
						}
					},
					setCaretPos = function (node, pos) {
						node = (typeof node === "string" || node instanceof String) ? options.ownerDocument.getElementById(node) : node;
						if (!node) {
							return false;
						}
						if (node.createTextRange) {
							var textRange = node.createTextRange();
							textRange.collapse(true);
							textRange.moveEnd('character', pos);
							textRange.moveStart('character', pos);
							textRange.select();
							return true;
						}
						if (node.setSelectionRange) {
							node.setSelectionRange(pos, pos);
							return true;
						}
						return false;
					};

				if(options.mask) {
					input.off('keydown.xdsoft');
				}

				if (options.mask === true) {
					if (typeof moment != 'undefined') {
						options.mask = options.format
							.replace(/Y{4}/g, '9999')
							.replace(/Y{2}/g, '99')
							.replace(/M{2}/g, '19')
							.replace(/D{2}/g, '39')
							.replace(/H{2}/g, '29')
							.replace(/m{2}/g, '59')
							.replace(/s{2}/g, '59');
					} else {
						options.mask = options.format
							.replace(/Y/g, '9999')
							.replace(/F/g, '9999')
							.replace(/m/g, '19')
							.replace(/d/g, '39')
							.replace(/H/g, '29')
							.replace(/i/g, '59')
							.replace(/s/g, '59');
					}
				}

				if ($.type(options.mask) === 'string') {
					if (!isValidValue(options.mask, input.val())) {
						input.val(options.mask.replace(/[0-9]/g, '_'));
						setCaretPos(input[0], 0);
					}

					input.on('paste.xdsoft', function (event) {
					    // couple options here
					    // 1. return false - tell them they can't paste
					    // 2. insert over current characters - minimal validation
					    // 3. full fledged parsing and validation
					    // let's go option 2 for now

					    // fires multiple times for some reason

					    // https://stackoverflow.com/a/30496488/1366033
					    var clipboardData = event.clipboardData || event.originalEvent.clipboardData || window.clipboardData,
						pastedData = clipboardData.getData('text'),
						val = this.value,
						pos = this.selectionStart

					    var valueBeforeCursor = val.substr(0, pos);
					    var valueAfterPaste = val.substr(pos + pastedData.length);

					    val = valueBeforeCursor + pastedData + valueAfterPaste;           
					    pos += pastedData.length;

					    if (isValidValue(options.mask, val)) {
						this.value = val;
						setCaretPos(this, pos);
					    } else if ($.trim(val) === '') {
						this.value = options.mask.replace(/[0-9]/g, '_');
					    } else {
						input.trigger('error_input.xdsoft');
					    }

					    event.preventDefault();
					    return false;
					  });

					  input.on('keydown.xdsoft', function (event) {
					    var val = this.value,
						key = event.which,
						pos = this.selectionStart,
						selEnd = this.selectionEnd,
						hasSel = pos !== selEnd,
						digit;

					    // only alow these characters
					    if (((key >=  KEY0 && key <=  KEY9)  ||
						 (key >= _KEY0 && key <= _KEY9)) || 
						 (key === BACKSPACE || key === DEL)) {

					      // get char to insert which is new character or placeholder ('_')
					      digit = (key === BACKSPACE || key === DEL) ? '_' :
							  String.fromCharCode((_KEY0 <= key && key <= _KEY9) ? key - KEY0 : key);

						// we're deleting something, we're not at the start, and have normal cursor, move back one
						// if we have a selection length, cursor actually sits behind deletable char, not in front
						if (key === BACKSPACE && pos && !hasSel) {
						    pos -= 1;
						}

						// don't stop on a separator, continue whatever direction you were going
						//   value char - keep incrementing position while on separator char and we still have room
						//   del char   - keep decrementing position while on separator char and we still have room
						while (true) {
						  var maskValueAtCurPos = options.mask.substr(pos, 1);
						  var posShorterThanMaskLength = pos < options.mask.length;
						  var posGreaterThanZero = pos > 0;
						  var notNumberOrPlaceholder = /[^0-9_]/;
						  var curPosOnSep = notNumberOrPlaceholder.test(maskValueAtCurPos);
						  var continueMovingPosition = curPosOnSep && posShorterThanMaskLength && posGreaterThanZero

						  // if we hit a real char, stay where we are
						  if (!continueMovingPosition) break;

						  // hitting backspace in a selection, you can possibly go back any further - go forward
						  pos += (key === BACKSPACE && !hasSel) ? -1 : 1;

						}


						if (hasSel) {
						  // pos might have moved so re-calc length
						  var selLength = selEnd - pos

						  // if we have a selection length we will wipe out entire selection and replace with default template for that range
						  var defaultBlank = options.mask.replace(/[0-9]/g, '_');
						  var defaultBlankSelectionReplacement = defaultBlank.substr(pos, selLength); 
						  var selReplacementRemainder = defaultBlankSelectionReplacement.substr(1) // might be empty

						  var valueBeforeSel = val.substr(0, pos);
						  var insertChars = digit + selReplacementRemainder;
						  var charsAfterSelection = val.substr(pos + selLength);

						  val = valueBeforeSel + insertChars + charsAfterSelection

						} else {
						  var valueBeforeCursor = val.substr(0, pos);
						  var insertChar = digit;
						  var valueAfterNextChar = val.substr(pos + 1);

						  val = valueBeforeCursor + insertChar + valueAfterNextChar
						}

						if ($.trim(val) === '') {
						  // if empty, set to default
						    val = defaultBlank
						} else {
						  // if at the last character don't need to do anything
						    if (pos === options.mask.length) {
							event.preventDefault();
							return false;
						    }
						}

						// resume cursor location
						pos += (key === BACKSPACE) ? 0 : 1;
						// don't stop on a separator, continue whatever direction you were going
						while (/[^0-9_]/.test(options.mask.substr(pos, 1)) && pos < options.mask.length && pos > 0) {
						    pos += (key === BACKSPACE) ? 0 : 1;
						}

						if (isValidValue(options.mask, val)) {
						    this.value = val;
						    setCaretPos(this, pos);
						} else if ($.trim(val) === '') {
						    this.value = options.mask.replace(/[0-9]/g, '_');
						} else {
						    input.trigger('error_input.xdsoft');
						}
					    } else {
						if (([AKEY, CKEY, VKEY, ZKEY, YKEY].indexOf(key) !== -1 && ctrlDown) || [ESC, ARROWUP, ARROWDOWN, ARROWLEFT, ARROWRIGHT, F5, CTRLKEY, TAB, ENTER].indexOf(key) !== -1) {
						    return true;
						}
					    }

					    event.preventDefault();
					    return false;
					  });
				}
			}

			_xdsoft_datetime.setCurrentTime(getCurrentValue());

			input
				.data('xdsoft_datetimepicker', datetimepicker)
				.on('open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart', function () {
					if (input.is(':disabled') || (input.data('xdsoft_datetimepicker').is(':visible') && options.closeOnInputClick)) {
						return;
					}
					if (!options.openOnFocus) {
						return;
					}
					clearTimeout(timer);
					timer = setTimeout(function () {
						if (input.is(':disabled')) {
							return;
						}

						triggerAfterOpen = true;
						_xdsoft_datetime.setCurrentTime(getCurrentValue(), true);
						if(options.mask) {
							setMask(options);
						}
						datetimepicker.trigger('open.xdsoft');
					}, 100);
				})
				.on('keydown.xdsoft', function (event) {
					var elementSelector,
						key = event.which;
					if ([ENTER].indexOf(key) !== -1 && options.enterLikeTab) {
						elementSelector = $("input:visible,textarea:visible,button:visible,a:visible");
						datetimepicker.trigger('close.xdsoft');
						elementSelector.eq(elementSelector.index(this) + 1).focus();
						return false;
					}
					if ([TAB].indexOf(key) !== -1) {
						datetimepicker.trigger('close.xdsoft');
						return true;
					}
				})
				.on('blur.xdsoft', function () {
					datetimepicker.trigger('close.xdsoft');
				});
		};
		destroyDateTimePicker = function (input) {
			var datetimepicker = input.data('xdsoft_datetimepicker');
			if (datetimepicker) {
				datetimepicker.data('xdsoft_datetime', null);
				datetimepicker.remove();
				input
					.data('xdsoft_datetimepicker', null)
					.off('.xdsoft');
				$(options.contentWindow).off('resize.xdsoft');
				$([options.contentWindow, options.ownerDocument.body]).off('mousedown.xdsoft touchstart');
				if (input.unmousewheel) {
					input.unmousewheel();
				}
			}
		};
		$(options.ownerDocument)
			.off('keydown.xdsoftctrl keyup.xdsoftctrl')
			.on('keydown.xdsoftctrl', function (e) {
				if (e.keyCode === CTRLKEY) {
					ctrlDown = true;
				}
			})
			.on('keyup.xdsoftctrl', function (e) {
				if (e.keyCode === CTRLKEY) {
					ctrlDown = false;
				}
			});

		this.each(function () {
			var datetimepicker = $(this).data('xdsoft_datetimepicker'), $input;
			if (datetimepicker) {
				if ($.type(opt) === 'string') {
					switch (opt) {
						case 'show':
							$(this).select().focus();
							datetimepicker.trigger('open.xdsoft');
							break;
						case 'hide':
							datetimepicker.trigger('close.xdsoft');
							break;
						case 'toggle':
							datetimepicker.trigger('toggle.xdsoft');
							break;
						case 'destroy':
							destroyDateTimePicker($(this));
							break;
						case 'reset':
							this.value = this.defaultValue;
							if (!this.value || !datetimepicker.data('xdsoft_datetime').isValidDate(dateHelper.parseDate(this.value, options.format))) {
								datetimepicker.data('changed', false);
							}
							datetimepicker.data('xdsoft_datetime').setCurrentTime(this.value);
							break;
						case 'validate':
							$input = datetimepicker.data('input');
							$input.trigger('blur.xdsoft');
							break;
						default:
							if (datetimepicker[opt] && $.isFunction(datetimepicker[opt])) {
								result = datetimepicker[opt](opt2);
							}
					}
				} else {
					datetimepicker
						.setOptions(opt);
				}
				return 0;
			}
			if ($.type(opt) !== 'string') {
				if (!options.lazyInit || options.open || options.inline) {
					createDateTimePicker($(this));
				} else {
					lazyInit($(this));
				}
			}
		});

		return result;
	};

	$.fn.datetimepicker.defaults = default_options;

	function HighlightedDate(date, desc, style) {
		"use strict";
		this.date = date;
		this.desc = desc;
		this.style = style;
	}
};
;(function (factory) {
	if ( typeof define === 'function' && define.amd ) {
		// AMD. Register as an anonymous module.
		define(['jquery', 'jquery-mousewheel'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS style for Browserify
		module.exports = factory(require('jquery'));;
	} else {
		// Browser globals
		factory(jQuery);
	}
}(datetimepickerFactory));



/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    // baConfigProvider.changeTheme({blur: true});
    
    // baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    // });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      // preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('mydata.agency').controller('agency.controller', AgencyController);

    function AgencyController($scope, $filter, toolsService, $state, $stateParams, Alertify, $uibModal, $localStorage, $uibModalStack) {

        $scope.smartTablePageSize = 10;
        $scope.agencySmartTableData = [];
        $scope.userSmartTableData = [];
        $scope.agency = {};

        //#region datepicker 
        $scope.popupDateFrom = {
            opened: false
        };
        $scope.openDateFrom = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.openStartDate = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.popupDateTo = {
            opened: false
        };
        $scope.openDateTo = function () {
            $scope.popupDateTo.opened = true;
        };
        $scope.openEndDate = function () {
            $scope.popupDateTo.opened = true;
        };
        //#endregion

        //#region load discount
        $scope.discountWithSearch = { selected: {} };
        $scope.loadDiscount = function () {
            $scope.discountWithSearch = { selected: {} };
            toolsService.ajaxGet('/discount/getDiscountList').then(function (data) {
                $scope.discountList = data.discountList;
            });
        };
        //#endregion

        //#region open menu
        $scope.newAgency = function () {
            $state.transitionTo('agency.create');
        };
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region agency list
        $scope.agencyFilter = function (tablestate, ctrl) {
            $scope.stCtrl = ctrl;
        }
        $scope.searchAgency = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                agencyName: this.agencyName || '',
                type: this.type || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxPost('/agency/search', request).then(function (data) {
                $scope.agencyData = data.agencyData;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'agency.search') {
            $scope.searchAgency();
        }
        $scope.selectAgencyPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                agencyName: this.agencyName || '',
                type: this.type || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxPost('/agency/search', request).then(function (data) {
                $scope.agencyData = data.agencyData;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region export agency list - excel
        $scope.exportAgencyExcel = function () {
            var request = {
                agencyName: this.agencyName || '',
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '1900-01-01',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '2100-12-31',
                type: this.type || null
            };
            toolsService.ajaxPostPdf('/agency/export', request).then(function (data) {
                var blob = new Blob(
                    [data],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }
                );
                saveAs(blob, 'Agency List.xlsx');
            });
        };
        //#endregion

        //#region agency user list
        $scope.userFilter = function (tablestate, ctrl) {
            $scope.stCtrl = ctrl;
        }
        $scope.manageAgencyUser = function (agencyId) {
            var request = {
                agencyId: agencyId || $stateParams.agencyId,
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/agency/getUserData', request).then(function (data) {
                $scope.userSmartTableData = data.userData;
                pagination(data.pagination)
            });
        }
        $scope.selectUserPage = function (page) {
            var request = {
                agencyId: $stateParams.agencyId,
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/agency/getUserData', request).then(function (data) {
                $scope.userSmartTableData = data.userData;
                pagination(data.pagination)
            });
        }
        //#endregion

        //#region agency detail
        $scope.manageAgency = function (agencyId) {
            var request = {
                agencyId: agencyId
            };
            toolsService.ajaxGet('/agency/getAgencyData', request).then(function (data) {
                $scope.agency = data.agencyData;
                $scope.discountWithSearch = { selected: data.agencyData.discountVal };
            });
        }
        if ($state.current.name == 'agency.manage') {
            $scope.manageAgency($stateParams.agencyId);
            $scope.manageAgencyUser($stateParams.agencyId);
        }
        //#endregion

        //#region agency update
        $scope.updateAgency = function () {
            var agencyName = null
            if (this.agency.agencyName){
                var agencyName = this.agency.agencyName.toUpperCase()
            }
            var request = {
                agencyId: this.agency.id,
                agencyName: agencyName,
                projectInd: this.agency.projectInd || null,
                type: this.agency.type || null,
                discId: this.discountWithSearch.selected.id || null
            };
            toolsService.ajaxPost('/agency/update', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully sssupdate data');
                    $state.transitionTo('agency.search');
                }
                else {
                    Alertify.error('Unsuccessful to update data');
                }
            });
        };
        //#endregion

        //#region agency create
        $scope.createAgency = function () {
            var agencyName = null
            if (this.agencyName){
                var agencyName = this.agencyName.toUpperCase()
            }
            var request = {
                agencyName: agencyName,
                type: this.type || null,
                projectInd: this.projectInd || null,
                discId: this.discountWithSearch.selected.id || null
            };
            toolsService.ajaxPost('/agency/create', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully create Agency/Firm.');
                    $state.transitionTo('agency.search');
                }
                else {
                    Alertify.error('Unsuccessful to create Agency/Firm.');
                }
            });
        };
        //#endregion
    
    }

})();

(function () {
    'use strict';

    angular.module('mydata.discount').controller('discount.controller', DiscountController);

    function DiscountController($scope, $filter, toolsService, $state, $stateParams, Alertify, $uibModal) {

        $scope.pageSize = 10;
        $scope.productList = [];
        $scope.newDiscountItem = [];

        //#region datepicker 
        $scope.popupDateFrom = {
            opened: false
        };
        $scope.openStartDate = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.popupDateTo = {
            opened: false
        };
        $scope.openEndDate = function () {
            $scope.popupDateTo.opened = true;
        };
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.pageSize = pagination.pageSize;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region product dropdown
        $scope.getProductList = function () {
            if ($scope.productList.length == 0){
                toolsService.ajaxGet('/discount/getProductList').then(function (data) {
                    $scope.productList = data.productList;
                });
            }
        }
        //#endregion

        //#region discount list
        $scope.searchDiscount = function (page) {
            var request = {
                searchText: this.searchText || '',
                sort: {},
                page: page || 1,
                itemPerPage: this.pageSize
            };
            toolsService.ajaxGet('/discount/search', request).then(function (data) {
                $scope.discountList = data.discountList;
                pagination(data.pagination)
            });
        }
        if ($state.current.name == 'discount.list') {
            $scope.searchDiscount(null);
        }
        //#endregion

        //#region discount detail
        $scope.viewDiscount = function (discId) {
            var request = {
                discId: discId
            };
            toolsService.ajaxGet('/discount/view', request).then(function (data) {
                $scope.discount = data.discount;
                if (data.discount.start_date){
                    $scope.discount.start_date = new Date(data.discount.start_date);
                }
                if (data.discount.end_date){
                    $scope.discount.end_date = new Date(data.discount.end_date);
                }
                $scope.discountItem = data.discountItem;
            });
        }
        if ($state.current.name == 'discount.detail') {
            $scope.getProductList();
            $scope.viewDiscount($stateParams.discId);
        }
        //#endregion

        //#region discount update
        $scope.updateDiscount = function (discItem) {
            var request = {
                discId: this.discount.id,
                code: this.discount.code,
                desc: this.discount.desc,
                active: this.discount.active,
                startDate: $filter('date')(this.discount.start_date,'yyyy-MM-dd 00:00:00') || null,
                endDate: $filter('date')(this.discount.end_date,'yyyy-MM-dd 23:59:59') || null,
                // discItem: discItem.filter(function(item){return item.active})
                discItem: discItem
            };
            // Alertify.success(request)
            toolsService.ajaxPost('/discount/update', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully update discount');
                    $state.transitionTo('discount.list');
                }
                else {
                    Alertify.error('Unsuccessful to update discount');
                }
            });
        };
        //#endregion

        //#region discount create
        // $scope.newDiscount = function () {
        //     toolsService.ajaxGet('/discount/getDiscountItem').then(function (data) {
        //         $scope.newDiscountItem = data.discountItem;
        //     });
        // }
        if ($state.current.name == 'discount.new') {
            // $scope.newDiscount();
            $scope.getProductList();
        }
        $scope.createDiscount = function (discItem) {
            var request = {
                code: this.code,
                desc: this.desc,
                active: this.active || false,
                startDate: $filter('date')(this.startDate,'yyyy-MM-dd 00:00:00') || null,
                endDate: $filter('date')(this.endDate,'yyyy-MM-dd 23:59:59') || null,
                // discItem: discItem.filter(function(item){return item.active})
                discItem: discItem
            };
            toolsService.ajaxPost('/discount/create', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully added new discount.');
                    $state.transitionTo('discount.list');
                }
                else {
                    Alertify.error('Unsuccessful to add new discount.');
                }
            });
        };
        //#endregion
    
        //#region initiate discount item value
        $scope.prepareDocumentItem = function () {
            if ($state.current.name == 'discount.new') {
                $scope.newDiscountItem.push({
                    product: null,
                    discType: 'A',
                    discValue: 0,
                    discCalc: 'A',
                    active: true
                });
            }
            if ($state.current.name == 'discount.detail') {
                $scope.discountItem.push({
                    product: null,
                    discType: 'A',
                    discValue: 0,
                    discCalc: 'A',
                    active: true
                });
            }
        };
        //#endregion

    }

})();

(function () {
    'use strict';

    angular.module('mydata.entity').controller('entity.controller', EntityController);

    function EntityController($scope, toolsService, $state, $stateParams, Alertify, $uibModal, $rootScope, $interval) {

        $scope.smartTablePageSize = 10;
        $scope.entityType = 'All Entities';
        $scope.entityname = '';
        $scope.documentData = [];
        $scope.entityCount = -1;
        $rootScope.proceedAddtoCart = false;

        //#region view sample
        $scope.openDocSample = function (type, lang, ctc, branch) {
            var items = {type:type, lang:lang, ctc:ctc, branch:branch};
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/doc-sample/openSampleDocument.html',
                controller: 'documentSampleCtrl',
                size: 'lg',
                resolve: {
                    items: function () {
                        return items;
                    }
                }
            });
        };
        //#endregion

         //#region brcl modal
         $scope.openBRCLModal = function (items) {
            var items = { 
                items: items,   
                entityNumber: $stateParams.entityNumber,
                entityType: $stateParams.entityType,
                entityName: $stateParams.entityName
            };
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/entity/brcl-modal.html',
                controller: 'BRCLModalController',
                size: 'md',
                resolve: {
                    items: function () {
                        return items;
                    }
                }
            });
        };
        //#endregion

        //#region search entity
        $scope.searchEntity = function () {
            if (this.entityInfo && this.entityInfo.length >= 3) {
                var request = {
                    entityInfo: this.entityInfo || '',
                    entityType: this.entityType || '',
                    sort: {},
                    page: 1,
                    itemPerPage: $scope.smartTablePageSize
                };
                toolsService.ajaxGet('/entity/entitySearch', request).then(function (data) {
                    $scope.entityCount = data.entityCount;
                    $scope.entityList = data.entityList;
                    if (data.message){
                        Alertify.error(data.message)
                    }
                });
            }
            else {
                $scope.entityCount = -1;
            }
        };
        //#endregion

        //#region save entity detail
        $scope.saveEntity = function (entity) {
            var request = {
                entity: entity
            }
            toolsService.ajaxPost('/entity/saveEntity', request).then(function (data) {
                if (data.success) {
                    if (request.entity.type == 'LLP')
                        $state.transitionTo('entity.llp', { entityNumber: data.entityNumber, entityType: data.entityType,  entityName: data.entityName });
                    else if (request.entity.type == 'Business')
                        $state.transitionTo('entity.rob', { entityNumber: data.entityNumber, entityType: data.entityType, entityName: data.entityName });
                    else
                        $state.transitionTo('entity.document', { entityNumber: data.entityNumber, entityType: data.entityType, entityName: data.entityName });
                }
                else {
                    Alertify.error('Unsuccessful to retrieve document for this entity');
                }
            });
        }
        //#endregion

        //#region display entity detail & available document
        $scope.loadEntityData = function (entityNumber) {
            var request = {
                entityNumber: entityNumber
            };
            toolsService.ajaxGet('/entity/getEntity', request).then(function (data) {
                $scope.entity = data.entity;
                $scope.docView = data.docView;
            });
        };
        if ($state.current.name == 'entity.document' || $state.current.name == 'entity.llp' || $state.current.name == 'entity.rob') {
            $scope.loadEntityData($stateParams.entityNumber);
        }
        //#endregion

        //#region reload document
        $scope.reloadDocument = function () {
            window.location.reload();
        };
        //#endregion

        //#region get profile document list
        $scope.getProfileDocList = function () {
            var request = {
                entityNumber: $stateParams.entityNumber,
                entityType: $stateParams.entityType,
                entityName: $stateParams.entityName
            };
            toolsService.ajaxGet('/entity/getProfileDocList', request).then(function (data) {
                $scope.profileDocSrc = data.profileDoc;
                if ($scope.profileDocSrc) {
                    $scope.profileDocSrc.forEach(function (item) {
                        $scope.checkDocProfileInCart(item.companyNo, item.type, item.ctc, item.lang);
                    });
                    var checkReq = {
                        entityNumber: $stateParams.entityNumber,
                        entityType: $stateParams.entityType,
                        entityName: $stateParams.entityName
                        // docList: data.profileDoc
                    };
                    toolsService.ajaxGet('/entity/checkProfileDoc', checkReq).then(function () { });
                }
                if (!data.success) {
                    Alertify.error('Oops. Let\'s reload again.');
                }
            });
        };
        if ($stateParams.entityType == 'Company' || $stateParams.entityType == 'Business' || $stateParams.entityType == 'LLP') {
            $scope.getProfileDocList();
            var count = 0;
            var auto = $interval(function () {
                var request = {
                    count: count
                }
                toolsService.ajaxGet('/entity/checkProfileDocResult', request).then(function (result) {
                    if ($scope.profileDocSrc){
                        $scope.profileDocSrc.forEach(function (item) {
                            if (item.type == 'Certificate Of Change Of Name' && result.isNameChanged != 'check') {
                                item.available = result.isNameChanged;
                            }
                            if (item.type == 'Certificate Of Conversion' && result.isConverted != 'check') {
                                item.available = result.isConverted;
                            }
                            if (item.type == 'Financial Historical Comparison' && result.hasFinancialYears != 'check') {
                                item.available = result.hasFinancialYears;
                                if (result.hasFinancialYears == 'yes') {
                                    $scope.financialYearList = result.financialYearList;
                                    $scope.financialYear1.selected = result.financialYearList[0];
                                    $scope.financialYear2.selected = result.financialYearList[result.financialYearList.length - 1];
                                }
                            }
                            if (item.type == 'Company Charges' && result.hasCharges != 'check') {
                                item.available = result.hasCharges;
                            }
                            if (item.type == 'Business Expiry Confirmation Letter' && result.isTerminated != 'check') {
                                item.available = result.isTerminated;
                            }
                            if (item.type == 'Attestation of Company Good Standing' && result.hasACGS != 'check') {
                                item.available = result.hasACGS;
                            }
                            if (item.type == 'Financial Comparison 2 Years' && result.hasFinancial2Years != 'check') {
                                item.available = result.hasFinancial2Years;
                            }
                            if (item.type == 'Financial Comparison 3 Years' && result.hasFinancial3Years != 'check') {
                                item.available = result.hasFinancial3Years;
                            }
                            if (item.type == 'Financial Comparison 5 Years' && result.hasFinancial5Years != 'check') {
                                item.available = result.hasFinancial5Years;
                            }
                            if (item.type == 'Financial Comparison 10 Years' && result.hasFinancial10Years != 'check') {
                                item.available = result.hasFinancial10Years;
                            }
                            if (item.type == 'Particular Of Change Of Company Name' && result.isNameChanged != 'check') {
                                item.available = result.isNameChanged;
                            }
                            if (item.type == 'Shareholder Listing And Analysis' && result.isCLBG != 'check') {
                                item.available = result.isCLBG;
                            }
                            if (item.type == 'Business Re-Register Confirmation Letter' && result.isBRCLE != 'check') {
                                item.available = result.isBRCLE;
                            }
                            if (item.type == 'LLP Certificate Of Change Of Name' && result.isNameChanged != 'check') {
                                item.available = result.isNameChanged;
                            }
                            // if (item.type == 'LLP Certification Of Conversion' && result.isConverted != 'check') {
                            //     item.available = result.isConverted;
                            // }
                            if (item.type == 'LLP Certificate Of Registration' && result.isConverted != 'check') {
                                if (result.isConverted == 'retry'){
                                    item.available = result.isConverted;
                                }
                                else {
                                    // hardcode to yes, defer on isConverted
                                    item.available = 'yes';
                                    if (result.isConverted == 'yes'){
                                        $rootScope.isLLPConverted = true;
                                    }
                                    else {
                                        $rootScope.isLLPConverted = false;
                                    }
                                }
                                
                            }
                            if (item.type == 'Attestation of LLP Good Standing' && result.hasACGS != 'check') {
                                item.available = result.hasACGS;
                            }
                        });
                    }
                    if (result.stopRefresh || count == 15) {
                        $interval.cancel(auto)
                        auto = 0;
                    }
                });
                count++;
            }, 5000);
        }
        //#endregion

        //#region get financial year comparison list
        $scope.financialYear1 = { selected: {} };
        $scope.loadFinancialYear1 = function () {
            $scope.financialYear1List = JSON.parse(JSON.stringify($scope.financialYearList));
            $scope.financialYear1List.forEach(function (item, index) {
                if ($scope.financialYear2) {
                    if (item.financialYear == $scope.financialYear2.selected.financialYear) {
                        $scope.financialYear1List.splice(index, 1);
                    }
                }
            });
        };
        $scope.financialYear2 = { selected: {} };
        $scope.loadFinancialYear2 = function () {
            $scope.financialYear2List = JSON.parse(JSON.stringify($scope.financialYearList));
            $scope.financialYear2List.forEach(function (item, index) {
                if ($scope.financialYear2) {
                    if (item.financialYear == $scope.financialYear1.selected.financialYear) {
                        $scope.financialYear2List.splice(index, 1);
                    }
                }
            });
        };
        //#endregion

        //#region get document image list
        $scope.enableView = function () {
            $scope.docView.enable = true;
            $scope.getDocImageList();
        };
        $scope.getDocImageList = function () {
            if (!$scope.imageDocSrc) {
                var request = {
                    entityNumber: $stateParams.entityNumber,
                    entityType: $stateParams.entityType
                };
                toolsService.ajaxGet('/entity/getDocImageList', request).then(function (data) {
                    $scope.imageDocCount = data.imageDocCount;
                    $scope.imageDocSrc = data.imageDoc;
                    $scope.imageDocResult = data.imageDocResult;
                    // if ($scope.imageDocSrc) {
                    //     $scope.imageDocSrc.forEach(function (item) {
                    //         $scope.checkDocImageInCart(item.companyNo, item.type, item.ctc, item.lang, item.verId);
                    //     });
                    // }
                    if (!data.success) {
                        Alertify.error('Oops. Let\'s reload again.');
                        // Alertify.error('Document & Form Images is currently not available.');
                    }
                });
            }
        };
        //#endregion

        //#region get business certificate list
        $scope.getBizCertList = function () {
            if (!$scope.robCertDocSrc) {
                var request = {
                    entityNumber: $stateParams.entityNumber,
                    entityType: $stateParams.entityType
                };
                toolsService.ajaxGet('/entity/getBizCertList', request).then(function (data) {
                    $scope.robCertDocCount = data.robCertDocCount;
                    $scope.robCertDocSrc = data.robCertDoc;
                    $scope.robCertResult = data.robCertResult;
                    // if ($scope.robCertDocSrc) {
                    //     $scope.robCertDocSrc.forEach(function (item) {
                    //         $scope.checkCertInCart(item.companyNo, item.type, item.ctc, item.lang, item.branchId);
                    //     });
                    // }
                    if (!data.success) {
                        // Alertify.error('Business Certificates is currently not available.');
                        Alertify.error('Oops. Let\'s reload again.');
                    }
                });
            }
        };
        //#endregion

        //#region get audit firm profile list
        $scope.getAuditFirmDocList = function () {
            var request = {
                entityNumber: $stateParams.entityNumber,
                entityType: $stateParams.entityType
            };
            toolsService.ajaxGet('/entity/getAuditFirmDocList', request).then(function (data) {
                $scope.auditFirmDocSrc = data.auditFirmDoc
                if ($scope.auditFirmDocSrc) {
                    $scope.auditFirmDocSrc.forEach(function (item) {
                        $scope.checkAuditFirmInCart(item.companyNo, item.type, item.ctc, item.lang);
                    })
                }
                if (!data.success) {
                    Alertify.error('Oops. Let\'s reload again.');
                }
            });
        };
        if ($stateParams.entityType == 'Audit Firm') {
            $scope.getAuditFirmDocList()
        }
        //#endregion

        //#region add to cart
        $scope.addToCart = function (item) {
            console.log(item[0].type);
            var request = {
                entityName: this.entity.entity_name,
                entityType: this.entity.entity_type,
                entityNumber: this.entity.entity_no,
                newEntityNumber: this.entity.new_entity_no,
                documentLang: this.item && this.item.lang || 'EN',
                documentCtc: this.item && this.item.ctc || false,
                documentData: item,
                financialYearEndDate1: this.financialYear1.selected.financialYearEndDate,
                financialYearEndDate2: this.financialYear2.selected.financialYearEndDate,
                newRegNo: null,
                oldRegNo: null
            };
            if(item[0].type == 'Financial Comparison 2 Years'){
                request.financialYearEndDate1 = $scope.financialYearList[$scope.financialYearList.length - 2].financialYearEndDate;
                request.financialYearEndDate2 = $scope.financialYearList[$scope.financialYearList.length - 1].financialYearEndDate;
            }else if(item[0].type == 'Financial Comparison 3 Years'){
                request.financialYearEndDate1 = $scope.financialYearList[$scope.financialYearList.length - 3].financialYearEndDate;
                request.financialYearEndDate2 = $scope.financialYearList[$scope.financialYearList.length - 1].financialYearEndDate;
            }else if(item[0].type == 'Financial Comparison 5 Years'){
                request.financialYearEndDate1 = $scope.financialYearList[$scope.financialYearList.length - 5].financialYearEndDate;
                request.financialYearEndDate2 = $scope.financialYearList[$scope.financialYearList.length - 1].financialYearEndDate;
            }else if(item[0].type == 'Financial Comparison 10 Years'){
                request.financialYearEndDate1 = $scope.financialYearList[$scope.financialYearList.length - 10].financialYearEndDate;
                request.financialYearEndDate2 = $scope.financialYearList[$scope.financialYearList.length - 1].financialYearEndDate;
            }else if(item[0].type == 'Business Re-Register Confirmation Letter'){
                request.oldRegNo = $rootScope.oldregno;
                request.newRegNo = $rootScope.newregno;
            }else if(item[0].type == 'LLP Certificate Of Registration'){
                request.isLLPConverted = $rootScope.isLLPConverted;
            }
            toolsService.ajaxPost('/entity/addToCart', request).then(function () {
                if (item[0].type == 'Business Profile' || 
                    item[0].type == 'Business Re-Register Confirmation Letter' ||
                    item[0].type == 'Business Expiry Confirmation Letter' || 
                    item[0].type == 'Company Profile' ||
                    item[0].type == 'LLP Profile' || 
                    item[0].type == 'LLP Certificate Of Registration' ||
                    item[0].type == 'LLP Certificate Of Change Of Name' ||
                    item[0].type == 'LLP Certification Of Conversion' || 
                    item[0].type == 'Attestation of LLP Good Standing' ||
                    item[0].type == 'Particular Of Registered Address' || 
                    item[0].type == 'Certificate Of Incorporation/Registration' ||
                    item[0].type == 'Particular Of Directors/Officers' || 
                    item[0].type == 'Certificate Of Change Of Name' ||
                    item[0].type == 'Certificate Of Conversion' || 
                    item[0].type == 'Particular Of Shareholders' || 
                    item[0].type == 'Company Charges' ||
                    item[0].type == 'Particular Of Company Secretary'|| 
                    item[0].type == 'Particular Of Share Capital' ||
                    item[0].type == 'Attestation of Company Good Standing' ||
                    item[0].type == 'Financial Historical Comparison' ||
                    item[0].type == 'Financial Comparison 2 Years' ||
                    item[0].type == 'Financial Comparison 3 Years' ||
                    item[0].type == 'Financial Comparison 5 Years' ||
                    item[0].type == 'Financial Comparison 10 Years' ||
                    item[0].type == 'Shareholder Listing And Analysis' ||
                    item[0].type == 'Particular Of Change Of Company Name') {

                    if ($scope.profileDocSrc){
                        $scope.profileDocSrc.forEach(function (doc) {
                            if (doc.type == item[0].type) {
                                doc.inCart = true;
                            }
                        });
                    }
                }
                if (item[0].type == 'Business Certificates') {
                    if ($scope.robCertDocSrc){
                        $scope.robCertDocSrc.forEach(function (doc) {
                            if (doc.branchId == item[0].branchId) {
                                doc.inCart = true;
                            }
                        });
                    }
                }
                if (item[0].type == 'Document & Form Download' || item[0].type == 'LLP Document & Form Download' || item[0].type == 'ROB Form Image Download') {
                    if ($scope.imageDocSrc){
                        $scope.imageDocSrc.forEach(function (doc) {
                            if (doc.verId == item[0].verId) {
                                doc.inCart = true;
                            }
                        });
                    }
                }
                if (item[0].type == 'Audit Firm Profile') {
                    if ($scope.auditFirmDocSrc){
                        $scope.auditFirmDocSrc.forEach(function (doc) {
                            if (doc.type == item[0].type) {
                                doc.inCart = true;
                            }
                        });
                    }
                }
            });
        };
        //#endregion

        //#region view in cart
        $scope.viewCart = function (item) {
            $state.transitionTo('document.request');
        };
        //#endregion

        //#region check profile document in cart
        $scope.checkDocProfileInCart = function (entityNo, type, ctc, lang) {
            var request = {
                entityNo: entityNo,
                type: type,
                ctc: ctc,
                lang: lang
            };
            toolsService.ajaxGet('/entity/checkDocProfileInCart', request).then(function (data) {
                if (data.existInCart) {
                    $scope.profileDocSrc.forEach(function (item) {
                        if (item.type == type) {
                            item.ctc = ctc;
                            item.lang = lang;
                            item.inCart = true;
                        }
                    });
                }
                else {
                    $scope.profileDocSrc.forEach(function (item) {
                        if (item.type == type) {
                            item.ctc = ctc;
                            item.lang = lang;
                            item.inCart = false;
                        }
                    });
                }
            });
        };
        //#endregion

        //#region check financial comparison in cart
        $scope.checkDocFinancialInCart = function (entityNo, type, ctc, lang, endDate1, endDate2) {
            var request = {
                entityNo: entityNo,
                type: type,
                ctc: ctc,
                lang: lang,
                endDate1: endDate1.financialYearEndDate,
                endDate2: endDate2.financialYearEndDate
            };
            toolsService.ajaxGet('/entity/checkDocFinancialInCart', request).then(function (data) {
                if (data.existInCart) {
                    $scope.profileDocSrc.forEach(function (item) {
                        if (item.type == type) {
                            item.ctc = ctc;
                            item.lang = lang;
                            item.inCart = true;
                        }
                    });
                }
                else {
                    $scope.profileDocSrc.forEach(function (item) {
                        if (item.type == type) {
                            item.ctc = ctc;
                            item.lang = lang;
                            item.inCart = false;
                        }
                    });
                }
            });
        };
        //#endregion

        //#region check business certificate in cart
        $scope.checkCertInCart = function (entityNo, type, ctc, lang, branchId) {
            var request = {
                entityNo: entityNo,
                type: type,
                ctc: ctc,
                lang: lang,
                branchId: branchId
            };
            toolsService.ajaxGet('/entity/checkCertInCart', request).then(function (data) {
                if (data.existInCart) {
                    if ($scope.robCertDocSrc){
                        $scope.robCertDocSrc.forEach(function (item) {
                            if (item.branchId == branchId) {
                                item.ctc = ctc;
                                item.lang = lang;
                                item.inCart = true;
                            }
                        });
                    }
                }
                else {
                    if ($scope.robCertDocSrc){
                        $scope.robCertDocSrc.forEach(function (item) {
                            if (item.branchId == branchId) {
                                item.ctc = ctc;
                                item.lang = lang;
                                item.inCart = false;
                            }
                        });
                    }
                }
            });
        };
        //#endregion

        //#region check document image in cart
        $scope.checkDocImageInCart = function (entityNo, type, ctc, lang, verId) {
            var request = {
                entityNo: entityNo,
                type: type,
                ctc: ctc,
                lang: lang,
                verId: verId
            };
            toolsService.ajaxGet('/entity/checkDocImageInCart', request).then(function (data) {
                if (data.existInCart) {
                    if ($scope.imageDocSrc){
                        $scope.imageDocSrc.forEach(function (item) {
                            if (item.verId == verId) {
                                item.ctc = ctc;
                                item.inCart = true;
                            }
                        });
                    }
                }
                else {
                    if ($scope.imageDocSrc){
                        $scope.imageDocSrc.forEach(function (item) {
                            if (item.verId == verId) {
                                item.ctc = ctc;
                                item.inCart = false;
                            }
                        });
                    }
                }
            });
        };
        //#endregion

        //#region check audit firm profile in cart
        $scope.checkAuditFirmInCart = function (entityNo, type, ctc, lang) {
            var request = {
                entityNo: entityNo,
                type: type,
                ctc: ctc,
                lang: lang
            };
            toolsService.ajaxGet('/entity/checkAuditFirmInCart', request).then(function (data) {
                if (data.existInCart) {
                    $scope.auditFirmDocSrc.forEach(function (item) {
                        if (item.type == type) {
                            item.ctc = ctc;
                            item.lang = lang;
                            item.inCart = true;
                        }
                    });
                }
                else {
                    $scope.auditFirmDocSrc.forEach(function (item) {
                        if (item.type == type) {
                            item.ctc = ctc;
                            item.lang = lang;
                            item.inCart = false;
                        }
                    });
                }
            });
        };
        //#endregion

    }

    angular.module('mydata.entity').controller('documentSampleCtrl', DocumentSampleCtrl);
    function DocumentSampleCtrl($scope, items) {
        $scope.type = items.type;
        $scope.lang = items.lang;
        $scope.ctc = items.ctc;
        $scope.branch = items.branch;
    }

    angular.module('mydata.entity').controller('BRCLModalController', ['$scope', '$rootScope', 'toolsService', 'items', function($scope, $rootScope, toolsService, items) {
        // Initialize scope variables with data from items
        $scope.type = items.type;
        $scope.lang = items.lang;
        $scope.ctc = items.ctc;
        $scope.branch = items.branch;
        $scope.proceed = false;
        $scope.proceedAddtoCart = false;
        $scope.erroralert = false;
        $rootScope.oldregno = null;
        $rootScope.newregno = null;

        //Check Old and New BR No 
        $scope.getCheckReregister = function () {
            if ($scope.oldBrNo && $scope.newBrNo) {
                var checkOldReq = { entityNo: $scope.oldBrNo };
                toolsService.ajaxGet('/entity/searchEntityReregister', checkOldReq).then(function (data) {
                    if (data.successCode == '00') {
                        var checkNewReq = { entityNo: $scope.newBrNo };
                        toolsService.ajaxGet('/entity/searchEntityReregister', checkNewReq).then(function (result) {
                            console.log("result1 :", result);
                            if (result.successCode == '00') {
                                $scope.oldBrName = data.entityInfos.name;
                                $scope.newBrName = result.entityInfos.name;
                                if ($scope.oldBrNo == data.entityInfos.entityid && items.entityName == data.entityInfos.name &&
                                    $scope.newBrNo == result.entityInfos.entityid && items.entityName == result.entityInfos.name) {
                                    //Check Status Reregisteration
                                    var request = {
                                        NewBrNo: $scope.newBrNo,
                                        OldBrNo: $scope.oldBrNo
                                    };
                                    console.log('Request Check Status Reregisteration :', request);
                                    toolsService.ajaxPost('/entity/entityReregisterStatus', request).then(function (reregisterdata) {
                                        if (reregisterdata.successCode == '00') {
                                            if (reregisterdata.sameBusinessNo == true && reregisterdata.status == true) {
                                                $rootScope.oldregno = data.entityInfos.newformatregno + "," + data.entityInfos.entityid + "-" + data.entityInfos.checkdigit;
                                                $rootScope.newregno = result.entityInfos.newformatregno + "," + result.entityInfos.entityid + "-" + result.entityInfos.checkdigit;
                                                $scope.proceed = true;
                                                $scope.erroralert = false;
                                                $rootScope.proceedAddtoCart = true;
                                                console.log('success');
                                            } else {
                                                $scope.erroralert = true;
                                                console.log('Oops. sameBusinessNo/status is false');
                                            }
                                        } else {
                                            $scope.erroralert = true;
                                            console.log('Oops. /entity/entityReregisterStatus not success');
                                        }
                                    });
                                } else {
                                    $scope.erroralert = true;
                                    console.log("sorry, can't proceed submit.");
                                }
                            } else {
                                $scope.erroralert = true;
                                console.log('Oops. invalid NewbrNo.');
                            }
                        });
                    } else {
                        $scope.erroralert = true;
                        console.log('Oops. invalid oldBrNo.');
                    }
                });
            } else {
                $scope.erroralert = true;
                console.log("Oops. invalid oldBrNo or newBrNo");
            }
        };
    }]);
})();

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd !== null)) {
  define("FileSaver.js", function() {
    return saveAs;
  });
}

/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('mydata.document')
        .controller('newDatePickerPopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function openDatepicker() {
            $scope.opened = true;
        }
    }
})();

(function () {
    'use strict';

    angular.module('mydata.document').controller('order.controller', OrderController);

    function OrderController($scope, toolsService, $state, $rootScope, $filter, $uibModal, Alertify, $interval, $stateParams) {

        $scope.smartTablePageSize = 10;
        $scope.docTableData = [];
        $scope.stOrderSummaryData = [];
        $scope.docDownloadTableData = [];
        $scope.summaryOrderCriteria = {};
        $scope.userOrderCriteria = {};
        $scope.agencyOrderCriteria = {};
        $scope.allOrderCriteria = {};
        $scope.agreePI = false;
        var interval;

        //#region datepicker 
        $scope.popupDateFrom = {
            opened: false
        };
        $scope.openDateFrom = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.popupDateTo = {
            opened: false
        };
        $scope.openDateTo = function () {
            $scope.popupDateTo.opened = true;
        };
        //#endregion

        //#region load agency user
        $scope.agencyUserWithSearch = { selected: {} };
        $scope.loadAgencyUser = function () {
            toolsService.ajaxGet('/report/getAllAgencyUser').then(function (data) {
                $scope.userOption = data.options;
            });
        };
        //#endregion

        //#region load agency
        $scope.agencyWithSearch = { selected: {} };
        $scope.loadAgency = function () {
            $scope.userWithSearch = { selected: {} };
            toolsService.ajaxGet('/report/getUserAgency').then(function (data) {
                $scope.agencyOption = data.options;
            });
        };
        //#endregion

        //#region load user
        $scope.userWithSearch = { selected: {} };
        $scope.loadUser = function () {
            var request = {}
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/report/getAllUser', request).then(function (data) {
                $scope.userOption = data.options;
            });
        };
        //#endregion

        //#region load product type
        $scope.docTypeWithSearch = { selected: {} };
        $scope.loadDocType = function () {
            toolsService.ajaxGet('/document/getDocumentType').then(function (data) {
                $scope.docType = data.options;
            });
        };
        //#endregion

        //#region load project list
        $scope.projectWithSearch = { selected: {} };
        $scope.loadProjectList = function () {
            toolsService.ajaxGet('/project/getProjectList').then(function (data) {
                $scope.projectList = data.projectList;
            });
        };
        $scope.loadProjectList();
        //#endregion

        //#region load project agency list
        $scope.projectAgencyWithSearch = { selected: {} };
        $scope.loadProjectAgencyList = function () {
            toolsService.ajaxGet('/project/getProjectAgencyList').then(function (data) {
                $scope.projectAgencyList = data.projectAgencyList;
            });
        };
        //#endregion

        //#region load project all list
        $scope.projectAllWithSearch = { selected: {} };
        $scope.loadProjectAllList = function () {
            toolsService.ajaxGet('/project/getProjectAllList').then(function (data) {
                $scope.projectAllList = data.projectAllList;
            });
        };
        //#endregion

        //#region onchange agree pi
        $scope.onchangeAgreePI = function (checked) {
            if (checked){
                $scope.agreePI = true;
            }
            else {
                $scope.agreePI = false;
            }
        }
        //#endregion

        //#region check checkout
        $scope.openCheckoutPIModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/document/checkout-pi.modal.html',
                size: 'md',
                backdrop: 'static',
            });
        }
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            $scope.rowCount = pagination.rowCount;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region cart list
        $scope.docPipe = function (tableState, ctrl) {
            $scope.docCtrl = ctrl;
        }
        $scope.docList = function () {
            var req = {
                sort: {},
                page: 1,
                itemPerPage: $scope.smartTablePageSize
            };
            toolsService.ajaxPost('/document/checkDocViewInCart', req).then(function(){
                toolsService.ajaxPost('/document/checkDuplicateDocInCart', req).then(function(result){
                    $scope.docTableData = result.data;
                    $scope.untaxedAmount = result.totalCart;
                    $scope.taxAmount = result.totalTax;
                    $scope.totalAmount = result.totalAmount;
                    $scope.orderCount = result.orderCount;
                    $scope.creditBalance = result.creditBalance;
                    $scope.isPI = result.isPI;
                    pagination(result.pagination)
                });
            });
        };
        if ($state.current.name == 'document.request') {
            $scope.docList();
            // setTimeout(function(){
            //     $scope.docList()
            // },1000);
        }
        $scope.selectDocPage = function (page) {
            var request = {
                sort: {},
                page: page,
                itemPerPage: $scope.smartTablePageSize
            };
            toolsService.ajaxPost('/document/checkDuplicateDocInCart', request).then(function (result) {
                $scope.docTableData = result.data;
                pagination(result.pagination)
                // toolsService.ajaxGet('/document/documentList', request).then(function (data) {
                //     $scope.docTableData = data.data;
                //     pagination(data.pagination)
                // });
            })
        };
        //#endregion

        //#region checkout list
        $scope.checkoutPipe = function (tablestate, ctrl) {
            $scope.docCtrl = ctrl;
        }
        $scope.searchCheckout = function () {
            var req = {
                sort: {},
                page: 1,
                itemPerPage: $scope.smartTablePageSize
            };
            toolsService.ajaxPost('/document/checkDocViewInCart', req).then(function(){
                toolsService.ajaxPost('/document/checkDuplicateDocInCheckout', req).then(function(data){
                    $scope.checkoutData = data.checkoutData;
                    $scope.untaxedAmount = data.untaxedAmount;
                    $scope.taxAmount = data.taxAmount;
                    $scope.totalAmount = data.totalAmount;
                    $scope.itemCount = data.itemCount;
                    // $scope.billingData = data.billingData;
                    $scope.billingData = {
                        fullName: '',
                        address1: '',
                        address2: '',
                        address3: '',
                        postcode: '',
                        city: '',
                        state: '',
                    };
                    $scope.mandatoryProject = data.mandatoryProject;
                    $scope.isPI = data.isPI;
                    $scope.paymentMethod = {option:'onlineBank'};
                    pagination(data.pagination)
                    //#region payment response
                    if ($stateParams.trxId){
                        var request = {
                            trxId: $stateParams.trxId
                        }
                        toolsService.ajaxPost('/document/processCheckoutPayment', request).then(function (result) {
                            if (result.success){
                                var items = {trxId:$stateParams.trxId}
                                $uibModal.open({
                                    animation: true,
                                    templateUrl: 'app/pages/document/payment-confirmation.modal.html',
                                    controller: 'paymentConfirmationCtrl',
                                    size: 'md',
                                    backdrop: 'static',
                                    resolve: {
                                        items: function () {
                                            return items;
                                        }
                                    }
                                });
                                $stateParams.trxId = ''
                                $state.transitionTo('document.checkout')
                            }
                            if (result.invSuccess){
                                $state.transitionTo('document.summary', {transId:$stateParams.trxId});
                            }
                        })
                    }
                    //#endregion
                });
            });
        }
        if ($state.current.name == 'document.checkout') {
            $scope.searchCheckout();
        }
        $scope.selectCheckoutPage = function (page) {
            var request = {
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxPost('/document/checkDuplicateDocInCheckout', request).then(function(data){
                $scope.checkoutData = data.checkoutData;
                pagination(data.pagination);
            });
        };
        //#endregion

        //#region refresh order every 10 seconds
        // retry 30 seconds
        $scope.startOrderInterval = function (refresh, orderIds) {
            // stops any running interval to avoid two intervals running at the same time
            $scope.stopOrderInterval();
            if (refresh){
                interval = $interval(function () {
                    toolsService.ajaxGet('/document/checkOrderStatus', {orderIds:orderIds}).then(function (result) {
                        var refreshData = true;
                        if (!result.refresh){
                            refreshData = false;
                        }
                        $scope.stopOrderInterval();
                        if ($state.current.name == 'document.download') {
                            $scope.searchDocument(
                                refreshData,
                                $scope.userOrderCriteria.dateFrom,
                                $scope.userOrderCriteria.dateTo,
                                $scope.userOrderCriteria.orderRef,
                                $scope.userOrderCriteria.trxRef,
                                $scope.userOrderCriteria.page
                            );
                        }
                        else if ($state.current.name == 'document.summary') {
                            $scope.loadOrderSummary(refreshData, $scope.summaryOrderCriteria.page);
                        }
                        else if ($state.current.name == 'document.order') {
                            $scope.agencyUserOrderSearch(
                                refreshData,
                                $scope.agencyOrderCriteria.dateFrom,
                                $scope.agencyOrderCriteria.dateTo,
                                $scope.agencyOrderCriteria.orderRef,
                                $scope.agencyOrderCriteria.trxRef,
                                $scope.agencyOrderCriteria.page
                            )
                        }
                        else if ($state.current.name == 'document.all') {
                            if ($rootScope.currentUser.userId == 1){
                                Alertify.success('FETCH ORDER ALL');
                            }
                            $scope.searchAllOrder(
                                refreshData,
                                $scope.allOrderCriteria.dateFrom,
                                $scope.allOrderCriteria.dateTo,
                                $scope.allOrderCriteria.orderStatus,
                                $scope.allOrderCriteria.entityRef,
                                $scope.allOrderCriteria.orderRef,
                                $scope.allOrderCriteria.trxRef,
                                $scope.allOrderCriteria.page
                            )
                        }
                        else{
                            $scope.startOrderInterval(refreshData, []);
                        }

                    });
                }, 10000);
            }
        };
        // stop user interval
        $scope.stopOrderInterval = function() {
            $interval.cancel(interval);
        };
        //#endregion

        //#region order summary
        $scope.stOrderSummaryFilter = function (tablestate, ctrl) {
            $scope.docCtrl = ctrl;
        }
        $scope.loadOrderSummary = function (refresh, page) {
            var request = {
                sort: {},
                page: page || 1,
                itemPerPage: this.smartTablePageSize
            };
            $scope.summaryOrderCriteria = request
            toolsService.ajaxGet('/document/getOrderSummary', request).then(function (data) {
                $scope.stOrderSummaryData = data.data;
                $scope.trxSummaryData = data.trxData;
                pagination(data.pagination);
                $scope.startOrderInterval(refresh, data.orderIds);
                if ($stateParams.transId){
                    var request = {
                        trxId: $stateParams.transId
                    }
                    toolsService.ajaxPost('/document/checkPaymentConfirmation', request).then(function (result) {
                        if (result.success){
                            var req = {
                                invoiceNumber: result.invoiceNo,
                                processDate: result.trxDate,
                                trxId: result.trxId,
                                userId: result.userId
                            };
                            toolsService.ajaxPost('/process/processCheckoutItem', req).then(function () {
                                var items = {trxId:$stateParams.transId}
                                $uibModal.open({
                                    animation: true,
                                    templateUrl: 'app/pages/document/payment-confirmation.modal.html',
                                    controller: 'paymentConfirmationCtrl',
                                    size: 'md',
                                    backdrop: 'static',
                                    resolve: {
                                        items: function () {
                                            return items;
                                        }
                                    }
                                });
                                $stateParams.transId = ''
                                $state.transitionTo('document.summary')
                            })
                        }
                    })
                }
            });
        };
        if ($state.current.name == 'document.summary') {
            $scope.loadOrderSummary(true, null);
        }
        //#endregion

        //#region order list - normal user
        $scope.docDownloadFilter = function (tableState, ctrl) {
            $scope.docCtrl = ctrl;
        };
        $scope.searchDocument = function (refresh, dateFrom, dateTo, orderRef, trxRef, page) {
            var request = {
                dateFrom: dateFrom || $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: dateTo || $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: orderRef || this.orderRef || '',
                trxRef: trxRef || this.trxRef || '',
                sort: {},
                page: page || 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.docTypeWithSearch) {
                request.docType = this.docTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.docTypeWithSearch.selected.ctc;
            }
            $scope.userOrderCriteria = request
            toolsService.ajaxPost('/document/documentSearch', request).then(function (data) {
                $scope.docDownloadTableData = data.data;
                pagination(data.pagination)
                // retry 30 seconds
                $scope.startOrderInterval(refresh, data.orderIds);
            });
        };
        if ($state.current.name == 'document.download') {
            // $scope.loadProjectAgencyList();
            $scope.searchDocument(true,null,null,null,null,null);
        }
        //#endregion

        //#region remove cart item
        $scope.removeItemModal = function (itemIndex, itemId, itemEntityNo, itemType, itemEntityType) {
            console.log(itemIndex, itemId, itemEntityNo, itemType, itemEntityType)
            $scope.items = {
                itemCartIndex: itemIndex,
                itemCartId: itemId,
                itemCartEntityNo: itemEntityNo,
                itemCartType: itemType,
                itemCartEntityType: itemEntityType
            };
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/document/cart-remove.modal.html',
                controller: 'itemRemoveModalCtrl',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    items: function () {
                        return $scope.items;
                    }
                }
            });
        };
        $scope.removeItem = function (itemIndex, itemId, entityNo, itemType, entityType) {
            var request = {
                id: itemId,
                entityNo: entityNo,
                type: itemType,
                entityType: entityType
            };
            toolsService.ajaxPost('/document/removeDocument', request).then(function () {
                location.reload();
            });
        };
        //#endregion

        //#region empty cart
        $scope.emptyCartModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/document/cart-empty.modal.html',
                size: 'sm',
                backdrop: 'static'
            });
        };
        $scope.removeAllItem = function () {
            toolsService.ajaxPost('/document/removeAllItem').then(function (data) {
                location.reload();
            });
        };
        //#endregion

        //#region check project
        $scope.checkMandatoryProject = function () {
            if (this.mandatoryProject){
                if (this.projectWithSearch.selected.id){
                    $scope.mandatoryProjectErr = ''
                }
            }
            else{
                $scope.mandatoryProjectErr = ''
            }
        }
        //#endregion

        //#region check checkout
        $scope.checkCheckout = function () {
            if (this.mandatoryProject){
                if (this.projectWithSearch.selected.id){
                    // proceed
                    confirmCheckout(this.paymentMethod,this.untaxedAmount,this.taxAmount,this.totalAmount,this.projectWithSearch,this.billingData)
                }
                else{
                    // prompt error
                    $scope.mandatoryProjectErr = 'Please select Purpose of Purchase.'
                }
            }
            else{
                // proceed
                confirmCheckout(this.paymentMethod,this.untaxedAmount,this.taxAmount,this.totalAmount,this.projectWithSearch,this.billingData)
            }
        }
        //#endregion

        //#region confirm checkout
        function confirmCheckout(paymentMethod,untaxedAmount,taxAmount,totalAmount,projectWithSearch,billingData){
            if (paymentMethod.option == 'userCredit'){
                var paymentItems = {
                    paymentMethod: 'User Credit',
                    untaxedAmount: untaxedAmount,
                    taxAmount: taxAmount,
                    totalAmount: totalAmount,
                    projectId: projectWithSearch.selected.id || null,
                    billing: billingData
                };
                if (totalAmount <= billingData.creditBalance){
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/document/checkout-process.modal.html',
                        controller: 'processCheckoutCtrl',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            paymentItems: function () {
                                return paymentItems;
                            }
                        }
                    });
                }
                else {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/document/checkout-insufficient-credit.modal.html',
                        controller: 'processCheckoutCtrl',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            paymentItems: function () {
                                return paymentItems;
                            }
                        }
                    });
                }
            }
            else{
                var request = {
                    untaxedAmount: untaxedAmount,
                    taxAmount: taxAmount,
                    totalAmount: totalAmount,
                    projectId: projectWithSearch.selected.id || null,
                    billing: billingData
                };
                toolsService.ajaxPost('/document/prepareCheckoutPayment', request).then(function(data){
                    if (data.success){
                        var req = { 
                            MerchantCode: 'M05232',
                            PaymentId: '2',
                            RefNo: data.trxRef,
                            Amount: '35.90',
                            Discount: '',
                            Currency: 'MYR',
                            Remark: '',
                            TransId: 'T202806669898',
                            AuthCode: 'T98061',
                            Status: '1',
                            ErrDesc: '',
                            // Status: '0',
                            // ErrDesc: 'Customer Cancel Transaction',
                            // ErrDesc: 'Cancel By Bank',
                            PayerEmail: '',
                            ExpiryDate: '',
                            Signature: '154ee03fdb42238ac9b0fea136533c54851e96fce148babaac3969a5f5e3855d',
                            CCName: 'Arif Hussain',
                            CCNo: '540067xxxxxx5370',
                            S_bankname: 'MALAYAN BANKING BERHAD',
                            S_country: 'MY',
                            OldTokenId: '',
                            HiddenToURL: 'http://localhost:3400/paymentResponse',
                            fpx_fpxTxnTime: '',
                            fpx_fpxTxnId: '',
                            fpx_buyerBankBranch: '',
                            TokenId: '',
                            BindCardErrDesc: '',
                            PANTrackNo: '',
                            ActionType: '',
                            BankMID: '00000313825',
                            TranDate: '2019-06-17' 
                        }
                        toolsService.ajaxPostTest('/paymentResponse', req).then(function(){});

                        // var form = document.createElement("form");
                        // form.setAttribute("method", "post");
                        // form.setAttribute("target", "_self");
                        // form.setAttribute("action", "https://ministg.mydata-ssm.com.my/proceedPaymentLite");
    
                        // var transactionId = document.createElement('input');
                        // transactionId.type = 'hidden';
                        // transactionId.name = 'transactionId';
                        // transactionId.value = data.trxRef;
                        // form.appendChild(transactionId);
    
                        // var amount = document.createElement('input');
                        // amount.type = 'hidden';
                        // amount.name = 'amount';
                        // amount.value = request.totalAmount;
                        // form.appendChild(amount);
    
                        // var billingName = document.createElement('input');
                        // billingName.type = 'hidden';
                        // billingName.name = 'billingName';
                        // billingName.value = request.billing.fullName;
                        // form.appendChild(billingName);
    
                        // var billingEmail = document.createElement('input');
                        // billingEmail.type = 'hidden';
                        // billingEmail.name = 'billingEmail';
                        // billingEmail.value = request.billing.email;
                        // form.appendChild(billingEmail);
    
                        // var billingAddressOne = document.createElement('input');
                        // billingAddressOne.type = 'hidden';
                        // billingAddressOne.name = 'billingAddressOne';
                        // billingAddressOne.value = request.billing.address1;
                        // form.appendChild(billingAddressOne);
    
                        // var billingAddressTwo = document.createElement('input');
                        // billingAddressTwo.type = 'hidden';
                        // billingAddressTwo.name = 'billingAddressTwo';
                        // billingAddressTwo.value = request.billing.address2;
                        // form.appendChild(billingAddressTwo);
    
                        // var billingAddressThree = document.createElement('input');
                        // billingAddressThree.type = 'hidden';
                        // billingAddressThree.name = 'billingAddressThree';
                        // billingAddressThree.value = request.billing.address3;
                        // form.appendChild(billingAddressThree);
    
                        // var billingPostcode = document.createElement('input');
                        // billingPostcode.type = 'hidden';
                        // billingPostcode.name = 'billingPostcode';
                        // billingPostcode.value = request.billing.postcode;
                        // form.appendChild(billingPostcode);
    
                        // var billingCity = document.createElement('input');
                        // billingCity.type = 'hidden';
                        // billingCity.name = 'billingCity';
                        // billingCity.value = request.billing.city;
                        // form.appendChild(billingCity);
    
                        // var billingState = document.createElement('input');
                        // billingState.type = 'hidden';
                        // billingState.name = 'billingState';
                        // billingState.value = request.billing.state;
                        // form.appendChild(billingState);
    
                        // document.body.appendChild(form);
                        // form.submit();
                        // document.body.removeChild(form);

                    }
                    else{
                        Alertify.error('Unsuccessful to proceed payment')
                    }
                })
            }
        };
        //#endregion

        //#region process document v2 - user credit
        $scope.processCheckoutItem = function (paymentItems) {
            var prepDocRequest = {
                userRole: $rootScope.currentUser.role,
                untaxedAmount: paymentItems.untaxedAmount || 0.00,
                taxAmount: paymentItems.taxAmount || 0.00,
                totalAmount: paymentItems.totalAmount || 0.00,
                paymentMethod: paymentItems.paymentMethod,
                projectId: paymentItems.projectId || null,
                billing: paymentItems.billing
            };
            toolsService.ajaxPost('/process/prepareCheckoutItem', prepDocRequest).then(function (data) {
                if (data.success) {
                    if (data.purchaseInfoSuccess) {
                        Alertify.success('Processing your order');
                        var procDocRequest = {
                            invoiceNumber: data.invoiceNumber,
                            processDate: data.processDate,
                            trxId: data.trxId,
                            userId: data.userId
                        };
                        toolsService.ajaxPost('/process/processCheckoutItem', procDocRequest).then(function (result) {
                            $state.transitionTo('document.summary');
                        });
                    }
                    else {
                        $state.transitionTo('document.summary');
                    }
                }
                else {
                    Alertify.error(data.errMsg);
                }
            });
        };
        //#endregion

        //#region reprocess order v2
        $scope.reprocessOrder = function (orderId) {
            var request = {
                orderId: orderId
            };
            toolsService.ajaxPost('/process/reprocessOrder', request).then(function (data) {
                if (!data.resupply) {
                    if (data.success) {
                        Alertify.success('Resupply your order.');
                    }
                    else{
                        Alertify.error('Oops. Let\'s retry again.');
                    }
                }
                else {
                    $scope.resupplyOrder(orderId);
                }
                if ($state.current.name == 'document.download') {
                    $scope.searchDocument(
                        true,
                        $scope.userOrderCriteria.dateFrom,
                        $scope.userOrderCriteria.dateTo,
                        $scope.userOrderCriteria.orderRef,
                        $scope.userOrderCriteria.trxRef,
                        $scope.userOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.order') {
                    $scope.agencyUserOrderSearch(
                        true,
                        $scope.agencyOrderCriteria.dateFrom,
                        $scope.agencyOrderCriteria.dateTo,
                        $scope.agencyOrderCriteria.orderRef,
                        $scope.agencyOrderCriteria.trxRef,
                        $scope.agencyOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.all') {
                    $scope.searchAllOrder(
                        true,
                        $scope.allOrderCriteria.dateFrom,
                        $scope.allOrderCriteria.dateTo,
                        $scope.allOrderCriteria.orderStatus,
                        $scope.allOrderCriteria.entityRef,
                        $scope.allOrderCriteria.orderRef,
                        $scope.allOrderCriteria.trxRef,
                        $scope.allOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.summary') {
                    $scope.loadOrderSummary(true, $scope.summaryOrderCriteria.page)
                }
                else {
                    location.reload();
                }
            });
        };
        //#endregion
 
        //#region resupply order v2
        $scope.resupplyOrder = function (orderId) {
            var request = {
                orderId: orderId
            };
            toolsService.ajaxPost('/process/resupplyOrder', request).then(function (data) {
                if (!data.reprocess) {
                    if (data.success) {
                        Alertify.success('Resupply your order.');
                    }
                    else{
                        Alertify.error('Oops. Let\'s retry again.');
                    }
                }
                else {
                    $scope.reprocessOrder(orderId);
                }
                if ($state.current.name == 'document.download') {
                    $scope.searchDocument(
                        true,
                        $scope.userOrderCriteria.dateFrom,
                        $scope.userOrderCriteria.dateTo,
                        $scope.userOrderCriteria.orderRef,
                        $scope.userOrderCriteria.trxRef,
                        $scope.userOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.order') {
                    $scope.agencyUserOrderSearch(
                        true,
                        $scope.agencyOrderCriteria.dateFrom,
                        $scope.agencyOrderCriteria.dateTo,
                        $scope.agencyOrderCriteria.orderRef,
                        $scope.agencyOrderCriteria.trxRef,
                        $scope.agencyOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.all') {
                    $scope.searchAllOrder(
                        true,
                        $scope.allOrderCriteria.dateFrom,
                        $scope.allOrderCriteria.dateTo,
                        $scope.allOrderCriteria.orderStatus,
                        $scope.allOrderCriteria.entityRef,
                        $scope.allOrderCriteria.orderRef,
                        $scope.allOrderCriteria.trxRef,
                        $scope.allOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.summary') {
                    $scope.loadOrderSummary(true, $scope.summaryOrderCriteria.page)
                }
                else {
                    location.reload();
                }
            });
        };
        //#endregion

        //#region resubmit order CTC
        $scope.resubmitOrderCTC = function (orderId) {
            var request = {
                orderId: orderId
            };
            toolsService.ajaxPost('/process/resubmitOrderCTC', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Resupply your order.');
                }
                else{
                    Alertify.error('Oops. Let\'s retry again.');
                }
                if ($state.current.name == 'document.download') {
                    $scope.searchDocument(
                        true,
                        $scope.userOrderCriteria.dateFrom,
                        $scope.userOrderCriteria.dateTo,
                        $scope.userOrderCriteria.orderRef,
                        $scope.userOrderCriteria.trxRef,
                        $scope.userOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.order') {
                    $scope.agencyUserOrderSearch(
                        true,
                        $scope.agencyOrderCriteria.dateFrom,
                        $scope.agencyOrderCriteria.dateTo,
                        $scope.agencyOrderCriteria.orderRef,
                        $scope.agencyOrderCriteria.trxRef,
                        $scope.agencyOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.all') {
                    $scope.searchAllOrder(
                        true,
                        $scope.allOrderCriteria.dateFrom,
                        $scope.allOrderCriteria.dateTo,
                        $scope.allOrderCriteria.orderStatus,
                        $scope.allOrderCriteria.entityRef,
                        $scope.allOrderCriteria.orderRef,
                        $scope.allOrderCriteria.trxRef,
                        $scope.allOrderCriteria.page
                    )
                }
                else if ($state.current.name == 'document.summary') {
                    $scope.loadOrderSummary(true, $scope.summaryOrderCriteria.page)
                }
                else {
                    location.reload();
                }
            });
        };
        //#endregion

        //#region rerequest order
        $scope.rerequestOrder = function (userId, transactionId, invoiceNo, processDate) {
            var request = {
                userId: userId,
                transactionId: transactionId,
                invoiceNo: invoiceNo,
                processDate: processDate
            };
            toolsService.ajaxPost('/process/rerequestOrder', request).then(function (result) {
                if (result.purchaseInfoSuccess) {
                    Alertify.success('Processing your order');
                    var procDocRequest = {
                        invoiceNumber: result.invoiceNumber,
                        processDate: result.processDate,
                        trxId: result.trxId,
                        userId: result.userId
                    };
                    toolsService.ajaxPost('/process/processCheckoutItem', procDocRequest).then(function () {
                        if ($state.current.name == 'document.download') {
                            $scope.searchDocument(
                                true,
                                $scope.userOrderCriteria.dateFrom,
                                $scope.userOrderCriteria.dateTo,
                                $scope.userOrderCriteria.orderRef,
                                $scope.userOrderCriteria.page
                            )
                        }
                        else if ($state.current.name == 'document.order') {
                            $scope.agencyUserOrderSearch(
                                true,
                                $scope.agencyOrderCriteria.dateFrom,
                                $scope.agencyOrderCriteria.dateTo,
                                $scope.agencyOrderCriteria.orderRef,
                                $scope.agencyOrderCriteria.page
                            )
                        }
                        else if ($state.current.name == 'document.all') {
                            $scope.searchAllOrder(
                                true,
                                $scope.allOrderCriteria.dateFrom,
                                $scope.allOrderCriteria.dateTo,
                                $scope.allOrderCriteria.orderStatus,
                                $scope.allOrderCriteria.entityRef,
                                $scope.allOrderCriteria.orderRef,
                                $scope.allOrderCriteria.page
                            )
                        }
                        else if ($state.current.name == 'document.summary') {
                            $scope.loadOrderSummary(true, $scope.summaryOrderCriteria.page)
                        }
                        else {
                            location.reload();
                        }
                    });
                }
            });
        };
        //#endregion

        //#region download document
        $scope.downloadFile = function (item) {
            var request = {orderNo:item.orderNumber};
            toolsService.ajaxPostPdf('/document/download', request).then(function (data) {
                var result = {}
                if (data.byteLength < 150){
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
                    result = JSON.parse(decodedString);
                }
                var success = true;
                if (result.success == false) {
                    success = false;
                }
                if (!success) {
                    Alertify.error(result.message);
                }
                else {
                    var type = '';
                    var date = '';
                    var lang = '';
                    if (item.type == 'Document & Form Download' || item.type == 'LLP Document & Form Download' || item.type == 'ROB Form Image Download') {
                        var docDate = new Date(item.documentDate);
                        docDate.setDate(docDate.getDate() + 1);
                        var newDate = new Date(docDate).toISOString();
                        var dateElement = newDate.slice(0, 10).split('-')
                        date = dateElement[2] + dateElement[1] + dateElement[0];
                        type = item.documentType;
                    }
                    else {
                        var docDate = item.processDate;
                        var dateElement = docDate.slice(0, 10).split('-')
                        date = dateElement[2] + dateElement[1] + dateElement[0];
                        var first_letter = item.type.match(/\b(\w)/g);
                        var index = first_letter.indexOf('1');
                        if (index !== -1) {
                            first_letter[index] = '10';
                        }
                        var acronym = first_letter.join('');
                        type = acronym;
                        lang = '_' + item.lang.toUpperCase();
                    }
                    var ctc = '';
                    if (item.ctc) {
                        ctc = '_CTC';
                    }
                    var filename = item.entityNumber + '_' + type + '_' + date + ctc + lang + '.pdf';
                    var file = new Blob([data], { type: 'application/pdf' });
                    saveAs(file, filename);
                }
            })
        }
        //#endregion

        //#region order list - account admin
        $scope.agencyUserOrderFilter = function (tableState, ctrl) {
            $scope.docCtrl = ctrl;
        };
        $scope.agencyUserOrderSearch = function (refresh, dateFrom, dateTo, orderRef, trxRef, page) {
            var request = {
                dateFrom: dateFrom || $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: dateTo || $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: orderRef || this.orderRef || '',
                trxRef: trxRef || this.trxRef || '',
                sort: {},
                page: page || 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.docTypeWithSearch) {
                request.docType = this.docTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.docTypeWithSearch.selected.ctc;
            }
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            $scope.agencyOrderCriteria = request
            toolsService.ajaxPost('/document/agencyUserOrderSearch', request).then(function (data) {
                $scope.agencyUserOrderData = data.data;
                pagination(data.pagination);
                $scope.startOrderInterval(refresh, data.orderIds);
            });
        };
        if ($state.current.name == 'document.order') {
            // $scope.loadProjectAgencyList();
            $scope.agencyUserOrderSearch(true,null,null,null,null,null);
        }
        //#endregion

        //#region order list - administrator
        $scope.allOrderPipe = function (tableState, ctrl) {
            $scope.docCtrl = ctrl;
        };
        $scope.searchAllOrder = function (refresh, dateFrom, dateTo, orderStatus, entityRef, orderRef, trxRef, page) {
            var request = {
                dateFrom: dateFrom || $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: dateTo || $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: orderRef || this.orderRef || '',
                entityRef: entityRef || this.entityRef || '',
                orderStatus: orderStatus || this.orderStatus || '',
                trxRef: trxRef || this.trxRef || '',
                sort: {},
                page: page || 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.docTypeWithSearch) {
                request.docType = this.docTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.docTypeWithSearch.selected.ctc;
            }
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            $scope.allOrderCriteria = request
            toolsService.ajaxPost('/document/searchAllOrder', request).then(function (data) {
                $scope.allOrderData = data.data;
                pagination(data.pagination);
                $scope.startOrderInterval(refresh, data.orderIds);
            });
        };
        if ($state.current.name == 'document.all') {
            $scope.searchAllOrder(true,null,null,null,null,null,null,null);
        }
        //#endregion

        //#region download invoice
        $scope.getInvoice = function (trxId, trxNo) {
            var req = {
                trxId: trxId
            }
            toolsService.ajaxGet('/transaction/prepareInvoice', req).then(function (result) {
                var request = {
                    trxId: trxId,
                }
                toolsService.ajaxPostPdf('/transaction/getInvoice', request).then(function (data) {
                    var success = true;
                    if (data.success == false) {
                        success = false;
                    }
                    if (!success) {
                        Alertify.error('Unable to download invoice.');
                    }
                    else {
                        var filename = 'TaxInvoice_' + trxNo + '.pdf';
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, filename);
                    }
                })
            })
        }
        //#endregion
    
        //#region generate payment url
        $scope.generatePaymentUrl = function () {
            var request = {
                untaxedAmount: this.untaxedAmount,
                taxAmount: this.taxAmount,
                totalAmount: this.totalAmount
            }
            toolsService.ajaxPost('/document/generatePaymentUrl', request).then(function (data) {
                $scope.paymentUrl = data.paymentUrl;
                $scope.transactionRef = data.transactionRef;
            });
        }
        //#endregion

    }

    angular.module('mydata.document').controller('itemRemoveModalCtrl', itemRemoveModalCtrl);
    function itemRemoveModalCtrl($scope, items) {
        $scope.itemCartIndex = items.itemCartIndex;
        $scope.itemCartId = items.itemCartId;
        $scope.itemCartEntityNo = items.itemCartEntityNo;
        $scope.itemCartType = items.itemCartType;
        $scope.itemCartEntityType = items.itemCartEntityType;
    }

    angular.module('mydata.document').controller('processCheckoutCtrl', ProcessCheckoutCtrl);
    function ProcessCheckoutCtrl($scope, toolsService, paymentItems) {
        $scope.paymentItems = paymentItems
    }

    angular.module('mydata.document').controller('paymentConfirmationCtrl', PaymentConfirmationCtrl);
    function PaymentConfirmationCtrl($scope, toolsService, items) {
        var request = {
            trxId: items.trxId
        }
        toolsService.ajaxPost('/document/getPaymentConfirmation', request).then(function (data) {
            $scope.paymentDetail = {
                trxId: data.paymentDetail.id,
                trxDate: data.paymentDetail.trx_date,
                invoiceNo: data.paymentDetail.invoice_no,
                paymentRef: data.paymentDetail.payment_ref,
                paymentStatus: data.paymentDetail.payment_status,
                errMsg: data.paymentDetail.err_msg
            }
        })
    }

})();

(function () {
    'use strict';

    angular.module('mydata.home').controller('home.controller', HomeController);

    function HomeController($scope, toolsService, $uibModal) {

        $scope.smartTablePageSize = 10;
        $scope.showNotification = false;

        $scope.notificationAlert = function () {
            var file = new XMLHttpRequest();
            // change for deployment
            file.open('GET', '../../notification-alert.txt');
            // file.open('GET', '../../../to-remove/notification-alert.txt');
            file.onreadystatechange = function() {
                if (file.readyState === 4) {
                    if (file.status === 200) {  // Makes sure it's found the file
                        if (file.responseText !== "") {  // Makes sure the document is not empty
                            $scope.notificationClass = "alert notification-alert";
                            document.getElementById("notification-alert").innerHTML = file.responseText;
                            setTimeout(function() {document.getElementById("notification-alert").parentElement.style.display='none';},60000);
                        }
                        else{
                            $scope.notificationClass = "notification-hide";
                            document.getElementById("notification-alert").parentElement.style.display='none';
                        }
                    }
                }
            }
            file.send();
        };
        $scope.notificationAlert();
    
        $scope.getEntityStatData = function(){
            $scope.entityStatData = {
                asAtDate: "29th February 2020",
                companies: "1,352,955",
                local: "1,348,106",
                foreign: "4,849",
                businesses: "7,706,174",
                soleProprietorship: "6,293,301",
                partnership: "1,412,873"
            };
        };
        $scope.getEntityStatData();
    }
})();

(function () {
    'use strict';
  
    angular.module('mydata.invoice').controller('invoice.controller', InvoiceController);
    
    function InvoiceController($scope, toolsService, $state, $stateParams, Alertify, $uibModal) {

        $scope.pageSize = 10;
        $scope.enableLineAdd = false;
        $scope.app = {
            "selected": "Lite", 
            "selection": [ "Lite", "Counter"] 
        };

        //#region search invoice
        $scope.searchInvoice = function (invoiceNo,app) {
            var request = {
                invoiceNo: invoiceNo
            };
            toolsService.ajaxGet('/invoice/searchInvoice'+app, request).then(function (result) {
                if (result.success){
                    $scope.invoice = result.invoice;
                    $scope.invoiceLineCoreData = result.invoiceLineCore;
                    $scope.invoiceLineData = result.invoiceLine;
                    $scope.appCode = result.appCode;
                }
                else{
                    Alertify.error(result.message);
                }
            });
        };
        //#endregion

        //#region download invoice
        $scope.getInvoice = function (invId,invNo) {
            toolsService.ajaxGet('/transaction/prepareInvoice', {trxId:invId}).then(function () {
                toolsService.ajaxPostPdf('/transaction/getInvoice', {trxId:invId}).then(function (data) {
                    var success = true;
                    if (data.success == false) {
                        success = false;
                    }
                    if (!success) {
                        Alertify.error('Unable to download invoice.');
                    }
                    else {
                        var filename = 'TaxInvoice_' + invNo + '.pdf';
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, filename);
                    }
                });
            });
        };
        //#endregion

        //#region download invoice
        $scope.downloadInvoice = function (invNo) {
            toolsService.ajaxGetExcel('/invoice/downloadInvoice', {invNo:invNo}).then(function (data) {
                var success = true;
                if (data.success == false) {
                    success = false;
                }
                if (!success) {
                    Alertify.error('Unable to download invoice.');
                }
                else {
                    var filename = 'Invoice_' + invNo + '.pdf';
                    var file = new Blob([data], { type: 'application/pdf' });
                    saveAs(file, filename);
                }
            });
        };
        //#endregion

        $scope.add = function () {
            $scope.enableLineAdd = true;
        };
        $scope.cancel = function () {
            $scope.enableLineAdd = false;
        };

        $scope.addInvoiceLine = function (appCode) {
            var request = {
                invoiceDate: this.invoice.invoiceDate,
                invoiceNo: this.invoice.invoiceNo,
                orderNo: this.orderNo,
                productId: this.productId
            }
            toolsService.ajaxPost('/invoice/addLine', request).then(function (result) {
                if (result.success){
                    Alertify.success(result.message);
                    $scope.enableLineAdd = false;
                    $scope.searchInvoice(request.invoiceNo,appCode);
                }
                else{
                    Alertify.success(result.message);
                }
            });
        };

    }

})();
  
(function () {
    'use strict';

    angular.module('mydata.login').controller('login.controller', LoginController);

    function LoginController($scope, $uibModal, $state, $stateParams, $rootScope, $localStorage, Alertify, toolsService) {

        //#region dropdown selection
        $scope.agencyWithSearch = { selected: {} };
        $scope.loadAgency = function () {
            toolsService.ajaxGet('/getAgency').then(function (data) {
                if (data) {
                    $scope.agencyOption = data.options;
                }
            });
        };
        $scope.deptSelect = { selected: {} };
        $scope.loadDepartment = function () {
            toolsService.ajaxGet('/getDepartment').then(function (data) {
                if (data) {
                    $scope.deptList = data.options;
                }
            });
        };
        //#endregion

        //#region term & condition modal
        $scope.openDisclaimerModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/login/term-condition.modal.html',
                size: 'md',
                backdrop: 'static'
            });
        };
        //#endregion

        //#region login
        $scope.login = function () {
            if (/Trident/.test(navigator.userAgent)) {
                console.log('IE');
                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/login/unsupported-browser.modal.html',
                    size: 'sm',
                    backdrop: 'static',
                    resolve: {
                        items: function () {
                            return $scope.items;
                        }
                    }
                });
            }
            else {
                console.log('NOT IE');
                if (this.email && this.password) {
                    $rootScope.currentUser = null;
                    delete $localStorage.currentUser;
                    var request = {
                        email: this.email,
                        password: this.password
                    }
                    toolsService.ajaxPost('/login', request).then(function (data) {
                        if (data.success) {
                            Alertify.success(data.message);
                            $rootScope.currentUser = {
                                'role': data.role,
                                'token': data.token,
                                'isLogin': true,
                                'userId': data.userId,
                                'userName': data.userName,
                                'userCreditBalance': data.creditBalance,
                                'userCartCount': data.cartCount,
                                'agencyId': data.agencyId
                            };
                            $localStorage.currentUser = $rootScope.currentUser;
                            if (data.role){
                              $state.transitionTo('entity.search');
                            } 
                            else{
                              $state.transitionTo('home');
                            } 
                        } else {
                            Alertify.error(data.message);
                        }
                    });
                } else {
                    $rootScope.currentUser = null;
                    delete $localStorage.currentUser;
                    Alertify.error('Invalid email/password.');
                }
            }
        };
        //#endregion

        //#region logout
        $scope.logout = function () {
            $rootScope.currentUser = null;
            delete $localStorage.currentUser;
            // refresh page when login
            // delete $localStorage.refresh;
            $state.transitionTo('home');
            Alertify.success('Succesfully logged out');
        };
        //#endregion

        //#region sign up
        $scope.user = {};
        $scope.signUp = function () {
            if (this.user.email != this.user.confirmEmail) {
                Alertify.error('Email and confirm email don\'t match');
            }
            else if (this.user.password != this.user.confirmPassword) {
                Alertify.error('Password and confirm password don\'t match');
            }
            else if (this.agencyWithSearch.selected.id == undefined || this.agencyWithSearch.selected.id == '') {
                Alertify.error('Please select agency/firm');
            }
            else if (this.deptSelect.selected.id == undefined || this.deptSelect.selected.id == '') {
                Alertify.error('Please select department');
            }
            else {
                var request = {
                    email: this.user.email || '',
                    fullName: this.user.fullName || '',
                    phoneNo: this.user.phoneNo || '',
                    password: this.user.password || '',
                    address1: this.user.address1 || '',
                    address2: this.user.address2 || '',
                    address3: this.user.address3 || '',
                    postcode: this.user.postcode || '',
                    city: this.user.city || '',
                    state: this.user.state || '',
                };
                if (this.agencyWithSearch) {
                    request.agencyId = this.agencyWithSearch.selected.id;
                }
                if (this.deptSelect) {
                    request.deptId = this.deptSelect.selected.id;
                    request.deptCode = this.deptSelect.selected.code;
                }
                toolsService.ajaxPost('/signUp', request).then(function (data) {
                    if (data.success) {
                        Alertify.success(data.message);
                        $state.transitionTo('home');
                    }
                    else {
                        Alertify.error(data.message);
                    }
                });
            }
        };
        //#endregion

        //#region forgot password
        $scope.forgotPassword = function () {
            var request = {
                email: this.checkEmail,
            };
            toolsService.ajaxPost('/forgotPassword', request).then(function (data) {
                if (data.success) {
                    Alertify.success(data.message);
                    $state.transitionTo('home');
                } else {
                    Alertify.error(data.message);
                }
            });
        };
        //#endregion

        //#region reset password
        $scope.resetPassword = function () {
            if (this.resetNewPassword != this.resetConfirmNewPassword) {
                Alertify.error('New Password And Confirm New Password don\'t match');
            }
            else {
                var request = {
                    newPassword: this.resetNewPassword,
                    token: $stateParams.token || ''
                };
                toolsService.ajaxPost('/resetPassword', request).then(function (data) {
                    if (data.success) {
                        Alertify.success(data.message);
                        $state.transitionTo('home');
                    } else {
                        Alertify.error(data.message);
                    }
                });
            }
        };
        //#endregion

    }

})();

(function () {
    'use strict';
  
    angular.module('mydata.notification').controller('notification.controller', NotificationController);
    
    function NotificationController($scope, toolsService, $state, $stateParams, $rootScope, Alertify, $uibModal) {

        $scope.smartTablePageSize = 10;

        $scope.searchNotification = function () {
            toolsService.ajaxGet('/notification/list').then(function (data) {
                $scope.notificationListSrc = data.data;
            });
        };
        if ($state.current.name == 'notification.list'){
            $scope.searchNotification();
        }

        $scope.viewNotification = function (notificationId) {
            var request = {
                notificationId: notificationId
            };
            toolsService.ajaxGet('/notification/detail', request).then(function (data) {
                $scope.notification = data.notificationData;
            });
        }
        if ($state.current.name == 'notification.detail') {
            $scope.viewNotification($stateParams.notificationId)
        }

        $scope.updateNotification = function () {
            var request = {
                notificationId: this.notification.id,
                notificationTitle: this.notification.title,
                notificationType: this.notification.type,
                notificationActive: this.notification.active,
                notificationMessage: this.notification.message
            };
            toolsService.ajaxPost('/notification/update', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully update notification');
                    $state.transitionTo('notification.list');
                }
                else {
                    Alertify.error('Unsuccessful to update notification');
                }
            });
        };

        $scope.createNotification = function () {
            var request = {
                title: this.title,
                type: this.type || 'Notification',
                active: this.active || false,
                message: this.message
            };
            toolsService.ajaxPost('/notification/create', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully create notification');
                    $state.transitionTo('notification.list');
                }
                else {
                    if (data.errorMsg){
                        Alertify.error(data.errorMsg);
                    }
                    else{
                        Alertify.error('Unsuccessful to create notification');
                    }
                }
            });
        };

        $scope.deleteNotificationModal = function (notificationId,notificationActive) {
            $scope.items = {
                notificationId: notificationId,
                notificationActive: notificationActive
            };
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/notification/notification-delete.modal.html',
                controller: 'notificationDeleteModalCtrl',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    items: function () {
                        return $scope.items;
                    }
                }
            });
        };

        $scope.deleteNotification = function (notificationId,notificationActive) {
            var request = {
                notificationId: notificationId,
                notificationActive: notificationActive
            };
            toolsService.ajaxGet('/notification/delete', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully delete notification');
                    $state.transitionTo('notification.list');
                }
                else {
                    Alertify.error('Unsuccessful to delete notification');
                }
            });
        };

    }

    angular.module('mydata.notification').controller('notificationDeleteModalCtrl', notificationDeleteModalCtrl)
    function notificationDeleteModalCtrl($scope, items) {
        $scope.notificationId = items.notificationId
        $scope.notificationActive = items.notificationActive
    }

})();
  
(function () {
    'use strict';

    angular.module('mydata.pi').controller('pi.controller', PIController);
    function PIController($scope, toolsService, $state, $stateParams, Alertify, $uibModal, $rootScope, $interval) {
        
        $scope.piModel = {
            idType: 'MK',
            idNo: ''
        }

        $scope.onchangeIdType = function() {
            $scope.piModel.idNo = '';
            $scope.piProducts.forEach(function (product) {                
                product.available = 'no';
                product.ctc = false;
                product.lang = 'EN';
                product.inCart = false;
            });
        }
        $scope.onchangeIdNo = function() {
            $scope.piProducts.forEach(function (product) {                
                product.available = 'no';
                product.ctc = false;
                product.lang = 'EN';
                product.inCart = false;
            });
        }

        $scope.getProducts = function() {
            var request = {};
            toolsService.ajaxGet('/pi/getProducts', request).then(function (result) {
                if ($scope.piProducts == undefined){
                    $scope.piProducts = result.piProducts;
                }
            });
        }
        $scope.getProducts();

        $scope.viewSample = function (type, lang, ctc) {
            var items = { 
                type: type, 
                lang: lang, 
                ctc: ctc 
            };
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/personal-involvement/pi.sample.view.html',
                controller: 'pi.sample.controller',
                size: 'lg',
                resolve: {
                    items: function () {
                        return items;
                    }
                }
            });
        };
        
        $scope.enableProducts = function() {
            $scope.piProducts.forEach(function (product) {                
                product.available = 'yes';
                $scope.checkInCart(product.productName, product.ctc, product.lang);
            });
        }

        $scope.checkInCart = function(productName, ctc, lang) {            
            var request = {
                idNo: $scope.piModel.idNo,
                idType: $scope.piModel.idType,
                productName: productName,
                ctc: ctc,
                lang: lang
            };
            toolsService.ajaxGet('/pi/checkInCart', request).then(function (result) {
                $scope.piProducts.forEach(function (product) {
                    if (product.productName == productName) {
                        if (result.inCart) {
                            product.inCart = true;
                        }
                        else {
                            product.inCart = false;
                        }
                    }
                });
            });
        }

        // $scope.addToCartModal = function (product) {
        //     var cartItems = {
        //         idNo: $scope.piModel.idNo,
        //         idType: $scope.piModel.idType,
        //         product: product
        //     };
        //     $scope.cartmodal = $uibModal.open({
        //         animation: true,
        //         templateUrl: 'app/pages/personal-involvement/pi.cart.modal.html',
        //         controller: 'pi.cart.controller',
        //         size: 'md',
        //         backdrop: 'static',
        //         resolve: {
        //             cartItems: function () {
        //                 return cartItems;
        //             }
        //         }
        //     });
        // };
        // $scope.addToCart = function (cartItems) {
        //     toolsService.ajaxPost('/pi/addToCart', cartItems).then(function () {
        //         $rootScope.piProducts.forEach(function (prod) {
        //             if (prod.productName == cartItems.product.productName) {
        //                 prod.inCart = true;
        //             }
        //         });
        //     });
        // };

        $scope.addToCart = function (product) {
            var request = {
                idNo: $scope.piModel.idNo,
                idType: $scope.piModel.idType,
                product: product
            };
            toolsService.ajaxPost('/pi/addToCart', request).then(function () {
                $scope.piProducts.forEach(function (prod) {
                    if (prod.productName == product.productName) {
                        prod.inCart = true;
                    }
                });
            });
        };

    }

    angular.module('mydata.pi').controller('pi.sample.controller', PISampleController);
    function PISampleController($scope, items) {
        $scope.type = items.type;
        $scope.lang = items.lang;
        $scope.ctc = items.ctc;
    }

    // angular.module('mydata.pi').controller('pi.cart.controller', PICartController);
    // function PICartController($scope, cartItems) {
    //     $scope.cartItems = cartItems
    // }

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function () {
    'use strict';
  
    angular.module('mydata.project').controller('project.controller', ProjectController);

    function ProjectController($scope, $uibModal, toolsService, $state, $stateParams, $rootScope, Alertify) {

        $scope.smartTablePageSize = 10;

        //#region load agency onclick
        $scope.agencyWithSearch = {selected:{}};
        $scope.loadAgency = function(){
            toolsService.ajaxGet('/report/getUserAgency').then(function (data) {
                $scope.agencyOption = data.options;
            });
        };
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region project list - account admin
        $scope.projectFilter = function(tablestate, ctrl){
            $scope.stCtrl = ctrl;
        }
        $scope.searchProject = function () {
            var request = {
                projectInfo: this.projectInfo || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/project/search', request).then(function (data) {
                $scope.projectData = data.data;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'project.list'){
            $scope.searchProject();
        }
        $scope.selectProject = function (page) {
            var request = {
                projectInfo: this.projectInfo || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/project/search', request).then(function (data) {
                $scope.projectData = data.data;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region project list - administrator
        $scope.projectAllFilter = function(tablestate, ctrl){
            $scope.stCtrl = ctrl;
        }
        $scope.searchProjectAll = function () {
            var request = {
                codeName: this.codeName || '',
                status: this.status || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.agencyWithSearch){
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/project/all/search', request).then(function (data) {
                $scope.projectAllData = data.data;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'project.listAll'){
            $scope.searchProjectAll();
        }
        $scope.selectProjectAll = function (page) {
            var request = {
                codeName: this.codeName || '',
                status: this.status || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            if (this.agencyWithSearch){
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/project/all/search', request).then(function (data) {
                $scope.projectAllData = data.data;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region project close
        $scope.closeProjectModal = function (projectId) {
            $scope.items = {
                projectId: projectId
            };
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/project/project-deactivate.modal.html',
                controller: 'projectCloseModalCtrl',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    items: function () {
                        return $scope.items;
                    }
                }
            });
        };
        $scope.closeProject = function (projectId) {
            var request = {
                projectId: projectId
            };
            toolsService.ajaxPost('/project/close', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully remove project');
                    location.reload();
                }
                else {
                    Alertify.error('Unsuccessful to remove project');
                }
            });
        };
        //#endregion

        //#region project open
        $scope.openProjectModal = function (projectId) {
            $scope.items = {
                projectId: projectId
            };
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/project/project-activate.modal.html',
                controller: 'projectCloseModalCtrl',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    items: function () {
                        return $scope.items;
                    }
                }
            });
        };
        $scope.openProject = function (projectId) {
            var request = {
                projectId: projectId
            };
            toolsService.ajaxGet('/project/open', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully reactivate project');
                    location.reload();
                }
                else {
                    Alertify.error('Unsuccessful to reactivate project');
                }
            });
        };
        //#endregion

        //#region project view
        $scope.viewProject = function (projectId) {
            var request = {
                projectId: projectId
            };
            toolsService.ajaxGet('/project/detail', request).then(function (data) {
                $scope.project = data.projectData;
            });
        }
        if ($stateParams.projectId != '' && typeof $stateParams.projectId != 'undefined') {
            $scope.viewProject($stateParams.projectId);
        }
        //#endregion

        //#region project update
        $scope.updateProject = function () {
            var request = {
                projectId: this.project.id,
                agencyId: this.project.agencyId,
                projectCode: this.project.projectCode,
                projectName: this.project.projectName,
            };
            toolsService.ajaxPost('/project/update', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully update project');
                    $state.transitionTo('project.list', { agencyId: data.agencyId });
                }
                else {
                    Alertify.error('Unsuccessful to update project');
                }
            });
        };
        //#endregion

        //#region project create
        $scope.createProject = function () {
            var request = {
                projectCode: this.projectCode,
                projectName: this.projectName
            };
            toolsService.ajaxPost('/project/create', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully add project');
                    $state.transitionTo('project.list', { agencyId: data.agencyId });
                }
                else {
                    if (data.errorMsg){
                        Alertify.error(data.errorMsg);
                    }
                    else{
                        Alertify.error('Unsuccessful to add project');
                    }
                }
            });
        };
        //#endregion

    }

    angular.module('mydata.project').controller('projectCloseModalCtrl', projectCloseModalCtrl);
    function projectCloseModalCtrl($scope, items) {
      $scope.projectId = items.projectId;
    }

})();
  
(function () {
    'use strict';
  
    angular.module('mydata.service').controller('service.controller', ServiceController);
    
    function ServiceController($scope, toolsService, $state, $stateParams, Alertify, $uibModal, $interval, $localStorage, $rootScope) {

        // remove active user from app
        $rootScope.currentUser = null;
        delete $localStorage.currentUser;

        $scope.pageSize = 10;
        var interval;
        $scope.feedback = {};
        $scope.checkoutData = [];
        

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            $scope.rowCount = pagination.rowCount;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region refresh order every 10 seconds
        $scope.startOrderInterval = function (refresh, orderIds) {
            // stops any running interval to avoid two intervals running at the same time
            $scope.stopOrderInterval();
            if (refresh){
                interval = $interval(function () {
                    toolsService.ajaxGet('/app/checkOrderStatus', {orderIds:orderIds}).then(function (result) {
                        var refreshData = true;
                        if (!result.refresh){
                            refreshData = false;
                        }
                        $scope.stopOrderInterval();
                        if ($state.current.name == 'order') {
                            $scope.getCustomerOrder(refreshData, $scope.orderFilter.page);
                        }
                        else{
                            $scope.startOrderInterval(refreshData, []);
                        }

                    });
                }, 10000);
            }
        };
        // stop user interval
        $scope.stopOrderInterval = function() {
            $interval.cancel(interval);
        };
        //#endregion

        //#region customer checkout
        $scope.checkoutPipe = function (tablestate, ctrl) {
            $scope.docCtrl = ctrl;
        }
        $scope.getCustomerCheckout = function (token) {
            var request = {
                token: token,
                page: 1,
                pageSize: this.pageSize
            };
            toolsService.ajaxGet('/app/getCustomerCheckout', request).then(function (data) {
                console.log(data);
                if (data.success){
                    $scope.checkoutData = data.checkoutData;
                    $scope.checkoutSummary = data.checkoutSummary;
                    $scope.billingData = {
                        fullName: '',
                        email: '',
                        address1: '',
                        address2: '',
                        address3: '',
                        postcode: '',
                        city: '',
                        state: '',
                    };
                    $scope.isPI = data.isPI;
                    pagination(data.pagination);
                    if (data.paymentProcessed){
                        // Alertify.success(data.trxData.errorMsg);
                        var paymentItems = { 
                            trxId: data.trxData.trxId,
                            trxDate: data.trxData.trxDate,
                            invoiceNo: data.trxData.invoiceNo,
                            paymentRef: data.trxData.paymentRef,
                            paymentStatus: data.trxData.paymentStatus,
                            errMsg: data.trxData.errorMsg
                        };
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'app/pages/service/payment.modal.html',
                            controller: 'payment.modal.controller',
                            size: 'md',
                            backdrop: 'static',
                            resolve: {
                                items: function () {
                                    return paymentItems;
                                }
                            }
                        });
                        $state.transitionTo('checkout', { token: data.checkoutToken });
                    }
                }
                else{
                    // Alertify.success(data.message);
                    $scope.errorMsg = data.message;
                }
            });
        };
        if ($state.current.name == 'checkout') {
            $scope.getCustomerCheckout($stateParams.token);
        }
        //#endregion

        //#region check required input
        $scope.checkInput = function(){
            if (this.billingData.fullName){
                $scope.feedback.fullName = '';
            }
            if (this.billingData.address1){
                $scope.feedback.address1 = '';
            }
            if (this.billingData.postcode){
                $scope.feedback.postcode = '';
            }
            if (this.billingData.city){
                $scope.feedback.city = '';
            }
            if (this.billingData.state){
                $scope.feedback.state = '';
            }
        };
        //#endregion

        //#region proceed payment
        $scope.proceedPayment = function () {
            console.log('proceedPayment');            
            var proceed = true;
            if (!this.billingData.fullName){
                $scope.feedback.fullName = 'Billing Name is required.'
                proceed = false;
            }
            if (!this.billingData.address1){
                $scope.feedback.address1 = 'Address Line 1 is required.'
                proceed = false;
            }
            if (!this.billingData.postcode){
                $scope.feedback.postcode = 'Postcode is required.'
                proceed = false;
            }
            if (!this.billingData.city){
                $scope.feedback.city = 'City is required.'
                proceed = false;
            }
            if (!this.billingData.state){
                $scope.feedback.state = 'State is required.'
                proceed = false;
            }
            if (proceed){
                var paymentData = {
                    trxId: this.checkoutSummary.trxId,
                    billing: this.billingData
                };
                toolsService.ajaxPost('/app/preparePayment', paymentData).then(function(data){
                    if (data.success){
                        if (data.paymentSuccess){
                            var req = {
                                trxId: data.trxId
                            };
                            toolsService.ajaxPost('/app/verifyPayment', req).then(function (result) {
                                if (result.verified){
                                    if (result.invSuccess){
                                        $state.transitionTo('order', { token: result.orderToken, id: data.trxId });
                                    }
                                }
                            });
                        }
                        else{
                            var billEmail = data.billingEmail;
                            if (paymentData.billing.email){
                                billEmail = paymentData.billing.email;
                            }
                            // var req = { 
                            //     MerchantCode: 'M05232',
                            //     PaymentId: '2',
                            //     RefNo: data.trxRef,
                            //     Amount: data.totalAmount,
                            //     Discount: '',
                            //     Currency: 'MYR',
                            //     Remark: '',
                            //     TransId: 'T202806669898',
                            //     AuthCode: 'T98061',
                            //     Status: '1',
                            //     ErrDesc: '',
                            //     PayerEmail: billEmail,
                            //     ExpiryDate: '',
                            //     Signature: '154ee03fdb42238ac9b0fea136533c54851e96fce148babaac3969a5f5e3855d',
                            //     CCName: 'Arif Hussain',
                            //     CCNo: '540067xxxxxx5370',
                            //     S_bankname: 'MALAYAN BANKING BERHAD',
                            //     S_country: 'MY',
                            //     OldTokenId: '',
                            //     HiddenToURL: 'http://localhost:3400/paymentResponse',
                            //     fpx_fpxTxnTime: '',
                            //     fpx_fpxTxnId: '',
                            //     fpx_buyerBankBranch: '',
                            //     TokenId: '',
                            //     BindCardErrDesc: '',
                            //     PANTrackNo: '',
                            //     ActionType: '',
                            //     BankMID: '00000313825',
                            //     TranDate: '2020-06-02' 
                            // }
                            // toolsService.ajaxPost('/app/savePaymentResponse', req).then(function(data){
                            //     $state.transitionTo('payment', {id:data.paymentId});
                            // });

                            var form = document.createElement("form");
                            form.setAttribute("method", "post");
                            form.setAttribute("target", "_self");
                            // change for deployment
                            form.setAttribute("action", "https://mini.mydata-ssm.com.my/proceedPaymentCounter");

                            var transactionId = document.createElement('input');
                            transactionId.type = 'hidden';
                            transactionId.name = 'transactionId';
                            transactionId.value = data.trxRef;
                            form.appendChild(transactionId);

                            var amount = document.createElement('input');
                            amount.type = 'hidden';
                            amount.name = 'amount';
                            amount.value = data.totalAmount;
                            form.appendChild(amount);

                            var billingName = document.createElement('input');
                            billingName.type = 'hidden';
                            billingName.name = 'billingName';
                            billingName.value = paymentData.billing.fullName;
                            form.appendChild(billingName);

                            var billingEmail = document.createElement('input');
                            billingEmail.type = 'hidden';
                            billingEmail.name = 'billingEmail';
                            billingEmail.value = billEmail;
                            form.appendChild(billingEmail);

                            var billingAddressOne = document.createElement('input');
                            billingAddressOne.type = 'hidden';
                            billingAddressOne.name = 'billingAddressOne';
                            billingAddressOne.value = paymentData.billing.address1;
                            form.appendChild(billingAddressOne);

                            var billingAddressTwo = document.createElement('input');
                            billingAddressTwo.type = 'hidden';
                            billingAddressTwo.name = 'billingAddressTwo';
                            billingAddressTwo.value = paymentData.billing.address2;
                            form.appendChild(billingAddressTwo);

                            var billingAddressThree = document.createElement('input');
                            billingAddressThree.type = 'hidden';
                            billingAddressThree.name = 'billingAddressThree';
                            billingAddressThree.value = paymentData.billing.address3;
                            form.appendChild(billingAddressThree);

                            var billingPostcode = document.createElement('input');
                            billingPostcode.type = 'hidden';
                            billingPostcode.name = 'billingPostcode';
                            billingPostcode.value = paymentData.billing.postcode;
                            form.appendChild(billingPostcode);

                            var billingCity = document.createElement('input');
                            billingCity.type = 'hidden';
                            billingCity.name = 'billingCity';
                            billingCity.value = paymentData.billing.city;
                            form.appendChild(billingCity);

                            var billingState = document.createElement('input');
                            billingState.type = 'hidden';
                            billingState.name = 'billingState';
                            billingState.value = paymentData.billing.state;
                            form.appendChild(billingState);

                            document.body.appendChild(form);
                            form.submit();
                            document.body.removeChild(form);
                        }
                    }
                    else{
                        Alertify.error('Unsuccessful to proceed payment')
                    }
                })
            }
        };
        //#endregion

        //#region proceed payment personal involvement
        $scope.proceedPaymentPI = function (paymentData) {
            console.log('proceedPaymentPI');
            console.log(paymentData);
            toolsService.ajaxPost('/app/preparePayment', paymentData).then(function(data){
                if (data.success){
                    if (data.paymentSuccess){
                        var req = {
                            trxId: data.trxId
                        };
                        toolsService.ajaxPost('/app/verifyPayment', req).then(function (result) {
                            if (result.verified){
                                if (result.invSuccess){
                                    $state.transitionTo('order', { token: result.orderToken, id: data.trxId });
                                }
                            }
                        });
                    }
                    else{
                        var billEmail = data.billingEmail;
                        if (paymentData.billing.email){
                            billEmail = paymentData.billing.email;
                        }
                        var req = { 
                            MerchantCode: 'M05232',
                            PaymentId: '2',
                            RefNo: data.trxRef,
                            Amount: data.totalAmount,
                            Discount: '',
                            Currency: 'MYR',
                            Remark: '',
                            TransId: 'T202806669898',
                            AuthCode: 'T98061',
                            Status: '1',
                            ErrDesc: '',
                            PayerEmail: billEmail,
                            ExpiryDate: '',
                            Signature: '154ee03fdb42238ac9b0fea136533c54851e96fce148babaac3969a5f5e3855d',
                            CCName: 'Arif Hussain',
                            CCNo: '540067xxxxxx5370',
                            S_bankname: 'MALAYAN BANKING BERHAD',
                            S_country: 'MY',
                            OldTokenId: '',
                            HiddenToURL: 'http://localhost:3400/paymentResponse',
                            fpx_fpxTxnTime: '',
                            fpx_fpxTxnId: '',
                            fpx_buyerBankBranch: '',
                            TokenId: '',
                            BindCardErrDesc: '',
                            PANTrackNo: '',
                            ActionType: '',
                            BankMID: '00000313825',
                            TranDate: '2020-06-02' 
                        }
                        toolsService.ajaxPost('/app/savePaymentResponse', req).then(function(data){
                            $state.transitionTo('payment', {id:data.paymentId});
                        });

                        // var form = document.createElement("form");
                        // form.setAttribute("method", "post");
                        // form.setAttribute("target", "_self");
                        // // change for deployment
                        // form.setAttribute("action", "https://mini.mydata-ssm.com.my/proceedPaymentCounter");

                        // var transactionId = document.createElement('input');
                        // transactionId.type = 'hidden';
                        // transactionId.name = 'transactionId';
                        // transactionId.value = data.trxRef;
                        // form.appendChild(transactionId);

                        // var amount = document.createElement('input');
                        // amount.type = 'hidden';
                        // amount.name = 'amount';
                        // amount.value = data.totalAmount;
                        // form.appendChild(amount);

                        // var billingName = document.createElement('input');
                        // billingName.type = 'hidden';
                        // billingName.name = 'billingName';
                        // billingName.value = paymentData.billing.fullName;
                        // form.appendChild(billingName);

                        // var billingEmail = document.createElement('input');
                        // billingEmail.type = 'hidden';
                        // billingEmail.name = 'billingEmail';
                        // billingEmail.value = billEmail;
                        // form.appendChild(billingEmail);

                        // var billingAddressOne = document.createElement('input');
                        // billingAddressOne.type = 'hidden';
                        // billingAddressOne.name = 'billingAddressOne';
                        // billingAddressOne.value = paymentData.billing.address1;
                        // form.appendChild(billingAddressOne);

                        // var billingAddressTwo = document.createElement('input');
                        // billingAddressTwo.type = 'hidden';
                        // billingAddressTwo.name = 'billingAddressTwo';
                        // billingAddressTwo.value = paymentData.billing.address2;
                        // form.appendChild(billingAddressTwo);

                        // var billingAddressThree = document.createElement('input');
                        // billingAddressThree.type = 'hidden';
                        // billingAddressThree.name = 'billingAddressThree';
                        // billingAddressThree.value = paymentData.billing.address3;
                        // form.appendChild(billingAddressThree);

                        // var billingPostcode = document.createElement('input');
                        // billingPostcode.type = 'hidden';
                        // billingPostcode.name = 'billingPostcode';
                        // billingPostcode.value = paymentData.billing.postcode;
                        // form.appendChild(billingPostcode);

                        // var billingCity = document.createElement('input');
                        // billingCity.type = 'hidden';
                        // billingCity.name = 'billingCity';
                        // billingCity.value = paymentData.billing.city;
                        // form.appendChild(billingCity);

                        // var billingState = document.createElement('input');
                        // billingState.type = 'hidden';
                        // billingState.name = 'billingState';
                        // billingState.value = paymentData.billing.state;
                        // form.appendChild(billingState);

                        // document.body.appendChild(form);
                        // form.submit();
                        // document.body.removeChild(form);
                    }
                }
                else{
                    Alertify.error('Unsuccessful to proceed payment')
                }
            });
        };
        //#endregion

        //#region customer order
        $scope.orderPipe = function (tablestate, ctrl) {
            $scope.docCtrl = ctrl;
        }
        $scope.getCustomerOrder = function (refresh, page) {
            var request = {
                token: $stateParams.token,
                page: page || 1,
                pageSize: this.pageSize
            };
            $scope.orderFilter = request;
            toolsService.ajaxGet('/app/getCustomerOrder', request).then(function (data) {
                console.log(data);
                $scope.orderData = data.orderData;
                $scope.orderSummary = data.orderSummary;
                pagination(data.pagination);
                $scope.startOrderInterval(refresh, data.orderIds);
                if ($stateParams.id){
                    var req = {
                        trxId: $stateParams.id
                    }
                    toolsService.ajaxGet('/app/checkInvoiceStatus', req).then(function (result) {
                        var paymentItems = { 
                            trxId: result.trxData.trxId,
                            trxDate: result.trxData.trxDate,
                            invoiceNo: result.trxData.invoiceNo,
                            paymentRef: result.trxData.paymentRef,
                            paymentStatus: result.trxData.paymentStatus,
                            errMsg: result.trxData.errorMsg
                        };
                        if (result.success) {
                            var rqst = {
                                trxId: result.trxData.trxId,
                                userId: result.trxData.userId,
                                invoiceNumber: result.trxData.invoiceNo,
                                processDate: result.trxData.trxDate,
                                processToken: result.token
                            };
                            if (result.orderSuccess){
                                $stateParams.id = '';
                                $state.transitionTo('order', { token: result.orderToken, id: '' });
                            }
                            else {
                                if(result.purchaseInfoSuccess){
                                    console.log("INFO: PURCHASE INFO SUCCESS & DO CHECKOUT ITEM");
                                    toolsService.ajaxPost('/process/processCheckoutItem', rqst).then(function () {
                                        $uibModal.open({
                                            animation: true,
                                            templateUrl: 'app/pages/service/payment.modal.html',
                                            controller: 'payment.modal.controller',
                                            size: 'md',
                                            backdrop: 'static',
                                            resolve: {
                                                items: function () {
                                                    return paymentItems;
                                                }
                                            }
                                        });
                                        $stateParams.id = '';
                                        $state.transitionTo('order', { token: result.orderToken, id: '' });
                                    })
                                }
                                else {
                                    console.log("INFO: PURCHASE INFO FAILED & SKIP CHECKOUT ITEM");
                                    $stateParams.id = '';
                                    $state.transitionTo('order', { token: result.orderToken, id: '' });
                                }
                            }
                        }
                        else {
                            Alertify.success('Invoice unsuccessful');
                            $uibModal.open({
                                animation: true,
                                templateUrl: 'app/pages/service/payment.modal.html',
                                controller: 'payment.modal.controller',
                                size: 'md',
                                backdrop: 'static',
                                resolve: {
                                    items: function () {
                                        return paymentItems;
                                    }
                                }
                            });
                            $stateParams.id = '';
                            $state.transitionTo('order', { token: result.orderToken, id: '' });
                        }
                    });
                }
            });
        };
        if ($state.current.name == 'order') {
            $scope.getCustomerOrder(true, null);
        }
        //#endregion

        //#region download order
        $scope.downloadOrder = function (orderNo) {
            var req = {
                orderNo: orderNo,
                token: $stateParams.token
            };
            toolsService.ajaxPost('/app/verifyOrder', req).then(function (result) {
                if (result.success){
                    if (result.verified){
                        var request = {
                            orderNo: orderNo,
                            orderToken: result.token
                        };
                        toolsService.ajaxPostPdf('/document/download', request).then(function (data) {
                            var result = {}
                            if (data.byteLength < 150){
                                var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
                                result = JSON.parse(decodedString);
                            }
                            var success = true;
                            if (result.success == false) {
                                success = false;
                            }
                            if (!success) {
                                Alertify.error(result.message);
                            }
                            else {
                                var filename = 'Order_' + orderNo + '.pdf';
                                var file = new Blob([data], { type: 'application/pdf' });
                                saveAs(file, filename);
                            }
                        });
                    }
                    else{
                        Alertify.error('Unable to download pdf');
                    }
                }
                else{
                    Alertify.error(result.message);
                }
            });
        }
        //#endregion

        //#region download invoice
        $scope.downloadInvoice = function (invNo) {
            var req = {
                invNo: invNo,
                token: $stateParams.token
            };
            toolsService.ajaxPost('/app/verifyTransaction', req).then(function (result) {
                if (result.success){
                    if (result.verified){
                        var request = {
                            invNo: invNo,
                            invToken: result.token
                        };
                        toolsService.ajaxGetExcel('/invoice/downloadInvoice', request).then(function (data) {
                            var success = true;
                            if (data.success == false) {
                                success = false;
                            }
                            if (!success) {
                                Alertify.error('Unable to download invoice.');
                            }
                            else {
                                var filename = 'Invoice_' + invNo + '.pdf';
                                var file = new Blob([data], { type: 'application/pdf' });
                                saveAs(file, filename);
                            }
                        });
                    }
                    else{
                        Alertify.error('Unable to download invoice');
                    }
                }
                else{
                    Alertify.error(result.message);
                }
            });
        };
        //#endregion

        //#region payment response
        $scope.getPaymentResponse = function () {
            var request = {
                id: $stateParams.id,
            };
            toolsService.ajaxGet('/app/getPaymentResponse', request).then(function (data) {
                $scope.payment = data.payment;
            })
        };
        if ($state.current.name == 'payment') {
            $scope.getPaymentResponse();
        }
        //#endregion
    
        //#region send payment response
        $scope.sendResponse = function (backend) {

            var path = "paymentResponse";
            if (backend){
                path = "paymentResponseBackend";
            }
            var paymentResponse = JSON.parse(this.payment.response);

            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("target", "_self");
            // change for deployment - not for prod
            form.setAttribute("action", "http://localhost:3800/"+path);
            // form.setAttribute("action", "https://expressdev.mydata-ssm.com.my/"+path);
            // form.setAttribute("action", "https://expressstg.mydata-ssm.com.my/"+path);

            var PaymentId = document.createElement('input');
            PaymentId.type = 'hidden';
            PaymentId.name = 'PaymentId';
            PaymentId.value = paymentResponse.PaymentId;
            form.appendChild(PaymentId);

            var RefNo = document.createElement('input');
            RefNo.type = 'hidden';
            RefNo.name = 'RefNo';
            RefNo.value = paymentResponse.RefNo;
            form.appendChild(RefNo);

            var Amount = document.createElement('input');
            Amount.type = 'hidden';
            Amount.name = 'Amount';
            Amount.value = paymentResponse.Amount;
            form.appendChild(Amount);

            var TransId = document.createElement('input');
            TransId.type = 'hidden';
            TransId.name = 'TransId';
            TransId.value = paymentResponse.TransId;
            form.appendChild(TransId);

            var Status = document.createElement('input');
            Status.type = 'hidden';
            Status.name = 'Status';
            Status.value = paymentResponse.Status;
            form.appendChild(Status);

            var ErrDesc = document.createElement('input');
            ErrDesc.type = 'hidden';
            ErrDesc.name = 'ErrDesc';
            ErrDesc.value = paymentResponse.ErrDesc;
            form.appendChild(ErrDesc);

            var TranDate = document.createElement('input');
            TranDate.type = 'hidden';
            TranDate.name = 'TranDate';
            TranDate.value = paymentResponse.TranDate;
            form.appendChild(TranDate);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        };
        //#endregion

    }

    angular.module('mydata.service').controller('payment.modal.controller', PaymentModalController);
    function PaymentModalController($scope, items) {
        $scope.paymentDetail = items;
    }

    angular.module('mydata.service').controller('payment.pi.controller', PaymentPIController);
    function PaymentPIController($scope, paymentData) {
        $scope.paymentData = paymentData;
    }


})();
  
(function () {
    'use strict';

    angular.module('mydata.transaction').controller('transaction.controller', TransactionController);

    function TransactionController($scope, toolsService, $state, $stateParams, $rootScope, Alertify, $filter, $uibModal) {

        $scope.smartTablePageSize = 10;
        $scope.trxTableData = [];
        $scope.allTrxTableData = [];
        $scope.trxItemTableData = [];

        //#region datepicker 
        $scope.popupDateFrom = {
            opened: false
        };
        $scope.openDateFrom = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.popupDateTo = {
            opened: false
        };
        $scope.openDateTo = function () {
            $scope.popupDateTo.opened = true;
        };
        //#endregion

        //#region load all agency
        $scope.agencyWithSearch = { selected: {} };
        $scope.loadAgency = function () {
            $scope.userWithSearch = { selected: {} };
            toolsService.ajaxGet('/report/getUserAgency').then(function (data) {
                $scope.agencyOption = data.options;
            });
        };
        //#endregion

        //#region load all user
        $scope.userWithSearch = { selected: {} };
        $scope.loadUser = function () {
            var request = {}
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/report/getAllUser', request).then(function (data) {
                $scope.userOption = data.options;
                // $scope.userWithSearch.selected = data.value;
            });
        };
        //#endregion

        //#region load agency user
        $scope.agencyUserWithSearch = { selected: {} };
        $scope.loadAgencyUser = function () {
            toolsService.ajaxGet('/report/getAllAgencyUser').then(function (data) {
                $scope.agencyUserOption = data.options;
            });
        };
        //#endregion

        //#region load project agency dropdown
        $scope.projectAgencyWithSearch = { selected: {} };
        $scope.loadProjectAgencyList = function () {
            toolsService.ajaxGet('/project/getProjectAgencyList').then(function (data) {
                $scope.projectAgencyList = data.projectAgencyList;
            });
        };
        //#endregion

        //#region load project all dropdown
        $scope.projectAllWithSearch = { selected: {} };
        $scope.loadProjectAllList = function () {
            toolsService.ajaxGet('/project/getProjectAllList').then(function (data) {
                $scope.projectAllList = data.projectAllList;
            });
        };
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            $scope.rowCount = pagination.rowCount;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region transaction list - normal user
        $scope.trxTableFilter = function (tableState, ctrl) {
            $scope.trxCtrl = ctrl;
        };
        $scope.searchTransaction = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxNo: this.trxNo || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxPost('/transaction/transactionSearch', request).then(function (data) {
                $scope.trxTableData = data.data;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'transaction.search') {
            $scope.searchTransaction();
        }
        if ($state.current.name == 'transaction.ssm') {
            $scope.searchTransaction();
        }
        $scope.selectTrxPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxNo: this.trxNo || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxPost('/transaction/transactionSearch', request).then(function (data) {
                $scope.trxTableData = data.data;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region transaction detail - normal user
        $scope.trxItemTableFilter = function (tableState, ctrl) {
            $scope.trxCtrl = ctrl;
        };
        $scope.loadTransactionDetail = function (trxId) {
            var request = {
                trxId: trxId,
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/transaction/getTransactionDetail', request).then(function (data) {
                $scope.trx = data.trxData;
                $scope.itemCount = data.itemCount;
                $scope.trxItemTableData = data.orderData;
                pagination(data.pagination)
            });
        };

        if ($state.current.name == 'transaction.detail') {
            $scope.loadTransactionDetail($stateParams.trxId);
        }
        if ($state.current.name == 'transaction.SSMDetail') {
            $scope.loadTransactionDetail($stateParams.SSMTransId);
        }

        $scope.selectTrxItemPage = function (trxId, page) {
            var request = {
                trxId: trxId,
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/transaction/getTransactionDetail', request).then(function (data) {
                $scope.trxItemTableData = data.orderData;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region transaction list - administrator
        $scope.allTrxTableFilter = function (tableState, ctrl) {
            $scope.trxCtrl = ctrl;
        };
        $scope.searchAllTransaction = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxType: this.trxType || '',
                trxNo: this.trxNo || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            // if (this.agencyWithSearch) {
            //     request.agencyId = this.agencyWithSearch.selected.id;
            //     request.agencyName = this.agencyWithSearch.selected.agencyName;
            // }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            toolsService.ajaxPost('/transaction/transactionSearchAll', request).then(function (data) {
                $scope.allTrxTableData = data.data;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'transaction.all') {
            $scope.searchAllTransaction();
        }
        $scope.selectAllTrxPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxType: this.trxType || '',
                trxNo: this.trxNo || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            // if (this.agencyWithSearch) {
            //     request.agencyId = this.agencyWithSearch.selected.id;
            //     request.agencyName = this.agencyWithSearch.selected.agencyName;
            // }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            toolsService.ajaxPost('/transaction/transactionSearchAll', request).then(function (data) {
                $scope.allTrxTableData = data.data;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region transaction export - administrator
        $scope.exportAllTrxToExcel = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxType: this.trxType || '',
                trxNo: this.trxNo || ''
            }
            // if (this.agencyWithSearch) {
            //     request.agencyId = this.agencyWithSearch.selected.id;
            //     request.agencyName = this.agencyWithSearch.selected.agencyName;
            // }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            toolsService.ajaxPostPdf('/transaction/exportAllTrxToExcel', request).then(function (data) {
                var blob = new Blob(
                    [data],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }
                );
                saveAs(blob, 'Transaction.xlsx');
            })
        }
        //#endregion

        //#region transaction detail - account admin / administrator
        $scope.trxAllItemTableFilter = function (tableState, ctrl) {
            $scope.trxCtrl = ctrl;
        };
        $scope.loadAllTransactionDetail = function (trxId) {
            var request = {
                trxId: trxId,
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/transaction/getAllTransactionDetail', request).then(function (data) {
                $scope.trxAll = data.allTrxData;
                $scope.allItemCount = data.allItemCount;
                $scope.trxAllItemTableData = data.OrderData;
                pagination(data.pagination)
            });
        };
        if($state.current.name == 'transaction.allDetail'){
            $scope.loadAllTransactionDetail($stateParams.transId);
        }
        if($state.current.name == 'transaction.agencyDetail'){
            $scope.loadAllTransactionDetail($stateParams.trx_id);
        }
        $scope.selectTrxAllPage = function (trxId, page) {
            var request = {
                trxId: trxId,
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            toolsService.ajaxGet('/transaction/getAllTransactionDetail', request).then(function (data) {
                $scope.trxAllItemTableData = data.OrderData;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region transaction list - account admin
        $scope.agencyTrxTableFilter = function (tableState, ctrl) {
            $scope.trxCtrl = ctrl;
        };
        $scope.searchAgencyTransaction = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxType: this.trxType || '',
                trxNo: this.trxNo || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            toolsService.ajaxPost('/transaction/transactionSearchAgency', request).then(function (data) {
                $scope.agencyTrxTableData = data.data;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'transaction.agency') {
            $scope.loadProjectAgencyList()
            $scope.searchAgencyTransaction();
        }
        $scope.selectAgencyTrxPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                trxType: this.trxType || '',
                trxNo: this.trxNo || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            toolsService.ajaxPost('/transaction/transactionSearchAgency', request).then(function (data) {
                $scope.agencyTrxTableData = data.data;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region download invoice
        $scope.getInvoice = function (trxId, trxNo) {
            var req = {
                trxId: trxId
            }
            toolsService.ajaxGet('/transaction/prepareInvoice', req).then(function (result) {
                var request = {
                    trxId: trxId
                }
                toolsService.ajaxPostPdf('/transaction/getInvoice', request).then(function (data) {
                    var success = true;
                    if (data.success == false) {
                        success = false;
                    }
                    if (!success) {
                        Alertify.error('Unable to download invoice.');
                    }
                    else {
                        var filename = 'TaxInvoice_' + trxNo + '.pdf';
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, filename);
                    }
                })
            })
        }
        //#endregion

        //#region download receipt
        $scope.getReceipt = function (userId, receiptNo) {
            var request = {
                receiptNo: receiptNo,
                userId: userId,
            }
            toolsService.ajaxPostPdf('/transaction/getReceipt', request).then(function (data) {
                var success = true;
                if (data.success == false) {
                    success = false;
                }
                if (!success) {
                    Alertify.error('Unable to download receipt.');
                }
                else {
                    var filename = 'Receipt_' + receiptNo + '.pdf';
                    var file = new Blob([data], { type: 'application/pdf' });
                    saveAs(file, filename);
                }
            })
        }
        //#endregion

        //#region update billing info
        $scope.updateBillingModal = function (trxId) {
            var trxItems = {
                trxId: trxId
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/transaction/transaction-billing.modal.html',
                controller: 'transaction.billing.controller',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    trxItems: function () {
                        return trxItems;
                    }
                }
            })
        }
        $scope.updateBilling = function() {
            var request = {
                billingExist: this.billingExist,
                billingTrxId: this.billingTrxId,
                billingId: this.billing.id,
                billingName: this.billing.name || $rootScope.currentUser.userName,
                address1: this.billing.address1 || '',
                address2: this.billing.address2 || '',
                address3: this.billing.address3 || '',
                postcode: this.billing.postcode || '',
                city: this.billing.city || '',
                state: this.billing.state || ''
            };
            toolsService.ajaxPost('/transaction/updateBilling', request).then(function (data) {
                if (data.success){
                    Alertify.success('Successfully update billing info.')
                }
                else{
                    Alertify.error('Unsuccessful to update billing info')
                }
                location.reload()
                // $scope.loadAllTransactionDetail(request.billingTrxId);
            })
        }
        //#endregion
        
    }

    angular.module('mydata.transaction').controller('transaction.billing.controller', TransactionBillingController);
    function TransactionBillingController($scope, toolsService, trxItems) {
        var request = {
            trxId: trxItems.trxId
        }
        toolsService.ajaxGet('/transaction/getBillingInfo', request).then(function (data) {
            $scope.billingTrxId = trxItems.trxId
            $scope.billingExist = data.billingExist
            $scope.billing = {
                id: data.billing.id,
                name: data.billing.name,
                address1: data.billing.address1,
                address2: data.billing.address2,
                address3: data.billing.address3,
                postcode: data.billing.postcode,
                city: data.billing.city,
                state: data.billing.state
            }
        })
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes, $http, toolsService, $state, $rootScope, $stateParams) {

    $scope.smartTablePageSize = 10;



    $scope.smartTableData3 = [];

    $scope.docDownloadFilter3 = function(tablestate, ctrl)
    {
      $scope.docCtrl = ctrl;
    }

    $scope.docDownloadList3 = function(userId)
    {
      var request = {
        userId: userId,
      };
      toolsService.ajaxGet('/document/documentDownloadList3', request).then(function (data) {
        $scope.smartTableData3 = data.data;
        console.log(data.data);
      });
    };

    // if($stateParams.userId != '' && typeof $stateParams.userId != 'undefined'){
    //   $scope.docDownloadList3($stateParams.userId);
    // }
    $scope.docDownloadList3(1);



    $scope.smartTableData2 = 
    [ { id: 88,
        requestId: '41',
        userId: '1',
        documentType: 'Profile',
        documentName: 'Company Profile',
        // // documentDate: 2017-10-30T16:00:00.000Z,
        entityName: 'SERI MANDALAS MEDIA SDN. BHD.',
        entityNumber: '989095-T',
        entityType: 'Company',
        status: 'Success',
        verId: 'FOCS2017110800001',
        processBy: '2',
        processDate: '2017-11-08 10:49:01',
        // created_at: 2017-10-31T08:49:06.000Z,
        // updated_at: 2017-11-08T02:49:06.000Z 
      },
      { id: 89,
        requestId: '41',
        userId: '1',
        documentType: '481',
        documentName: 'Statutory Declaration',
        // documentDate: 2012-04-18T16:00:00.000Z,
        entityName: 'SERI MANDALAS MEDIA SDN. BHD.',
        entityNumber: '989095-T',
        entityType: 'Company',
        status: 'Success',
        verId: '2771206',
        processBy: '2',
        processDate: '2017-11-08 10:49:01',
        // created_at: 2017-10-31T08:49:06.000Z,
        // updated_at: 2017-11-08T02:49:06.000Z 
      },
      { id: 98,
        requestId: '43',
        userId: '1',
        documentType: 'Profile',
        documentName: 'Company Profile',
        // documentDate: 2017-11-01T16:00:00.000Z,
        entityName: 'PASOKOM SDN. BHD.',
        entityNumber: '984553-D',
        entityType: 'Company',
        status: 'Success',
        verId: 'FOCS2017110600001',
        processBy: '2',
        processDate: '2017-11-06 10:53:15',
        // created_at: 2017-11-02T01:38:24.000Z,
        // updated_at: 2017-11-06T02:53:29.000Z 
      },
      { id: 99,
        requestId: '43',
        userId: '1',
        documentType: '108',
        documentName: 'Surat Seksyen 308(1)',
        // documentDate: 2016-03-15T16:00:00.000Z,
        entityName: 'PASOKOM SDN. BHD.',
        entityNumber: '984553-D',
        entityType: 'Company',
        status: 'Success',
        verId: '3259557',
        processBy: '2',
        processDate: '2017-11-06 10:53:15',
        // created_at: 2017-11-02T01:38:24.000Z,
        // updated_at: 2017-11-06T02:53:29.000Z 
      },
      { id: 125,
        requestId: null,
        userId: '1',
        documentType: 'Profile',
        documentName: 'Company Profile',
        // documentDate: 2017-11-13T16:00:00.000Z,
        entityName: 'ZIN SOFTWARE INDUSTRY SDN. BHD.',
        entityNumber: '983779-T',
        entityType: 'Company',
        status: 'Success',
        verId: 'FOCS2017111400003',
        processBy: '1',
        processDate: '2017-11-14 16:50:40.183',
        // created_at: 2017-11-14T07:00:10.000Z,
        // updated_at: 2017-11-14T08:50:50.000Z 
      },
      { id: 126,
        requestId: null,
        userId: '1',
        documentType: '24',
        documentName: 'Borang 24 / S. 78 - Return for allotment of shares',
        // documentDate: 2012-03-22T16:00:00.000Z,
        entityName: 'ZIN SOFTWARE INDUSTRY SDN. BHD.',
        entityNumber: '983779-T',
        entityType: 'Company',
        status: 'Success',
        verId: '2776266',
        processBy: '1',
        processDate: '2017-11-14 16:55:41.497',
        // created_at: 2017-11-14T07:00:10.000Z,
        // updated_at: 2017-11-14T08:55:42.000Z 
      },
      { id: 127,
        requestId: null,
        userId: '1',
        documentType: '9',
        documentName: 'Cert. Of Incorporation Of Private Company',
        // documentDate: 2012-03-22T16:00:00.000Z,
        entityName: 'ZIN SOFTWARE INDUSTRY SDN. BHD.',
        entityNumber: '983779-T',
        entityType: 'Company',
        status: 'Success',
        verId: '2847482',
        processBy: '1',
        processDate: '2017-11-14 16:55:41.497',
        // created_at: 2017-11-14T07:00:10.000Z,
        // updated_at: 2017-11-14T08:55:42.000Z 
      },
      { id: 128,
        requestId: null,
        userId: '1',
        documentType: '481',
        documentName: 'Statutory Declaration',
        // documentDate: 2012-03-15T16:00:00.000Z,
        entityName: 'ZIN SOFTWARE INDUSTRY SDN. BHD.',
        entityNumber: '983779-T',
        entityType: 'Company',
        status: 'Success',
        verId: '2847484',
        processBy: '1',
        processDate: '2017-11-14 16:55:41.497',
        // created_at: 2017-11-14T07:00:10.000Z,
        // updated_at: 2017-11-14T08:55:42.000Z 
      },
      { id: 129,
        requestId: null,
        userId: '1',
        documentType: '6',
        documentName: 'Declaration Of Compliance / S. 14 - Superform',
        // documentDate: 2012-03-15T16:00:00.000Z,
        entityName: 'ZIN SOFTWARE INDUSTRY SDN. BHD.',
        entityNumber: '983779-T',
        entityType: 'Company',
        status: 'Success',
        verId: '2847485',
        processBy: '1',
        processDate: '2017-11-14 16:55:41.497',
        // created_at: 2017-11-14T07:00:10.000Z,
        // updated_at: 2017-11-14T08:55:42.000Z 
      },
      { id: 130,
        requestId: null,
        userId: '1',
        documentType: '559',
        documentName: 'Annual Return',
        // documentDate: 2013-03-30T16:00:00.000Z,
        entityName: 'ZIN SOFTWARE INDUSTRY SDN. BHD.',
        entityNumber: '983779-T',
        entityType: 'Company',
        status: 'Success',
        verId: '2903890',
        processBy: '1',
        processDate: '2017-11-14 16:55:41.497',
        // created_at: 2017-11-14T07:00:10.000Z,
        // updated_at: 2017-11-14T08:55:42.000Z 
      } 
    ];

    console.log($scope.smartTableData2);

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

(function () {
    'use strict';

    angular.module('mydata.user').controller('user.controller', UserController);

    function UserController($scope, $filter, toolsService, $state, $stateParams, $rootScope, Alertify, $uibModal) {

        $scope.smartTablePageSize = 10;
        $scope.smartTableData = [];

        //#region datepicker 
        $scope.popupDateFrom = {
            opened: false
        };
        $scope.openDateFrom = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.popupDateTo = {
            opened: false
        };
        $scope.openDateTo = function () {
            $scope.popupDateTo.opened = true;
        };
        //#endregion

        //#region dropdown selection
        $scope.agencyWithSearch = { selected: {} };
        $scope.loadAgency = function () {
            toolsService.ajaxGet('/report/getUserAgency').then(function (data) {
                $scope.agencyList = data.options;
            });
        };
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region user list - administrator
        $scope.userFilter = function (tablestate, ctrl) {
            $scope.stCtrl = ctrl;
        }
        $scope.searchUser = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                name: this.userName || '',
                status: this.status || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/user/userSearch', request).then(function (data) {
                $scope.smartTableData = data.data;
                pagination(data.pagination)
            },
            function (error) {
                $state.transitionTo('login');
            });
        };
        if ($state.current.name == 'user.search') {
            $scope.searchUser();
        }
        $scope.selectPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                name: this.userName || '',
                status: this.status || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/user/userSearch', request).then(function (data) {
                $scope.smartTableData = data.data;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region export user list - administrator
        $scope.exportUserExcel = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                name: this.userName || '',
                status: this.status || ''
            };
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGetExcel('/user/exportUserExcel', request).then(function (data) {
                var blob = new Blob(
                    [data],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }
                );
                saveAs(blob, 'User List.xlsx');
            });
        };
        //#endregion

        //#region user detail - administrator
        $scope.loadUserData = function (userId) {
            var request = {
                userId: userId
            };
            toolsService.ajaxGet('/user/getUser', request).then(function (data) {
                $scope.user = data.data;
            });
        };
        // if ($stateParams.userId != '' && typeof $stateParams.userId != 'undefined') {
        if ($state.current.name == 'user.manage') {
            $scope.loadUserData($stateParams.userId);
        }
        //#endregion

        //#region user edit
        $scope.editUser = function () {
            var request = {
                userId: this.user.id,
                role: this.user.role,
                status: this.user.status,
                note: this.user.note
            };
            toolsService.ajaxPost('/user/updateUser', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully saved data')
                    $state.transitionTo('user.search');
                }
                else {
                    Alertify.error('Unsuccessful to update data')
                }
            });
        };
        //#endregion

        //#region user list - account admin
        $scope.searchAgencyUser = function () {
            toolsService.ajaxGet('/user/agencyUserSearch').then(function (data) {
                $scope.agencyUserList = data.data;
            })
        }
        if ($state.current.name == 'user.list') {
            $scope.searchAgencyUser();
        }
        //#endregion

        //#region user detail - account admin
        $scope.loadAgencyUserData = function (userId) {
            var request = {
                userId: userId
            };
            toolsService.ajaxGet('/user/getAgencyUser', request).then(function (data) {
                $scope.agencyUser = data.data;
            });
        };
        // if ($stateParams.user_id != '' && typeof $stateParams.user_id != 'undefined') {
        if ($state.current.name == 'user.detail') {
            $scope.loadAgencyUserData($stateParams.user_id);
        }
        //#endregion

        //#region user edit - account admin
        $scope.editAgencyUser = function () {
            var request = {
                userId: this.agencyUser.id,
                role: this.agencyUser.role,
                status: this.agencyUser.status,
                note: this.agencyUser.note
            };
            toolsService.ajaxPost('/user/updateAgencyUser', request).then(function (data) {
                if (data.success) {
                    Alertify.success('Successfully saved data')
                    $state.transitionTo('user.list');
                }
                else {
                    Alertify.error('Unsuccessful to update data')
                }
            });
        };
        //#endregion

        //#region user profile
        $scope.viewProfile = function () {
            toolsService.ajaxGet('/user/getUserProfile').then(function (data) {
                $scope.user = data.data;
                //#region payment response
                if ($stateParams.trxId){
                    var request = {
                        trxId: $stateParams.trxId
                    }
                    toolsService.ajaxPost('/user/processTopupPayment', request).then(function (data) {
                        if (data.success){
                            var items = {trxId: $stateParams.trxId}
                            $uibModal.open({
                                animation: true,
                                templateUrl: 'app/pages/user/topup-confirmation.modal.html',
                                controller: 'topup.confirmation.controller',
                                size: 'md',
                                backdrop: 'static',
                                resolve: {
                                    items: function () {
                                        return items;
                                    }
                                }
                            });
                            $stateParams.trxId = ''
                            $state.transitionTo('user.profile')
                        }
                    })
                }
                //#endregion
            });
        };
        if ($state.current.name == 'user.profile') {
            $scope.viewProfile();
        }
        //#endregion

        //#region user profile update
        $scope.updateProfile = function () {
            var request = {
                fullName: this.user.fullName,
                phoneNo: this.user.phoneNo,
                address1: this.user.address1,
                address2: this.user.address2,
                address3: this.user.address3,
                postcode: this.user.postcode,
                city: this.user.city,
                state: this.user.state,
            };
            toolsService.ajaxPost('/user/updateUserProfile', request).then(function (data) {
                if (data.success) {
                    // $rootScope.currentUser.userName = data.data.fullName;
                    Alertify.success(data.message);
                    $state.transitionTo('entity.search');
                }
                else{
                    Alertify.error(data.message);
                }
            });
        };
        //#endregion

        //#region topup credit
        $scope.manageCreditModal = function (userId, status, role, note) {
            var request = {
                userId: userId
            };
            toolsService.ajaxGet('/user/getUserCreditBalance', request).then(function (data) {
                var userData = {
                    userId: userId,
                    creditBalance: data.creditBalance,
                    status: status,
                    role: role,
                    note: note
                };
                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/user/manage-credit.modal.html',
                    controller: 'manage.credit.controller',
                    size: 'md',
                    backdrop: 'static',
                    resolve: {
                        userData: function () {
                            return userData;
                        }
                    }
                });
            });
        };
        $scope.manageCredit = function (userId, creditBalance, status, role, note) {
            if (this.trxAmt < 0.1){
                $scope.trxAmtErr = 'Invalid amount value.'
            }
            else{
                var request = {
                    userId: userId,
                    creditBalance: creditBalance,
                    trxType: this.trxType,
                    trxAmt: parseFloat(this.trxAmt),
                    trxDesc: this.trxDesc,
                    role: role,
                    status: status,
                    note: note
                };
                toolsService.ajaxPost('/user/manageCredit', request).then(function (data) {
                    if (data.success) {
                        Alertify.success('Successfully saved data')
                        location.reload();
                    }
                    else {
                        Alertify.error('Unsuccessful to update data')
                    }
                });
            }
        };
        //#endregion

        //#region transfer/delegate credit
        $scope.transferCreditModal = function (userId, name, status, role, note) {
            var updateUserData = {
                id: userId,
                name: name,
                status: status,
                role: role,
                note: note
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/user/delegate-credit-detail.modal.html',
                controller: 'return.credit.controller',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    updateUserData: function () {
                        return updateUserData;
                    }
                }
            })
        }
        $scope.delegateCreditModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/user/delegate-credit-list.modal.html',
                controller: 'delegate.credit.controller',
                size: 'md',
                backdrop: 'static'
            })
        }
        $scope.delegateCredit = function (delegateUserId, delegateAmount, status, role, note) {
            if (delegateUserId) {
                if (delegateAmount <= this.accountUserData.creditBalance) {
                    document.getElementById('submitButton').disabled = true;
                    var request = {
                        delegateUserId: delegateUserId || this.delegateUserWithSearch.selected.id,
                        delegateAmount: delegateAmount || this.delegateAmount,
                        role: role,
                        status: status,
                        note: note
                    }
                    toolsService.ajaxPost('/user/delegateCredit', request).then(function (data) {
                        if (data.success) {
                            Alertify.success('Successful delegate credit')
                            location.reload()
                        }
                        else {
                            Alertify.error('Unsuccessful to delegate credit')
                        }
                    })
                }
                else {
                    Alertify.success('Delegate Credit Amount must be less than or equal to Credit Available')
                }
            }
            else {
                Alertify.success('Please select Delegate Credit To')
            }
        }
        //#endregion

        //#region return/take credit
        $scope.takeCreditModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/user/return-credit-list.modal.html',
                controller: 'delegate.credit.controller',
                size: 'md',
                backdrop: 'static'
            })
        }
        $scope.returnCreditModal = function (userId, name, status, role, note, creditBalance) {
            var updateUserData = {
                id: userId,
                name: name,
                status: status,
                role: role,
                note: note,
                creditBalance: creditBalance
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/user/return-credit-detail.modal.html',
                controller: 'return.credit.controller',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    updateUserData: function () {
                        return updateUserData;
                    }
                }
            })
        }
        $scope.updateReturnUserCredit = function (creditBalance) {
            $scope.returnUser = { creditBalance: creditBalance }
        }
        $scope.returnCredit = function (returnUserId, returnAmount, status, role, note, creditBalance) {
            if (returnUserId) {
                if (returnAmount <= creditBalance) {
                    document.getElementById('submitButton').disabled = true;
                    var request = {
                        returnUserId: returnUserId || this.delegateUserWithSearch.selected.id,
                        returnAmount: returnAmount || this.returnAmount,
                        role: role,
                        status: status,
                        note: note
                    }
                    toolsService.ajaxPost('/user/returnCredit', request).then(function (data) {
                        if (data.success) {
                            Alertify.success('Successful return credit')
                            location.reload()
                        }
                        else {
                            Alertify.error('Unsuccessful to return credit')
                        }
                    })
                }
                else {
                    Alertify.success('Return Credit Amount must be less than or equal to Credit Balance')
                }
            }
            else {
                Alertify.success('Please select Return Credit From')
            }
        }
        //#endregion

        //#region online topup credit
        $scope.topupCreditModal = function (userId) {
            var topupItems = {userId:userId}
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/user/topup-credit.modal.html',
                controller: 'topup.credit.controller',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    topupItems: function () {
                        return topupItems;
                    }
                }
            });
        };
        $scope.topupCredit = function () {
            if (!this.topupAmount || this.topupAmount < 1){
                Alertify.success('Minimun Topup Amount is RM1.00')
            }
            else{
                var request = {
                    creditBalance: this.topupBilling.creditBalance,
                    topupAmount: this.topupAmount,
                    billingName: this.topupBilling.name || $rootScope.currentUser.userName,
                    billingEmail: this.topupBilling.email || '',
                    billingAddressOne: this.topupBilling.address1,
                    billingAddressTwo: this.topupBilling.address2,
                    billingAddressThree: this.topupBilling.address3,
                    billingPostcode: this.topupBilling.postcode,
                    billingCity: this.topupBilling.city,
                    billingState: this.topupBilling.state
                };
                toolsService.ajaxPost('/user/prepareTopupCredit', request).then(function (data) {
                    if (data.success){

                        // var req = { 
                        //     MerchantCode: 'M05232',
                        //     PaymentId: '6',
                        //     RefNo: data.trxRef,
                        //     Amount: '1.00',
                        //     Discount: '',
                        //     Currency: 'MYR',
                        //     Remark: '',
                        //     TransId: 'T202806660500',
                        //     AuthCode: 'T98061',
                        //     Status: '1',
                        //     ErrDesc: '',
                        //     // Status: '0',
                        //     // ErrDesc: 'Customer Cancel Transaction',
                        //     // ErrDesc: 'Cancel By Bank',
                        //     PayerEmail: '',
                        //     ExpiryDate: '',
                        //     Signature: '154ee03fdb42238ac9b0fea136533c54851e96fce148babaac3969a5f5e3855d',
                        //     CCName: 'Arif Hussain',
                        //     CCNo: '540067xxxxxx5370',
                        //     S_bankname: 'MALAYAN BANKING BERHAD',
                        //     S_country: 'MY',
                        //     OldTokenId: '',
                        //     HiddenToURL: 'http://localhost:3400/paymentResponse',
                        //     fpx_fpxTxnTime: '',
                        //     fpx_fpxTxnId: '',
                        //     fpx_buyerBankBranch: '',
                        //     TokenId: '',
                        //     BindCardErrDesc: '',
                        //     PANTrackNo: '',
                        //     ActionType: '',
                        //     BankMID: '00000313825',
                        //     TranDate: '2019-01-15' 
                        // }
                        // toolsService.ajaxPostTest('/paymentResponse', req).then(function(){});

                        var form = document.createElement("form");
                        form.setAttribute("method", "post");
                        form.setAttribute("target", "_self");
                        form.setAttribute("action", "https://ministg.mydata-ssm.com.my/proceedPaymentLite");

                        var transactionId = document.createElement('input');
                        transactionId.type = 'hidden';
                        transactionId.name = 'transactionId';
                        transactionId.value = data.trxRef;
                        form.appendChild(transactionId);

                        var amount = document.createElement('input');
                        amount.type = 'hidden';
                        amount.name = 'amount';
                        amount.value = request.topupAmount;
                        form.appendChild(amount);

                        var billingName = document.createElement('input');
                        billingName.type = 'hidden';
                        billingName.name = 'billingName';
                        billingName.value = request.billingName;
                        form.appendChild(billingName);

                        var billingEmail = document.createElement('input');
                        billingEmail.type = 'hidden';
                        billingEmail.name = 'billingEmail';
                        billingEmail.value = request.billingEmail;
                        form.appendChild(billingEmail);

                        var billingAddressOne = document.createElement('input');
                        billingAddressOne.type = 'hidden';
                        billingAddressOne.name = 'billingAddressOne';
                        billingAddressOne.value = request.billingAddressOne;
                        form.appendChild(billingAddressOne);

                        var billingAddressTwo = document.createElement('input');
                        billingAddressTwo.type = 'hidden';
                        billingAddressTwo.name = 'billingAddressTwo';
                        billingAddressTwo.value = request.billingAddressTwo;
                        form.appendChild(billingAddressTwo);

                        var billingAddressThree = document.createElement('input');
                        billingAddressThree.type = 'hidden';
                        billingAddressThree.name = 'billingAddressThree';
                        billingAddressThree.value = request.billingAddressThree;
                        form.appendChild(billingAddressThree);

                        var billingPostcode = document.createElement('input');
                        billingPostcode.type = 'hidden';
                        billingPostcode.name = 'billingPostcode';
                        billingPostcode.value = request.billingPostcode;
                        form.appendChild(billingPostcode);

                        var billingCity = document.createElement('input');
                        billingCity.type = 'hidden';
                        billingCity.name = 'billingCity';
                        billingCity.value = request.billingCity;
                        form.appendChild(billingCity);

                        var billingState = document.createElement('input');
                        billingState.type = 'hidden';
                        billingState.name = 'billingState';
                        billingState.value = request.billingState;
                        form.appendChild(billingState);

                        document.body.appendChild(form);
                        form.submit();
                        document.body.removeChild(form);
                    }
                    else{
                        Alertify.success('Unsuccessful to topup credit')
                    }
                })
            }
        };
        //#endregion

        //#region reload page
        $scope.reloadPage = function () {
            location.reload()
        };
        //#endregion
        
    }

    angular.module('mydata.user').controller('manage.credit.controller', ManageCreditController);
    function ManageCreditController($scope, userData) {
        $scope.userData = userData
        $scope.trxType = 'Topup Credit'
    }

    angular.module('mydata.user').controller('delegate.credit.controller', DelegateCreditController);
    function DelegateCreditController($scope, $rootScope, toolsService) {

        //#region load delegate user
        $scope.delegateUserWithSearch = { selected: {} };
        $scope.loadDelegateUser = function () {
            toolsService.ajaxGet('/user/getDelegateUser').then(function (data) {
                $scope.delegateUserOption = data.options;
            });
        };
        //#endregion load delegate user

        //#region get account user data
        $scope.getAccountUserData = function () {
            toolsService.ajaxGet('/user/getAccountUserData').then(function (result) {
                $scope.accountUserData = result.accountUserData;
            })
        }
        $scope.getAccountUserData()
        //#endregion
    }

    angular.module('mydata.user').controller('return.credit.controller', ReturnCreditController);
    function ReturnCreditController($scope, toolsService, updateUserData) {

        $scope.updateUserData = updateUserData;

        //#region get account user data
        $scope.getAccountUserData = function () {
            toolsService.ajaxGet('/user/getAccountUserData').then(function (result) {
                $scope.accountUserData = result.accountUserData;
            })
        }
        $scope.getAccountUserData()
        //#endregion
    }

    angular.module('mydata.user').controller('returnCreditModalCtrl', returnCreditModalCtrl)
    function returnCreditModalCtrl($scope, toolsService) {

        //#region load delegate user
        $scope.delegateUserWithSearch = { selected: {} };
        $scope.loadDelegateUser = function () {
            toolsService.ajaxGet('/user/getDelegateUser').then(function (data) {
                $scope.delegateUserOption = data.options;
            })
        }
        //#endregion load delegate user

        //#region get account user data
        $scope.getAccountUserData = function () {
            toolsService.ajaxGet('/user/getAccountUserData').then(function (result) {
                $scope.accountUserData = result.accountUserData;
            })
        }
        $scope.getAccountUserData()
        //#endregion
    }

    angular.module('mydata.user').controller('topup.credit.controller', TopupCreditController);
    function TopupCreditController($scope, toolsService, topupItems) {
        var request = {
            userId: topupItems.userId
        }
        toolsService.ajaxPost('/user/billingInfo', request).then(function (data) {
            $scope.topupBilling = {
                name: data.billing.fullName,
                creditBalance: data.billing.creditBalance,
                email: data.billing.email,
                address1: data.billing.address1,
                address2: data.billing.address2,
                address3: data.billing.address3,
                postcode: data.billing.postcode,
                city: data.billing.city,
                state: data.billing.state
            }
        })
    }

    angular.module('mydata.user').controller('topup.confirmation.controller', TopupConfirmationController);
    function TopupConfirmationController($scope, toolsService, items) {
        var request = {
            trxId: items.trxId
        }
        toolsService.ajaxPost('/user/getTopupConfirmation', request).then(function (data) {
            $scope.topupDetail = {
                userId: data.topupDetail.user_id,
                topupAmt: data.topupDetail.topup_amount,
                newCreditBalance: data.topupDetail.new_credit_balance,
                receiptNo: data.topupDetail.invoice_no,
                trxDate: data.topupDetail.trx_date,
                paymentRef: data.topupDetail.payment_ref,
                paymentStatus: data.topupDetail.payment_status,
                errMsg: data.topupDetail.err_msg
            }
        })
    }

})();

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd !== null)) {
  define("FileSaver.js", function() {
    return saveAs;
  });
}

/** @preserve
 * jsPDF - PDF Document creation from JavaScript
 * Version ${versionID}
 *                           CommitID ${commitID}
 *
 * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, willow-systems.com
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */

/**
 * Creates new jsPDF document object instance.
 * @name jsPDF
 * @class
 * @param orientation One of "portrait" or "landscape" (or shortcuts "p" (Default), "l") <br />
 * Can also be an options object.
 * @param unit        Measurement unit to be used when coordinates are specified.
 *                    One of "pt" (points), "mm" (Default), "cm", "in"
 * @param format      One of 'pageFormats' as shown below, default: a4
 * @returns {jsPDF}
 * @description
 * If the first parameter (orientation) is an object, it will be interpreted as an object of named parameters
 * ```
 * {
 *  orientation: 'p',
 *  unit: 'mm',
 *  format: 'a4',
 *  hotfixes: [] // an array of hotfix strings to enable
 * }
 * ```
 */
var jsPDF = (function(global) {
  'use strict';
  var pdfVersion = '1.3',
    pageFormats = { // Size in pt of various paper formats
      'a0': [2383.94, 3370.39],
      'a1': [1683.78, 2383.94],
      'a2': [1190.55, 1683.78],
      'a3': [841.89, 1190.55],
      'a4': [595.28, 841.89],
      'a5': [419.53, 595.28],
      'a6': [297.64, 419.53],
      'a7': [209.76, 297.64],
      'a8': [147.40, 209.76],
      'a9': [104.88, 147.40],
      'a10': [73.70, 104.88],
      'b0': [2834.65, 4008.19],
      'b1': [2004.09, 2834.65],
      'b2': [1417.32, 2004.09],
      'b3': [1000.63, 1417.32],
      'b4': [708.66, 1000.63],
      'b5': [498.90, 708.66],
      'b6': [354.33, 498.90],
      'b7': [249.45, 354.33],
      'b8': [175.75, 249.45],
      'b9': [124.72, 175.75],
      'b10': [87.87, 124.72],
      'c0': [2599.37, 3676.54],
      'c1': [1836.85, 2599.37],
      'c2': [1298.27, 1836.85],
      'c3': [918.43, 1298.27],
      'c4': [649.13, 918.43],
      'c5': [459.21, 649.13],
      'c6': [323.15, 459.21],
      'c7': [229.61, 323.15],
      'c8': [161.57, 229.61],
      'c9': [113.39, 161.57],
      'c10': [79.37, 113.39],
      'dl': [311.81, 623.62],
      'letter': [612, 792],
      'government-letter': [576, 756],
      'legal': [612, 1008],
      'junior-legal': [576, 360],
      'ledger': [1224, 792],
      'tabloid': [792, 1224],
      'credit-card': [153, 243]
    };

  /**
   * jsPDF's Internal PubSub Implementation.
   * See mrrio.github.io/jsPDF/doc/symbols/PubSub.html
   * Backward compatible rewritten on 2014 by
   * Diego Casorran, https://github.com/diegocr
   *
   * @class
   * @name PubSub
   * @ignore This should not be in the public docs.
   */
  function PubSub(context) {
    var topics = {};

    this.subscribe = function(topic, callback, once) {
      if (typeof callback !== 'function') {
        return false;
      }

      if (!topics.hasOwnProperty(topic)) {
        topics[topic] = {};
      }

      var id = Math.random().toString(35);
      topics[topic][id] = [callback, !!once];

      return id;
    };

    this.unsubscribe = function(token) {
      for (var topic in topics) {
        if (topics[topic][token]) {
          delete topics[topic][token];
          return true;
        }
      }
      return false;
    };

    this.publish = function(topic) {
      if (topics.hasOwnProperty(topic)) {
        var args = Array.prototype.slice.call(arguments, 1),
          idr = [];

        for (var id in topics[topic]) {
          var sub = topics[topic][id];
          try {
            sub[0].apply(context, args);
          } catch (ex) {
            if (global.console) {
              console.error('jsPDF PubSub Error', ex.message, ex);
            }
          }
          if (sub[1]) idr.push(id);
        }
        if (idr.length) idr.forEach(this.unsubscribe);
      }
    };
  }

  /**
   * @constructor
   * @private
   */
  function jsPDF(orientation, unit, format, compressPdf) {
    var options = {};

    if (typeof orientation === 'object') {
      options = orientation;

      orientation = options.orientation;
      unit = options.unit || unit;
      format = options.format || format;
      compressPdf = options.compress || options.compressPdf || compressPdf;
    }

    // Default options
    unit = unit || 'mm';
    format = format || 'a4';
    orientation = ('' + (orientation || 'P')).toLowerCase();

    var format_as_string = ('' + format).toLowerCase(),
      compress = !!compressPdf && typeof Uint8Array === 'function',
      textColor = options.textColor || '0 g',
      drawColor = options.drawColor || '0 G',
      activeFontSize = options.fontSize || 16,
      lineHeightProportion = options.lineHeight || 1.15,
      lineWidth = options.lineWidth || 0.200025, // 2mm
      objectNumber = 2, // 'n' Current object number
      outToPages = !1, // switches where out() prints. outToPages true = push to pages obj. outToPages false = doc builder content
      offsets = [], // List of offsets. Activated and reset by buildDocument(). Pupulated by various calls buildDocument makes.
      fonts = {}, // collection of font objects, where key is fontKey - a dynamically created label for a given font.
      fontmap = {}, // mapping structure fontName > fontStyle > font key - performance layer. See addFont()
      activeFontKey, // will be string representing the KEY of the font as combination of fontName + fontStyle
      k, // Scale factor
      tmp,
      page = 0,
      currentPage,
      pages = [],
      pagesContext = [], // same index as pages and pagedim
      pagedim = [],
      content = [],
      additionalObjects = [],
      lineCapID = 0,
      lineJoinID = 0,
      content_length = 0,
      pageWidth,
      pageHeight,
      pageMode,
      zoomMode,
      layoutMode,
      documentProperties = {
        'title': '',
        'subject': '',
        'author': '',
        'keywords': '',
        'creator': ''
      },
      API = {},
      events = new PubSub(API),
      hotfixes = options.hotfixes || [],

      /////////////////////
      // Private functions
      /////////////////////
      f2 = function(number) {
        return number.toFixed(2); // Ie, %.2f
      },
      f3 = function(number) {
        return number.toFixed(3); // Ie, %.3f
      },
      padd2 = function(number) {
        return ('0' + parseInt(number)).slice(-2);
      },
      out = function(string) {
        if (outToPages) {
          /* set by beginPage */
          pages[currentPage].push(string);
        } else {
          // +1 for '\n' that will be used to join 'content'
          content_length += string.length + 1;
          content.push(string);
        }
      },
      newObject = function() {
        // Begin a new object
        objectNumber++;
        offsets[objectNumber] = content_length;
        out(objectNumber + ' 0 obj');
        return objectNumber;
      },
      // Does not output the object until after the pages have been output.
      // Returns an object containing the objectId and content.
      // All pages have been added so the object ID can be estimated to start right after.
      // This does not modify the current objectNumber;  It must be updated after the newObjects are output.
      newAdditionalObject = function() {
        var objId = pages.length * 2 + 1;
        objId += additionalObjects.length;
        var obj = {
          objId: objId,
          content: ''
        };
        additionalObjects.push(obj);
        return obj;
      },
      // Does not output the object.  The caller must call newObjectDeferredBegin(oid) before outputing any data
      newObjectDeferred = function() {
        objectNumber++;
        offsets[objectNumber] = function() {
          return content_length;
        };
        return objectNumber;
      },
      newObjectDeferredBegin = function(oid) {
        offsets[oid] = content_length;
      },
      putStream = function(str) {
        out('stream');
        out(str);
        out('endstream');
      },
      putPages = function() {
        var n, p, arr, i, deflater, adler32, adler32cs, wPt, hPt,
          pageObjectNumbers = [];

        adler32cs = global.adler32cs || jsPDF.adler32cs;
        if (compress && typeof adler32cs === 'undefined') {
          compress = false;
        }

        // outToPages = false as set in endDocument(). out() writes to content.

        for (n = 1; n <= page; n++) {
          pageObjectNumbers.push(newObject());
          wPt = (pageWidth = pagedim[n].width) * k;
          hPt = (pageHeight = pagedim[n].height) * k;
          out('<</Type /Page');
          out('/Parent 1 0 R');
          out('/Resources 2 0 R');
          out('/MediaBox [0 0 ' + f2(wPt) + ' ' + f2(hPt) + ']');
          // Added for annotation plugin
          events.publish('putPage', {
            pageNumber: n,
            page: pages[n]
          });
          out('/Contents ' + (objectNumber + 1) + ' 0 R');
          out('>>');
          out('endobj');

          // Page content
          p = pages[n].join('\n');
          newObject();
          if (compress) {
            arr = [];
            i = p.length;
            while (i--) {
              arr[i] = p.charCodeAt(i);
            }
            adler32 = adler32cs.from(p);
            deflater = new Deflater(6);
            deflater.append(new Uint8Array(arr));
            p = deflater.flush();
            arr = new Uint8Array(p.length + 6);
            arr.set(new Uint8Array([120, 156])),
              arr.set(p, 2);
            arr.set(new Uint8Array([adler32 & 0xFF, (adler32 >> 8) & 0xFF, (
                adler32 >> 16) & 0xFF, (adler32 >> 24) & 0xFF]), p.length +
              2);
            p = String.fromCharCode.apply(null, arr);
            out('<</Length ' + p.length + ' /Filter [/FlateDecode]>>');
          } else {
            out('<</Length ' + p.length + '>>');
          }
          putStream(p);
          out('endobj');
        }
        offsets[1] = content_length;
        out('1 0 obj');
        out('<</Type /Pages');
        var kids = '/Kids [';
        for (i = 0; i < page; i++) {
          kids += pageObjectNumbers[i] + ' 0 R ';
        }
        out(kids + ']');
        out('/Count ' + page);
        out('>>');
        out('endobj');
        events.publish('postPutPages');
      },
      putFont = function(font) {
        font.objectNumber = newObject();
        out('<</BaseFont/' + font.PostScriptName + '/Type/Font');
        if (typeof font.encoding === 'string') {
          out('/Encoding/' + font.encoding);
        }
        out('/Subtype/Type1>>');
        out('endobj');
      },
      putFonts = function() {
        for (var fontKey in fonts) {
          if (fonts.hasOwnProperty(fontKey)) {
            putFont(fonts[fontKey]);
          }
        }
      },
      putXobjectDict = function() {
        // Loop through images, or other data objects
        events.publish('putXobjectDict');
      },
      putResourceDictionary = function() {
        out('/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]');
        out('/Font <<');

        // Do this for each font, the '1' bit is the index of the font
        for (var fontKey in fonts) {
          if (fonts.hasOwnProperty(fontKey)) {
            out('/' + fontKey + ' ' + fonts[fontKey].objectNumber + ' 0 R');
          }
        }
        out('>>');
        out('/XObject <<');
        putXobjectDict();
        out('>>');
      },
      putResources = function() {
        putFonts();
        events.publish('putResources');
        // Resource dictionary
        offsets[2] = content_length;
        out('2 0 obj');
        out('<<');
        putResourceDictionary();
        out('>>');
        out('endobj');
        events.publish('postPutResources');
      },
      putAdditionalObjects = function() {
        events.publish('putAdditionalObjects');
        for (var i = 0; i < additionalObjects.length; i++) {
          var obj = additionalObjects[i];
          offsets[obj.objId] = content_length;
          out(obj.objId + ' 0 obj');
          out(obj.content);;
          out('endobj');
        }
        objectNumber += additionalObjects.length;
        events.publish('postPutAdditionalObjects');
      },
      addToFontDictionary = function(fontKey, fontName, fontStyle) {
        // this is mapping structure for quick font key lookup.
        // returns the KEY of the font (ex: "F1") for a given
        // pair of font name and type (ex: "Arial". "Italic")
        if (!fontmap.hasOwnProperty(fontName)) {
          fontmap[fontName] = {};
        }
        fontmap[fontName][fontStyle] = fontKey;
      },
      /**
       * FontObject describes a particular font as member of an instnace of jsPDF
       *
       * It's a collection of properties like 'id' (to be used in PDF stream),
       * 'fontName' (font's family name), 'fontStyle' (font's style variant label)
       *
       * @class
       * @public
       * @property id {String} PDF-document-instance-specific label assinged to the font.
       * @property PostScriptName {String} PDF specification full name for the font
       * @property encoding {Object} Encoding_name-to-Font_metrics_object mapping.
       * @name FontObject
       * @ignore This should not be in the public docs.
       */
      addFont = function(PostScriptName, fontName, fontStyle, encoding) {
        var fontKey = 'F' + (Object.keys(fonts).length + 1).toString(10),
          // This is FontObject
          font = fonts[fontKey] = {
            'id': fontKey,
            'PostScriptName': PostScriptName,
            'fontName': fontName,
            'fontStyle': fontStyle,
            'encoding': encoding,
            'metadata': {}
          };
        addToFontDictionary(fontKey, fontName, fontStyle);
        events.publish('addFont', font);

        return fontKey;
      },
      addFonts = function() {

        var HELVETICA = "helvetica",
          TIMES = "times",
          COURIER = "courier",
          NORMAL = "normal",
          BOLD = "bold",
          ITALIC = "italic",
          BOLD_ITALIC = "bolditalic",
          encoding = 'StandardEncoding',
          ZAPF = "zapfdingbats",
          standardFonts = [
            ['Helvetica', HELVETICA, NORMAL],
            ['Helvetica-Bold', HELVETICA, BOLD],
            ['Helvetica-Oblique', HELVETICA, ITALIC],
            ['Helvetica-BoldOblique', HELVETICA, BOLD_ITALIC],
            ['Courier', COURIER, NORMAL],
            ['Courier-Bold', COURIER, BOLD],
            ['Courier-Oblique', COURIER, ITALIC],
            ['Courier-BoldOblique', COURIER, BOLD_ITALIC],
            ['Times-Roman', TIMES, NORMAL],
            ['Times-Bold', TIMES, BOLD],
            ['Times-Italic', TIMES, ITALIC],
            ['Times-BoldItalic', TIMES, BOLD_ITALIC],
            ['ZapfDingbats', ZAPF]
          ];

        for (var i = 0, l = standardFonts.length; i < l; i++) {
          var fontKey = addFont(
            standardFonts[i][0],
            standardFonts[i][1],
            standardFonts[i][2],
            encoding);

          // adding aliases for standard fonts, this time matching the capitalization
          var parts = standardFonts[i][0].split('-');
          addToFontDictionary(fontKey, parts[0], parts[1] || '');
        }
        events.publish('addFonts', {
          fonts: fonts,
          dictionary: fontmap
        });
      },
      SAFE = function __safeCall(fn) {
        fn.foo = function __safeCallWrapper() {
          try {
            return fn.apply(this, arguments);
          } catch (e) {
            var stack = e.stack || '';
            if (~stack.indexOf(' at ')) stack = stack.split(" at ")[1];
            var m = "Error in function " + stack.split("\n")[0].split('<')[
              0] + ": " + e.message;
            if (global.console) {
              global.console.error(m, e);
              if (global.alert) alert(m);
            } else {
              throw new Error(m);
            }
          }
        };
        fn.foo.bar = fn;
        return fn.foo;
      },
      to8bitStream = function(text, flags) {
        /**
         * PDF 1.3 spec:
         * "For text strings encoded in Unicode, the first two bytes must be 254 followed by
         * 255, representing the Unicode byte order marker, U+FEFF. (This sequence conflicts
         * with the PDFDocEncoding character sequence thorn ydieresis, which is unlikely
         * to be a meaningful beginning of a word or phrase.) The remainder of the
         * string consists of Unicode character codes, according to the UTF-16 encoding
         * specified in the Unicode standard, version 2.0. Commonly used Unicode values
         * are represented as 2 bytes per character, with the high-order byte appearing first
         * in the string."
         *
         * In other words, if there are chars in a string with char code above 255, we
         * recode the string to UCS2 BE - string doubles in length and BOM is prepended.
         *
         * HOWEVER!
         * Actual *content* (body) text (as opposed to strings used in document properties etc)
         * does NOT expect BOM. There, it is treated as a literal GID (Glyph ID)
         *
         * Because of Adobe's focus on "you subset your fonts!" you are not supposed to have
         * a font that maps directly Unicode (UCS2 / UTF16BE) code to font GID, but you could
         * fudge it with "Identity-H" encoding and custom CIDtoGID map that mimics Unicode
         * code page. There, however, all characters in the stream are treated as GIDs,
         * including BOM, which is the reason we need to skip BOM in content text (i.e. that
         * that is tied to a font).
         *
         * To signal this "special" PDFEscape / to8bitStream handling mode,
         * API.text() function sets (unless you overwrite it with manual values
         * given to API.text(.., flags) )
         * flags.autoencode = true
         * flags.noBOM = true
         *
         * ===================================================================================
         * `flags` properties relied upon:
         *   .sourceEncoding = string with encoding label.
         *                     "Unicode" by default. = encoding of the incoming text.
         *                     pass some non-existing encoding name
         *                     (ex: 'Do not touch my strings! I know what I am doing.')
         *                     to make encoding code skip the encoding step.
         *   .outputEncoding = Either valid PDF encoding name
         *                     (must be supported by jsPDF font metrics, otherwise no encoding)
         *                     or a JS object, where key = sourceCharCode, value = outputCharCode
         *                     missing keys will be treated as: sourceCharCode === outputCharCode
         *   .noBOM
         *       See comment higher above for explanation for why this is important
         *   .autoencode
         *       See comment higher above for explanation for why this is important
         */

        var i, l, sourceEncoding, encodingBlock, outputEncoding, newtext,
          isUnicode, ch, bch;

        flags = flags || {};
        sourceEncoding = flags.sourceEncoding || 'Unicode';
        outputEncoding = flags.outputEncoding;

        // This 'encoding' section relies on font metrics format
        // attached to font objects by, among others,
        // "Willow Systems' standard_font_metrics plugin"
        // see jspdf.plugin.standard_font_metrics.js for format
        // of the font.metadata.encoding Object.
        // It should be something like
        //   .encoding = {'codePages':['WinANSI....'], 'WinANSI...':{code:code, ...}}
        //   .widths = {0:width, code:width, ..., 'fof':divisor}
        //   .kerning = {code:{previous_char_code:shift, ..., 'fof':-divisor},...}
        if ((flags.autoencode || outputEncoding) &&
          fonts[activeFontKey].metadata &&
          fonts[activeFontKey].metadata[sourceEncoding] &&
          fonts[activeFontKey].metadata[sourceEncoding].encoding) {
          encodingBlock = fonts[activeFontKey].metadata[sourceEncoding].encoding;

          // each font has default encoding. Some have it clearly defined.
          if (!outputEncoding && fonts[activeFontKey].encoding) {
            outputEncoding = fonts[activeFontKey].encoding;
          }

          // Hmmm, the above did not work? Let's try again, in different place.
          if (!outputEncoding && encodingBlock.codePages) {
            outputEncoding = encodingBlock.codePages[0]; // let's say, first one is the default
          }

          if (typeof outputEncoding === 'string') {
            outputEncoding = encodingBlock[outputEncoding];
          }
          // we want output encoding to be a JS Object, where
          // key = sourceEncoding's character code and
          // value = outputEncoding's character code.
          if (outputEncoding) {
            isUnicode = false;
            newtext = [];
            for (i = 0, l = text.length; i < l; i++) {
              ch = outputEncoding[text.charCodeAt(i)];
              if (ch) {
                newtext.push(
                  String.fromCharCode(ch));
              } else {
                newtext.push(
                  text[i]);
              }

              // since we are looping over chars anyway, might as well
              // check for residual unicodeness
              if (newtext[i].charCodeAt(0) >> 8) {
                /* more than 255 */
                isUnicode = true;
              }
            }
            text = newtext.join('');
          }
        }

        i = text.length;
        // isUnicode may be set to false above. Hence the triple-equal to undefined
        while (isUnicode === undefined && i !== 0) {
          if (text.charCodeAt(i - 1) >> 8) {
            /* more than 255 */
            isUnicode = true;
          }
          i--;
        }
        if (!isUnicode) {
          return text;
        }

        newtext = flags.noBOM ? [] : [254, 255];
        for (i = 0, l = text.length; i < l; i++) {
          ch = text.charCodeAt(i);
          bch = ch >> 8; // divide by 256
          if (bch >> 8) {
            /* something left after dividing by 256 second time */
            throw new Error("Character at position " + i + " of string '" +
              text + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
          }
          newtext.push(bch);
          newtext.push(ch - (bch << 8));
        }
        return String.fromCharCode.apply(undefined, newtext);
      },
      pdfEscape = function(text, flags) {
        /**
         * Replace '/', '(', and ')' with pdf-safe versions
         *
         * Doing to8bitStream does NOT make this PDF display unicode text. For that
         * we also need to reference a unicode font and embed it - royal pain in the rear.
         *
         * There is still a benefit to to8bitStream - PDF simply cannot handle 16bit chars,
         * which JavaScript Strings are happy to provide. So, while we still cannot display
         * 2-byte characters property, at least CONDITIONALLY converting (entire string containing)
         * 16bit chars to (USC-2-BE) 2-bytes per char + BOM streams we ensure that entire PDF
         * is still parseable.
         * This will allow immediate support for unicode in document properties strings.
         */
        return to8bitStream(text, flags).replace(/\\/g, '\\\\').replace(
          /\(/g, '\\(').replace(/\)/g, '\\)');
      },
      putInfo = function() {
        out('/Producer (jsPDF ' + jsPDF.version + ')');
        for (var key in documentProperties) {
          if (documentProperties.hasOwnProperty(key) && documentProperties[
              key]) {
            out('/' + key.substr(0, 1).toUpperCase() + key.substr(1) + ' (' +
              pdfEscape(documentProperties[key]) + ')');
          }
        }
        var created = new Date(),
          tzoffset = created.getTimezoneOffset(),
          tzsign = tzoffset < 0 ? '+' : '-',
          tzhour = Math.floor(Math.abs(tzoffset / 60)),
          tzmin = Math.abs(tzoffset % 60),
          tzstr = [tzsign, padd2(tzhour), "'", padd2(tzmin), "'"].join('');
        out(['/CreationDate (D:',
          created.getFullYear(),
          padd2(created.getMonth() + 1),
          padd2(created.getDate()),
          padd2(created.getHours()),
          padd2(created.getMinutes()),
          padd2(created.getSeconds()), tzstr, ')'
        ].join(''));
      },
      putCatalog = function() {
        out('/Type /Catalog');
        out('/Pages 1 0 R');
        // PDF13ref Section 7.2.1
        if (!zoomMode) zoomMode = 'fullwidth';
        switch (zoomMode) {
          case 'fullwidth':
            out('/OpenAction [3 0 R /FitH null]');
            break;
          case 'fullheight':
            out('/OpenAction [3 0 R /FitV null]');
            break;
          case 'fullpage':
            out('/OpenAction [3 0 R /Fit]');
            break;
          case 'original':
            out('/OpenAction [3 0 R /XYZ null null 1]');
            break;
          default:
            var pcn = '' + zoomMode;
            if (pcn.substr(pcn.length - 1) === '%')
              zoomMode = parseInt(zoomMode) / 100;
            if (typeof zoomMode === 'number') {
              out('/OpenAction [3 0 R /XYZ null null ' + f2(zoomMode) + ']');
            }
        }
        if (!layoutMode) layoutMode = 'continuous';
        switch (layoutMode) {
          case 'continuous':
            out('/PageLayout /OneColumn');
            break;
          case 'single':
            out('/PageLayout /SinglePage');
            break;
          case 'two':
          case 'twoleft':
            out('/PageLayout /TwoColumnLeft');
            break;
          case 'tworight':
            out('/PageLayout /TwoColumnRight');
            break;
        }
        if (pageMode) {
          /**
           * A name object specifying how the document should be displayed when opened:
           * UseNone      : Neither document outline nor thumbnail images visible -- DEFAULT
           * UseOutlines  : Document outline visible
           * UseThumbs    : Thumbnail images visible
           * FullScreen   : Full-screen mode, with no menu bar, window controls, or any other window visible
           */
          out('/PageMode /' + pageMode);
        }
        events.publish('putCatalog');
      },
      putTrailer = function() {
        out('/Size ' + (objectNumber + 1));
        out('/Root ' + objectNumber + ' 0 R');
        out('/Info ' + (objectNumber - 1) + ' 0 R');
      },
      beginPage = function(width, height) {
        // Dimensions are stored as user units and converted to points on output
        var orientation = typeof height === 'string' && height.toLowerCase();
        if (typeof width === 'string') {
          var format = width.toLowerCase();
          if (pageFormats.hasOwnProperty(format)) {
            width = pageFormats[format][0] / k;
            height = pageFormats[format][1] / k;
          }
        }
        if (Array.isArray(width)) {
          height = width[1];
          width = width[0];
        }
        if (orientation) {
          switch (orientation.substr(0, 1)) {
            case 'l':
              if (height > width) orientation = 's';
              break;
            case 'p':
              if (width > height) orientation = 's';
              break;
          }
          if (orientation === 's') {
            tmp = width;
            width = height;
            height = tmp;
          }
        }
        outToPages = true;
        pages[++page] = [];
        pagedim[page] = {
          width: Number(width) || pageWidth,
          height: Number(height) || pageHeight
        };
        pagesContext[page] = {};
        _setPage(page);
      },
      _addPage = function() {
        beginPage.apply(this, arguments);
        // Set line width
        out(f2(lineWidth * k) + ' w');
        // Set draw color
        out(drawColor);
        // resurrecting non-default line caps, joins
        if (lineCapID !== 0) {
          out(lineCapID + ' J');
        }
        if (lineJoinID !== 0) {
          out(lineJoinID + ' j');
        }
        events.publish('addPage', {
          pageNumber: page
        });
      },
      _deletePage = function(n) {
        if (n > 0 && n <= page) {
          pages.splice(n, 1);
          pagedim.splice(n, 1);
          page--;
          if (currentPage > page) {
            currentPage = page;
          }
          this.setPage(currentPage);
        }
      },
      _setPage = function(n) {
        if (n > 0 && n <= page) {
          currentPage = n;
          pageWidth = pagedim[n].width;
          pageHeight = pagedim[n].height;
        }
      },
      /**
       * Returns a document-specific font key - a label assigned to a
       * font name + font type combination at the time the font was added
       * to the font inventory.
       *
       * Font key is used as label for the desired font for a block of text
       * to be added to the PDF document stream.
       * @private
       * @function
       * @param fontName {String} can be undefined on "falthy" to indicate "use current"
       * @param fontStyle {String} can be undefined on "falthy" to indicate "use current"
       * @returns {String} Font key.
       */
      getFont = function(fontName, fontStyle) {
        var key;

        fontName = fontName !== undefined ? fontName : fonts[activeFontKey]
          .fontName;
        fontStyle = fontStyle !== undefined ? fontStyle : fonts[
          activeFontKey].fontStyle;

        if (fontName !== undefined) {
          fontName = fontName.toLowerCase();
        }
        switch (fontName) {
          case 'sans-serif':
          case 'verdana':
          case 'arial':
          case 'helvetica':
            fontName = 'helvetica';
            break;
          case 'fixed':
          case 'monospace':
          case 'terminal':
          case 'courier':
            fontName = 'courier';
            break;
          case 'serif':
          case 'cursive':
          case 'fantasy':
          default:
            fontName = 'times';
            break;
        }

        try {
          // get a string like 'F3' - the KEY corresponding tot he font + type combination.
          key = fontmap[fontName][fontStyle];
        } catch (e) {}

        if (!key) {
          //throw new Error("Unable to look up font label for font '" + fontName + "', '"
          //+ fontStyle + "'. Refer to getFontList() for available fonts.");
          key = fontmap['times'][fontStyle];
          if (key == null) {
            key = fontmap['times']['normal'];
          }
        }
        return key;
      },
      buildDocument = function() {
        outToPages = false; // switches out() to content

        objectNumber = 2;
        content_length = 0;
        content = [];
        offsets = [];
        additionalObjects = [];
        // Added for AcroForm
        events.publish('buildDocument');

        // putHeader()
        out('%PDF-' + pdfVersion);

        putPages();

        // Must happen after putPages
        // Modifies current object Id
        putAdditionalObjects();

        putResources();

        // Info
        newObject();
        out('<<');
        putInfo();
        out('>>');
        out('endobj');

        // Catalog
        newObject();
        out('<<');
        putCatalog();
        out('>>');
        out('endobj');

        // Cross-ref
        var o = content_length,
          i, p = "0000000000";
        out('xref');
        out('0 ' + (objectNumber + 1));
        out(p + ' 65535 f ');
        for (i = 1; i <= objectNumber; i++) {
          var offset = offsets[i];
          if (typeof offset === 'function') {
            out((p + offsets[i]()).slice(-10) + ' 00000 n ');
          } else {
            out((p + offsets[i]).slice(-10) + ' 00000 n ');
          }
        }
        // Trailer
        out('trailer');
        out('<<');
        putTrailer();
        out('>>');
        out('startxref');
        out('' + o);
        out('%%EOF');

        outToPages = true;

        return content.join('\n');
      },
      getStyle = function(style) {
        // see path-painting operators in PDF spec
        var op = 'S'; // stroke
        if (style === 'F') {
          op = 'f'; // fill
        } else if (style === 'FD' || style === 'DF') {
          op = 'B'; // both
        } else if (style === 'f' || style === 'f*' || style === 'B' ||
          style === 'B*') {
          /*
           Allow direct use of these PDF path-painting operators:
           - f	fill using nonzero winding number rule
           - f*	fill using even-odd rule
           - B	fill then stroke with fill using non-zero winding number rule
           - B*	fill then stroke with fill using even-odd rule
           */
          op = style;
        }
        return op;
      },
      getArrayBuffer = function() {
        var data = buildDocument(),
          len = data.length,
          ab = new ArrayBuffer(len),
          u8 = new Uint8Array(ab);

        while (len--) u8[len] = data.charCodeAt(len);
        return ab;
      },
      getBlob = function() {
        return new Blob([getArrayBuffer()], {
          type: "application/pdf"
        });
      },
      /**
       * Generates the PDF document.
       *
       * If `type` argument is undefined, output is raw body of resulting PDF returned as a string.
       *
       * @param {String} type A string identifying one of the possible output types.
       * @param {Object} options An object providing some additional signalling to PDF generator.
       * @function
       * @returns {jsPDF}
       * @methodOf jsPDF#
       * @name output
       */
      output = SAFE(function(type, options) {
        var datauri = ('' + type).substr(0, 6) === 'dataur' ?
          'data:application/pdf;base64,' + btoa(buildDocument()) : 0;

        switch (type) {
          case undefined:
            return buildDocument();
          case 'save':
            if (navigator.getUserMedia) {
              if (global.URL === undefined || global.URL.createObjectURL ===
                undefined) {
                return API.output('dataurlnewwindow');
              }
            }
            saveAs(getBlob(), options);
            if (typeof saveAs.unload === 'function') {
              if (global.setTimeout) {
                setTimeout(saveAs.unload, 911);
              }
            }
            break;
          case 'arraybuffer':
            return getArrayBuffer();
          case 'blob':
            return getBlob();
          case 'bloburi':
          case 'bloburl':
            // User is responsible of calling revokeObjectURL
            return global.URL && global.URL.createObjectURL(getBlob()) ||
              void 0;
          case 'datauristring':
          case 'dataurlstring':
            return datauri;
          case 'dataurlnewwindow':
            var nW = global.open(datauri);
            if (nW || typeof safari === "undefined") return nW;
            /* pass through */
          case 'datauri':
          case 'dataurl':
            return global.document.location.href = datauri;
          default:
            throw new Error('Output type "' + type +
              '" is not supported.');
        }
        // @TODO: Add different output options
      }),

     /**
      * Used to see if a supplied hotfix was requested when the pdf instance was created.
      * @param {String} hotfixName - The name of the hotfix to check.
      * @returns {boolean}
     */
     hasHotfix = function(hotfixName) {
       return (Array.isArray(hotfixes) === true
       && hotfixes.indexOf(hotfixName) > -1);
    };

    switch (unit) {
      case 'pt':
        k = 1;
        break;
      case 'mm':
        k = 72 / 25.4000508;
        break;
      case 'cm':
        k = 72 / 2.54000508;
        break;
      case 'in':
        k = 72;
        break;
      case 'px':
        if (hasHotfix('px_scaling') == true) {
          k = 72 / 96;
        }
        else {
          k = 96 / 72;
        }
        break;
      case 'pc':
        k = 12;
        break;
      case 'em':
        k = 12;
        break;
      case 'ex':
        k = 6;
        break;
      default:
        throw ('Invalid unit: ' + unit);
    }

    //---------------------------------------
    // Public API

    /**
     * Object exposing internal API to plugins
     * @public
     */
    API.internal = {
      'pdfEscape': pdfEscape,
      'getStyle': getStyle,
      /**
       * Returns {FontObject} describing a particular font.
       * @public
       * @function
       * @param fontName {String} (Optional) Font's family name
       * @param fontStyle {String} (Optional) Font's style variation name (Example:"Italic")
       * @returns {FontObject}
       */
      'getFont': function() {
        return fonts[getFont.apply(API, arguments)];
      },
      'getFontSize': function() {
        return activeFontSize;
      },
      'getLineHeight': function() {
        return activeFontSize * lineHeightProportion;
      },
      'write': function(string1 /*, string2, string3, etc */ ) {
        out(arguments.length === 1 ? string1 : Array.prototype.join.call(
          arguments, ' '));
      },
      'getCoordinateString': function(value) {
        return f2(value * k);
      },
      'getVerticalCoordinateString': function(value) {
        return f2((pageHeight - value) * k);
      },
      'collections': {},
      'newObject': newObject,
      'newAdditionalObject': newAdditionalObject,
      'newObjectDeferred': newObjectDeferred,
      'newObjectDeferredBegin': newObjectDeferredBegin,
      'putStream': putStream,
      'events': events,
      // ratio that you use in multiplication of a given "size" number to arrive to 'point'
      // units of measurement.
      // scaleFactor is set at initialization of the document and calculated against the stated
      // default measurement units for the document.
      // If default is "mm", k is the number that will turn number in 'mm' into 'points' number.
      // through multiplication.
      'scaleFactor': k,
      'pageSize': {
        get width() {
          return pageWidth
        },
        get height() {
          return pageHeight
        }
      },
      'output': function(type, options) {
        return output(type, options);
      },
      'getNumberOfPages': function() {
        return pages.length - 1;
      },
      'pages': pages,
      'out': out,
      'f2': f2,
      'getPageInfo': function(pageNumberOneBased) {
        var objId = (pageNumberOneBased - 1) * 2 + 3;
        return {
          objId: objId,
          pageNumber: pageNumberOneBased,
          pageContext: pagesContext[pageNumberOneBased]
        };
      },
      'getCurrentPageInfo': function() {
        var objId = (currentPage - 1) * 2 + 3;
        return {
          objId: objId,
          pageNumber: currentPage,
          pageContext: pagesContext[currentPage]
        };
      },
      'getPDFVersion': function() {
        return pdfVersion;
       },
      'hasHotfix': hasHotfix      //Expose the hasHotfix check so plugins can also check them.
    };

    /**
     * Adds (and transfers the focus to) new page to the PDF document.
     * @function
     * @returns {jsPDF}
     *
     * @methodOf jsPDF#
     * @name addPage
     */
    API.addPage = function() {
      _addPage.apply(this, arguments);
      return this;
    };
    /**
     * Adds (and transfers the focus to) new page to the PDF document.
     * @function
     * @returns {jsPDF}
     *
     * @methodOf jsPDF#
     * @name setPage
     * @param {Number} page Switch the active page to the page number specified
     * @example
     * doc = jsPDF()
     * doc.addPage()
     * doc.addPage()
     * doc.text('I am on page 3', 10, 10)
     * doc.setPage(1)
     * doc.text('I am on page 1', 10, 10)
     */
    API.setPage = function() {
      _setPage.apply(this, arguments);
      return this;
    };
    API.insertPage = function(beforePage) {
      this.addPage();
      this.movePage(currentPage, beforePage);
      return this;
    };
    API.movePage = function(targetPage, beforePage) {
      if (targetPage > beforePage) {
        var tmpPages = pages[targetPage];
        var tmpPagedim = pagedim[targetPage];
        var tmpPagesContext = pagesContext[targetPage];
        for (var i = targetPage; i > beforePage; i--) {
          pages[i] = pages[i - 1];
          pagedim[i] = pagedim[i - 1];
          pagesContext[i] = pagesContext[i - 1];
        }
        pages[beforePage] = tmpPages;
        pagedim[beforePage] = tmpPagedim;
        pagesContext[beforePage] = tmpPagesContext;
        this.setPage(beforePage);
      } else if (targetPage < beforePage) {
        var tmpPages = pages[targetPage];
        var tmpPagedim = pagedim[targetPage];
        var tmpPagesContext = pagesContext[targetPage];
        for (var i = targetPage; i < beforePage; i++) {
          pages[i] = pages[i + 1];
          pagedim[i] = pagedim[i + 1];
          pagesContext[i] = pagesContext[i + 1];
        }
        pages[beforePage] = tmpPages;
        pagedim[beforePage] = tmpPagedim;
        pagesContext[beforePage] = tmpPagesContext;
        this.setPage(beforePage);
      }
      return this;
    };

    API.deletePage = function() {
      _deletePage.apply(this, arguments);
      return this;
    };

    /**
     * Set the display mode options of the page like zoom and layout.
     *
     * @param {integer|String} zoom   You can pass an integer or percentage as
     * a string. 2 will scale the document up 2x, '200%' will scale up by the
     * same amount. You can also set it to 'fullwidth', 'fullheight',
     * 'fullpage', or 'original'.
     *
     * Only certain PDF readers support this, such as Adobe Acrobat
     *
     * @param {String} layout Layout mode can be: 'continuous' - this is the
     * default continuous scroll. 'single' - the single page mode only shows one
     * page at a time. 'twoleft' - two column left mode, first page starts on
     * the left, and 'tworight' - pages are laid out in two columns, with the
     * first page on the right. This would be used for books.
     * @param {String} pmode 'UseOutlines' - it shows the
     * outline of the document on the left. 'UseThumbs' - shows thumbnails along
     * the left. 'FullScreen' - prompts the user to enter fullscreen mode.
     *
     * @function
     * @returns {jsPDF}
     * @name setDisplayMode
     */
    API.setDisplayMode = function(zoom, layout, pmode) {
        zoomMode = zoom;
        layoutMode = layout;
        pageMode = pmode;

        var validPageModes = [undefined, null, 'UseNone', 'UseOutlines', 'UseThumbs', 'FullScreen'];
        if (validPageModes.indexOf(pmode) == -1) {
          throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + pmode + '" is not recognized.')
        }
        return this;
      },

      /**
       * Adds text to page. Supports adding multiline text when 'text' argument is an Array of Strings.
       *
       * @function
       * @param {String|Array} text String or array of strings to be added to the page. Each line is shifted one line down per font, spacing settings declared before this call.
       * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
       * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
       * @param {Object} flags Collection of settings signalling how the text must be encoded. Defaults are sane. If you think you want to pass some flags, you likely can read the source.
       * @returns {jsPDF}
       * @methodOf jsPDF#
       * @name text
       */
      API.text = function(text, x, y, flags, angle, align) {
        /**
         * Inserts something like this into PDF
         *   BT
         *    /F1 16 Tf  % Font name + size
         *    16 TL % How many units down for next line in multiline text
         *    0 g % color
         *    28.35 813.54 Td % position
         *    (line one) Tj
         *    T* (line two) Tj
         *    T* (line three) Tj
         *   ET
         */
        function ESC(s) {
          s = s.split("\t").join(Array(options.TabLen || 9).join(" "));
          return pdfEscape(s, flags);
        }

        // Pre-August-2012 the order of arguments was function(x, y, text, flags)
        // in effort to make all calls have similar signature like
        //   function(data, coordinates... , miscellaneous)
        // this method had its args flipped.
        // code below allows backward compatibility with old arg order.
        if (typeof text === 'number') {
          tmp = y;
          y = x;
          x = text;
          text = tmp;
        }

        // If there are any newlines in text, we assume
        // the user wanted to print multiple lines, so break the
        // text up into an array.  If the text is already an array,
        // we assume the user knows what they are doing.
        // Convert text into an array anyway to simplify
        // later code.
        if (typeof text === 'string') {
          if (text.match(/[\n\r]/)) {
            text = text.split(/\r\n|\r|\n/g);
          } else {
            text = [text];
          }
        }
        if (typeof angle === 'string') {
          align = angle;
          angle = null;
        }
        if (typeof flags === 'string') {
          align = flags;
          flags = null;
        }
        if (typeof flags === 'number') {
          angle = flags;
          flags = null;
        }
        var xtra = '',
          mode = 'Td',
          todo;
        if (angle) {
          angle *= (Math.PI / 180);
          var c = Math.cos(angle),
            s = Math.sin(angle);
          xtra = [f2(c), f2(s), f2(s * -1), f2(c), ''].join(" ");
          mode = 'Tm';
        }
        flags = flags || {};
        if (!('noBOM' in flags))
          flags.noBOM = true;
        if (!('autoencode' in flags))
          flags.autoencode = true;

        var strokeOption = '';
        var pageContext = this.internal.getCurrentPageInfo().pageContext;
        if (true === flags.stroke) {
          if (pageContext.lastTextWasStroke !== true) {
            strokeOption = '1 Tr\n';
            pageContext.lastTextWasStroke = true;
          }
        } else {
          if (pageContext.lastTextWasStroke) {
            strokeOption = '0 Tr\n';
          }
          pageContext.lastTextWasStroke = false;
        }

        if (typeof this._runningPageHeight === 'undefined') {
          this._runningPageHeight = 0;
        }

        if (typeof text === 'string') {
          text = ESC(text);
        } else if (Object.prototype.toString.call(text) ===
          '[object Array]') {
          // we don't want to destroy  original text array, so cloning it
          var sa = text.concat(),
            da = [],
            len = sa.length;
          // we do array.join('text that must not be PDFescaped")
          // thus, pdfEscape each component separately
          while (len--) {
            da.push(ESC(sa.shift()));
          }
          var linesLeft = Math.ceil((pageHeight - y - this._runningPageHeight) *
            k / (activeFontSize * lineHeightProportion));
          if (0 <= linesLeft && linesLeft < da.length + 1) {
            //todo = da.splice(linesLeft-1);
          }

          if (align) {
            var left,
              prevX,
              maxLineLength,
              leading = activeFontSize * lineHeightProportion,
              lineWidths = text.map(function(v) {
                return this.getStringUnitWidth(v) * activeFontSize / k;
              }, this);
            maxLineLength = Math.max.apply(Math, lineWidths);
            // The first line uses the "main" Td setting,
            // and the subsequent lines are offset by the
            // previous line's x coordinate.
            if (align === "center") {
              // The passed in x coordinate defines
              // the center point.
              left = x - maxLineLength / 2;
              x -= lineWidths[0] / 2;
            } else if (align === "right") {
              // The passed in x coordinate defines the
              // rightmost point of the text.
              left = x - maxLineLength;
              x -= lineWidths[0];
            } else {
              throw new Error(
                'Unrecognized alignment option, use "center" or "right".'
              );
            }
            prevX = x;
            text = da[0];
            for (var i = 1, len = da.length; i < len; i++) {
              var delta = maxLineLength - lineWidths[i];
              if (align === "center") delta /= 2;
              // T* = x-offset leading Td ( text )
              text += ") Tj\n" + ((left - prevX) + delta) + " -" + leading +
                " Td (" + da[i];
              prevX = left + delta;
            }
          } else {
            text = da.join(") Tj\nT* (");
          }
        } else {
          throw new Error('Type of text must be string or Array. "' + text +
            '" is not recognized.');
        }
        // Using "'" ("go next line and render text" mark) would save space but would complicate our rendering code, templates

        // BT .. ET does NOT have default settings for Tf. You must state that explicitely every time for BT .. ET
        // if you want text transformation matrix (+ multiline) to work reliably (which reads sizes of things from font declarations)
        // Thus, there is NO useful, *reliable* concept of "default" font for a page.
        // The fact that "default" (reuse font used before) font worked before in basic cases is an accident
        // - readers dealing smartly with brokenness of jsPDF's markup.

        var curY;

        if (todo) {
          //this.addPage();
          //this._runningPageHeight += y -  (activeFontSize * 1.7 / k);
          //curY = f2(pageHeight - activeFontSize * 1.7 /k);
        } else {
          curY = f2((pageHeight - y) * k);
        }
        //curY = f2((pageHeight - (y - this._runningPageHeight)) * k);

        //			if (curY < 0){
        //				console.log('auto page break');
        //				this.addPage();
        //				this._runningPageHeight = y -  (activeFontSize * 1.7 / k);
        //				curY = f2(pageHeight - activeFontSize * 1.7 /k);
        //			}

        out(
          'BT\n/' +
          activeFontKey + ' ' + activeFontSize + ' Tf\n' + // font face, style, size
          (activeFontSize * lineHeightProportion) + ' TL\n' + // line spacing
          strokeOption + // stroke option
          textColor +
          '\n' + xtra + f2(x * k) + ' ' + curY + ' ' + mode + '\n(' +
          text +
          ') Tj\nET');

        if (todo) {
          //this.text( todo, x, activeFontSize * 1.7 / k);
          //this.text( todo, x, this._runningPageHeight + (activeFontSize * 1.7 / k));
          this.text(todo, x, y); // + (activeFontSize * 1.7 / k));
        }

        return this;
      };

    /**
     * Letter spacing method to print text with gaps
     *
     * @function
     * @param {String|Array} text String to be added to the page.
     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} spacing Spacing (in units declared at inception)
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name lstext
     * @deprecated We'll be removing this function. It doesn't take character width into account.
     */
    API.lstext = function(text, x, y, spacing) {
      console.warn('jsPDF.lstext is deprecated');
      for (var i = 0, len = text.length; i < len; i++, x += spacing) this
        .text(text[i], x, y);
      return this;
    };

    API.line = function(x1, y1, x2, y2) {
      return this.lines([
        [x2 - x1, y2 - y1]
      ], x1, y1);
    };

    API.clip = function() {
      // By patrick-roberts, github.com/MrRio/jsPDF/issues/328
      // Call .clip() after calling .rect() with a style argument of null
      out('W') // clip
      out('S') // stroke path; necessary for clip to work
    };

    /**
     * This fixes the previous function clip(). Perhaps the 'stroke path' hack was due to the missing 'n' instruction?
     * We introduce the fixed version so as to not break API.
     * @param fillRule
     */
    API.clip_fixed = function(fillRule) {
      // Call .clip() after calling drawing ops with a style argument of null
      // W is the PDF clipping op
      if ('evenodd' === fillRule) {
        out('W*');
      } else {
        out('W');
      }
      // End the path object without filling or stroking it.
      // This operator is a path-painting no-op, used primarily for the side effect of changing the current clipping path
      // (see Section 4.4.3, “Clipping Path Operators”)
      out('n');
    };

    /**
     * Adds series of curves (straight lines or cubic bezier curves) to canvas, starting at `x`, `y` coordinates.
     * All data points in `lines` are relative to last line origin.
     * `x`, `y` become x1,y1 for first line / curve in the set.
     * For lines you only need to specify [x2, y2] - (ending point) vector against x1, y1 starting point.
     * For bezier curves you need to specify [x2,y2,x3,y3,x4,y4] - vectors to control points 1, 2, ending point. All vectors are against the start of the curve - x1,y1.
     *
     * @example .lines([[2,2],[-2,2],[1,1,2,2,3,3],[2,1]], 212,110, 10) // line, line, bezier curve, line
     * @param {Array} lines Array of *vector* shifts as pairs (lines) or sextets (cubic bezier curves).
     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} scale (Defaults to [1.0,1.0]) x,y Scaling factor for all vectors. Elements can be any floating number Sub-one makes drawing smaller. Over-one grows the drawing. Negative flips the direction.
     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
     * @param {Boolean} closed If true, the path is closed with a straight line from the end of the last curve to the starting point.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name lines
     */
    API.lines = function(lines, x, y, scale, style, closed) {
      var scalex, scaley, i, l, leg, x2, y2, x3, y3, x4, y4;

      // Pre-August-2012 the order of arguments was function(x, y, lines, scale, style)
      // in effort to make all calls have similar signature like
      //   function(content, coordinateX, coordinateY , miscellaneous)
      // this method had its args flipped.
      // code below allows backward compatibility with old arg order.
      if (typeof lines === 'number') {
        tmp = y;
        y = x;
        x = lines;
        lines = tmp;
      }

      scale = scale || [1, 1];

      // starting point
      out(f3(x * k) + ' ' + f3((pageHeight - y) * k) + ' m ');

      scalex = scale[0];
      scaley = scale[1];
      l = lines.length;
      //, x2, y2 // bezier only. In page default measurement "units", *after* scaling
      //, x3, y3 // bezier only. In page default measurement "units", *after* scaling
      // ending point for all, lines and bezier. . In page default measurement "units", *after* scaling
      x4 = x; // last / ending point = starting point for first item.
      y4 = y; // last / ending point = starting point for first item.

      for (i = 0; i < l; i++) {
        leg = lines[i];
        if (leg.length === 2) {
          // simple line
          x4 = leg[0] * scalex + x4; // here last x4 was prior ending point
          y4 = leg[1] * scaley + y4; // here last y4 was prior ending point
          out(f3(x4 * k) + ' ' + f3((pageHeight - y4) * k) + ' l');
        } else {
          // bezier curve
          x2 = leg[0] * scalex + x4; // here last x4 is prior ending point
          y2 = leg[1] * scaley + y4; // here last y4 is prior ending point
          x3 = leg[2] * scalex + x4; // here last x4 is prior ending point
          y3 = leg[3] * scaley + y4; // here last y4 is prior ending point
          x4 = leg[4] * scalex + x4; // here last x4 was prior ending point
          y4 = leg[5] * scaley + y4; // here last y4 was prior ending point
          out(
            f3(x2 * k) + ' ' +
            f3((pageHeight - y2) * k) + ' ' +
            f3(x3 * k) + ' ' +
            f3((pageHeight - y3) * k) + ' ' +
            f3(x4 * k) + ' ' +
            f3((pageHeight - y4) * k) + ' c');
        }
      }

      if (closed) {
        out(' h');
      }

      // stroking / filling / both the path
      if (style !== null) {
        out(getStyle(style));
      }
      return this;
    };

    /**
     * Adds a rectangle to PDF
     *
     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} w Width (in units declared at inception of PDF document)
     * @param {Number} h Height (in units declared at inception of PDF document)
     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name rect
     */
    API.rect = function(x, y, w, h, style) {
      var op = getStyle(style);
      out([
        f2(x * k),
        f2((pageHeight - y) * k),
        f2(w * k),
        f2(-h * k),
        're'
      ].join(' '));

      if (style !== null) {
        out(getStyle(style));
      }

      return this;
    };

    /**
     * Adds a triangle to PDF
     *
     * @param {Number} x1 Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y1 Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} x2 Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y2 Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} x3 Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y3 Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name triangle
     */
    API.triangle = function(x1, y1, x2, y2, x3, y3, style) {
      this.lines(
        [
          [x2 - x1, y2 - y1], // vector to point 2
          [x3 - x2, y3 - y2], // vector to point 3
          [x1 - x3, y1 - y3] // closing vector back to point 1
        ],
        x1,
        y1, // start of path
        [1, 1],
        style,
        true);
      return this;
    };

    /**
     * Adds a rectangle with rounded corners to PDF
     *
     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} w Width (in units declared at inception of PDF document)
     * @param {Number} h Height (in units declared at inception of PDF document)
     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name roundedRect
     */
    API.roundedRect = function(x, y, w, h, rx, ry, style) {
      var MyArc = 4 / 3 * (Math.SQRT2 - 1);
      this.lines(
        [
          [(w - 2 * rx), 0],
          [(rx * MyArc), 0, rx, ry - (ry * MyArc), rx, ry],
          [0, (h - 2 * ry)],
          [0, (ry * MyArc), -(rx * MyArc), ry, -rx, ry],
          [(-w + 2 * rx), 0],
          [-(rx * MyArc), 0, -rx, -(ry * MyArc), -rx, -ry],
          [0, (-h + 2 * ry)],
          [0, -(ry * MyArc), (rx * MyArc), -ry, rx, -ry]
        ],
        x + rx,
        y, // start of path
        [1, 1],
        style);
      return this;
    };

    /**
     * Adds an ellipse to PDF
     *
     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name ellipse
     */
    API.ellipse = function(x, y, rx, ry, style) {
      var lx = 4 / 3 * (Math.SQRT2 - 1) * rx,
        ly = 4 / 3 * (Math.SQRT2 - 1) * ry;

      out([
        f2((x + rx) * k),
        f2((pageHeight - y) * k),
        'm',
        f2((x + rx) * k),
        f2((pageHeight - (y - ly)) * k),
        f2((x + lx) * k),
        f2((pageHeight - (y - ry)) * k),
        f2(x * k),
        f2((pageHeight - (y - ry)) * k),
        'c'
      ].join(' '));
      out([
        f2((x - lx) * k),
        f2((pageHeight - (y - ry)) * k),
        f2((x - rx) * k),
        f2((pageHeight - (y - ly)) * k),
        f2((x - rx) * k),
        f2((pageHeight - y) * k),
        'c'
      ].join(' '));
      out([
        f2((x - rx) * k),
        f2((pageHeight - (y + ly)) * k),
        f2((x - lx) * k),
        f2((pageHeight - (y + ry)) * k),
        f2(x * k),
        f2((pageHeight - (y + ry)) * k),
        'c'
      ].join(' '));
      out([
        f2((x + lx) * k),
        f2((pageHeight - (y + ry)) * k),
        f2((x + rx) * k),
        f2((pageHeight - (y + ly)) * k),
        f2((x + rx) * k),
        f2((pageHeight - y) * k),
        'c'
      ].join(' '));

      if (style !== null) {
        out(getStyle(style));
      }

      return this;
    };

    /**
     * Adds an circle to PDF
     *
     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param {Number} r Radius (in units declared at inception of PDF document)
     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name circle
     */
    API.circle = function(x, y, r, style) {
      return this.ellipse(x, y, r, r, style);
    };

    /**
     * Adds a properties to the PDF document
     *
     * @param {Object} A property_name-to-property_value object structure.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setProperties
     */
    API.setProperties = function(properties) {
      // copying only those properties we can render.
      for (var property in documentProperties) {
        if (documentProperties.hasOwnProperty(property) && properties[
            property]) {
          documentProperties[property] = properties[property];
        }
      }
      return this;
    };

    /**
     * Sets font size for upcoming text elements.
     *
     * @param {Number} size Font size in points.
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setFontSize
     */
    API.setFontSize = function(size) {
      activeFontSize = size;
      return this;
    };

    /**
     * Sets text font face, variant for upcoming text elements.
     * See output of jsPDF.getFontList() for possible font names, styles.
     *
     * @param {String} fontName Font name or family. Example: "times"
     * @param {String} fontStyle Font style or variant. Example: "italic"
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setFont
     */
    API.setFont = function(fontName, fontStyle) {
      activeFontKey = getFont(fontName, fontStyle);
      // if font is not found, the above line blows up and we never go further
      return this;
    };

    /**
     * Switches font style or variant for upcoming text elements,
     * while keeping the font face or family same.
     * See output of jsPDF.getFontList() for possible font names, styles.
     *
     * @param {String} style Font style or variant. Example: "italic"
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setFontStyle
     */
    API.setFontStyle = API.setFontType = function(style) {
      activeFontKey = getFont(undefined, style);
      // if font is not found, the above line blows up and we never go further
      return this;
    };

    /**
     * Returns an object - a tree of fontName to fontStyle relationships available to
     * active PDF document.
     *
     * @public
     * @function
     * @returns {Object} Like {'times':['normal', 'italic', ... ], 'arial':['normal', 'bold', ... ], ... }
     * @methodOf jsPDF#
     * @name getFontList
     */
    API.getFontList = function() {
      // TODO: iterate over fonts array or return copy of fontmap instead in case more are ever added.
      var list = {},
        fontName, fontStyle, tmp;

      for (fontName in fontmap) {
        if (fontmap.hasOwnProperty(fontName)) {
          list[fontName] = tmp = [];
          for (fontStyle in fontmap[fontName]) {
            if (fontmap[fontName].hasOwnProperty(fontStyle)) {
              tmp.push(fontStyle);
            }
          }
        }
      }

      return list;
    };

    /**
     * Add a custom font.
     *
     * @param {String} Postscript name of the Font.  Example: "Menlo-Regular"
     * @param {String} Name of font-family from @font-face definition.  Example: "Menlo Regular"
     * @param {String} Font style.  Example: "normal"
     * @function
     * @returns the {fontKey} (same as the internal method)
     * @methodOf jsPDF#
     * @name addFont
     */
    API.addFont = function(postScriptName, fontName, fontStyle) {
      addFont(postScriptName, fontName, fontStyle, 'StandardEncoding');
    };

    /**
     * Sets line width for upcoming lines.
     *
     * @param {Number} width Line width (in units declared at inception of PDF document)
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setLineWidth
     */
    API.setLineWidth = function(width) {
      out((width * k).toFixed(2) + ' w');
      return this;
    };

    /**
     * Sets the stroke color for upcoming elements.
     *
     * Depending on the number of arguments given, Gray, RGB, or CMYK
     * color space is implied.
     *
     * When only ch1 is given, "Gray" color space is implied and it
     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
     * if values are communicated as String types, or in range from 0 (black)
     * to 255 (white) if communicated as Number type.
     * The RGB-like 0-255 range is provided for backward compatibility.
     *
     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
     * value must be in the range from 0.00 (minimum intensity) to to 1.00
     * (max intensity) if values are communicated as String types, or
     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
     * as Number types.
     * The RGB-like 0-255 range is provided for backward compatibility.
     *
     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
     * value must be a in the range from 0.00 (0% concentration) to to
     * 1.00 (100% concentration)
     *
     * Because JavaScript treats fixed point numbers badly (rounds to
     * floating point nearest to binary representation) it is highly advised to
     * communicate the fractional numbers as String types, not JavaScript Number type.
     *
     * @param {Number|String} ch1 Color channel value
     * @param {Number|String} ch2 Color channel value
     * @param {Number|String} ch3 Color channel value
     * @param {Number|String} ch4 Color channel value
     *
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setDrawColor
     */
    API.setDrawColor = function(ch1, ch2, ch3, ch4) {
      var color;
      if (ch2 === undefined || (ch4 === undefined && ch1 === ch2 === ch3)) {
        // Gray color space.
        if (typeof ch1 === 'string') {
          color = ch1 + ' G';
        } else {
          color = f2(ch1 / 255) + ' G';
        }
      } else if (ch4 === undefined) {
        // RGB
        if (typeof ch1 === 'string') {
          color = [ch1, ch2, ch3, 'RG'].join(' ');
        } else {
          color = [f2(ch1 / 255), f2(ch2 / 255), f2(ch3 / 255), 'RG'].join(
            ' ');
        }
      } else {
        // CMYK
        if (typeof ch1 === 'string') {
          color = [ch1, ch2, ch3, ch4, 'K'].join(' ');
        } else {
          color = [f2(ch1), f2(ch2), f2(ch3), f2(ch4), 'K'].join(' ');
        }
      }

      out(color);
      return this;
    };

    /**
     * Sets the fill color for upcoming elements.
     *
     * Depending on the number of arguments given, Gray, RGB, or CMYK
     * color space is implied.
     *
     * When only ch1 is given, "Gray" color space is implied and it
     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
     * if values are communicated as String types, or in range from 0 (black)
     * to 255 (white) if communicated as Number type.
     * The RGB-like 0-255 range is provided for backward compatibility.
     *
     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
     * value must be in the range from 0.00 (minimum intensity) to to 1.00
     * (max intensity) if values are communicated as String types, or
     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
     * as Number types.
     * The RGB-like 0-255 range is provided for backward compatibility.
     *
     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
     * value must be a in the range from 0.00 (0% concentration) to to
     * 1.00 (100% concentration)
     *
     * Because JavaScript treats fixed point numbers badly (rounds to
     * floating point nearest to binary representation) it is highly advised to
     * communicate the fractional numbers as String types, not JavaScript Number type.
     *
     * @param {Number|String} ch1 Color channel value
     * @param {Number|String} ch2 Color channel value
     * @param {Number|String} ch3 Color channel value
     * @param {Number|String} ch4 Color channel value
     *
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setFillColor
     */
    API.setFillColor = function(ch1, ch2, ch3, ch4) {
      var color;

      if (ch2 === undefined || (ch4 === undefined && ch1 === ch2 === ch3)) {
        // Gray color space.
        if (typeof ch1 === 'string') {
          color = ch1 + ' g';
        } else {
          color = f2(ch1 / 255) + ' g';
        }
      } else if (ch4 === undefined || typeof ch4 === 'object') {
        // RGB
        if (typeof ch1 === 'string') {
          color = [ch1, ch2, ch3, 'rg'].join(' ');
        } else {
          color = [f2(ch1 / 255), f2(ch2 / 255), f2(ch3 / 255), 'rg'].join(
            ' ');
        }
        if (ch4 && ch4.a === 0) {
          //TODO Implement transparency.
          //WORKAROUND use white for now
          color = ['255', '255', '255', 'rg'].join(' ');
        }
      } else {
        // CMYK
        if (typeof ch1 === 'string') {
          color = [ch1, ch2, ch3, ch4, 'k'].join(' ');
        } else {
          color = [f2(ch1), f2(ch2), f2(ch3), f2(ch4), 'k'].join(' ');
        }
      }

      out(color);
      return this;
    };

    /**
     * Sets the text color for upcoming elements.
     * If only one, first argument is given,
     * treats the value as gray-scale color value.
     *
     * @param {Number} r Red channel color value in range 0-255 or {String} r color value in hexadecimal, example: '#FFFFFF'
     * @param {Number} g Green channel color value in range 0-255
     * @param {Number} b Blue channel color value in range 0-255
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setTextColor
     */
    API.setTextColor = function(r, g, b) {
      if ((typeof r === 'string') && /^#[0-9A-Fa-f]{6}$/.test(r)) {
        var hex = parseInt(r.substr(1), 16);
        r = (hex >> 16) & 255;
        g = (hex >> 8) & 255;
        b = (hex & 255);
      }

      if ((r === 0 && g === 0 && b === 0) || (typeof g === 'undefined')) {
        textColor = f3(r / 255) + ' g';
      } else {
        textColor = [f3(r / 255), f3(g / 255), f3(b / 255), 'rg'].join(
          ' ');
      }
      return this;
    };

    /**
     * Is an Object providing a mapping from human-readable to
     * integer flag values designating the varieties of line cap
     * and join styles.
     *
     * @returns {Object}
     * @fieldOf jsPDF#
     * @name CapJoinStyles
     */
    API.CapJoinStyles = {
      0: 0,
      'butt': 0,
      'but': 0,
      'miter': 0,
      1: 1,
      'round': 1,
      'rounded': 1,
      'circle': 1,
      2: 2,
      'projecting': 2,
      'project': 2,
      'square': 2,
      'bevel': 2
    };

    /**
     * Sets the line cap styles
     * See {jsPDF.CapJoinStyles} for variants
     *
     * @param {String|Number} style A string or number identifying the type of line cap
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setLineCap
     */
    API.setLineCap = function(style) {
      var id = this.CapJoinStyles[style];
      if (id === undefined) {
        throw new Error("Line cap style of '" + style +
          "' is not recognized. See or extend .CapJoinStyles property for valid styles"
        );
      }
      lineCapID = id;
      out(id + ' J');

      return this;
    };

    /**
     * Sets the line join styles
     * See {jsPDF.CapJoinStyles} for variants
     *
     * @param {String|Number} style A string or number identifying the type of line join
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name setLineJoin
     */
    API.setLineJoin = function(style) {
      var id = this.CapJoinStyles[style];
      if (id === undefined) {
        throw new Error("Line join style of '" + style +
          "' is not recognized. See or extend .CapJoinStyles property for valid styles"
        );
      }
      lineJoinID = id;
      out(id + ' j');

      return this;
    };

    // Output is both an internal (for plugins) and external function
    API.output = output;

    /**
     * Saves as PDF document. An alias of jsPDF.output('save', 'filename.pdf')
     * @param  {String} filename The filename including extension.
     *
     * @function
     * @returns {jsPDF}
     * @methodOf jsPDF#
     * @name save
     */
    API.save = function(filename) {
      API.output('save', filename);
    };

    // applying plugins (more methods) ON TOP of built-in API.
    // this is intentional as we allow plugins to override
    // built-ins
    for (var plugin in jsPDF.API) {
      if (jsPDF.API.hasOwnProperty(plugin)) {
        if (plugin === 'events' && jsPDF.API.events.length) {
          (function(events, newEvents) {

            // jsPDF.API.events is a JS Array of Arrays
            // where each Array is a pair of event name, handler
            // Events were added by plugins to the jsPDF instantiator.
            // These are always added to the new instance and some ran
            // during instantiation.
            var eventname, handler_and_args, i;

            for (i = newEvents.length - 1; i !== -1; i--) {
              // subscribe takes 3 args: 'topic', function, runonce_flag
              // if undefined, runonce is false.
              // users can attach callback directly,
              // or they can attach an array with [callback, runonce_flag]
              // that's what the "apply" magic is for below.
              eventname = newEvents[i][0];
              handler_and_args = newEvents[i][1];
              events.subscribe.apply(
                events, [eventname].concat(
                  typeof handler_and_args === 'function' ? [
                    handler_and_args
                  ] : handler_and_args));
            }
          }(events, jsPDF.API.events));
        } else {
          API[plugin] = jsPDF.API[plugin];
        }
      }
    }

    //////////////////////////////////////////////////////
    // continuing initialization of jsPDF Document object
    //////////////////////////////////////////////////////
    // Add the first page automatically
    addFonts();
    activeFontKey = 'F1';
    _addPage(format, orientation);

    events.publish('initialized');
    return API;
  }

  /**
   * jsPDF.API is a STATIC property of jsPDF class.
   * jsPDF.API is an object you can add methods and properties to.
   * The methods / properties you add will show up in new jsPDF objects.
   *
   * One property is prepopulated. It is the 'events' Object. Plugin authors can add topics,
   * callbacks to this object. These will be reassigned to all new instances of jsPDF.
   * Examples:
   * jsPDF.API.events['initialized'] = function(){ 'this' is API object }
   * jsPDF.API.events['addFont'] = function(added_font_object){ 'this' is API object }
   *
   * @static
   * @public
   * @memberOf jsPDF
   * @name API
   *
   * @example
   * jsPDF.API.mymethod = function(){
   *   // 'this' will be ref to internal API object. see jsPDF source
   *   // , so you can refer to built-in methods like so:
   *   //     this.line(....)
   *   //     this.text(....)
   * }
   * var pdfdoc = new jsPDF()
   * pdfdoc.mymethod() // <- !!!!!!
   */
  jsPDF.API = {
    events: []
  };
  jsPDF.version = "1.x-master";

  if (typeof define === 'function' && define.amd) {
    define('jsPDF', function() {
      return jsPDF;
    });
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = jsPDF;
  } else {
    global.jsPDF = jsPDF;
  }
  return jsPDF;
}(typeof self !== "undefined" && self || typeof window !== "undefined" &&
  window || this));

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jspdf=e()}(this,function(){"use strict";var t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e=(function(){function t(t){this.value=t}function e(e){function n(i,o){try{var a=e[i](o),s=a.value;s instanceof t?Promise.resolve(s.value).then(function(t){n("next",t)},function(t){n("throw",t)}):r(a.done?"return":"normal",a.value)}catch(t){r("throw",t)}}function r(t,e){switch(t){case"return":i.resolve({value:e,done:!0});break;case"throw":i.reject(e);break;default:i.resolve({value:e,done:!1})}(i=i.next)?n(i.key,i.arg):o=null}var i,o;this._invoke=function(t,e){return new Promise(function(r,a){var s={key:t,arg:e,resolve:r,reject:a,next:null};o?o=o.next=s:(i=o=s,n(t,e))})},"function"!=typeof e.return&&(this.return=void 0)}"function"==typeof Symbol&&Symbol.asyncIterator&&(e.prototype[Symbol.asyncIterator]=function(){return this}),e.prototype.next=function(t){return this._invoke("next",t)},e.prototype.throw=function(t){return this._invoke("throw",t)},e.prototype.return=function(t){return this._invoke("return",t)}}(),function(e){function n(t){var n={};this.subscribe=function(t,e,r){if("function"!=typeof e)return!1;n.hasOwnProperty(t)||(n[t]={});var i=Math.random().toString(35);return n[t][i]=[e,!!r],i},this.unsubscribe=function(t){for(var e in n)if(n[e][t])return delete n[e][t],!0;return!1},this.publish=function(r){if(n.hasOwnProperty(r)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var a in n[r]){var s=n[r][a];try{s[0].apply(t,i)}catch(t){e.console&&console.error("jsPDF PubSub Error",t.message,t)}s[1]&&o.push(a)}o.length&&o.forEach(this.unsubscribe)}}}function i(c,l,u,h){var f={};"object"===(void 0===c?"undefined":t(c))&&(c=(f=c).orientation,l=f.unit||l,u=f.format||u,h=f.compress||f.compressPdf||h),l=l||"mm",u=u||"a4",c=(""+(c||"P")).toLowerCase();(""+u).toLowerCase();var d,p,m,g,w,y,v,b,x,k=!!h&&"function"==typeof Uint8Array,_=f.textColor||"0 g",C=f.drawColor||"0 G",A=f.fontSize||16,S=f.lineHeight||1.15,q=f.lineWidth||.200025,T=2,P=!1,I=[],E={},O={},F=0,B=[],R=[],D=[],j=[],z=[],N=0,L=0,M=0,U={title:"",subject:"",author:"",keywords:"",creator:""},H={},W=new n(H),X=f.hotfixes||[],V=function(t){return t.toFixed(2)},G=function(t){return t.toFixed(3)},Y=function(t){return("0"+parseInt(t)).slice(-2)},J=function(t){P?B[g].push(t):(M+=t.length+1,j.push(t))},Q=function(){return T++,I[T]=M,J(T+" 0 obj"),T},K=function(t){J("stream"),J(t),J("endstream")},$=function(){var t,n,r,a,s,c,l,u,h,f=[];for(l=e.adler32cs||i.adler32cs,k&&void 0===l&&(k=!1),t=1;t<=F;t++){if(f.push(Q()),u=(w=D[t].width)*p,h=(y=D[t].height)*p,J("<</Type /Page"),J("/Parent 1 0 R"),J("/Resources 2 0 R"),J("/MediaBox [0 0 "+V(u)+" "+V(h)+"]"),W.publish("putPage",{pageNumber:t,page:B[t]}),J("/Contents "+(T+1)+" 0 R"),J(">>"),J("endobj"),n=B[t].join("\n"),Q(),k){for(r=[],a=n.length;a--;)r[a]=n.charCodeAt(a);c=l.from(n),(s=new o(6)).append(new Uint8Array(r)),n=s.flush(),(r=new Uint8Array(n.length+6)).set(new Uint8Array([120,156])),r.set(n,2),r.set(new Uint8Array([255&c,c>>8&255,c>>16&255,c>>24&255]),n.length+2),n=String.fromCharCode.apply(null,r),J("<</Length "+n.length+" /Filter [/FlateDecode]>>")}else J("<</Length "+n.length+">>");K(n),J("endobj")}I[1]=M,J("1 0 obj"),J("<</Type /Pages");var d="/Kids [";for(a=0;a<F;a++)d+=f[a]+" 0 R ";J(d+"]"),J("/Count "+F),J(">>"),J("endobj"),W.publish("postPutPages")},Z=function(t){t.objectNumber=Q(),J("<</BaseFont/"+t.PostScriptName+"/Type/Font"),"string"==typeof t.encoding&&J("/Encoding/"+t.encoding),J("/Subtype/Type1>>"),J("endobj")},tt=function(){for(var t in E)E.hasOwnProperty(t)&&Z(E[t])},et=function(){W.publish("putXobjectDict")},nt=function(){J("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),J("/Font <<");for(var t in E)E.hasOwnProperty(t)&&J("/"+t+" "+E[t].objectNumber+" 0 R");J(">>"),J("/XObject <<"),et(),J(">>")},rt=function(){tt(),W.publish("putResources"),I[2]=M,J("2 0 obj"),J("<<"),nt(),J(">>"),J("endobj"),W.publish("postPutResources")},it=function(){W.publish("putAdditionalObjects");for(var t=0;t<z.length;t++){var e=z[t];I[e.objId]=M,J(e.objId+" 0 obj"),J(e.content),J("endobj")}T+=z.length,W.publish("postPutAdditionalObjects")},ot=function(t,e,n){O.hasOwnProperty(e)||(O[e]={}),O[e][n]=t},at=function(t,e,n,r){var i="F"+(Object.keys(E).length+1).toString(10),o=E[i]={id:i,PostScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return ot(i,e,n),W.publish("addFont",o),i},st=function(t,e){var n,r,i,o,a,s,c,l,u;if(e=e||{},i=e.sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&E[d].metadata&&E[d].metadata[i]&&E[d].metadata[i].encoding&&(o=E[d].metadata[i].encoding,!a&&E[d].encoding&&(a=E[d].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(c=!1,s=[],n=0,r=t.length;n<r;n++)(l=a[t.charCodeAt(n)])?s.push(String.fromCharCode(l)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(n=t.length;void 0===c&&0!==n;)t.charCodeAt(n-1)>>8&&(c=!0),n--;if(!c)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if(l=t.charCodeAt(n),(u=l>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(l-(u<<8))}return String.fromCharCode.apply(void 0,s)},ct=function(t,e){return st(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},lt=function(){J("/Producer (jsPDF "+i.version+")");for(var t in U)U.hasOwnProperty(t)&&U[t]&&J("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ct(U[t])+")");var e=new Date,n=e.getTimezoneOffset(),r=n<0?"+":"-",o=Math.floor(Math.abs(n/60)),a=Math.abs(n%60),s=[r,Y(o),"'",Y(a),"'"].join("");J(["/CreationDate (D:",e.getFullYear(),Y(e.getMonth()+1),Y(e.getDate()),Y(e.getHours()),Y(e.getMinutes()),Y(e.getSeconds()),s,")"].join(""))},ut=function(){switch(J("/Type /Catalog"),J("/Pages 1 0 R"),b||(b="fullwidth"),b){case"fullwidth":J("/OpenAction [3 0 R /FitH null]");break;case"fullheight":J("/OpenAction [3 0 R /FitV null]");break;case"fullpage":J("/OpenAction [3 0 R /Fit]");break;case"original":J("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+b;"%"===t.substr(t.length-1)&&(b=parseInt(b)/100),"number"==typeof b&&J("/OpenAction [3 0 R /XYZ null null "+V(b)+"]")}switch(x||(x="continuous"),x){case"continuous":J("/PageLayout /OneColumn");break;case"single":J("/PageLayout /SinglePage");break;case"two":case"twoleft":J("/PageLayout /TwoColumnLeft");break;case"tworight":J("/PageLayout /TwoColumnRight")}v&&J("/PageMode /"+v),W.publish("putCatalog")},ht=function(){J("/Size "+(T+1)),J("/Root "+T+" 0 R"),J("/Info "+(T-1)+" 0 R")},ft=function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();s.hasOwnProperty(r)&&(t=s[r][0]/p,e=s[r][1]/p)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":e>t&&(n="s");break;case"p":t>e&&(n="s")}"s"===n&&(m=t,t=e,e=m)}P=!0,B[++F]=[],D[F]={width:Number(t)||w,height:Number(e)||y},R[F]={},mt(F)},dt=function(){ft.apply(this,arguments),J(V(q*p)+" w"),J(C),0!==N&&J(N+" J"),0!==L&&J(L+" j"),W.publish("addPage",{pageNumber:F})},pt=function(t){t>0&&t<=F&&(B.splice(t,1),D.splice(t,1),g>--F&&(g=F),this.setPage(g))},mt=function(t){t>0&&t<=F&&(g=t,w=D[t].width,y=D[t].height)},gt=function(t,e){var n;switch(t=void 0!==t?t:E[d].fontName,e=void 0!==e?e:E[d].fontStyle,void 0!==t&&(t=t.toLowerCase()),t){case"sans-serif":case"verdana":case"arial":case"helvetica":t="helvetica";break;case"fixed":case"monospace":case"terminal":case"courier":t="courier";break;case"serif":case"cursive":case"fantasy":default:t="times"}try{n=O[t][e]}catch(t){}return n||null==(n=O.times[e])&&(n=O.times.normal),n},wt=function(){P=!1,T=2,M=0,j=[],I=[],z=[],W.publish("buildDocument"),J("%PDF-"+a),$(),it(),rt(),Q(),J("<<"),lt(),J(">>"),J("endobj"),Q(),J("<<"),ut(),J(">>"),J("endobj");var t,e=M,n="0000000000";for(J("xref"),J("0 "+(T+1)),J(n+" 65535 f "),t=1;t<=T;t++){var r=I[t];J("function"==typeof r?(n+I[t]()).slice(-10)+" 00000 n ":(n+I[t]).slice(-10)+" 00000 n ")}return J("trailer"),J("<<"),ht(),J(">>"),J("startxref"),J(""+e),J("%%EOF"),P=!0,j.join("\n")},yt=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},vt=function(){for(var t=wt(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},bt=function(){return new Blob([vt()],{type:"application/pdf"})},xt=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var n=t.stack||"";~n.indexOf(" at ")&&(n=n.split(" at ")[1]);var r="Error in function "+n.split("\n")[0].split("<")[0]+": "+t.message;if(!e.console)throw new Error(r);e.console.error(r,t),e.alert&&alert(r)}},t.foo.bar=t,t.foo}(function(t,n){var i="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(wt()):0;switch(t){case void 0:return wt();case"save":if(navigator.getUserMedia&&(void 0===e.URL||void 0===e.URL.createObjectURL))return H.output("dataurlnewwindow");r(bt(),n),"function"==typeof r.unload&&e.setTimeout&&setTimeout(r.unload,911);break;case"arraybuffer":return vt();case"blob":return bt();case"bloburi":case"bloburl":return e.URL&&e.URL.createObjectURL(bt())||void 0;case"datauristring":case"dataurlstring":return i;case"dataurlnewwindow":var o=e.open(i);if(o||"undefined"==typeof safari)return o;case"datauri":case"dataurl":return e.document.location.href=i;default:throw new Error('Output type "'+t+'" is not supported.')}}),kt=function(t){return!0===Array.isArray(X)&&X.indexOf(t)>-1};switch(l){case"pt":p=1;break;case"mm":p=72/25.4000508;break;case"cm":p=72/2.54000508;break;case"in":p=72;break;case"px":p=1==kt("px_scaling")?.75:96/72;break;case"pc":case"em":p=12;break;case"ex":p=6;break;default:throw"Invalid unit: "+l}H.internal={pdfEscape:ct,getStyle:yt,getFont:function(){return E[gt.apply(H,arguments)]},getFontSize:function(){return A},getLineHeight:function(){return A*S},write:function(t){J(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return V(t*p)},getVerticalCoordinateString:function(t){return V((y-t)*p)},collections:{},newObject:Q,newAdditionalObject:function(){var t=2*B.length+1,e={objId:t+=z.length,content:""};return z.push(e),e},newObjectDeferred:function(){return T++,I[T]=function(){return M},T},newObjectDeferredBegin:function(t){I[t]=M},putStream:K,events:W,scaleFactor:p,pageSize:{get width(){return w},get height(){return y}},output:function(t,e){return xt(t,e)},getNumberOfPages:function(){return B.length-1},pages:B,out:J,f2:V,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:R[t]}},getCurrentPageInfo:function(){return{objId:2*(g-1)+3,pageNumber:g,pageContext:R[g]}},getPDFVersion:function(){return a},hasHotfix:kt},H.addPage=function(){return dt.apply(this,arguments),this},H.setPage=function(){return mt.apply(this,arguments),this},H.insertPage=function(t){return this.addPage(),this.movePage(g,t),this},H.movePage=function(t,e){if(t>e){for(var n=B[t],r=D[t],i=R[t],o=t;o>e;o--)B[o]=B[o-1],D[o]=D[o-1],R[o]=R[o-1];B[e]=n,D[e]=r,R[e]=i,this.setPage(e)}else if(t<e){for(var n=B[t],r=D[t],i=R[t],o=t;o<e;o++)B[o]=B[o+1],D[o]=D[o+1],R[o]=R[o+1];B[e]=n,D[e]=r,R[e]=i,this.setPage(e)}return this},H.deletePage=function(){return pt.apply(this,arguments),this},H.setDisplayMode=function(t,e,n){if(b=t,x=e,v=n,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},H.text=function(t,e,n,r,i,o){function a(t){return t=t.split("\t").join(Array(f.TabLen||9).join(" ")),ct(t,r)}"number"==typeof t&&(m=n,n=e,e=t,t=m),"string"==typeof t&&(t=t.match(/[\n\r]/)?t.split(/\r\n|\r|\n/g):[t]),"string"==typeof i&&(o=i,i=null),"string"==typeof r&&(o=r,r=null),"number"==typeof r&&(i=r,r=null);var s="",c="Td";if(i){i*=Math.PI/180;var l=Math.cos(i),u=Math.sin(i);s=[V(l),V(u),V(-1*u),V(l),""].join(" "),c="Tm"}"noBOM"in(r=r||{})||(r.noBOM=!0),"autoencode"in r||(r.autoencode=!0);var h="",g=this.internal.getCurrentPageInfo().pageContext;if(!0===r.stroke?!0!==g.lastTextWasStroke&&(h="1 Tr\n",g.lastTextWasStroke=!0):(g.lastTextWasStroke&&(h="0 Tr\n"),g.lastTextWasStroke=!1),void 0===this._runningPageHeight&&(this._runningPageHeight=0),"string"==typeof t)t=a(t);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');for(var w=t.concat(),v=[],b=w.length;b--;)v.push(a(w.shift()));if(o){var x,k,C,q=A*S,T=t.map(function(t){return this.getStringUnitWidth(t)*A/p},this);if(C=Math.max.apply(Math,T),"center"===o)x=e-C/2,e-=T[0]/2;else{if("right"!==o)throw new Error('Unrecognized alignment option, use "center" or "right".');x=e-C,e-=T[0]}k=e,t=v[0];for(var P=1,b=v.length;P<b;P++){var I=C-T[P];"center"===o&&(I/=2),t+=") Tj\n"+(x-k+I)+" -"+q+" Td ("+v[P],k=x+I}}else t=v.join(") Tj\nT* (")}var E;return E=V((y-n)*p),J("BT\n/"+d+" "+A+" Tf\n"+A*S+" TL\n"+h+_+"\n"+s+V(e*p)+" "+E+" "+c+"\n("+t+") Tj\nET"),this},H.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},H.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},H.clip=function(){J("W"),J("S")},H.clip_fixed=function(t){J("evenodd"===t?"W*":"W"),J("n")},H.lines=function(t,e,n,r,i,o){var a,s,c,l,u,h,f,d,g,w,v;for("number"==typeof t&&(m=n,n=e,e=t,t=m),r=r||[1,1],J(G(e*p)+" "+G((y-n)*p)+" m "),a=r[0],s=r[1],l=t.length,w=e,v=n,c=0;c<l;c++)2===(u=t[c]).length?(w=u[0]*a+w,v=u[1]*s+v,J(G(w*p)+" "+G((y-v)*p)+" l")):(h=u[0]*a+w,f=u[1]*s+v,d=u[2]*a+w,g=u[3]*s+v,w=u[4]*a+w,v=u[5]*s+v,J(G(h*p)+" "+G((y-f)*p)+" "+G(d*p)+" "+G((y-g)*p)+" "+G(w*p)+" "+G((y-v)*p)+" c"));return o&&J(" h"),null!==i&&J(yt(i)),this},H.rect=function(t,e,n,r,i){yt(i);return J([V(t*p),V((y-e)*p),V(n*p),V(-r*p),"re"].join(" ")),null!==i&&J(yt(i)),this},H.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},H.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},H.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return J([V((t+n)*p),V((y-e)*p),"m",V((t+n)*p),V((y-(e-a))*p),V((t+o)*p),V((y-(e-r))*p),V(t*p),V((y-(e-r))*p),"c"].join(" ")),J([V((t-o)*p),V((y-(e-r))*p),V((t-n)*p),V((y-(e-a))*p),V((t-n)*p),V((y-e)*p),"c"].join(" ")),J([V((t-n)*p),V((y-(e+a))*p),V((t-o)*p),V((y-(e+r))*p),V(t*p),V((y-(e+r))*p),"c"].join(" ")),J([V((t+o)*p),V((y-(e+r))*p),V((t+n)*p),V((y-(e+a))*p),V((t+n)*p),V((y-e)*p),"c"].join(" ")),null!==i&&J(yt(i)),this},H.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},H.setProperties=function(t){for(var e in U)U.hasOwnProperty(e)&&t[e]&&(U[e]=t[e]);return this},H.setFontSize=function(t){return A=t,this},H.setFont=function(t,e){return d=gt(t,e),this},H.setFontStyle=H.setFontType=function(t){return d=gt(void 0,t),this},H.getFontList=function(){var t,e,n,r={};for(t in O)if(O.hasOwnProperty(t)){r[t]=n=[];for(e in O[t])O[t].hasOwnProperty(e)&&n.push(e)}return r},H.addFont=function(t,e,n){at(t,e,n,"StandardEncoding")},H.setLineWidth=function(t){return J((t*p).toFixed(2)+" w"),this},H.setDrawColor=function(t,e,n,r){var i;return i=void 0===e||void 0===r&&t===e===n?"string"==typeof t?t+" G":V(t/255)+" G":void 0===r?"string"==typeof t?[t,e,n,"RG"].join(" "):[V(t/255),V(e/255),V(n/255),"RG"].join(" "):"string"==typeof t?[t,e,n,r,"K"].join(" "):[V(t),V(e),V(n),V(r),"K"].join(" "),J(i),this},H.setFillColor=function(e,n,r,i){var o;return void 0===n||void 0===i&&e===n===r?o="string"==typeof e?e+" g":V(e/255)+" g":void 0===i||"object"===(void 0===i?"undefined":t(i))?(o="string"==typeof e?[e,n,r,"rg"].join(" "):[V(e/255),V(n/255),V(r/255),"rg"].join(" "),i&&0===i.a&&(o=["255","255","255","rg"].join(" "))):o="string"==typeof e?[e,n,r,i,"k"].join(" "):[V(e),V(n),V(r),V(i),"k"].join(" "),J(o),this},H.setTextColor=function(t,e,n){if("string"==typeof t&&/^#[0-9A-Fa-f]{6}$/.test(t)){var r=parseInt(t.substr(1),16);t=r>>16&255,e=r>>8&255,n=255&r}return _=0===t&&0===e&&0===n||void 0===e?G(t/255)+" g":[G(t/255),G(e/255),G(n/255),"rg"].join(" "),this},H.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},H.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return N=e,J(e+" J"),this},H.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return L=e,J(e+" j"),this},H.output=xt,H.save=function(t){H.output("save",t)};for(var _t in i.API)i.API.hasOwnProperty(_t)&&("events"===_t&&i.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(W,i.API.events):H[_t]=i.API[_t]);return function(){for(var t=[["Helvetica","helvetica","normal"],["Helvetica-Bold","helvetica","bold"],["Helvetica-Oblique","helvetica","italic"],["Helvetica-BoldOblique","helvetica","bolditalic"],["Courier","courier","normal"],["Courier-Bold","courier","bold"],["Courier-Oblique","courier","italic"],["Courier-BoldOblique","courier","bolditalic"],["Times-Roman","times","normal"],["Times-Bold","times","bold"],["Times-Italic","times","italic"],["Times-BoldItalic","times","bolditalic"],["ZapfDingbats","zapfdingbats"]],e=0,n=t.length;e<n;e++){var r=at(t[e][0],t[e][1],t[e][2],"StandardEncoding"),i=t[e][0].split("-");ot(r,i[0],i[1]||"")}W.publish("addFonts",{fonts:E,dictionary:O})}(),d="F1",dt(u,c),W.publish("initialized"),H}var a="1.3",s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};return i.API={events:[]},i.version="1.x-master","function"==typeof define&&define.amd?define("jsPDF",function(){return i}):"undefined"!=typeof module&&module.exports?module.exports=i:e.jsPDF=i,i}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0));/**
 * jsPDF AcroForm Plugin
 * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(window.AcroForm=function(t){var n=window.AcroForm;n.scale=function(t){return t*(r.internal.scaleFactor/1)},n.antiScale=function(t){return 1/r.internal.scaleFactor*t};var r={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null};e.API.acroformPlugin=r;var i=function(){for(var t in this.acroformPlugin.acroFormDictionaryRoot.Fields){var e=this.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&a.call(this,e)}},o=function(){if(this.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");this.acroformPlugin.acroFormDictionaryRoot=new n.AcroFormDictionary,this.acroformPlugin.internal=this.internal,this.acroformPlugin.acroFormDictionaryRoot._eventID=this.internal.events.subscribe("postPutResources",l),this.internal.events.subscribe("buildDocument",i),this.internal.events.subscribe("putCatalog",c),this.internal.events.subscribe("postPutPages",u)},a=function(t){var n={type:"reference",object:t};e.API.annotationPlugin.annotations[this.internal.getPageInfo(t.page).pageNumber].push(n)},s=function(t){this.acroformPlugin.printedOut&&(this.acroformPlugin.printedOut=!1,this.acroformPlugin.acroFormDictionaryRoot=null),this.acroformPlugin.acroFormDictionaryRoot||o.call(this),this.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},c=function(){void 0!==this.acroformPlugin.acroFormDictionaryRoot?this.internal.write("/AcroForm "+this.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},l=function(){this.internal.events.unsubscribe(this.acroformPlugin.acroFormDictionaryRoot._eventID),delete this.acroformPlugin.acroFormDictionaryRoot._eventID,this.acroformPlugin.printedOut=!0},u=function(t){var e=!t;t||(this.internal.newObjectDeferredBegin(this.acroformPlugin.acroFormDictionaryRoot.objId),this.internal.out(this.acroformPlugin.acroFormDictionaryRoot.getString()));var t=t||this.acroformPlugin.acroFormDictionaryRoot.Kids;for(var r in t){var i=t[r],o=i.Rect;i.Rect&&(i.Rect=n.internal.calculateCoordinates.call(this,i.Rect)),this.internal.newObjectDeferredBegin(i.objId);var a="";if(a+=i.objId+" 0 obj\n",a+="<<\n"+i.getContent(),i.Rect=o,i.hasAppearanceStream&&!i.appearanceStreamContent){var s=n.internal.calculateAppearanceStream.call(this,i);a+="/AP << /N "+s+" >>\n",this.acroformPlugin.xForms.push(s)}if(i.appearanceStreamContent){a+="/AP << ";for(var c in i.appearanceStreamContent){var l=i.appearanceStreamContent[c];if(a+="/"+c+" ",a+="<< ",Object.keys(l).length>=1||Array.isArray(l))for(var r in l)"function"==typeof(u=l[r])&&(u=u.call(this,i)),a+="/"+r+" "+u+" ",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u);else{var u=l;"function"==typeof u&&(u=u.call(this,i)),a+="/"+r+" "+u+" \n",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u)}a+=" >>\n"}a+=">>\n"}a+=">>\nendobj\n",this.internal.out(a)}e&&h.call(this,this.acroformPlugin.xForms)},h=function(t){for(var e in t){var n=e,r=t[e];this.internal.newObjectDeferredBegin(r&&r.objId);var i="";i+=r?r.getString():"",this.internal.out(i),delete t[n]}};t.addField=function(t){return t instanceof n.TextField?d.call(this,t):t instanceof n.ChoiceField?p.call(this,t):t instanceof n.Button?f.call(this,t):t instanceof n.ChildClass?s.call(this,t):t&&s.call(this,t),t.page=this.acroformPlugin.internal.getCurrentPageInfo().pageNumber,this};var f=function(t){(t=t||new n.Field).FT="/Btn";var e=t.Ff||0;t.pushbutton&&(e=n.internal.setBitPosition(e,17),delete t.pushbutton),t.radio&&(e=n.internal.setBitPosition(e,16),delete t.radio),t.noToggleToOff&&(e=n.internal.setBitPosition(e,15)),t.Ff=e,s.call(this,t)},d=function(t){(t=t||new n.Field).FT="/Tx";var e=t.Ff||0;t.multiline&&(e|=4096),t.password&&(e|=8192),t.fileSelect&&(e|=1<<20),t.doNotSpellCheck&&(e|=1<<22),t.doNotScroll&&(e|=1<<23),t.Ff=t.Ff||e,s.call(this,t)},p=function(t){var e=t||new n.Field;e.FT="/Ch";var r=e.Ff||0;e.combo&&(r=n.internal.setBitPosition(r,18),delete e.combo),e.edit&&(r=n.internal.setBitPosition(r,19),delete e.edit),e.sort&&(r=n.internal.setBitPosition(r,20),delete e.sort),e.multiSelect&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,22),delete e.multiSelect),e.doNotSpellCheck&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,23),delete e.doNotSpellCheck),e.Ff=r,s.call(this,e)}})(e.API);var n=window.AcroForm;n.internal={},n.createFormXObject=function(t){var e=new n.FormXObject,r=n.Appearance.internal.getHeight(t)||0,i=n.Appearance.internal.getWidth(t)||0;return e.BBox=[0,0,i,r],e},n.Appearance={CheckBox:{createAppearanceStream:function(){return{N:{On:n.Appearance.CheckBox.YesNormal},D:{On:n.Appearance.CheckBox.YesPushDown,Off:n.Appearance.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",50);return r+="0.749023 g\n             0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n             f\n             BMC\n             q\n             0 0 1 rg\n             /F13 "+i.fontSize+" Tf 0 g\n             BT\n",r+=i.text,r+="ET\n             Q\n             EMC\n",e.stream=r,e},YesNormal:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",.9*n.Appearance.internal.getHeight(t));return r+="1 g\n0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\nf\nq\n0 0 1 rg\n0 0 "+(n.Appearance.internal.getWidth(t)-1)+" "+(n.Appearance.internal.getHeight(t)-1)+" re\nW\nn\n0 g\nBT\n/F13 "+i.fontSize+" Tf 0 g\n",r+=i.text,r+="ET\n             Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Circle.YesNormal,e.D[t]=n.Appearance.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4;i*=.9;var o=n.Appearance.internal.Bezier_C;return r+="q\n1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+i*o+" "+i*o+" "+i+" 0 "+i+" c\n-"+i*o+" "+i+" -"+i+" "+i*o+" -"+i+" 0 c\n-"+i+" -"+i*o+" -"+i*o+" -"+i+" 0 -"+i+" c\n"+i*o+" -"+i+" "+i+" -"+i*o+" "+i+" 0 c\nf\nQ\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4,o=2*(i*=.9),a=o*n.Appearance.internal.Bezier_C,s=i*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n           1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n            0 g\n            q\n            1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+s+" "+s+" "+i+" 0 "+i+" c\n-"+s+" "+i+" -"+i+" "+s+" -"+i+" 0 c\n-"+i+" -"+s+" -"+s+" -"+i+" 0 -"+i+" c\n"+s+" -"+i+" "+i+" -"+s+" "+i+" 0 c\n            f\n            Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4,o=2*(i*=.9),a=o*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n 1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n",e.stream=r,e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Cross.YesNormal,e.D[t]=n.Appearance.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.calculateCross(t);return r+="q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+i.x1.x+" "+i.x1.y+" m\n            "+i.x2.x+" "+i.x2.y+" l\n            "+i.x4.x+" "+i.x4.y+" m\n            "+i.x3.x+" "+i.x3.y+" l\n            s\n            Q\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r=n.Appearance.internal.calculateCross(t),i="";return i+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n            q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+r.x1.x+" "+r.x1.y+" m\n            "+r.x2.x+" "+r.x2.y+" l\n            "+r.x4.x+" "+r.x4.y+" m\n            "+r.x3.x+" "+r.x3.y+" l\n            s\n            Q\n",e.stream=i,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}}},createDefaultAppearanceStream:function(t){var e="";return e+="/Helv 0 Tf 0 g"}},n.Appearance.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=n.Appearance.internal.getWidth(t),r=n.Appearance.internal.getHeight(t),i=function(t,e){return t>e?e:t}(e,r);return{x1:{x:(e-i)/2,y:(r-i)/2+i},x2:{x:(e-i)/2+i,y:(r-i)/2},x3:{x:(e-i)/2,y:(r-i)/2},x4:{x:(e-i)/2+i,y:(r-i)/2+i}}}},n.Appearance.internal.getWidth=function(t){return t.Rect[2]},n.Appearance.internal.getHeight=function(t){return t.Rect[3]},n.internal.inherit=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},n.internal.arrayToPdfArray=function(t){if(Array.isArray(t)){var e=" [";for(var n in t)e+=t[n].toString(),e+=n<t.length-1?" ":"";return e+="]"}},n.internal.toPdfString=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+="("),t},n.PDFObject=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(this.internal?t=this.internal.newObjectDeferred():e.API.acroformPlugin.internal&&(t=e.API.acroformPlugin.internal.newObjectDeferred())),t||console.log("Couldn't create Object ID"),t},configurable:!1})},n.PDFObject.prototype.toString=function(){return this.objId+" 0 R"},n.PDFObject.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="endstream\n"),t+="endobj\n"},n.PDFObject.prototype.getContent=function(){var t="";return t+=function(t){var e="",r=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var i in r){var o=r[i],a=t[o];a&&(Array.isArray(a)?e+="/"+o+" "+n.internal.arrayToPdfArray(a)+"\n":a instanceof n.PDFObject?e+="/"+o+" "+a.objId+" 0 R\n":e+="/"+o+" "+a+"\n")}return e}(this)},n.FormXObject=function(){n.PDFObject.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo;var t;Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==t?t.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(e){t=e},get:function(){return t||null}})},n.internal.inherit(n.FormXObject,n.PDFObject),n.AcroFormDictionary=function(){n.PDFObject.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return t.length>0?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA},n.internal.inherit(n.AcroFormDictionary,n.PDFObject),n.Field=function(){n.PDFObject.call(this);var t;Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(t)return t},set:function(e){t=e}});var e="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){e=t},get:function(){return e}});var r;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){r=t},get:function(){if(!r||r.length<1){if(this instanceof n.ChildClass)return;return"(FieldObject"+n.Field.FieldNum+++")"}return"("==r.substring(0,1)&&r.substring(r.length-1)?r:"("+r+")"}});var i;Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(i)return"("+i+")"},set:function(t){i=t}});var o;Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})},n.Field.FieldNum=0,n.internal.inherit(n.Field,n.PDFObject),n.ChoiceField=function(){n.Field.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0,this.combo=!1,Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0,Object.defineProperty(this,"V",{get:function(){n.internal.toPdfString()}})},n.internal.inherit(n.ChoiceField,n.Field),window.ChoiceField=n.ChoiceField,n.ListBox=function(){n.ChoiceField.call(this)},n.internal.inherit(n.ListBox,n.ChoiceField),window.ListBox=n.ListBox,n.ComboBox=function(){n.ListBox.call(this),this.combo=!0},n.internal.inherit(n.ComboBox,n.ListBox),window.ComboBox=n.ComboBox,n.EditBox=function(){n.ComboBox.call(this),this.edit=!0},n.internal.inherit(n.EditBox,n.ComboBox),window.EditBox=n.EditBox,n.Button=function(){n.Field.call(this),this.FT="/Btn"},n.internal.inherit(n.Button,n.Field),window.Button=n.Button,n.PushButton=function(){n.Button.call(this),this.pushbutton=!0},n.internal.inherit(n.PushButton,n.Button),window.PushButton=n.PushButton,n.RadioButton=function(){n.Button.call(this),this.radio=!0;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(t.length>0)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}});var e;Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return e},set:function(t){e=t}})},n.internal.inherit(n.RadioButton,n.Button),window.RadioButton=n.RadioButton,n.ChildClass=function(t,e){n.Field.call(this),this.Parent=t,this._AppearanceType=n.Appearance.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=n.internal.setBitPosition(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e},n.internal.inherit(n.ChildClass,n.Field),n.RadioButton.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},n.RadioButton.prototype.createOption=function(t){var r=this,i=new n.ChildClass(r,t);return this.__Kids.push(i),e.API.addField(i),i},n.CheckBox=function(){Button.call(this),this.appearanceStreamContent=n.Appearance.CheckBox.createAppearanceStream(),this.MK=n.Appearance.CheckBox.createMK(),this.AS="/On",this.V="/On"},n.internal.inherit(n.CheckBox,n.Button),window.CheckBox=n.CheckBox,n.TextField=function(){n.Field.call(this),this.DA=n.Appearance.createDefaultAppearanceStream(),this.F=4;var t;Object.defineProperty(this,"V",{get:function(){return t?"("+t+")":t},enumerable:!0,set:function(e){t=e}});var e;Object.defineProperty(this,"DV",{get:function(){return e?"("+e+")":e},enumerable:!0,set:function(t){e=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})},n.internal.inherit(n.TextField,n.Field),window.TextField=n.TextField,n.PasswordField=function(){TextField.call(this),Object.defineProperty(this,"password",{value:!0,enumerable:!1,configurable:!1,writable:!1})},n.internal.inherit(n.PasswordField,n.TextField),window.PasswordField=n.PasswordField,n.internal.calculateFontSpace=function(t,e,r){var r=r||"helvetica",i=n.internal.calculateFontSpace.canvas||(n.internal.calculateFontSpace.canvas=document.createElement("canvas"));(s=i.getContext("2d")).save();var o=e+" "+r;s.font=o;var a=s.measureText(t);s.fontcolor="black";var s=i.getContext("2d");return a.height=1.5*s.measureText("3").width,s.restore(),a},n.internal.calculateX=function(t,e,r,i){var i=i||12,r=r||"helvetica",o={text:"",fontSize:""},a=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),s=i,c=n.Appearance.internal.getHeight(t)||0;c=c<0?-c:c;var l=n.Appearance.internal.getWidth(t)||0;l=l<0?-l:l;s++;t:for(;;){var e="";s--;var u=n.internal.calculateFontSpace("3",s+"px",r).height,h=t.multiline?c-s:(c-u)/2,f=-2,d=h+=2,p=0,m=0,g=0;if(0==s){s=12,e="(...) Tj\n",e+="% Width of Text: "+n.internal.calculateFontSpace(e,"1px").width+", FieldWidth:"+l+"\n";break}g=n.internal.calculateFontSpace(a[0]+" ",s+"px",r).width;var w="",y=0;for(var v in a){w=" "==(w+=a[v]+" ").substr(w.length-1)?w.substr(0,w.length-1):w;var b=parseInt(v);g=n.internal.calculateFontSpace(w+" ",s+"px",r).width;var x=function(t,e,i){if(t+1<a.length){var o=e+" "+a[t+1];return n.internal.calculateFontSpace(o,i+"px",r).width<=l-4}return!1}(b,w,s),k=v>=a.length-1;if(!x||k){if(x||k){if(k)m=b;else if(t.multiline&&(u+2)*(y+2)+2>c)continue t}else{if(!t.multiline)continue t;if((u+2)*(y+2)+2>c)continue t;m=b}for(var _="",C=p;C<=m;C++)_+=a[C]+" ";switch(_=" "==_.substr(_.length-1)?_.substr(0,_.length-1):_,g=n.internal.calculateFontSpace(_,s+"px",r).width,t.Q){case 2:f=l-g-2;break;case 1:f=(l-g)/2;break;case 0:default:f=2}e+=f+" "+d+" Td\n",e+="("+_+") Tj\n",e+=-f+" 0 Td\n",d=-(s+2),g=0,p=m+1,y++,w=""}else w+=" "}break}return o.text=e,o.fontSize=s,o},n.internal.calculateAppearanceStream=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e="",r=t.V||t.DV,i=n.internal.calculateX(t,r);e+="/Tx BMC\nq\n/F1 "+i.fontSize+" Tf\n1 0 0 1 0 0 Tm\n",e+="BT\n",e+=i.text,e+="ET\n",e+="Q\nEMC\n";var o=new n.createFormXObject(t);return o.stream=e,o}},n.internal.calculateCoordinates=function(t,e,r,i){var o={};if(this.internal){var a=function(t){return t*this.internal.scaleFactor};Array.isArray(t)?(t[0]=n.scale(t[0]),t[1]=n.scale(t[1]),t[2]=n.scale(t[2]),t[3]=n.scale(t[3]),o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=a.call(this,this.internal.pageSize.height)-t[3]-t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=a.call(this,this.internal.pageSize.height)-t[1]||0):(t=n.scale(t),e=n.scale(e),r=n.scale(r),i=n.scale(i),o.lowerLeft_X=t||0,o.lowerLeft_Y=this.internal.pageSize.height-e||0,o.upperRight_X=t+r||0,o.upperRight_Y=this.internal.pageSize.height-e+i||0)}else Array.isArray(t)?(o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=t[1]+t[3]||0):(o.lowerLeft_X=t||0,o.lowerLeft_Y=e||0,o.upperRight_X=t+r||0,o.upperRight_Y=e+i||0);return[o.lowerLeft_X,o.lowerLeft_Y,o.upperRight_X,o.upperRight_Y]},n.internal.calculateColor=function(t,e,n){var r=new Array(3);return r.r=0|t,r.g=0|e,r.b=0|n,r},n.internal.getBitPosition=function(t,e){var n=1;return n<<=e-1,(t=t||0)|n},n.internal.setBitPosition=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else var t=t&~r;return t},e.API.addHTML=function(t,e,n,r,i){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof e&&(r=e,i=n),"function"==typeof r&&(i=r,r=null);var o=this.internal,a=o.scaleFactor,s=o.pageSize.width,c=o.pageSize.height;if(r=r||{},r.onrendered=function(t){e=parseInt(e)||0,n=parseInt(n)||0;var o=r.dim||{},l=o.h||0,u=o.w||Math.min(s,t.width/a)-e,h="JPEG";if(r.format&&(h=r.format),t.height>c&&r.pagesplit){var f=function(){for(var r=0;;){var o=document.createElement("canvas");o.width=Math.min(s*a,t.width),o.height=Math.min(c*a,t.height-r),o.getContext("2d").drawImage(t,0,r,t.width,o.height,0,0,o.width,o.height);var l=[o,e,r?0:n,o.width/a,o.height/a,h,null,"SLOW"];if(this.addImage.apply(this,l),(r+=o.height)>=t.height)break;this.addPage()}i(u,r,null,l)}.bind(this);if("CANVAS"===t.nodeName){var d=new Image;d.onload=f,d.src=t.toDataURL("image/png"),t=d}else f()}else{var p=Math.random().toString(35),m=[t,e,n,u,l,h,p,"SLOW"];this.addImage.apply(this,m),i(u,l,p,m)}}.bind(this),"undefined"!=typeof html2canvas&&!r.rstz)return html2canvas(t,r);if("undefined"!=typeof rasterizeHTML){var l="drawDocument";return"string"==typeof t&&(l=/^http/.test(t)?"drawURL":"drawHTML"),r.width=r.width||s*a,rasterizeHTML[l](t,void 0,r).then(function(t){r.onrendered(t.image)},function(t){i(null,t)})}return null},/** @preserve
 * jsPDF addImage plugin
 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
 *               2013 Chris Dowling, https://github.com/gingerchris
 *               2013 Trinh Ho, https://github.com/ineedfat
 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
 *               2013 Norah Smith, https://github.com/burnburnrocket
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 James Robb, https://github.com/jamesbrobb
 *
 * 
 */
function(e){var n=["jpeg","jpg","png"],r=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,l={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(l.f=e.f),t.call(this,l)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},i=function(){var t=this.internal.collections.addImage_images;for(var e in t)r.call(this,t[e])},o=function(){var t,e=this.internal.collections.addImage_images,n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},a=function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:e.image_compression.NONE},s=function(){var t=this.internal.collections.addImage_images;return t||(this.internal.collections.addImage_images=t={},this.internal.events.subscribe("putResources",i),this.internal.events.subscribe("putXobjectDict",o)),t},c=function(t){var e=0;return t&&(e=Object.keys?Object.keys(t).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(t)),e},l=function(t){return void 0===t||null===t},u=function(t){return"string"==typeof t&&e.sHashCode(t)},h=function(t){return-1===n.indexOf(t)},f=function(t){return"function"!=typeof e["process"+t.toUpperCase()]},d=function(e){return"object"===(void 0===e?"undefined":t(e))&&1===e.nodeType},p=function(e,n,r){if("IMG"===e.nodeName&&e.hasAttribute("src")){var i=""+e.getAttribute("src");if(!r&&0===i.indexOf("data:image/"))return i;!n&&/\.png(?:[?#].*)?$/i.test(i)&&(n="png")}if("CANVAS"===e.nodeName)var o=e;else{(o=document.createElement("canvas")).width=e.clientWidth||e.width,o.height=e.clientHeight||e.height;var a=o.getContext("2d");if(!a)throw"addImage requires canvas to be supported by browser.";if(r){var s,c,l,u,h,f,d,p,m=Math.PI/180;"object"===(void 0===r?"undefined":t(r))&&(s=r.x,c=r.y,l=r.bg,r=r.angle),p=r*m,u=Math.abs(Math.cos(p)),h=Math.abs(Math.sin(p)),f=o.width,d=o.height,o.width=d*h+f*u,o.height=d*u+f*h,isNaN(s)&&(s=o.width/2),isNaN(c)&&(c=o.height/2),a.clearRect(0,0,o.width,o.height),a.fillStyle=l||"white",a.fillRect(0,0,o.width,o.height),a.save(),a.translate(s,c),a.rotate(p),a.drawImage(e,-f/2,-d/2),a.rotate(-p),a.translate(-s,-c),a.restore()}else a.drawImage(e,0,0,o.width,o.height)}return o.toDataURL("png"==(""+n).toLowerCase()?"image/png":"image/jpeg")},m=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n},g=function(t,e,n){return t||e||(t=-96,e=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]},w=function(t,e,n,r,i,o,a){var s=g.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;n=s[0],r=s[1],a[o]=i,this.internal.write("q",c(n),"0 0",c(r),c(t),l(e+r),"cm /I"+i.i,"Do Q")};e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},e.sHashCode=function(t){return Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},e.isString=function(t){return"string"==typeof t},e.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(t)},e.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},e.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},e.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},e.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},e.arrayBufferToBinaryString=function(t){if("function"==typeof window.atob)return atob(this.arrayBufferToBase64(t));for(var e=this.isArrayBuffer(t)?t:new Uint8Array(t),n="",r=Math.round(e.byteLength/20480),i=0;i<r;i++)n+=String.fromCharCode.apply(null,e.slice(20480*i,20480*i+20480));return n},e.arrayBufferToBase64=function(t){for(var e,n,r,i,o="",a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=new Uint8Array(t),c=s.byteLength,l=c%3,u=c-l,h=0;h<u;h+=3)e=(258048&(i=s[h]<<16|s[h+1]<<8|s[h+2]))>>12,n=(4032&i)>>6,r=63&i,o+=a[(16515072&i)>>18]+a[e]+a[n]+a[r];return 1==l?(e=(3&(i=s[u]))<<4,o+=a[(252&i)>>2]+a[e]+"=="):2==l&&(e=(1008&(i=s[u]<<8|s[u+1]))>>4,n=(15&i)<<2,o+=a[(64512&i)>>10]+a[e]+a[n]+"="),o},e.createImageInfo=function(t,e,n,r,i,o,a,s,c,l,u,h,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),c&&(d.dp=c),l&&(d.trns=l),u&&(d.pal=u),h&&(d.smask=h),f&&(d.p=f),d},e.addImage=function(e,r,i,o,g,y,v,b,x){if("string"!=typeof r){var k=y;y=g,g=o,o=i,i=r,r=k}if("object"===(void 0===e?"undefined":t(e))&&!d(e)&&"imageData"in e){var _=e;e=_.imageData,r=_.format||r,i=_.x||i||0,o=_.y||o||0,g=_.w||g,y=_.h||y,v=_.alias||v,b=_.compression||b,x=_.rotation||_.angle||x}if(isNaN(i)||isNaN(o))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var C,A=s.call(this);if(!(C=m(e,A))){var S;if(d(e)&&(e=p(e,r,x)),l(v)&&(v=u(e)),!(C=m(v,A))){if(this.isString(e)){var q=this.extractInfoFromBase64DataURI(e);q?(r=q[2],e=atob(q[3])):137===e.charCodeAt(0)&&80===e.charCodeAt(1)&&78===e.charCodeAt(2)&&71===e.charCodeAt(3)&&(r="png")}if(r=(r||"JPEG").toLowerCase(),h(r))throw new Error("addImage currently only supports formats "+n+", not '"+r+"'");if(f(r))throw new Error("please ensure that the plugin for '"+r+"' support is added");if(this.supportsArrayBuffer()&&(e instanceof Uint8Array||(S=e,e=this.binaryStringToUint8Array(e))),!(C=this["process"+r.toUpperCase()](e,c(A),v,a(b),S)))throw new Error("An unkwown error occurred whilst processing the image")}}return w.call(this,i,o,g,y,C,C.i,A),this};var y=function(t){var e,n,r;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var i=256*t.charCodeAt(4)+t.charCodeAt(5),o=4,a=t.length;o<a;){if(o+=i,255!==t.charCodeAt(o))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(o+1)||193===t.charCodeAt(o+1)||194===t.charCodeAt(o+1)||195===t.charCodeAt(o+1)||196===t.charCodeAt(o+1)||197===t.charCodeAt(o+1)||198===t.charCodeAt(o+1)||199===t.charCodeAt(o+1))return n=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),e=256*t.charCodeAt(o+7)+t.charCodeAt(o+8),r=t.charCodeAt(o+9),[e,n,r];o+=2,i=256*t.charCodeAt(o)+t.charCodeAt(o+1)}},v=function(t){if(65496!==(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n,r,i,o=t.length,a=(t[4]<<8)+t[5],s=4;s<o;){if(s+=a,e=b(t,s),a=(e[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&a>7)return e=b(t,s+5),n=(e[2]<<8)+e[3],r=(e[0]<<8)+e[1],i=e[4],{width:n,height:r,numcomponents:i};s+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")},b=function(t,e){return t.subarray(e,e+5)};e.processJPEG=function(t,e,n,r,i){var o,a=this.color_spaces.DEVICE_RGB,s=this.decode.DCT_DECODE;return this.isString(t)?(o=y(t),this.createImageInfo(t,o[0],o[1],1==o[3]?this.color_spaces.DEVICE_GRAY:a,8,s,e,n)):(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)?(o=v(t),t=i||this.arrayBufferToBinaryString(t),this.createImageInfo(t,o.width,o.height,1==o.numcomponents?this.color_spaces.DEVICE_GRAY:a,8,s,e,n)):null)},e.processJPG=function(){return this.processJPEG.apply(this,arguments)}}(e.API),/**
 * jsPDF Annotations PlugIn
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var n={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}};e.API.annotationPlugin=n,e.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],r=!1,i=0;i<e.length&&!r;i++)switch((l=e[i]).type){case"link":if(n.notEmpty(l.options.url)||n.notEmpty(l.options.pageNumber)){r=!0;break}case"reference":case"text":case"freetext":r=!0}if(0!=r){this.internal.write("/Annots [");for(var o=this.annotationPlugin.f2,a=this.internal.scaleFactor,s=this.internal.pageSize.height,c=this.internal.getPageInfo(t.pageNumber),i=0;i<e.length;i++){var l=e[i];switch(l.type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var u=this.internal.newAdditionalObject(),h=this.internal.newAdditionalObject(),f=l.title||"Note";w="<</Type /Annot /Subtype /Text "+(p="/Rect ["+o(l.bounds.x*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+" "+o((l.bounds.x+l.bounds.w)*a)+" "+o((s-l.bounds.y)*a)+"] ")+"/Contents ("+l.contents+")",w+=" /Popup "+h.objId+" 0 R",w+=" /P "+c.objId+" 0 R",w+=" /T ("+f+") >>",u.content=w;var d=u.objId+" 0 R";w="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+o((l.bounds.x+30)*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+" "+o((l.bounds.x+l.bounds.w+30)*a)+" "+o((s-l.bounds.y)*a)+"] ")+" /Parent "+d,l.open&&(w+=" /Open true"),w+=" >>",h.content=w,this.internal.write(u.objId,"0 R",h.objId,"0 R");break;case"freetext":var p="/Rect ["+o(l.bounds.x*a)+" "+o((s-l.bounds.y)*a)+" "+o(l.bounds.x+l.bounds.w*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+"] ",m=l.color||"#000000";w="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",w+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+m+")",w+=" /Border [0 0 0]",w+=" >>",this.internal.write(w);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);var p="/Rect ["+o(l.x*a)+" "+o((s-l.y)*a)+" "+o((l.x+l.w)*a)+" "+o((s-(l.y+l.h))*a)+"] ",w="";if(l.options.url)w="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(w="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(l.options.pageNumber)).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":w+=" /Fit]";break;case"FitH":w+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,w+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=o((s-l.options.top)*a);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),w+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=w&&(w+=" >>",this.internal.write(w))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()}}(e.API),e.API.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this},/**
 * jsPDF Canvas PlugIn
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.events.push(["initialized",function(){this.canvas.pdf=this}]),t.canvas={getContext:function(t){return this.pdf.context2d._canvas=this,this.pdf.context2d},style:{}},Object.defineProperty(t.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(t.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}})}(e.API),/** ====================================================================
 * jsPDF Cell plugin
 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Hall, james@parall.ax
 *               2014 Diego Casorran, https://github.com/diegocr
 *
 * 
 * ====================================================================
 */
function(t){var e,n,r,i,o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1,s=function(t,e,n,r,i){o={x:t,y:e,w:n,h:r,ln:i}},c=function(){return o},l={left:0,top:0,bottom:0};t.setHeaderFunction=function(t){i=t},t.getTextDimensions=function(t){e=this.internal.getFont().fontName,n=this.table_font_size||this.internal.getFontSize(),r=this.internal.getFont().fontStyle;var i,o;(o=document.createElement("font")).id="jsPDFCell";try{o.style.fontStyle=r}catch(t){o.style.fontWeight=r}o.style.fontName=e,o.style.fontSize=n+"pt";try{o.textContent=t}catch(e){o.innerText=t}return document.body.appendChild(o),i={w:(o.offsetWidth+1)*(19.049976/25.4),h:(o.offsetHeight+1)*(19.049976/25.4)},document.body.removeChild(o),i},t.cellAddPage=function(){var t=this.margins||l;this.addPage(),s(t.left,t.top,void 0,void 0),a+=1},t.cellInitialize=function(){o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1},t.cell=function(t,e,n,r,i,o,a){var u=c(),h=!1;if(void 0!==u.ln)if(u.ln===o)t=u.x+u.w,e=u.y;else{var f=this.margins||l;u.y+u.h+r+13>=this.internal.pageSize.height-f.bottom&&(this.cellAddPage(),h=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=c().y+c().h,h&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var d=0;d<i.length;d++){var p=i[d],m=this.getStringUnitWidth(p)*this.internal.getFontSize();this.text(p,t+n-m-3,e+this.internal.getLineHeight()*(d+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return s(t,e,n,r,o),this},t.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):i>o&&(o=i);return o},t.table=function(e,n,r,i,s){if(!r)throw"No data for PDF table";var c,u,h,f,d,p,m,g,w,y,v=[],b=[],x={},k={},_=[],C=[],A=!1,S=!0,q=12,T=l;if(T.width=this.internal.pageSize.width,s&&(!0===s.autoSize&&(A=!0),!1===s.printHeaders&&(S=!1),s.fontSize&&(q=s.fontSize),s.css&&void 0!==s.css["font-size"]&&(q=16*s.css["font-size"]),s.margins&&(T=s.margins)),this.lnMod=0,o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1,this.printHeaders=S,this.margins=T,this.setFontSize(q),this.table_font_size=q,void 0===i||null===i)v=Object.keys(r[0]);else if(i[0]&&"string"!=typeof i[0]){for(u=0,h=i.length;u<h;u+=1)c=i[u],v.push(c.name),b.push(c.prompt),k[c.name]=c.width*(19.049976/25.4)}else v=i;if(A)for(y=function(t){return t[c]},u=0,h=v.length;u<h;u+=1){for(x[c=v[u]]=r.map(y),_.push(this.getTextDimensions(b[u]||c).w),m=0,f=(p=x[c]).length;m<f;m+=1)d=p[m],_.push(this.getTextDimensions(d).w);k[c]=t.arrayMax(_),_=[]}if(S){P=this.calculateLineHeight(v,k,b.length?b:v);for(u=0,h=v.length;u<h;u+=1)c=v[u],C.push([e,n,k[c],P,String(b.length?b[u]:c)]);this.setTableHeaderRow(C),this.printHeaderRow(1,!1)}for(u=0,h=r.length;u<h;u+=1){var P;for(g=r[u],P=this.calculateLineHeight(v,k,g),m=0,w=v.length;m<w;m+=1)c=v[m],this.cell(e,n,k[c],P,g[c],u+2,c.align)}return this.lastCellPos=o,this.table_x=e,this.table_y=n,this},t.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;a>i&&(i=a)}return i},t.setTableHeaderRow=function(t){this.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,o,c;if(this.printingHeaderRow=!0,void 0!==i){var l=i(this,a);s(l[0],l[1],l[2],l[3],-1)}this.setFontStyle("bold");var u=[];for(o=0,c=this.tableHeaderRow.length;o<c;o+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[o],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,u.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));u.length>0&&this.setTableHeaderRow(u),this.setFontStyle("normal"),this.printingHeaderRow=!1}}(e.API),/**
 * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
 *
 * Licensed under the MIT License. http://opensource.org/licenses/mit-license
 */
function(t){function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}t.events.push(["initialized",function(){this.context2d.pdf=this,this.context2d.internal.pdf=this,this.context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,o;if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))e=0,n=0,r=0,o=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),o=1):null!=(a=this.internal.rxRgba.exec(t))?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),o=parseFloat(a[4])):(o=1,"#"!=t.charAt(0)&&((t=i.colorNameToHex(t))||(t="#000000")),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:o,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(this.ctx._clip_path.length>0){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(c<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(l)}this.ctx._clip_path.length>0&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(this.ctx._clip_path.length>0){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===c)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(l)}this.ctx._clip_path.length>0&&a.push("Q")}},setFont:function(t){this.ctx.font=t;var e=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/;if(null!=(u=e.exec(t))){var n=u[1],r=u[3],i=u[4],o=u[5],a=u[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i),"bold"===r||"700"===r?this.pdf.setFontStyle("bold"):"italic"===n?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal");var s,c=(f=a).toLowerCase().split(/\s*,\s*/);s=-1!=c.indexOf("arial")?"Arial":-1!=c.indexOf("verdana")?"Verdana":-1!=c.indexOf("helvetica")?"Helvetica":-1!=c.indexOf("sans-serif")?"sans-serif":-1!=c.indexOf("fixed")?"Fixed":-1!=c.indexOf("monospace")?"Monospace":-1!=c.indexOf("terminal")?"Terminal":-1!=c.indexOf("courier")?"Courier":-1!=c.indexOf("times")?"Times":-1!=c.indexOf("cursive")?"Cursive":-1!=c.indexOf("fantasy")?"Fantasy":(c.indexOf("serif"),"Serif");var l;l="bold"===r?"bold":"normal",this.pdf.setFont(s,l)}else{var u=(e=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/).exec(t);if(null!=u){var h=u[1],f=u[3];(l=u[4])||(l="normal"),h="em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(h)),this.pdf.setFontSize(h),this.pdf.setFont(f,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){this.lastBreak=0;for(var e=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=o=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak){var o=Math.floor(t/this.pageWrapY)+1;n+=o}return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o);var a;i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r);var i;n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),c=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(c[0]-s[0],2)+Math.pow(c[1]-s[1],2))}var l={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(l)},drawImage:function(t,e,n,r,i,o,a,s,c){void 0!==o&&(e=o,n=a,r=s,i=c),e=this._wrapX(e),n=this._wrapY(n);var l,u=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),h=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:c}),/data:image\/(\w+).*/i.exec(t));l=null!=h?h[1]:"png",this.pdf.addImage(t,l,u.x,u.y,u.w,u.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],c=n*t[0]+r*t[2],l=i*t[0]+o*t[2],u=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],n=c,i=l,a=u,[n,r,i,o,a,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return r/=s,i/=s,a/=s,e*i<n*r&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],c=e[0],l=e[1];return[c*n+l*i+a,c*r+l*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(this.ctx._clip_path.length>0){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":h=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(h),e[e.length-1].abs.push(i);break;case"bct":h=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(h);break;case"qct":var o=n[r-1].x+2/3*(i.x1-n[r-1].x),a=n[r-1].y+2/3*(i.y1-n[r-1].y),s=i.x+2/3*(i.x1-i.x),c=i.y+2/3*(i.y1-i.y),l=i.x,u=i.y,h=[o-n[r-1].x,a-n[r-1].y,s-n[r-1].x,c-n[r-1].y,l-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(h);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var m=d[p],g=360*m.startAngle/(2*Math.PI),w=360*m.endAngle/(2*Math.PI),y=m.x,v=m.y;this.internal.arc2(this,y,v,m.radius,g,w,m.anticlockwise,f,t)}else{var y=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,y,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,y,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(this.ctx._clip_path.length>0){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var r,i="function"==typeof this.pdf.internal.newObject2;r=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var o=[],a=window.outIntercept;if(i)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var s=this.pdf.internal.newStreamObject(),c=this.pdf.internal.newObject2();c.push("<</Type /ExtGState"),c.push("/SMask <</S /Alpha /G "+s.objId+" 0 R>>"),c.push(">>");d="MASK"+c.objId;this.pdf.internal.addGraphicsState(d,c.objId);var l="/"+d+" gs";r.splice(0,0,"q"),r.splice(1,0,l),r.push("Q"),window.outIntercept=s;break;default:var u="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];u&&this.pdf.internal.out(u+" gs")}var h=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(h=this.ctx._fillOpacity),i){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+h),f.push("/ca "+h),f.push(">>");var d="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(d,f.objId),this.pdf.internal.out("/"+d+" gs")}for(var p=this.path,m=0;m<p.length;m++){var g=p[m];switch(g.type){case"mt":o.push({start:g,deltas:[],abs:[]});break;case"lt":_=[g.x-p[m-1].x,g.y-p[m-1].y];o[o.length-1].deltas.push(_),o[o.length-1].abs.push(g);break;case"bct":_=[g.x1-p[m-1].x,g.y1-p[m-1].y,g.x2-p[m-1].x,g.y2-p[m-1].y,g.x-p[m-1].x,g.y-p[m-1].y];o[o.length-1].deltas.push(_);break;case"qct":var w=p[m-1].x+2/3*(g.x1-p[m-1].x),y=p[m-1].y+2/3*(g.y1-p[m-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,k=g.y,_=[w-p[m-1].x,y-p[m-1].y,v-p[m-1].x,b-p[m-1].y,x-p[m-1].x,k-p[m-1].y];o[o.length-1].deltas.push(_);break;case"arc":0===o.length&&o.push({deltas:[],abs:[]}),o[o.length-1].arc=!0,o[o.length-1].abs.push(g);break;case"close":o.push({close:!0})}}for(m=0;m<o.length;m++){var C;if(m==o.length-1?(C="f","evenodd"===t&&(C+="*")):C=null,o[m].close)this.pdf.internal.out("h"),this.pdf.internal.out("f");else if(o[m].arc){o[m].start&&this.internal.move2(this,o[m].start.x,o[m].start.y);for(var A=o[m].abs,S=0;S<A.length;S++){var q=A[S];if(void 0!==q.startAngle){var T=360*q.startAngle/(2*Math.PI),P=360*q.endAngle/(2*Math.PI),I=q.x,E=q.y;if(0===S&&this.internal.move2(this,I,E),this.internal.arc2(this,I,E,q.radius,T,P,q.anticlockwise,null,e),S===A.length-1&&o[m].start){var I=o[m].start.x,E=o[m].start.y;this.internal.line2(n,I,E)}}else this.internal.line2(n,q.x,q.y)}}else{var I=o[m].start.x,E=o[m].start.y;e?(this.pdf.lines(o[m].deltas,I,E,null,null),this.pdf.clip_fixed()):this.pdf.lines(o[m].deltas,I,E,null,C)}}window.outIntercept=a}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(this.ctx._clip_path.length>0)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(t){var e=this.pdf;return{getWidth:function(){var n=e.internal.getFontSize(),r=e.getStringUnitWidth(t)*n/e.internal.scaleFactor;return r*=1.3333},get width(){return this.getWidth(t)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var n=t.context2d;Object.defineProperty(n,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(n,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(n,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(n,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(n,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(n,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(n,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(n,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(n,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(n,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(n,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(n,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),n.internal={},n.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,n.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,n.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,n.internal.arc=function(t,e,n,r,i,o,a,s){for(var c=this.pdf.internal.scaleFactor,l=this.pdf.internal.pageSize.height,u=this.pdf.internal.f2,h=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,h,f,a),p=0;p<d.length;p++){var m=d[p];0===p?this.pdf.internal.out([u((m.x1+e)*c),u((l-(m.y1+n))*c),"m",u((m.x2+e)*c),u((l-(m.y2+n))*c),u((m.x3+e)*c),u((l-(m.y3+n))*c),u((m.x4+e)*c),u((l-(m.y4+n))*c),"c"].join(" ")):this.pdf.internal.out([u((m.x2+e)*c),u((l-(m.y2+n))*c),u((m.x3+e)*c),u((l-(m.y3+n))*c),u((m.x4+e)*c),u((l-(m.y4+n))*c),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},n.internal.arc2=function(t,e,n,r,i,o,a,s,c){var l=e,u=n;c?(this.arc(t,l,u,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,l,u,r,i,o,a,s)},n.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},n.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},n.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||a>i)&&(a%=i),a<0&&(a=i+a);e>n;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var c=[],l=r?-1:1,u=a;s>1e-5;){var h=u+l*Math.min(s,o);c.push(this.createSmallArc(t,u,h)),s-=Math.abs(h-u),u=h}return c},n.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},n.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,c=a*a+s*s,l=c+a*i+s*o,u=4/3*(Math.sqrt(2*c*l)-l)/(a*o-s*i),h=a-u*s,f=s+u*a,d=h,p=-f,m=r+e,g=Math.cos(m),w=Math.sin(m);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*g-f*w,y2:h*w+f*g,x3:d*g-p*w,y3:d*w+p*g,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}(e.API),/** @preserve
 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Daniel Husar, https://github.com/danielhusar
 *               2014 Wolfgang Gassler, https://github.com/woolfg
 *               2014 Steven Spungin, https://github.com/flamenco
 *
 * 
 * ====================================================================
 */
function(e){var n,r,o,a,s,c,l,u,h,f,d,p,m,g,w,y,v,b,x,k;n=function(){function t(){}return function(e){return t.prototype=e,new t}}(),f=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,i=!1,a=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},p=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=o[n.trim().toLowerCase()],n=r.shift();return e},m=function(t){(t="auto"===t?"0px":t).indexOf("em")>-1&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),t.indexOf("pt")>-1&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px");var e;return void 0,16,(e=g[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[{css_line_height_string:t}])?g[t]=e/16:(e=parseFloat(t))?g[t]=e/16:3===(e=t.match(/([\d\.]+)(px)/)).length?g[t]=parseFloat(e[1])/16:g[t]=1},h=function(t){var e,n,r;return r=function(e){var n;return n=function(t){return document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(t,null):t.currentStyle?t.currentStyle:t.style}(t),function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),n[t]}}(),e={},n=void 0,e["font-family"]=p(r("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=c[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=m(r("font-size"))||1,e["line-height"]=m(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&m(r("margin-top"))||0,e["margin-bottom"]=n&&m(r("margin-bottom"))||0,e["padding-top"]=n&&m(r("padding-top"))||0,e["padding-bottom"]=n&&m(r("padding-bottom"))||0,e["margin-left"]=n&&m(r("margin-left"))||0,e["margin-right"]=n&&m(r("margin-right"))||0,e["padding-left"]=n&&m(r("padding-left"))||0,e["padding-right"]=n&&m(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=l[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},w=function(t,e,n){var r,i,o,a,s;if(o=!1,i=void 0,a=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s=t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},k=function(t,e){var n,r,i,o,a,s,c,l,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,c=t.clientWidth;i<u;)l=t.rows[0].cells[i],r[i]={name:l.textContent.toLowerCase().replace(/\s+/g,""),prompt:l.textContent.replace(/\r?\n/g,""),width:l.clientWidth/c*e.pdf.internal.pageSize.width},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var _={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},C=1;r=function(e,i,o){var a,s,c,l,u,f,d,p;for(s=e.childNodes,a=void 0,(u="block"===(c=h(e)).display)&&(i.setBlockBoundary(),i.setBlockStyle(c)),l=0,f=s.length;l<f;){if("object"===(void 0===(a=s[l])?"undefined":t(a))){if(i.executeWatchFunctions(a),1===a.nodeType&&"HEADER"===a.nodeName){var m=a,g=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=g,r(m,i,o),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===a.nodeType&&"#comment"===a.nodeName)~a.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==a.nodeType||_[a.nodeName])if(3===a.nodeType){var v=a.nodeValue;if(a.nodeValue&&"LI"===a.parentNode.nodeName)if("OL"===a.parentNode.parentNode.nodeName)v=C+++". "+v;else{var b=c["font-size"],x=(3-.75*b)*i.pdf.internal.scaleFactor,A=.75*b*i.pdf.internal.scaleFactor,S=1.74*b/i.pdf.internal.scaleFactor;p=function(t,e){this.pdf.circle(t+x,e+A,S,"FD")}}16&a.ownerDocument.body.compareDocumentPosition(a)&&i.addText(v,c)}else"string"==typeof a&&i.addText(a,c);else{var q;if("IMG"===a.nodeName){var T=a.getAttribute("src");q=y[i.pdf.sHashCode(T)||T]}if(q){i.pdf.internal.pageSize.height-i.pdf.margins_doc.bottom<i.y+a.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(a));var P=h(a),I=i.x,E=12/i.pdf.internal.scaleFactor,O=(P["margin-left"]+P["padding-left"])*E,F=(P["margin-right"]+P["padding-right"])*E,B=(P["margin-top"]+P["padding-top"])*E,R=(P["margin-bottom"]+P["padding-bottom"])*E;void 0!==P.float&&"right"===P.float?I+=i.settings.width-a.width-F:I+=O,i.pdf.addImage(q,I,i.y+B,a.width,a.height),q=void 0,"right"===P.float||"left"===P.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!_[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===P.float?-a.width-O-F:0,i.y+a.height+B+R,a.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===h(n).clear&&(i.y=t,!0)}.bind(this,i.y+a.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=a.width+O+F,"left"===P.float&&(i.x+=a.width+O+F)):i.y+=a.height+B+R}else if("TABLE"===a.nodeName)d=k(a,i),i.y+=10,i.pdf.table(i.x,i.y,d.rows,d.headers,{autoSize:!1,printHeaders:o.printHeaders,margins:i.pdf.margins_doc,css:h(a)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===a.nodeName||"UL"===a.nodeName)C=1,w(a,i,o)||r(a,i,o),i.y+=10;else if("LI"===a.nodeName){var D=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,w(a,i,o)||r(a,i,o),i.x=D}else"BR"===a.nodeName?(i.y+=c["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",n(c))):w(a,i,o)||r(a,i,o)}}l++}if(o.outY=i.y,u)return i.setBlockBoundary(p)},y={},v=function(t,e,n,r){function i(){e.pdf.internal.events.publish("imagesLoaded"),r(o)}for(var o,a=t.getElementsByTagName("img"),s=a.length,c=0;s--;)!function(t,n,r){if(t){var a=new Image;o=++c,a.crossOrigin="",a.onerror=a.onload=function(){if(a.complete&&(0===a.src.indexOf("data:image/")&&(a.width=n||a.width||0,a.height=r||a.height||0),a.width+a.height)){var o=e.pdf.sHashCode(t)||t;y[o]=y[o]||a}--c||i()},a.src=t}}(a[s].getAttribute("src"),a[s].width,a[s].height);return c||i()},b=function(t,e,n){var i=t.getElementsByTagName("footer");if(i.length>0){i=i[0];var o=e.pdf.internal.write,a=e.y;e.pdf.internal.write=function(){},r(i,e,n);var s=Math.ceil(e.y-a)+5;e.y=a,e.pdf.internal.write=o,e.pdf.margins_doc.bottom+=s;for(var c=function(t){var o=void 0!==t?t.pageNumber:1,a=e.y;e.y=e.pdf.internal.pageSize.height-e.pdf.margins_doc.bottom,e.pdf.margins_doc.bottom-=s;for(var c=i.getElementsByTagName("span"),l=0;l<c.length;++l)(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")>-1&&(c[l].innerHTML=o),(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&(c[l].innerHTML="###jsPDFVarTotalPages###");r(i,e,n),e.pdf.margins_doc.bottom+=s,e.y=a},l=i.getElementsByTagName("span"),u=0;u<l.length;++u)(" "+l[u].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&e.pdf.internal.events.subscribe("htmlRenderingFinished",e.pdf.putTotalPages.bind(e.pdf,"###jsPDFVarTotalPages###"),!0);e.pdf.internal.events.subscribe("addPage",c,!1),c(),_.FOOTER=1}},x=function(t,e,n,i,o,a){if(!e)return!1;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(e=function(t){var e,n,r,i;return r="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),i="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",n=document.createElement("div"),n.style.cssText=i,n.innerHTML='<iframe style="height:1px;width:1px" name="'+r+'" />',document.body.appendChild(n),(e=window.frames[r]).document.open(),e.document.writeln(t),e.document.close(),e.document.body}(e.replace(/<\/?script[^>]*?>/gi,"")));var s,c=new d(t,n,i,o);return v.call(this,e,c,o.elementHandlers,function(t){b(e,c,o.elementHandlers),r(e,c,o.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),s=c.dispose(),"function"==typeof a?a(s):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),s||{x:c.x,y:c.y}},(d=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},d.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},d.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(this.watchFunctions.length>0){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},d.prototype.splitFragmentsIntoLines=function(t,e){var r,i,o,a,s,c,l,u,h,f,d,p,m,g;for(12,f=this.pdf.internal.scaleFactor,a={},i=void 0,h=void 0,o=void 0,s=void 0,g=void 0,u=void 0,l=void 0,c=void 0,p=[d=[]],r=0,m=this.settings.width;t.length;)if(s=t.shift(),g=e.shift(),s)if(i=g["font-family"],h=g["font-style"],(o=a[i+h])||(o=this.pdf.internal.getFont(i,h).metadata.Unicode,a[i+h]=o),u={widths:o.widths,kerning:o.kerning,fontSize:12*g["font-size"],textIndent:r},l=this.pdf.getStringUnitWidth(s,u)*u.fontSize/f,"\u2028"==s)d=[],p.push(d);else if(r+l>m){for(c=this.pdf.splitTextToSize(s,m,u),d.push([c.shift(),g]);c.length;)d=[[c.shift(),g]],p.push(d);r=this.pdf.getStringUnitWidth(d[0][0],u)*u.fontSize/f}else d.push([s,g]),r+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var w=0;w<p.length;++w){var y=this.pdf.getStringUnitWidth(p[w][0][0],u)*u.fontSize/f;w>0&&(p[w][0][1]=n(p[w][0][1]));var v=m-y;if("right"===g["text-align"])p[w][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[w][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var b=p[w][0][0].split(" ").length-1;p[w][0][1]["word-spacing"]=v/b,w===p.length-1&&(p[w][0][1]["word-spacing"]=0)}}return p},d.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.height-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),e.color,"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&e["word-spacing"]>0&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},d.prototype.getPdfColor=function(t){var e,n,r,o=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3])):("#"!=t.charAt(0)&&((t=i.colorNameToHex(t))||(t="#000000")),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},d.prototype.f3=function(t){return t.toFixed(3)},d.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,c,l,u,h,d,p;if(r=f(this.paragraph.text),d=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,d),a=void 0,c=void 0,12,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,h=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,h=((e["margin-top"]||0)+(e["padding-top"]||0))*n),l=this.pdf.internal.write,i=void 0,o=void 0,this.y+=h,l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var m=0;s.length;){for(c=0,i=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(c=Math.max(c,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,w=0;for(void 0!==a[0][1]["margin-left"]&&a[0][1]["margin-left"]>0&&(g=(w=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-m,m=w),l(g+Math.max(e["margin-left"]||0,0)*n,(-12*c).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=c*n,this.executeWatchFunctions(a[0][1])&&s.length>0){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(f(y),v),l("ET","Q"),l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),l("ET","Q"),this.y+=u}},d.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},d.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},d.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},o={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},c={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},l={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},g={normal:1},e.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),x(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(e.API),/** ==================================================================== 
 * jsPDF JavaScript plugin
 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
 * 
 * 
 * ====================================================================
 */
function(t){var n,r,i;e.API.addJS=function(t){return i=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.write("<< /Names [(EmbeddedJS) "+(n+1)+" 0 R] >>","endobj"),r=this.internal.newObject(),this.internal.write("<< /S /JavaScript /JS (",i,") >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.write("/Names <</JavaScript "+n+" 0 R>>")}),this}}(),/**
 * jsPDF Outline PlugIn
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){for(var s=this.internal.pages.length,c=[],r=0;r<s;r++){var l=t.internal.newObject();c.push(l);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var h=t.internal.newObject();t.internal.write("<< /Names [ ");for(r=0;r<c.length;r++)t.internal.write("(page_"+(r+1)+")"+c[r]+" 0 R");t.internal.write(" ] >>","endobj");t.internal.newObject();t.internal.write("<< /Dests "+h+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){var t=this;t.outline.root.children.length>0&&(t.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&t.internal.write("/Names "+namesOid+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var n=0;n<e.children.length;n++)this.genIds_r(e.children[n])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(i=0;i<e.children.length;i++){o=e.children[i];this.objStart(o),this.line("/Title "+this.makeString(o.title)),this.line("/Parent "+this.makeRef(e)),i>0&&this.line("/Prev "+this.makeRef(e.children[i-1])),i<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[i+1])),o.children.length>0&&(this.line("/First "+this.makeRef(o.children[0])),this.line("/Last "+this.makeRef(o.children[o.children.length-1])));var n=this.count=this.count_r({count:0},o);if(n>0&&this.line("/Count "+n),o.options&&o.options.pageNumber){var r=t.internal.getPageInfo(o.options.pageNumber);this.line("/Dest ["+r.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.height+" 0]")}this.objEnd()}for(var i=0;i<e.children.length;i++){var o=e.children[i];this.renderItems(o)}},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}])}(e.API),/**@preserve
 *  ====================================================================
 * jsPDF PNG PlugIn
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * 
 * ====================================================================
 */
function(t){var e=function(){return"function"!=typeof PNG||"function"!=typeof s},n=function(e){return e!==t.image_compression.NONE&&r()},r=function(){var t="function"==typeof o;if(!t)throw new Error("requires deflate.js for compression");return t},i=function(e,n,r,i){var s=5,u=f;switch(i){case t.image_compression.FAST:s=3,u=h;break;case t.image_compression.MEDIUM:s=6,u=d;break;case t.image_compression.SLOW:s=9,u=p}e=l(e,n,r,u);var m=new Uint8Array(a(s)),g=c(e),w=new o(s),y=w.append(e),v=w.flush(),b=m.length+y.length+v.length,x=new Uint8Array(b+4);return x.set(m),x.set(y,m.length),x.set(v,m.length+y.length),x[b++]=g>>>24&255,x[b++]=g>>>16&255,x[b++]=g>>>8&255,x[b++]=255&g,t.arrayBufferToBinaryString(x)},a=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,r+=31-r%31,[n,255&r]},c=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;o>0;){o-=n=o>e?e:o;do{i+=r+=t[a++]}while(--n);r%=65521,i%=65521}return(i<<16|r)>>>0},l=function(t,e,n,r){for(var i,o,a,s=t.length/e,c=new Uint8Array(t.length+s),l=g(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)c.set(r(i,n,o),a+u);else{for(var h=0,f=l.length,d=[];h<f;h++)d[h]=l[h](i,n,o);var p=w(d.concat());c.set(d[p],a+u)}o=i}return c},u=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},h=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},f=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},d=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},p=function(t,e,n){var r,i,o,a,s=[],c=0,l=t.length;for(s[0]=4;c<l;c++)r=t[c-e]||0,i=n&&n[c]||0,o=n&&n[c-e]||0,a=m(r,i,o),s[c+1]=t[c]-a+256&255;return s},m=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},g=function(){return[u,h,f,d,p]},w=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=y(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},y=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},v=function(e){var n;switch(e){case t.image_compression.FAST:n=11;break;case t.image_compression.MEDIUM:n=13;break;case t.image_compression.SLOW:n=14;break;default:n=12}return n};t.processPNG=function(t,r,o,a,s){var c,l,u,h,f,d,p=this.color_spaces.DEVICE_RGB,m=this.decode.FLATE_DECODE,g=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if(e())throw new Error("PNG support requires png.js and zlib.js");if(c=new PNG(t),t=c.imgData,g=c.bits,p=c.colorSpace,h=c.colors,-1!==[4,6].indexOf(c.colorType)){if(8===c.bits)for(var w,y=(I=32==c.pixelBitlength?new Uint32Array(c.decodePixels().buffer):16==c.pixelBitlength?new Uint16Array(c.decodePixels().buffer):new Uint8Array(c.decodePixels().buffer)).length,b=new Uint8Array(y*c.colors),x=new Uint8Array(y),k=c.pixelBitlength-c.bits,_=0,C=0;_<y;_++){for(A=I[_],w=0;w<k;)b[C++]=A>>>w&255,w+=c.bits;x[_]=A>>>w&255}if(16===c.bits){for(var A,y=(I=new Uint32Array(c.decodePixels().buffer)).length,b=new Uint8Array(y*(32/c.pixelBitlength)*c.colors),x=new Uint8Array(y*(32/c.pixelBitlength)),S=c.colors>1,_=0,C=0,q=0;_<y;)A=I[_++],b[C++]=A>>>0&255,S&&(b[C++]=A>>>16&255,A=I[_++],b[C++]=A>>>0&255),x[q++]=A>>>16&255;g=8}n(a)?(t=i(b,c.width*c.colors,c.colors,a),d=i(x,c.width,1,a)):(t=b,d=x,m=null)}if(3===c.colorType&&(p=this.color_spaces.INDEXED,f=c.palette,c.transparency.indexed)){for(var T=c.transparency.indexed,P=0,_=0,y=T.length;_<y;++_)P+=T[_];if((P/=255)===y-1&&-1!==T.indexOf(0))u=[T.indexOf(0)];else if(P!==y){for(var I=c.decodePixels(),x=new Uint8Array(I.length),_=0,y=I.length;_<y;_++)x[_]=T[I[_]];d=i(x,c.width,1)}}var E=v(a);return l=m===this.decode.FLATE_DECODE?"/Predictor "+E+" /Colors "+h+" /BitsPerComponent "+g+" /Columns "+c.width:"/Colors "+h+" /BitsPerComponent "+g+" /Columns "+c.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(d&&this.isArrayBuffer(d)||this.isArrayBufferView(d))&&(d=this.arrayBufferToBinaryString(d)),this.createImageInfo(t,c.width,c.height,p,g,m,r,o,l,u,f,d,E)}throw new Error("Unsupported PNG image data, try using JPEG instead.")}}(e.API),e.API.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this},/** @preserve
 * jsPDF split_text_to_size plugin - MIT license.
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 *               2014 Diego Casorran, https://github.com/diegocr
 */
function(t){var e=t.getCharWidthsArray=function(t,e){e||(e={});var n,r,i,o=e.widths?e.widths:this.internal.getFont().metadata.Unicode.widths,a=o.fof?o.fof:1,s=e.kerning?e.kerning:this.internal.getFont().metadata.Unicode.kerning,c=s.fof?s.fof:1,l=0,u=o[0]||a,h=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),h.push((o[i]||u)/a+(s[i]&&s[i][l]||0)/c),l=i;return h},n=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},r=t.getStringUnitWidth=function(t,r){return n(e.call(this,t,r))},i=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var c=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(c,o)),s=0,c=o),s+=e[o],o++;return c!==o&&i.push(t.slice(c,o)),i},o=function(t,o,a){a||(a={});var s,c,l,u,h,f,d=[],p=[d],m=a.textIndent||0,g=0,w=0,y=t.split(" "),v=e(" ",a)[0];if(f=-1===a.lineIndent?y[0].length+2:a.lineIndent||0){var b=Array(f).join(" "),x=[];y.map(function(t){(t=t.split(/\s*\n/)).length>1?x=x.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):x.push(t[0])}),y=x,f=r(b,a)}for(l=0,u=y.length;l<u;l++){var k=0;if(s=y[l],f&&"\n"==s[0]&&(s=s.substr(1),k=1),c=e(s,a),w=n(c),m+g+w>o||k){if(w>o){for(h=i(s,c,o-(m+g),o),d.push(h.shift()),d=[h.pop()];h.length;)p.push([h.shift()]);w=n(c.slice(s.length-d[0].length))}else d=[s];p.push(d),m=w+f,g=v}else d.push(s),m+=g+w,g=v}if(f)_=function(t,e){return(e?b:"")+t.join(" ")};else var _=function(t){return t.join(" ")};return p.map(_)};t.splitTextToSize=function(t,e,n){n||(n={});var r,i=n.fontSize||this.internal.getFontSize(),a=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle);return r.metadata.Unicode?{widths:r.metadata.Unicode.widths||e,kerning:r.metadata.Unicode.kerning||n}:{widths:e,kerning:n}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var s=1*this.internal.scaleFactor*e/i;a.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=n.lineIndent;var c,l,u=[];for(c=0,l=r.length;c<l;c++)u=u.concat(o(r[c],s,a));return u}}(e.API),/** @preserve 
jsPDF standard_fonts_metrics plugin
Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
MIT license.
*/
function(t){var e=function(t){for(var e={},n=0;n<"klmnopqrstuvwxyz".length;n++)e["klmnopqrstuvwxyz"[n]]="0123456789abcdef"[n];var r,i,o,a,s={},c=1,l=s,u=[],h="",f="",d=t.length-1;for(n=1;n!=d;)a=t[n],n+=1,"'"==a?r?(o=r.join(""),r=void 0):r=[]:r?r.push(a):"{"==a?(u.push([l,o]),l={},o=void 0):"}"==a?((i=u.pop())[0][i[1]]=l,o=void 0,l=i[0]):"-"==a?c=-1:void 0===o?e.hasOwnProperty(a)?(h+=e[a],o=parseInt(h,16)*c,c=1,h=""):h+=a:e.hasOwnProperty(a)?(f+=e[a],l[o]=parseInt(f,16)*c,c=1,o=void 0,f=""):f+=a;return s},n={codePages:["WinAnsiEncoding"],WinAnsiEncoding:e("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},r={Unicode:{Courier:n,"Courier-Bold":n,"Courier-BoldOblique":n,"Courier-Oblique":n,Helvetica:n,"Helvetica-Bold":n,"Helvetica-BoldOblique":n,"Helvetica-Oblique":n,"Times-Roman":n,"Times-Bold":n,"Times-BoldItalic":n,"Times-Italic":n}},i={Unicode:{"Courier-Oblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":e("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":e("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Helvetica:e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),"Courier-Bold":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":e("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":e("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e,n,o;(e=i.Unicode[t.PostScriptName])&&((n=t.metadata.Unicode?t.metadata.Unicode:t.metadata.Unicode={}).widths=e.widths,n.kerning=e.kerning),(o=r.Unicode[t.PostScriptName])&&((n=t.metadata.Unicode?t.metadata.Unicode:t.metadata.Unicode={}).encoding=o,o.codePages&&o.codePages.length&&(t.encoding=o.codePages[0]))}])}(e.API),e.API.addSVG=function(t,e,n,r,i){function o(t,e){var n=e.createElement("style");n.type="text/css",n.styleSheet?n.styleSheet.cssText=t:n.appendChild(e.createTextNode(t)),e.getElementsByTagName("head")[0].appendChild(n)}if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");var a=function(t,e){var n=(e.contentWindow||e.contentDocument).document;return n.write(t),n.close(),n.getElementsByTagName("svg")[0]}(t,function(t){var e=t.createElement("iframe");return o(".jsPDF_sillysvg_iframe {display:none;position:absolute;}",t),e.name="childframe",e.setAttribute("width",0),e.setAttribute("height",0),e.setAttribute("frameborder","0"),e.setAttribute("scrolling","no"),e.setAttribute("seamless","seamless"),e.setAttribute("class","jsPDF_sillysvg_iframe"),t.body.appendChild(e),e}(document)),s=[1,1],c=parseFloat(a.getAttribute("width")),l=parseFloat(a.getAttribute("height"));c&&l&&(r&&i?s=[r/c,i/l]:r?s=[r/c,r/c]:i&&(s=[i/l,i/l]));var u,h,f,d,p=a.childNodes;for(u=0,h=p.length;u<h;u++)(f=p[u]).tagName&&"PATH"===f.tagName.toUpperCase()&&((d=function(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}(f.getAttribute("d").split(" ")))[0]=d[0]*s[0]+e,d[1]=d[1]*s[1]+n,this.lines.call(this,d[2],d[0],d[1],s));return this},e.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},/** ==================================================================== 
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 * 
 * 
 * ====================================================================
 */
function(t){var n="",r="",i="";e.API.addMetadata=function(t,e){return r=e||"http://jspdf.default.namespaceuri/",n=t,this.internal.events.subscribe("postPutResources",function(){if(n){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+r+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),o=unescape(encodeURIComponent(t)),a=unescape(encodeURIComponent(n)),s=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),c=unescape(encodeURIComponent("</x:xmpmeta>")),l=o.length+a.length+s.length+e.length+c.length;i=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+l+" >>"),this.internal.write("stream"),this.internal.write(e+o+a+s+c),this.internal.write("endstream"),this.internal.write("endobj")}else i=""}),this.internal.events.subscribe("putCatalog",function(){i&&this.internal.write("/Metadata "+i+" 0 R")}),this}}(),function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return void new Blob}catch(t){}var e=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var e=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},n=function(){this.data=[]},r=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},i=n.prototype,o=r.prototype,a=t.FileReaderSync,s=function(t){this.code=this[this.name=t]},c="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),l=c.length,u=t.URL||t.webkitURL||t,h=u.createObjectURL,f=u.revokeObjectURL,d=u,p=t.btoa,m=t.atob,g=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(r.fake=o.fake=!0;l--;)s.prototype[c[l]]=l+1;return u.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof r?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):h?h.call(u,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(u,t)},i.append=function(t){var n=this.data;if(w&&(t instanceof g||t instanceof w)){for(var i="",o=new w(t),c=0,l=o.length;c<l;c++)i+=String.fromCharCode(o[c]);n.push(i)}else if("Blob"===e(t)||"File"===e(t)){if(!a)throw new s("NOT_READABLE_ERR");var u=new a;n.push(u.readAsBinaryString(t))}else t instanceof r?"base64"===t.encoding&&m?n.push(m(t.data)):"URI"===t.encoding?n.push(decodeURIComponent(t.data)):"raw"===t.encoding&&n.push(t.data):("string"!=typeof t&&(t+=""),n.push(unescape(encodeURIComponent(t))))},i.getBlob=function(t){return arguments.length||(t=null),new r(this.data.join(""),t,"raw")},i.toString=function(){return"[object BlobBuilder]"},o.slice=function(t,e,n){var i=arguments.length;return i<3&&(n=null),new r(this.data.slice(t,i>1?e:this.data.length),n,this.encoding)},o.toString=function(){return"[object Blob]"},o.close=function(){this.size=0,delete this.data},n}(t);t.Blob=function(t,n){var r=n?n.type||"":"",i=new e;if(t)for(var o=0,a=t.length;o<a;o++)Uint8Array&&t[o]instanceof Uint8Array?i.append(t[o].buffer):i.append(t[o]);var s=i.getBlob(r);return!s.slice&&s.webkitSlice&&(s.slice=s.webkitSlice),s};var n=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=n(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content||void 0);var r=r||function(t){if(!(void 0===t||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var e=function(){return t.URL||t.webkitURL||t},n=t.document.createElementNS("http://www.w3.org/1999/xhtml","a"),r="download"in n,i=function(t){var e=new MouseEvent("click");t.dispatchEvent(e)},o=/constructor/i.test(t.HTMLElement)||t.safari,a=/CriOS\/[\d]+/.test(navigator.userAgent),s=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},c=function(t){setTimeout(function(){"string"==typeof t?e().revokeObjectURL(t):t.remove()},4e4)},l=function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){s(t)}}},u=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},h=function(s,h,f){f||(s=u(s));var d,p=this,m="application/octet-stream"===s.type,g=function(){l(p,"writestart progress write writeend".split(" "))};if(p.readyState=p.INIT,r)return d=e().createObjectURL(s),void setTimeout(function(){n.href=d,n.download=h,i(n),g(),c(d),p.readyState=p.DONE});!function(){if((a||m&&o)&&t.FileReader){var n=new FileReader;return n.onloadend=function(){var e=a?n.result:n.result.replace(/^data:[^;]*;/,"data:attachment/file;");t.open(e,"_blank")||(t.location.href=e),e=void 0,p.readyState=p.DONE,g()},n.readAsDataURL(s),void(p.readyState=p.INIT)}d||(d=e().createObjectURL(s)),m?t.location.href=d:t.open(d,"_blank")||(t.location.href=d),p.readyState=p.DONE,g(),c(d)}()},f=h.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=u(t)),navigator.msSaveOrOpenBlob(t,e)}:(f.abort=function(){},f.readyState=f.INIT=0,f.WRITING=1,f.DONE=2,f.error=f.onwritestart=f.onprogress=f.onwrite=f.onabort=f.onerror=f.onwriteend=null,function(t,e,n){return new h(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content);"undefined"!=typeof module&&module.exports?module.exports.saveAs=r:"undefined"!=typeof define&&null!==define&&null!==define.amd&&define("FileSaver.js",function(){return r}),function(t,e){"object"==typeof module?module.exports=e():"function"==typeof define?define(e):t.adler32cs=e()}(e,function(){var t="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,e=null,n=function(){if(!t)return function(){return!1};try{var n={};"function"==typeof n.Buffer&&(e=n.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==e&&t instanceof e}}(),r=null!==e?function(t){return new e(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},i=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)r=(r+(n=(n+(255&e.charCodeAt(i)))%65521))%65521;return(r<<16|n)>>>0},o=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)r=(r+(n=(n+e[i])%65521))%65521;return(r<<16|n)>>>0},a={},s=a.Adler32=function(){var e=function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0},a=e.prototype={};return a.constructor=e,e.from=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=i(1,t.toString())}),e.fromUtf8=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var n=r(t.toString());this.checksum=i(1,n)}),t&&(e.fromBuffer=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var r=new Uint8Array(t);return this.checksum=o(1,r)})),a.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=i(this.checksum,t)},a.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return this.checksum=i(this.checksum,e)},t&&(a.updateBuffer=function(t){if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=o(this.checksum,e)}),a.clone=function(){return new s(this.checksum)},e}();return a.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return i(1,t.toString())},a.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return i(1,e)},t&&(a.fromBuffer=function(t){if(!n(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return o(1,e)}),a});/**
 * CssColors
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
var i={};i._colorsTable={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"},i.colorNameToHex=function(t){return t=t.toLowerCase(),void 0!==this._colorsTable[t]&&this._colorsTable[t]};/*
 Deflate.js - https://github.com/gildas-lormeau/zip.js
 Copyright (c) 2013 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var o=function(t){function e(){function t(t){var e,n,i,o,a,c,l=r.dyn_tree,u=r.stat_desc.static_tree,h=r.stat_desc.extra_bits,d=r.stat_desc.extra_base,p=r.stat_desc.max_length,m=0;for(o=0;o<=s;o++)t.bl_count[o]=0;for(l[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<f;e++)(o=l[2*l[2*(n=t.heap[e])+1]+1]+1)>p&&(o=p,m++),l[2*n+1]=o,n>r.max_code||(t.bl_count[o]++,a=0,n>=d&&(a=h[n-d]),c=l[2*n],t.opt_len+=c*(o+a),u&&(t.static_len+=c*(u[2*n+1]+a)));if(0!==m){do{for(o=p-1;0===t.bl_count[o];)o--;t.bl_count[o]--,t.bl_count[o+1]+=2,t.bl_count[p]--,m-=2}while(m>0);for(o=p;0!==o;o--)for(n=t.bl_count[o];0!==n;)(i=t.heap[--e])>r.max_code||(l[2*i+1]!=o&&(t.opt_len+=(o-l[2*i+1])*l[2*i],l[2*i+1]=o),n--)}}function e(t,e){var n=0;do{n|=1&t,t>>>=1,n<<=1}while(--e>0);return n>>>1}function n(t,n,r){var i,o,a,c=[],l=0;for(i=1;i<=s;i++)c[i]=l=l+r[i-1]<<1;for(o=0;o<=n;o++)0!==(a=t[2*o+1])&&(t[2*o]=e(c[a]++,a))}var r=this;r.build_tree=function(e){var i,o,a,s=r.dyn_tree,c=r.stat_desc.static_tree,l=r.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=f,i=0;i<l;i++)0!==s[2*i]?(e.heap[++e.heap_len]=u=i,e.depth[i]=0):s[2*i+1]=0;for(;e.heap_len<2;)s[2*(a=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[a]=0,e.opt_len--,c&&(e.static_len-=c[2*a+1]);for(r.max_code=u,i=Math.floor(e.heap_len/2);i>=1;i--)e.pqdownheap(s,i);a=l;do{i=e.heap[1],e.heap[1]=e.heap[e.heap_len--],e.pqdownheap(s,1),o=e.heap[1],e.heap[--e.heap_max]=i,e.heap[--e.heap_max]=o,s[2*a]=s[2*i]+s[2*o],e.depth[a]=Math.max(e.depth[i],e.depth[o])+1,s[2*i+1]=s[2*o+1]=a,e.heap[1]=a++,e.pqdownheap(s,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1],t(e),n(s,r.max_code,e.bl_count)}}function n(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}function r(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}function i(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function o(){function t(){var t;for(Pt=2*At,Et[Ft-1]=0,t=0;t<Ft-1;t++)Et[t]=0;Vt=z[Gt].max_lazy,Jt=z[Gt].good_length,Qt=z[Gt].nice_length,Xt=z[Gt].max_chain,Mt=0,jt=0,Ht=0,zt=Wt=$-1,Lt=0,Ot=0}function r(){var t;for(t=0;t<h;t++)Kt[2*t]=0;for(t=0;t<c;t++)$t[2*t]=0;for(t=0;t<l;t++)Zt[2*t]=0;Kt[2*d]=1,te.opt_len=te.static_len=0,ae=ce=0}function o(){ee.dyn_tree=Kt,ee.stat_desc=n.static_l_desc,ne.dyn_tree=$t,ne.stat_desc=n.static_d_desc,re.dyn_tree=Zt,re.stat_desc=n.static_bl_desc,ue=0,he=0,le=8,r()}function a(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<c?Zt[2*r]+=a:0!==r?(r!=i&&Zt[2*r]++,Zt[2*p]++):a<=10?Zt[2*m]++:Zt[2*g]++,a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4))}function s(){var t;for(a(Kt,ee.max_code),a($t,ne.max_code),re.build_tree(te),t=l-1;t>=3&&0===Zt[2*e.bl_order[t]+1];t--);return te.opt_len+=3*(t+1)+5+5+4,t}function f(t){te.pending_buf[te.pending++]=t}function O(t){f(255&t),f(t>>>8&255)}function et(t){f(t>>8&255),f(255&t)}function nt(t,e){var n,r=e;he>w-r?(O(ue|=(n=t)<<he&65535),ue=n>>>w-he,he+=r-w):(ue|=t<<he&65535,he+=r)}function rt(t,e){var n=2*t;nt(65535&e[n],65535&e[n+1])}function it(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<c)do{rt(r,Zt)}while(0!=--a);else 0!==r?(r!=i&&(rt(r,Zt),a--),rt(p,Zt),nt(a-3,2)):a<=10?(rt(m,Zt),nt(a-3,3)):(rt(g,Zt),nt(a-11,7));a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4)}}function ot(t,n,r){var i;for(nt(t-257,5),nt(n-1,5),nt(r-4,4),i=0;i<r;i++)nt(Zt[2*e.bl_order[i]+1],3);it(Kt,t-1),it($t,n-1)}function at(){16==he?(O(ue),ue=0,he=0):he>=8&&(f(255&ue),ue>>>=8,he-=8)}function st(){nt(Q<<1,3),rt(d,n.static_ltree),at(),1+le+10-he<9&&(nt(Q<<1,3),rt(d,n.static_ltree),at()),le=7}function ct(t,n){var r,i,o;if(te.pending_buf[se+2*ae]=t>>>8&255,te.pending_buf[se+2*ae+1]=255&t,te.pending_buf[ie+ae]=255&n,ae++,0===t?Kt[2*n]++:(ce++,t--,Kt[2*(e._length_code[n]+u+1)]++,$t[2*e.d_code(t)]++),0==(8191&ae)&&Gt>2){for(r=8*ae,i=Mt-jt,o=0;o<c;o++)r+=$t[2*o]*(5+e.extra_dbits[o]);if(r>>>=3,ce<Math.floor(ae/2)&&r<Math.floor(i/2))return!0}return ae==oe-1}function lt(t,n){var r,i,o,a,s=0;if(0!==ae)do{r=te.pending_buf[se+2*s]<<8&65280|255&te.pending_buf[se+2*s+1],i=255&te.pending_buf[ie+s],s++,0===r?rt(i,t):(rt((o=e._length_code[i])+u+1,t),0!==(a=e.extra_lbits[o])&&nt(i-=e.base_length[o],a),r--,rt(o=e.d_code(r),n),0!==(a=e.extra_dbits[o])&&nt(r-=e.base_dist[o],a))}while(s<ae);rt(d,t),le=t[2*d+1]}function ut(){he>8?O(ue):he>0&&f(255&ue),ue=0,he=0}function ht(t,e,n){ut(),le=8,n&&(O(e),O(~e)),te.pending_buf.set(Tt.subarray(t,t+e),te.pending),te.pending+=e}function ft(t,e,n){nt((J<<1)+(n?1:0),3),ht(t,e,!0)}function dt(t,e,i){var o,a,c=0;Gt>0?(ee.build_tree(te),ne.build_tree(te),c=s(),o=te.opt_len+3+7>>>3,(a=te.static_len+3+7>>>3)<=o&&(o=a)):o=a=e+5,e+4<=o&&-1!=t?ft(t,e,i):a==o?(nt((Q<<1)+(i?1:0),3),lt(n.static_ltree,n.static_dtree)):(nt((K<<1)+(i?1:0),3),ot(ee.max_code+1,ne.max_code+1,c+1),lt(Kt,$t)),r(),i&&ut()}function pt(t){dt(jt>=0?jt:-1,Mt-jt,t),jt=Mt,xt.flush_pending()}function mt(){var t,e,n,r;do{if(0===(r=Pt-Ht-Mt)&&0===Mt&&0===Ht)r=At;else if(-1==r)r--;else if(Mt>=At+At-tt){Tt.set(Tt.subarray(At,At+At),0),Ut-=At,Mt-=At,jt-=At,n=t=Ft;do{e=65535&Et[--n],Et[n]=e>=At?e-At:0}while(0!=--t);n=t=At;do{e=65535&It[--n],It[n]=e>=At?e-At:0}while(0!=--t);r+=At}if(0===xt.avail_in)return;t=xt.read_buf(Tt,Mt+Ht,r),(Ht+=t)>=$&&(Ot=255&Tt[Mt],Ot=(Ot<<Dt^255&Tt[Mt+1])&Rt)}while(Ht<tt&&0!==xt.avail_in)}function gt(t){var e,n=65535;for(n>_t-5&&(n=_t-5);;){if(Ht<=1){if(mt(),0===Ht&&t==k)return L;if(0===Ht)break}if(Mt+=Ht,Ht=0,e=jt+n,(0===Mt||Mt>=e)&&(Ht=Mt-e,Mt=e,pt(!1),0===xt.avail_out))return L;if(Mt-jt>=At-tt&&(pt(!1),0===xt.avail_out))return L}return pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function wt(t){var e,n,r=Xt,i=Mt,o=Wt,a=Mt>At-tt?Mt-(At-tt):0,s=Qt,c=qt,l=Mt+Z,u=Tt[i+o-1],h=Tt[i+o];Wt>=Jt&&(r>>=2),s>Ht&&(s=Ht);do{if(e=t,Tt[e+o]==h&&Tt[e+o-1]==u&&Tt[e]==Tt[i]&&Tt[++e]==Tt[i+1]){i+=2,e++;do{}while(Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&i<l);if(n=Z-(l-i),i=l-Z,n>o){if(Ut=t,o=n,n>=s)break;u=Tt[i+o-1],h=Tt[i+o]}}}while((t=65535&It[t&c])>a&&0!=--r);return o<=Ht?o:Ht}function yt(t){for(var e,n=0;;){if(Ht<tt){if(mt(),Ht<tt&&t==k)return L;if(0===Ht)break}if(Ht>=$&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,n=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt),0!==n&&(Mt-n&65535)<=At-tt&&Yt!=b&&(zt=wt(n)),zt>=$)if(e=ct(Mt-Ut,zt-$),Ht-=zt,zt<=Vt&&Ht>=$){zt--;do{Ot=(Ot<<Dt^255&Tt[++Mt+($-1)])&Rt,n=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt}while(0!=--zt);Mt++}else Mt+=zt,zt=0,Ot=255&Tt[Mt],Ot=(Ot<<Dt^255&Tt[Mt+1])&Rt;else e=ct(0,255&Tt[Mt]),Ht--,Mt++;if(e&&(pt(!1),0===xt.avail_out))return L}return pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function vt(t){for(var e,n,r=0;;){if(Ht<tt){if(mt(),Ht<tt&&t==k)return L;if(0===Ht)break}if(Ht>=$&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,r=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt),Wt=zt,Nt=Ut,zt=$-1,0!==r&&Wt<Vt&&(Mt-r&65535)<=At-tt&&(Yt!=b&&(zt=wt(r)),zt<=5&&(Yt==v||zt==$&&Mt-Ut>4096)&&(zt=$-1)),Wt>=$&&zt<=Wt){n=Mt+Ht-$,e=ct(Mt-1-Nt,Wt-$),Ht-=Wt-1,Wt-=2;do{++Mt<=n&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,r=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt)}while(0!=--Wt);if(Lt=0,zt=$-1,Mt++,e&&(pt(!1),0===xt.avail_out))return L}else if(0!==Lt){if((e=ct(0,255&Tt[Mt-1]))&&pt(!1),Mt++,Ht--,0===xt.avail_out)return L}else Lt=1,Mt++,Ht--}return 0!==Lt&&(e=ct(0,255&Tt[Mt-1]),Lt=0),pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function bt(e){return e.total_in=e.total_out=0,e.msg=null,te.pending=0,te.pending_out=0,kt=V,Ct=k,o(),t(),S}var xt,kt,_t,Ct,At,St,qt,Tt,Pt,It,Et,Ot,Ft,Bt,Rt,Dt,jt,zt,Nt,Lt,Mt,Ut,Ht,Wt,Xt,Vt,Gt,Yt,Jt,Qt,Kt,$t,Zt,te=this,ee=new e,ne=new e,re=new e;te.depth=[];var ie,oe,ae,se,ce,le,ue,he;te.bl_count=[],te.heap=[],Kt=[],$t=[],Zt=[],te.pqdownheap=function(t,e){for(var n=te.heap,r=n[e],o=e<<1;o<=te.heap_len&&(o<te.heap_len&&i(t,n[o+1],n[o],te.depth)&&o++,!i(t,r,n[o],te.depth));)n[e]=n[o],e=o,o<<=1;n[e]=r},te.deflateInit=function(t,e,n,r,i,o){return r||(r=Y),i||(i=B),o||(o=x),t.msg=null,e==y&&(e=6),i<1||i>F||r!=Y||n<9||n>15||e<0||e>9||o<0||o>b?P:(t.dstate=te,St=n,At=1<<St,qt=At-1,Bt=i+7,Ft=1<<Bt,Rt=Ft-1,Dt=Math.floor((Bt+$-1)/$),Tt=new Uint8Array(2*At),It=[],Et=[],oe=1<<i+6,te.pending_buf=new Uint8Array(4*oe),_t=4*oe,se=Math.floor(oe/2),ie=3*oe,Gt=e,Yt=o,bt(t))},te.deflateEnd=function(){return kt!=X&&kt!=V&&kt!=G?P:(te.pending_buf=null,Et=null,It=null,Tt=null,te.dstate=null,kt==V?I:S)},te.deflateParams=function(t,e,n){var r=S;return e==y&&(e=6),e<0||e>9||n<0||n>b?P:(z[Gt].func!=z[e].func&&0!==t.total_in&&(r=t.deflate(_)),Gt!=e&&(Vt=z[Gt=e].max_lazy,Jt=z[Gt].good_length,Qt=z[Gt].nice_length,Xt=z[Gt].max_chain),Yt=n,r)},te.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||kt!=X)return P;if(i<$)return S;for(i>At-tt&&(o=n-(i=At-tt)),Tt.set(e.subarray(o,o+i),0),Mt=i,jt=i,Ot=255&Tt[0],Ot=(Ot<<Dt^255&Tt[1])&Rt,r=0;r<=i-$;r++)Ot=(Ot<<Dt^255&Tt[r+($-1)])&Rt,It[r&qt]=Et[Ot],Et[Ot]=r;return S},te.deflate=function(t,e){var n,r,i,o,a;if(e>A||e<0)return P;if(!t.next_out||!t.next_in&&0!==t.avail_in||kt==G&&e!=A)return t.msg=N[T-P],P;if(0===t.avail_out)return t.msg=N[T-E],E;if(xt=t,o=Ct,Ct=e,kt==X&&(r=Y+(St-8<<4)<<8,(i=(Gt-1&255)>>1)>3&&(i=3),r|=i<<6,0!==Mt&&(r|=W),kt=V,et(r+=31-r%31)),0!==te.pending){if(xt.flush_pending(),0===xt.avail_out)return Ct=-1,S}else if(0===xt.avail_in&&e<=o&&e!=A)return xt.msg=N[T-E],E;if(kt==G&&0!==xt.avail_in)return t.msg=N[T-E],E;if(0!==xt.avail_in||0!==Ht||e!=k&&kt!=G){switch(a=-1,z[Gt].func){case R:a=gt(e);break;case D:a=yt(e);break;case j:a=vt(e)}if(a!=U&&a!=H||(kt=G),a==L||a==U)return 0===xt.avail_out&&(Ct=-1),S;if(a==M){if(e==_)st();else if(ft(0,0,!1),e==C)for(n=0;n<Ft;n++)Et[n]=0;if(xt.flush_pending(),0===xt.avail_out)return Ct=-1,S}}return e!=A?S:q}}function a(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}var s=15,c=30,l=19,u=256,h=u+1+29,f=2*h+1,d=256,p=16,m=17,g=18,w=16,y=-1,v=1,b=2,x=0,k=0,_=1,C=3,A=4,S=0,q=1,T=2,P=-2,I=-3,E=-5,O=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];e._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],e.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],e.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],e.d_code=function(t){return t<256?O[t]:O[256+(t>>>7)]},e.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],e.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],e.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],e.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],n.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],n.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],n.static_l_desc=new n(n.static_ltree,e.extra_lbits,u+1,h,s),n.static_d_desc=new n(n.static_dtree,e.extra_dbits,0,c,s),n.static_bl_desc=new n(null,e.extra_blbits,0,l,7);var F=9,B=8,R=0,D=1,j=2,z=[new r(0,0,0,0,R),new r(4,4,8,4,D),new r(4,5,16,8,D),new r(4,6,32,32,D),new r(4,4,16,16,j),new r(8,16,32,32,j),new r(8,16,128,128,j),new r(8,32,128,256,j),new r(32,128,258,1024,j),new r(32,258,258,4096,j)],N=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],L=0,M=1,U=2,H=3,W=32,X=42,V=113,G=666,Y=8,J=0,Q=1,K=2,$=3,Z=258,tt=Z+$+1;return a.prototype={deflateInit:function(t,e){var n=this;return n.dstate=new o,e||(e=s),n.dstate.deflateInit(n,t,e)},deflate:function(t){var e=this;return e.dstate?e.dstate.deflate(e,t):P},deflateEnd:function(){var t=this;if(!t.dstate)return P;var e=t.dstate.deflateEnd();return t.dstate=null,e},deflateParams:function(t,e){var n=this;return n.dstate?n.dstate.deflateParams(n,t,e):P},deflateSetDictionary:function(t,e){var n=this;return n.dstate?n.dstate.deflateSetDictionary(n,t,e):P},read_buf:function(t,e,n){var r=this,i=r.avail_in;return i>n&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}},function(t){var e=this,n=new a,r=k,i=new Uint8Array(512);void 0===t&&(t=y),n.deflateInit(t),n.next_out=i,e.append=function(t,e){var o,a=[],s=0,c=0,l=0;if(t.length){n.next_in_index=0,n.next_in=t,n.avail_in=t.length;do{if(n.next_out_index=0,n.avail_out=512,n.deflate(r)!=S)throw"deflating: "+n.msg;n.next_out_index&&(512==n.next_out_index?a.push(new Uint8Array(i)):a.push(new Uint8Array(i.subarray(0,n.next_out_index)))),l+=n.next_out_index,e&&n.next_in_index>0&&n.next_in_index!=s&&(e(n.next_in_index),s=n.next_in_index)}while(n.avail_in>0||0===n.avail_out);return o=new Uint8Array(l),a.forEach(function(t){o.set(t,c),c+=t.length}),o}},e.flush=function(){var t,e,r=[],o=0,a=0;do{if(n.next_out_index=0,n.avail_out=512,(t=n.deflate(A))!=q&&t!=S)throw"deflating: "+n.msg;512-n.avail_out>0&&r.push(new Uint8Array(i.subarray(0,n.next_out_index))),a+=n.next_out_index}while(n.avail_in>0||0===n.avail_out);return n.deflateEnd(),e=new Uint8Array(a),r.forEach(function(t){e.set(t,o),o+=t.length}),e}}}();/*
  html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
  Copyright (c) 2016 Niklas von Hertzen

  Released under  License
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function t(e,n,r){function i(a,s){if(!n[a]){if(!e[a]){var c="function"==typeof require&&require;if(!s&&c)return c(a,!0);if(o)return o(a,!0);var l=new Error("Cannot find module '"+a+"'");throw l.code="MODULE_NOT_FOUND",l}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n||t)},u,u.exports,t,e,n,r)}return n[a].exports}for(var o="function"==typeof require&&require,a=0;a<r.length;a++)i(r[a]);return i}({1:[function(t,e,n){(function(t){!function(r){function i(t){throw RangeError(E[t])}function o(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function a(t,e){return o(t.split(I),e).join(".")}function s(t){for(var e,n,r=[],i=0,o=t.length;i<o;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function c(t){return o(t,function(t){var e="";return t>65535&&(e+=B((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=B(t)}).join("")}function l(t){return t-48<10?t-22:t-65<26?t-65:t-97<26?t-97:b}function u(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function h(t,e,n){var r=0;for(t=n?F(t/C):t>>1,t+=F(t/e);t>O*k>>1;r+=b)t=F(t/O);return F(r+(O+1)*t/(t+_))}function f(t){var e,n,r,o,a,s,u,f,d,p,m=[],g=t.length,w=0,y=S,_=A;for((n=t.lastIndexOf(q))<0&&(n=0),r=0;r<n;++r)t.charCodeAt(r)>=128&&i("not-basic"),m.push(t.charCodeAt(r));for(o=n>0?n+1:0;o<g;){for(a=w,s=1,u=b;o>=g&&i("invalid-input"),((f=l(t.charCodeAt(o++)))>=b||f>F((v-w)/s))&&i("overflow"),w+=f*s,d=u<=_?x:u>=_+k?k:u-_,!(f<d);u+=b)s>F(v/(p=b-d))&&i("overflow"),s*=p;_=h(w-a,e=m.length+1,0==a),F(w/e)>v-y&&i("overflow"),y+=F(w/e),w%=e,m.splice(w++,0,y)}return c(m)}function d(t){var e,n,r,o,a,c,l,f,d,p,m,g,w,y,_,C=[];for(g=(t=s(t)).length,e=S,n=0,a=A,c=0;c<g;++c)(m=t[c])<128&&C.push(B(m));for(r=o=C.length,o&&C.push(q);r<g;){for(l=v,c=0;c<g;++c)(m=t[c])>=e&&m<l&&(l=m);for(l-e>F((v-n)/(w=r+1))&&i("overflow"),n+=(l-e)*w,e=l,c=0;c<g;++c)if((m=t[c])<e&&++n>v&&i("overflow"),m==e){for(f=n,d=b;p=d<=a?x:d>=a+k?k:d-a,!(f<p);d+=b)_=f-p,y=b-p,C.push(B(u(p+_%y,0))),f=F(_/y);C.push(B(u(f,0))),a=h(n,w,r==o),n=0,++r}++n,++e}return C.join("")}var p="object"==typeof n&&n,m="object"==typeof e&&e&&e.exports==p&&e,g="object"==typeof t&&t;g.global!==g&&g.window!==g||(r=g);var w,y,v=2147483647,b=36,x=1,k=26,_=38,C=700,A=72,S=128,q="-",T=/^xn--/,P=/[^ -~]/,I=/\x2E|\u3002|\uFF0E|\uFF61/g,E={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},O=b-x,F=Math.floor,B=String.fromCharCode;if(w={version:"1.2.4",ucs2:{decode:s,encode:c},decode:f,encode:d,toASCII:function(t){return a(t,function(t){return P.test(t)?"xn--"+d(t):t})},toUnicode:function(t){return a(t,function(t){return T.test(t)?f(t.slice(4).toLowerCase()):t})}},p&&!p.nodeType)if(m)m.exports=w;else for(y in w)w.hasOwnProperty(y)&&(p[y]=w[y]);else r.punycode=w}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){function r(t,e,n){!t.defaultView||e===t.defaultView.pageXOffset&&n===t.defaultView.pageYOffset||t.defaultView.scrollTo(e,n)}function i(t,e){try{e&&(e.width=t.width,e.height=t.height,e.getContext("2d").putImageData(t.getContext("2d").getImageData(0,0,t.width,t.height),0,0))}catch(e){s("Unable to copy canvas content from",t,e)}}function o(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(o(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?i(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}function a(t){if(1===t.nodeType){t.scrollTop=t._scrollTop,t.scrollLeft=t._scrollLeft;for(var e=t.firstChild;e;)a(e),e=e.nextSibling}}var s=t("./log");e.exports=function(t,e,n,i,s,c,l){var u=o(t.documentElement,s.javascriptEnabled),h=e.createElement("iframe");return h.className="html2canvas-container",h.style.visibility="hidden",h.style.position="fixed",h.style.left="-10000px",h.style.top="0px",h.style.border="0",h.width=n,h.height=i,h.scrolling="no",e.body.appendChild(h),new Promise(function(e){var n=h.contentWindow.document;h.contentWindow.onload=h.onload=function(){var t=setInterval(function(){n.body.childNodes.length>0&&(a(n.documentElement),clearInterval(t),"view"===s.type&&(h.contentWindow.scrollTo(c,l),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||h.contentWindow.scrollY===l&&h.contentWindow.scrollX===c||(n.documentElement.style.top=-l+"px",n.documentElement.style.left=-c+"px",n.documentElement.style.position="absolute")),e(h))},50)},n.open(),n.write("<!DOCTYPE html><html></html>"),r(t,c,l),n.replaceChild(n.adoptNode(u),n.documentElement),n.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),t.length>3&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e=null;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e=null;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e=null;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=c[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var c={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){function r(t,e){var n=k++;if((e=e||{}).logging&&(g.options.logging=!0,g.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:f,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var r=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v(u(t),e.proxy,document,r,a,e).then(function(t){return o(t.contentWindow.document.documentElement,t,e,r,a)})}var s=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return s.setAttribute(x+n,n),i(s.ownerDocument,e,s.ownerDocument.defaultView.innerWidth,s.ownerDocument.defaultView.innerHeight,n).then(function(t){return"function"==typeof e.onrendered&&(g("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}function i(t,e,n,r,i){return y(t,t,n,r,e,t.defaultView.pageXOffset,t.defaultView.pageYOffset).then(function(a){g("Document cloned");var s=x+i,c="["+s+"='"+i+"']";t.querySelector(c).removeAttribute(s);var l=a.contentWindow,u=l.document.querySelector(c);return("function"==typeof e.onclone?Promise.resolve(e.onclone(l.document)):Promise.resolve(!0)).then(function(){return o(u,a,e,n,r)})})}function o(t,e,n,r,i){var o=e.contentWindow,u=new h(o.document),f=new d(n,u),m=b(t),w="view"===n.type?r:c(o.document),y="view"===n.type?i:l(o.document),v=new n.renderer(w,y,f,n,document);return new p(t,v,u,f,n).ready.then(function(){g("Finished rendering");var r;return r="view"===n.type?s(v.canvas,{width:v.canvas.width,height:v.canvas.height,top:0,left:0,x:0,y:0}):t===o.document.body||t===o.document.documentElement||null!=n.canvas?v.canvas:s(v.canvas,{width:null!=n.width?n.width:m.width,height:null!=n.height?n.height:m.height,top:m.top,left:m.left,x:0,y:0}),a(e,n),r})}function a(t,e){e.removeContainer&&(t.parentNode.removeChild(t),g("Cleaned up container"))}function s(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,c=a-o;return g("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",c),g("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,c,e.x,e.y,s,c),n}function c(t){return Math.max(Math.max(t.body.scrollWidth,t.documentElement.scrollWidth),Math.max(t.body.offsetWidth,t.documentElement.offsetWidth),Math.max(t.body.clientWidth,t.documentElement.clientWidth))}function l(t){return Math.max(Math.max(t.body.scrollHeight,t.documentElement.scrollHeight),Math.max(t.body.offsetHeight,t.documentElement.offsetHeight),Math.max(t.body.clientHeight,t.documentElement.clientHeight))}function u(t){var e=document.createElement("a");return e.href=t,e.href=e.href,e}var h=t("./support"),f=t("./renderers/canvas"),d=t("./imageloader"),p=t("./nodeparser"),m=t("./nodecontainer"),g=t("./log"),w=t("./utils"),y=t("./clone"),v=t("./proxy").loadUrlDocument,b=w.getBounds,x="data-html2canvas-node",k=0;r.CanvasRenderer=f,r.NodeContainer=m,r.log=g,r.utils=w;var _="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:r;e.exports=_},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){function r(t){if(this.src=t,i("DummyImageContainer for",t),!this.promise||!this.image){i("Initiating DummyImageContainer"),r.prototype.image=new Image;var e=this.image;r.prototype.promise=new Promise(function(t,n){e.onload=t,e.onerror=n,e.src=o(),!0===e.complete&&t(e)})}}var i=t("./log"),o=t("./utils").smallImage;e.exports=r},{"./log":13,"./utils":26}],6:[function(t,e,n){var r=t("./utils").smallImage;e.exports=function(t,e){var n,i,o=document.createElement("div"),a=document.createElement("img"),s=document.createElement("span");o.style.visibility="hidden",o.style.fontFamily=t,o.style.fontSize=e,o.style.margin=0,o.style.padding=0,document.body.appendChild(o),a.src=r(),a.width=1,a.height=1,a.style.margin=0,a.style.padding=0,a.style.verticalAlign="baseline",s.style.fontFamily=t,s.style.fontSize=e,s.style.margin=0,s.style.padding=0,s.appendChild(document.createTextNode("Hidden Text")),o.appendChild(s),o.appendChild(a),n=a.offsetTop-s.offsetTop+1,o.removeChild(s),o.appendChild(document.createTextNode("Hidden Text")),o.style.lineHeight="normal",a.style.verticalAlign="super",i=a.offsetTop-o.offsetTop+1,document.body.removeChild(o),this.baseline=n,this.lineWidth=1,this.middle=i}},{"./utils":26}],7:[function(t,e,n){function r(){this.data={}}var i=t("./font");r.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new i(t,e)),this.data[t+"-"+e]},e.exports=r},{"./font":6}],8:[function(t,e,n){function r(e,n,r){this.image=null,this.src=e;var o=this,a=i(e);this.promise=(n?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(r.proxy,a,r)).then(function(e){return t("./core")(e.contentWindow.document.documentElement,{type:"view",width:e.width,height:e.height,proxy:r.proxy,javascriptEnabled:r.javascriptEnabled,removeContainer:r.removeContainer,allowTaint:r.allowTaint,imageTimeout:r.imageTimeout/2})}).then(function(t){return o.image=t})}var i=t("./utils").getBounds,o=t("./proxy").loadUrlDocument;r.prototype.proxyLoad=function(t,e,n){var r=this.src;return o(r.src,t,r.ownerDocument,e.width,e.height,n)},e.exports=r},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(t,e){this.src=t,this.image=new Image;var n=this;this.tainted=null,this.promise=new Promise(function(r,i){n.image.onload=r,n.image.onerror=i,e&&(n.image.crossOrigin="anonymous"),n.image.src=t,!0===n.image.complete&&r(n.image)})}},{}],11:[function(t,e,n){function r(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}var i=t("./log"),o=t("./imagecontainer"),a=t("./dummyimagecontainer"),s=t("./proxyimagecontainer"),c=t("./framecontainer"),l=t("./svgcontainer"),u=t("./svgnodecontainer"),h=t("./lineargradientcontainer"),f=t("./webkitgradientcontainer"),d=t("./utils").bind;r.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},r.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},r.prototype.addImage=function(t,e){return function(n){n.args.forEach(function(r){this.imageExists(t,r)||(t.splice(0,0,e.call(this,n)),i("Added image #"+t.length,"string"==typeof r?r.substring(0,100):r))},this)}},r.prototype.hasImageBackground=function(t){return"none"!==t.method},r.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new o(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new o(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new o(e,!0):this.options.proxy?new s(e,this.options.proxy):new a(e):new l(e)}return"linear-gradient"===t.method?new h(t):"gradient"===t.method?new f(t):"svg"===t.method?new u(t.args[0],this.support.svg):"IFRAME"===t.method?new c(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new a(t)},r.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||l.prototype.isInline(t)},r.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},r.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},r.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},r.prototype.getPromise=function(t){return this.timeout(t,this.options.imageTimeout).catch(function(){return new a(t.src).promise.then(function(e){t.image=e})})},r.prototype.get=function(t){var e=null;return this.images.some(function(n){return(e=n).src===t})?e:null},r.prototype.fetch=function(t){return this.images=t.reduce(d(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(t,e){t.promise.then(function(){i("Succesfully loaded image #"+(e+1),t)},function(n){i("Failed loading image #"+(e+1),t,n)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),i("Finished searching images"),this},r.prototype.timeout=function(t,e){var n,r=Promise.race([t.promise,new Promise(function(r,o){n=setTimeout(function(){i("Timed out loading image",t),o(t)},e)})]).then(function(t){return clearTimeout(n),t});return r.catch(function(){clearTimeout(n)}),r},e.exports=r},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(t,e){null===t.stop&&this.colorStops.slice(e).some(function(n,r){return null!==n.stop&&(t.stop=(n.stop-this.colorStops[e-1].stop)/(r+1)+this.colorStops[e-1].stop,!0)},this)},this)}var i=t("./gradientcontainer"),o=t("./color");r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){function r(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function i(t){var e=t.options[t.selectedIndex||0];return e?e.text||"":""}function o(t){if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}function a(t){return-1!==t.toString().indexOf("%")}function s(t){return t.replace("px","")}function c(t){return parseFloat(t)}var l=t("./color"),u=t("./utils"),h=u.getBounds,f=u.parseBackgrounds,d=u.offsetBounds;r.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},r.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},r.prototype.assignStack=function(t){this.stack=t,t.children.push(this)},r.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},r.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},r.prototype.prefixedCss=function(t){var e=["webkit","moz","ms","o"],n=this.css(t);return void 0===n&&e.some(function(e){return void 0!==(n=this.css(e+t.substr(0,1).toUpperCase()+t.substr(1)))},this),void 0===n?null:n},r.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},r.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},r.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new l(this.css(t)))},r.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},r.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},r.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},r.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=f(this.css("backgroundImage")))},r.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return n=n[e||0]||n[0]||"auto",1===(n=n.trim().split(" ")).length&&(n=[n[0],a(n[0])?"auto":n[0]]),n},r.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(a(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var s=t.width/t.height,c=e.width/e.height;return s<c^"contain"===o[0]?{width:t.height*c,height:t.height}:{width:t.width,height:t.width/c}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:a(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},r.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,s=this.cssList("backgroundPosition",n);return i=a(s[0])?(t.width-(r||e).width)*(parseFloat(s[0])/100):parseInt(s[0],10),o="auto"===s[1]?i/e.width*e.height:a(s[1])?(t.height-(r||e).height)*parseFloat(s[1])/100:parseInt(s[1],10),"auto"===s[0]&&(i=o/e.height*e.width),{left:i,top:o}},r.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},r.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new l(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},r.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(s).map(c);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},r.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?o(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},r.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?d(this.node):h(this.node))},r.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},r.prototype.getValue=function(){var t=this.node.value||"";return"SELECT"===this.node.tagName?t=i(this.node):"password"===this.node.type&&(t=Array(t.length+1).join("•")),0===t.length?this.node.placeholder||"":t},r.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,r.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,r.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,r.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=r},{"./color":3,"./utils":26}],15:[function(t,e,n){function r(t,e,n,r,i){L("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new G(!0,1,t.ownerDocument,null);var o=new U(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new V(i.background)),t===t.ownerDocument.documentElement){var a=new U(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=R([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new X,L("Fetched nodes, total:",this.nodes.length),L("Calculate overflow clips"),this.calculateOverflowClips(),L("Start fetching images"),this.images=r.fetch(this.nodes.filter(q)),this.ready=this.images.ready.then(J(function(){return L("Images loaded, starting parsing"),L("Creating stacking contexts"),this.createStackingContexts(),L("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),L("Render queue created with "+this.renderQueue.length+" items"),new Promise(J(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):this.renderQueue.length>0?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function i(t){return t.parent&&t.parent.clip.length}function o(t){return t.replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")})}function a(){}function s(t,e,n,r){return t.map(function(i,o){if(i.width>0){var a=e.left,s=e.top,c=e.width,l=e.height-t[2].width;switch(o){case 0:l=t[0].width,i.args=h({c1:[a,s],c2:[a+c,s],c3:[a+c-t[1].width,s+l],c4:[a+t[3].width,s+l]},r[0],r[1],n.topLeftOuter,n.topLeftInner,n.topRightOuter,n.topRightInner);break;case 1:a=e.left+e.width-t[1].width,c=t[1].width,i.args=h({c1:[a+c,s],c2:[a+c,s+l+t[2].width],c3:[a,s+l],c4:[a,s+t[0].width]},r[1],r[2],n.topRightOuter,n.topRightInner,n.bottomRightOuter,n.bottomRightInner);break;case 2:s=s+e.height-t[2].width,l=t[2].width,i.args=h({c1:[a+c,s+l],c2:[a,s+l],c3:[a+t[3].width,s],c4:[a+c-t[3].width,s]},r[2],r[3],n.bottomRightOuter,n.bottomRightInner,n.bottomLeftOuter,n.bottomLeftInner);break;case 3:c=t[3].width,i.args=h({c1:[a,s+l+t[2].width],c2:[a,s],c3:[a+c,s+t[0].width],c4:[a+c,s+l]},r[3],r[0],n.bottomLeftOuter,n.bottomLeftInner,n.topLeftOuter,n.topLeftInner)}}return i})}function c(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,c=e+r;return{topLeft:u({x:t,y:c},{x:t,y:c-a},{x:s-o,y:e},{x:s,y:e}),topRight:u({x:t,y:e},{x:t+o,y:e},{x:s,y:c-a},{x:s,y:c}),bottomRight:u({x:s,y:e},{x:s,y:e+a},{x:t+o,y:c},{x:t,y:c}),bottomLeft:u({x:s,y:c},{x:s-o,y:c},{x:t,y:e+a},{x:t,y:e})}}function l(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,l=e[0][1]<a/2?e[0][1]:a/2,u=e[1][0]<o/2?e[1][0]:o/2,h=e[1][1]<a/2?e[1][1]:a/2,f=e[2][0]<o/2?e[2][0]:o/2,d=e[2][1]<a/2?e[2][1]:a/2,p=e[3][0]<o/2?e[3][0]:o/2,m=e[3][1]<a/2?e[3][1]:a/2,g=o-u,w=a-d,y=o-f,v=a-m;return{topLeftOuter:c(r,i,s,l).topLeft.subdivide(.5),topLeftInner:c(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,l-n[0].width)).topLeft.subdivide(.5),topRightOuter:c(r+g,i,u,h).topRight.subdivide(.5),topRightInner:c(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:u-n[3].width,h-n[0].width).topRight.subdivide(.5),bottomRightOuter:c(r+y,i+w,f,d).bottomRight.subdivide(.5),bottomRightInner:c(r+Math.min(y,o-n[3].width),i+Math.min(w,a+n[0].width),Math.max(0,f-n[1].width),d-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:c(r,i+v,p,m).bottomLeft.subdivide(.5),bottomLeftInner:c(r+n[3].width,i+v,Math.max(0,p-n[3].width),m-n[2].width).bottomLeft.subdivide(.5)}}function u(t,e,n,r){var i=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:t,startControl:e,endControl:n,end:r,subdivide:function(o){var a=i(t,e,o),s=i(e,n,o),c=i(n,r,o),l=i(a,s,o),h=i(s,c,o),f=i(l,h,o);return[u(t,a,l,f),u(f,h,c,r)]},curveTo:function(t){t.push(["bezierCurve",e.x,e.y,n.x,n.y,r.x,r.y])},curveToReversed:function(r){r.push(["bezierCurve",n.x,n.y,e.x,e.y,t.x,t.y])}}}function h(t,e,n,r,i,o,a){var s=[];return e[0]>0||e[1]>0?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),n[0]>0||n[1]>0?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),e[0]>0||e[1]>0?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function f(t,e,n,r,i,o,a){e[0]>0||e[1]>0?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(n[0]>0||n[1]>0)&&t.push(["line",i[0].start.x,i[0].start.y])}function d(t){return t.cssInt("zIndex")<0}function p(t){return t.cssInt("zIndex")>0}function m(t){return 0===t.cssInt("zIndex")}function g(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function w(t){return t instanceof G}function y(t){return t.node.data.trim().length>0}function v(t){return/^(normal|none|0px)$/.test(t.parent.css("letterSpacing"))}function b(t){return["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(e){var n=t.css("border"+e+"Radius").split(" ");return n.length<=1&&(n[1]=n[0]),n.map(O)})}function x(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function k(t){var e=t.css("position");return"auto"!==(-1!==["absolute","relative","fixed"].indexOf(e)?t.css("zIndex"):"auto")}function _(t){return"static"!==t.css("position")}function C(t){return"none"!==t.css("float")}function A(t){return-1!==["inline-block","inline-table"].indexOf(t.css("display"))}function S(t){var e=this;return function(){return!t.apply(e,arguments)}}function q(t){return t.node.nodeType===Node.ELEMENT_NODE}function T(t){return!0===t.isPseudoElement}function P(t){return t.node.nodeType===Node.TEXT_NODE}function I(t){return function(e,n){return e.cssInt("zIndex")+t.indexOf(e)/t.length-(n.cssInt("zIndex")+t.indexOf(n)/t.length)}}function E(t){return t.getOpacity()<1}function O(t){return parseInt(t,10)}function F(t){return t.width}function B(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function R(t){return[].concat.apply([],t)}function D(t){var e=t.substr(0,1);return e===t.substr(t.length-1)&&e.match(/'|"/)?t.substr(1,t.length-2):t}function j(t){for(var e,n=[],r=0,i=!1;t.length;)z(t[r])===i?((e=t.splice(0,r)).length&&n.push(M.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(M.ucs2.encode(e));return n}function z(t){return-1!==[32,13,10,9,45].indexOf(t)}function N(t){return/[^\u0000-\u00ff]/.test(t)}var L=t("./log"),M=t("punycode"),U=t("./nodecontainer"),H=t("./textcontainer"),W=t("./pseudoelementcontainer"),X=t("./fontmetrics"),V=t("./color"),G=t("./stackingcontext"),Y=t("./utils"),J=Y.bind,Q=Y.getBounds,K=Y.parseBackgrounds,$=Y.offsetBounds;r.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(q(t)){T(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=i(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,T(t)&&t.cleanDOM()}else P(t)&&(t.clip=i(t)?t.parent.clip:[]);T(t)||(t.bounds=null)},this)},r.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(J(function(){this.asyncRenderer(t,e)},this),0)},r.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},r.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},r.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},r.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return R(e)},r.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r=D(n.content),i="url"===r.substr(0,3),a=document.createElement(i?"img":"html2canvaspseudoelement"),s=new W(a,t,e),c=n.length-1;c>=0;c--){var l=o(n.item(c));a.style[l]=n[l]}if(a.className=W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,i)return a.src=K(r)[0].args[0],[s];var u=document.createTextNode(r);return a.appendChild(u),[s,new H(u,s)]},r.prototype.getChildren=function(t){return R([].filter.call(t.node.childNodes,x).map(function(e){var n=[e.nodeType===Node.TEXT_NODE?new H(e,t):new U(e,t)].filter(B);return e.nodeType===Node.ELEMENT_NODE&&n.length&&"TEXTAREA"!==e.tagName?n[0].isElementVisible()?n.concat(this.getChildren(n[0])):[]:n},this))},r.prototype.newStackingContext=function(t,e){var n=new G(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},r.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){q(t)&&(this.isRootElement(t)||E(t)||k(t)||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):q(t)&&(_(t)&&m(t)||A(t)||C(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},r.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},r.prototype.isRootElement=function(t){return null===t.parent},r.prototype.sortStackingContexts=function(t){t.contexts.sort(I(t.contexts.slice(0))),t.contexts.forEach(this.sortStackingContexts,this)},r.prototype.parseTextBounds=function(t){return function(e,n,r){if("none"!==t.parent.css("textDecoration").substr(0,4)||0!==e.trim().length){if(this.support.rangeBounds&&!t.parent.hasTransform()){var i=r.slice(0,n).join("").length;return this.getRangeBounds(t.node,i,e.length)}if(t.node&&"string"==typeof t.node.data){var o=t.node.splitText(e.length),a=this.getWrapperBounds(t.node,t.parent.hasTransform());return t.node=o,a}}else this.support.rangeBounds&&!t.parent.hasTransform()||(t.node=t.node.splitText(e.length));return{}}},r.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?$(n):Q(n);return r.replaceChild(i,n),o},r.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},r.prototype.parse=function(t){var e=t.contexts.filter(d),n=t.children.filter(q),r=n.filter(S(C)),i=r.filter(S(_)).filter(S(g)),o=n.filter(S(_)).filter(C),s=r.filter(S(_)).filter(g),c=t.contexts.concat(r.filter(_)).filter(m),l=t.children.filter(P).filter(y),u=t.contexts.filter(p);e.concat(i).concat(o).concat(s).concat(c).concat(l).concat(u).forEach(function(t){this.renderQueue.push(t),w(t)&&(this.parse(t),this.renderQueue.push(new a))},this)},r.prototype.paint=function(t){try{t instanceof a?this.renderer.ctx.restore():P(t)?(T(t.parent)&&t.parent.appendToDOM(),this.paintText(t),T(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(L(t),this.options.strict)throw t}},r.prototype.paintNode=function(t){w(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},r.prototype.paintElement=function(t){var e=t.parseBounds();this.renderer.clip(t.backgroundClip,function(){this.renderer.renderBackground(t,e,t.borders.borders.map(F))},this),this.renderer.clip(t.clip,function(){this.renderer.renderBorders(t.borders.borders)},this),this.renderer.clip(t.backgroundClip,function(){switch(t.node.nodeName){case"svg":case"IFRAME":var n=this.images.get(t.node);n?this.renderer.renderImage(t,e,t.borders,n):L("Error loading <"+t.node.nodeName+">",t.node);break;case"IMG":var r=this.images.get(t.node.src);r?this.renderer.renderImage(t,e,t.borders,r):L("Error loading <img>",t.node.src);break;case"CANVAS":this.renderer.renderImage(t,e,t.borders,{image:t.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(t)}},this)},r.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new V("#A5A5A5"),width:t}}),c=l(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new V("#DEDEDE")),this.renderer.renderBorders(s(a,r,c,o)),t.node.checked&&(this.renderer.font(new V("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},r.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new V("#DEDEDE"),1,new V("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new V("#424242"))},this)},r.prototype.paintFormValue=function(t){var e=t.getValue();if(e.length>0){var n=t.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(e){try{r.style[e]=t.css(e)}catch(t){L("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=t.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=e,n.body.appendChild(r),this.paintText(new H(r.firstChild,t)),n.body.removeChild(r)}},r.prototype.paintText=function(t){t.applyTextTransform();var e=M.ucs2.decode(t.node.data),n=this.options.letterRendering&&!v(t)||N(t.node.data)?e.map(function(t){return M.ucs2.encode([t])}):j(e),r=t.parent.fontWeight(),i=t.parent.css("fontSize"),o=t.parent.css("fontFamily"),a=t.parent.parseTextShadows();this.renderer.font(t.parent.color("color"),t.parent.css("fontStyle"),t.parent.css("fontVariant"),r,i,o),a.length?this.renderer.fontShadow(a[0].color,a[0].offsetX,a[0].offsetY,a[0].blur):this.renderer.clearShadow(),this.renderer.clip(t.parent.clip,function(){n.map(this.parseTextBounds(t),this).forEach(function(e,r){e&&(this.renderer.text(n[r],e.left,e.bottom),this.renderTextDecoration(t.parent,e,this.fontMetrics.getMetrics(o,i)))},this)},this)},r.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var Z={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};r.prototype.parseBorders=function(t){var e=t.parseBounds(),n=b(t),r=["Top","Right","Bottom","Left"].map(function(e,n){var r=t.css("border"+e+"Style"),i=t.color("border"+e+"Color");"inset"===r&&i.isBlack()&&(i=new V([255,255,255,i.a]));var o=Z[r]?Z[r][n]:null;return{width:t.cssInt("border"+e+"Width"),color:o?i[o[0]](o[1]):i,args:null}}),i=l(e,n,r);return{clip:this.parseBackgroundClip(t,i,r,n,e),borders:s(r,e,i,n)}},r.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":f(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),f(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),f(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),f(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:f(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),f(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),f(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),f(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=r},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){function r(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var s=o(r),l=a(e,t,s);return r?c(l):i(n,l,s).then(function(t){return f(t.content)})}function i(t,e,n){return new Promise(function(r,i){var o=t.createElement("script"),a=function(){delete window.html2canvas.proxy[n],t.body.removeChild(o)};window.html2canvas.proxy[n]=function(t){a(),r(t)},o.src=e,o.onerror=function(t){a(),i(t)},t.body.appendChild(o)})}function o(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++d+"_"+Math.round(1e5*Math.random())}function a(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}function s(t){return function(e){var n,r=new DOMParser;try{n=r.parseFromString(e,"text/html")}catch(t){u("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){u("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var i=n.querySelector("base");if(!i||!i.href.host){var o=n.createElement("base");o.href=t,n.head.insertBefore(o,n.head.firstChild)}return n}}var c=t("./xhr"),l=t("./utils"),u=t("./log"),h=t("./clone"),f=l.decode64,d=0;n.Proxy=r,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,s=o(r),c=a(e,t,s);return r?Promise.resolve(c):i(n,c,s).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,i,o,a){return new r(t,e,window.document).then(s(t)).then(function(t){return h(t,n,i,o,a,0,0)})}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var r=t("./proxy").ProxyURL;e.exports=function(t,e){var n=document.createElement("a");n.href=t,t=n.href,this.src=t,this.image=new Image;var i=this;this.promise=new Promise(function(n,o){i.image.crossOrigin="Anonymous",i.image.onload=n,i.image.onerror=o,new r(t,e,document).then(function(t){i.image.src=t}).catch(o)})}},{"./proxy":16}],18:[function(t,e,n){function r(t,e,n){i.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}var i=t("./nodecontainer");r.prototype.cloneTo=function(t){r.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(r.prototype=Object.create(i.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},r.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},r.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=r},{"./nodecontainer":14}],19:[function(t,e,n){function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}var i=t("./log");r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),c=n.borders,l=e.width-(c[1].width+c[3].width+i+a),u=e.height-(c[0].width+c[2].width+o+s);this.drawImage(r,0,0,r.image.width||l,r.image.height||u,e.left+i+c[3].width,e.top+o+c[0].width,l,u)},r.prototype.renderBackground=function(t,e,n){e.height>0&&e.width>0&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(t,e,n){t.parseBackgroundImages().reverse().forEach(function(r,o,a){switch(r.method){case"url":var s=this.images.get(r.args[0]);s?this.renderBackgroundRepeating(t,e,s,a.length-(o+1),n):i("Error loading background-image",r.args[0]);break;case"linear-gradient":case"gradient":var c=this.images.get(r.value);c?this.renderBackgroundGradient(c,e,n):i("Error loading background-image",r.args[0]);break;case"none":break;default:i("Unknown background-image type",r.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){function r(t,e){o.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},s("Initialized CanvasRenderer with size",t,"x",e)}function i(t){return t.length>0}var o=t("../renderer"),a=t("../lineargradientcontainer"),s=t("../log");(r.prototype=Object.create(o.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},r.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},r.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},r.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},r.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},r.prototype.taints=function(t){if(null===t.tainted){this.taintCtx.drawImage(t.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),t.tainted=!1}catch(e){this.taintCtx=document.createElement("canvas").getContext("2d"),t.tainted=!0}}return t.tainted},r.prototype.drawImage=function(t,e,n,r,i,o,a,s,c){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,c)},r.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(i).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},r.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},r.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},r.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},r.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},r.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},r.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},r.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},r.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},r.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,c){var l=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([l],function(){this.renderBackgroundRepeat(t,e,n,r,c[3],c[0])},this)},r.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},r.prototype.renderBackgroundGradient=function(t,e){if(t instanceof a){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},r.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=r},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}var i=t("./nodecontainer");(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){function r(t){this.src=t,this.image=null;var e=this;this.promise=this.hasFabric().then(function(){return e.isInline(t)?Promise.resolve(e.inlineFormatting(t)):i(t)}).then(function(t){return new Promise(function(n){window.html2canvas.svg.fabric.loadSVGFromString(t,e.createCanvas.call(e,n))})})}var i=t("./xhr"),o=t("./utils").decode64;r.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},r.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},r.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},r.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},r.prototype.createCanvas=function(t){var e=this;return function(n,r){var i=new window.html2canvas.svg.fabric.StaticCanvas("c");e.image=i.lowerCanvasEl,i.setWidth(r.width).setHeight(r.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(n,r)).renderAll(),t(i.lowerCanvasEl)}},r.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):o(t)},e.exports=r},{"./utils":26,"./xhr":28}],24:[function(t,e,n){function r(t,e){this.src=t,this.image=null;var n=this;this.promise=e?new Promise(function(e,r){n.image=new Image,n.image.onload=e,n.image.onerror=r,n.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(t),!0===n.image.complete&&e(n.image)}):this.hasFabric().then(function(){return new Promise(function(e){window.html2canvas.svg.fabric.parseSVGDocument(t,n.createCanvas.call(n,e))})})}var i=t("./svgcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./svgcontainer":23}],25:[function(t,e,n){function r(t,e){o.call(this,t,e)}function i(t,e,n){if(t.length>0)return e+n.toUpperCase()}var o=t("./nodecontainer");(r.prototype=Object.create(o.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},r.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,i);case"uppercase":return e.toUpperCase();default:return e}},e.exports=r},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
n.decode64=function(t){var e,n,r,i,o,a,s,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=t.length,u="";for(e=0;e<l;e+=4)o=c.indexOf(t[e])<<2|(n=c.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=c.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=c.indexOf(t[e+3])),u+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return u},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,c=[],l=0,u=0,h=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&(i=e.indexOf("-",1)+1)>0&&(r=e.substr(0,i),e=e.substr(i)),c.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===l&&" \r\n\t".indexOf(t)>-1)){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===l)return l=1,void(o+=t);u++;break;case")":if(a)break;if(1===l){if(0===u)return l=0,o+=t,void h();u--}break;case",":if(a)break;if(0===l)return void h();if(1===l&&0===u&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===l?e+=t:n+=t}}),h(),c}},{}],27:[function(t,e,n){function r(t){i.apply(this,arguments),this.type="linear"===t.args[0]?i.TYPES.LINEAR:i.TYPES.RADIAL}var i=t("./gradientcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(t){return new Promise(function(e,n){var r=new XMLHttpRequest;r.open("GET",t),r.onload=function(){200===r.status?e(r.responseText):n(new Error(r.statusText))},r.onerror=function(){n(new Error("Network Error"))},r.send()})}},{}]},{},[4])(4)}),/*
# PNG.js
# Copyright (c) 2011 Devon Govett
# MIT LICENSE
# 
# 
*/
function(t){var e;e=function(){function e(t){var e,n,r,i,o,a,s,c,l,u,h,f,d,p,m;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],s=t=0;t<4;s=++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,s=d=0;0<=e?d<e:d>e;s=0<=e?++d:--d)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if((h=r-this.transparency.indexed.length)>0)for(s=p=0;0<=h?p<h:p>h;s=0<=h?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":c=(f=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,f.slice(0,c)),this.text[l]=String.fromCharCode.apply(String,f.slice(c+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(m=this.colorType)||6===m,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}var n,r,i;e.load=function(t,n,r){var i;return"function"==typeof n&&(r=n),(i=new XMLHttpRequest).open("GET",t,!0),i.responseType="arraybuffer",i.onload=function(){var t,o;return t=new Uint8Array(i.response||i.mozResponseArrayBuffer),o=new e(t),"function"==typeof(null!=n?n.getContext:void 0)&&o.render(n),"function"==typeof r?r(o):void 0},i.send(null)},e.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},e.prototype.readUInt32=function(){var t,e,n,r;return t=this.data[this.pos++]<<24,e=this.data[this.pos++]<<16,n=this.data[this.pos++]<<8,r=this.data[this.pos++],t|e|n|r},e.prototype.readUInt16=function(){var t,e;return t=this.data[this.pos++]<<8,e=this.data[this.pos++],t|e},e.prototype.decodePixels=function(t){var e,n,r,i,o,a,c,l,u,h,f,d,p,m,g,w,y,v,b,x,k,_,C;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);for(t=(t=new s(t)).getBytes(),w=(d=this.pixelBitlength/8)*this.width,p=new Uint8Array(w*this.height),a=t.length,g=0,m=0,n=0;m<a;){switch(t[m++]){case 0:for(i=b=0;b<w;i=b+=1)p[n++]=t[m++];break;case 1:for(i=x=0;x<w;i=x+=1)e=t[m++],o=i<d?0:p[n-d],p[n++]=(e+o)%256;break;case 2:for(i=k=0;k<w;i=k+=1)e=t[m++],r=(i-i%d)/d,y=g&&p[(g-1)*w+r*d+i%d],p[n++]=(y+e)%256;break;case 3:for(i=_=0;_<w;i=_+=1)e=t[m++],r=(i-i%d)/d,o=i<d?0:p[n-d],y=g&&p[(g-1)*w+r*d+i%d],p[n++]=(e+Math.floor((o+y)/2))%256;break;case 4:for(i=C=0;C<w;i=C+=1)e=t[m++],r=(i-i%d)/d,o=i<d?0:p[n-d],0===g?y=v=0:(y=p[(g-1)*w+r*d+i%d],v=r&&p[(g-1)*w+(r-1)*d+i%d]),c=o+y-v,l=Math.abs(c-o),h=Math.abs(c-y),f=Math.abs(c-v),u=l<=h&&l<=f?o:h<=f?y:v,p[n++]=(e+u)%256;break;default:throw new Error("Invalid filter algorithm: "+t[m-1])}g++}return p},e.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,c;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,t=0,e=a=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(c=o[t++])?c:255;return i},e.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,c,l,u,h,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),i=t.data||t,l=i.length,a=u||e,o=s=0,1===r)for(;o<l;)c=u?4*e[o/4]:s,h=a[c++],i[o++]=h,i[o++]=h,i[o++]=h,i[o++]=n?a[c++]:255,s=c;else for(;o<l;)c=u?4*e[o/4]:s,i[o++]=a[c++],i[o++]=a[c++],i[o++]=a[c++],i[o++]=n?a[c++]:255,s=c},e.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{r=t.document.createElement("canvas"),i=r.getContext("2d")}catch(t){return-1}return n=function(t){var e;return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),e=new Image,e.src=r.toDataURL(),e},e.prototype.decodeFrames=function(t){var e,r,i,o,a,s,c,l;if(this.animation){for(l=[],r=a=0,s=(c=this.animation.frames).length;a<s;r=++a)e=c[r],i=t.createImageData(e.width,e.height),o=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(i,o),e.imageData=i,l.push(e.image=n(i));return l}},e.prototype.renderFrame=function(t,e){var n,r,i;return r=this.animation.frames,n=r[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},e.prototype.animate=function(t){var e,n,r,i,o,a,s=this;return n=0,a=this.animation,i=a.numFrames,r=a.frames,o=a.numPlays,(e=function(){var a,c;if(a=n++%i,c=r[a],s.renderFrame(t,a),i>1&&n/i<o)return s.animation._timeout=setTimeout(e,c.delay)})()},e.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},e.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},e}(),t.PNG=e}("undefined"!=typeof window&&window||void 0);/*
 * Extracted from pdf.js
 * https://github.com/andreasgal/pdf.js
 *
 * Copyright (c) 2011 Mozilla Foundation
 *
 * Contributors: Andreas Gal <gal@mozilla.com>
 *               Chris G Jones <cjones@mozilla.com>
 *               Shaon Barman <shaon.barman@gmail.com>
 *               Vivien Nicolas <21@vingtetun.org>
 *               Justin D'Arcangelo <justindarc@gmail.com>
 *               Yury Delendik
 *
 * 
 */
var a=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(r=e+t;!this.eof&&this.bufferLength<r;)this.readBlock();var n=this.bufferLength;r>n&&(r=n)}else{for(;!this.eof;)this.readBlock();var r=this.bufferLength}return this.pos=r,this.buffer.subarray(e,r)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),s=function(){function t(t){throw new Error(t)}function e(e){var n=0,r=e[n++],i=e[n++];-1!=r&&-1!=i||t("Invalid header in flate stream"),8!=(15&r)&&t("Unknown compression method in flate stream"),((r<<8)+i)%31!=0&&t("Bad FCHECK in flate stream"),32&i&&t("FDICT bit set in flate stream"),this.bytes=e,this.bytesPos=n,this.codeSize=0,this.codeBuf=0,a.call(this)}if("undefined"!=typeof Uint32Array){var n=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),r=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),i=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),o=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],s=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return e.prototype=Object.create(a.prototype),e.prototype.getBits=function(e){for(var n,r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<e;)void 0===(n=o[a++])&&t("Bad encoding in flate stream"),i|=n<<r,r+=8;return n=i&(1<<e)-1,this.codeBuf=i>>e,this.codeSize=r-=e,this.bytesPos=a,n},e.prototype.getCode=function(e){for(var n=e[0],r=e[1],i=this.codeSize,o=this.codeBuf,a=this.bytes,s=this.bytesPos;i<r;){var c;void 0===(c=a[s++])&&t("Bad encoding in flate stream"),o|=c<<i,i+=8}var l=n[o&(1<<r)-1],u=l>>16,h=65535&l;return(0==i||i<u||0==u)&&t("Bad encoding in flate stream"),this.codeBuf=o>>u,this.codeSize=i-u,this.bytesPos=s,h},e.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,c=2;a<=n;++a,s<<=1,c<<=1)for(var l=0;l<e;++l)if(t[l]==a){for(var u=0,h=s,r=0;r<a;++r)u=u<<1|1&h,h>>=1;for(r=u;r<i;r+=c)o[r]=a<<16|l;++s}return[o,n]},e.prototype.readBlock=function(){function e(t,e,n,r,i){for(var o=t.getBits(n)+r;o-- >0;)e[p++]=i}var a=this.getBits(3);if(1&a&&(this.eof=!0),0!=(a>>=1)){var c,l;if(1==a)c=o,l=s;else if(2==a){for(var u=this.getBits(5)+257,h=this.getBits(5)+1,f=this.getBits(4)+4,d=Array(n.length),p=0;p<f;)d[n[p++]]=this.getBits(3);for(var m=this.generateHuffmanTable(d),g=0,p=0,w=u+h,y=new Array(w);p<w;){var v=this.getCode(m);16==v?e(this,y,2,3,g):17==v?e(this,y,3,3,g=0):18==v?e(this,y,7,11,g=0):y[p++]=g=v}c=this.generateHuffmanTable(y.slice(0,u)),l=this.generateHuffmanTable(y.slice(u,w))}else t("Unknown block type in flate stream");for(var b=(O=this.buffer)?O.length:0,x=this.bufferLength;;){var k=this.getCode(c);if(k<256)x+1>=b&&(b=(O=this.ensureBuffer(x+1)).length),O[x++]=k;else{if(256==k)return void(this.bufferLength=x);var _=(k=r[k-=257])>>16;_>0&&(_=this.getBits(_));g=(65535&k)+_;k=this.getCode(l),(_=(k=i[k])>>16)>0&&(_=this.getBits(_));var C=(65535&k)+_;x+g>=b&&(b=(O=this.ensureBuffer(x+g)).length);for(var A=0;A<g;++A,++x)O[x]=O[x-C]}}}else{var S,q=this.bytes,T=this.bytesPos;void 0===(S=q[T++])&&t("Bad block header in flate stream");var P=S;void 0===(S=q[T++])&&t("Bad block header in flate stream"),P|=S<<8,void 0===(S=q[T++])&&t("Bad block header in flate stream");var I=S;void 0===(S=q[T++])&&t("Bad block header in flate stream"),(I|=S<<8)!=(65535&~P)&&t("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var E=this.bufferLength,O=this.ensureBuffer(E+P),F=E+P;this.bufferLength=F;for(var B=E;B<F;++B){if(void 0===(S=q[T++])){this.eof=!0;break}O[B]=S}this.bytesPos=T}},e}}();return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var n,r,i,o,a,s=0,c=0,l="",u=[];if(!t)return t;do{n=(a=t.charCodeAt(s++)<<16|t.charCodeAt(s++)<<8|t.charCodeAt(s++))>>18&63,r=a>>12&63,i=a>>6&63,o=63&a,u[c++]=e.charAt(n)+e.charAt(r)+e.charAt(i)+e.charAt(o)}while(s<t.length);l=u.join("");var h=t.length%3;return(h?l.slice(0,h-3):l)+"===".slice(h||3)}),void 0===t.atob&&(t.atob=function(t){var n,r,i,o,a,s,c=0,l=0,u=[];if(!t)return t;t+="";do{n=(s=e.indexOf(t.charAt(c++))<<18|e.indexOf(t.charAt(c++))<<12|(o=e.indexOf(t.charAt(c++)))<<6|(a=e.indexOf(t.charAt(c++))))>>16&255,r=s>>8&255,i=255&s,u[l++]=64==o?String.fromCharCode(n):64==a?String.fromCharCode(n,r):String.fromCharCode(n,r,i)}while(c<t.length);return u.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=arguments.length>1?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=function(){var t=Object.prototype.hasOwnProperty,e=!{toString:null}.propertyIsEnumerable("toString"),n=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],r=n.length;return function(i){if("object"!=typeof i&&("function"!=typeof i||null===i))throw new TypeError;var o,a,s=[];for(o in i)t.call(i,o)&&s.push(o);if(e)for(a=0;a<r;a++)t.call(i,n[a])&&s.push(n[a]);return s}}()),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0),e});
/*!
 * jsPDF AutoTable plugin v2.3.2
 * Copyright (c) 2014 Simon Bengtsson, https://github.com/simonbengtsson/jsPDF-AutoTable 
 * 
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * 
 * */if (typeof window === 'object') window.jspdfAutoTableVersion = '2.3.2';/*
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jspdf"));
	else if(typeof define === 'function' && define.amd)
		define(["jspdf"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jspdf")) : factory(root["jsPDF"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_19__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 35);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
/**
 * Ratio between font size and font height. The number comes from jspdf's source code
 */
exports.FONT_ROW_RATIO = 1.15;
var models_1 = __webpack_require__(16);
var table = null;
var assign = __webpack_require__(13);
var entries = __webpack_require__(33);
/**
 * Styles for the themes (overriding the default styles)
 */
exports.getTheme = function (name) {
    var themes = {
        'striped': {
            table: { fillColor: 255, textColor: 80, fontStyle: 'normal' },
            header: { textColor: 255, fillColor: [41, 128, 185], fontStyle: 'bold' },
            body: {},
            alternateRow: { fillColor: 245 }
        },
        'grid': {
            table: { fillColor: 255, textColor: 80, fontStyle: 'normal', lineWidth: 0.1 },
            header: { textColor: 255, fillColor: [26, 188, 156], fontStyle: 'bold', lineWidth: 0 },
            body: {},
            alternateRow: {}
        },
        'plain': {
            header: { fontStyle: 'bold' }
        }
    };
    return themes[name];
};
function getDefaults() {
    var scaleFactor = Config.scaleFactor();
    return {
        // Styling
        theme: 'striped',
        styles: {},
        headerStyles: {},
        bodyStyles: {},
        alternateRowStyles: {},
        columnStyles: {},
        // Properties
        startY: false,
        margin: 40 / scaleFactor,
        pageBreak: 'auto',
        tableWidth: 'auto',
        showHeader: 'everyPage',
        tableLineWidth: 0,
        tableLineColor: 200,
        // Hooks
        createdHeaderCell: function (cell, data) { },
        createdCell: function (cell, data) { },
        drawHeaderRow: function (row, data) { },
        drawRow: function (row, data) { },
        drawHeaderCell: function (cell, data) { },
        drawCell: function (cell, data) { },
        addPageContent: function (data) { }
    };
}
exports.getDefaults = getDefaults;
// Base style for all themes
function defaultStyles() {
    var scaleFactor = Config.scaleFactor();
    return {
        font: "helvetica",
        fontStyle: 'normal',
        overflow: 'ellipsize',
        fillColor: false,
        textColor: 20,
        halign: 'left',
        valign: 'top',
        fontSize: 10,
        cellPadding: 5 / scaleFactor,
        lineColor: 200,
        lineWidth: 0 / scaleFactor,
        columnWidth: 'auto'
    };
}
var Config = (function () {
    function Config() {
    }
    Config.pageSize = function () {
        return table.doc.internal.pageSize;
    };
    Config.applyUserStyles = function () {
        Config.applyStyles(table.userStyles);
    };
    Config.createTable = function (doc) {
        table = new models_1.Table(doc);
        return table;
    };
    Config.tableInstance = function () {
        return table;
    };
    Config.scaleFactor = function () {
        return table.doc.internal.scaleFactor;
    };
    Config.hooksData = function (additionalData) {
        if (additionalData === void 0) { additionalData = {}; }
        return assign({
            pageCount: table.pageCount,
            settings: table.settings,
            table: table,
            doc: table.doc,
            cursor: table.cursor
        }, additionalData || {});
    };
    Config.initSettings = function (table, allOptions) {
        var _loop_1 = function (styleProp) {
            var styles = allOptions.map(function (opts) { return opts[styleProp] || {}; });
            table.styles[styleProp] = assign.apply(void 0, [{}].concat(styles));
        };
        // Merge styles one level deeper
        for (var _i = 0, _a = Object.keys(table.styles); _i < _a.length; _i++) {
            var styleProp = _a[_i];
            _loop_1(styleProp);
        }
        // Append event handlers instead of replacing them
        for (var _b = 0, _c = entries(table.hooks); _b < _c.length; _b++) {
            var _d = _c[_b], hookName = _d[0], list = _d[1];
            for (var _e = 0, allOptions_1 = allOptions; _e < allOptions_1.length; _e++) {
                var opts = allOptions_1[_e];
                if (opts && opts[hookName]) {
                    list.push(opts[hookName]);
                }
            }
        }
        // Merge all other options one level
        table.settings = assign.apply(void 0, [getDefaults()].concat(allOptions));
    };
    // This is messy, only keep array and number format the next major version
    Config.marginOrPadding = function (value, defaultValue) {
        var newValue = {};
        if (Array.isArray(value)) {
            if (value.length >= 4) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[2], 'left': value[3] };
            }
            else if (value.length === 3) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[2], 'left': value[1] };
            }
            else if (value.length === 2) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[0], 'left': value[1] };
            }
            else if (value.length === 1) {
                value = value[0];
            }
            else {
                value = defaultValue;
            }
        }
        else if (typeof value === 'object') {
            if (value['vertical']) {
                value['top'] = value['vertical'];
                value['bottom'] = value['vertical'];
            }
            else if (value['horizontal']) {
                value['right'] = value['horizontal'];
                value['left'] = value['horizontal'];
            }
            for (var _i = 0, _a = ['top', 'right', 'bottom', 'left']; _i < _a.length; _i++) {
                var side = _a[_i];
                newValue[side] = value[side] || value[side] === 0 ? value[side] : defaultValue;
            }
        }
        if (typeof value === 'number') {
            newValue = { 'top': value, 'right': value, 'bottom': value, 'left': value };
        }
        return newValue;
    };
    Config.styles = function (styles) {
        styles = Array.isArray(styles) ? styles : [styles];
        return assign.apply(void 0, [defaultStyles()].concat(styles));
    };
    Config.applyStyles = function (styles) {
        var doc = table.doc;
        var styleModifiers = {
            fillColor: doc.setFillColor,
            textColor: doc.setTextColor,
            fontStyle: doc.setFontStyle,
            lineColor: doc.setDrawColor,
            lineWidth: doc.setLineWidth,
            font: doc.setFont,
            fontSize: doc.setFontSize
        };
        Object.keys(styleModifiers).forEach(function (name) {
            var style = styles[name];
            var modifier = styleModifiers[name];
            if (typeof style !== 'undefined') {
                if (Array.isArray(style)) {
                    modifier.apply(this, style);
                }
                else {
                    modifier(style);
                }
            }
        });
    };
    return Config;
}());
exports.Config = Config;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var painter_1 = __webpack_require__(4);
function getStringWidth(text, styles) {
    var k = config_1.Config.scaleFactor();
    var fontSize = styles.fontSize / k;
    config_1.Config.applyStyles(styles);
    text = Array.isArray(text) ? text : [text];
    var maxWidth = 0;
    text.forEach(function (line) {
        var width = config_1.Config.tableInstance().doc.getStringUnitWidth(line);
        if (width > maxWidth) {
            maxWidth = width;
        }
    });
    var precision = 10000 * k;
    maxWidth = Math.floor(maxWidth * precision) / precision;
    return maxWidth * fontSize;
}
exports.getStringWidth = getStringWidth;
/**
 * Ellipsize the text to fit in the width
 */
function ellipsize(text, width, styles, ellipsizeStr) {
    if (ellipsizeStr === void 0) { ellipsizeStr = '...'; }
    if (Array.isArray(text)) {
        var value_1 = [];
        text.forEach(function (str, i) {
            value_1[i] = ellipsize(str, width, styles, ellipsizeStr);
        });
        return value_1;
    }
    var precision = 10000 * config_1.Config.scaleFactor();
    width = Math.ceil(width * precision) / precision;
    if (width >= getStringWidth(text, styles)) {
        return text;
    }
    while (width < getStringWidth(text + ellipsizeStr, styles)) {
        if (text.length <= 1) {
            break;
        }
        text = text.substring(0, text.length - 1);
    }
    return text.trim() + ellipsizeStr;
}
exports.ellipsize = ellipsize;
function addTableBorder() {
    var table = config_1.Config.tableInstance();
    var styles = { lineWidth: table.settings.tableLineWidth, lineColor: table.settings.tableLineColor };
    config_1.Config.applyStyles(styles);
    var fs = getFillStyle(styles);
    if (fs) {
        table.doc.rect(table.pageStartX, table.pageStartY, table.width, table.cursor.y - table.pageStartY, fs);
    }
}
exports.addTableBorder = addTableBorder;
function addPage() {
    var table = config_1.Config.tableInstance();
    table.finalY = table.cursor.y;
    // Add user content just before adding new page ensure it will 
    // be drawn above other things on the page
    addContentHooks();
    addTableBorder();
    nextPage(table.doc);
    table.pageCount++;
    table.cursor = { x: table.margin('left'), y: table.margin('top') };
    table.pageStartX = table.cursor.x;
    table.pageStartY = table.cursor.y;
    if (table.settings.showHeader === true || table.settings.showHeader === 'everyPage') {
        painter_1.printRow(table.headerRow, table.hooks.drawHeaderRow, table.hooks.drawHeaderCell);
    }
}
exports.addPage = addPage;
function addContentHooks() {
    for (var _i = 0, _a = config_1.Config.tableInstance().hooks.addPageContent; _i < _a.length; _i++) {
        var hook = _a[_i];
        config_1.Config.applyUserStyles();
        hook(config_1.Config.hooksData());
    }
    config_1.Config.applyUserStyles();
}
exports.addContentHooks = addContentHooks;
function getFillStyle(styles) {
    var drawLine = styles.lineWidth > 0;
    var drawBackground = styles.fillColor || styles.fillColor === 0;
    if (drawLine && drawBackground) {
        return 'DF'; // Fill then stroke
    }
    else if (drawLine) {
        return 'S'; // Only stroke (transparent background)
    }
    else if (drawBackground) {
        return 'F'; // Only fill, no stroke
    }
    else {
        return false;
    }
}
exports.getFillStyle = getFillStyle;
function nextPage(doc) {
    var current = doc.internal.getCurrentPageInfo().pageNumber;
    doc.setPage(current + 1);
    var newCurrent = doc.internal.getCurrentPageInfo().pageNumber;
    if (newCurrent === current) {
        doc.addPage();
    }
}
exports.nextPage = nextPage;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var implementation = __webpack_require__(27);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(1);
function printFullRow(row, drawRowHooks, drawCellHooks) {
    var remainingRowHeight = 0;
    var remainingTexts = {};
    var table = config_1.Config.tableInstance();
    if (!canFitOnPage(row.height)) {
        if (row.maxLineCount <= 1) {
            common_1.addPage();
        }
        else {
            // Modify the row to fit the current page and calculate text and height of partial row
            row.spansMultiplePages = true;
            var pageHeight = table.doc.internal.pageSize.height;
            var maxCellHeight = 0;
            for (var j = 0; j < table.columns.length; j++) {
                var col = table.columns[j];
                var cell = row.cells[col.dataKey];
                var fontHeight = cell.styles.fontSize / config_1.Config.scaleFactor() * config_1.FONT_ROW_RATIO;
                var vPadding = cell.padding('vertical');
                var remainingPageSpace = pageHeight - table.cursor.y - table.margin('bottom');
                var remainingLineCount = Math.floor((remainingPageSpace - vPadding) / fontHeight);
                if (Array.isArray(cell.text) && cell.text.length > remainingLineCount) {
                    var remainingLines = cell.text.splice(remainingLineCount, cell.text.length);
                    remainingTexts[col.dataKey] = remainingLines;
                    var cellHeight = cell.text.length * fontHeight + vPadding;
                    if (cellHeight > maxCellHeight) {
                        maxCellHeight = cellHeight;
                    }
                    var rCellHeight = remainingLines.length * fontHeight + vPadding;
                    if (rCellHeight > remainingRowHeight) {
                        remainingRowHeight = rCellHeight;
                    }
                }
            }
            // Reset row height since text are now removed
            row.height = maxCellHeight;
        }
    }
    printRow(row, drawRowHooks, drawCellHooks);
    // Parts of the row is now printed. Time for adding a new page, prune 
    // the text and start over
    if (Object.keys(remainingTexts).length > 0) {
        for (var j = 0; j < table.columns.length; j++) {
            var col = table.columns[j];
            var cell = row.cells[col.dataKey];
            cell.text = remainingTexts[col.dataKey] || '';
        }
        common_1.addPage();
        row.pageCount++;
        row.height = remainingRowHeight;
        printFullRow(row, drawRowHooks, drawCellHooks);
    }
}
exports.printFullRow = printFullRow;
function printRow(row, drawRowHooks, drawCellHooks) {
    var table = config_1.Config.tableInstance();
    row.y = table.cursor.y;
    for (var _i = 0, drawRowHooks_1 = drawRowHooks; _i < drawRowHooks_1.length; _i++) {
        var hook = drawRowHooks_1[_i];
        if (hook(row, config_1.Config.hooksData({ row: row, addPage: common_1.addPage })) === false) {
            return;
        }
    }
    table.cursor.x = table.margin('left');
    for (var i = 0; i < table.columns.length; i++) {
        var column = table.columns[i];
        var cell = row.cells[column.dataKey];
        if (!cell) {
            continue;
        }
        config_1.Config.applyStyles(cell.styles);
        cell.x = table.cursor.x;
        cell.y = table.cursor.y;
        cell.height = row.height;
        cell.width = column.width;
        if (cell.styles.valign === 'top') {
            cell.textPos.y = table.cursor.y + cell.padding('top');
        }
        else if (cell.styles.valign === 'bottom') {
            cell.textPos.y = table.cursor.y + row.height - cell.padding('bottom');
        }
        else {
            cell.textPos.y = table.cursor.y + row.height / 2;
        }
        if (cell.styles.halign === 'right') {
            cell.textPos.x = cell.x + cell.width - cell.padding('right');
        }
        else if (cell.styles.halign === 'center') {
            cell.textPos.x = cell.x + cell.width / 2;
        }
        else {
            cell.textPos.x = cell.x + cell.padding('left');
        }
        var shouldDrawCell = true;
        var data = config_1.Config.hooksData({ column: column, row: row, addPage: common_1.addPage });
        for (var _a = 0, drawCellHooks_1 = drawCellHooks; _a < drawCellHooks_1.length; _a++) {
            var hook = drawCellHooks_1[_a];
            if (hook(cell, data) === false) {
                shouldDrawCell = false;
            }
        }
        if (shouldDrawCell) {
            var fillStyle = common_1.getFillStyle(cell.styles);
            if (fillStyle) {
                table.doc.rect(cell.x, cell.y, cell.width, cell.height, fillStyle);
            }
            table.doc.autoTableText(cell.text, cell.textPos.x, cell.textPos.y, {
                halign: cell.styles.halign,
                valign: cell.styles.valign
            });
        }
        table.cursor.x += cell.width;
    }
    table.cursor.y += row.height;
}
exports.printRow = printRow;
function canFitOnPage(rowHeight) {
    var table = config_1.Config.tableInstance();
    var pos = rowHeight + table.cursor.y + table.margin('bottom');
    return pos < config_1.Config.pageSize().height;
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(31);
var foreach = __webpack_require__(26);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var has = Object.prototype.hasOwnProperty;
module.exports = Object.assign || function assign(target, source) {
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(2);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(22);
var has = __webpack_require__(12);
var bind = __webpack_require__(2);
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

module.exports = function entries(O) {
	var obj = ES.RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(14);

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
exports.table = {};
var Table = (function () {
    function Table(doc) {
        this.height = 0;
        this.width = 0;
        this.contentWidth = 0;
        this.preferredWidth = 0;
        this.rows = [];
        this.columns = [];
        this.headerRow = null;
        this.pageCount = 1;
        this.hooks = {
            createdHeaderCell: [],
            createdCell: [],
            drawHeaderRow: [],
            drawRow: [],
            drawHeaderCell: [],
            drawCell: [],
            addPageContent: []
        };
        this.styles = {
            styles: {},
            headerStyles: {},
            bodyStyles: {},
            alternateRowStyles: {},
            columnStyles: {}
        };
        this.doc = doc;
        this.userStyles = {
            textColor: 30,
            fontSize: doc.internal.getFontSize(),
            fontStyle: doc.internal.getFont().fontStyle
        };
    }
    Table.prototype.margin = function (side) {
        return config_1.Config.marginOrPadding(this.settings.margin, config_1.getDefaults().margin)[side];
    };
    return Table;
}());
exports.Table = Table;
var Row = (function () {
    function Row(raw, index) {
        this.cells = {};
        this.spansMultiplePages = false;
        this.pageCount = 1;
        this.height = 0;
        this.y = 0;
        this.maxLineCount = 1;
        this.raw = raw;
        this.index = index;
    }
    return Row;
}());
exports.Row = Row;
var Cell = (function () {
    function Cell(raw) {
        this.styles = {};
        this.text = '';
        this.contentWidth = 0;
        this.textPos = {};
        this.height = 0;
        this.width = 0;
        this.x = 0;
        this.y = 0;
        this.raw = raw;
    }
    Cell.prototype.padding = function (name) {
        var padding = config_1.Config.marginOrPadding(this.styles.cellPadding, config_1.Config.styles([]).cellPadding);
        if (name === 'vertical') {
            return padding.top + padding.bottom;
        }
        else if (name === 'horizontal') {
            return padding.left + padding.right;
        }
        else {
            return padding[name];
        }
    };
    return Cell;
}());
exports.Cell = Cell;
var Column = (function () {
    function Column(dataKey, index) {
        this.options = {};
        this.contentWidth = 0;
        this.preferredWidth = 0;
        this.widthStyle = 'auto';
        this.width = 0;
        this.x = 0;
        this.dataKey = dataKey;
        this.index = index;
    }
    return Column;
}());
exports.Column = Column;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(1);
/**
 * Calculate the column widths
 */
function calculateWidths(doc, pageWidth) {
    var table = config_1.Config.tableInstance();
    // Column and table content width
    var fixedWidth = 0;
    var autoWidth = 0;
    var dynamicColumns = [];
    table.columns.forEach(function (column) {
        column.contentWidth = 0;
        table.rows.concat(table.headerRow).forEach(function (row) {
            var cell = row.cells[column.dataKey];
            cell.contentWidth = cell.padding('horizontal') + common_1.getStringWidth(cell.text, cell.styles);
            if (cell.contentWidth > column.contentWidth) {
                column.contentWidth = cell.contentWidth;
            }
        });
        table.contentWidth += column.contentWidth;
        if (typeof column.widthStyle === 'number') {
            column.preferredWidth = column.widthStyle;
            fixedWidth += column.preferredWidth;
            column.width = column.preferredWidth;
        }
        else if (column.widthStyle === 'wrap') {
            column.preferredWidth = column.contentWidth;
            fixedWidth += column.preferredWidth;
            column.width = column.preferredWidth;
        }
        else {
            column.preferredWidth = column.contentWidth;
            autoWidth += column.contentWidth;
            dynamicColumns.push(column);
        }
        table.preferredWidth += column.preferredWidth;
    });
    if (typeof table.settings.tableWidth === 'number') {
        table.width = table.settings.tableWidth;
    }
    else if (table.settings.tableWidth === 'wrap') {
        table.width = table.preferredWidth;
    }
    else {
        table.width = pageWidth - table.margin('left') - table.margin('right');
    }
    distributeWidth(dynamicColumns, fixedWidth, autoWidth, 0);
    // Row height, table height and text overflow
    var all = table.rows.concat(table.headerRow);
    all.forEach(function (row) {
        table.columns.forEach(function (col) {
            var cell = row.cells[col.dataKey];
            config_1.Config.applyStyles(cell.styles);
            var textSpace = col.width - cell.padding('horizontal');
            if (cell.styles.overflow === 'linebreak') {
                // Add one pt to textSpace to fix rounding error
                try {
                    cell.text = doc.splitTextToSize(cell.text, textSpace + 1, { fontSize: cell.styles.fontSize });
                }
                catch (e) {
                    if (e instanceof TypeError && Array.isArray(cell.text)) {
                        cell.text = doc.splitTextToSize(cell.text.join(' '), textSpace + 1, { fontSize: cell.styles.fontSize });
                    }
                    else {
                        throw e;
                    }
                }
            }
            else if (cell.styles.overflow === 'ellipsize') {
                cell.text = common_1.ellipsize(cell.text, textSpace, cell.styles);
            }
            else if (cell.styles.overflow === 'visible') {
                // Do nothing
            }
            else if (cell.styles.overflow === 'hidden') {
                cell.text = common_1.ellipsize(cell.text, textSpace, cell.styles, '');
            }
            else if (typeof cell.styles.overflow === 'function') {
                cell.text = cell.styles.overflow(cell.text, textSpace);
            }
            else {
                console.error("Unrecognized overflow type: " + cell.styles.overflow);
            }
            var k = config_1.Config.scaleFactor();
            var lineCount = Array.isArray(cell.text) ? cell.text.length : 1;
            var fontHeight = cell.styles.fontSize / k * config_1.FONT_ROW_RATIO;
            cell.contentHeight = lineCount * fontHeight + cell.padding('vertical');
            if (cell.contentHeight > row.height) {
                row.height = cell.contentHeight;
                row.maxLineCount = lineCount;
            }
        });
        table.height += row.height;
    });
}
exports.calculateWidths = calculateWidths;
function distributeWidth(dynamicColumns, staticWidth, dynamicColumnsContentWidth, fairWidth) {
    var table = config_1.Config.tableInstance();
    var extraWidth = table.width - staticWidth - dynamicColumnsContentWidth;
    for (var i = 0; i < dynamicColumns.length; i++) {
        var col = dynamicColumns[i];
        var ratio = col.contentWidth / dynamicColumnsContentWidth;
        // A column turned out to be none dynamic, start over recursively
        var isNoneDynamic = col.contentWidth + extraWidth * ratio < fairWidth;
        if (extraWidth < 0 && isNoneDynamic) {
            dynamicColumns.splice(i, 1);
            dynamicColumnsContentWidth -= col.contentWidth;
            col.width = fairWidth;
            staticWidth += col.width;
            distributeWidth(dynamicColumns, staticWidth, dynamicColumnsContentWidth, fairWidth);
            break;
        }
        else {
            col.width = col.contentWidth + extraWidth * ratio;
        }
    }
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__(16);
var config_1 = __webpack_require__(0);
var assign = __webpack_require__(13);
function validateInput(headers, data, allOptions) {
    if (!headers || typeof headers !== 'object') {
        console.error("The headers should be an object or array, is: " + typeof headers);
    }
    if (!data || typeof data !== 'object') {
        console.error("The data should be an object or array, is: " + typeof data);
    }
    var _loop_1 = function (settings) {
        if (settings && typeof settings !== 'object') {
            console.error("The options parameter should be of type object, is: " + typeof settings);
        }
        if (typeof settings.extendWidth !== 'undefined') {
            settings.tableWidth = settings.extendWidth ? 'auto' : 'wrap';
            console.error("Use of deprecated option: extendWidth, use tableWidth instead.");
        }
        if (typeof settings.margins !== 'undefined') {
            if (typeof settings.margin === 'undefined')
                settings.margin = settings.margins;
            console.error("Use of deprecated option: margins, use margin instead.");
        }
        if (typeof settings.afterPageContent !== 'undefined' || typeof settings.beforePageContent !== 'undefined' || typeof settings.afterPageAdd !== 'undefined') {
            console.error("The afterPageContent, beforePageContent and afterPageAdd hooks are deprecated. Use addPageContent instead");
            if (typeof settings.addPageContent === 'undefined') {
                settings.addPageContent = function (data) {
                    config_1.Config.applyUserStyles();
                    if (settings.beforePageContent)
                        settings.beforePageContent(data);
                    config_1.Config.applyUserStyles();
                    if (settings.afterPageContent)
                        settings.afterPageContent(data);
                    config_1.Config.applyUserStyles();
                    if (settings.afterPageAdd && data.pageCount > 1) {
                        data.afterPageAdd(data);
                    }
                    config_1.Config.applyUserStyles();
                };
            }
        }
        [['padding', 'cellPadding'], ['lineHeight', 'rowHeight'], 'fontSize', 'overflow'].forEach(function (o) {
            var deprecatedOption = typeof o === 'string' ? o : o[0];
            var style = typeof o === 'string' ? o : o[1];
            if (typeof settings[deprecatedOption] !== 'undefined') {
                if (typeof settings.styles[style] === 'undefined') {
                    settings.styles[style] = settings[deprecatedOption];
                }
                console.error("Use of deprecated option: " + deprecatedOption + ", use the style " + style + " instead.");
            }
        });
        for (var _i = 0, _a = ['styles', 'bodyStyles', 'headerStyles', 'columnStyles']; _i < _a.length; _i++) {
            var styleProp = _a[_i];
            if (settings[styleProp] && typeof settings[styleProp] !== 'object') {
                console.error("The " + styleProp + " style should be of type object, is: " + typeof settings[styleProp]);
            }
            else if (settings[styleProp] && settings[styleProp].rowHeight) {
                console.error("Use of deprecated style: rowHeight, use vertical cell padding instead");
            }
        }
    };
    for (var _i = 0, allOptions_1 = allOptions; _i < allOptions_1.length; _i++) {
        var settings = allOptions_1[_i];
        _loop_1(settings);
    }
}
exports.validateInput = validateInput;
/**
 * Create models from the user input
 *
 * @param inputHeaders
 * @param inputData
 */
function createModels(inputHeaders, inputData) {
    var splitRegex = /\r\n|\r|\n/g;
    var table = config_1.Config.tableInstance();
    var settings = table.settings;
    var theme = config_1.getTheme(settings.theme);
    // Header row and columns
    var headerRow = new models_1.Row(inputHeaders, -1);
    headerRow.index = -1;
    // Columns and header row
    inputHeaders.forEach(function (rawColumn, index) {
        var dataKey = index;
        if (typeof rawColumn.dataKey !== 'undefined') {
            dataKey = rawColumn.dataKey;
        }
        else if (typeof rawColumn.key !== 'undefined') {
            console.error("Deprecation warning: Use dataKey instead of key");
            dataKey = rawColumn.key; // deprecated since 2.x
        }
        var col = new models_1.Column(dataKey, index);
        col.raw = rawColumn;
        col.widthStyle = config_1.Config.styles([theme.table, theme.header, table.styles.styles, table.styles.columnStyles[col.dataKey] || {}]).columnWidth;
        table.columns.push(col);
        var cell = new models_1.Cell(rawColumn);
        cell.styles = config_1.Config.styles([theme.table, theme.header, table.styles.styles, table.styles.headerStyles]);
        if (cell.raw instanceof HTMLElement) {
            cell.text = (cell.raw.innerText || '').trim();
        }
        else {
            var text = typeof cell.raw === 'object' ? cell.raw.title : cell.raw;
            // Stringify 0 and false, but not undefined
            cell.text = typeof cell.raw !== 'undefined' ? '' + text : '';
        }
        cell.text = cell.text.split(splitRegex);
        headerRow.cells[dataKey] = cell;
        for (var _i = 0, _a = table.hooks.createdHeaderCell; _i < _a.length; _i++) {
            var hook = _a[_i];
            hook(cell, { cell: cell, column: col, row: headerRow, settings: settings });
        }
    });
    table.headerRow = headerRow;
    // Rows och cells
    inputData.forEach(function (rawRow, i) {
        var row = new models_1.Row(rawRow, i);
        var rowStyles = i % 2 === 0 ? assign({}, theme.alternateRow, table.styles.alternateRowStyles) : {};
        table.columns.forEach(function (column) {
            var cell = new models_1.Cell(rawRow[column.dataKey]);
            var colStyles = table.styles.columnStyles[column.dataKey] || {};
            cell.styles = config_1.Config.styles([theme.table, theme.body, table.styles.styles, table.styles.bodyStyles, rowStyles, colStyles]);
            if (cell.raw && cell.raw instanceof HTMLElement) {
                cell.text = (cell.raw.innerText || '').trim();
            }
            else {
                // Stringify 0 and false, but not undefined
                cell.text = typeof cell.raw !== 'undefined' ? '' + cell.raw : '';
            }
            cell.text = cell.text.split(splitRegex);
            row.cells[column.dataKey] = cell;
            for (var _i = 0, _a = table.hooks.createdCell; _i < _a.length; _i++) {
                var hook = _a[_i];
                hook(cell, config_1.Config.hooksData({ cell: cell, column: column, row: row }));
            }
        });
        table.rows.push(row);
    });
}
exports.createModels = createModels;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(8);
var $isFinite = __webpack_require__(7);

var sign = __webpack_require__(10);
var mod = __webpack_require__(9);

var IsCallable = __webpack_require__(3);
var toPrimitive = __webpack_require__(24);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return Boolean(value);
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	}
};

module.exports = ES5;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
var symbolToStr = hasSymbols ? Symbol.prototype.toString : toStr;

var $isNaN = __webpack_require__(8);
var $isFinite = __webpack_require__(7);
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(6);
var sign = __webpack_require__(10);
var mod = __webpack_require__(9);
var isPrimitive = __webpack_require__(23);
var toPrimitive = __webpack_require__(25);
var parseInteger = parseInt;
var bind = __webpack_require__(2);
var strSlice = bind.call(Function.call, String.prototype.slice);
var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, String.prototype.replace);
var trim = function (value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(20);

var hasRegExpMatcher = __webpack_require__(29);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, 'number');
		if (typeof value === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = Math.floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a string');
		}
		return String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, String);
		return typeof key === 'symbol' ? symbolToStr.call(key) : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr.call(argument) !== '[object String]') {
			throw new TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: Array.isArray || function IsArray(argument) {
		return toStr.call(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: function IsExtensible(obj) {
		if (!Object.preventExtensions) { return true; }
		if (isPrimitive(obj)) {
			return false;
		}
		return Object.isExtensible(obj);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = Math.abs(argument);
		return Math.floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return undefined;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && Symbol.species ? C[Symbol.species] : undefined;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new TypeError('no constructor found');
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES6 = __webpack_require__(21);
var assign = __webpack_require__(6);

var ES7 = assign(ES6, {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

module.exports = ES7;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(11);

var isCallable = __webpack_require__(3);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(11);
var isCallable = __webpack_require__(3);
var isDate = __webpack_require__(28);
var isSymbol = __webpack_require__(30);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (PreferredType === String) {
			hint = 'string';
		} else if (PreferredType === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 27 */
/***/ (function(module, exports) {

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(12);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') { return false; }
		return symStringRegex.test(symToStr.call(value));
	};
	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') { return true; }
		if (toStr.call(value) !== '[object Symbol]') { return false; }
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {
	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false;
	};
}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(32);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(5);

var implementation = __webpack_require__(14);
var getPolyfill = __webpack_require__(15);
var shim = __webpack_require__(34);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(15);
var define = __webpack_require__(5);

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var jsPDF = __webpack_require__(19);
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(1);
var painter_1 = __webpack_require__(4);
var calculator_1 = __webpack_require__(17);
var creator_1 = __webpack_require__(18);
/**
 * Create a table from a set of rows and columns.
 *
 * @param {Object[]|String[]} headers Either as an array of objects or array of strings
 * @param {Object[][]|String[][]} data Either as an array of objects or array of strings
 * @param {Object} [userOptions={}] Options that will override the default ones
 */
jsPDF.API.autoTable = function (headers, data, tableOptions) {
    if (tableOptions === void 0) { tableOptions = {}; }
    this.autoTableState = this.autoTableState || {};
    jsPDF.autoTableState = jsPDF.autoTableState || {};
    var allOptions = [jsPDF.autoTableState.defaults || {}, this.autoTableState.defaults || {}, tableOptions || {}];
    creator_1.validateInput(headers, data, allOptions);
    var table = config_1.Config.createTable(this);
    config_1.Config.initSettings(table, allOptions);
    var settings = table.settings;
    // Create the table model with its columns, rows and cells
    creator_1.createModels(headers, data);
    settings.margin = config_1.Config.marginOrPadding(settings.margin, config_1.getDefaults().margin);
    calculator_1.calculateWidths(this, config_1.Config.pageSize().width);
    table.cursor = {
        x: table.margin('left'),
        y: settings.startY === false ? table.margin('top') : settings.startY
    };
    var minTableBottomPos = settings.startY + table.margin('bottom') + table.headerRow.height;
    if (settings.pageBreak === 'avoid') {
        minTableBottomPos += table.height;
    }
    var pageHeight = config_1.Config.pageSize().height;
    if ((settings.pageBreak === 'always' && settings.startY !== false) ||
        (settings.startY !== false && minTableBottomPos > pageHeight)) {
        common_1.nextPage(table.doc);
        table.cursor.y = table.margin('top');
    }
    table.pageStartX = table.cursor.x;
    table.pageStartY = table.cursor.y;
    config_1.Config.applyUserStyles();
    if (settings.showHeader === true || settings.showHeader === 'firstPage' || settings.showHeader === 'everyPage') {
        painter_1.printRow(table.headerRow, table.hooks.drawHeaderRow, table.hooks.drawHeaderCell);
    }
    config_1.Config.applyUserStyles();
    table.rows.forEach(function (row) {
        painter_1.printFullRow(row, table.hooks.drawRow, table.hooks.drawCell);
    });
    common_1.addTableBorder();
    // Don't call global and document addPageContent more than once for each page
    var pageNumber = this.internal.getCurrentPageInfo().pageNumber;
    if (this.autoTableState.addPageHookPages && this.autoTableState.addPageHookPages[pageNumber]) {
        if (typeof tableOptions['addPageContent'] === 'function') {
            tableOptions['addPageContent'](config_1.Config.hooksData());
        }
    }
    else {
        if (!this.autoTableState.addPageHookPages)
            this.autoTableState.addPageHookPages = {};
        this.autoTableState.addPageHookPages[pageNumber] = true;
        common_1.addContentHooks();
    }
    table.finalY = table.cursor.y;
    this.autoTable.previous = table;
    config_1.Config.applyUserStyles();
    return this;
};
// Enables doc.autoTable.previous.finalY || 40;
jsPDF.API.autoTable.previous = false;
jsPDF.API.autoTableSetDefaults = function (defaults) {
    if (!this.autoTableState)
        this.autoTableState = {};
    if (defaults && typeof defaults === 'object') {
        this.autoTableState.defaults = defaults;
    }
    else {
        delete this.autoTableState.defaults;
    }
    return this;
};
jsPDF.autoTableSetDefaults = function (defaults) {
    if (!jsPDF.autoTableState)
        jsPDF.autoTableState = {};
    if (defaults && typeof defaults === 'object') {
        this.autoTableState.defaults = defaults;
    }
    else {
        delete this.autoTableState.defaults;
    }
    jsPDF.autoTableState.defaults = defaults;
};
/**
 * Parses an html table
 *
 * @param tableElem Html table element
 * @param includeHiddenElements If to include hidden rows and columns (defaults to false)
 * @returns Object Object with two properties, columns and rows
 */
jsPDF.API.autoTableHtmlToJson = function (tableElem, includeHiddenElements) {
    includeHiddenElements = includeHiddenElements || false;
    if (!tableElem || !(tableElem instanceof HTMLTableElement)) {
        console.error("A HTMLTableElement has to be sent to autoTableHtmlToJson");
        return null;
    }
    var columns = {}, rows = [];
    var header = tableElem.rows[0];
    for (var i = 0; i < header.cells.length; i++) {
        var cell = header.cells[i];
        var style = window.getComputedStyle(cell);
        if (includeHiddenElements || style.display !== 'none') {
            columns[i] = cell;
        }
    }
    var _loop_1 = function (i) {
        var tableRow = tableElem.rows[i];
        var style = window.getComputedStyle(tableRow);
        if (includeHiddenElements || style.display !== 'none') {
            var rowData_1 = [];
            Object.keys(columns).forEach(function (key) {
                var cell = tableRow.cells[key];
                rowData_1.push(cell);
            });
            rows.push(rowData_1);
        }
    };
    for (var i = 1; i < tableElem.rows.length; i++) {
        _loop_1(i);
    }
    var values = Object.keys(columns).map(function (key) { return columns[key]; });
    return { columns: values, rows: rows, data: rows };
};
/**
 * Improved text function with halign and valign support
 * Inspiration from: http://stackoverflow.com/questions/28327510/align-text-right-using-jspdf/28433113#28433113
 */
jsPDF.API.autoTableText = function (text, x, y, styles) {
    if (typeof x !== 'number' || typeof y !== 'number') {
        console.error('The x and y parameters are required. Missing for the text: ', text);
    }
    var k = this.internal.scaleFactor;
    var fontSize = this.internal.getFontSize() / k;
    var splitRegex = /\r\n|\r|\n/g;
    var splitText = null;
    var lineCount = 1;
    if (styles.valign === 'middle' || styles.valign === 'bottom' || styles.halign === 'center' || styles.halign === 'right') {
        splitText = typeof text === 'string' ? text.split(splitRegex) : text;
        lineCount = splitText.length || 1;
    }
    // Align the top
    y += fontSize * (2 - config_1.FONT_ROW_RATIO);
    if (styles.valign === 'middle')
        y -= (lineCount / 2) * fontSize * config_1.FONT_ROW_RATIO;
    else if (styles.valign === 'bottom')
        y -= lineCount * fontSize * config_1.FONT_ROW_RATIO;
    if (styles.halign === 'center' || styles.halign === 'right') {
        var alignSize = fontSize;
        if (styles.halign === 'center')
            alignSize *= 0.5;
        if (lineCount >= 1) {
            for (var iLine = 0; iLine < splitText.length; iLine++) {
                this.text(splitText[iLine], x - this.getStringUnitWidth(splitText[iLine]) * alignSize, y);
                y += fontSize;
            }
            return this;
        }
        x -= this.getStringUnitWidth(text) * alignSize;
    }
    this.text(text, x, y);
    return this;
};
/**
 * @deprecated Use doc.autoTable.previous.finalY instead
 */
jsPDF.API.autoTableEndPosY = function () {
    var prev = this.autoTable.previous;
    if (prev.cursor && typeof prev.cursor.y === 'number') {
        return prev.cursor.y;
    }
    else {
        return 0;
    }
};
/**
 * @deprecated Use jsPDF.autoTableSetDefaults({addPageContent: function() {}}) instead
 */
jsPDF.API.autoTableAddPageContent = function (hook) {
    if (!jsPDF.API.autoTable.globalDefaults) {
        jsPDF.API.autoTable.globalDefaults = {};
    }
    jsPDF.API.autoTable.globalDefaults.addPageContent = hook;
    return this;
};
/**
 * @deprecated Use data.addPage in hooks instead
 */
jsPDF.API.autoTableAddPage = function () {
    common_1.addPage();
    return this;
};


/***/ })
/******/ ]);
});
(function () {
    'use strict';

    angular.module('mydata.report').controller('report.controller', ReportController);

    function ReportController($scope, toolsService, $state, $filter, $rootScope, $interval) {

        $scope.smartTablePageSize = 10;
        $scope.stOrderTrxData = [];
        $scope.stOrderTrxUserData = [];
        $scope.stOrderTrxAllData = [];

        //#region datepicker 
        $scope.popupDateFrom = {
            opened: false
        };
        $scope.openDateFrom = function () {
            $scope.popupDateFrom.opened = true;
        };
        $scope.popupDateTo = {
            opened: false
        };
        $scope.openDateTo = function () {
            $scope.popupDateTo.opened = true;
        };
        var nowDate = new Date()
        $scope.dateFrom = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);;
        $scope.dateTo = nowDate;
        //#endregion

        //#region load doc type onclick
        $scope.docTypeWithSearch = { selected: {} };
        $scope.loadDocType = function () {
            toolsService.ajaxGet('/document/getDocumentType').then(function (data) {
                $scope.docType = data.options;
            });
        };
        //#endregion load doc type onclick

        //#region load doc type onclick
        $scope.productTypeWithSearch = { selected: {} };
        $scope.loadProductType = function () {
            toolsService.ajaxGet('/document/getProductType').then(function (data) {
                $scope.productTypes = data.options;
                // $scope.productTypeWithSearch.selected = data.value;
            });
        };
        //#endregion load doc type onclick

        //#region load agency onclick
        $scope.agencyWithSearch = { selected: {} };
        $scope.loadAgency = function () {
            $scope.userWithSearch = { selected: {} };
            toolsService.ajaxGet('/report/getUserAgency').then(function (data) {
                $scope.agencyOption = data.options;
            });
        };
        //#endregion load agency onclick

        //#region load all user onclick
        $scope.userWithSearch = { selected: {} };
        $scope.loadUser = function () {
            var request = {}
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            toolsService.ajaxGet('/report/getAllUser', request).then(function (data) {
                $scope.userOption = data.options;
                // $scope.userWithSearch.selected = data.value;
            });
        };
        // $scope.loadUser();
        //#endregion load all user onclick

        //#region load all user
        $scope.agencyUserWithSearch = { selected: {} };
        $scope.loadAgencyUser = function () {
            toolsService.ajaxGet('/report/getAllAgencyUser').then(function (data) {
                $scope.userOption = data.options;
            });
        };
        //#endregion load all user

        //#region load project agency dropdown
        $scope.projectAgencyWithSearch = { selected: {} };
        $scope.loadProjectAgencyList = function () {
            toolsService.ajaxGet('/project/getProjectAgencyList').then(function (data) {
                $scope.projectAgencyList = data.projectAgencyList;
            });
        };
        //#endregion

        //#region load project all dropdown
        $scope.projectAllWithSearch = { selected: {} };
        $scope.loadProjectAllList = function () {
            toolsService.ajaxGet('/project/getProjectAllList').then(function (data) {
                $scope.projectAllList = data.projectAllList;
            });
        };
        //#endregion

        //#region page pagination
        function pagination(pagination){
            $scope.currentPage = pagination.page;
            $scope.numPages = pagination.pageCount;
            $scope.smartTablePageSize = pagination.pageSize;
            var firstRecord = ((pagination.page - 1) * pagination.pageSize) + 1
            var lastRecord = pagination.page * pagination.pageSize
            if (lastRecord >= pagination.rowCount){
                lastRecord = pagination.rowCount
            }
            $scope.pageDesc = 'Showing ' + firstRecord + ' - ' + lastRecord + ' of ' + pagination.rowCount + ' records'
            var i;
            var start = 1;
            var end;
            $scope.pages = [];
            start = Math.max(start, $scope.currentPage - 2);
            end = start + 5;
            if (end > $scope.numPages) {
                end = $scope.numPages + 1;
                start = Math.max(1, end - 5);
            }
            for (i = start; i < end; i++) {
                $scope.pages.push(i);
            }
        }
        //#endregion

        //#region report list - normal user
        $scope.stOrderTrxUserFilter = function (tableState, ctrl) {
            $scope.trxOrderCtrl = ctrl;
        };
        $scope.searchOrderTrxUser = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                orderRef: this.orderRef || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.projectAgencyWithSearch && this.projectAgencyWithSearch.selected) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
            }
            toolsService.ajaxPost('/report/getUserOrderTransaction', request).then(function (data) {
                $scope.stOrderTrxUserData = data.data;
                $scope.projectExist = data.projectExist;
                $scope.untaxedAmount = data.untaxedAmount;
                $scope.taxAmount = data.taxAmount;
                $scope.totalAmount = data.totalAmount;
                $scope.trxCount = data.trxCount;
                pagination(data.pagination)
            });
        };

        if ($state.current.name == 'report.orderTrxUser') {
            $scope.loadProjectAgencyList();
            $scope.searchOrderTrxUser();
        }

        $scope.selectOrderTrxUserPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                orderRef: this.orderRef || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.projectAgencyWithSearch && this.projectAgencyWithSearch.selected) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
            }
            toolsService.ajaxPost('/report/getUserOrderTransaction', request).then(function (data) {
                $scope.stOrderTrxUserData = data.data;
                $scope.projectExist = data.projectExist;
                pagination(data.pagination)
            });
        };
        //#endregion trx report for user

        //#region report export excel - normal user
        $scope.exportOrderTrxUserExcel = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                orderRef: this.orderRef || '',
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.projectAgencyWithSearch && this.projectAgencyWithSearch.selected) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
            }
            toolsService.ajaxPostPdf('/report/exportOrderTrxUserExcel', request).then(function (data) {
                var blob = new Blob(
                    [data],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }
                );
                saveAs(blob, 'TransactionReport.xlsx');
            });
        };
        //#endregion

        //#region report export pdf - normal user
        $scope.exportOrderTrxUserPdf = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                orderRef: this.orderRef || '',
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.projectAgencyWithSearch && this.projectAgencyWithSearch.selected) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
                request.projectName = this.projectAgencyWithSearch.selected.projectName;
            }
            toolsService.ajaxPost('/report/exportOrderTrxUserPdf', request).then(function (data) {
                var columns = [
                    { title: "Purchase Date", dataKey: "processDate" },
                    { title: "Order Number", dataKey: "orderNumber" },
                    { title: "User", dataKey: "fullName" },
                    { title: "Product Type", dataKey: "type" },
                    { title: "Entity Number / Name", dataKey: "entityName" },
                    { title: "Document Description", dataKey: "documentName" },
                    { title: "Document Date", dataKey: "documentDate" },
                    { title: "Lang", dataKey: "lang" },
                    { title: "Status", dataKey: "status" },
                    { title: "Price (RM)", dataKey: "documentPrice" },
                    { title: "Tax  Amt (RM)", dataKey: "tax_amount" },
                    { title: "Total Amt (RM)", dataKey: "total_doc_price" },
                ];
                var columns2 = [
                    { title: "Title", dataKey: "summaryTitle" },
                    { title: "Data", dataKey: "summaryData" },
                ];
                var doc = new jsPDF('l', 'pt', 'a4');
                var totalPagesExp = "{total_pages_count_string}";

                var pageContent = function (data) {
                    // HEADER
                    // repeat logo each page
                    // if (logo1Img) {
                    //   doc.addImage(logo1Img, 'PNG', 335, 20, 167, 50);
                    // }

                    // FOOTER
                    var str = "Page " + data.pageCount;
                    if (typeof doc.putTotalPages === 'function') {
                        str = str + " of " + totalPagesExp;
                    }
                    doc.setFontSize(7);
                    doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 20);
                    doc.setFontSize(8);
                    doc.text('BIG Dataworks Sdn Bhd', 375, doc.internal.pageSize.height - 30);
                    doc.text('The Warehouse, 1st Tier, Wisma Amtek, No.15 Jalan Tandang, 46050 Petaling Jaya, Selangor', 275, doc.internal.pageSize.height - 20);
                    doc.text('TEL: +603-27759339', 380, doc.internal.pageSize.height - 10);
                };
                if (logo1Img) {
                    doc.addImage(logo1Img, 'PNG', 335, 20, 167, 50);
                }
                doc.text('Transaction Report', 350, 90);
                doc.setFontSize(9);
                var producttype = request.docType;
                if (request.docType == "" || request.docType == undefined) {
                    producttype = "All"
                }
                var orderstatus = request.orderStatus;
                if (request.orderStatus == "" || request.orderStatus == undefined) {
                    orderstatus = "All"
                }
                var project = "";
                if (data.projectExist) {
                    if (request.projectName == "" || request.projectName == undefined) {
                        project = ",  Project: All";
                    }
                    else {
                        project = ",  Project: " + request.projectName;
                    }
                }
                doc.text('Purchase Date From: ' + request.dateFrom + '  To: ' + request.dateTo + ',  Product Type: ' + producttype + ',  Status: ' + orderstatus + project, 30, 113);
                doc.autoTable(columns, data.data, {
                    addPageContent: pageContent,
                    startY: 120,
                    theme: 'grid',
                    pageBreak: 'auto',
                    margin: { top: 30, right: 30, bottom: 60, left: 30 },
                    styles: {
                        fontSize: 8,
                        font: 'helvetica',
                        halign: "left",
                        overflow: 'linebreak',
                    },
                    // tableWidth: 'auto',
                    headerStyles: {
                        fillColor: [64, 64, 64],
                        textColor: [255, 255, 255],
                        fontStyle: 'bold',
                    },
                    bodyStyles: { textColor: [0, 0, 0], lineColor: [240, 240, 240] },
                    columnStyles: {
                        processDate: { columnWidth: 50 },
                        orderNumber: { columnWidth: 70 },
                        fullName: { columnWidth: 75 },
                        type: { columnWidth: 75 },
                        entityName: { columnWidth: 130 },
                        documentName: { columnWidth: 140 },
                        documentDate: { columnWidth: 50 },
                        lang: { columnWidth: 30 },
                        status: { columnWidth: 60 },
                        documentPrice: { columnWidth: 33, halign: "right" },
                        tax_amount: { columnWidth: 32, halign: "right" },
                        total_doc_price: { columnWidth: 35, halign: "right" }
                    }
                });
                doc.autoTable(columns2, data.summaryData, {
                    startY: doc.autoTable.previous.finalY + 0,
                    showHeader: 'never',
                    theme: 'plain',
                    pageBreak: 'avoid',
                    margin: { right: 30, left: 30 },
                    styles: {
                        fontSize: 8,
                        font: 'helvetica',
                        halign: "right",
                        overflow: 'linebreak'
                    },
                    // headerStyles: {
                    //   fillColor: [0,0,0],
                    //   fontSize: 8
                    // },
                    columnStyles: {
                        summaryTitle: { columnWidth: 715, fontSize: 9, fontStyle: 'bold', fillColor: [240, 240, 240] },
                        summaryData: { columnWidth: 65, fontSize: 9, fontStyle: 'bold', fillColor: [240, 240, 240] }
                    }
                });

                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp);
                }

                doc.save("TransactionReport.pdf");
            });
        };
        //#endregion

        //#region report list - administrator
        $scope.stOrderTrxAllFilter = function (tableState, ctrl) {
            $scope.trxOrderCtrl = ctrl;
        };
        $scope.searchOrderTrxAll = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: this.orderRef || '',
                entityRef: this.entityRef || '',
                status: this.orderStatus || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            if (this.projectAllWithSearch) {
                request.projectId = this.projectAllWithSearch.selected.id;
                request.projectName = this.projectAllWithSearch.selected.projectName;
            }
            toolsService.ajaxPost('/report/getAllOrderTransaction', request).then(function (data) {
                $scope.stOrderTrxAllData = data.data;
                $scope.projectExist = data.projectExist;
                $scope.allUntaxedAmount = data.allUntaxedAmount;
                $scope.allTaxAmount = data.allTaxAmount;
                $scope.allTotalAmount = data.allTotalAmount;
                $scope.allTrxCount = data.allTrxCount;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'report.orderTrxAll') {
            $scope.searchOrderTrxAll();
        }
        $scope.selectOrderTrxAllPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: this.orderRef || '',
                entityRef: this.entityRef || '',
                status: this.orderStatus || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            if (this.projectAllWithSearch) {
                request.projectId = this.projectAllWithSearch.selected.id;
                request.projectName = this.projectAllWithSearch.selected.projectName;
            }
            toolsService.ajaxPost('/report/getAllOrderTransaction', request).then(function (data) {
                $scope.stOrderTrxAllData = data.data;
                $scope.projectExist = data.projectExist;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region report export excel - administrator
        $scope.exportAllOrderTrxToExcel = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: this.orderRef || '',
                entityRef: this.entityRef || '',
                status: this.orderStatus || '',
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            if (this.projectAllWithSearch) {
                request.projectId = this.projectAllWithSearch.selected.id;
                request.projectName = this.projectAllWithSearch.selected.projectName;
            }
            toolsService.ajaxPostPdf('/report/exportAllOrderTrxToExcel', request).then(function (data) {
                var blob = new Blob(
                    [data],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }
                );
                saveAs(blob, 'TransactionReport.xlsx');
            });
        };
        //#endregion

        //#region report export pdf - administrator
        var logo1Img = null;
        imgToBase64('assets/img/logo2_opt.png', function (base64) {
            logo1Img = base64;
        });
        function imgToBase64(url, callback) {
            if (!window.FileReader) {
                callback(null);
                return;
            }
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result.replace('text/xml', 'image/png'));
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.send();
        }

        $scope.exportAllOrderTrxToPdf = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderRef: this.orderRef || '',
                entityRef: this.entityRef || '',
                status: this.orderStatus || '',
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyWithSearch) {
                request.agencyId = this.agencyWithSearch.selected.id;
                request.agencyName = this.agencyWithSearch.selected.agencyName;
            }
            if (this.userWithSearch) {
                request.userId = this.userWithSearch.selected.id;
                request.userName = this.userWithSearch.selected.fullName;
            }
            if (this.projectAllWithSearch) {
                request.projectId = this.projectAllWithSearch.selected.id;
                request.projectName = this.projectAllWithSearch.selected.projectName;
            }
            // else {
            //     request.projectId = null;
            //     request.projectName = '';
            // }
            toolsService.ajaxPost('/report/exportAllOrderTrxToPdf', request).then(function (data) {
                var columns = [
                    { title: "Purchase Date", dataKey: "processDate" },
                    { title: "Order Number", dataKey: "orderNumber" },
                    { title: "Agency / User", dataKey: "agencyName" },
                    { title: "Product Type", dataKey: "type" },
                    { title: "Entity Number / Name", dataKey: "entityName" },
                    { title: "Document Description", dataKey: "documentName" },
                    { title: "Document Date", dataKey: "documentDate" },
                    { title: "Lang", dataKey: "lang" },
                    { title: "Status", dataKey: "status" },
                    { title: "Price (RM)", dataKey: "documentPrice" },
                    { title: "Tax  Amt (RM)", dataKey: "tax_amount" },
                    { title: "Total Amt (RM)", dataKey: "total_doc_price" },
                ];
                var columns2 = [
                    { title: "Title", dataKey: "summaryTitle" },
                    { title: "Data", dataKey: "summaryData" },
                ];
                var doc = new jsPDF('l', 'pt', 'a4');
                var totalPagesExp = "{total_pages_count_string}";

                var pageContent = function (data) {
                    // HEADER
                    // repeat logo each page
                    // if (logo1Img) {
                    //   doc.addImage(logo1Img, 'PNG', 335, 20, 167, 50);
                    // }

                    // FOOTER
                    var str = "Page " + data.pageCount;
                    if (typeof doc.putTotalPages === 'function') {
                        str = str + " of " + totalPagesExp;
                    }
                    doc.setFontSize(7);
                    doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 20);
                    doc.setFontSize(8);
                    doc.text('BIG Dataworks Sdn Bhd', 375, doc.internal.pageSize.height - 30);
                    doc.text('The Warehouse, 1st Tier, Wisma Amtek, No.15 Jalan Tandang, 46050 Petaling Jaya, Selangor', 275, doc.internal.pageSize.height - 20);
                    doc.text('TEL: +603-27759339', 380, doc.internal.pageSize.height - 10);
                };
                if (logo1Img) {
                    doc.addImage(logo1Img, 'PNG', 335, 20, 167, 50);
                }
                doc.text('Transaction Report', 350, 90);
                doc.setFontSize(9);
                var agencyname = request.agencyName;
                if (request.agencyName == "" || request.agencyName == undefined) {
                    agencyname = "All"
                }
                var username = request.userName;
                if (request.userName == "" || request.userName == undefined) {
                    username = "All"
                }
                var producttype = request.docType;
                if (request.docType == "" || request.docType == undefined) {
                    producttype = "All"
                }
                var orderstatus = request.status;
                if (request.status == "" || request.status == undefined) {
                    orderstatus = "All"
                }
                var project = "";
                if (data.projectExist) {
                    if (request.projectName == "" || request.projectName == undefined) {
                        project = ",  Project: All";
                    }
                    else {
                        project = ",  Project: " + request.projectName;
                    }
                }
                doc.text(
                    'Purchase Date From: ' + request.dateFrom +
                    '  To: ' + request.dateTo +
                    ',  Product Type: ' + producttype +
                    ',  Status: ' + orderstatus +
                    ',  Agency: ' + agencyname +
                    ',  User: ' + username +
                    project, 30, 113);
                doc.autoTable(columns, data.data, {
                    addPageContent: pageContent,
                    startY: 120,
                    theme: 'grid',
                    pageBreak: 'auto',
                    margin: { top: 30, right: 30, bottom: 60, left: 30 },
                    styles: {
                        fontSize: 8,
                        font: 'helvetica',
                        halign: "left",
                        overflow: 'linebreak',
                    },
                    // tableWidth: 'auto',
                    headerStyles: {
                        fillColor: [64, 64, 64],
                        textColor: [255, 255, 255],
                        fontStyle: 'bold',
                    },
                    bodyStyles: { textColor: [0, 0, 0], lineColor: [240, 240, 240] },
                    columnStyles: {
                        processDate: { columnWidth: 50 },
                        orderNumber: { columnWidth: 70 },
                        agencyName: { columnWidth: 83 },
                        type: { columnWidth: 75 },
                        entityName: { columnWidth: 125 },
                        documentName: { columnWidth: 140 },
                        documentDate: { columnWidth: 50 },
                        lang: { columnWidth: 30 },
                        status: { columnWidth: 57 },
                        // tax_rate: {columnWidth: 30, halign: "right"},
                        documentPrice: { columnWidth: 33, halign: "right" },
                        tax_amount: { columnWidth: 32, halign: "right" },
                        total_doc_price: { columnWidth: 35, halign: "right" }
                    }
                });
                doc.autoTable(columns2, data.summaryData, {
                    startY: doc.autoTable.previous.finalY + 0,
                    showHeader: 'never',
                    theme: 'plain',
                    pageBreak: 'avoid',
                    margin: { right: 30, left: 30 },
                    styles: {
                        fontSize: 8,
                        font: 'helvetica',
                        halign: "right",
                        overflow: 'linebreak'
                    },
                    // headerStyles: {
                    //   fillColor: [0,0,0],
                    //   fontSize: 8
                    // },
                    columnStyles: {
                        summaryTitle: { columnWidth: 715, fontSize: 9, fontStyle: 'bold', fillColor: [240, 240, 240] },
                        summaryData: { columnWidth: 65, fontSize: 9, fontStyle: 'bold', fillColor: [240, 240, 240] }
                    }
                });

                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp);
                }

                doc.save("TransactionReport.pdf");
            });
        };
        //#endregion

        //#region report list - account admin
        $scope.stOrderTrxAgencyFilter = function (tableState, ctrl) {
            $scope.trxOrderCtrl = ctrl;
        };
        $scope.searchOrderTrxAgency = function (agencyId) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                entityRef: this.entityRef || '',
                orderRef: this.orderRef || '',
                sort: {},
                page: 1,
                itemPerPage: this.smartTablePageSize
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            if (this.projectAgencyWithSearch) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
            }
            toolsService.ajaxPost('/report/getAgencyOrderTransaction', request).then(function (data) {
                $scope.stOrderTrxAgencyData = data.data;
                $scope.projectExist = data.projectExist;
                $scope.untaxedAmount = data.untaxedAmount;
                $scope.taxAmount = data.taxAmount;
                $scope.totalAmount = data.totalAmount;
                $scope.trxCount = data.trxCount;
                pagination(data.pagination)
            });
        };
        if ($state.current.name == 'report.orderTrxAgency') {
            $scope.loadProjectAgencyList();
            $scope.searchOrderTrxAgency();
        }
        $scope.selectOrderTrxAgencyPage = function (page) {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                entityRef: this.entityRef || '',
                orderRef: this.orderRef || '',
                sort: {},
                page: page,
                itemPerPage: this.smartTablePageSize
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            if (this.projectAgencyWithSearch) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
            }
            toolsService.ajaxPost('/report/getAgencyOrderTransaction', request).then(function (data) {
                $scope.stOrderTrxAgencyData = data.data;
                $scope.projectExist = data.projectExist;
                pagination(data.pagination)
            });
        };
        //#endregion

        //#region report export excel - account admin
        $scope.exportOrderTrxAgencyExcel = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                entityRef: this.entityRef || '',
                orderRef: this.orderRef || ''
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            if (this.projectAgencyWithSearch) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
            }
            toolsService.ajaxPostPdf('/report/exportOrderTrxAgencyExcel', request).then(function (data) {
                var blob = new Blob(
                    [data],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" }
                );
                saveAs(blob, 'TransactionReport.xlsx');
            });
        };
        //#endregion

        //#region report export pdf - account admin
        $scope.exportOrderTrxAgencyPdf = function () {
            var request = {
                dateFrom: $filter('date')(this.dateFrom,'yyyy-MM-dd') || '',
                dateTo: $filter('date')(this.dateTo, 'yyyy-MM-dd') || '',
                orderStatus: this.orderStatus || '',
                entityRef: this.entityRef || '',
                orderRef: this.orderRef || ''
            };
            if (this.productTypeWithSearch) {
                request.docType = this.productTypeWithSearch.selected.documentName;
                request.docTypeCtc = this.productTypeWithSearch.selected.ctc;
            }
            if (this.agencyUserWithSearch) {
                request.agencyUserId = this.agencyUserWithSearch.selected.id;
                request.agencyUserName = this.agencyUserWithSearch.selected.fullName;
            }
            if (this.projectAgencyWithSearch) {
                request.projectId = this.projectAgencyWithSearch.selected.id;
                request.projectCode = this.projectAgencyWithSearch.selected.projectCode;
                request.projectName = this.projectAgencyWithSearch.selected.projectName;
            }
            toolsService.ajaxPost('/report/exportOrderTrxAgencyPdf', request).then(function (data) {
                var columns = [
                    { title: "Purchase Date", dataKey: "processDate" },
                    { title: "Order Number", dataKey: "orderNumber" },
                    { title: "User", dataKey: "fullName" },
                    { title: "Product Type", dataKey: "type" },
                    { title: "Entity Number / Name", dataKey: "entityName" },
                    { title: "Document Description", dataKey: "documentName" },
                    { title: "Document Date", dataKey: "documentDate" },
                    { title: "Lang", dataKey: "lang" },
                    { title: "Status", dataKey: "status" },
                    { title: "Price (RM)", dataKey: "documentPrice" },
                    { title: "Tax  Amt (RM)", dataKey: "tax_amount" },
                    { title: "Total Amt (RM)", dataKey: "total_doc_price" },
                ];
                var columns2 = [
                    { title: "Title", dataKey: "summaryTitle" },
                    { title: "Data", dataKey: "summaryData" },
                ];
                var doc = new jsPDF('l', 'pt', 'a4');
                var totalPagesExp = "{total_pages_count_string}";

                var pageContent = function (data) {
                    // HEADER
                    // repeat logo each page
                    // if (logo1Img) {
                    //   doc.addImage(logo1Img, 'PNG', 335, 20, 167, 50);
                    // }

                    // FOOTER
                    var str = "Page " + data.pageCount;
                    if (typeof doc.putTotalPages === 'function') {
                        str = str + " of " + totalPagesExp;
                    }
                    doc.setFontSize(7);
                    doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 20);
                    doc.setFontSize(8);
                    doc.text('BIG Dataworks Sdn Bhd', 375, doc.internal.pageSize.height - 30);
                    doc.text('The Warehouse, 1st Tier, Wisma Amtek, No.15 Jalan Tandang, 46050 Petaling Jaya, Selangor', 275, doc.internal.pageSize.height - 20);
                    doc.text('TEL: +603-27759339', 380, doc.internal.pageSize.height - 10);
                };
                if (logo1Img) {
                    doc.addImage(logo1Img, 'PNG', 335, 20, 167, 50);
                }
                // doc.text('Transaction Report ('+request.dateFrom+' - '+request.dateTo+')', 250, 90);
                doc.text('Transaction Report', 350, 90);
                doc.setFontSize(9);
                var username = request.agencyUserName;
                if (request.agencyUserName == "" || request.agencyUserName == undefined) {
                    username = "All"
                }
                var producttype = request.docType;
                if (request.docType == "" || request.docType == undefined) {
                    producttype = "All"
                }
                var orderstatus = request.orderStatus;
                if (request.orderStatus == "" || request.orderStatus == undefined) {
                    orderstatus = "All"
                }
                var project = "";
                if (data.projectExist) {
                    if (request.projectName == "" || request.projectName == undefined) {
                        project = ",  Project: All";
                    }
                    else {
                        project = ",  Project: " + request.projectName;
                    }
                }
                doc.text('Purchase Date From: ' + request.dateFrom + '  To: ' + request.dateTo + ',  Product Type: ' + producttype + ',  User: ' + username + ',  Status: ' + orderstatus + project, 30, 113);
                doc.autoTable(columns, data.data, {
                    addPageContent: pageContent,
                    startY: 120,
                    theme: 'grid',
                    pageBreak: 'auto',
                    margin: { top: 30, right: 30, bottom: 60, left: 30 },
                    styles: {
                        fontSize: 8,
                        font: 'helvetica',
                        halign: "left",
                        overflow: 'linebreak',
                    },
                    // tableWidth: 'auto',
                    headerStyles: {
                        fillColor: [64, 64, 64],
                        textColor: [255, 255, 255],
                        fontStyle: 'bold',
                    },
                    bodyStyles: { textColor: [0, 0, 0], lineColor: [240, 240, 240] },
                    columnStyles: {
                        processDate: { columnWidth: 50 },
                        orderNumber: { columnWidth: 70 },
                        fullName: { columnWidth: 75 },
                        type: { columnWidth: 75 },
                        entityName: { columnWidth: 130 },
                        documentName: { columnWidth: 140 },
                        documentDate: { columnWidth: 50 },
                        lang: { columnWidth: 30 },
                        status: { columnWidth: 60 },
                        documentPrice: { columnWidth: 33, halign: "right" },
                        tax_amount: { columnWidth: 32, halign: "right" },
                        total_doc_price: { columnWidth: 35, halign: "right" }
                    }
                });
                doc.autoTable(columns2, data.summaryData, {
                    startY: doc.autoTable.previous.finalY + 0,
                    showHeader: 'never',
                    theme: 'plain',
                    pageBreak: 'avoid',
                    margin: { right: 30, left: 30 },
                    styles: {
                        fontSize: 8,
                        font: 'helvetica',
                        halign: "right",
                        overflow: 'linebreak'
                    },
                    // headerStyles: {
                    //   fillColor: [0,0,0],
                    //   fontSize: 8
                    // },
                    columnStyles: {
                        summaryTitle: { columnWidth: 715, fontSize: 9, fontStyle: 'bold', fillColor: [240, 240, 240] },
                        summaryData: { columnWidth: 65, fontSize: 9, fontStyle: 'bold', fillColor: [240, 240, 240] }
                    }
                });

                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp);
                }

                doc.save("TransactionReport.pdf");
            });
        };
        //#endregion
    }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme').directive('loading',
        ["$rootScope", "$timeout",
        function ($rootScope, $timeout) {
            return {
                restrict: 'E',
                replace: true,
                template: '<div class="loading"><img src="assets/img/ajax-loader.gif" width="60" height="60" /></div>',
                link: function ($scope, element, attr) {
                    // var maxAwaitTime = 1000;
                    var maxAwaitTime = 500;
                    var timer;

                    $scope.$on("loadingShow", function () {
                        if (!timer) {
                            timer = $timeout(function () {
                                return element.show();
                            }, maxAwaitTime);
                        }
                    });

                    $scope.$on("loadingHide", function () {
                        $timeout.cancel(timer);
                        timer = null;
                        return element.hide();
                    });
                }
            }
        }]);
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('refreshTable', refreshTable);

  /** @ngInject */
  function refreshTable() {
    return {
      require:'stTable',
      restrict: "A",
      link:function(scope,elem,attr,table){
          scope.$on("refreshProducts", function() {
              table.pipe(table.tableState());
          });
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('toolsService', [
            '$http', '$q', '$rootScope', '$filter', '$state', '$localStorage', function ($http, $q, $rootScope, $filter, $state, $localStorage) {
                // change for deployment
                // var baseUrl = 'https://expressdev.mydata-ssm.com.my';
                // var baseUrl = 'https://expressstg.mydata-ssm.com.my';
                var baseUrl = 'https://express.mydata-ssm.com.my';
                // var baseUrl = 'http://localhost:3800';
                // var testUrl = 'http://localhost:4500';
                var processSuccessRequest = function(deferred, data, status, headers, config) {
                    if (status === 401) {
                        $rootScope.currentUser = {};
                        $localStorage.currentUser = {};
                        $state.transitionTo('login');
                        if ($rootScope.currentUser) {
                            $rootScope.currentUser.isAuthenticated = false;
                            $rootScope.currentUser.profile = null;
                            $rootScope.currentUser.cart = null;
                            $rootScope.currentUser.avatar = null;
                        }
                        deferred.reject({ message: 'Unathorized', code: status });
                    }
                    deferred.resolve(data);
                };
                var prepareParameters = function (params) {
                    if (params) {
                        var properties = Object.getOwnPropertyNames(params);
                        for (var i = 0; i < properties.length; i++) {
                            if (params[properties[i]] instanceof Date) {
                                params[properties[i]] = $filter('date')(params[properties[i]], 'yyyy-MM-dd HH:mm:ss');
                            }
                        }
                    }
                    
                    return params;
                }
                var service = {
                    getFullUrl: function(url) {
                        return baseUrl + url;
                    },
                    getFullAbsoluteUrl: function() {
                        return window.location.origin + window.location.pathname;
                    },
                    valueToJson: function(value) {
                        return angular.isDate(value) ? value.toISOString() : value;
                    },
                    toJson: function(obj) {
                        
                    },
                    ajaxGet: function(url, params) {
                        var deferred = $q.defer();
                        $http({ url: baseUrl + url, method: "GET", params: prepareParameters(params) })
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function (error, status, headers, config) {
                                if(status === 401){
                                    $state.transitionTo('login');
                                }
                                // processSuccessRequest(deferred, data, status, config);
                                // deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxGetExcel: function(url, params) {
                        var deferred = $q.defer();
                        $http({ url: baseUrl + url, method: "GET", responseType: "arraybuffer", params: prepareParameters(params) })
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function (error, status, headers, config) {
                                if(status === 401){
                                    $state.transitionTo('login');
                                }
                                // processSuccessRequest(deferred, data, status, config);
                                // deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxPost: function(url, params) {
                        var deferred = $q.defer();
                        $http({ url: baseUrl + url, method: "POST", data: prepareParameters(params) })
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxPostToken: function(url, params, header) {
                        var deferred = $q.defer();
                        $http({ url: baseUrl + url, method: "POST", data: prepareParameters(params), headers:header })
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxPostTest: function(url, params) {
                        var deferred = $q.defer();
                        $http({ url: testUrl + url, method: "POST", data: prepareParameters(params) })
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxPostPdf: function(url, params) {
                        var deferred = $q.defer();
                        $http({ url: baseUrl + url, method: "POST", responseType: "arraybuffer", data: prepareParameters(params) })
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxPostPdfToken: function(url, params, header) {
                        var deferred = $q.defer();
                        $http({ url: baseUrl + url, method: "POST", responseType: "arraybuffer", data: prepareParameters(params), headers:header})
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxPut: function(url, params) {
                        var deferred = $q.defer();
                        $http.put(baseUrl + url, prepareParameters(params))
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    },
                    ajaxDelete: function(url, params) {
                        var deferred = $q.defer();
                        $http.delete(baseUrl + url, prepareParameters(params))
                            .success(function (data, status, headers, config) {
                                processSuccessRequest(deferred, data, status, config);
                            })
                            .error(function(error, status, headers, config) {
                                deferred.reject({ message: error, code: status });
                            });
                        return deferred.promise;
                    }
                    // createIncrementalSearch: function () {
                    //     var search = {};
                    //     search.searchQueue = [];
                    //     search.searchInProgress = false;
                    //     search.searchEnqueue = function (action, success) {
                    //         search.searchQueue.push(function () {
                    //             action().then(function (data) {
                    //                 success(data);
                    //                 search.searchInProgress = false;
                    //                 search.searchDequeue();
                    //             }, function (data) {
                    //                 search.searchInProgress = false;
                    //                 search.searchDequeue();
                    //             });
                    //         });
                    //         search.searchDequeue();
                    //     };
                    //     search.searchDequeue = function () {
                    //         if (search.searchInProgress === false && search.searchQueue.length > 0) {
                    //             search.searchInProgress = true;
                    //             search.searchQueue.shift()();
                    //         }
                    //     };
                    //     return search;
                    // },
                    // getIncSearchUrl: function(attrs) {
                    //     if (attrs.mode === 'accounts') {
                    //         return '/api/Account/SearchAccounts';
                    //     }
                    //     if (attrs.mode === 'allUsers') {
                    //         return '/api/User/SearchAllUsers';
                    //     }
                    //     if (attrs.mode === 'accountUsers') {
                    //         return '/api/User/SearchAccountUsers';
                    //     }
                    //     if (attrs.mode === 'accountApiUsers') {
                    //         return '/api/User/SearchApiAccountUsers';
                    //     }
                    //     return null;
                    // }
                };
                return service;
            }
        ]);
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: true, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'},
          { title: 'Russia', id: 'RU', color: layoutColors.danger, customData: '9236', groupId: '4'},
          { title: 'Malaya', id: 'MY', color: layoutColors.danger, customData: '9236', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @ngdoc module
 * @name material.components.tooltip
 */
angular
    .module('material.components.tooltip', [
      'material.core',
      'material.components.panel'
    ])
    .directive('mdTooltip', MdTooltipDirective)
    .service('$$mdTooltipRegistry', MdTooltipRegistry);


/**
 * @ngdoc directive
 * @name mdTooltip
 * @module material.components.tooltip
 * @description
 * Tooltips are used to describe elements that are interactive and primarily
 * graphical (not textual).
 *
 * Place a `<md-tooltip>` as a child of the element it describes.
 *
 * A tooltip will activate when the user hovers over, focuses, or touches the
 * parent element.
 *
 * @usage
 * <hljs lang="html">
 *   <md-button class="md-fab md-accent" aria-label="Play">
 *     <md-tooltip>Play Music</md-tooltip>
 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
 *   </md-button>
 * </hljs>
 *
 * @param {number=} md-z-index The visual level that the tooltip will appear
 *     in comparison with the rest of the elements of the application.
 * @param {expression=} md-visible Boolean bound to whether the tooltip is
 *     currently visible.
 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
 *     after the user hovers over, focuses, or touches the parent element.
 *     Defaults to 0ms on non-touch devices and 75ms on touch.
 * @param {boolean=} md-autohide If present or provided with a boolean value,
 *     the tooltip will hide on mouse leave, regardless of focus.
 * @param {string=} md-direction The direction that the tooltip is shown,
 *     relative to the parent element. Supports top, right, bottom, and left.
 *     Defaults to bottom.
 */
function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
    $mdUtil, $mdPanel, $$mdTooltipRegistry) {

  var ENTER_EVENTS = 'focus touchstart mouseenter';
  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
  var TOOLTIP_DEFAULT_Z_INDEX = 100;
  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
  var TOOLTIP_DIRECTIONS = {
    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
  };

  return {
    restrict: 'E',
    priority: 210, // Before ngAria
    scope: {
      mdZIndex: '=?mdZIndex',
      mdDelay: '=?mdDelay',
      mdVisible: '=?mdVisible',
      mdAutohide: '=?mdAutohide',
      mdDirection: '@?mdDirection' // Do not expect expressions.
    },
    link: linkFunc
  };

  function linkFunc(scope, element, attr) {
    // Set constants.
    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
    var parent = $mdUtil.getParentWithPointerEvents(element);
    var debouncedOnResize = $$rAF.throttle(updatePosition);
    var mouseActive = false;
    var origin, position, panelPosition, panelRef, autohide, showTimeout,
        elementFocusedOnWindowBlur = null;

    // Set defaults
    setDefaults();

    // Set parent aria-label.
    addAriaLabel();

    // Remove the element from its current DOM position.
    element.detach();

    updatePosition();
    bindEvents();
    configureWatchers();

    function setDefaults() {
      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
      }
    }

    function addAriaLabel(labelText) {
      // Only interpolate the text from the HTML element because otherwise the custom text could
      // be interpolated twice and cause XSS violations.
      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);

      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
      // tooltip directive.
      if (
        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
        parent.attr('md-labeled-by-tooltip')
      ) {
        parent.attr('aria-label', interpolatedText);

        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
        if (!parent.attr('md-labeled-by-tooltip')) {
          parent.attr('md-labeled-by-tooltip', tooltipId);
        }
      }
    }

    function updatePosition() {
      setDefaults();

      // If the panel has already been created, remove the current origin
      // class from the panel element.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.removeClass(origin);
      }

      // Set the panel element origin class based off of the current
      // mdDirection.
      origin = 'md-origin-' + scope.mdDirection;

      // Create the position of the panel based off of the mdDirection.
      position = TOOLTIP_DIRECTIONS[scope.mdDirection];

      // Using the newly created position object, use the MdPanel
      // panelPosition API to build the panel's position.
      panelPosition = $mdPanel.newPanelPosition()
          .relativeTo(parent)
          .addPanelPosition(position.x, position.y);

      // If the panel has already been created, add the new origin class to
      // the panel element and update it's position with the panelPosition.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.addClass(origin);
        panelRef.updatePosition(panelPosition);
      }
    }

    function bindEvents() {
      // Add a mutationObserver where there is support for it and the need
      // for it in the form of viable host(parent[0]).
      if (parent[0] && 'MutationObserver' in $window) {
        // Use a mutationObserver to tackle #2602.
        var attributeObserver = new MutationObserver(function(mutations) {
          if (isDisabledMutation(mutations)) {
            $mdUtil.nextTick(function() {
              setVisible(false);
            });
          }
        });

        attributeObserver.observe(parent[0], {
          attributes: true
        });
      }

      elementFocusedOnWindowBlur = false;

      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
      $$mdTooltipRegistry.register('resize', debouncedOnResize);

      scope.$on('$destroy', onDestroy);

      // To avoid 'synthetic clicks', we listen to mousedown instead of
      // 'click'.
      parent.on('mousedown', mousedownEventHandler);
      parent.on(ENTER_EVENTS, enterEventHandler);

      function isDisabledMutation(mutations) {
        mutations.some(function(mutation) {
          return mutation.attributeName === 'disabled' && parent[0].disabled;
        });
        return false;
      }

      function windowScrollEventHandler() {
        setVisible(false);
      }

      function windowBlurEventHandler() {
        elementFocusedOnWindowBlur = document.activeElement === parent[0];
      }

      function enterEventHandler($event) {
        // Prevent the tooltip from showing when the window is receiving
        // focus.
        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
          elementFocusedOnWindowBlur = false;
        } else if (!scope.mdVisible) {
          parent.on(LEAVE_EVENTS, leaveEventHandler);
          setVisible(true);

          // If the user is on a touch device, we should bind the tap away
          // after the 'touched' in order to prevent the tooltip being
          // removed immediately.
          if ($event.type === 'touchstart') {
            parent.one('touchend', function() {
              $mdUtil.nextTick(function() {
                $document.one('touchend', leaveEventHandler);
              }, false);
            });
          }
        }
      }

      function leaveEventHandler() {
        autohide = scope.hasOwnProperty('mdAutohide') ?
            scope.mdAutohide :
            attr.hasOwnProperty('mdAutohide');

        if (autohide || mouseActive ||
            $document[0].activeElement !== parent[0]) {
          // When a show timeout is currently in progress, then we have
          // to cancel it, otherwise the tooltip will remain showing
          // without focus or hover.
          if (showTimeout) {
            $timeout.cancel(showTimeout);
            setVisible.queued = false;
            showTimeout = null;
          }

          parent.off(LEAVE_EVENTS, leaveEventHandler);
          parent.triggerHandler('blur');
          setVisible(false);
        }
        mouseActive = false;
      }

      function mousedownEventHandler() {
        mouseActive = true;
      }

      function onDestroy() {
        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);

        parent
            .off(ENTER_EVENTS, enterEventHandler)
            .off(LEAVE_EVENTS, leaveEventHandler)
            .off('mousedown', mousedownEventHandler);

        // Trigger the handler in case any of the tooltips are
        // still visible.
        leaveEventHandler();
        attributeObserver && attributeObserver.disconnect();
      }
    }

    function configureWatchers() {
      if (element[0] && 'MutationObserver' in $window) {
        var attributeObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'md-visible' &&
                !scope.visibleWatcher ) {
              scope.visibleWatcher = scope.$watch('mdVisible',
                  onVisibleChanged);
            }
          });
        });

        attributeObserver.observe(element[0], {
          attributes: true
        });

        // Build watcher only if mdVisible is being used.
        if (attr.hasOwnProperty('mdVisible')) {
          scope.visibleWatcher = scope.$watch('mdVisible',
              onVisibleChanged);
        }
      } else {
        // MutationObserver not supported
        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
      }

      // Direction watcher
      scope.$watch('mdDirection', updatePosition);

      // Clean up if the element or parent was removed via jqLite's .remove.
      // A couple of notes:
      //   - In these cases the scope might not have been destroyed, which
      //     is why we destroy it manually. An example of this can be having
      //     `md-visible="false"` and adding tooltips while they're
      //     invisible. If `md-visible` becomes true, at some point, you'd
      //     usually get a lot of tooltips.
      //   - We use `.one`, not `.on`, because this only needs to fire once.
      //     If we were using `.on`, it would get thrown into an infinite
      //     loop.
      //   - This kicks off the scope's `$destroy` event which finishes the
      //     cleanup.
      element.one('$destroy', onElementDestroy);
      parent.one('$destroy', onElementDestroy);
      scope.$on('$destroy', function() {
        setVisible(false);
        panelRef && panelRef.destroy();
        attributeObserver && attributeObserver.disconnect();
        element.remove();
      });

      // Updates the aria-label when the element text changes. This watch
      // doesn't need to be set up if the element doesn't have any data
      // bindings.
      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
        scope.$watch(function() {
          return element.text().trim();
        }, addAriaLabel);
      }

      function onElementDestroy() {
        scope.$destroy();
      }
    }

    function setVisible(value) {
      // Break if passed value is already in queue or there is no queue and
      // passed value is current in the controller.
      if (setVisible.queued && setVisible.value === !!value ||
          !setVisible.queued && scope.mdVisible === !!value) {
        return;
      }
      setVisible.value = !!value;

      if (!setVisible.queued) {
        if (value) {
          setVisible.queued = true;
          showTimeout = $timeout(function() {
            scope.mdVisible = setVisible.value;
            setVisible.queued = false;
            showTimeout = null;
            if (!scope.visibleWatcher) {
              onVisibleChanged(scope.mdVisible);
            }
          }, scope.mdDelay);
        } else {
          $mdUtil.nextTick(function() {
            scope.mdVisible = false;
            if (!scope.visibleWatcher) {
              onVisibleChanged(false);
            }
          });
        }
      }
    }

    function onVisibleChanged(isVisible) {
      isVisible ? showTooltip() : hideTooltip();
    }

    function showTooltip() {
      // Do not show the tooltip if the text is empty.
      if (!element[0].textContent.trim()) {
        throw new Error('Text for the tooltip has not been provided. ' +
            'Please include text within the mdTooltip element.');
      }

      if (!panelRef) {
        var attachTo = angular.element(document.body);
        var panelAnimation = $mdPanel.newPanelAnimation()
            .openFrom(parent)
            .closeTo(parent)
            .withAnimation({
              open: 'md-show',
              close: 'md-hide'
            });

        var panelConfig = {
          id: tooltipId,
          attachTo: attachTo,
          contentElement: element,
          propagateContainerEvents: true,
          panelClass: 'md-tooltip ' + origin,
          animation: panelAnimation,
          position: panelPosition,
          zIndex: scope.mdZIndex,
          focusOnOpen: false
        };

        panelRef = $mdPanel.create(panelConfig);
      }

      panelRef.open().then(function() {
        panelRef.panelEl.attr('role', 'tooltip');
      });
    }

    function hideTooltip() {
      panelRef && panelRef.close();
    }
  }

}


/**
 * Service that is used to reduce the amount of listeners that are being
 * registered on the `window` by the tooltip component. Works by collecting
 * the individual event handlers and dispatching them from a global handler.
 *
 * @ngInject
 */
function MdTooltipRegistry() {
  var listeners = {};
  var ngWindow = angular.element(window);

  return {
    register: register,
    deregister: deregister
  };

  /**
   * Global event handler that dispatches the registered handlers in the
   * service.
   * @param {!Event} event Event object passed in by the browser
   */
  function globalEventHandler(event) {
    if (listeners[event.type]) {
      listeners[event.type].forEach(function(currentHandler) {
        currentHandler.call(this, event);
      }, this);
    }
  }

  /**
   * Registers a new handler with the service.
   * @param {string} type Type of event to be registered.
   * @param {!Function} handler Event handler.
   * @param {boolean} useCapture Whether to use event capturing.
   */
  function register(type, handler, useCapture) {
    var handlers = listeners[type] = listeners[type] || [];

    if (!handlers.length) {
      useCapture ? window.addEventListener(type, globalEventHandler, true) :
          ngWindow.on(type, globalEventHandler);
    }

    if (handlers.indexOf(handler) === -1) {
      handlers.push(handler);
    }
  }

  /**
   * Removes an event handler from the service.
   * @param {string} type Type of event handler.
   * @param {!Function} handler The event handler itself.
   * @param {boolean} useCapture Whether the event handler used event capturing.
   */
  function deregister(type, handler, useCapture) {
    var handlers = listeners[type];
    var index = handlers ? handlers.indexOf(handler) : -1;

    if (index > -1) {
      handlers.splice(index, 1);

      if (handlers.length === 0) {
        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
            ngWindow.off(type, globalEventHandler);
      }
    }
  }
}

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author ah
 * created on 18.11.2017
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components.pageTop')
      .controller('pageTopCtrl', PageTopCtrl);
  
    /** @ngInject */
    function PageTopCtrl($scope, $uibModal) {
      $scope.open = function (page, size) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          size: size,
          resolve: {
            items: function () {
              return $scope.items;
            }
          }
        });
      };
    }
  
  
  })();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

angular.module('tooltipDemo', ['ngMaterial'])
    .controller('AppCtrl', AppCtrl);

function AppCtrl($scope) {
  $scope.demo = {
    showTooltip: false,
    tipDirection: 'bottom'
  };

  $scope.demo.delayTooltip = undefined;
  $scope.$watch('demo.delayTooltip', function(val) {
    $scope.demo.delayTooltip = parseInt(val, 10) || 0;
  });
}

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/agency/agency-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="updateAgency()"><div class="row"><div class="form-group col-sm-4"><label>Agency/Firm Name</label> <input type="text" class="form-control" id="agencyName" ng-model="agency.agencyName" style="text-transform:uppercase"></div><div class="form-group col-sm-2"><label for="type">Type</label><select class="form-control" name="type" id="type" ng-model="agency.type" selectpicker=""><option>Postpaid</option><option>Prepaid</option></select></div><div class="form-group col-sm-2"><label>Total User</label> <input type="text" class="form-control" id="userCount" ng-model="agency.userCount" disabled=""></div><div class="form-group col-sm-2"><label>Created Date</label> <input type="text" class="form-control" id="userCount" ng-model="agency.created_at" disabled=""></div><div class="form-group col-sm-12" style="margin-bottom:1px"><label style="font-weight:500">Project Setting</label></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="projectInd" ng-model="agency.projectInd"> <span style="font-size:13px">Mandatory to select Project in Checkout</span></label></div><div class="form-group col-sm-4" ng-if="currentUser.userId == 1"><label style="font-weight:500">Discount Setting</label><ui-select ng-model="discountWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match ng-click="loadDiscount()">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat="discountWithSearch in discountList | filter: $select.search"><span style="white-space:normal;" ng-bind-html="discountWithSearch.desc"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-12"><button type="submit" class="btn btn-primary btn-raised btn-full-width-margin" style="margin-right:5px;">Update Agency Detail</button></div></div></form><h4 class="with-line">User List</h4><div class="table-responsive"><table class="table font-size-13" st-table="userSmartTableData" st-pipe="userFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Joined Date</th><th class="bold-title">User Name</th><th class="bold-title">User Email</th><th class="bold-title">Department</th><th class="bold-title">Role</th><th class="bold-title">Status</th><th class="bold-title align-right">Credit Balance</th></tr></thead><tbody><tr ng-repeat="item in userSmartTableData"><td>{{item.created_at | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.fullName}}</td><td>{{item.email}}</td><td>{{item.deptName}}</td><td>{{item.role}}</td><td>{{item.status}}</td><td class="align-right">{{item.creditBalance | number:2}}</td></tr><tr ng-if="userSmartTableData.length == 0"><td colspan="7"><br><i>No record found</i><br><br></td></tr></tbody><tfoot ng-if="numPages && pages.length >= 2"><tr><td colspan="7" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="manageAgencyUser()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectUserPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom: 7px;"><button type="button" class="btn btn-default btn-full-width-margin" ui-sref="agency.search()" style="margin-right:5px;">Back</button></div></div></div>');
$templateCache.put('app/pages/agency/agency-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Created Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">Created Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label>Agency/Firm Name</label> <input type="text" class="form-control" placeholder="Enter agency/firm name" id="agencyName" ng-model="agencyName"></div></div><div class="col-sm-2"><div class="form-group"><label for="type">Type</label><select class="form-control" name="type" id="type" ng-model="type" selectpicker=""><option value="All" ng-selected="true">All</option><option value="Postpaid">Postpaid</option><option value="Prepaid">Prepaid</option></select></div></div><div class="col-sm-2"><div class="form-group" style="margin-top:25px"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchAgency()" style="margin-right:5px"><i class="fa fa-search" aria-hidden="true"></i> Search</button><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary-border" uib-dropdown-toggle=""><i class="fa fa-cloud-download" aria-hidden="true"></i> Export <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="exportAgencyExcel()"><i class="fa fa-file-excel-o" aria-hidden="true"></i> EXCEL</a></li></ul></div></div></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="agencyData" st-pipe="agencyFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Created Date</th><th class="bold-title">Agency/Firm Name</th><th class="bold-title">Type</th><th class="bold-title text-align-center">Total User</th></tr></thead><tbody><tr ng-repeat="item in agencyData" class="clickable-row" ui-sref="agency.manage({agencyId:\'{{item.id}}\'})"><td>{{item.created_at | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.agencyName}}</td><td>{{item.type}}</td><td class="text-align-center">{{item.userCount}}</td></tr><tr ng-if="agencyData.length == 0"><td colspan="4"><br><i>No record found</i><br><br></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchAgency()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectAgencyPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom: 7px;"><button type="button" class="btn btn-info btn-full-width-margin" ng-click="newAgency()">Add Agency/Firm</button></div></div></div>');
$templateCache.put('app/pages/agency/agency-new.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="createAgency()"><div class="row"><div class="col-sm-6" style="padding-left:0px"><div class="form-group col-sm-8"><label>Agency/Firm Name</label> <input type="text" class="form-control" id="agencyName" name="agencyName" ng-model="agencyName" style="text-transform:uppercase" required=""></div><div class="form-group col-sm-4"><label for="type">Type</label><select class="form-control" ng-model="type" selectpicker="" required=""><option>Postpaid</option><option>Prepaid</option></select></div><div class="form-group col-sm-6" style="margin-bottom:1px"><label style="font-weight:500">Project Settings</label></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="projectInd" ng-model="projectInd"> <span style="font-size:13px">Mandatory to select Project in Checkout</span></label></div><div class="form-group col-sm-12" style="margin-bottom:1px"><label style="font-weight:500">Discount Setting</label></div><div class="col-sm-8"><div class="form-group"><ui-select ng-model="discountWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match ng-click="loadDiscount()">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat="discountWithSearch in discountList | filter: $select.search"><span style="white-space:normal;" ng-bind-html="discountWithSearch.desc"></span></ui-select-choices></ui-select></div></div><div class="form-group col-sm-12" style="margin-bottom:7px"><h4 class="with-line" style="padding-top:0px;margin-bottom:18px"></h4><button type="submit" class="btn btn-primary btn-raised btn-full-width-margin" style="margin-right:5px;">Save</button> <button type="button" class="btn btn-default btn-full-width-margin" ui-sref="agency.search()">Cancel</button></div></div></div></form></div>');
$templateCache.put('app/pages/discount/discount-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="updateDiscount(discountItem)"><div class="row"><div class="form-group col-sm-2"><label>Code</label> <input type="text" class="form-control" id="code" ng-model="discount.code" maxlength="5" required=""></div><div class="form-group col-sm-4"><label>Description</label> <input type="text" class="form-control" id="desc" ng-model="discount.desc" maxlength="100" required=""></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label">Start Date</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="discount.start_date" ng-click="openStartDate()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">End Date</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="discount.end_date" ng-click="openEndDate()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="active" ng-model="discount.active"> <span style="font-size:13px;font-weight:500">Activate Discount</span></label></div></div><h4 class="with-line" style="font-size:15px;margin-bottom:10px;">Discount Item</h4><div class="row"><div class="form-group col-sm-2" style="margin-bottom:10px;"><button type="button" ng-click="prepareDocumentItem()" class="btn btn-sm btn-info btn-full-width-margin">Add Discount Item</button></div></div><div class="table-responsive"><table class="table font-size-13" st-table="discountItem"><thead><tr class="black-muted-bg"><th class="bold-title">#</th><th class="bold-title">Product</th><th width="15%" class="bold-title">Discount Type</th><th width="15%" class="bold-title">Discount Value</th><th width="15%" class="bold-title">Discount Calculation</th><th width="10%" class="bold-title text-center">Active</th></tr></thead><tbody><tr ng-repeat="item in discountItem"><td>{{$index + 1}}</td><td><select class="form-control input-sm" ng-model="item.product"><option ng-repeat="item in productList" value="{{item}}">{{item.name}}</option></select></td><td><select class="form-control input-sm" ng-model="item.discType" ng-disabled=""><option value="A">Amount (RM)</option><option value="P">Percentage (%)</option></select></td><td><input type="number" class="form-control input-sm" ng-model="item.discValue"></td><td><select class="form-control input-sm" ng-model="item.discCalc"><option value="B">Before Tax Calculation</option><option value="A">After Tax Calculation</option></select></td><td class="text-center"><label class="custom-checkbox"><input type="checkbox" ng-model="item.active"> <span>&nbsp;</span></label></td></tr></tbody></table></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom: 7px;"><button type="submit" class="btn btn-primary btn-full-width-margin" style="margin-right:5px">Update Discount</button> <button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="discount.list()">Back</button></div></div></form></div>');
$templateCache.put('app/pages/discount/discount-item.modal.html','<div class="message-modal" ng-controller="discount.controller"><form ng-submit="manageCredit(userData.userId,userData.creditBalance,userData.status,userData.role,userData.note)"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Add Discount Item</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal"><div class="row"><div class="form-group col-sm-6"><label>Product</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-6"><label>CTC</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-6"><label>Discount Type</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-6"><label>Discount Amount</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-6"><label>Discount Rate</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-6"><label>Discount Method</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-6"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"></label></div></div><div class="row"><div class="col-sm-12"><div class="form-group clearfix"><label class="col-sm-3 control-label" style="text-align:left;float:left">Credit Balance</label><div class="col-sm-9"><input type="text" class="form-control" id="oldCreditBalance" ng-model="userData.creditBalance" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label" style="text-align:left;float:left">Transaction Type</label><div class="col-sm-9"><select class="form-control" ng-model="trxType" selectpicker=""><option>Topup Credit</option><option>Refund Credit</option><option>Remove Credit</option></select></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label" ng-if="trxType==\'Topup Credit\'" style="text-align:left;float:left">Topup Amount</label> <label class="col-sm-3 control-label" ng-if="trxType==\'Refund Credit\'" style="text-align:left;float:left">Refund Amount</label> <label class="col-sm-3 control-label" ng-if="trxType==\'Remove Credit\'" style="text-align:left;float:left">Remove Amount</label><div class="col-sm-9" ng-class="{\'has-error\':trxAmtErr}"><input type="number" class="form-control" id="trxAmt" ng-model="trxAmt" step=".01" required=""> <span class="help-block" style="color:#ed7878;font-size:12px;margin-bottom:0px" ng-if="trxAmtErr">{{trxAmtErr}}</span></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label" style="text-align:left;float:left">Remark</label><div class="col-sm-9"><input type="text" class="form-control" id="trxDesc" ng-model="trxDesc" required=""></div></div></div></div><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"> <span>Are you sure you want to <span ng-if="trxType==\'Topup Credit\'">topup</span> <span ng-if="trxType==\'Refund Credit\'">refund</span> <span ng-if="trxType==\'Remove Credit\'">remove</span> credit of <b>RM{{trxAmt || 0 | number:2}}</b> for this user?</span></label><br><br></div><button type="submit" class="btn btn-sm btn-primary" ng-click="this.disabled=true" ng-disabled="confirmTopup == false || confirmTopup == undefined">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></form></div>');
$templateCache.put('app/pages/discount/discount-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label>Code/Description</label> <input type="text" class="form-control" id="searchText" ng-model="searchText"></div><div class="form-group col-sm-2"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchDiscount(null)" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="discountList"><thead><tr class="black-muted-bg"><th class="bold-title">Code</th><th class="bold-title">Description</th><th class="bold-title">Start Date</th><th class="bold-title">End Date</th><th class="bold-title text-center">Active</th></tr></thead><tbody><tr ng-repeat="item in discountList" class="clickable-row" ui-sref="discount.detail({discId:item.id})"><td>{{item.code}}</td><td>{{item.desc}}</td><td>{{item.start_date | date:\'dd/MM/yyyy\'}}</td><td>{{item.end_date | date:\'dd/MM/yyyy\'}}</td><td class="text-center"><label class="custom-checkbox"><input type="checkbox" id="active" ng-model="item.active"> <span>&nbsp;</span></label></td></tr><tr ng-if="discountList.length == 0"><td colspan="5"><br><i>No record found</i><br><br></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchDiscount(null)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="searchDiscount(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom: 7px;"><button type="button" class="btn btn-info btn-full-width-margin" href="" ui-sref="discount.new()">Add Discount</button></div></div></div>');
$templateCache.put('app/pages/discount/discount-new.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="createDiscount(newDiscountItem)"><div class="row"><div class="form-group col-sm-2"><label>Code</label> <input type="text" class="form-control" id="code" ng-model="code" maxlength="5" required=""></div><div class="form-group col-sm-4"><label>Description</label> <input type="text" class="form-control" id="desc" ng-model="desc" maxlength="100" required=""></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label">Start Date</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="startDate" ng-click="openStartDate()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">End Date</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="endDate" ng-click="openEndDate()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="active" ng-model="active"> <span style="font-size:13px;font-weight:500">Activate Discount</span></label></div></div><h4 class="with-line" style="font-size:15px;margin-bottom:10px;">Discount Item</h4><div class="row"><div class="form-group col-sm-2" style="margin-bottom:10px;"><button type="button" ng-click="prepareDocumentItem()" class="btn btn-sm btn-info btn-full-width-margin">Add Discount Item</button></div></div><div class="table-responsive"><table class="table font-size-13" st-table="newDiscountItem"><thead><tr class="black-muted-bg"><th class="bold-title">#</th><th class="bold-title">Product</th><th width="15%" class="bold-title">Discount Type</th><th width="15%" class="bold-title">Discount Value</th><th width="15%" class="bold-title">Discount Calculation</th><th class="bold-title text-center">Active</th></tr></thead><tbody><tr ng-repeat="item in newDiscountItem"><td>{{$index + 1}}</td><td><select class="form-control input-sm" ng-model="item.product" ng-click="getProductList()"><option ng-repeat="item in productList" value="{{item}}">{{item.name}}</option></select></td><td><select class="form-control input-sm" ng-model="item.discType"><option value="A">Amount (RM)</option><option value="P">Percentage (%)</option></select></td><td><input type="number" class="form-control input-sm" ng-model="item.discValue"></td><td><select class="form-control input-sm" ng-model="item.discCalc"><option value="B">Before Tax Calculation</option><option value="A">After Tax Calculation</option></select></td><td class="text-center"><label class="custom-checkbox"><input type="checkbox" ng-model="item.active"> <span>&nbsp;</span></label></td></tr><tr ng-if="newDiscountItem.length == 0"><td colspan="6"><br><i>No discount item found</i><br><br></td></tr></tbody></table></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom: 7px;"><button type="submit" class="btn btn-primary btn-full-width-margin" style="margin-right:5px">Save Discount</button> <button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="discount.list()">Back</button></div></div></form></div>');
$templateCache.put('app/pages/doc-sample/openSampleDocument.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><object ng-if="type==\'Business Profile\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_business_profile_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_profile_en.pdf"></object><object ng-if="type==\'Business Profile\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_business_profile_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_profile_en_ctc.pdf"></object><object ng-if="type==\'Business Profile\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_business_profile_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_profile_my.pdf"></object><object ng-if="type==\'Business Profile\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_business_profile_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_profile_my_ctc.pdf"></object><object ng-if="type==\'Business Certificates\' && lang!=\'MY\' && ctc==true && branch==\'Main\'" type="application/pdf" data="/assets/pdf/sample_business_certificate_main_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_certificate_main_en_ctc.pdf"></object><object ng-if="type==\'Business Certificates\' && lang!=\'MY\' && ctc==true && branch==\'Branch\'" type="application/pdf" data="/assets/pdf/sample_business_certificate_branch_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_certificate_branch_en_ctc.pdf"></object><object ng-if="type==\'Business Certificates\' && lang==\'MY\' && ctc==true && branch==\'Main\'" type="application/pdf" data="/assets/pdf/sample_business_certificate_main_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_certificate_main_my_ctc.pdf"></object><object ng-if="type==\'Business Certificates\' && lang==\'MY\' && ctc==true && branch==\'Branch\'" type="application/pdf" data="/assets/pdf/sample_business_certificate_branch_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_certificate_branch_my_ctc.pdf"></object><object ng-if="type==\'Company Profile\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_company_profile_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_profile_en.pdf"></object><object ng-if="type==\'Company Profile\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_company_profile_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_profile_en_ctc.pdf"></object><object ng-if="type==\'Company Profile\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_company_profile_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_profile_my.pdf"></object><object ng-if="type==\'Company Profile\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_company_profile_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_profile_my_ctc.pdf"></object><object ng-if="type==\'LLP Profile\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_profile_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_profile_en.pdf"></object><object ng-if="type==\'LLP Profile\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_llp_profile_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_profile_my.pdf"></object><object ng-if="type==\'Particular Of Registered Address\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particulars_of_registered_address_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_registered_address_en.pdf"></object><object ng-if="type==\'Particular Of Registered Address\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particulars_of_registered_address_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_registered_address_en_ctc.pdf"></object><object ng-if="type==\'Particular Of Registered Address\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particulars_of_registered_address_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_registered_address_my.pdf"></object><object ng-if="type==\'Particular Of Registered Address\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particulars_of_registered_address_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_registered_address_my_ctc.pdf"></object><object ng-if="type==\'Particular Of Directors/Officers\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particular_of_directors-officers_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_directors-officers_en.pdf"></object><object ng-if="type==\'Particular Of Directors/Officers\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particular_of_directors-officers_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_directors-officers_en_ctc.pdf"></object><object ng-if="type==\'Particular Of Directors/Officers\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particular_of_directors-officers_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_directors-officers_my.pdf"></object><object ng-if="type==\'Particular Of Directors/Officers\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particular_of_directors-officers_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_directors-officers_my_ctc.pdf"></object><object ng-if="type==\'Certificate Of Incorporation/Registration\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_certificate_of_incorporation-registration_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_incorporation-registration_en.pdf"></object><object ng-if="type==\'Certificate Of Incorporation/Registration\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_certificate_of_incorporation-registration_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_incorporation-registration_en_ctc.pdf"></object><object ng-if="type==\'Certificate Of Incorporation/Registration\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_certificate_of_incorporation-registration_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_incorporation-registration_my.pdf"></object><object ng-if="type==\'Certificate Of Incorporation/Registration\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_certificate_of_incorporation-registration_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_incorporation-registration_my_ctc.pdf"></object><object ng-if="type==\'LLP Certificate Of Registration\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/LLP_certificate_registration_sample_EN.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/LLP_certificate_registration_sample_EN.pdf"></object><object ng-if="type==\'Certificate Of Incorporation/Registration\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/LLP_certificate_registration_sample_MY.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/LLP_certificate_registration_sample_MY.pdf"></object><object ng-if="type==\'Certificate Of Change Of Name\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_certificate_of_change_of_name_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_change_of_name_en.pdf"></object><object ng-if="type==\'Certificate Of Change Of Name\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_certificate_of_change_of_name_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_change_of_name_en_ctc.pdf"></object><object ng-if="type==\'Certificate Of Change Of Name\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_certificate_of_change_of_name_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_change_of_name_my.pdf"></object><object ng-if="type==\'Certificate Of Change Of Name\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_certificate_of_change_of_name_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_change_of_name_my_ctc.pdf"></object><object ng-if="type==\'Certificate Of Change Of Name\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_certificate_of_change_of_name_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_certificate_of_change_of_name_my.pdf"></object><object ng-if="type==\'Certificate Of Change Of Name\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_certificate_of_change_of_name_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_certificate_of_change_of_name_en.pdf"></object><object ng-if="type==\'Certificate Of Conversion\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_certificate_of_conversion_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_conversion_en.pdf"></object><object ng-if="type==\'Certificate Of Conversion\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_certificate_of_conversion_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_conversion_en_ctc.pdf"></object><object ng-if="type==\'Certificate Of Conversion\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_certificate_of_conversion_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_conversion_my.pdf"></object><object ng-if="type==\'Certificate Of Conversion\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_certificate_of_conversion_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_certificate_of_conversion_my_ctc.pdf"></object><object ng-if="type==\'LLP Certificate Of Conversion\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_certificate_of_conversion_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_certificate_of_conversion_en.pdf"></object><object ng-if="type==\'LLP Certificate Of Conversion\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_certificate_of_conversion_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_certificate_of_conversion_my.pdf"></object><object ng-if="type==\'Particular Of Share Capital\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particulars_of_share_capital_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_share_capital_en.pdf"></object><object ng-if="type==\'Particular Of Share Capital\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particulars_of_share_capital_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_share_capital_en_ctc.pdf"></object><object ng-if="type==\'Particular Of Share Capital\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particulars_of_share_capital_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_share_capital_my.pdf"></object><object ng-if="type==\'Particular Of Share Capital\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particulars_of_share_capital_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_share_capital_my_ctc.pdf"></object><object ng-if="type==\'Particular Of Shareholders\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particulars_of_shareholders_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_shareholders_en.pdf"></object><object ng-if="type==\'Particular Of Shareholders\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particulars_of_shareholders_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_shareholders_en_ctc.pdf"></object><object ng-if="type==\'Particular Of Shareholders\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particulars_of_shareholders_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_shareholders_my.pdf"></object><object ng-if="type==\'Particular Of Shareholders\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particulars_of_shareholders_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particulars_of_shareholders_my_ctc.pdf"></object><object ng-if="type==\'Financial Historical Comparison\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_financial_historical_comparison_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_historical_comparison_en.pdf"></object><object ng-if="type==\'Financial Historical Comparison\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_financial_historical_comparison_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_historical_comparison_en_ctc.pdf"></object><object ng-if="type==\'Financial Historical Comparison\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_financial_historical_comparison_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_historical_comparison_my.pdf"></object><object ng-if="type==\'Financial Historical Comparison\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_financial_historical_comparison_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_historical_comparison_my_ctc.pdf"></object><object ng-if="type==\'Company Charges\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_company_charges_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_charges_en.pdf"></object><object ng-if="type==\'Company Charges\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_company_charges_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_charges_en_ctc.pdf"></object><object ng-if="type==\'Company Charges\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_company_charges_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_charges_my.pdf"></object><object ng-if="type==\'Company Charges\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_company_charges_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_company_charges_my_ctc.pdf"></object><object ng-if="type==\'Business Expiry Confirmation Letter\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_termination_letter_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_termination_letter_en.pdf"></object><object ng-if="type==\'Business Expiry Confirmation Letter\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_termination_letter_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_termination_letter_en_ctc.pdf"></object><object ng-if="type==\'Business Expiry Confirmation Letter\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_termination_letter_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_termination_letter_my.pdf"></object><object ng-if="type==\'Business Expiry Confirmation Letter\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_termination_letter_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_termination_letter_my_ctc.pdf"></object><object ng-if="type==\'Particular Of Company Secretary\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particular_of_company_secretary_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_company_secretary_en.pdf"></object><object ng-if="type==\'Particular Of Company Secretary\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particular_of_company_secretary_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_company_secretary_en_ctc.pdf"></object><object ng-if="type==\'Particular Of Company Secretary\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particular_of_company_secretary_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_company_secretary_my.pdf"></object><object ng-if="type==\'Particular Of Company Secretary\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particular_of_company_secretary_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_company_secretary_my_ctc.pdf"></object><object ng-if="type==\'Audit Firm Profile\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_audit_firm_profile_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_audit_firm_profile_en.pdf"></object><object ng-if="type==\'Audit Firm Profile\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_audit_firm_profile_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_audit_firm_profile_en_ctc.pdf"></object><object ng-if="type==\'Audit Firm Profile\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_audit_firm_profile_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_audit_firm_profile_my.pdf"></object><object ng-if="type==\'Audit Firm Profile\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_audit_firm_profile_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_audit_firm_profile_my_ctc.pdf"></object><object ng-if="type==\'Attestation of Company Good Standing\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_acgs_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_acgs_en.pdf"></object><object ng-if="type==\'Attestation of Company Good Standing\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_acgs_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_acgs_en.pdf"></object><object ng-if="type==\'Attestation of Company Good Standing\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_acgs_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_acgs_my.pdf"></object><object ng-if="type==\'Attestation of Company Good Standing\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_acgs_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_acgs_my.pdf"></object><object ng-if="type==\'Attestation of LLP Good Standing\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_attestation_of_llp_good_standing_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_attestation_of_llp_good_standing_en.pdf"></object><object ng-if="type==\'Attestation of LLP Good Standing\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_llp_attestation_of_llp_good_standing_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_llp_attestation_of_llp_good_standing_my.pdf"></object><object ng-if="type==\'Financial Comparison 2 Years\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_financial_2_years_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_2_years_en.pdf"></object><object ng-if="type==\'Financial Comparison 3 Years\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_financial_3_years_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_3_years_en.pdf"></object><object ng-if="type==\'Financial Comparison 5 Years\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_financial_5_years_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_5_years_en.pdf"></object><object ng-if="type==\'Financial Comparison 10 Years\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_financial_10_years_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_financial_10_years_en.pdf"></object><object ng-if="type==\'Shareholder Listing And Analysis\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_shareholder_listing_and_analysis_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_shareholder_listing_and_analysis_en.pdf"></object><object ng-if="type==\'Shareholder Listing And Analysis\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_shareholder_listing_and_analysis_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_shareholder_listing_and_analysis_en_ctc.pdf"></object><object ng-if="type==\'Shareholder Listing And Analysis\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_shareholder_listing_and_analysis_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_shareholder_listing_and_analysis_my.pdf"></object><object ng-if="type==\'Shareholder Listing And Analysis\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_shareholder_listing_and_analysis_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_shareholder_listing_and_analysis_my_ctc.pdf"></object><object ng-if="type==\'Particular Of Change Of Company Name\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particular_of_change_of_company_name_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_change_of_company_name_en.pdf"></object><object ng-if="type==\'Particular Of Change Of Company Name\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particular_of_change_of_company_name_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_change_of_company_name_en_ctc.pdf"></object><object ng-if="type==\'Particular Of Change Of Company Name\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_particular_of_change_of_company_name_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_change_of_company_name_my.pdf"></object><object ng-if="type==\'Particular Of Change Of Company Name\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_particular_of_change_of_company_name_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_particular_of_change_of_company_name_my_ctc.pdf"></object><object ng-if="type==\'Business Re-Register Confirmation Letter\' && lang!=\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_business_reregister_confirmation_letter_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_reregister_confirmation_letter_en.pdf"></object><object ng-if="type==\'Business Re-Register Confirmation Letter\' && lang!=\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_business_reregister_confirmation_letter_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_reregister_confirmation_letter_en_ctc.pdf"></object><object ng-if="type==\'Business Re-Register Confirmation Letter\' && lang==\'MY\' && ctc==false" type="application/pdf" data="/assets/pdf/sample_business_reregister_confirmation_letter_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_reregister_confirmation_letter_my.pdf"></object><object ng-if="type==\'Business Re-Register Confirmation Letter\' && lang==\'MY\' && ctc==true" type="application/pdf" data="/assets/pdf/sample_business_reregister_confirmation_letter_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/sample_business_reregister_confirmation_letter_my_ctc.pdf"></object></div></div>');
$templateCache.put('app/pages/doc-sample/sampleBusinessCertBranch.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><object type="application/pdf" data="/assets/pdf/sample_business_certificate_branch_en_ctc.pdf" style="width:100%;height:100vh;">Unsupported browser</object></div></div>');
$templateCache.put('app/pages/doc-sample/sampleBusinessCertMain.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><object type="application/pdf" data="/assets/pdf/sample_business_certificate_main_en_ctc.pdf" style="width:100%;height:100vh;">Unsupported browser</object></div></div>');
$templateCache.put('app/pages/doc-sample/sampleNotFound.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body">No sample to display</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/doc-sample/sampleProfile.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><object type="application/pdf" data="/assets/pdf/sample_company_profile_en.pdf" style="width:100%;height:100vh;">Unsupported browser</object></div></div>');
$templateCache.put('app/pages/doc-sample/sampleProfileROB.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><object type="application/pdf" data="/assets/pdf/sample_business_profile_en.pdf" style="width:100%;height:100vh;">Unsupported browser</object></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/document/cart-empty.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Are you sure to empty your cart?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); removeAllItem()">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/document/cart-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row" ng-if="!paymentUrl"><div class="col-md-6 form-group" style="margin-top:7px" ng-if="docTableData.length > 0"><button type="button" class="btn btn-primary-border" ng-click="emptyCartModal()" style="margin-right:5px">Empty Cart</button> <button type="button" class="btn btn-info btn-raised btn-full-width" href="" ui-sref="entity.search()">Add More Document</button></div></div><div class="horizontal-scroll"><table class="table font-size-13" st-table="docTableData" st-pipe="docPipe"><thead><tr class="black-muted-bg" ng-if="docTableData.length > 0"><th class="bold-title text-align-right"></th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title text-align-center">Language</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr><tr class="black-muted-bg" ng-if="docTableData.length == 0"><td colspan="7" class="bold-title"><i>Your cart is empty</i></td></tr></thead><tbody><tr ng-repeat="item in docTableData track by $index"><td ng-if="item.documentType != \'Service Charge\'" class="text-align-right"><a href="" ng-click="removeItemModal($index, item.id, item.entityNumber, item.type, item.entityType)" ng-if="!paymentUrl"><i class="ion-close-round" aria-hidden="true" title="Remove this document" style="font-size:15px;"></i></a></td><td ng-if="item.documentType == \'Service Charge\'"></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="docTableData.length == 0"><td></td><td colspan="5" class="text-center"><br><button type="button" class="btn btn-info btn-raised" data-toggle="modal" href="" ui-sref="entity.search()">Add Document</button><br><br></td><td></td></tr><tr ng-if="docTableData.length > 0"><td colspan="3" class="text-align-left"><br><br><br><i>* Service Tax of 8% impose on Service Fee and CTC Service Fee as per Service Tax Act 2018</i></td><td colspan="3" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude SST) (RM) :</b><br><b>SST @ 8% for Service Fee (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{orderCount}}</b><br><b>{{untaxedAmount | number:2}}</b><br><b>{{taxAmount | number:2}}</b><br><b>{{totalAmount | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="7" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="docList()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectDocPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row" ng-if="docTableData.length > 0"><div class="form-group col-md-12" style="margin-bottom:7px" ng-if="!paymentUrl && isPI"><label class="custom-checkbox"><input type="checkbox" id="agreePI" ng-model="agreePI" ng-change="onchangeAgreePI(agreePI)"> <span style="font-weight:400">&nbsp;I, hereby confirm and agree that:</span></label><ol style="font-size:13px;line-height:30px;"><li>The ID number given is correct. By purchasing personal involvement, fee will be charge for any information result.</li><li>As an applicant to the corporate information related to personal involvements of individuals in businesses, companies and limited liability partnerships registered with SSM, I shall subject to the relevant provisions of the Personal Data Protection Act 2010 (Act 709).</li><li>Fully responsible for the usage of information supplied by SSM.</li></ol></div><div class="form-group col-md-12" style="margin-bottom:7px" ng-if="!paymentUrl"><span ng-if="!isPI"><button type="button" class="btn btn-primary btn-raised btn-full-width-margin" ng-click="generatePaymentUrl()">Generate Payment URL</button></span><span ng-if="isPI && agreePI"><button type="button" class="btn btn-primary btn-raised btn-full-width-margin" ng-click="generatePaymentUrl()">Generate Payment URL</button></span> <span ng-if="isPI && !agreePI"><button type="button" class="btn btn-primary btn-raised btn-full-width-margin" disabled="">Generate Payment URL</button></span></div><div class="form-group col-sm-12" ng-if="paymentUrl"><label>Transaction Reference:</label><div style="font-size:16px;font-weight:700">{{transactionRef}}</div></div><div class="form-group col-sm-6" ng-if="paymentUrl"><label for="inputNumber">Payment URL:</label><div style="font-size:13px;font-weight:500;overflow-wrap:break-word;">{{paymentUrl}}</div></div></div></div>');
$templateCache.put('app/pages/document/cart-remove.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Are you sure to remove this item?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); removeItem(itemCartIndex,itemCartId,itemCartEntityNo,itemCartType,itemCartEntityType)">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/document/checkout-insufficient-credit.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Insufficient Credit</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Your current credit balance is <b>RM{{paymentItems.billing.creditBalance | number:2}}</b><br><br>In order to proceed, please top up your credit balance or remove some items in cart.<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Close</button></div></div>');
$templateCache.put('app/pages/document/checkout-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="horizontal-scroll" style="margin-top:7px"><table class="table font-size-13" st-table="checkoutData" st-pipe="checkoutPipe"><thead><tr class="black-muted-bg"><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title text-align-center">Language</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in checkoutData track by $index"><td ng-if="item.documentType == \'Service Charge\'"></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}}</span><br>{{item.entityName}}</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="checkoutData.length == 0"><td colspan="6"><br><span><i>No record found</i></span><br><br></td></tr><tr ng-if="checkoutData.length > 0"><td colspan="2" class="text-align-left"><br><br><br><i>* Service Tax of 8% impose on Service Fee and CTC Service Fee as per Service Tax Act 2018</i></td><td colspan="3" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude SST) (RM) :</b><br><b>SST @ 8% for Service Fee (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{itemCount}}</b><br><b>{{untaxedAmount | number:2}}</b><br><b>{{taxAmount | number:2}}</b><br><b>{{totalAmount | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="7" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchCheckout()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectCheckoutPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" ng-if="checkoutData.length > 0" style="padding-top:4px"></h4><div class="row" ng-if="checkoutData.length > 0"><div class="col-sm-6"><div class="form-group col-md-6" style="margin-bottom:5px"><div class="form-group" style="margin-bottom:5px"><label for="address1" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Billing Information</label> <input type="text" class="input-sm form-control" placeholder="Billing Name" ng-model="billingData.fullName"></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="Address Line 1" ng-model="billingData.address1"></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="Address Line 2" ng-model="billingData.address2"></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="Address Line 3" ng-model="billingData.address3"></div><div class="form-group col-md-4" style="margin-bottom:5px;padding-left:0px;padding-right:5px"><input type="text" class="input-sm form-control" placeholder="Postcode" ng-model="billingData.postcode" maxlength="6"></div><div class="form-group col-md-8" style="margin-bottom:5px;padding-left:0px;padding-right:0px"><input type="text" class="input-sm form-control" placeholder="City" ng-model="billingData.city"></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="State" ng-model="billingData.state"></div></div></div></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button ng-if="checkoutData.length > 0" type="button" class="btn btn-primary btn-raised btn-full-width-margin" ng-click="checkCheckout()" style="margin-right:5px">Proceed Payment</button></div></div></div>');
$templateCache.put('app/pages/document/checkout-pi.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:15px;font-weight:500;margin-top:0px;margin-bottom:0px;text-align:left;">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal;text-align:left;font-size:13px;font-weight:300">Please verify that the entered ID, selected type of involvement, and chosen product type are correct.<br><br>Are you sure you want to proceed?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px;text-align:right;"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss();generatePaymentUrl()">Confirm</button></div></div>');
$templateCache.put('app/pages/document/checkout-process.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirm Purchase</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Are you sure you want to purchase this document for <b>RM{{paymentItems.totalAmount | number:2}}?</b><br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); processCheckoutItem(paymentItems)">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/document/order-account-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDocType">Product Type</label><ui-select ng-model="docTypeWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Product Type" ng-click="loadDocType()">{{$select.selected.documentName}}</ui-select-match><ui-select-choices repeat="docTypeWithSearch in docType | filter: $select.search"><span style="white-space:normal;" ng-bind-html="docTypeWithSearch.documentName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label>User</label><ui-select ng-model="agencyUserWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadAgencyUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="agencyUserWithSearch in userOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="agencyUserWithSearch.fullName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Order Reference</label> <input type="text" class="form-control" placeholder="Entity/Order/Invoice" id="orderRef" ng-model="orderRef"></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Transaction Reference</label> <input type="text" class="form-control" placeholder="Transaction Reference" id="trxRef" ng-model="trxRef"></div></div></div><div class="row"><div class="col-sm-2"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="agencyUserOrderSearch(true,null,null,null,null,null)"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div></div><div class="row"><div class="col-sm-12" style="margin-bottom:5px"><i><b>Orders available to be downloaded within 7 days from date of purchase.</b></i></div></div><div class="table-responsive mobile-view-hide"><table class="table font-size-13" st-table="agencyUserOrderData" st-pipe="agencyUserOrderFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">User Name</th><th class="bold-title">Order Number</th><th class="bold-title">Billing Name</th><th class="bold-title">Product Description</th><th class="bold-title">Entity Number / Name</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in agencyUserOrderData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><span ng-if="item.invoiceNumber"><a href="" ng-click="downloadInvoice(item.invoiceNumber)" ng-controller="invoice.controller" title="Donload Invoice">{{item.trx_ref}}</a></span> <span ng-if="!item.invoiceNumber">{{item.trx_ref}}</span></td><td>{{item.fullName}}</td><td>{{item.orderNumber}}</td><td>{{item.customerName}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="error-color">Unsuccessful</span> <span ng-if="item.status == \'Waiting\'" class="warning-color">Waiting Payment</span></td><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\' || item.status == \'Waiting\'"></span></td><td class="text-align-center"><span ng-if="item.status == \'Processing\' || item.status == \'Success\' || item.status == \'Waiting\'"></span> <span ng-if="item.status == \'Failed\'"><span ng-if="item.orderNumber && item.orderStatus != \'Failed\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber && item.orderStatus != \'Failed\'"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">RESUPPLY</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span></span></td></tr><tr ng-if="agencyUserOrderData.length == 0"><td colspan="11"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="agencyUserOrderSearch(true,null,null,null,null,null)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="agencyUserOrderSearch(true,null,null,null,null,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show"><table class="table font-size-13" st-table="agencyUserOrderData" st-pipe="agencyUserOrderFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Download</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Status</th><th class="bold-title">Language</th><th class="bold-title">Purchase Date</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">User Name</th><th class="bold-title">Order Number</th><th class="bold-title">Billing Name</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in agencyUserOrderData track by $index"><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="error-color">Unsuccessful</span> <span ng-if="item.status == \'Waiting\'" class="warning-color">Waiting Payment</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><span ng-if="item.invoiceNumber"><a href="" ng-click="downloadInvoice(item.invoiceNumber)" ng-controller="invoice.controller" title="Donload Invoice">{{item.trx_ref}}</a></span> <span ng-if="!item.invoiceNumber">{{item.trx_ref}}</span></td><td>{{item.fullName}}</td><td>{{item.orderNumber}}</td><td>{{item.customerName}}</td><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td class="text-align-center"><span ng-if="item.status == \'Processing\' || item.status == \'Success\'"></span> <span ng-if="item.status == \'Failed\'"><span ng-if="item.orderNumber && item.orderStatus != \'Failed\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber && item.orderStatus != \'Failed\'"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">RESUPPLY</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span></span></td></tr><tr ng-if="agencyUserOrderData.length == 0"><td colspan="12"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="12" class="text-left"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="agencyUserOrderSearch(true,null,null,null,null,null)"></select></div><span style="float:right;padding-top:11px">Rows on page</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="agencyUserOrderSearch(true,null,null,null,null,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/document/order-all-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDocType">Product Type</label><ui-select ng-model="docTypeWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Product Type" ng-click="loadDocType()">{{$select.selected.documentName}}</ui-select-match><ui-select-choices repeat="docTypeWithSearch in docType | filter: $select.search"><span style="white-space:normal;" ng-bind-html="docTypeWithSearch.documentName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label>User</label><ui-select ng-model="userWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="userWithSearch in userOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="userWithSearch.fullName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="orderStatus">Status</label><select class="form-control" name="rptOrderStatus" id="orderStatus" ng-model="orderStatus" selectpicker=""><option ng-selected="true">All</option><option value="Success">Success</option><option value="Processing">Processing</option><option value="Failed">Unsuccessful</option></select></div></div></div><div class="row"><div class="col-sm-2"><div class="form-group"><label for="entityRef">Entity Number/Name</label> <input type="text" class="form-control" placeholder="Enter entity number/name" id="entityRef" ng-model="entityRef"></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Invoice/Order Number</label> <input type="text" class="form-control" placeholder="Enter invoice/order number" id="orderRef" ng-model="orderRef"></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Transaction Reference</label> <input type="text" class="form-control" placeholder="Enter transaction reference" id="trxRef" ng-model="trxRef"></div></div><div class="col-md-2"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchAllOrder(true,null,null,null,null,null,null,null)" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div></div><div class="row"><div class="col-sm-12" style="margin-bottom:5px"><i><b>Orders available to be downloaded within 7 days from date of purchase.</b></i></div></div><div class="horizontal-scroll"><table class="table font-size-13" st-table="allOrderData" st-pipe="allOrderPipe"><thead><tr class="black-muted-bg"><th class="bold-title" width="7%">Purchase Date</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">User Name</th><th class="bold-title">Order/Invoice No.</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number/Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title" width="7.5%">Status</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in allOrderData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><a href="" ui-sref="transaction.allDetail({transId:\'{{item.trx_id}}\'})" title="View Transaction Detail">{{item.trx_ref}}</a><br>{{item.payment_ref}}</td><td>{{item.fullName}}</td><td>{{item.orderNumber}}<br><a href="" ng-click="downloadInvoice(item.invoiceNumber)" ng-controller="invoice.controller" title="Download Invoice">{{item.invoiceNumber}}</a></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}} <img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="error-color">Unsuccessful</span> <span ng-if="item.status == \'Waiting\'" class="warning-color">Waiting Payment</span></td><td><span class="text-align-center" ng-if="item.status == \'Success\' && item.documentType != \'Service Charge\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span></td><td class="text-align-center"><span ng-if="item.status == \'Success\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)">RESUPPLY</button> <span ng-if="item.submitCode == \'11\'"><button class="btn btn-xs btn-success-border" ng-click="resubmitOrderCTC(item.id)">RESUBMIT</button></span></span> <span ng-if="item.status == \'Failed\' && item.orderStatus != \'Failed\'"><span ng-if="item.orderNumber"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">REREQUEST</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">REPROCESS</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">REPROCESS</button></span></span></span></td></tr><tr ng-if="allOrderData.length == 0"><td colspan="11"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchAllOrder(true,null,null,null,null,null,null,null)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="searchAllOrder(true,null,null,null,null,null,null,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/document/order-summary.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2" ng-if="trxSummaryData.invNo && currentUser.role != \'SSM Admin\'"><label>Invoice Number</label> <input type="text" class="form-control" id="invoice_no" ng-model="trxSummaryData.invNo" readonly=""></div><div class="form-group col-sm-4" ng-if="trxSummaryData.projectName"><label>Project Code/Name</label> <input type="text" class="form-control" id="projectName" ng-model="trxSummaryData.projectName" readonly=""></div></div><div class="row"><div class="col-sm-12" style="margin-bottom:5px"><i><b>Orders available to be downloaded within 7 days from date of purchase.</b></i></div></div><div class="table-responsive mobile-view-hide"><table class="table font-size-13" st-table="stOrderSummaryData" st-pipe="stOrderSummaryFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title">Product Description</th><th class="bold-title" style="min-width:300px">Entity Number / Name</th><th class="bold-title">Language</th><th class="bold-title" width="8%">Status</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in stOrderSummaryData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td class="">{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-center"><span ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td class="text-align-center"><span ng-if="item.status == \'Processing\' || item.status == \'Success\'"></span> <span ng-if="item.status == \'Failed\'"><span ng-if="item.orderNumber && item.orderStatus != \'Failed\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber && item.orderStatus != \'Failed\'"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">RESUPPLY</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span></span></td></tr><tr ng-if="stOrderSummaryData.length == 0"><td colspan="8"><br><span><i>No record found</i></span><br></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="loadOrderSummary(true,null)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="loadOrderSummary(true,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show"><table class="table font-size-13" st-table="stOrderSummaryData" st-pipe="stOrderSummaryFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Download</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title">Status</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in stOrderSummaryData track by $index"><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td class="text-align-center"><span ng-if="item.status == \'Processing\' || item.status == \'Success\'"></span> <span ng-if="item.status == \'Failed\'"><span ng-if="item.orderNumber && item.orderStatus != \'Failed\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber && item.orderStatus != \'Failed\'"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">RESUPPLY</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span></span></td></tr><tr ng-if="stOrderSummaryData.length == 0"><td colspan="9"><br><span><i>No record found</i></span><br></td></tr></tbody><tfoot><tr><td colspan="9" class="text-left"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="loadOrderSummary(true,null)"></select></div><span style="float:right;padding-top:11px">Rows on page</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="loadOrderSummary(true,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button ng-if="currentUser.role == \'Normal User\' || currentUser.role == \'SSM Admin\'" type="button" href="" ui-sref="document.download()" class="btn btn-primary btn-raised btn-full-width-margin" style="margin-right:5px">View Order List</button> <button ng-if="currentUser.role == \'Account Admin\'" type="button" href="" ui-sref="document.order()" class="btn btn-primary btn-raised btn-full-width-margin" style="margin-right:5px">View Order List</button> <button ng-if="currentUser.role == \'Administrator\' || currentUser.role == \'Support Admin\'" type="button" href="" ui-sref="document.all()" class="btn btn-primary btn-raised btn-full-width-margin" style="margin-right:5px">View Order List</button> <button ng-if="currentUser.role != \'SSM Admin\' && trxSummaryData.invReady" type="button" ng-click="downloadInvoice(trxSummaryData.invNo)" ng-controller="invoice.controller" class="btn btn-primary-border btn-full-width-margin" style="margin-right:5px">Invoice</button></div></div></div>');
$templateCache.put('app/pages/document/order-user-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDocType">Product Type</label><ui-select ng-model="docTypeWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Product Type" ng-click="loadDocType()">{{$select.selected.documentName}}</ui-select-match><ui-select-choices repeat="docTypeWithSearch in docType | filter: $select.search"><span style="white-space:normal;" ng-bind-html="docTypeWithSearch.documentName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Order Reference</label> <input type="text" class="form-control" placeholder="Entity/Order/Invoice" id="orderRef" ng-model="orderRef"></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Transaction Reference</label> <input type="text" class="form-control" placeholder="Transaction Reference" id="trxRef" ng-model="trxRef"></div></div><div class="col-sm-2"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchDocument(true,null,null,null,null,null)" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div></div><div class="row"><div class="col-sm-12" style="margin-bottom:5px"><i><b>Orders available to be downloaded within 7 days from date of purchase.</b></i></div></div><div class="table-responsive mobile-view-hide"><table class="table font-size-13" st-table="docDownloadTableData" st-pipe="docDownloadFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">Order Number</th><th class="bold-title">Billing Name</th><th class="bold-title">Product Description</th><th class="bold-title" style="min-width:300px">Entity Number / Name</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in docDownloadTableData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><span ng-if="item.invoiceNumber"><a href="" ng-click="downloadInvoice(item.invoiceNumber)" ng-controller="invoice.controller" title="Donload Invoice">{{item.trx_ref}}</a></span> <span ng-if="!item.invoiceNumber">{{item.trx_ref}}</span></td><td>{{item.orderNumber}}</td><td>{{item.customerName}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td class="">{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="error-color">Unsuccessful</span> <span ng-if="item.status == \'Waiting\'" class="warning-color">Waiting Payment</span></td><td class="text-align-center"><span ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td class="text-align-center"><span ng-if="item.status == \'Processing\' || item.status == \'Success\'"></span> <span ng-if="item.status == \'Failed\'"><span ng-if="item.orderNumber && item.orderStatus != \'Failed\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber && item.orderStatus != \'Failed\'"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">RESUPPLY</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span></span></td></tr><tr ng-if="docDownloadTableData.length == 0"><td colspan="10"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchDocument(true,null,null,null,null,null)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="searchDocument(true,null,null,null,null,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show"><table class="table font-size-13" st-table="docDownloadTableData" st-pipe="docDownloadFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Download</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Status</th><th class="bold-title">Language</th><th class="bold-title">Purchase Date</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">Order Number</th><th class="bold-title">Billing Name</th><th class="bold-title text-align-center">Download</th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in docDownloadTableData track by $index"><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="error-color">Unsuccessful</span> <span ng-if="item.status == \'Waiting\'" class="warning-color">Waiting Payment</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><span ng-if="item.invoiceNumber"><a href="" ng-click="downloadInvoice(item.invoiceNumber)" ng-controller="invoice.controller" title="Donload Invoice">{{item.trx_ref}}</a></span> <span ng-if="!item.invoiceNumber">{{item.trx_ref}}</span></td><td>{{item.orderNumber}}</td><td>{{item.customerName}}</td><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadFile(item)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td class="text-align-center"><span ng-if="item.status == \'Processing\' || item.status == \'Success\'"></span> <span ng-if="item.status == \'Failed\'"><span ng-if="item.orderNumber && item.orderStatus != \'Failed\'"><button class="btn btn-xs btn-primary-border" ng-click="resupplyOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span> <span ng-if="!item.orderNumber && item.orderStatus != \'Failed\'"><span ng-if="item.purchaseInfoId"><span ng-if="item.transactionStatus != \'SUCCESS\' && item.transactionStatus != \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="rerequestOrder(item.userId, item.trx_id, item.invoiceNumber, item.processDate)">RESUPPLY</button></span> <span ng-if="item.transactionStatus == \'SUCCESS\' || item.transactionStatus == \'PENDING\'"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span> <span ng-if="!item.purchaseInfoId"><button class="btn btn-xs btn-primary-border" ng-click="reprocessOrder(item.id)" ng-disabled="item.retryStatus==\'Waiting\'||item.retryStatus==\'Closed\'">RESUPPLY</button></span></span></span></td></tr><tr ng-if="docDownloadTableData.length == 0"><td colspan="11"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="11" class="text-left"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchDocument(true,null,null,null,null,null)"></select></div><span style="float:right;padding-top:11px">Rows on page</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="searchDocument(true,null,null,null,null,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><br></div>');
$templateCache.put('app/pages/document/payment-confirmation.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Status<br><span ng-if="paymentDetail.paymentStatus==\'Success\'" class="success-color"><b><i class="ion-checkmark-circled" style="padding-right:5px"></i>Successful Payment</b></span> <span ng-if="paymentDetail.paymentStatus==\'Failed\'" class="warning-color"><b><i class="ion-alert-circled" style="padding-right:5px"></i>Unsuccessful Payment</b></span><br><br><span ng-if="paymentDetail.paymentStatus==\'Success\'">Invoice No. / Payment Ref.<br><b>{{paymentDetail.invoiceNo}} / {{paymentDetail.paymentRef}}</b><br></span> <span ng-if="paymentDetail.paymentStatus==\'Failed\'">Message<br><b>{{paymentDetail.errMsg}}</b><br></span><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button ng-if="paymentDetail.paymentStatus==\'Success\'" type="button" class="btn btn-sm btn-default" ng-click="$dismiss();loadOrderSummary()">Close</button> <button ng-if="paymentDetail.paymentStatus==\'Failed\'" type="button" class="btn btn-sm btn-default" ng-click="$dismiss();searchCheckout()">Close</button></div></div>');
$templateCache.put('app/pages/entity/brcl-modal.html','<div class="modal-content"><form ng-submit="getCheckReregister()"><div class="modal-header"><div class="modal-title" id="myModalLabel" style="font-size:16px; font-weight:bold; margin-top:0; margin-bottom:0;"><span>Check Availability</span></div></div><hr style="margin: 0; border: 1px solid #ddd;"><div class="modal-body"><div ng-if="alert" class="alert bg-danger"><strong>We`re sorry!</strong><br>This business is not eligible to purchase the business re-register confirmation letter</div><div ng-if="success" class="alert bg-success"><strong>New registration number and old registration number match, you can proceed to purchase.</strong></div><div class="form-horizontal"><div class="form-group" style="display: flex; justify-content: space-between;"><div style="width: 47%;"><label for="oldBrNo" class="control-label">Previous Registration Number</label> <input type="text" class="form-control" id="oldBrNo" placeholder="" ng-model="oldBrNo"><div style="margin: 6px 0 0 12px; font-size: 11px; font-weight: 500;">{{oldBrName}}</div></div><div style="width: 47%;"><label for="newBrNo" class="control-label">Current Registration Number</label> <input type="text" class="form-control" id="newBrNo" placeholder="" ng-model="newBrNo"><div style="margin: 6px 0 0 12px; font-size: 11px; font-weight: 500;">{{newBrName}}</div></div></div><div style="margin-top: 20px; font-size: 12px; color: #aaa7a7;"><b>NOTE:</b> Please enter ONLY the business registration number to continue. Example: IP0288003 or 200903127790.</div></div></div><div class="modal-footer" style="background:#f5f5f5; padding-top: 10px; padding-bottom: 10px;"><div ng-if="!proceed" style="font-size:14px;"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()" style="margin-top: 10px; margin-bottom: 10px; margin-right: 5px;">Close</button> <button ng-disabled="proceed" type="submit" class="btn btn-sm btn-primary" style="margin-top: 10px; margin-bottom: 10px;">Submit</button></div><div ng-if="proceed" style="font-size:14px;"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()" style="margin-top: 10px; margin-bottom: 10px; margin-right: 5px;">Close</button></div></div></form></div>');
$templateCache.put('app/pages/entity/check-order.modal.html','<div class="message-modal" ng-controller="order.controller"><div class="modal-header"></div><div class="modal-body"><div style="margin:0 20px;font-size:14px;line-height:normal"><span ng-if="!verId && !branchId && !endDate1 && !endDate2">You already purchased <b>{{type}} <span ng-if="ctc == true">CTC</span> ({{lang | uppercase}})</b> for <b>{{entityName}} ({{entityNo}})</b>.</span> <span ng-if="verId">You already purchased <b>Document & Form <span ng-if="ctc == true">CTC</span> - {{docType}} / {{docName}} ({{docDate | date:\'dd/MM/yyyy\'}})</b> for <b>{{entityName}} ({{entityNo}})</b>.</span> <span ng-if="branchId">You already purchased <b>{{type}} <span ng-if="ctc == true">CTC</span> ({{lang | uppercase}}) - {{branch | uppercase}} / {{docName}}</b> for <b>{{entityName}} ({{entityNo}})</b>.</span> <span ng-if="endDate1 && endDate2">You already purchased <b>{{type}} <span ng-if="ctc == true">CTC</span> ({{lang | uppercase}}) - ({{endDate1 | date:\'yyyy\'}} & {{endDate2 | date:\'yyyy\'}})</b> for <b>{{entityName}} ({{entityNo}})</b>.</span><br><br><h4 class="with-line"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button ng-if="role==\'Normal User\'||role==\'SSM Admin\'" type="button" class="btn btn-sm btn-primary" ng-click="$dismiss()" ui-sref="document.download()">View Order</button> <button ng-if="role==\'Account Admin\'" type="button" class="btn btn-sm btn-primary" ng-click="$dismiss()" ui-sref="document.order()">View Order</button> <button ng-if="role==\'Administrator\'" type="button" class="btn btn-sm btn-primary" ng-click="$dismiss()" ui-sref="document.all()">View Order</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Close</button></div></div>');
$templateCache.put('app/pages/entity/entity-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row" style="margin-top:5px"><div class="form-group col-sm-6"><label for="inputCompany">Entity Name</label><div style="font-size:18px;font-weight:900">{{entity.entity_name}}</div></div><div class="form-group col-sm-3"><label for="inputNumber">Entity Number</label><div style="font-size:18px;font-weight:900">{{entity.entity_number}}</div></div><div class="form-group col-sm-1"><label for="inputType">Entity Type</label><div style="font-size:18px;font-weight:900">{{entity.entity_type | uppercase}}</div></div><div class="form-group col-sm-2" style="text-align:right"><button type="button" class="btn btn-primary btn-full-width-margin btn-form" href="" ui-sref="entity.search()" style="margin-top:7px">Change Entity</button></div></div><h4 class="with-line" style="padding-top:5px"></h4><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Profile" ng-if="entity.entity_type == \'Company\'"><div style="text-align:center" ng-if="!profileDocSrc || profileDocSrc.length == 0"><p><i>Unsuccessful to load this document</i></p><button type="button" class="btn btn-info btn-sm" data-toggle="modal" ng-click="getProfileDocList()"><i class="fa fa-refresh" aria-hidden="true"></i> Reload Document</button><p></p></div><div class="table-responsive mobile-view-hide" ng-if="profileDocSrc.length > 0"><table class="table font-size-13" st-table="profileDocList" st-safe-src="profileDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docDesc" class="bold-title">Document Name</th><th class="bold-title" width="140px"></th><th class="bold-title" width="210px"></th><th class="bold-title" width="5%">Language</th><th class="bold-title" width="11%"></th><th class="bold-title" width="12%"></th><th class="bold-title" width="15%"></th></tr><tr><th><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in profileDocList"><td ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'yes\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'no\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}} <i style="float:right;">(Sorry, currently there is no financial history available for this company.)</i></td><td colspan="3" ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'check\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'retry\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td ng-if="item.type != \'Financial Historical Comparison\' && item.available == \'yes\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type != \'Financial Historical Comparison\' && item.available == \'no\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type != \'Financial Historical Comparison\' && item.available == \'check\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type != \'Financial Historical Comparison\' && item.available == \'retry\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'yes\'" style="vertical-align:middle"><div class="form-group"><label for="financialYear1" class="col-sm-3 control-label" style="margin-bottom:0px;padding:0px">Year:</label><div class="col-sm-9" style="padding:0 5px"><ui-select ng-model="financialYear1.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" style="width:auto;" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"><ui-select-match ng-click="loadFinancialYear1()">{{$select.selected.financialYear}}</ui-select-match><ui-select-choices repeat="financialYear1 in financialYear1List | filter: $select.search"><span style="white-space:normal;" ng-bind-html="financialYear1.financialYear"></span></ui-select-choices></ui-select></div></div></td><td ng-if="item.type != \'Financial Historical Comparison\' && item.available == \'yes\'"></td><td ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'yes\'" style="vertical-align:middle"><div class="form-group"><label for="financialYear2" class="col-sm-4 control-label" style="margin-bottom:0px;padding:0px">With Year:</label><div class="col-sm-8" style="padding:0 3px"><ui-select ng-model="financialYear2.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" style="width:auto;" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"><ui-select-match ng-click="loadFinancialYear2()">{{$select.selected.financialYear}}</ui-select-match><ui-select-choices repeat="financialYear2 in financialYear2List | filter: $select.search"><span style="white-space:normal;" ng-bind-html="financialYear2.financialYear"></span></ui-select-choices></ui-select></div></div></td><td ng-if="item.type != \'Financial Historical Comparison\' && item.available == \'yes\'"></td><td ng-if="item.type != \'Financial Historical Comparison\'" style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td ng-if="item.type == \'Financial Historical Comparison\'" style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td><td ng-if="item.type != \'Financial Historical Comparison\'" style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="item.type == \'Financial Historical Comparison\'" style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13 font-weight-300" ng-click="(item.type == \'Business Re-Register Confirmation Letter\' && !proceedAddtoCart) ? openBRCLModal([item]) : addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.active && item.available == \'no\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Not available</button> <button ng-if="item.active && item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="item.active && item.available == \'retry\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Unable to check</button> <button ng-if="!item.active" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;">Coming soon</button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="profileDocSrc.length > 0"><table class="table font-size-13" st-table="profileDocList" st-safe-src="profileDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docDesc" class="bold-title">Document Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title"></th><th class="bold-title"></th><th class="bold-title">Language</th><th class="bold-title"></th><th class="bold-title"></th></tr><tr><th colspan="3"><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in profileDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13" ng-click="openBRCLModal([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.active && item.available == \'no\'" type="button" disabled="" class="btn btn-info font-size-13" style="width:145px;pointer-events:none">Not Available</button> <button ng-if="item.active && item.available == \'check\'" type="button" disabled="" class="btn btn-normal-border font-size-13" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="!item.active" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;">Coming soon</button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" disabled="" class="btn btn-normal-border font-size-13" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td><td ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'yes\'" style="vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'check\'" style="vertical-align:middle">{{item.docDesc}}</td><td colspan="3" ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'no\'" style="vertical-align:middle">{{item.docDesc}} <i style="float:right;">(Sorry, currently there is no financial history available for this company.)</i></td><td ng-if="item.type != \'Financial Historical Comparison\'" style="vertical-align:middle">{{item.docDesc}}</td><td ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'yes\'" style="vertical-align:middle"><div class="form-group"><label for="financialYear1" class="col-sm-3 control-label" style="margin-bottom:0px;padding:0px">Year:</label><div class="col-sm-9" style="padding:0 5px"><ui-select ng-model="financialYear1.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" style="width:auto;" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"><ui-select-match ng-click="loadFinancialYear1()">{{$select.selected.financialYear}}</ui-select-match><ui-select-choices repeat="financialYear1 in financialYear1List | filter: $select.search"><span style="white-space:normal;" ng-bind-html="financialYear1.financialYear"></span></ui-select-choices></ui-select></div></div></td><td ng-if="item.type != \'Financial Historical Comparison\'"></td><td ng-if="item.type == \'Financial Historical Comparison\' && item.available == \'yes\'" style="vertical-align:middle"><div class="form-group"><label for="financialYear2" class="col-sm-4 control-label" style="margin-bottom:0px;padding:0px">With Year:</label><div class="col-sm-8" style="padding:0 3px"><ui-select ng-model="financialYear2.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" style="width:auto;" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"><ui-select-match ng-click="loadFinancialYear2()">{{$select.selected.financialYear}}</ui-select-match><ui-select-choices repeat="financialYear2 in financialYear2List | filter: $select.search"><span style="white-space:normal;" ng-bind-html="financialYear2.financialYear"></span></ui-select-choices></ui-select></div></div></td><td ng-if="item.type != \'Financial Historical Comparison\'"></td><td ng-if="item.type != \'Financial Historical Comparison\'" style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td ng-if="item.type == \'Financial Historical Comparison\'" style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" style="color:#ddd;" disabled=""><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" style="color:#ddd;" disabled=""><option>EN</option><option>MY</option><option>BOTH</option></select></td><td ng-if="item.type != \'Financial Historical Comparison\'" style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="item.type == \'Financial Historical Comparison\'" style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocFinancialInCart(item.companyNo,item.type,item.ctc,item.lang,financialYear1.selected,financialYear2.selected)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td></tr></tbody><tfoot><tr><td colspan="7" class="pagination-text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading="Document & Form Images" ng-if="entity.entity_type == \'Company\'"><div class="row" ng-if="!docView.enable"><div class="form-group col-sm-12"><label>By requesting to view the DOCUMENT & FORM IMAGES for {{entity.entity_name}}, RM{{docView.totalPrice|number:2}} viewing fee will be charged.</label> <label>RM{{docView.ssmPrice|number:2}} goes to SSM and RM{{docView.servicePrice|number:2}} for service charge (Inclusive {{docView.taxRate}}% SST).</label></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="agreeView" ng-model="agreeView"> <span>I agree</span></label></div><div class="form-group col-sm-12"><button type="button" class="btn btn-default" style="color:#555;background:#D6D6D6;width:170px" ng-disabled="agreeView==false || agreeView==undefined" ng-click="enableView()">PROCEED TO VIEW</button><h4 class="with-line" style="padding-top:20px;margin-bottom:0px"></h4></div></div><div class="row" ng-if="docView.enable"><div class="form-group col-sm-12"><div style="padding:10px 10px 5px 10px" ng-if="(!imageDocSrc || imageDocSrc.length == 0) && !imageDocResult"><span>Unsuccessful to load Document & Form Images.</span> <button type="button" class="btn btn-default btn-sm" data-toggle="modal" ng-click="getDocImageList()"><i class="fa fa-refresh" aria-hidden="true"></i> Retry</button></div><div style="padding:10px 10px 5px 10px" ng-if="(!imageDocSrc || imageDocSrc.length == 0) && imageDocResult"><span>Sorry, currently there are no Document & Form Images available for this company.</span></div><div class="table-responsive mobile-view-hide" ng-if="imageDocSrc.length > 0"><table class="table font-size-13" st-table="imageDocList" st-safe-src="imageDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docType" class="bold-title">Document Type</th><th st-sort="docDesc" class="bold-title">Document Name</th><th st-sort="docDate" st-sort-default="reverse" class="bold-title">Document Date</th><th st-sort="docPage" class="bold-title text-align-center">Total Pages</th><th class="bold-title" width="12%"></th><th class="bold-title" width="15%"></th></tr><tr><th><input st-search="docType" placeholder="Document Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="docDesc" placeholder="Document Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="showDocDate" placeholder="Document Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in imageDocList"><td style="vertical-align:middle">{{item.docType}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle">{{item.showDocDate}}</td><td class="text-align-center" style="vertical-align:middle">{{item.docPage}}</td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocImageInCart(item.companyNo,item.type,item.ctc,item.lang,item.verId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill" ng-click="viewCart()" style="width:145px;">View in cart</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><span style="float:left;padding-top:11px"><b>{{imageDocCount}} document(s) available</b></span><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="imageDocSrc.length > 0"><table class="table font-size-13" st-table="imageDocList" st-safe-src="imageDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docType" class="bold-title">Document<br>Type</th><th st-sort="docDesc" class="bold-title">Document &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>Name</th><th st-sort="docDate" st-sort-default="reverse" class="bold-title">Document<br>Date</th><th st-sort="docPage" class="bold-title">Total<br>Pages</th><th class="bold-title"></th></tr><tr><th></th><th><input st-search="docType" placeholder="Document Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="docDesc" placeholder="Document Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="showDocDate" placeholder="Document Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in imageDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill" ng-click="viewCart()" style="width:145px;">View in cart</button></td><td style="vertical-align:middle">{{item.docType}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle">{{item.showDocDate}}</td><td class="text-align-center" style="vertical-align:middle">{{item.docPage}}</td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocImageInCart(item.companyNo,item.type,item.ctc,item.lang,item.verId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td></tr></tbody><tfoot><tr><td colspan="7" class="pagination-text-center"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:20px;margin-bottom:0px"></h4></div></div></uib-tab><uib-tab heading="Audit Firm" ng-if="entity.entity_type == \'Audit Firm\'"><div style="text-align:center" ng-if="!auditFirmDocSrc || auditFirmDocSrc.length == 0"><p><i>Unsuccessful to load this document</i></p><button type="button" class="btn btn-info btn-sm" data-toggle="modal" ng-click="getAuditFirmDocList()"><i class="fa fa-refresh" aria-hidden="true"></i> Reload Document</button><p></p></div><div class="table-responsive mobile-view-hide" ng-if="auditFirmDocSrc.length > 0"><table class="table font-size-13" st-table="auditFirmDocList" st-safe-src="auditFirmDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docDesc" class="bold-title">Document Name</th><th class="bold-title" width="5%">Language</th><th class="bold-title" width="11%"></th><th class="bold-title" width="12%"></th><th class="bold-title" width="15%"></th></tr><tr><th><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in auditFirmDocList"><td ng-if="item.available == \'yes\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select ng-if="item.available == \'yes\'" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkAuditFirmInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td><td style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkAuditFirmInCart(item.companyNo,item.type,item.ctc,item.lang)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13 font-weight-300" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="auditFirmDocSrc.length > 0"><table class="table font-size-13" st-table="auditFirmDocList" st-safe-src="auditFirmDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docDesc" class="bold-title">Document Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title"></th><th class="bold-title"></th></tr><tr><th></th><th><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in auditFirmDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13 font-weight-300" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button></td><td ng-if="item.available == \'yes\'" style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select ng-if="item.available == \'yes\'" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkAuditFirmInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkAuditFirmInCart(item.companyNo,item.type,item.ctc,item.lang)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td></tr></tbody><tfoot><tr><td colspan="5" class="pagination-text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary btn-raised btn-full-width" href="" ui-sref="document.request()">View Cart</button></div></div></div>');
$templateCache.put('app/pages/entity/entity-search.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><form ng-submit="searchEntity()"><div class="form-group col-md-4"><label for="entityInfo">Entity Number/Name</label> <input type="text" class="form-control" placeholder="Enter entity number/name" id="entityInfo" ng-model="entityInfo"></div><div class="form-group col-sm-2"><label for="entityType">Entity Type</label><select class="form-control" id="entityType" ng-model="entityType" selectpicker=""><option ng-selected="true">All Entities</option><option value="ROC">Company</option><option value="ROB">Business</option><option value="AFM">Audit Firm</option><option value="LLP">LLP</option></select></div><div class="form-group col-sm-2"><button type="submit" class="btn btn-primary btn-full-width-margin btn-form" ng-disabled="entityInfo == null || entityInfo.length < 3"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></form></div><div class="row"><div class="col-sm-12" style="margin-bottom:5px"><i ng-if="entityInfo.length >= 3 && entityCount > 1"><b>{{entityCount}} entities found</b></i> <i ng-if="entityInfo.length >= 3 && entityCount == 1"><b>{{entityCount}} entity found</b></i> <i ng-if="entityCount == -1"><b>* Please enter at least 3 character to search</b></i></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="smartTableData" st-safe-src="entityList"><thead><tr class="sortable black-muted-bg"><th st-sort="name" width="50%" class="bold-title">Entity Name</th><th st-sort="entityNumber" width="25%" class="bold-title">Entity Number</th><th st-sort="entityType" width="25%" class="bold-title">Entity Type</th></tr></thead><tbody><tr ng-repeat="item in smartTableData" class="clickable-row" ng-click="saveEntity(item)"><td>{{item.name}}</td><td>{{item.number}}</td><td>{{item.type}}</td></tr><tr ng-if="smartTableData.length == 0" style="background-color:white"><td colspan="3"><br><i ng-if="entityInfo.length >= 3 && entityCount == 0">No entity found</i><br><br></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10" style="margin-left:-150px;"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/entity/llp-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row" style="margin-top:5px"><div class="form-group col-sm-6"><label for="inputCompany">Entity Name</label><div style="font-size:18px;font-weight:900">{{entity.entity_name}}</div></div><div class="form-group col-sm-3"><label for="inputNumber">Entity Number</label><div style="font-size:18px;font-weight:900">{{entity.entity_number}}</div></div><div class="form-group col-sm-1"><label for="inputType">Entity Type</label><div style="font-size:18px;font-weight:900">{{entity.entity_type | uppercase}}</div></div><div class="form-group col-sm-2" style="text-align:right"><button type="button" class="btn btn-primary btn-full-width-margin btn-form" href="" ui-sref="entity.search()" style="margin-top:7px">Change Entity</button></div></div><h4 class="with-line" style="padding-top:5px"></h4><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Profile" ng-if="entity.entity_type == \'LLP\'"><div style="text-align:center" ng-if="!profileDocSrc || profileDocSrc.length == 0"><p><i>Unsuccessful to load this document</i></p><button type="button" class="btn btn-info btn-sm" data-toggle="modal" ng-click="getProfileDocList()"><i class="fa fa-refresh" aria-hidden="true"></i> Reload Document</button><p></p></div><div class="table-responsive mobile-view-hide" ng-if="profileDocSrc.length > 0"><table class="table font-size-13" st-table="profileDocList" st-safe-src="profileDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docDesc" class="bold-title">Document Name</th><th class="bold-title" width="5%">Language</th><th class="bold-title" width="11%"></th><th class="bold-title" width="12%"></th><th class="bold-title" width="13%"></th></tr><tr><th><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in profileDocList"><td style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td><td style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle;text-align:right"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13 font-weight-300" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.active && item.available == \'no\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Not available</button> <button ng-if="item.active && item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="item.active && item.available == \'retry\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Unable to check</button> <button ng-if="!item.active" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;">Coming soon</button></td><td ng-if="item.inCart" style="vertical-align:middle;text-align:right"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="profileDocSrc.length > 0"><table class="table font-size-13" st-table="profileDocList" st-safe-src="profileDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docDesc" class="bold-title">Document Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title"></th><th class="bold-title"></th></tr><tr><th colspan="2"><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in profileDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.active && item.available == \'no\'" type="button" disabled="" class="btn btn-info font-size-13" style="width:145px;pointer-events:none">Not Available</button> <button ng-if="item.active && item.available == \'check\'" type="button" disabled="" class="btn btn-normal-border font-size-13" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="item.active && item.available == \'retry\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Unable to check</button> <button ng-if="!item.active" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;">Coming soon</button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" disabled="" class="btn btn-normal-border font-size-13" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td><td style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td></tr></tbody><tfoot><tr><td colspan="7" class="pagination-text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading="Document & Form Images" ng-if="entity.entity_type == \'LLP\'"><div class="row" ng-if="!docView.enable"><div class="form-group col-sm-12"><label>By requesting to view the DOCUMENT & FORM IMAGES for {{entity.entity_name}}, RM{{docView.totalPrice|number:2}} viewing fee will be charged.</label> <label>RM{{docView.ssmPrice|number:2}} goes to SSM and RM{{docView.servicePrice|number:2}} for service charge (Inclusive {{docView.taxRate}}% SST).</label></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="agreeView" ng-model="agreeView"> <span>I agree</span></label></div><div class="form-group col-sm-12"><button type="button" class="btn btn-default" style="color:#555;background:#D6D6D6;width:170px" ng-disabled="agreeView==false || agreeView==undefined" ng-click="enableView()">PROCEED TO VIEW</button><h4 class="with-line" style="padding-top:20px;margin-bottom:0px"></h4></div></div><div class="row" ng-if="docView.enable"><div class="form-group col-sm-12"><div style="padding:10px 10px 5px 10px" ng-if="(!imageDocSrc || imageDocSrc.length == 0) && !imageDocResult"><span>Unsuccessful to load Document & Form Images.</span> <button type="button" class="btn btn-default btn-sm" data-toggle="modal" ng-click="getDocImageList()"><i class="fa fa-refresh" aria-hidden="true"></i> Retry</button></div><div style="padding:10px 10px 5px 10px" ng-if="(!imageDocSrc || imageDocSrc.length == 0) && imageDocResult"><span>Sorry, currently there are no Document & Form Images available for this company.</span></div><div class="table-responsive mobile-view-hide" ng-if="imageDocSrc.length > 0"><table class="table font-size-13" st-table="imageDocList" st-safe-src="imageDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docType" class="bold-title">Document Type</th><th st-sort="docDesc" class="bold-title">Document Name</th><th st-sort="docDate" width="10%" st-sort-default="reverse" class="bold-title">Document Date</th><th class="bold-title" width="12%"></th><th class="bold-title" width="14%"></th></tr><tr><th><input st-search="docType" placeholder="Document Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="docDesc" placeholder="Document Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="showDocDate" placeholder="Document Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in imageDocList"><td style="vertical-align:middle">{{item.docType}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle">{{item.showDocDate}}</td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocImageInCart(item.companyNo,item.type,item.ctc,item.lang,item.verId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle;text-align:right;"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle;text-align:right;"><button type="button" class="btn btn-info-border-fill" ng-click="viewCart()" style="width:145px;">View in cart</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><span style="float:left;padding-top:11px"><b>{{imageDocCount}} document(s) available</b></span><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="imageDocSrc.length > 0"><table class="table font-size-13" st-table="imageDocList" st-safe-src="imageDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docType" class="bold-title">Document<br>Type</th><th st-sort="docDesc" class="bold-title">Document &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>Name</th><th st-sort="docDate" st-sort-default="reverse" class="bold-title">Document<br>Date</th><th class="bold-title"></th></tr><tr><th></th><th><input st-search="docType" placeholder="Document Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="docDesc" placeholder="Document Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="showDocDate" placeholder="Document Date" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in imageDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill" ng-click="viewCart()" style="width:145px;">View in cart</button></td><td style="vertical-align:middle">{{item.docType}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle">{{item.showDocDate}}</td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocImageInCart(item.companyNo,item.type,item.ctc,item.lang,item.verId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td></tr></tbody><tfoot><tr><td colspan="5" class="pagination-text-center"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:20px;margin-bottom:0px"></h4></div></div></uib-tab></uib-tabset><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary btn-raised btn-full-width" href="" ui-sref="document.request()">View Cart</button></div></div></div>');
$templateCache.put('app/pages/entity/rob-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row" style="margin-top:5px"><div class="form-group col-sm-6"><label for="inputCompany">Entity Name</label><div style="font-size:18px;font-weight:900">{{entity.entity_name}}</div></div><div class="form-group col-sm-3"><label for="inputNumber">Entity Number</label><div style="font-size:18px;font-weight:900">{{entity.entity_number}}</div></div><div class="form-group col-sm-1"><label for="inputType">Entity Type</label><div style="font-size:18px;font-weight:900">{{entity.entity_type | uppercase}}</div></div><div class="form-group col-sm-2" style="text-align:right"><button type="button" class="btn btn-primary btn-full-width-margin btn-form" href="" ui-sref="entity.search()" style="margin-top:7px">Change Entity</button></div></div><h4 class="with-line" style="padding-top:5px"></h4><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Profile"><div style="text-align:center" ng-if="!profileDocSrc || profileDocSrc.length == 0"><p><i>Unsuccessful to load this document</i></p><button type="button" class="btn btn-info btn-sm" data-toggle="modal" ng-click="getProfileDocList()"><i class="fa fa-refresh" aria-hidden="true"></i> Reload Document</button><p></p></div><div class="table-responsive mobile-view-hide" ng-if="profileDocSrc.length > 0"><table class="table font-size-13" st-table="profileDocList" st-safe-src="profileDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docDesc" class="bold-title">Document Name</th><th class="bold-title" width="5%">Language</th><th class="bold-title" width="11%"></th><th class="bold-title" width="12%"></th><th class="bold-title" width="13%"></th></tr></thead><tbody><tr ng-repeat="item in profileDocList"><td style="font-size:14px;vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td><td style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13 font-weight-300" ng-click="(item.type == \'Business Re-Register Confirmation Letter\' && !proceedAddtoCart) ? openBRCLModal([item]) : addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.active && item.available == \'no\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Not available</button> <button ng-if="item.active && item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="item.active && item.available == \'retry\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Unable to check</button> <button ng-if="!item.active" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;">Coming soon</button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="profileDocSrc.length > 0"><table class="table font-size-13" st-table="profileDocList" st-safe-src="profileDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docDesc" class="bold-title">Document Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title"></th><th class="bold-title"></th></tr></thead><tbody><tr ng-repeat="item in profileDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button ng-if="item.active && item.available == \'yes\'" class="btn btn-info font-size-13" ng-click="openBRCLModal([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.active && item.available == \'no\'" type="button" disabled="" class="btn btn-info font-size-13" style="width:145px;pointer-events:none">Not Available</button> <button ng-if="item.active && item.available == \'check\'" type="button" disabled="" class="btn btn-normal-border font-size-13" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="item.active && item.available == \'retry\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Unable to check</button> <button ng-if="!item.active" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;">Coming soon</button></td><td ng-if="item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" disabled="" class="btn btn-normal-border font-size-13" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select ng-if="item.available == \'yes\' && item.enableLang" class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available == \'yes\' && !item.enableLang" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select><select ng-if="item.available != \'yes\'" class="form-control" id="docLang" ng-model="item.lang" disabled="" style="color:#ddd;"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocProfileInCart(item.companyNo,item.type,item.ctc,item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,null)" style="width:100px;">View Sample</button></td></tr></tbody><tfoot><tr><td colspan="7" class="pagination-text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading="Business Certificates" ng-click="getBizCertList()"><div style="padding:10px 10px 20px 10px" ng-if="(!robCertDocSrc || robCertDocSrc.length == 0) && !robCertResult"><span>Unable to load Business Certificates.</span> <button type="button" class="btn btn-default btn-sm" data-toggle="modal" ng-click="getBizCertList()"><i class="fa fa-refresh" aria-hidden="true"></i> Retry</button></div><div style="padding:10px 10px 20px 10px" ng-if="(!robCertDocSrc || robCertDocSrc.length == 0) && robCertResult"><span>Business Certificate for {{entity.entity_name}} is not available. Please contact MYDATA support to get further information.</span></div><div class="table-responsive mobile-view-hide" ng-if="robCertDocSrc.length > 0"><table class="table font-size-13" st-table="robCertDocList" st-safe-src="robCertDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="branch" class="bold-title">Type</th><th st-sort="docDesc" class="bold-title">Address</th><th class="bold-title" width="5%">Language</th><th class="bold-title" width="11%"></th><th class="bold-title" width="12%"></th><th class="bold-title" width="15%"></th></tr><tr><th colspan="2"><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in robCertDocList"><td style="vertical-align:middle">{{item.branch}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkCertInCart(item.companyNo,item.type,item.ctc,item.lang,item.branchId)"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,item.branch)" style="width:100px;">View Sample</button></td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" disabled="" ng-change="checkCertInCart(item.companyNo,item.type,item.ctc,item.lang,item.branchId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><span style="float:left;padding-top:11px"><b>{{robCertDocCount}} Document(s) available</b></span><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="robCertDocSrc.length > 0"><table class="table font-size-13" st-table="robCertDocList" st-safe-src="robCertDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="branch" class="bold-title">Type</th><th st-sort="docDesc" class="bold-title">Address &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title"></th><th class="bold-title"></th></tr><tr><th colspan="3"><input st-search="" placeholder="Search Document" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in robCertDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.docPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.docPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill font-size-13" ng-click="viewCart()" style="width:145px;">View in cart</button></td><td style="vertical-align:middle">{{item.branch}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle"><select class="form-control font-size-13" id="docLang" ng-model="item.lang" ng-change="checkCertInCart(item.companyNo,item.type,item.ctc,item.lang,item.branchId)"><option>EN</option><option>MY</option><option>BOTH</option></select></td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" disabled="" ng-change="checkCertInCart(item.companyNo,item.type,item.ctc,item.lang,item.branchId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td class="text-align-center" style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="openDocSample(item.type,item.lang,item.ctc,item.branch)" style="width:100px;">View Sample</button></td></tr></tbody><tfoot><tr><td colspan="6" class="pagination-text-center"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px;margin-bottom:10px"></h4></uib-tab><uib-tab heading="Form Images" ng-click="getDocImageList()"><div style="padding:10px 10px 5px 10px" ng-if="(!imageDocSrc || imageDocSrc.length == 0) && !imageDocResult"><span>Unsuccessful to load Form Images.</span> <button type="button" class="btn btn-default btn-sm" data-toggle="modal" ng-click="getDocImageList()"><i class="fa fa-refresh" aria-hidden="true"></i> Retry</button></div><div style="padding:10px 10px 5px 10px" ng-if="(!imageDocSrc || imageDocSrc.length == 0) && imageDocResult"><span>Sorry, currently there are no Form Images available for this company.</span></div><div class="table-responsive mobile-view-hide" ng-if="imageDocSrc.length > 0"><table class="table font-size-13" st-table="imageDocList" st-safe-src="imageDocSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="docType" class="bold-title">Document Type</th><th st-sort="docDesc" class="bold-title">Document Name</th><th st-sort="docDate" st-sort-default="reverse" class="bold-title">Document Date</th><th st-sort="docPage" class="bold-title text-align-center">Total Pages</th><th class="bold-title" width="12%"></th><th class="bold-title" width="15%"></th></tr><tr><th><input st-search="docType" placeholder="Document Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="docDesc" placeholder="Document Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="showDocDate" placeholder="Document Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in imageDocList"><td style="vertical-align:middle">{{item.docType}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle">{{item.showDocDate}}</td><td class="text-align-center" style="vertical-align:middle">{{item.docPage}}</td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocImageInCart(item.companyNo,item.type,item.ctc,item.lang,item.verId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill" ng-click="viewCart()" style="width:145px;">View in cart</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><span style="float:left;padding-top:11px"><b>{{imageDocCount}} document(s) available</b></span><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show" ng-if="imageDocSrc.length > 0"><table class="table font-size-13" st-table="imageDocList" st-safe-src="imageDocSrc"><thead><tr class="sortable black-muted-bg"><th class="bold-title"></th><th st-sort="docType" class="bold-title">Document<br>Type</th><th st-sort="docDesc" class="bold-title">Document &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>Name</th><th st-sort="docDate" st-sort-default="reverse" class="bold-title">Document<br>Date</th><th st-sort="docPage" class="bold-title">Total<br>Pages</th><th class="bold-title"></th></tr><tr><th></th><th><input st-search="docType" placeholder="Document Type" class="input-sm form-control search-input" type="search"></th><th><input st-search="docDesc" placeholder="Document Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="showDocDate" placeholder="Document Date" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in imageDocList"><td ng-if="!item.inCart" style="vertical-align:middle"><button class="btn btn-info font-size-13" ng-click="addToCart([item])" style="width:145px;"><span ng-if="item.ctc != true">Add to cart RM{{item.docPrice | number:2}}</span> <span ng-if="item.ctc == true">Add to cart RM{{item.docPrice + item.ctcPrice | number:2}}</span></button></td><td ng-if="item.inCart" style="vertical-align:middle"><button type="button" class="btn btn-info-border-fill" ng-click="viewCart()" style="width:145px;">View in cart</button></td><td style="vertical-align:middle">{{item.docType}}</td><td style="vertical-align:middle">{{item.docDesc}}</td><td style="vertical-align:middle">{{item.showDocDate}}</td><td class="text-align-center" style="vertical-align:middle">{{item.docPage}}</td><td style="vertical-align:middle"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkDocImageInCart(item.companyNo,item.type,item.ctc,item.lang,item.verId)"> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td></tr></tbody><tfoot><tr><td colspan="7" class="pagination-text-center"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div><span style="float:right;padding-top:11px">Rows on page</span><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:20px;margin-bottom:0px"></h4></uib-tab></uib-tabset><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary btn-raised btn-full-width" href="" ui-sref="document.request()">View Cart</button></div></div></div>');
$templateCache.put('app/pages/home/landing-page.html','<div class="al-content-hompage"><link href="https://fonts.googleapis.com/css?family=Roboto:400,300,100,500" rel="stylesheet" type="text/css"><link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css"><link rel="stylesheet" href="../../css/animate.css"><link rel="stylesheet" href="../../css/icomoon.css"><link rel="stylesheet" href="../../css/owl.carousel.min.css"><link rel="stylesheet" href="../../css/owl.theme.default.min.css"><link rel="stylesheet" href="../../css/magnific-popup.css"><link rel="stylesheet" href="../../css/style.css"><script src="../../js/modernizr-2.6.2.min.js"></script><div class="fh5co-slider" ng-controller="home.controller"><div id="home" class="owl-carousel-fullwidth"><div class="item" style="background-image:url(../../images/header-1.jpg);height:100%;background-position: center;background-repeat: no-repeat;background-size: cover;"><a href="#/login"><div style="float:right;padding:5px 25px;border: 2px solid #eeeeee;margin: 5px;border-radius:25px;"><span style="color:#eeeeee;font-size:14px;font-weight:500;">Login <i style="font-size:12px;font-weight:bold" class="icon-login"></i></span></div></a></div></div></div><footer id="fh5co-footer"><div class="container"><div class="row"><div class="col-md-4 col-sm-6"><div class="fh5co-footer-widget"><h5 class="fh5co-footer-logo">Connect With Us</h5></div><div class="fh5co-footer-widget"><ul class="fh5co-social" style="margin-top: 10px;"><li><a href="https://www.facebook.com/MyDataSSM" target="_blank"><i class="icon-facebook"></i></a></li><li><a href="https://twitter.com/MyDataSSM" target="_blank"><i class="icon-twitter"></i></a></li><li><a href="https://youtu.be/KXOhpbQ-Gn8" target="_blank"><i class="icon-youtube"></i></a></li></ul><h5 style="margin-bottom:3px;color:#eeeeee;font-size:13px;">Website:</h5><a style="font-size:13px;" href="http://www.bigdataworks.com.my/" target="_blank">http://www.bigdataworks.com.my</a></div></div><div class="visible-sm-block clearfix"></div><div class="col-md-4 col-sm-6"><div class="fh5co-footer-widget"><h5 class="fh5co-footer-logo">Contact Us</h5></div><div class="fh5co-footer-widget"><h5 style="margin-bottom:3px;color:#eeeeee;font-size:13px;">Sales:</h5><a style="font-size:13px;" ng-href="mailto:sales@mydata-ssm.com.my" href="mailto:sales@mydata-ssm.com.my">sales@mydata-ssm.com.my</a><h5 style="margin-bottom:3px;color:#eeeeee;font-size:13px;">Support Helpdesk:</h5><a style="font-size:13px;" ng-href="mailto:support@mydata-ssm.com.my" href="mailto:support@mydata-ssm.com.my">support@mydata-ssm.com.my</a><br><a style="font-size:13px;">+60 3-2775 9339</a></div></div><div class="col-md-4 col-sm-6"><div class="fh5co-footer-widget"><h5 class="fh5co-footer-logo">Meet us</h5></div><div class="fh5co-footer-widget"><h5 style="margin-bottom:3px;color:#eeeeee;font-size:13px;">Address:</h5><span style="font-size:13px;line-height:0;">Big Dataworks Sdn Bhd<br>The Warehouse, 1st Tier<br>Wisma Amtek, No.15 Jalan Tandang<br>46050 Petaling Jaya, Selangor<br></span></div></div></div></div></footer><script src="../../js/jquery.min.js"></script><script src="../../js/jquery.easing.1.3.js"></script><script src="../../js/owl.carousel.min.js"></script><script src="../../js/jquery.waypoints.min.js"></script><script src="../../js/jquery.magnific-popup.min.js"></script><script src="../../js/main.js"></script></div>');
$templateCache.put('app/pages/invoice/invoice.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label>Invoice Number</label> <input type="text" class="form-control" id="invoiceNo" ng-model="invoiceNo"></div><div class="form-group col-sm-2"><label>App Account</label><select class="form-control selectpicker" ng-model="app.selected" ng-options="item for item in app.selection" selectpicker=""></select></div><div class="form-group col-sm-2"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchInvoice(invoiceNo,app.selected)" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div><h4 class="with-line" style="padding-top:5px"></h4><div class="row" style="margin-top:5px"><div class="form-group col-sm-2"><label for="inputCompany">Invoice Date</label><div style="font-size:18px;font-weight:900">{{invoice.invoiceDate}}</div></div><div class="form-group col-sm-2"><label for="inputNumber">Invoice Number</label><div style="font-size:18px;font-weight:900">{{invoice.invoiceNo}}</div></div><div class="form-group col-sm-3"><label for="inputType">Agency Name</label><div style="font-size:18px;font-weight:900">{{invoice.agencyName}}</div></div><div class="form-group col-sm-3"><label for="inputType">User Name</label><div style="font-size:18px;font-weight:900">{{invoice.userName}}</div></div><div class="form-group col-sm-2"><button type="button" class="btn btn-primary-border" style="margin-top:7px" ng-click="downloadInvoice(invoice.invoiceNo)">View Invoice</button></div></div><h4 class="with-line" style="padding-top:5px"></h4><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Invoice Line Core"><div class="table-responsive"><table class="table font-size-13" st-table="invoiceLineCore" st-safe-src="invoiceLineCoreData"><thead><tr class="sortable black-muted-bg"><th st-sort="ordernumber" class="bold-title">Order Number</th><th st-sort="productid" class="bold-title">Product Id</th><th st-sort="producttype" class="bold-title">Product Type</th><th st-sort="ssmamt" class="bold-title text-align-right">Price (RM)</th><th st-sort="mydamt" class="bold-title text-align-right">Service Fee (RM)</th><th st-sort="mydtax" class="bold-title text-align-right">Service Tax (RM)</th><th st-sort="myddisc" class="bold-title text-align-right" ng-if="appCode==\'Counter\'">Discount (RM)</th><th st-sort="totalnet" class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in invoiceLineCore"><td>{{item.ordernumber}}</td><td>{{item.productid}}</td><td>{{item.producttype}}</td><td class="text-align-right">{{item.ssmamt | number:2}}</td><td class="text-align-right">{{item.mydamt | number:2}}</td><td class="text-align-right">{{item.mydtax | number:2}}</td><td class="text-align-right" ng-if="appCode==\'Counter\'">{{item.myddisc | number:2}}</td><td class="text-align-right">{{item.totalnet | number:2}}</td></tr><tr ng-if="invoiceLineCore.length == 0"><td colspan="8"><br><i>No record found.</i><br><br></td></tr><tr ng-if="!enableLineAdd"><td colspan="8"><a href="" ng-click="add()"><i class="ion-plus-round"></i> Add Invoice Line</a></td></tr><tr ng-if="enableLineAdd"><td><input type="text" class="form-control input-sm" ng-model="orderNo" maxlength="17"></td><td><input type="text" class="form-control input-sm" ng-model="productId" maxlength="2"></td><td><button type="button" ng-click="addInvoiceLine(appCode)" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-click="cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></td><td></td><td></td><td></td><td></td><td></td></tr><tr ng-if="appCode==\'Lite\'"><td></td><td colspan="5" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{invoice.totalLineCore}}</b><br><b>{{invoice.untaxedAmtCore | number:2}}</b><br><b>{{invoice.taxAmtCore | number:2}}</b><br><b>{{invoice.totalAmtCore | number:2}}</b></td></tr><tr ng-if="appCode==\'Counter\'"><td></td><td colspan="6" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Discount Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{invoice.totalLineCore}}</b><br><b>{{invoice.untaxedAmtCore | number:2}}</b><br><b>{{invoice.taxAmtCore | number:2}}</b><br><b>{{invoice.discAmtCore | number:2}}</b><br><b>{{invoice.totalAmtCore | number:2}}</b></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [10,25,50,75,100]" ng-change="searchInvoice(invoice.invoiceNo,appCode)"></select></div><div st-pagination="" st-items-by-page="pageSize" st-displayed-pages="10" style="margin-left:-150px;"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading="Invoice Line {{appCode}}"><div class="table-responsive"><table class="table font-size-13" st-table="invoiceLine" st-safe-src="invoiceLineData"><thead><tr class="sortable black-muted-bg"><th st-sort="orderNo" class="bold-title">Order Number</th><th st-sort="productId" class="bold-title">Product Id</th><th st-sort="productType" class="bold-title">Product Type</th><th st-sort="status" class="bold-title">Status</th><th st-sort="price" class="bold-title text-align-right">Price (RM)</th><th st-sort="serviceFee" class="bold-title text-align-right">Service Fee (RM)</th><th st-sort="serviceTax" class="bold-title text-align-right">Service Tax (RM)</th><th st-sort="discount" class="bold-title text-align-right" ng-if="appCode==\'Counter\'">Discount (RM)</th><th st-sort="totalPrice" class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in invoiceLine"><td>{{item.orderNo}}</td><td>{{item.productId}}</td><td>{{item.productType}}</td><td>{{item.status}}</td><td class="text-align-right">{{item.price | number:2}}</td><td class="text-align-right">{{item.serviceFee | number:2}}</td><td class="text-align-right">{{item.serviceTax | number:2}}</td><td class="text-align-right" ng-if="appCode==\'Counter\'">{{item.discount | number:2}}</td><td class="text-align-right">{{item.totalPrice | number:2}}</td></tr><tr ng-if="invoiceLine.length == 0"><td colspan="9"><br><i>No record found.</i><br><br></td></tr><tr ng-if="appCode==\'Lite\'"><td></td><td colspan="6" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{invoice.totalLine}}</b><br><b>{{invoice.untaxedAmt | number:2}}</b><br><b>{{invoice.taxAmt | number:2}}</b><br><b>{{invoice.totalAmt | number:2}}</b></td></tr><tr ng-if="appCode==\'Counter\'"><td></td><td colspan="7" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Discount Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{invoice.totalLine}}</b><br><b>{{invoice.untaxedAmt | number:2}}</b><br><b>{{invoice.taxAmt | number:2}}</b><br><b>{{invoice.discAmt | number:2}}</b><br><b>{{invoice.totalAmt | number:2}}</b></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [10,25,50,75,100]" ng-change="searchInvoice(invoice.invoiceNo,appCode)"></select></div><div st-pagination="" st-items-by-page="pageSize" st-displayed-pages="10" style="margin-left:-150px;"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/login/forgot-password.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="forgotPassword()"><div class="row"><div class="col-md-12"><div class="form-group col-sm-6"><h5>Please type in your email address. We send you a link to reset the password.</h5><br><label>Email Address</label> <input type="email" class="form-control" id="updateEmail" ng-model="checkEmail" required=""></div></div></div><div class="row"><div class="col-md-12"><div class="form-group col-sm-6"><button type="submit" class="btn btn-primary btn-raised btn-full-width">Reset Password</button></div></div></div></form></div>');
$templateCache.put('app/pages/login/login.view.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="col-md-3"><form ng-submit="login()"><h3>LOGIN</h3><div class="col-md-12"><div class="form-group row clearfix"><label for="inputEmail" class="control-label">Email Address</label> <input type="text" class="form-control input-sm" id="inputEmail" placeholder="" ng-model="email"></div><div class="form-group row clearfix"><label for="inputPassword" class="control-label">Password</label> <input type="password" class="form-control input-sm" id="inputPassword" placeholder="" ng-model="password"> <span class="help-block basic-block"><a href="#/forgot-password">Reset password</a></span></div></div><div class="row button-wrapper"><button type="submit" class="btn btn-primary btn-full-width-margin">LOGIN</button></div></form></div><hr class="signUp-hr"><div class="col-md-9 signUp"><h3>SIGN UP <span class="header-help">All fields marked with (*) are mandatory</span></h3><form ng-submit="signUp()"><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputNewEmail">Email Address *</label> <input type="email" class="form-control input-sm" id="inputNewEmail" ng-model="user.email" required=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputConfirmEmail">Confirm Email Address *</label> <input type="email" class="form-control input-sm" id="inputConfirmEmail" ng-model="user.confirmEmail" required=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputPassword">Password *</label> <input type="password" class="form-control input-sm" id="inputNewPassword" ng-model="user.password" required=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputConfirmPassword">Confirm Password *</label> <input type="password" class="form-control input-sm" id="inputConfirmPassword" ng-model="user.confirmPassword" required=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFullName">Name *</label> <input type="text" class="form-control input-sm" id="inputFullName" ng-model="user.fullName" required=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputPhoneNo">Phone No *</label> <input type="text" class="form-control input-sm" id="inputPhoneNo" ng-model="user.phoneNo" required=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Agency/Firm *</label><ui-select ng-model="agencyWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Agency/Firm" ng-click="loadAgency()">{{$select.selected.agencyName}}</ui-select-match><ui-select-choices repeat="agency in agencyOption | filter: $select.search | limitTo:1"><span ng-bind-html="agency.agencyName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-6"><div class="form-group"><label for="inputDept">Department *</label><ui-select ng-model="deptSelect.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Select Department" ng-click="loadDepartment()"><span>{{$select.selected.description}}</span></ui-select-match><ui-select-choices repeat="dept in deptList | filter: $select.search"><span ng-bind-html="dept.description"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress1">Address Line 1 *</label> <input type="text" class="form-control input-sm" id="inputAddress1" ng-model="user.address1" required=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputAddress2">Address Line 2</label> <input type="text" class="form-control input-sm" id="inputAddress2" ng-model="user.address2"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress3">Address Line 3</label> <input type="text" class="form-control input-sm" id="inputAddress3" ng-model="user.address3"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputPostcode">Postcode *</label> <input type="text" class="form-control input-sm" id="inputPostcode" maxlength="6" ng-model="user.postcode" required=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputCity">City *</label> <input type="text" class="form-control input-sm" id="inputCity" ng-model="user.city" required=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputState">State *</label> <input type="text" class="form-control input-sm" id="inputState" ng-model="user.state" required=""></div></div></div><div class="row button-wrapper"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="agree"> <span>By Sign Up, I agree to <a href="" ng-click="openDisclaimerModal()">MYDATA Terms & Conditions</a></span></label><br><br></div><button type="submit" class="btn btn-primary btn-full-width" ng-disabled="agree == false || agree == undefined">SIGN UP</button></div></form></div></div></div>');
$templateCache.put('app/pages/login/reset-password.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="resetPassword()"><div class="row"><div class="col-md-12"><div class="form-group col-sm-6"><h5>Please enter a new password</h5><br><label>New Password</label> <input type="password" class="form-control" id="resetPassword" ng-model="resetNewPassword" required=""></div></div><div class="col-md-12"><div class="form-group col-sm-6"><label>Confirm New Password</label> <input type="password" class="form-control" id="resetConfirmNewPassword" ng-model="resetConfirmNewPassword" required=""></div></div></div><div class="row"><div class="col-md-12"><div class="form-group col-sm-6"><button type="submit" class="btn btn-primary btn-raised btn-full-width">Submit</button></div></div></div></form></div>');
$templateCache.put('app/pages/login/term-condition.modal.html','<div class="message-modal"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:18px;font-weight:bold;margin-top:0px;margin-bottom:0px">Privacy Policy</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:20px;text-align:left"><b>Privacy Policy</b><p style="text-align:justify;">The following Privacy Policy outlines the use and security of information shared by visitors to the Mydata Enterprise website at <span style="font-weight:600">www.lite.mydata-ssm.com.my</span>.</p><b>Data Security</b><p style="text-align:justify;">All personal data delivered will be protected and kept by using suitable security technology.</p><b>Information Gathered</b><p style="text-align:justify;">No personal information will be gathered when visitors visit <span style="font-weight:600">www.lite.mydata-ssm.com.my</span> except for the information lodged by visitors via e-mail or during registration in protected parts of this website. This information may be shared with Companies Commission of Malaysia (SSM) and/or the Ministry of Domestic Trade and Consumer Affairs (KPDNHEP) agencies to aid in preparing for a more effective service; for example in the solving of enquiries or complaints that need feedbacks from other agencies.</p><b>Links</b><p style="text-align:justify;">Although <span style="font-weight:600">www.lite.mydata-ssm.com.my</span> have links with SSM and/or KPDNHEP and other agencies, this privacy policy applies to this website only. Visitors are advised to study and understand the privacy policy of other agencies\u2019 websites.</p><b>Log Files</b><p style="text-align:justify;">For the purpose of increasing Mydata Enterprise website security and efficiency, visitor\u2019s general information such as the type of browser, domain name, country name and other information shall be collected and applied to the analysis of demographic information and the frequently visited pages. However, it does not involve individual\'s privacy.</p><b>Cookies</b><p style="text-align:justify;">Web browser cookies will only be used to collect information on identifying the visitors trends for future visits. Mydata Enterprise website uses non-persistent cookies or per-session cookies for technical purposes, such as switching of languages on the website. This cookies will not be permanently recorded and be stored in the computer\u2019s hard disk. It will be erased immediately after visitors leave this website.</p><b>Policy Amendments</b><p style="text-align:justify;">If this privacy policy is amended, amendments will be updated in this website.</p><b>Query or Complaint</b><p style="text-align:justify;">Any query or complaint regarding <span style="font-weight:600">www.lite.mydata-ssm.com.my</span> privacy policy can be email to <span style="font-weight:600">helpdesk@mydata-ssm.com.my</span>. This email address is protected from Spambot.</p><b>Feedback</b><p style="text-align:justify;">All feedback from visitors is much welcomed.</p><b>Disclaimer</b><p style="text-align:justify;">SSM shall not be liable for any loss or damage caused by the usage of any information obtained from this site.</p><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/login/unsupported-browser.modal.html','<div class="message-modal"><div class="modal-header"><h5 class="modal-title" id="myModalLabel">Browser not supported</h5></div><div class="modal-body">To continue using Mydata Express, please use <a href="//www.google.com/chrome/" target="_blank">Google Chrome</a> or <a href="//www.mozilla.org/ms/firefox/new/" target="_blank">Firefox</a> browser.<br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/notification/notification-delete.modal.html','<div class="message-modal" ng-controller="notification.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Are you sure to remove this notification?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); deleteNotification(notificationId,notificationActive)">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/notification/notification-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="updateNotification()"><div class="row"><div class="form-group col-sm-5"><label>Title</label> <input type="text" class="form-control" id="title" ng-model="notification.title" required=""></div><div class="form-group col-sm-2"><label>Type</label><select class="form-control" ng-model="notification.type" selectpicker=""><option>Notification</option><option>Maintenance</option></select></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="active" ng-model="notification.active"> <span><b>Show Notification</b></span></label></div><div class="form-group col-sm-12"><label><b>Notification Message (HTML Format)</b></label> <textarea rows="20" type="text" class="form-control" style="height:unset;" id="message" ng-model="notification.message" required=""></textarea></div></div><div class="row"><div class="form-group col-sm-12" style="margin-bottom:7px"><button type="submit" class="btn btn-primary btn-full-width-margin" style="margin-right:5px">Save</button> <button type="button" class="btn btn-danger-border btn-full-width-margin" ng-click="deleteNotificationModal(notification.id,notification.active)" style="margin-right:5px">Delete</button> <button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="notification.list()" style="margin-right:5px">Cancel</button></div></div></form></div>');
$templateCache.put('app/pages/notification/notification-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="table-responsive" style="margin-top:7px"><table class="table table-hover font-size-13" st-table="notificationList" st-safe-src="notificationListSrc"><thead><tr class="sortable black-muted-bg"><th st-sort="title" class="bold-title">Title</th><th st-sort="type" class="bold-title">Type</th><th st-sort="active" class="bold-title text-center">Show Notification</th></tr></thead><tbody><tr ng-repeat="item in notificationList" class="clickable-row" ui-sref="notification.detail({notificationId:\'{{item.id}}\'})"><td>{{item.title}}</td><td>{{item.type}}</td><td class="text-center"><label class="custom-checkbox"><input type="checkbox" id="active" ng-model="item.active"> <span>&nbsp;</span></label></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchNotification()"></select></div><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10" style="margin-left:-150px;"></div></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom: 7px;"><button type="button" class="btn btn-info btn-full-width-margin" ui-sref="notification.new()">Add Notification</button></div></div></div>');
$templateCache.put('app/pages/notification/notification-new.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="createNotification()"><div class="row"><div class="form-group col-sm-5"><label>Title</label> <input type="text" class="form-control" id="title" ng-model="title" required=""></div><div class="form-group col-sm-2"><label>Type</label><select class="form-control" ng-model="type" selectpicker=""><option ng-selected="true">Notification</option><option>Maintenance</option></select></div><div class="form-group col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="active" ng-model="active"> <span><b>Show Notification</b></span></label></div><div class="form-group col-sm-12"><label><b>Notification Message (HTML Format)</b></label> <textarea rows="20" type="text" class="form-control" style="height:unset;" id="message" ng-model="message" required=""></textarea></div></div><div class="row"><div class="form-group col-sm-12" style="margin-bottom:7px"><button type="submit" class="btn btn-primary btn-full-width-margin" style="margin-right:5px">Save</button> <button type="button" class="btn btn-default" href="" ui-sref="notification.list()" style="margin-right:5px">Cancel</button></div></div></form></div>');
$templateCache.put('app/pages/personal-involvement/pi.cart.modal.html','<div class="message-modal" ng-controller="pi.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:15px;font-weight:500;margin-top:0px;margin-bottom:0px;text-align:left;">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal;text-align:left;font-size:13px;font-weight:300">Please verify that the entered ID, selected type of involvement, and chosen product type are correct.<br><br>Are you sure you want to proceed?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px;text-align:right;"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Close</button> <button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); addToCart(cartItems);">Proceed</button></div></div>');
$templateCache.put('app/pages/personal-involvement/pi.product.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><form name="piForm" ng-submit="enableProducts()"><div class="form-group col-sm-2"><label for="idType">ID Type</label><select class="form-control" id="idType" ng-model="piModel.idType" ng-change="onchangeIdType()" selectpicker=""><option ng-selected="true" value="MK">MyKad</option><option value="PR">Permanent Resident</option><option value="P">Passport No</option><option value="B">Old IC</option><option value="Y">Police ID</option><option value="Z">Army ID</option></select></div><div class="form-group col-md-2" ng-class="{\'has-error\': piForm.idNo.$invalid && (piForm.idNo.$dirty || piForm.$submitted)}"><span ng-if="piModel.idType==\'MK\'"><label for="idNo">MyKad No</label> <input type="text" class="form-control" id="idNo" name="idNo" placeholder="Enter 12 digits MyKad number" ng-model="piModel.idNo" ng-pattern="/^\\d{12}$/" maxlength="12" ng-change="onchangeIdNo()" required=""> <span class="help-block error-block basic-block">Please enter 12 digits MyKad number</span></span> <span ng-if="piModel.idType==\'PR\'"><label for="idNo">MyPR No</label> <input type="text" class="form-control" id="idNo" name="idNo" placeholder="Enter 12 digits MyPR number" ng-model="piModel.idNo" ng-pattern="/^\\d{0,12}$/" maxlength="12" required=""> <span class="help-block error-block basic-block">Please enter 12 digits MyPR number</span></span> <span ng-if="piModel.idType==\'P\'"><label for="idNo">Passport No</label> <input type="text" class="form-control" id="idNo" name="idNo" placeholder="Enter passport number" ng-model="piModel.idNo" ng-pattern="/^[A-Z0-9]{6,10}$/" maxlength="10" required=""> <span class="help-block error-block basic-block">Please enter valid Passport number</span></span> <span ng-if="piModel.idType==\'B\'"><label for="idNo">Old IC</label> <input type="text" class="form-control" id="idNo" name="idNo" placeholder="Enter old ic number" ng-model="piModel.idNo" ng-pattern="/^[A-Z]\\d{4,7}$/" maxlength="8" required=""> <span class="help-block error-block basic-block">Please enter valid Old IC number</span></span> <span ng-if="piModel.idType==\'Y\'"><label for="idNo">Police ID</label> <input type="text" class="form-control" id="idNo" name="idNo" placeholder="Enter police id number" ng-model="piModel.idNo" ng-pattern="/^[A-Z]{0,2}\\d{4,7}$/" maxlength="8" required=""> <span class="help-block error-block basic-block">Please enter valid Police ID number</span></span> <span ng-if="piModel.idType==\'Z\'"><label for="idNo">Army ID</label> <input type="text" class="form-control" id="idNo" name="idNo" placeholder="Enter army id number" ng-model="piModel.idNo" ng-pattern="/^[TKA]?\\d{4,7}$/" maxlength="8" required=""> <span class="help-block error-block basic-block">Please enter valid Army ID number</span></span></div><div class="form-group col-sm-2" ng-if="piForm.$invalid"><button class="btn btn-primary btn-full-width-margin btn-form" disabled=""><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="form-group col-sm-2" ng-if="piForm.$valid"><button type="submit" class="btn btn-primary btn-full-width-margin btn-form"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></form></div><h4 class="with-line" style="margin-bottom:25px;"></h4><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Personal Involvement"><div style="text-align:center" ng-if="!piProducts || piProducts.length == 0"><p><i>Unsuccessful to load products</i></p><button type="button" class="btn btn-info btn-sm" data-toggle="modal" ng-click="getPIProduct()"><i class="fa fa-refresh" aria-hidden="true"></i> Reload</button><p></p></div><div class="table-responsive mobile-view-hide" ng-if="piProducts.length > 0"><table class="table font-size-13" st-table="piProducts" st-safe-src="piProducts"><thead><tr class="sortable black-muted-bg"><th class="bold-title">Document Name</th><th class="bold-title" width="12%">Sample</th><th class="bold-title" width="12%">Language</th><th class="bold-title" width="13%">CTC</th><th class="bold-title" width="13%"></th></tr></thead><tbody><tr ng-repeat="item in piProducts track by $index"><td ng-if="item.active" style="font-size:14px;vertical-align:middle">{{item.productName}}</td><td style="vertical-align:middle"><button class="btn font-size-13 btn-info-border" ng-click="viewSample(item.productName,item.lang,item.ctc)" style="width:100px;">View Sample</button></td><td ng-if="item.active" style="vertical-align:middle"><select class="form-control font-size-13" style="width:60%;" ng-if="item.available == \'yes\' && item.enableLang" ng-model="item.lang" ng-change="checkInCart(item.productName, item.ctc, item.lang)"><option>EN</option><option>MY</option><option>BOTH</option></select><select class="form-control font-size-13" style="width:60%;color:#ddd;" ng-if="item.available == \'yes\' && !item.enableLang" ng-model="item.lang" disabled=""><option>EN</option><option>MY</option><option>BOTH</option></select><select class="form-control font-size-13" style="width:60%;color:#ddd;" ng-if="item.available != \'yes\'" ng-model="item.lang" disabled=""><option>EN</option><option>MY</option><option>BOTH</option></select></td><td ng-if="item.active" style="font-size:13px;vertical-align:middle"><label class="custom-checkbox"><input ng-if="item.available == \'yes\' && item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" ng-change="checkInCart(item.productName, item.ctc, item.lang)"> <input ng-if="item.available == \'yes\' && !item.enableCtc" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <input ng-if="item.available != \'yes\'" type="checkbox" id="docCtc" ng-model="item.ctc" disabled=""> <span ng-if="item.lang != \'BOTH\'">CTC (+ RM{{item.ctcPrice | number:2}})</span> <span ng-if="item.lang == \'BOTH\'">CTC (+ RM{{item.ctcPrice * 2 | number:2}})</span></label></td><td ng-if="item.active && !item.inCart" style="vertical-align:middle"><button ng-if="item.available == \'yes\'" class="btn btn-info font-size-13 font-weight-300" ng-click="addToCart(item)" style="width:145px;"><span ng-if="item.lang != \'BOTH\' && item.ctc != true">Add to cart RM{{item.productPrice | number:2}}</span> <span ng-if="item.lang != \'BOTH\' && item.ctc == true">Add to cart RM{{item.productPrice + item.ctcPrice | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc != true">Add to cart RM{{item.productPrice * 2 | number:2}}</span> <span ng-if="item.lang == \'BOTH\' && item.ctc == true">Add to cart RM{{(item.productPrice * 2) + (item.ctcPrice * 2) | number:2}}</span></button> <button ng-if="item.available == \'no\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Add to cart RM{{item.productPrice | number:2}}</button> <button ng-if="item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button> <button ng-if="item.available == \'retry\'" type="button" class="btn btn-info font-size-13" disabled="" style="width:145px;pointer-events:none">Unable to check</button></td><td ng-if="item.active && item.inCart" style="vertical-align:middle"><button ng-if="item.available != \'check\'" type="button" class="btn btn-info-border-fill font-size-13" ui-sref="document.request()" style="width:145px;">View in cart</button> <button ng-if="item.available == \'check\'" type="button" class="btn btn-normal-border font-size-13" disabled="" style="width:145px;pointer-events:none">Checking <img src="assets/img/sq-loader.gif" width="20px"></button></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary btn-raised btn-full-width" href="" ui-sref="document.request()">View Cart</button></div></div></div>');
$templateCache.put('app/pages/personal-involvement/pi.sample.view.html','<div class="modal-content"><div class="modal-header" style="padding-top: 5px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><object ng-if="type==\'Director Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_director_involvement_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_director_involvement_en.pdf"></object><object ng-if="type==\'Director Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_director_involvement_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_director_involvement_en_ctc.pdf"></object><object ng-if="type==\'Director Involvement\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_director_involvement_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_director_involvement_my.pdf"></object><object ng-if="type==\'Director Involvement\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_director_involvement_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_director_involvement_my_ctc.pdf"></object><object ng-if="type==\'Shareholder Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_shareholder_involvement_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_shareholder_involvement_en.pdf"></object><object ng-if="type==\'Shareholder Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_shareholder_involvement_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_shareholder_involvement_en_ctc.pdf"></object><object ng-if="type==\'Shareholder Involvement\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_shareholder_involvement_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_shareholder_involvement_my.pdf"></object><object ng-if="type==\'Shareholder Involvement\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_shareholder_involvement_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_shareholder_involvement_my_ctc.pdf"></object><object ng-if="type==\'Secretary Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_secretary_involvement_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_secretary_involvement_en.pdf"></object><object ng-if="type==\'Secretary Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_secretary_involvement_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_secretary_involvement_en_ctc.pdf"></object><object ng-if="type==\'Secretary Involvement\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_secretary_involvement_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_secretary_involvement_my.pdf"></object><object ng-if="type==\'Secretary Involvement\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_secretary_involvement_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_secretary_involvement_my_ctc.pdf"></object><object ng-if="type==\'Auditor Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_auditor_involvement_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_auditor_involvement_en.pdf"></object><object ng-if="type==\'Auditor Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_auditor_involvement_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_auditor_involvement_en_ctc.pdf"></object><object ng-if="type==\'Auditor Involvement\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_auditor_involvement_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_auditor_involvement_my.pdf"></object><object ng-if="type==\'Auditor Involvement\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_auditor_involvement_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_auditor_involvement_my_ctc.pdf"></object><object ng-if="type==\'Liquidator Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_liquidator_involvement_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_liquidator_involvement_en.pdf"></object><object ng-if="type==\'Liquidator Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_liquidator_involvement_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_liquidator_involvement_en_ctc.pdf"></object><object ng-if="type==\'Liquidator Involvement\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_liquidator_involvement_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_liquidator_involvement_my.pdf"></object><object ng-if="type==\'Liquidator Involvement\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_liquidator_involvement_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_liquidator_involvement_my_ctc.pdf"></object><object ng-if="type==\'Partner Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_partner_involvement_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_partner_involvement_en.pdf"></object><object ng-if="type==\'Partner Involvement\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_partner_involvement_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_partner_involvement_en_ctc.pdf"></object><object ng-if="type==\'Partner Involvement\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_partner_involvement_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_partner_involvement_my.pdf"></object><object ng-if="type==\'Partner Involvement\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_partner_involvement_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_partner_involvement_my_ctc.pdf"></object><object ng-if="type==\'Business Ownership\' && (lang==\'EN\' || lang==\'BOTH\') && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_business_ownership_en.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_business_ownership_en.pdf"></object><object ng-if="type==\'Business Ownership\' && (lang==\'EN\' || lang==\'BOTH\') && ctc" type="application/pdf" data="/assets/pdf/PI/sample_business_ownership_en_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_business_ownership_en_ctc.pdf"></object><object ng-if="type==\'Business Ownership\' && lang==\'MY\' && !ctc" type="application/pdf" data="/assets/pdf/PI/sample_business_ownership_my.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_business_ownership_my.pdf"></object><object ng-if="type==\'Business Ownership\' && lang==\'MY\' && ctc" type="application/pdf" data="/assets/pdf/PI/sample_business_ownership_my_ctc.pdf" style="width:100%;height:90vh;"><param name="src" value="/assets/pdf/PI/sample_business_ownership_my_ctc.pdf"></object></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="col-md-3"><h2>LOGIN</h2><div class="col-md-12"><div class="form-group row clearfix"><label for="inputFirstName" class="control-label">Email Address</label> <input type="text" class="form-control" id="inputFirstName" placeholder=""></div><div class="form-group row clearfix"><label for="inputLastName" class="control-label">Password</label> <input type="password" class="form-control" id="inputLastName" placeholder=""></div><div class="row button-wrapper"><button type="submit" class="btn btn-primary btn-lg">Login</button></div></div></div><div class="col-md-9 signUp"><h2>SIGN UP</h2><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputNewEmail">Email Address</label> <input type="text" class="form-control" id="inputNewEmail"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputFullName">Full Name</label> <input type="text" class="form-control" id="inputFullName"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputIcNo">IC No</label> <input type="text" class="form-control" id="inputIcNo"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputTelNo">Tel No</label> <input type="text" class="form-control" id="inputTelNo"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputPassword">Password</label> <input type="password" class="form-control" id="inputPassword"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputConfirmPassword">Confirm Password</label> <input type="password" class="form-control" id="inputConfirmPassword"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputHODName">Head Of Department Name</label> <input type="text" class="form-control" id="inputHODName"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputHODPosition">Head Of Department Position</label> <input type="text" class="form-control" id="inputHODPosition"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputHODEmail">Head Of Department Email</label> <input type="text" class="form-control" id="inputHODEmail"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputAgencyName">Agency Name</label> <input type="text" class="form-control" id="inputAgencyName" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress1">Agency Address Line 1</label> <input type="text" class="form-control" id="inputAddress1"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputAddress2">Agency Address Line 2</label> <input type="text" class="form-control" id="inputAddress2"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress3">Agency Address Line 3</label> <input type="text" class="form-control" id="inputAddress3"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputPostcode">Postcode</label> <input type="text" class="form-control" id="inputPostcode"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputCity">City</label> <input type="text" class="form-control" id="inputCity"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputState">State</label> <input type="text" class="form-control" id="inputState"></div></div></div><div class="row"><div class="col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>By Sign Up, I agree to <a href="">\'My Data\' Terms & Conditions</a></span></label></div></div><div class="row button-wrapper"><button type="submit" class="btn btn-primary btn-lg">Submit</button></div></div></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/project/project-activate.modal.html','<div class="message-modal" ng-controller="project.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Are you sure to reactivate this project?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); openProject(projectId)">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/project/project-all-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label for="codeName">Project Code/Name</label> <input type="text" class="form-control" placeholder="Enter project code/name" id="codeName" ng-model="codeName"></div><div class="form-group col-sm-2"><label for="inputAgency">Agency/Firm</label><ui-select ng-model="agencyWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Agency/Firm" ng-click="loadAgency()">{{$select.selected.agencyName}}</ui-select-match><ui-select-choices repeat="agencyWithSearch in agencyOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="agencyWithSearch.agencyName"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-2"><label for="inputOrderStatus">Status</label><select class="form-control" name="status" id="status" ng-model="status" selectpicker=""><option value="All">All</option><option value="Active" ng-selected="true">Active</option><option value="Inactive">Inactive</option></select></div><div class="form-group col-sm-2"><button type="button" class="btn btn-primary btn-full-width-margin btn-form" ng-click="searchProjectAll()"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div><div class="table-responsive"><table class="table font-size-13" st-table="projectAllData" st-pipe="projectAllFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Project Code</th><th class="bold-title">Project Name</th><th class="bold-title">Agency/Firm</th><th class="bold-title">Status</th><th class="bold-title text-align-center" width="10%">Action</th></tr></thead><tbody><tr ng-repeat="item in projectAllData"><td>{{item.projectCode}}</td><td>{{item.projectName}}</td><td>{{item.agencyName}}</td><td>{{item.projectStatus}}</td><td ng-if="item.projectStatus == \'Active\'" class="text-align-center"><button type="button" class="btn btn-xs btn-danger-border btn-with-icon" ng-click="closeProjectModal(item.id)"><i class="ion-close"></i>Remove</button></td><td ng-if="item.projectStatus != \'Active\'" class="text-align-center"><button type="button" class="btn btn-xs btn-info-border btn-with-icon" ng-click="openProjectModal(item.id)">Reactivate</button></td></tr><tr ng-if="projectAllData.length == 0"><td colspan="5"><i>No project found</i></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchProjectAll()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectProjectAll(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/project/project-deactivate.modal.html','<div class="message-modal" ng-controller="project.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Are you sure to remove this project?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); closeProject(projectId)">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/project/project-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="updateProject()"><div class="row"><div class="col-md-12"><div class="form-group col-md-3"><label>Project Code</label> <input type="text" class="form-control" id="projectCode" name="projectCode" ng-model="project.projectCode" required=""></div><div class="form-group col-md-6"><label>Project Name</label> <input type="text" class="form-control" id="projectName" name="projectName" ng-model="project.projectName" required=""></div></div></div><div class="row"><div class="col-md-12"><div class="form-group col-md-12"><br><button type="submit" class="btn btn-primary btn-full-width-margin" style="margin-right:5px">Update Project</button> <button type="button" class="btn btn-default" href="" ui-sref="project.list()">Cancel</button></div></div></div></form></div>');
$templateCache.put('app/pages/project/project-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label for="projectName">Project Code/Name</label> <input type="text" class="form-control" placeholder="Enter project code/name" id="projectInfo" ng-model="projectInfo"></div><div class="form-group col-sm-2"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchProject()" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="projectData" st-pipe="projectFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Project Code</th><th class="bold-title">Project Name</th></tr></thead><tbody><tr ng-repeat="item in projectData" class="clickable-row" ui-sref="project.detail({projectId:item.id})"><td>{{item.projectCode}}</td><td>{{item.projectName}}</td></tr><tr ng-if="projectData.length == 0"><td colspan="2"><br><span><i>No record found</i></span><br><br></td></tr></tbody><tfoot><tr><td colspan="2" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchProject()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectProject(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" ui-sref="project.new()" class="btn btn-md btn-info btn-full-width-margin">Add Project</button></div></div></div>');
$templateCache.put('app/pages/project/project-new.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><form ng-submit="createProject()"><div class="row"><div class="col-md-12"><div class="form-group col-md-3"><label>Project Code</label> <input type="text" class="form-control" id="projectCode" name="projectCode" ng-model="projectCode" required=""></div><div class="form-group col-md-6"><label>Project Name</label> <input type="text" class="form-control" id="projectName" name="projectName" ng-model="projectName" required=""></div></div></div><div class="row"><div class="col-md-12"><div class="form-group col-md-12"><br><button type="submit" class="btn btn-primary btn-raised btn-full-width-margin">Save Project</button> <button type="button" class="btn btn-default" href="" ui-sref="project.list()">Cancel</button></div></div></div></form></div>');
$templateCache.put('app/pages/report/report-account-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDocType">Product Type</label><ui-select ng-model="productTypeWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Product Type" ng-click="loadProductType()">{{$select.selected.documentName}}</ui-select-match><ui-select-choices repeat="productTypeWithSearch in productTypes | filter: $select.search"><span style="white-space:normal;" ng-bind-html="productTypeWithSearch.documentName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="orderStatus">Status</label><select class="form-control" id="orderStatus" ng-model="orderStatus" selectpicker=""><option value="All" ng-selected="true">All</option><option value="Success">Success</option><option value="Failed">Unsuccessful</option></select></div></div><div class="col-sm-2"><div class="form-group"><label>User</label><ui-select ng-model="agencyUserWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadAgencyUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="agencyUserWithSearch in userOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="agencyUserWithSearch.fullName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2" ng-if="projectAgencyList.length > 0"><div class="form-group"><label for="project">Project</label><ui-select ng-model="projectAgencyWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="">{{$select.selected.projectName}}</ui-select-match><ui-select-choices repeat="project in projectAgencyList | filter: $select.search"><span style="white-space:normal;"><b>{{project.projectCode}}</b> / {{project.projectName}}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-sm-2"><div class="form-group"><label for="entityRef">Entity Number/Name</label> <input type="text" class="form-control" placeholder="" id="entityRef" ng-model="entityRef"></div></div><div class="col-sm-2"><div class="form-group"><label>Invoice/Order Number</label> <input type="text" class="form-control" placeholder="" id="orderRef" ng-model="orderRef"></div></div><div class="col-sm-4"><div class="form-group" style="margin-top:25px"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchOrderTrxAgency()" style="margin-right:5px"><i class="fa fa-search" aria-hidden="true"></i> Search</button><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary-border" uib-dropdown-toggle=""><i class="fa fa-cloud-download" aria-hidden="true"></i> Export <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="exportOrderTrxAgencyPdf()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF</a></li><li><a href="" ng-click="exportOrderTrxAgencyExcel()"><i class="fa fa-file-excel-o" aria-hidden="true"></i> EXCEL</a></li></ul></div></div></div></div><div class="horizontal-scroll"><table class="table font-size-13" st-table="stOrderTrxAgencyData" st-pipe="stOrderTrxAgencyFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title">User Name</th><th class="bold-title" ng-if="projectExist">Project Code/Name</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in stOrderTrxAgencyData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td>{{item.fullName}}</td><td ng-if="projectExist"><span ng-if="item.projectCode">{{item.projectCode}} / {{item.projectName}}</span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="stOrderTrxAgencyData.length == 0"><td colspan="9"><br><i>No record found.</i><br><br></td></tr><tr ng-if="stOrderTrxAgencyData.length > 0"><td></td><td ng-if="projectExist"></td><td colspan="6" class="text-align-right"><b>Total Transaction :</b><br><b>Total Price (RM) :</b><br><b>Total Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{trxCount}}</b><br><b>{{untaxedAmount | number:2}}</b><br><b>{{taxAmount | number:2}}</b><br><b>{{totalAmount | number:2}}</b></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchOrderTrxAgency()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectOrderTrxAgencyPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/report/report-all-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDocType">Product Type</label><ui-select ng-model="productTypeWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Product Type" ng-click="loadProductType()">{{$select.selected.documentName}}</ui-select-match><ui-select-choices repeat="productTypeWithSearch in productTypes | filter: $select.search"><span style="white-space:normal;" ng-bind-html="productTypeWithSearch.documentName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Invoice/Order Number</label> <input type="text" class="form-control" id="orderRef" ng-model="orderRef"></div></div><div class="col-sm-2"><div class="form-group"><label for="entityRef">Entity Number/Name</label> <input type="text" class="form-control" id="entityRef" ng-model="entityRef"></div></div><div class="col-sm-2"><div class="form-group"><label>Status</label><select class="form-control" id="orderStatus" ng-model="orderStatus" selectpicker=""><option value="All" ng-selected="true">All</option><option value="Success">Success</option><option value="Processing">Processing</option><option value="Failed">Unsuccessful</option></select></div></div><div class="col-sm-2"><div class="form-group"><label>Agency/Firm</label><ui-select ng-model="agencyWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Agency/Firm" ng-click="loadAgency()">{{$select.selected.agencyName}}</ui-select-match><ui-select-choices repeat="agencyWithSearch in agencyOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="agencyWithSearch.agencyName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label>User</label><ui-select ng-model="userWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="userWithSearch in userOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="userWithSearch.fullName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="project">Project</label><ui-select ng-model="projectAllWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Project" ng-click="loadProjectAllList()">{{$select.selected.projectName}}</ui-select-match><ui-select-choices repeat="project in projectAllList | filter: $select.search"><span style="white-space:normal;"><b>{{project.projectCode}}</b> / {{project.projectName}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group" style="margin-top:25px"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchOrderTrxAll()" style="margin-right:5px"><i class="fa fa-search" aria-hidden="true"></i> Search</button><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary-border" uib-dropdown-toggle=""><i class="fa fa-cloud-download" aria-hidden="true"></i> Export <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="exportAllOrderTrxToPdf()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF</a></li><li><a href="" ng-click="exportAllOrderTrxToExcel()"><i class="fa fa-file-excel-o" aria-hidden="true"></i> EXCEL</a></li></ul></div></div></div></div><div class="horizontal-scroll"><table id="trxReportTable" class="table font-size-13" st-table="stOrderTrxAllData" st-pipe="stOrderTrxAllFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title">Agency/Firm</th><th class="bold-title">User Name</th><th class="bold-title" ng-if="projectExist">Project Code/Name</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number/Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price</th></tr></thead><tbody><tr ng-repeat="item in stOrderTrxAllData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td>{{item.agencyName}}</td><td>{{item.fullName}}</td><td ng-if="projectExist"><span ng-if="item.projectCode">{{item.projectCode}} / {{item.projectName}}</span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="stOrderTrxAllData.length == 0"><td colspan="10"><br><i>No record found.</i><br><br></td></tr><tr><td></td><td ng-if="projectExist"></td><td colspan="7" class="text-align-right"><b>Total Transaction :</b><br><b>Total Price (RM) :</b><br><b>Total Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{allTrxCount}}</b><br><b>{{allUntaxedAmount | number:2}}</b><br><b>{{allTaxAmount | number:2}}</b><br><b>{{allTotalAmount | number:2}}</b></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchOrderTrxAll()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectOrderTrxAllPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/report/report-user-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Purchase Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDocType">Product Type</label><ui-select ng-model="productTypeWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Product Type" ng-click="loadProductType()">{{$select.selected.documentName}}</ui-select-match><ui-select-choices repeat="productTypeWithSearch in productTypes | filter: $select.search"><span style="white-space:normal;" ng-bind-html="productTypeWithSearch.documentName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="inputOrderStatus">Status</label><select class="form-control" id="inputOrderStatus" ng-model="orderStatus" selectpicker=""><option value="All" ng-selected="true">All</option><option value="Success">Success</option><option value="Failed">Unsuccessful</option></select></div></div><div class="col-sm-2" ng-if="projectAgencyList.length > 0"><div class="form-group"><label for="project">Project</label><ui-select ng-model="projectAgencyWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search project">{{$select.selected.projectName}}</ui-select-match><ui-select-choices repeat="project in projectAgencyList | filter: $select.search"><span style="white-space:normal;"><b>{{project.projectCode}}</b> / {{project.projectName}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="orderRef">Order Reference</label> <input type="text" class="form-control" placeholder="Entity/Order/Invoice" id="orderRef" ng-model="orderRef"></div></div></div><div class="row"><div class="col-sm-12"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchOrderTrxUser()" style="margin-right:5px"><i class="fa fa-search" aria-hidden="true"></i> Search</button><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary-border" uib-dropdown-toggle=""><i class="fa fa-cloud-download" aria-hidden="true"></i> Export <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="exportOrderTrxUserPdf()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF</a></li><li><a href="" ng-click="exportOrderTrxUserExcel()"><i class="fa fa-file-excel-o" aria-hidden="true"></i> EXCEL</a></li></ul></div></div></div></div><div class="horizontal-scroll"><table class="table font-size-13" st-table="stOrderTrxUserData" st-pipe="stOrderTrxUserFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title" ng-if="projectExist">Project Name</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in stOrderTrxUserData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td ng-if="projectExist"><span ng-if="item.projectCode">{{item.projectCode}} / {{item.projectName}}</span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td class="">{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="stOrderTrxUserData.length == 0"><td colspan="8"><br><i>No record found.</i><br><br></td></tr><tr ng-if="stOrderTrxUserData.length > 0"><td></td><td ng-if="projectExist"></td><td colspan="5" class="text-align-right"><b>Total Transaction :</b><br><b>Total Price (RM) :</b><br><b>Total Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{trxCount}}</b><br><b>{{untaxedAmount | number:2}}</b><br><b>{{taxAmount | number:2}}</b><br><b>{{totalAmount | number:2}}</b></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchOrderTrxUser()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectOrderTrxUserPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/service/checkout.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="horizontal-scroll" style="margin-top:7px"><table class="table font-size-13" st-table="checkoutData" st-pipe="checkoutPipe" style="font-size:15px;"><thead><tr class="black-muted-bg"><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title text-align-center">Language</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in checkoutData track by $index"><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="checkoutData.length == 0"><td colspan="6"><br><span><i>No record found</i></span><br><br></td></tr><tr><td colspan="2" class="text-align-left"><br><br><br><i ng-if="checkoutData.length > 0">* Service Tax of 8% impose on Service Fee and CTC Service Fee as per Service Tax Act 2018</i> <i ng-if="checkoutData.length == 0">* Please contact salesperson for assistance regarding this issue.</i></td><td colspan="3" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude SST) (RM) :</b><br><b>SST @ 8% for Service Fee (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right" ng-if="checkoutData.length > 0"><b>{{checkoutSummary.itemCount}}</b><br><b>{{checkoutSummary.untaxedAmount | number:2}}</b><br><b>{{checkoutSummary.taxAmount | number:2}}</b><br><b>{{checkoutSummary.totalAmount | number:2}}</b></td><td class="text-align-right" ng-if="checkoutData.length == 0"><b>{{0}}</b><br><b>{{0 | number:2}}</b><br><b>{{0 | number:2}}</b><br><b>{{0 | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="7" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchCheckout()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectCheckoutPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" ng-if="checkoutData.length > 0" style="padding-top:4px"></h4><div class="row" ng-if="checkoutData.length > 0"><div class="col-sm-6"><div class="form-group col-md-12" style="margin-bottom:5px"><label class="control-label" style="float:left;font-size:15px;font-weight:bold;color:#7d7d7d">Billing Information</label></div><div class="form-group col-md-6" style="margin-bottom:5px"><div class="form-group has-feedback" ng-class="{\'has-error\':feedback.fullName}" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="Name" ng-model="billingData.fullName" ng-change="checkInput()"> <span ng-if="feedback.fullName" style="font-size:12px;color:#ed7878;font-style:italic;">* {{feedback.fullName}}<br></span></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="Email" ng-model="billingData.email"></div></div><div class="form-group col-md-6" style="margin-bottom:5px"><div class="form-group has-feedback" ng-class="{\'has-error\':feedback.address1}" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="Address Line 1" ng-model="billingData.address1" ng-change="checkInput()"> <span ng-if="feedback.address1" style="font-size:12px;color:#ed7878;font-style:italic;">* {{feedback.address1}}<br></span></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="Address Line 2" ng-model="billingData.address2"></div><div class="form-group" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="Address Line 3" ng-model="billingData.address3"></div><div class="form-group has-feedback" ng-class="{\'has-error\':feedback.postcode}" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="Postcode" maxlength="6" ng-model="billingData.postcode" ng-change="checkInput()"> <span ng-if="feedback.postcode" style="font-size:12px;color:#ed7878;font-style:italic;">* {{feedback.postcode}}<br></span></div><div class="form-group has-feedback" ng-class="{\'has-error\':feedback.city}" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="City" ng-model="billingData.city" ng-change="checkInput()"> <span ng-if="feedback.city" style="font-size:12px;color:#ed7878;font-style:italic;">* {{feedback.postcode}}<br></span></div><div class="form-group has-feedback" ng-class="{\'has-error\':feedback.state}" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="State" ng-model="billingData.state" ng-change="checkInput()"> <span ng-if="feedback.state" style="font-size:12px;color:#ed7878;font-style:italic;">* {{feedback.state}}<br></span></div></div></div></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button ng-if="checkoutData.length > 0" type="button" class="btn btn-primary btn-raised btn-full-width-margin" ng-click="proceedPayment()" style="margin-right:5px">Proceed Payment</button></div></div></div>');
$templateCache.put('app/pages/service/order.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2" ng-if="orderSummary.invNo"><label style="font-size:15px;font-weight:bold">Invoice Number</label> <input type="text" class="form-control input-lg" id="invoice_no" ng-model="orderSummary.invNo" readonly=""></div><div class="form-group col-sm-2"><button type="button" ng-click="downloadInvoice(orderSummary.invNo)" class="btn btn-lg btn-primary-border btn-full-width-margin" style="margin-top:25px">View Invoice</button></div></div><div class="row"><div class="col-sm-12" style="margin-bottom:5px"><i style="font-size:15px"><b>Orders available to be downloaded within 7 days from date of purchase.</b></i></div></div><div class="table-responsive mobile-view-hide"><table class="table font-size-13" st-table="orderData" st-pipe="orderPipe" style="font-size:15px;"><thead><tr class="black-muted-bg"><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title">Product Description</th><th class="bold-title" style="min-width:300px">Entity Number / Name</th><th class="bold-title">Language</th><th class="bold-title" width="8%">Status</th><th class="bold-title text-align-center">Download</th></tr></thead><tbody><tr ng-repeat="item in orderData track by $index"><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}}</span><br>{{item.entityName}}</span></td><td class="">{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-center"><span ng-if="item.status == \'Success\'"><a href="" ng-click="downloadOrder(item.orderNumber)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td></tr><tr ng-if="orderData.length == 0"><td colspan="8"><br><span><i>No record found</i></span><br></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="getCustomerOrder(true,null)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="getCustomerOrder(true,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><div class="horizontal-scroll mobile-view-show"><table class="table font-size-13" st-table="orderData" st-pipe="orderPipe"><thead><tr class="black-muted-bg"><th class="bold-title">Download</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Purchase Date</th><th class="bold-title">Order Number</th><th class="bold-title">Status</th><th class="bold-title text-align-center">Download</th></tr></thead><tbody><tr ng-repeat="item in orderData track by $index"><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadOrder(item.orderNumber)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}}</span><br>{{item.entityName}}</span></td><td class="text-align-center">{{item.lang | uppercase}}</td><td>{{item.processDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.orderNumber}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}<img src="assets/img/pik-loader.gif" width="18px"></span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td><span class="text-align-center" ng-if="item.status == \'Success\'"><a href="" ng-click="downloadOrder(item.orderNumber)"><i class="fa fa-file-pdf-o" aria-hidden="true" style="font-size:18px"></i> PDF</a></span> <span ng-if="item.status == \'Processing\' || item.status == \'Failed\'"></span></td></tr><tr ng-if="orderData.length == 0"><td colspan="9"><br><span><i>No record found</i></span><br></td></tr></tbody><tfoot><tr><td colspan="9" class="text-left"><div class="form-group select-page-size-wrap pull-right"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="getCustomerOrder(true,null)"></select></div><span style="float:right;padding-top:11px">Rows on page</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="getCustomerOrder(true,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4></div>');
$templateCache.put('app/pages/service/payment-pi.modal.html','<div class="message-modal" ng-controller="service.controller"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:15px;font-weight:500;margin-top:0px;margin-bottom:0px;text-align:left;">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal;text-align:left;font-size:13px;font-weight:300">Please verify that the entered ID, selected type of involvement, and chosen product type are correct.<br><br>Are you sure you want to proceed?<br><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px;text-align:right;"><button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Close</button> <button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); proceedPaymentPI(paymentData);">Proceed</button></div></div>');
$templateCache.put('app/pages/service/payment.modal.html','<div class="message-modal"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Confirmation</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal">Status<br><span ng-if="paymentDetail.paymentStatus==\'Success\'" class="success-color"><b><i class="ion-checkmark-circled" style="padding-right:5px"></i>Successful Payment</b></span> <span ng-if="paymentDetail.paymentStatus==\'Failed\'" class="warning-color"><b><i class="ion-alert-circled" style="padding-right:5px"></i>Unsuccessful Payment</b></span><br><br><span ng-if="paymentDetail.paymentStatus==\'Success\'">Invoice No. / Payment Ref.<br><b>{{paymentDetail.invoiceNo}} / {{paymentDetail.paymentRef}}</b><br></span> <span ng-if="paymentDetail.paymentStatus==\'Failed\'">Message<br><b>{{paymentDetail.errMsg}}</b><br></span><br><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button ng-if="paymentDetail.paymentStatus==\'Success\'" type="button" class="btn btn-sm btn-default" ng-click="$dismiss();getCustomerOrder()">Close</button> <button ng-if="paymentDetail.paymentStatus==\'Failed\'" type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Close</button></div></div>');
$templateCache.put('app/pages/service/payment.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-12"><label><b>Payment Response (JSON)</b></label> <textarea rows="5" type="text" class="form-control" style="height:unset;" id="message" ng-model="payment.response" required=""></textarea></div></div><div class="row"><div class="form-group col-sm-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary" ng-click="sendResponse(false)" style="margin-right:5px">Send Response</button> <button type="button" class="btn btn-info" ng-click="sendResponse(true)" style="margin-right:5px">Send Response Backend</button></div></div></div>');
$templateCache.put('app/pages/transaction/transaction-account-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label>Transaction Date</label> <input type="text" class="form-control" id="trxAllDate" ng-model="trxAll.trx_date" readonly=""></div><div class="form-group col-sm-2"><label>Invoice Number</label> <input type="text" class="form-control" id="trxAllInvoiceNo" ng-model="trxAll.invoice_no" readonly=""></div><div class="form-group col-sm-2"><label>Remark</label> <input type="text" class="form-control" id="trx_desc" ng-model="trxAll.trx_desc" readonly=""></div><div class="form-group col-sm-2"><label>User Name</label> <input type="text" class="form-control" id="trxAllFullName" ng-model="trxAll.fullName" readonly=""></div><div class="form-group col-sm-2"><label>Customer Name</label> <input type="text" class="form-control" id="trxAllType" ng-model="trxAll.billing_name" readonly=""></div></div><div class="row" ng-if="trxAll.payment_method == \'Online Payment\'"><div class="form-group col-sm-2"><label>Transaction Reference</label> <input type="text" class="form-control" id="trx_ref" ng-model="trxAll.trx_ref" readonly=""></div><div class="form-group col-sm-2"><label>Payment Method</label> <input type="text" class="form-control" id="payment_method" ng-model="trxAll.payment_method_desc" readonly=""></div><div class="form-group col-sm-2"><label>Payment Reference</label> <input type="text" class="form-control" id="payment_ref" ng-model="trxAll.payment_ref" readonly=""></div><div class="form-group col-sm-2"><label>Payment Status</label> <input type="text" class="form-control" id="payment_status" ng-model="trxAll.payment_status" readonly=""></div><div class="form-group col-sm-10" ng-if="trxAll.payment_url"><label>Payment URL</label> <textarea class="form-control" id="payment_url" ng-model="trxAll.payment_url" readonly="">\r\n        </textarea></div><div class="form-group col-sm-10" ng-if="trxAll.order_url && trxAll.payment_status == \'Success\'"><label>Order URL</label> <textarea class="form-control" id="payment_url" ng-model="trxAll.order_url" readonly="">\r\n        </textarea></div></div><div class="horizontal-scroll" ng-if="trxAll.trx_type == \'Purchase Document\'"><table class="table font-size-13" st-table="trxAllItemTableData" st-pipe="trxAllItemTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Order Number</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in trxAllItemTableData"><td>{{item.orderNumber}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="trxAllItemTableData.length == 0"><td colspan="8"><br><i>No record found</i><br><br></td></tr><tr><td></td><td colspan="6" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{allItemCount}}</b><br><b>{{trxAll.untaxed_amount | number:2}}</b><br><b>{{trxAll.tax_amount | number:2}}</b><br><b>{{trxAll.total_amount | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="loadAllTransactionDetail(trxAll.id)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectTrxAllPage(trxAll.id,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary-border btn-full-width-margin" style="margin-right:5px" ng-click="downloadInvoice(trxAll.invoice_no)" ng-controller="invoice.controller"><i class="fa fa-file-text-o" aria-hidden="true"></i> Invoice</button> <button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="transaction.agency()">Back</button></div></div></div>');
$templateCache.put('app/pages/transaction/transaction-account-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Transaction Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">Transaction Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label>User</label><ui-select ng-model="agencyUserWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadAgencyUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="agencyUserWithSearch in agencyUserOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="agencyUserWithSearch.fullName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="invoice">Transaction Number</label> <input type="text" class="form-control" placeholder="" id="trxNo" ng-model="trxNo"></div></div><div class="col-sm-2"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchAgencyTransaction()" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div></div><div class="table-responsive"><table class="table font-size-13" st-table="agencyTrxTableData" st-pipe="agencyTrxTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Transaction Date</th><th class="bold-title">User Name</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">Customer Name</th><th class="bold-title">Invoice Number</th><th class="bold-title">Remark</th><th class="bold-title text-align-right">Amount (RM)</th><th class="bold-title text-align-center">Download</th></tr></thead><tbody><tr ng-repeat="item in agencyTrxTableData"><td>{{item.trx_date | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.fullName}}</td><td><a href="" ui-sref="transaction.agencyDetail({trx_id:\'{{item.id}}\'})" title="View Transaction Detail">{{item.trx_ref}}</a></td><td>{{item.customer_name}}</td><td>{{item.invoice_no}}</td><td>{{item.trx_desc}}</td><td class="text-align-right">{{item.total_amount | number:2}}</td><td class="text-align-center"><a ng-if="item.invoice_no" href="" ng-click="downloadInvoice(item.invoice_no)" ng-controller="invoice.controller"><i class="fa fa-file-text-o" aria-hidden="true" style="font-size:18px"></i> Invoice</a></td></tr><tr ng-if="agencyTrxTableData.length == 0"><td colspan="9"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchAgencyTransaction()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectAgencyTrxPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/transaction/transaction-all-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label>Transaction Date</label> <input type="text" class="form-control" id="trxAllDate" ng-model="trxAll.trx_date" readonly=""></div><div class="form-group col-sm-2"><label>Invoice Number</label> <input type="text" class="form-control" id="trxAllInvoiceNo" ng-model="trxAll.invoice_no" readonly=""></div><div class="form-group col-sm-2"><label>Remark</label> <input type="text" class="form-control" id="trxAllDesc" ng-model="trxAll.trx_desc" readonly=""></div><div class="form-group col-sm-2"><label>User Name</label> <input type="text" class="form-control" id="trxAllFullName" ng-model="trxAll.fullName" readonly=""></div><div class="form-group col-sm-2" ng-if="trxAll.trx_type == \'Purchase Document\'"><label>Billing Name</label><p class="input-group" style="margin-bottom:0px"><input type="text" class="form-control" id="billing_name" ng-model="trxAll.billing_name" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-info" style="font-size:1px" title="Update Billing Information" ng-click="updateBillingModal(trxAll.id)"><i class="ion ion-android-create" style="font-size:20px"></i></button></span></p></div></div><div class="row" ng-if="trxAll.payment_method == \'Online Payment\'"><div class="form-group col-sm-2"><label>Transaction Reference</label> <input type="text" class="form-control" id="payment_ref" ng-model="trxAll.trx_ref" readonly=""></div><div class="form-group col-sm-2"><label>Payment Method</label> <input type="text" class="form-control" id="payment_method" ng-model="trxAll.payment_method_desc" readonly=""></div><div class="form-group col-sm-2"><label>Payment Reference</label> <input type="text" class="form-control" id="payment_ref" ng-model="trxAll.payment_ref" readonly=""></div><div class="form-group col-sm-2"><label>Payment Status</label> <input type="text" class="form-control" id="payment_status" ng-model="trxAll.payment_status" readonly=""></div><div class="form-group col-sm-10" ng-if="trxAll.payment_url"><label>Payment URL</label> <textarea class="form-control" id="payment_url" ng-model="trxAll.payment_url" readonly="">\r\n        </textarea></div><div class="form-group col-sm-10" ng-if="trxAll.order_url && trxAll.payment_status == \'Success\'"><label>Order URL</label> <textarea class="form-control" id="payment_url" ng-model="trxAll.order_url" readonly="">\r\n        </textarea></div></div><div class="horizontal-scroll" ng-if="trxAll.trx_type == \'Purchase Document\'"><table class="table font-size-13" st-table="trxAllItemTableData" st-pipe="trxAllItemTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Order Number</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in trxAllItemTableData"><td>{{item.orderNumber}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="trxAllItemTableData.length == 0"><td colspan="8"><br><i>No record found</i><br><br></td></tr><tr><td></td><td colspan="6" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{allItemCount}}</b><br><b>{{trxAll.untaxed_amount | number:2}}</b><br><b>{{trxAll.tax_amount | number:2}}</b><br><b>{{trxAll.total_amount | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="loadAllTransactionDetail(trxAll.id)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectTrxAllPage(trxAll.id,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary-border btn-full-width-margin" ng-if="trxAll.trx_type == \'Purchase Document\'" style="margin-right:5px" ng-click="downloadInvoice(trxAll.invoice_no)" ng-controller="invoice.controller"><i class="fa fa-file-text-o" aria-hidden="true"></i> Invoice</button> <button type="button" class="btn btn-primary-border btn-full-width-margin" ng-click="getReceipt(trxAll.user_id,trxAll.invoice_no)" ng-if="trxAll.trx_type != \'Purchase Document\'" style="margin-right:5px"><i class="fa fa-print" aria-hidden="true"></i> Receipt</button><button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="transaction.all()">Back</button></div></div></div>');
$templateCache.put('app/pages/transaction/transaction-all-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Transaction Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">Transaction Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label>User</label><ui-select ng-model="userWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="userWithSearch in userOption | filter: $select.search"><span style="white-space:normal;" ng-bind-html="userWithSearch.fullName"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><div class="form-group"><label for="invoice">Transaction Number</label> <input type="text" class="form-control" placeholder="" id="trxNo" ng-model="trxNo"></div></div><div class="col-sm-2"><div class="form-group" style="margin-top:25px"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchAllTransaction()" style="margin-right:2px"><i class="fa fa-search" aria-hidden="true"></i> Search</button><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary-border" uib-dropdown-toggle=""><i class="fa fa-cloud-download" aria-hidden="true"></i> Export <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="exportAllTrxToExcel()"><i class="fa fa-file-excel-o" aria-hidden="true"></i> EXCEL</a></li></ul></div></div></div></div><div class="table-responsive"><table class="table font-size-13" st-table="allTrxTableData" st-pipe="allTrxTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Transaction Date</th><th class="bold-title">User Name</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">Payment Ref.</th><th class="bold-title">Customer Name</th><th class="bold-title">Invoice Number</th><th class="bold-title">Remark</th><th class="bold-title text-align-right">Amount (RM)</th><th class="bold-title text-align-center">Download</th></tr></thead><tbody><tr ng-repeat="item in allTrxTableData"><td>{{item.trx_date | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.fullName}}</td><td><a href="" ui-sref="transaction.allDetail({transId:\'{{item.id}}\'})" title="View Transaction Detail">{{item.trx_ref}}</a></td><td>{{item.payment_ref}}</td><td>{{item.customer_name}}</td><td>{{item.invoice_no}}</td><td>{{item.trx_desc}}</td><td class="text-align-right">{{item.total_amount | number:2}}</td><td class="text-align-center"><a ng-if="item.invoice_no" href="" ng-click="downloadInvoice(item.invoice_no)" ng-controller="invoice.controller" title="Print Invoice"><i class="fa fa-file-text-o" aria-hidden="true" style="font-size:18px"></i> Invoice</a></td></tr><tr ng-if="allTrxTableData.length == 0"><td colspan="11"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchAllTransaction()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectAllTrxPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/transaction/transaction-billing.modal.html','<div class="message-modal"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Update Billing Details</div></div><div class="modal-body"><div style="margin:20px 40px 0px 40px;font-size:14px;line-height:normal"><div class="form-group row"><div class="col-sm-12" style="margin-bottom:10px"><label for="name" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Billing Name</label> <input type="text" class="input-md form-control" placeholder="" ng-model="billing.name"></div><div class="col-sm-12" style="margin-bottom:5px"><label for="address1" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Billing Address</label> <input type="text" class="input-md form-control" placeholder="" ng-model="billing.address1"></div><div class="col-sm-12" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="" ng-model="billing.address2"></div><div class="col-sm-12" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="" ng-model="billing.address3"></div><div class="col-sm-3" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="" ng-model="billing.postcode" maxlength="6"></div><div class="col-sm-9" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="" ng-model="billing.city"></div><div class="col-sm-12" style="margin-bottom:5px"><input type="text" class="input-md form-control" placeholder="" ng-model="billing.state"></div></div><h4 class="with-line" style="padding-top:0px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary" ng-click="$dismiss(); updateBilling()" ng-controller="transaction.controller">Update</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">Cancel</button></div></div>');
$templateCache.put('app/pages/transaction/transaction-ssm-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label>Transaction Date</label> <input type="text" class="form-control" id="trx_date" ng-model="trx.trx_date" readonly=""></div><div class="form-group col-sm-2"><label>Transaction Type</label> <input type="text" class="form-control" id="trx_type" ng-model="trx.trx_type" readonly=""></div><div class="form-group col-sm-2"><label>Description</label> <input type="text" class="form-control" id="trx_desc" ng-model="trx.trx_desc" readonly=""></div></div><div class="horizontal-scroll"><table class="table font-size-13" st-table="trxItemTableData" st-pipe="trxItemTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Order Number</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in trxItemTableData"><td>{{item.orderNumber}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="trxItemTableData.length == 0"><td colspan="8"><br><i>No record found</i><br><br></td></tr><tr><td></td><td colspan="6" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{itemCount}}</b><br><b>{{trx.untaxed_amount | number:2}}</b><br><b>{{trx.tax_amount | number:2}}</b><br><b>{{trx.total_amount | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="loadTransactionDetail(trx.id)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectTrxItemPage(trx.id,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="transaction.ssm()">Back</button></div></div></div>');
$templateCache.put('app/pages/transaction/transaction-ssm-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Transaction Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">Transaction Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchTransaction()" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="trxTableData" st-pipe="trxTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Transaction Date</th><th class="bold-title">Transaction Type</th><th class="bold-title">Description</th><th class="bold-title text-align-right">Total Amount (RM)</th></tr></thead><tbody><tr ng-repeat="item in trxTableData" class="clickable-row" ui-sref="transaction.SSMDetail({SSMTransId:item.id})"><td>{{item.trx_date | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.trx_type}}</td><td>{{item.trx_desc}}</td><td class="text-align-right">{{item.total_amount | number:2}}</td></tr><tr ng-if="trxTableData.length == 0"><td colspan="4"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchTransaction()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectTrxPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/transaction/transaction-user-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="form-group col-sm-2"><label>Transaction Date</label> <input type="text" class="form-control" id="trx_date" ng-model="trx.trx_date" readonly=""></div><div class="form-group col-sm-2"><label>Invoice Number</label> <input type="text" class="form-control" id="invoice_no" ng-model="trx.invoice_no" readonly=""></div><div class="form-group col-sm-2"><label>Remark</label> <input type="text" class="form-control" id="trx_desc" ng-model="trx.trx_desc" readonly=""></div><div class="form-group col-sm-2"><label>Customer Name</label> <input type="text" class="form-control" id="trx_desc" ng-model="trx.billing_name" readonly=""></div></div><div class="row" ng-if="trx.payment_method == \'Online Payment\'"><div class="form-group col-sm-2"><label>Transaction Reference</label> <input type="text" class="form-control" id="trx_ref" ng-model="trx.trx_ref" readonly=""></div><div class="form-group col-sm-2"><label>Payment Method</label> <input type="text" class="form-control" id="trx_type" ng-model="trx.payment_method_desc" readonly=""></div><div class="form-group col-sm-2"><label>Payment Reference</label> <input type="text" class="form-control" id="trx_type" ng-model="trx.payment_ref" readonly=""></div><div class="form-group col-sm-2"><label>Payment Status</label> <input type="text" class="form-control" id="trx_type" ng-model="trx.payment_status" readonly=""></div><div class="form-group col-sm-10" ng-if="trx.payment_url"><label>Payment URL</label> <textarea class="form-control" id="payment_url" ng-model="trx.payment_url" readonly="">\r\n        </textarea></div><div class="form-group col-sm-10" ng-if="trx.order_url && trx.payment_status == \'Success\'"><label>Order URL</label> <textarea class="form-control" id="payment_url" ng-model="trx.order_url" readonly="">\r\n        </textarea></div></div><div class="horizontal-scroll" ng-if="trx.trx_type == \'Purchase Document\'"><table class="table font-size-13" st-table="trxItemTableData" st-pipe="trxItemTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Order Number</th><th class="bold-title">Product Description &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Entity Number / Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th><th class="bold-title">Language</th><th class="bold-title">Status</th><th class="bold-title text-align-right">Price (RM)</th><th class="bold-title text-align-right">Service Fee (RM)</th><th class="bold-title text-align-right">Total Price (RM)</th></tr></thead><tbody><tr ng-repeat="item in trxItemTableData"><td>{{item.orderNumber}}</td><td>{{item.type}} <span ng-if="item.ctc == true">CTC</span> <span ng-if="item.type == \'Document & Form Download\' || item.type == \'LLP Document & Form Download\' || item.type == \'ROB Form Image Download\'"><span style="font-weight:400"><br>{{item.documentType}} / {{item.documentName}} ({{item.documentDate | date : \'dd/MM/yyyy\'}})</span></span> <span ng-if="item.type == \'Business Certificates\'"><span style="font-weight:400"><br>{{item.branch | uppercase}} / {{item.documentName | uppercase}}</span></span> <span ng-if="item.type == \'Financial Historical Comparison\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} & {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span> <span ng-if="item.type == \'Financial Comparison 2 Years\' || item.type == \'Financial Comparison 3 Years\' || item.type == \'Financial Comparison 5 Years\' || item.type == \'Financial Comparison 10 Years\'"><span style="font-weight:400"><br>({{item.financialYearEndDate1 | date : \'yyyy\'}} - {{item.financialYearEndDate2 | date : \'yyyy\'}})</span></span></td><td><span ng-if="item.newEntityNumber"><span style="font-weight:400">{{item.newEntityNumber}} ({{item.entityNumber}})</span><br>{{item.entityName}}</span> <span ng-if="!item.newEntityNumber"><span style="font-weight:400">{{item.entityNumber}} <span ng-if="item.entityName==\'PERSONAL INVOLVEMENT\'">({{item.documentType}})</span></span><br>{{item.entityName}}</span></td><td>{{item.lang | uppercase}}</td><td><span ng-if="item.status == \'Processing\'">{{item.status}}</span> <span ng-if="item.status == \'Success\'" class="success-color">{{item.status}}</span> <span ng-if="item.status == \'Failed\'" class="warning-color">Unsuccessful</span></td><td class="text-align-right">{{item.docPrice + item.ctcPrice | number:2}}</td><td class="text-align-right">{{item.serviceFee + item.ctcServiceFee | number:2}}</td><td class="text-align-right">{{item.documentPrice | number:2}}</td></tr><tr ng-if="trxItemTableData.length == 0"><td colspan="8"><br><i>No record found</i><br><br></td></tr><tr><td></td><td colspan="6" class="text-align-right"><b>Total Document :</b><br><b>Total (exclude tax) (RM) :</b><br><b>Tax Amount (RM) :</b><br><b>Total Amount (RM) :</b></td><td class="text-align-right"><b>{{itemCount}}</b><br><b>{{trx.untaxed_amount | number:2}}</b><br><b>{{trx.tax_amount | number:2}}</b><br><b>{{trx.total_amount | number:2}}</b></td></tr></tbody><tfoot ng-if="rowCount > 5"><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="loadTransactionDetail(trx.id)"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectTrxItemPage(trx.id,page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row"><div class="form-group col-md-12" style="margin-bottom:7px"><button type="button" class="btn btn-primary-border btn-full-width-margin" style="margin-right:5px" ng-click="downloadInvoice(trx.invoice_no)" ng-controller="invoice.controller"><i class="fa fa-file-text-o" aria-hidden="true"></i> Invoice</button> <button type="button" class="btn btn-default btn-full-width-margin" href="" ui-sref="transaction.search()">Back</button></div></div></div>');
$templateCache.put('app/pages/transaction/transaction-user-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Transaction Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">Transaction Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group"><label for="invoice">Transaction Number</label> <input type="text" class="form-control" placeholder="" id="trxNo" ng-model="trxNo"></div></div><div class="col-sm-2"><div class="form-group"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchTransaction()" style="margin-top:25px"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div></div></div><div class="table-responsive"><table class="table font-size-13" st-table="trxTableData" st-pipe="trxTableFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Transaction Date</th><th class="bold-title">Transaction Ref.</th><th class="bold-title">Customer Name</th><th class="bold-title">Invoice Number</th><th class="bold-title">Remark</th><th class="bold-title text-align-right">Amount (RM)</th><th class="bold-title text-align-center">Download</th></tr></thead><tbody><tr ng-repeat="item in trxTableData"><td>{{item.trx_date | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><a href="" ui-sref="transaction.detail({trxId:\'{{item.id}}\'})" title="View Transaction Detail">{{item.trx_ref}}</a></td><td>{{item.customer_name}}</td><td>{{item.invoice_no}}</td><td>{{item.trx_desc}}</td><td class="text-align-right">{{item.total_amount | number:2}}</td><td class="text-align-center"><a ng-if="item.invoice_no" href="" ng-click="downloadInvoice(item.invoice_no)" ng-controller="invoice.controller" title="Print Invoice"><i class="fa fa-file-text-o" aria-hidden="true" style="font-size:18px"></i> Invoice</a></td></tr><tr ng-if="trxTableData.length == 0"><td colspan="8"><br><i>No record found.</i><br><br></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchTransaction()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectTrxPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/user/delegate-credit-detail.modal.html','<div class="message-modal" ng-controller="user.controller"><form ng-submit="delegateCredit(updateUserData.id,delegateAmount,updateUserData.status,updateUserData.role,updateUserData.note)"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Delegate Credit</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal"><div class="row"><div class="col-sm-12"><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Credit Available</label><div class="col-sm-8"><input type="text" class="form-control" id="CreditBalance" ng-model="accountUserData.creditBalance" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Delegate Credit To</label><div class="col-sm-8"><input type="text" class="form-control" id="CreditBalance" ng-model="updateUserData.name" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Delegate Credit Amount</label><div class="col-sm-8"><input type="number" class="form-control" id="delegateAmount" ng-model="delegateAmount" min="1" step=".01" required=""></div></div></div></div><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"> <span>Are you sure you want to delegate <b>RM{{delegateAmount || 0 | number:2}}</b> to user <b>{{updateUserData.name}}</b>?</span></label><br><br></div><button type="submit" class="btn btn-sm btn-primary" id="submitButton" ng-disabled="confirmTopup == false || confirmTopup == undefined">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></form></div>');
$templateCache.put('app/pages/user/delegate-credit-list.modal.html','<div class="message-modal" ng-controller="user.controller"><form ng-submit="delegateCredit(delegateUserWithSearch.selected.id, delegateAmount, null, null, null)"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Delegate Credit</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal"><div class="row"><div class="col-sm-12"><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Credit Available</label><div class="col-sm-8"><input type="text" class="form-control" id="CreditBalance" ng-model="accountUserData.creditBalance" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Delegate Credit To</label><div class="col-sm-8"><ui-select ng-model="delegateUserWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadDelegateUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="delegateUserWithSearch in delegateUserOption | filter: $select.search"><span style="white-space:normal;">{{delegateUserWithSearch.fullName}}<br><span style="font-style:italic;font-size:12px">(Credit balance: RM{{delegateUserWithSearch.creditBalance | number:2}})</span></span></ui-select-choices></ui-select></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Delegate Credit Amount</label><div class="col-sm-8"><input type="number" class="form-control" id="delegateAmount" ng-model="delegateAmount" min="1" step=".01" required=""></div></div></div></div><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"> <span>Are you sure you want to delegate <b>RM{{delegateAmount || 0 | number:2}}</b> <span ng-if="delegateUserWithSearch.selected.fullName">to user <b>{{delegateUserWithSearch.selected.fullName}}</b></span>?</span></label><br><br></div><button type="submit" class="btn btn-sm btn-primary" id="submitButton" ng-disabled="confirmTopup == false || confirmTopup == undefined">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></form></div>');
$templateCache.put('app/pages/user/manage-credit.modal.html','<div class="message-modal" ng-controller="user.controller"><form ng-submit="manageCredit(userData.userId,userData.creditBalance,userData.status,userData.role,userData.note)"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Manage Credit</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal"><div class="row"><div class="col-sm-12"><div class="form-group clearfix"><label class="col-sm-3 control-label" style="text-align:left;float:left">Credit Balance</label><div class="col-sm-9"><input type="text" class="form-control" id="oldCreditBalance" ng-model="userData.creditBalance" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label" style="text-align:left;float:left">Transaction Type</label><div class="col-sm-9"><select class="form-control" ng-model="trxType" selectpicker=""><option>Topup Credit</option><option>Refund Credit</option><option>Remove Credit</option></select></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label" ng-if="trxType==\'Topup Credit\'" style="text-align:left;float:left">Topup Amount</label> <label class="col-sm-3 control-label" ng-if="trxType==\'Refund Credit\'" style="text-align:left;float:left">Refund Amount</label> <label class="col-sm-3 control-label" ng-if="trxType==\'Remove Credit\'" style="text-align:left;float:left">Remove Amount</label><div class="col-sm-9" ng-class="{\'has-error\':trxAmtErr}"><input type="number" class="form-control" id="trxAmt" ng-model="trxAmt" step=".01" required=""> <span class="help-block" style="color:#ed7878;font-size:12px;margin-bottom:0px" ng-if="trxAmtErr">{{trxAmtErr}}</span></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label" style="text-align:left;float:left">Remark</label><div class="col-sm-9"><input type="text" class="form-control" id="trxDesc" ng-model="trxDesc" required=""></div></div></div></div><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"> <span>Are you sure you want to <span ng-if="trxType==\'Topup Credit\'">topup</span> <span ng-if="trxType==\'Refund Credit\'">refund</span> <span ng-if="trxType==\'Remove Credit\'">remove</span> credit of <b>RM{{trxAmt || 0 | number:2}}</b> for this user?</span></label><br><br></div><button type="submit" class="btn btn-sm btn-primary" ng-click="this.disabled=true" ng-disabled="confirmTopup == false || confirmTopup == undefined">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></form></div>');
$templateCache.put('app/pages/user/return-credit-detail.modal.html','<div class="message-modal" ng-controller="user.controller"><form ng-submit="returnCredit(updateUserData.id,returnAmount,updateUserData.status,updateUserData.role,updateUserData.note,updateUserData.creditBalance)"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Return Credit</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal"><div class="row"><div class="col-sm-12"><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Return Credit From</label><div class="col-sm-8"><input type="text" class="form-control" id="CreditBalance" ng-model="updateUserData.name" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Credit Available</label><div class="col-sm-8"><input type="text" class="form-control" id="CreditBalance" ng-model="updateUserData.creditBalance" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Return Credit Amount</label><div class="col-sm-8"><input type="number" class="form-control" id="returnAmount" ng-model="returnAmount" min="0.01" step=".01" required=""></div></div></div></div><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"> <span>Are you sure you want to take back <b>RM{{returnAmount || 0 | number:2}}</b> to user <b>{{updateUserData.name}}</b>?</span></label><br><br></div><button type="submit" class="btn btn-sm btn-primary" id="submitButton" ng-disabled="confirmTopup == false || confirmTopup == undefined">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></form></div>');
$templateCache.put('app/pages/user/return-credit-list.modal.html','<div class="message-modal" ng-controller="user.controller"><form ng-submit="returnCredit(delegateUserWithSearch.selected.id,returnAmount,null,null,null,returnUser.creditBalance)"><div class="modal-header" style="background:#f5f5f5"><div class="modal-title" id="myModalLabel" style="font-size:16px;font-weight:bold;margin-top:0px;margin-bottom:0px">Return Credit</div></div><div class="modal-body"><div style="margin:20px 20px 0px 20px;font-size:14px;line-height:normal"><div class="row"><div class="col-sm-12"><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Return Credit From</label><div class="col-sm-8"><ui-select ng-model="delegateUserWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="Search User" ng-click="loadDelegateUser()">{{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="delegateUserWithSearch in delegateUserOption | filter: $select.search" ng-click="updateReturnUserCredit(delegateUserWithSearch.selected.creditBalance)"><span style="white-space:normal;">{{delegateUserWithSearch.fullName}}<br><span style="font-style:italic;font-size:12px">(Credit balance: RM{{delegateUserWithSearch.creditBalance | number:2}})</span></span></ui-select-choices></ui-select></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Credit Balance</label><div class="col-sm-8"><input type="text" class="form-control" id="CreditBalance" ng-model="returnUser.creditBalance" disabled=""></div></div><div class="form-group clearfix"><label class="col-sm-4 control-label" style="text-align:left;float:left">Return Credit Amount</label><div class="col-sm-8"><input type="number" class="form-control" id="returnAmount" ng-model="returnAmount" min="0.01" step=".01" required=""></div></div></div></div><h4 class="with-line" style="padding-top:5px"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><div class="col-sm-12"><label class="custom-checkbox"><input type="checkbox" id="docCtc" ng-model="confirmTopup"> <span>Are you sure you want to take back <b>RM{{returnAmount || 0 | number:2}}</b> <span ng-if="delegateUserWithSearch.selected.fullName">from user <b>{{delegateUserWithSearch.selected.fullName}}</b></span>?</span></label><br><br></div><button type="submit" class="btn btn-sm btn-primary" id="submitButton" ng-disabled="confirmTopup == false || confirmTopup == undefined">Yes</button> <button type="button" class="btn btn-sm btn-default" ng-click="$dismiss()">No</button></div></form></div>');
$templateCache.put('app/pages/user/topup-confirmation.modal.html','<div class="message-modal"><div class="modal-header"><h5 class="modal-title" id="myModalLabel" style="font-weight:bold;margin-top:12px">PAYMENT CONFIRMATION</h5></div><div class="modal-body"><div style="margin:0 20px;font-size:14px;line-height:normal">Status<br><span ng-if="topupDetail.paymentStatus==\'Success\'" class="success-color"><b><i class="ion-checkmark-circled" style="padding-right:5px"></i>Successful</b></span> <span ng-if="topupDetail.paymentStatus==\'Failed\'" class="warning-color"><b><i class="ion-alert-circled" style="padding-right:5px"></i>Unsuccessful</b></span><br><br><span ng-if="topupDetail.paymentStatus==\'Success\'">Receipt No. / Payment Ref.<br><b>{{topupDetail.receiptNo}} / {{topupDetail.paymentRef}}</b><br><br>Topup Amount<br><b>RM{{topupDetail.topupAmt | number:2}}</b><br><br>Credit Balance<br><b>RM{{topupDetail.newCreditBalance | number:2}}</b><br></span> <span ng-if="topupDetail.paymentStatus==\'Failed\'">Message<br><b>{{topupDetail.errMsg}}</b><br></span><br><h4 class="with-line"></h4></div></div><div class="modal-footer" style="font-size:14px;margin-top:2px"><button type="button" class="btn btn-sm btn-primary btn-full-width-margin" ng-if="topupDetail.paymentStatus==\'Success\'" ng-click="getReceipt(topupDetail.userId,topupDetail.receiptNo)" ng-controller="transaction.controller">DOWNLOAD RECEIPT</button> <button type="button" class="btn btn-sm btn-default btn-full-width-margin" ng-click="$dismiss();reloadPage()" ng-controller="user.controller">CLOSE</button></div></div>');
$templateCache.put('app/pages/user/topup-credit.modal.html','<div class="message-modal" ng-controller="user.controller"><div class="modal-header"><h5 class="modal-title" id="myModalLabel" style="font-weight:bold;margin-top:10px;margin-bottom:10px">TOPUP CREDIT</h5></div><div class="modal-body"><div style="margin:0 50px;font-size:14px;line-height:normal"><div class="form-group row"><div class="col-sm-6" style="margin-bottom:10px"><label for="method" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Payment Method</label><select class="form-control" selectpicker=""><option ng-selected="true">Credit Card / Debit Card</option><option>Online Banking</option></select></div><div class="col-sm-6" style="margin-bottom:10px"><label for="amount" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Topup Amount (RM)</label> <input type="number" class="form-control" ng-model="topupAmount"></div><div class="col-sm-12" style="margin-bottom:10px"><label for="name" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Billing Name</label> <input type="text" class="input-sm form-control" placeholder="Billing Name" ng-model="topupBilling.name"></div><div class="col-sm-12" style="margin-bottom:5px"><label for="address1" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Billing Address</label> <input type="text" class="input-sm form-control" placeholder="Address Line 1" ng-model="topupBilling.address1"></div><div class="col-sm-12" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="Address Line 2" ng-model="topupBilling.address2"></div><div class="col-sm-12" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="Address Line 3" ng-model="topupBilling.address3"></div><div class="col-sm-3" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="Postcode" ng-model="topupBilling.postcode" maxlength="5"></div><div class="col-sm-9" style="margin-bottom:5px"><input type="text" class="input-sm form-control" placeholder="City" ng-model="topupBilling.city"></div><div class="col-sm-12" style="margin-bottom:10px"><input type="text" class="input-sm form-control" placeholder="State" ng-model="topupBilling.state"></div><div class="col-sm-12" style="margin-bottom:10px"><label for="email" class="control-label" style="float:left;font-size:13px;font-weight:bold;color:#7d7d7d">Email</label> <input type="text" class="input-sm form-control" placeholder="Email" ng-model="topupBilling.email"></div></div></div></div><div class="modal-footer" style="margin:0px 35px"><button type="button" class="btn btn-sm btn-primary btn-raised btn-full-width-margin" ng-click="topupCredit()" style="margin-bottom:10px">PROCEED</button> <button type="button" class="btn btn-sm btn-default btn-full-width-margin" ng-click="$dismiss()" style="margin-bottom:10px;margin-left:0px">CANCEL</button></div></div>');
$templateCache.put('app/pages/user/user-all-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="panel-content" id="manage-user"><div class="col-md-12"><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFullName">User Name</label> <input type="text" class="form-control" id="inputFullName" ng-model="user.fullName" disabled=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputCompany">Agency/Firm Name</label> <input type="text" class="form-control" id="inputCompany" ng-model="user.agencyName" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputNewEmail">Email Address</label> <input type="text" class="form-control" id="inputNewEmail" ng-model="user.email" disabled=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputPhoneNo">Phone No</label> <input type="text" class="form-control" id="inputPhoneNo" ng-model="user.phoneNo" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress1">Address Line 1</label> <input type="text" class="form-control" id="inputAddress1" ng-model="user.address1" disabled=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputAddress2">Address Line 2</label> <input type="text" class="form-control" id="inputAddress2" ng-model="user.address2" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress3">Address Line 3</label> <input type="text" class="form-control" id="inputAddress3" ng-model="user.address3" disabled=""></div></div><div class="col-sm-2"><div class="form-group"><label for="inputPostcode">Postcode</label> <input type="text" class="form-control" id="inputPostcode" ng-model="user.postcode" disabled=""></div></div><div class="col-sm-4"><div class="form-group"><label for="inputCity">City</label> <input type="text" class="form-control" id="inputCity" ng-model="user.city" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputState">State</label> <input type="text" class="form-control" id="inputState" ng-model="user.state" disabled=""></div></div><div class="col-sm-3"><div class="form-group"><label for="entityName">Status</label><select class="form-control" ng-model="user.status" selectpicker=""><option selected="">Pending</option><option>Block</option><option>Approve</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="entityName">Role</label><select class="form-control" ng-model="user.role" selectpicker=""><option>Normal User</option><option>Account Admin</option><option>SSM Admin</option><option>Support Admin</option><option>Administrator</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="actionReason">Note</label> <textarea type="text" class="form-control" id="inputRegAdd" ng-model="user.note"></textarea></div></div><div class="col-sm-3" ng-if="currentUser.role != \'Administrator\'"><div class="form-group"><label>Credit Balance</label> <input type="text" class="form-control" id="inputCreditBalance" ng-model="user.creditBalance" disabled=""></div></div><div class="col-sm-3" ng-if="currentUser.role == \'Administrator\'"><div class="form-group"><label>Credit Balance</label><p class="input-group"><input type="text" class="form-control" id="inputCreditBalance" ng-model="user.creditBalance" disabled=""> <span class="input-group-btn"><button type="button" class="btn btn-info btn-raised" ng-click="manageCreditModal(user.id,user.status,user.role,user.note)">Manage Credit</button></span></p></div></div></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row button-wrapper"><button type="button" class="btn btn-primary btn-raised btn-full-width-margin" ng-click="editUser()"><i class="fa fa-check" aria-hidden="true"></i> Save</button></div></div></div></div>');
$templateCache.put('app/pages/user/user-all-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateFrom">Joined Date From</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateFrom.opened" close-text="Close" show-button-bar="false" ng-model="dateFrom" ng-click="openDateFrom()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="col-sm-2"><div class="form-group has-feedback"><label class="control-label" for="inputDateTo">Joined Date To</label> <input type="text" class="form-control cursor-pointer" datepicker-options="{showWeeks:false,minMode:\'day\'}" uib-datepicker-popup="dd/MM/yyyy" is-open="popupDateTo.opened" close-text="Close" show-button-bar="false" ng-model="dateTo" ng-click="openDateTo()" readonly=""> <i class="ion-ios-calendar-outline form-control-feedback form-control-icon"></i></div></div><div class="form-group col-sm-2"><label>Name/Email</label> <input type="text" class="form-control" placeholder="" id="userName" ng-model="userName"></div><div class="form-group col-sm-2"><label>Agency/Firm</label><ui-select ng-model="agencyWithSearch.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Agency/Firm" ng-click="loadAgency()">{{$select.selected.agencyName}}</ui-select-match><ui-select-choices repeat="agencyWithSearch in agencyList | filter: $select.search"><span style="white-space:normal;" ng-bind-html="agencyWithSearch.agencyName"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-2"><label>Status</label><select class="form-control" ng-model="status" selectpicker=""><option ng-selected="true">All</option><option>Pending</option><option>Block</option><option>Approve</option></select></div><div class="col-sm-2"><div class="form-group" style="margin-top:25px"><button type="button" class="btn btn-primary btn-full-width-margin" ng-click="searchUser()" style="margin-right:5px"><i class="fa fa-search" aria-hidden="true"></i> Search</button><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary-border" uib-dropdown-toggle=""><i class="fa fa-cloud-download" aria-hidden="true"></i> Export <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="exportUserExcel()"><i class="fa fa-file-excel-o" aria-hidden="true"></i> EXCEL</a></li></ul></div></div></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="smartTableData" st-pipe="userFilter"><thead><tr class="black-muted-bg"><th class="bold-title">Joined Date</th><th class="bold-title">Name</th><th class="bold-title">Email</th><th class="bold-title">Agency/Firm</th><th class="bold-title">Department</th><th class="bold-title">Role</th><th class="bold-title">Status</th><th class="bold-title align-right">Credit Balance</th></tr></thead><tbody><tr ng-repeat="item in smartTableData" class="clickable-row" ui-sref="user.manage({userId:\'{{item.id}}\'})"><td>{{item.created_at | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{item.fullName}}</td><td>{{item.email}}</td><td>{{item.agencyName}}</td><td>{{item.deptName}}</td><td>{{item.role}}</td><td>{{item.status}}</td><td class="align-right">{{item.creditBalance | number : 2}}</td></tr><tr ng-if="smartTableData.length == 0"><td colspan="8"><br><i>No record found</i><br><br></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchUser()"></select></div><span style="float:right;padding-top:11px">{{pageDesc}}</span><nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="javascript: void(0);" ng-click="selectPage(page)">{{page}}</a></li></ul></nav></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/user/user-detail.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="col-md-12"><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFullName">User Name</label> <input type="text" class="form-control" id="inputFullName" ng-model="agencyUser.fullName" disabled=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputCompany">Agency/Firm Name</label> <input type="text" class="form-control" id="inputCompany" ng-model="agencyUser.agencyName" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputNewEmail">Email Address</label> <input type="text" class="form-control" id="inputNewEmail" ng-model="agencyUser.email" disabled=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputPhoneNo">Phone No</label> <input type="text" class="form-control" id="inputPhoneNo" ng-model="agencyUser.phoneNo" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress1">Address Line 1</label> <input type="text" class="form-control" id="inputAddress1" ng-model="agencyUser.address1" disabled=""></div></div><div class="col-sm-6"><div class="form-group"><label for="inputAddress2">Address Line 2</label> <input type="text" class="form-control" id="inputAddress2" ng-model="agencyUser.address2" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputAddress3">Address Line 3</label> <input type="text" class="form-control" id="inputAddress3" ng-model="agencyUser.address3" disabled=""></div></div><div class="col-sm-2"><div class="form-group"><label for="inputPostcode">Postcode</label> <input type="text" class="form-control" id="inputPostcode" ng-model="agencyUser.postcode" disabled=""></div></div><div class="col-sm-4"><div class="form-group"><label for="inputCity">City</label> <input type="text" class="form-control" id="inputCity" ng-model="agencyUser.city" disabled=""></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputState">State</label> <input type="text" class="form-control" id="inputState" ng-model="agencyUser.state" readonly=""></div></div><div class="col-sm-3"><div class="form-group"><label for="entityName">Status</label><select class="form-control" ng-model="agencyUser.status" selectpicker=""><option>Approve</option><option>Pending</option><option>Block</option></select></div></div><div class="col-sm-3"><div class="form-group"><label for="entityName">Role</label><select class="form-control" ng-model="agencyUser.role" selectpicker=""><option>Normal User</option><option>Account Admin</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="actionReason">Note</label> <textarea type="text" class="form-control" id="inputRegAdd" ng-model="agencyUser.note"></textarea></div></div><div class="col-sm-3"><div class="form-group"><label>Credit Balance</label> <input type="text" class="form-control" id="inputCreditBalance" ng-model="agencyUser.creditBalance" disabled=""></div></div><div class="col-sm-3" ng-if="currentUser.userId != agencyUser.id"><div class="form-group" style="padding-top:25px"><button type="button" class="btn btn-info" ng-click="transferCreditModal(agencyUser.id,agencyUser.fullName,agencyUser.status,agencyUser.role,agencyUser.note)" style="margin-right:5px">Delegate Credit</button> <button type="button" class="btn btn-danger" ng-click="returnCreditModal(agencyUser.id,agencyUser.fullName,agencyUser.status,agencyUser.role,agencyUser.note,agencyUser.creditBalance)">Return Credit</button></div></div></div><h4 class="with-line" style="padding-top:4px"></h4><div class="row button-wrapper"><button type="button" class="btn btn-primary btn-raised btn-full-width-margin" ng-click="editAgencyUser()"><i class="fa fa-check" aria-hidden="true"></i> Save</button></div></div></div></div>');
$templateCache.put('app/pages/user/user-list.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="row"><div class="col-sm-6 form-group" style="margin-top:7px"><button type="button" class="btn btn-info" ng-click="delegateCreditModal()" ng-if="currentUser.role == \'Account Admin\'" style="margin-right:5px"><i class="fa fa-share-alt" aria-hidden="true"></i> Delegate Credit</button> <button type="button" class="btn btn-danger" ng-click="takeCreditModal()" ng-if="currentUser.role == \'Account Admin\'">Return Credit</button></div></div><div class="table-responsive"><table class="table table-hover font-size-13" st-table="agencyUserTableData" st-safe-src="agencyUserList"><thead><tr class="sortable black-muted-bg"><th st-sort="fullName" class="bold-title">Name</th><th st-sort="email" class="bold-title">Email</th><th st-sort="agencyName" class="bold-title">Agency/Firm</th><th st-sort="deptName" class="bold-title">Department</th><th st-sort="role" class="bold-title">Role</th><th st-sort="status" class="bold-title">Status</th><th st-sort="creditBalance" class="bold-title align-right">Credit Balance</th></tr><tr><th><input st-search="fullName" placeholder="Search name" class="input-sm form-control search-input"></th><th><input st-search="email" placeholder="Search email" class="input-sm form-control search-input"></th><th><input st-search="agencyName" placeholder="Search agency/firm" class="input-sm form-control search-input"></th><th><input st-search="deptName" placeholder="Search department" class="input-sm form-control search-input"></th><th><input st-search="role" placeholder="Search role" class="input-sm form-control search-input"></th><th><input st-search="status" placeholder="Search status" class="input-sm form-control search-input"></th><th></th></tr></thead><tbody><tr ng-repeat="item in agencyUserTableData" class="clickable-row" ui-sref="user.detail({user_id:\'{{item.id}}\'})"><td>{{item.fullName}}</td><td>{{item.email}}</td><td>{{item.agencyName}}</td><td>{{item.deptName}}</td><td>{{item.role}}</td><td>{{item.status}}</td><td class="align-right">{{item.creditBalance | number : 2}}</td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><span style="float:left;padding-top:11px">Rows on page</span><div class="form-group select-page-size-wrap pull-left"><select class="form-control selectpicker dropup" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]" ng-change="searchAgencyUser()"></select></div><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10" style="margin-left:-150px;"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/user/user-profile.view.html','<content-top></content-top><div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><form ng-submit="updateProfile()"><h4 class="with-line">User Information</h4><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="fullName" class="col-sm-3 control-label">Name</label><div class="col-sm-9"><input type="text" class="form-control" id="fullName" placeholder="Name" ng-model="user.fullName" required=""></div></div><div class="form-group row clearfix"><label for="creditBalance" class="col-sm-3 control-label">Credit Balance</label><div class="col-sm-9"><input type="text" class="form-control" id="creditBalance" ng-model="user.creditBalance" disabled=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="agencyName" class="col-sm-3 control-label">Agency/Firm Name</label><div class="col-sm-9"><input type="text" class="form-control" id="agencyName" ng-model="user.agencyName" disabled=""></div></div><div class="form-group row clearfix"><label for="deptName" class="col-sm-3 control-label">Department</label><div class="col-sm-9"><input type="text" class="form-control" id="deptName" ng-model="user.deptName" disabled=""></div></div></div></div><h4 class="with-line">Contact Information</h4><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="email" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="text" class="form-control" id="email" ng-model="user.email" disabled=""></div></div><div class="form-group row clearfix"><label for="phoneNo" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="phoneNo" placeholder="Phone" ng-model="user.phoneNo" maxlength="20" required=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="address1" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><input type="text" class="form-control" id="address1" placeholder="Address Line 1" ng-model="user.address1" required=""></div></div><div class="form-group row clearfix"><label for="address2" class="col-sm-3 control-label"></label><div class="col-sm-9"><input type="text" class="form-control" id="address2" placeholder="Address Line 2" ng-model="user.address2"></div></div><div class="form-group row clearfix"><label for="address3" class="col-sm-3 control-label"></label><div class="col-sm-9"><input type="text" class="form-control" id="address3" placeholder="Address Line 3" ng-model="user.address3"></div></div><div class="form-group row clearfix"><label for="postcode" class="col-sm-3 control-label"></label><div class="col-sm-3"><input type="text" class="form-control" id="postcode" placeholder="Postcode" ng-model="user.postcode" maxlength="6" required=""></div><div class="col-sm-6"><input type="text" class="form-control" id="city" placeholder="City" ng-model="user.city" required=""></div></div><div class="form-group row clearfix"><label for="state" class="col-sm-3 control-label"></label><div class="col-sm-9"><input type="text" class="form-control" id="state" placeholder="State" ng-model="user.state" required=""></div></div></div></div><h4 class="with-line" style="padding-top: 4px;"></h4><div class="text-center"><button type="submit" class="btn btn-primary btn-with-icon btn-raised btn-full-width" style="margin-bottom:7px;"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></form></div></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData2"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="entityName">Entity Name</th><th st-sort="documentName">Document Name</th><th st-sort="documentType">Document Type</th><th st-sort="processDate">Process Date</th><th st-sort="status">status</th></tr><tr><th></th><th><input st-search="entityName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="documentName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="documentType" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="processDate" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData2"><td class="table-id">{{item.id}}</td><td>{{item.entityName}}</td><td>{{item.documentName}}</td><td>{{item.documentType}}</td><td>{{item.processDate}}</td><td>{{item.status}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/home">Home</a></li><li><span ng-if="activePageTitle == \'Cart\'"><i class="fa fa-shopping-cart" aria-hidden="true"></i></span> <span ng-if="activePageTitle != \'Cart\'">{{ activePageTitle }}</span></li></ul></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/home" class="al-logo clearfix"><img class="al-logo-img" src="assets/img/logo_ssm.png" alt=""></a> <a href="#/home" class="al-logo clearfix"><img class="al-logo-img" src="assets/img/logo2_opt.png" alt=""></a><div class="user-profile clearfix"><div ng-if="currentUser.isLogin" uib-dropdown="" class="menu-ion"><a uib-dropdown-toggle="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><ul class="top-dropdown-menu" uib-dropdown-menu="" ng-if="currentUser.isLogin"><li><i class="dropdown-arr"></i></li><li ng-if="currentUser.isLogin"><a class="hvr-underline-from-left" href="" ui-sref="entity.search()"><i class="fa fa-building" aria-hidden="true"></i> Search Entity</a></li><li ng-if="currentUser.isLogin"><a class="hvr-underline-from-left" href="" ui-sref="pi.product()"><i class="fa fa-building" aria-hidden="true"></i> Personal Involvement</a></li><li ng-if="currentUser.isLogin"><a class="hvr-underline-from-left" href="" ui-sref="document.request()"><i class="fa fa-shopping-cart" aria-hidden="true"></i> Cart <i style="float:right">( {{currentUser.userCartCount}} items in cart )</i></a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Normal User\' || currentUser.role == \'SSM Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="document.download()"><i class="fa fa-file-text" aria-hidden="true"></i> Orders</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="document.order()"><i class="fa fa-file-text" aria-hidden="true"></i> Orders</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Administrator\' || currentUser.role == \'Support Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="document.all()"><i class="fa fa-file-text-o" aria-hidden="true"></i> Orders</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Normal User\')"><a class="hvr-underline-from-left" href="" ui-sref="transaction.search()"><i class="fa fa-file-text" aria-hidden="true"></i> Transactions</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="transaction.agency()"><i class="fa fa-file-text" aria-hidden="true"></i> Transactions</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Administrator\' || currentUser.role == \'Support Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="transaction.all()"><i class="fa fa-money" aria-hidden="true"></i> Transactions</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Normal User\' || currentUser.role == \'SSM Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="report.orderTrxUser()"><i class="fa fa-bar-chart" aria-hidden="true"></i> Report</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="report.orderTrxAgency()"><i class="fa fa-bar-chart" aria-hidden="true"></i> Report</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\'"><a class="hvr-underline-from-left" href="" ui-sref="report.orderTrxAll()"><i class="fa fa-bar-chart" aria-hidden="true"></i> Report</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="user.list()"><i class="fa fa-users" aria-hidden="true"></i> Users</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\'"><a class="hvr-underline-from-left" href="" ui-sref="user.search()"><i class="fa fa-users" aria-hidden="true"></i> Users</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\'"><a class="hvr-underline-from-left" href="" ui-sref="agency.search()"><i class="fa fa-building-o" aria-hidden="true"></i> Agency/Firm</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\' && currentUser.userId == 1"><a class="hvr-underline-from-left" href="" ui-sref="discount.list()"><i class="fa fa-tags" aria-hidden="true"></i> Discount</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\'"><a class="hvr-underline-from-left" href="" ui-sref="notification.list()"><i class="fa fa-bullhorn" aria-hidden="true"></i> Notification</a></li><hr class="top-dropdown-menu-hr"><li ng-if="currentUser.isLogin"><a>Credit: <b>{{currentUser.userCreditBalance | number:2}}</b></a></li><li ng-if="currentUser.isLogin" ng-controller="user.controller"><a href="" ui-sref="user.profile()"><i class="fa fa-user" aria-hidden="true"></i> {{currentUser.userName}}</a></li><li ng-if="currentUser.isLogin" ng-controller="login.controller"><a href="" ng-click="logout()"><i class="fa fa-sign-out" aria-hidden="true"></i> Logout</a></li></ul></div><div class="al-user-profile menu-logout" ng-if="currentUser.isLogin"><ul><li ng-if="currentUser.isLogin" ng-controller="login.controller"><a href="" ng-click="logout()"><i class="fa fa-sign-out" aria-hidden="true"></i> Logout</a></li></ul></div><div class="screen-540"><a class="al-user" ng-if="currentUser.isLogin" href="" ui-sref="user.profile()"><i class="fa fa-user" aria-hidden="true"></i> {{currentUser.userName}}</a></div></div><div class="al-menu screen-680 clearfix"><ul><li ng-if="currentUser.isLogin"><a title="Credit Balance"><b>{{currentUser.userCreditBalance | number:2}}</b></a></li></ul></div><div class="al-menu screen-1180 clearfix"><ul class="al-msg-center clearfix"><li ng-if="currentUser.isLogin" uib-dropdown="" class="menu-ion"><a class="hvr-underline-from-left" href="" uib-dropdown-toggle="" ba-sidebar-toggle-menu="">Products <i class="fa fa-caret-down" aria-hidden="true"></i></a><ul class="top-dropdown-menu setting-menu" uib-dropdown-menu="" style="height: auto;"><li style="padding-top: 0px;"><i class="dropdown-arr"></i></li><li><a class="hvr-underline-from-left" href="" ui-sref="entity.search()" style="padding-left:7px;padding-right:7px;">Search Entity</a></li><li style="padding-bottom:10px;"><a class="hvr-underline-from-left" href="" ui-sref="pi.product()" style="padding-left:7px;padding-right:7px;">Personal Involvement</a></li></ul></li><li ng-if="currentUser.isLogin"><a class="hvr-underline-from-left" href="" ui-sref="document.request()">Cart <span ng-if="currentUser.userCartCount > 0">{{currentUser.userCartCount}}</span></a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Normal User\' || currentUser.role == \'SSM Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="document.download()">Orders</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="document.order()">Orders</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Administrator\' || currentUser.role == \'Support Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="document.all()">Orders</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Normal User\'"><a class="hvr-underline-from-left" href="" ui-sref="transaction.search()">Transactions</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="transaction.agency()">Transactions</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Administrator\' || currentUser.role == \'Support Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="transaction.all()">Transactions</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'SSM Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="transaction.ssm()">Transactions</a></li><li ng-if="currentUser.isLogin && (currentUser.role == \'Normal User\' || currentUser.role == \'SSM Admin\')"><a class="hvr-underline-from-left" href="" ui-sref="report.orderTrxUser()">Report</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="report.orderTrxAgency()">Report</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\'"><a class="hvr-underline-from-left" href="" ui-sref="report.orderTrxAll()">Report</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Account Admin\'"><a class="hvr-underline-from-left" href="" ui-sref="user.list()">Users</a></li><li ng-if="currentUser.isLogin && currentUser.role == \'Administrator\'" uib-dropdown="" class="menu-ion"><a class="hvr-underline-from-left" href="" uib-dropdown-toggle="" ba-sidebar-toggle-menu="">Setting <i class="fa fa-caret-down" aria-hidden="true"></i></a><ul class="top-dropdown-menu setting-menu" uib-dropdown-menu="" style="height: auto;"><li style="padding-top: 0px;"><i class="dropdown-arr"></i></li><li><a class="hvr-underline-from-left" href="" ui-sref="user.search()" style="padding-left:7px;padding-right:7px;">Users</a></li><li><a class="hvr-underline-from-left" href="" ui-sref="agency.search()" style="padding-left:7px;padding-right:7px;">Agency/Firm</a></li><li ng-if="currentUser.userId == 1"><a class="hvr-underline-from-left" href="" ui-sref="discount.list()" style="padding-left:7px;padding-right:7px;">Discount</a></li><li style="padding-bottom: 5px;"><a class="hvr-underline-from-left" href="" ui-sref="notification.list()" style="padding-left:7px;padding-right:7px;">Notification</a></li></ul></li><li ng-if="currentUser.isLogin"><span>|</span></li></ul></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/tooltip/demoBasicUsage/index.html','<div ng-controller="AppCtrl" ng-cloak=""><md-toolbar class="md-accent"><div class="md-toolbar-tools"><h2>Awesome Material App</h2><span flex=""></span><md-button class="md-icon-button test-tooltip" aria-label="Refresh"><md-tooltip md-direction="left">Refresh</md-tooltip><md-icon md-svg-src="img/icons/ic_refresh_24px.svg" style="width: 24px; height: 24px"></md-icon></md-button></div></md-toolbar><md-content layout-padding="" style="margin-left: 20px; margin-right: 20px"><div><p>The tooltip is visible when the button is hovered, focused, or touched. Hover over the <strong>Refresh</strong> icon in the above toolbar.</p><div style="margin-top: 20px"><p>The Tooltip\'s <code>md-z-index</code> attribute can be used to change the tooltip\'s visual level in comparison with the other elements of the application.<br><strong>Note:</strong> the z-index default is <strong>100</strong>.</p></div><div style="margin-top: 20px"><p>The Tooltip\'s <code>md-direction</code> attribute can be used to dynamically change the direction of the tooltip.<br><strong>Note:</strong> the direction default value is <strong>\'bottom\'</strong>.</p><div layout="row" layout-align="space-between"><md-radio-group ng-model="demo.tipDirection" style="padding-left: 30px"><md-radio-button value="top">Top</md-radio-button><md-radio-button value="right">Right</md-radio-button><md-radio-button value="bottom">Bottom</md-radio-button><md-radio-button value="left">Left</md-radio-button></md-radio-group><md-button class="md-fab"><md-tooltip md-direction="{{demo.tipDirection}}">Insert Drive</md-tooltip><md-icon md-svg-src="img/icons/ic_insert_drive_file_24px.svg"></md-icon></md-button></div></div><div style="margin-top: 30px"><p>The Tooltip\'s <code>md-visible</code> attribute can be used to programmatically show/hide itself. Toggle the checkbox below...</p><div layout="row" layout-align="space-between center"><div style="padding-left: 30px"><md-checkbox ng-model="demo.showTooltip" style="padding-left: 30px">Insert Drive</md-checkbox></div><md-button class="md-fab" aria-label="Photos"><md-tooltip md-visible="demo.showTooltip">Photos</md-tooltip><md-icon md-svg-src="img/icons/ic_photo_24px.svg"></md-icon></md-button></div></div><div style="margin-top: 20px"><p>The Tooltip\'s <code>md-delay</code> attribute can be used to delay the show animation.<br><strong>Note:</strong> the delay default value is <strong>0 milliseconds</strong>.</p><div layout="row" layout-align="space-between center"><div style="padding-left: 30px"><md-input-container><label>Tooltip Delay</label> <input ng-model="demo.delayTooltip"></md-input-container></div><md-button class="md-fab" aria-label="Menu with Tooltip Delay" style="margin-top: -24px"><md-tooltip md-delay="demo.delayTooltip">Menu with Tooltip Delay {{demo.delayTooltip}} msecs</md-tooltip><md-icon md-svg-src="img/icons/ic_more_vert_24px.svg"></md-icon></md-button></div></div></div></md-content></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');}]);